var __webpack_modules__ = ({
353(module) {
!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),Y=_.prototype;return O.prototype=Y,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){Y[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

},
375(module) {
!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";return function(e,t){var r=t.prototype,n=r.format;r.format=function(e){var t=this,r=this.$locale();if(!this.isValid())return n.bind(this)(e);var s=this.$utils(),a=(e||"YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g,(function(e){switch(e){case"Q":return Math.ceil((t.$M+1)/3);case"Do":return r.ordinal(t.$D);case"gggg":return t.weekYear();case"GGGG":return t.isoWeekYear();case"wo":return r.ordinal(t.week(),"W");case"w":case"ww":return s.s(t.week(),"w"===e?1:2,"0");case"W":case"WW":return s.s(t.isoWeek(),"W"===e?1:2,"0");case"k":case"kk":return s.s(String(0===t.$H?24:t.$H),"k"===e?1:2,"0");case"X":return Math.floor(t.$d.getTime()/1e3);case"x":return t.$d.getTime();case"z":return"["+t.offsetName()+"]";case"zzz":return"["+t.offsetName("long")+"]";default:return e}}));return n.bind(this)(a)}}}));

},
750(module) {
!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};return function(t,o,n){var r=o.prototype,i=r.format;n.en.formats=e,r.format=function(t){void 0===t&&(t="YYYY-MM-DDTHH:mm:ssZ");var o=this.$locale().formats,n=function(t,o){return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var i=r&&r.toUpperCase();return n||o[r]||e[r]||o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,o){return t||o.slice(1)}))}))}(t,void 0===o?{}:o);return i.call(this,n)}}}));

},
67(module, exports, __webpack_require__) {
/* module decorator */ module = __webpack_require__.nmd(module);
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
	var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see https://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(codePoint) {
		return '&#x' + codePoint.toString(16).toUpperCase() + ';';
	};

	var decEscape = function(codePoint) {
		return '&#' + codePoint + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		var escapeCodePoint = options.decimal ? decEscape : hexEscape;

		var escapeBmpSymbol = function(symbol) {
			return escapeCodePoint(symbol.charCodeAt(0));
		};

		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return escapeBmpSymbol(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, escapeBmpSymbol);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return escapeCodePoint(codePoint);
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, escapeBmpSymbol);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false,
		'decimal' : false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
			var codePoint;
			var semicolon;
			var decDigits;
			var hexDigits;
			var reference;
			var next;

			if ($1) {
				reference = $1;
				// Note: there is no need to check `has(decodeMap, reference)`.
				return decodeMap[reference];
			}

			if ($2) {
				// Decode named character references without trailing `;`, e.g. `&amp`.
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $2;
				next = $3;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			}

			if ($4) {
				// Decode decimal escapes, e.g. `&#119558;`.
				decDigits = $4;
				semicolon = $5;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(decDigits, 10);
				return codePointToSymbol(codePoint, strict);
			}

			if ($6) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $6;
				semicolon = $7;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}

			// If we’re still here, `if ($7)` is implied; it’s an ambiguous
			// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
			if (strict) {
				parseError(
					'named character reference was not terminated by a semicolon'
				);
			}
			return $0;
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '1.2.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define(function() {
			return he;
		});
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = he;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in he) {
				has(he, key) && (freeExports[key] = he[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.he = he;
	}

}(this));


},
204(__unused_rspack_module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(994);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createDriver;

var _regenerator = _interopRequireDefault(__webpack_require__(756));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(693));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(293));

var _utils = __webpack_require__(281);

function createDriver(name, property) {
  var storage = (0, _utils.getStorage)();
  var support = !!(storage && storage[property]);
  var driver = support ? storage[property] : {
    clear: function clear() {},
    get: function get() {},
    remove: function remove() {},
    set: function set() {}
  };

  var _clear = driver.clear.bind(driver);

  var get = driver.get.bind(driver);
  var remove = driver.remove.bind(driver);
  var set = driver.set.bind(driver);
  return {
    _driver: name,
    _support: support,
    // eslint-disable-next-line no-underscore-dangle
    _initStorage: function _initStorage() {
      return Promise.resolve();
    },
    clear: function clear(callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _clear();

                if (callback) callback();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    iterate: function iterate(iterator, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var items, keys;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _utils.usePromise)(get, null);

              case 2:
                items = _context2.sent;
                keys = Object.keys(items);
                keys.forEach(function (key, i) {
                  return iterator(items[key], key, i);
                });
                if (callback) callback();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getItem: function getItem(key, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return (0, _utils.usePromise)(get, key);

              case 3:
                result = _context3.sent;
                result = typeof key === 'string' ? result[key] : result;
                result = result === undefined ? null : result;
                if (callback) callback(null, result);
                return _context3.abrupt("return", result);

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                if (callback) callback(_context3.t0);
                throw _context3.t0;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 10]]);
      }))();
    },
    key: function key(n, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var results, key;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _utils.usePromise)(get, null);

              case 2:
                results = _context4.sent;
                key = Object.keys(results)[n];
                if (callback) callback(key);
                return _context4.abrupt("return", key);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    keys: function keys(callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var results, keys;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _utils.usePromise)(get, null);

              case 2:
                results = _context5.sent;
                keys = Object.keys(results);
                if (callback) callback(keys);
                return _context5.abrupt("return", keys);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    length: function length(callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var results, _Object$keys, length;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _utils.usePromise)(get, null);

              case 2:
                results = _context6.sent;
                _Object$keys = Object.keys(results), length = _Object$keys.length;
                if (callback) callback(length);
                return _context6.abrupt("return", length);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    removeItem: function removeItem(key, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _utils.usePromise)(remove, key);

              case 2:
                if (callback) callback();

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    setItem: function setItem(key, value, callback) {
      return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (0, _utils.usePromise)(set, (0, _defineProperty2["default"])({}, key, value));

              case 2:
                if (callback) callback();

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  };
}

},
735(__unused_rspack_module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(994);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _driver = _interopRequireDefault(__webpack_require__(204));

var _default = (0, _driver["default"])('webExtensionLocalStorage', 'local');

exports["default"] = _default;

},
685(__unused_rspack_module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(994);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _driver = _interopRequireDefault(__webpack_require__(204));

var _default = (0, _driver["default"])('webExtensionSyncStorage', 'sync');

exports["default"] = _default;

},
281(__unused_rspack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getStorage = getStorage;
exports.usePromise = usePromise;

/**
 * Need to invoke a function at runtime instead of import-time to make tests
 * pass with mocked browser and chrome objects
 */
function getStorage() {
  return typeof browser !== 'undefined' && browser.storage || typeof chrome !== 'undefined' && chrome.storage;
}
/**
 * Need to invoke a function at runtime instead of import-time to make tests
 * pass with mocked browser and chrome objects
 */


function usesPromises() {
  var storage = getStorage();

  try {
    return storage && storage.local.get && storage.local.get() && typeof storage.local.get().then === 'function';
  } catch (e) {
    return false;
  }
}
/**
 * Converts a callback-based API to a promise based API.
 * For now we assume that there is only one arg in addition to the callback
 */


function usePromise(fn, arg) {
  if (usesPromises()) {
    return fn(arg);
  }

  return new Promise(function (resolve) {
    fn(arg, function () {
      resolve.apply(void 0, arguments);
    });
  });
}

},
56(module) {
/*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
	// Make sure the the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {

			// Support: IE <9 only
			// IE doesn't have `contains` on `document` so we need to check for
			// `documentElement` presence.
			// We need to fall back to `a` when `documentElement` is missing
			// as `ownerDocument` of elements within `<template/>` may have
			// a null one - a default behavior of all modern browsers.
			var adown = a.nodeType === 9 && a.documentElement || a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

// EXPOSE
var _sizzle = window.Sizzle;

Sizzle.noConflict = function() {
	if ( window.Sizzle === Sizzle ) {
		window.Sizzle = _sizzle;
	}

	return Sizzle;
};

if ( typeof define === "function" && define.amd ) {
	define( function() {
		return Sizzle;
	} );

// Sizzle requires that there be a global window in Common-JS like environments
} else if (  true && module.exports ) {
	module.exports = Sizzle;
} else {
	window.Sizzle = Sizzle;
}

// EXPOSE

} )( window );


},
604(__unused_rspack_module, exports) {
var __rspack_unused_export;
/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports.n = sprintf
        __rspack_unused_export = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (typeof define === 'function' && define['amd']) {
            define(function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            })
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


},
172(module) {
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
293(module) {
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
693(module, __unused_rspack_exports, __webpack_require__) {
var toPropertyKey = __webpack_require__(736);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
994(module) {
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
993(module, __unused_rspack_exports, __webpack_require__) {
var regeneratorDefine = __webpack_require__(546);
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
    return this;
  }), regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (module.exports = _regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
869(module, __unused_rspack_exports, __webpack_require__) {
var regeneratorAsyncGen = __webpack_require__(887);
function _regeneratorAsync(n, e, r, t, o) {
  var a = regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
887(module, __unused_rspack_exports, __webpack_require__) {
var regenerator = __webpack_require__(993);
var regeneratorAsyncIterator = __webpack_require__(791);
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new regeneratorAsyncIterator(regenerator().w(r, e, t, o), n || Promise);
}
module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
791(module, __unused_rspack_exports, __webpack_require__) {
var OverloadYield = __webpack_require__(172);
var regeneratorDefine = __webpack_require__(546);
function AsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), regeneratorDefine(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
546(module) {
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
}
module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
373(module) {
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
633(module, __unused_rspack_exports, __webpack_require__) {
var OverloadYield = __webpack_require__(172);
var regenerator = __webpack_require__(993);
var regeneratorAsync = __webpack_require__(869);
var regeneratorAsyncGen = __webpack_require__(887);
var regeneratorAsyncIterator = __webpack_require__(791);
var regeneratorKeys = __webpack_require__(373);
var regeneratorValues = __webpack_require__(579);
function _regeneratorRuntime() {
  "use strict";

  var r = regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    "throw": 1,
    "return": 2,
    "break": 3,
    "continue": 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        "catch": function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new OverloadYield(r, e);
      },
      AsyncIterator: regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: regeneratorKeys,
      values: regeneratorValues
    };
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
579(module, __unused_rspack_exports, __webpack_require__) {
var _typeof = (__webpack_require__(738)/* ["default"] */["default"]);
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
45(module, __unused_rspack_exports, __webpack_require__) {
var _typeof = (__webpack_require__(738)/* ["default"] */["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
736(module, __unused_rspack_exports, __webpack_require__) {
var _typeof = (__webpack_require__(738)/* ["default"] */["default"]);
var toPrimitive = __webpack_require__(45);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
738(module) {
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},
756(module, __unused_rspack_exports, __webpack_require__) {
// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(633)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


},

});
// The module cache
var __webpack_module_cache__ = {};

// The require function
function __webpack_require__(moduleId) {

// Check if module is in cache
var cachedModule = __webpack_module_cache__[moduleId];
if (cachedModule !== undefined) {
return cachedModule.exports;
}
// Create a new module (and put it into the cache)
var module = (__webpack_module_cache__[moduleId] = {
exports: {}
});
// Execute the module function
__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);

// Return the exports of the module
return module.exports;

}

// webpack/runtime/define_property_getters
(() => {
__webpack_require__.d = (exports, getters, values) => {
	var define = (defs, kind) => {
		for(var key in defs) {
			if(__webpack_require__.o(defs, key) && !__webpack_require__.o(exports, key)) {
				Object.defineProperty(exports, key, { enumerable: true, [kind]: defs[key] });
			}
		}
	};
	define(getters, "get");
	define(values, "value");
};
})();
// webpack/runtime/global
(() => {
__webpack_require__.g = (() => {
	if (typeof globalThis === 'object') return globalThis;
	try {
		return this || new Function('return this')();
	} catch (e) {
		if (typeof window === 'object') return window;
	}
})();
})();
// webpack/runtime/has_own_property
(() => {
__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
})();
// webpack/runtime/make_namespace_object
(() => {
// define __esModule on exports
__webpack_require__.r = (exports) => {
	if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	}
	Object.defineProperty(exports, '__esModule', { value: true });
};
})();
// webpack/runtime/node_module_decorator
(() => {
__webpack_require__.nmd = (module) => {
  module.paths = [];
  if (!module.children) module.children = [];
  return module;
};
})();
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  XQ: () => (/* reexport */ shared_message),
  Xh: () => (/* reexport */ bookmarks_model),
  _r: () => (/* reexport */ bookmarks_collection),
  M$: () => (/* reexport */ strophe_esm_Builder),
  sB: () => (/* reexport */ chat_model),
  pM: () => (/* reexport */ Collection),
  pF: () => (/* reexport */ omemo_device),
  fs: () => (/* reexport */ omemo_devicelist),
  K_: () => (/* reexport */ devicelists),
  uk: () => (/* reexport */ omemo_devices),
  pP: () => (/* reexport */ picker),
  bk: () => (/* reexport */ skeletor_esm_EventEmitter),
  yp: () => (/* reexport */ MAMPlaceholderMessage),
  mu: () => (/* reexport */ muc_muc),
  pJ: () => (/* reexport */ muc_message),
  Q1: () => (/* reexport */ muc_messages),
  PW: () => (/* reexport */ muc_occupant),
  O0: () => (/* reexport */ muc_occupants),
  QB: () => (/* reexport */ chat_message),
  B2: () => (/* reexport */ chat_messages),
  Qd: () => (/* reexport */ microblog_profile),
  Kx: () => (/* reexport */ skeletor_esm_Model),
  w: () => (/* reexport */ model_with_messages_ModelWithMessages),
  Cq: () => (/* reexport */ roster_presence),
  T7: () => (/* reexport */ roster_presences),
  WV: () => (/* reexport */ Profile),
  Qq: () => (/* reexport */ microblog_feed),
  n0: () => (/* reexport */ microblog_feeds),
  RM: () => (/* reexport */ microblog_message),
  mp: () => (/* reexport */ microblog_messages),
  C7: () => (/* reexport */ roster_contact),
  yP: () => (/* reexport */ contacts),
  G2: () => (/* reexport */ RosterFilter),
  xS: () => (/* reexport */ Stanza),
  Jn: () => (/* reexport */ vcard_vcard),
  K2: () => (/* reexport */ vcard_vcards),
  JR: () => (/* reexport */ shared_converse),
  FH: () => (/* reexport */ shared_api),
  Ev: () => (/* reexport */ buildCommentTree),
  wK: () => (/* reexport */ computeThreadCounts),
  AA: () => (/* binding */ constants),
  iq: () => (/* reexport */ api_public),
  Ay: () => (/* binding */ headless),
  sO: () => (/* reexport */ errors_namespaceObject),
  DS: () => (/* reexport */ getAncestors),
  nb: () => (/* reexport */ getUploadService),
  Ru: () => (/* reexport */ i18n),
  Rm: () => (/* reexport */ src_log),
  T_: () => (/* reexport */ parsers_namespaceObject),
  u: () => (/* reexport */ headless_utils),
  QM: () => (/* reexport */ uploadFile)
});
// NAMESPACE OBJECT: ./src/headless/utils/html.js
var html_namespaceObject = {};
__webpack_require__.r(html_namespaceObject);
__webpack_require__.d(html_namespaceObject, { 
  decodeHTMLEntities: () => (decodeHTMLEntities),
  isElement: () => (isElement),
  isEqualNode: () => (isEqualNode),
  isTagEqual: () => (html_isTagEqual),
  queryChildren: () => (queryChildren),
  siblingIndex: () => (siblingIndex),
  unescapeHTML: () => (unescapeHTML) });

// NAMESPACE OBJECT: ./src/headless/utils/stanza.js
var stanza_namespaceObject = {};
__webpack_require__.r(stanza_namespaceObject);
__webpack_require__.d(stanza_namespaceObject, { 
  getAttributes: () => (getAttributes),
  isErrorStanza: () => (isErrorStanza),
  isForbiddenError: () => (isForbiddenError),
  isServiceUnavailableError: () => (isServiceUnavailableError),
  toStanza: () => (toStanza) });

// NAMESPACE OBJECT: ./src/headless/utils/environment.js
var environment_namespaceObject = {};
__webpack_require__.r(environment_namespaceObject);
__webpack_require__.d(environment_namespaceObject, { 
  IS_BROWSER: () => (IS_BROWSER),
  addRouteListener: () => (addRouteListener),
  addUnloadListener: () => (addUnloadListener),
  addVisibilityListener: () => (addVisibilityListener),
  getLocalStorageItem: () => (getLocalStorageItem),
  getRouteHash: () => (getRouteHash),
  getUnloadEvent: () => (getUnloadEvent),
  hasCredentialsAPI: () => (hasCredentialsAPI),
  isAppHidden: () => (isAppHidden),
  removeLocalStorageItem: () => (removeLocalStorageItem),
  removeRouteListener: () => (removeRouteListener),
  removeUnloadListener: () => (removeUnloadListener),
  removeVisibilityListener: () => (removeVisibilityListener),
  setLocalStorageItem: () => (setLocalStorageItem) });

// NAMESPACE OBJECT: ./src/headless/utils/object.js
var object_namespaceObject = {};
__webpack_require__.r(object_namespaceObject);
__webpack_require__.d(object_namespaceObject, { 
  isEmpty: () => (object_isEmpty),
  isError: () => (isError),
  isErrorObject: () => (isErrorObject),
  isFunction: () => (object_isFunction),
  isPersistableModel: () => (isPersistableModel),
  isUndefined: () => (isUndefined),
  merge: () => (object_merge) });

// NAMESPACE OBJECT: ./src/headless/utils/session.js
var session_namespaceObject = {};
__webpack_require__.r(session_namespaceObject);
__webpack_require__.d(session_namespaceObject, { 
  clearSession: () => (clearSession),
  isTestEnv: () => (isTestEnv),
  isUniView: () => (isUniView),
  replacePromise: () => (replacePromise),
  shouldClearCache: () => (shouldClearCache),
  tearDown: () => (tearDown) });

// NAMESPACE OBJECT: ./src/headless/shared/constants.js
var shared_constants_namespaceObject = {};
__webpack_require__.r(shared_constants_namespaceObject);
__webpack_require__.d(shared_constants_namespaceObject, { 
  ACTIVE: () => (ACTIVE),
  ANONYMOUS: () => (ANONYMOUS),
  BOSH_WAIT: () => (BOSH_WAIT),
  CHATROOMS_TYPE: () => (CHATROOMS_TYPE),
  CHAT_STATES: () => (CHAT_STATES),
  CLOSED: () => (CLOSED),
  COMPOSING: () => (COMPOSING),
  CONNECTION_STATUS: () => (CONNECTION_STATUS),
  CONTROLBOX_TYPE: () => (CONTROLBOX_TYPE),
  CORE_PLUGINS: () => (CORE_PLUGINS),
  EXTERNAL: () => (EXTERNAL),
  FAILURE: () => (FAILURE),
  GONE: () => (GONE),
  HEADLINES_TYPE: () => (HEADLINES_TYPE),
  INACTIVE: () => (INACTIVE),
  KEYCODES: () => (KEYCODES),
  LOGIN: () => (LOGIN),
  LOGOUT: () => (LOGOUT),
  MARKER_TYPES: () => (MARKER_TYPES),
  METADATA_ATTRIBUTES: () => (METADATA_ATTRIBUTES),
  OPENED: () => (OPENED),
  PAUSED: () => (PAUSED),
  PREBIND: () => (PREBIND),
  PRES_SHOW_VALUES: () => (PRES_SHOW_VALUES),
  PRES_TYPE_VALUES: () => (PRES_TYPE_VALUES),
  PRIVATE_CHAT_TYPE: () => (PRIVATE_CHAT_TYPE),
  STATUS_WEIGHTS: () => (STATUS_WEIGHTS),
  SUCCESS: () => (SUCCESS),
  VERSION_NAME: () => (VERSION_NAME),
  XFORM_TYPE_MAP: () => (XFORM_TYPE_MAP),
  XFORM_VALIDATE_TYPE_MAP: () => (XFORM_VALIDATE_TYPE_MAP) });

// NAMESPACE OBJECT: ./src/headless/utils/storage.js
var storage_namespaceObject = {};
__webpack_require__.r(storage_namespaceObject);
__webpack_require__.d(storage_namespaceObject, { 
  createStore: () => (createStore),
  getDefaultStorageType: () => (getDefaultStorageType),
  initStorage: () => (initStorage),
  isPersistentStorageAvailable: () => (isPersistentStorageAvailable) });

// NAMESPACE OBJECT: ./src/headless/utils/jid.js
var jid_namespaceObject = {};
__webpack_require__.r(jid_namespaceObject);
__webpack_require__.d(jid_namespaceObject, { 
  getFullJID: () => (getFullJID),
  getItemFromURI: () => (getItemFromURI),
  getJIDFromURI: () => (getJIDFromURI),
  getNodeFromURI: () => (getNodeFromURI),
  isOwnJID: () => (isOwnJID),
  isSameBareJID: () => (isSameBareJID),
  isSameDomain: () => (isSameDomain),
  isValidJID: () => (isValidJID),
  isValidMUCJID: () => (isValidMUCJID),
  maybeAppendDomain: () => (maybeAppendDomain) });

// NAMESPACE OBJECT: ./src/headless/utils/init.js
var init_namespaceObject = {};
__webpack_require__.r(init_namespaceObject);
__webpack_require__.d(init_namespaceObject, { 
  attemptNonPreboundSession: () => (attemptNonPreboundSession),
  cleanup: () => (init_cleanup),
  initClientConfig: () => (initClientConfig),
  initPersistentStorage: () => (initPersistentStorage),
  initPlugins: () => (initPlugins),
  initSession: () => (initSession),
  initSessionStorage: () => (initSessionStorage),
  registerGlobalEventHandlers: () => (registerGlobalEventHandlers),
  safeSave: () => (safeSave),
  savedLoginInfo: () => (savedLoginInfo),
  setUserJID: () => (setUserJID) });

// NAMESPACE OBJECT: ./src/headless/utils/promise.js
var promise_namespaceObject = {};
__webpack_require__.r(promise_namespaceObject);
__webpack_require__.d(promise_namespaceObject, { 
  debounce: () => (promise_debounce),
  getOpenPromise: () => (openpromise_getOpenPromise),
  waitUntil: () => (waitUntil) });

// NAMESPACE OBJECT: ./src/headless/shared/errors.js
var errors_namespaceObject = {};
__webpack_require__.r(errors_namespaceObject);
__webpack_require__.d(errors_namespaceObject, { 
  BadRequestError: () => (BadRequestError),
  ConflictError: () => (ConflictError),
  FeatureNotImplementedError: () => (FeatureNotImplementedError),
  ForbiddenError: () => (ForbiddenError),
  GoneError: () => (GoneError),
  IQError: () => (IQError),
  InternalServerError: () => (InternalServerError),
  ItemNotFoundError: () => (ItemNotFoundError),
  JIDMalformedError: () => (JIDMalformedError),
  MethodNotImplementedError: () => (MethodNotImplementedError),
  NotAcceptableError: () => (NotAcceptableError),
  NotAllowedError: () => (NotAllowedError),
  NotAuthorizedError: () => (NotAuthorizedError),
  PaymentRequiredError: () => (PaymentRequiredError),
  RecipientUnavailableError: () => (RecipientUnavailableError),
  RedirectError: () => (RedirectError),
  RegistrationRequiredError: () => (RegistrationRequiredError),
  RemoteServerNotFoundError: () => (RemoteServerNotFoundError),
  RemoteServerTimeoutError: () => (RemoteServerTimeoutError),
  ResourceConstraintError: () => (ResourceConstraintError),
  ServiceUnavailableError: () => (ServiceUnavailableError),
  StanzaError: () => (StanzaError),
  StanzaParseError: () => (StanzaParseError),
  SubscriptionRequiredError: () => (SubscriptionRequiredError),
  TimeoutError: () => (TimeoutError),
  UndefinedConditionError: () => (UndefinedConditionError),
  UnexpectedRequestError: () => (UnexpectedRequestError),
  UserFacingError: () => (UserFacingError) });

// NAMESPACE OBJECT: ./src/headless/utils/array.js
var array_namespaceObject = {};
__webpack_require__.r(array_namespaceObject);
__webpack_require__.d(array_namespaceObject, { 
  unique: () => (array_unique) });

// NAMESPACE OBJECT: ./src/headless/utils/arraybuffer.js
var arraybuffer_namespaceObject = {};
__webpack_require__.r(arraybuffer_namespaceObject);
__webpack_require__.d(arraybuffer_namespaceObject, { 
  appendArrayBuffer: () => (appendArrayBuffer),
  arrayBufferToBase64: () => (arrayBufferToBase64),
  arrayBufferToHex: () => (arrayBufferToHex),
  arrayBufferToString: () => (arrayBufferToString),
  base64ToArrayBuffer: () => (base64ToArrayBuffer),
  hexToArrayBuffer: () => (hexToArrayBuffer),
  stringToArrayBuffer: () => (stringToArrayBuffer) });

// NAMESPACE OBJECT: ./src/headless/utils/color.js
var color_namespaceObject = {};
__webpack_require__.r(color_namespaceObject);
__webpack_require__.d(color_namespaceObject, { 
  colorize: () => (colorize) });

// NAMESPACE OBJECT: ./src/headless/utils/text.js
var text_namespaceObject = {};
__webpack_require__.r(text_namespaceObject);
__webpack_require__.d(text_namespaceObject, { 
  firstCharToUpperCase: () => (firstCharToUpperCase),
  getLongestSubstring: () => (getLongestSubstring),
  isString: () => (text_isString) });

// NAMESPACE OBJECT: ./src/headless/utils/url.js
var url_namespaceObject = {};
__webpack_require__.r(url_namespaceObject);
__webpack_require__.d(url_namespaceObject, { 
  addMediaURLsOffset: () => (addMediaURLsOffset),
  checkFileTypes: () => (checkFileTypes),
  getHeaders: () => (getHeaders),
  getMediaURLs: () => (getMediaURLs),
  getMediaURLsMetadata: () => (getMediaURLsMetadata),
  getMetadataForURL: () => (getMetadataForURL),
  getURL: () => (getURL),
  isAudioURL: () => (isAudioURL),
  isEncryptedFileURL: () => (isEncryptedFileURL),
  isGIFURL: () => (isGIFURL),
  isImageURL: () => (isImageURL),
  isURLWithImageExtension: () => (isURLWithImageExtension),
  isValidURL: () => (isValidURL),
  isVideoURL: () => (isVideoURL),
  withinString: () => (withinString) });

// NAMESPACE OBJECT: ./src/headless/shared/parsers.js
var parsers_namespaceObject = {};
__webpack_require__.r(parsers_namespaceObject);
__webpack_require__.d(parsers_namespaceObject, { 
  getChatMarker: () => (getChatMarker),
  getChatState: () => (getChatState),
  getCorrectionAttributes: () => (getCorrectionAttributes),
  getDeprecatedRetractionAttributes: () => (getDeprecatedRetractionAttributes),
  getEncryptionAttributes: () => (getEncryptionAttributes),
  getErrorAttributes: () => (getErrorAttributes),
  getFallbackAttributes: () => (getFallbackAttributes),
  getInputType: () => (getInputType),
  getOpenGraphMetadata: () => (getOpenGraphMetadata),
  getOutOfBandAttributes: () => (getOutOfBandAttributes),
  getReceiptId: () => (getReceiptId),
  getReferences: () => (getReferences),
  getReplyAttributes: () => (getReplyAttributes),
  getRetractionAttributes: () => (getRetractionAttributes),
  getSpoilerAttributes: () => (getSpoilerAttributes),
  getStanzaIDs: () => (getStanzaIDs),
  isArchived: () => (isArchived),
  isCarbon: () => (isCarbon),
  isHeadline: () => (isHeadline),
  isMUCPrivateMessage: () => (isMUCPrivateMessage),
  isServerMessage: () => (isServerMessage),
  isValidReceiptRequest: () => (isValidReceiptRequest),
  parseErrorStanza: () => (parseErrorStanza),
  parseXForm: () => (parseXForm),
  throwErrorIfInvalidForward: () => (throwErrorIfInvalidForward) });

// NAMESPACE OBJECT: ./src/headless/plugins/muc/constants.js
var muc_constants_namespaceObject = {};
__webpack_require__.r(muc_constants_namespaceObject);
__webpack_require__.d(muc_constants_namespaceObject, { 
  ACTION_INFO_CODES: () => (ACTION_INFO_CODES),
  ADMIN_COMMANDS: () => (ADMIN_COMMANDS),
  AFFILIATIONS: () => (AFFILIATIONS),
  AFFILIATION_CHANGES: () => (AFFILIATION_CHANGES),
  AFFILIATION_CHANGES_LIST: () => (AFFILIATION_CHANGES_LIST),
  DISCONNECT_CODES: () => (DISCONNECT_CODES),
  INFO_CODES: () => (INFO_CODES),
  MODERATOR_COMMANDS: () => (MODERATOR_COMMANDS),
  MUC_NICK_CHANGED_CODE: () => (MUC_NICK_CHANGED_CODE),
  MUC_ROLE_CHANGES: () => (MUC_ROLE_CHANGES),
  MUC_ROLE_CHANGES_LIST: () => (MUC_ROLE_CHANGES_LIST),
  MUC_ROLE_WEIGHTS: () => (MUC_ROLE_WEIGHTS),
  MUC_TRAFFIC_STATES: () => (MUC_TRAFFIC_STATES),
  MUC_TRAFFIC_STATES_LIST: () => (MUC_TRAFFIC_STATES_LIST),
  NEW_NICK_CODES: () => (NEW_NICK_CODES),
  OWNER_COMMANDS: () => (OWNER_COMMANDS),
  ROLES: () => (ROLES),
  ROOMSTATUS: () => (ROOMSTATUS),
  ROOM_FEATURES: () => (ROOM_FEATURES),
  STATUS_CODE_STANZAS: () => (STATUS_CODE_STANZAS),
  VISITOR_COMMANDS: () => (VISITOR_COMMANDS) });

// NAMESPACE OBJECT: ./src/headless/plugins/omemo/constants.js
var omemo_constants_namespaceObject = {};
__webpack_require__.r(omemo_constants_namespaceObject);
__webpack_require__.d(omemo_constants_namespaceObject, { 
  KEY_ALGO: () => (KEY_ALGO),
  TAG_LENGTH: () => (TAG_LENGTH),
  TRUSTED: () => (TRUSTED),
  UNDECIDED: () => (UNDECIDED),
  UNTRUSTED: () => (UNTRUSTED) });


;// CONCATENATED MODULE: ./src/log/index.js
/**
 * @type {Object.<string, number>}
 */
const LEVELS = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
    fatal: 4,
};

/**
 * Logs messages to the console.
 * Available loglevels are:
 *      - 0: 'debug'
 *      - 1: 'info'
 *      - 2: 'warn',
 *      - 3: 'error'
 *      - 4: 'fatal'.
 * @namespace log
 */
const log = {
    /** @type {keyof LEVELS} The current log level */
    loglevel: 'info',

    /**
     * Sets the current log level which determines which messages are logged
     * @param {keyof LEVELS} level - The log level to set
     * @throws {Error} If an invalid log level is provided
     */
    setLogLevel(level) {
        if (!['debug', 'info', 'warn', 'error', 'fatal'].includes(/** @type {string} */ (level))) {
            throw new Error(`Invalid loglevel: ${level}`);
        }
        this.loglevel = level;
    },

    /**
     * Logs a message at the specified level.
     * Accepts the same arguments as the corresponding console method.
     * @param {keyof LEVELS} level - The log level to use
     * @param  {...any} args - Arguments passed through to the console method
     */
    log(level, ...args) {
        if (LEVELS[level] < LEVELS[this.loglevel]) {
            return;
        }

        const [msg, ...rest] = args;
        let formattedMsg = msg;
        if (msg instanceof Error) {
            formattedMsg = msg.stack;
        } else if (typeof Element !== 'undefined' && msg instanceof Element) {
            formattedMsg = msg.outerHTML;
        }

        const method = level === 'fatal' ? 'error' : level;
        console[method](formattedMsg, ...rest);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.debug
     */
    debug(...args) {
        this.log('debug', ...args);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.error
     */
    error(...args) {
        this.log('error', ...args);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.info
     */
    info(...args) {
        this.log('info', ...args);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.warn
     */
    warn(...args) {
        this.log('warn', ...args);
    },

    /**
     * @param  {...any} args - Arguments passed through to console.error
     */
    fatal(...args) {
        this.log('fatal', ...args);
    },
};

/* export default */ const src_log = (log);

// EXTERNAL MODULE: ./node_modules/sizzle/dist/sizzle.js
var sizzle = __webpack_require__(56);
;// CONCATENATED MODULE: ./node_modules/strophe.js/dist/strophe.esm.js
const _NS = {
    AUTH: 'jabber:iq:auth',
    BIND: 'urn:ietf:params:xml:ns:xmpp-bind',
    BOSH: 'urn:xmpp:xbosh',
    CLIENT: 'jabber:client',
    COMPONENT: 'jabber:component:accept' /** XEP-0114 */,
    DISCO_INFO: 'http://jabber.org/protocol/disco#info',
    DISCO_ITEMS: 'http://jabber.org/protocol/disco#items',
    DELAY: 'urn:xmpp:delay' /** XEP-0203 */,
    FRAMING: 'urn:ietf:params:xml:ns:xmpp-framing',
    HTTPBIND: 'http://jabber.org/protocol/httpbind',
    MUC: 'http://jabber.org/protocol/muc',
    PROFILE: 'jabber:iq:profile',
    ROSTER: 'jabber:iq:roster',
    SASL: 'urn:ietf:params:xml:ns:xmpp-sasl',
    SERVER: 'jabber:server',
    SESSION: 'urn:ietf:params:xml:ns:xmpp-session',
    SM: 'urn:xmpp:sm:3',
    STANZAS: 'urn:ietf:params:xml:ns:xmpp-stanzas',
    STREAM: 'http://etherx.jabber.org/streams',
    VERSION: 'jabber:iq:version',
    XHTML: 'http://www.w3.org/1999/xhtml',
    XHTML_IM: 'http://jabber.org/protocol/xhtml-im',
};
/**
 * Common namespace constants from the XMPP RFCs and XEPs.
 * Extensible at runtime via {@link Strophe.addNamespace}, hence the string
 * index signature.
 */
const NS = _NS;
const PARSE_ERROR_NS = 'http://www.w3.org/1999/xhtml';
/**
 * The version of the page↔worker message protocol spoken between
 * WorkerWebsocket and dist/shared-connection-worker.js. A SharedWorker can
 * outlive the pages that spawned it, so after a deploy a freshly loaded page
 * may attach to a worker from an older build (or vice versa). The version is
 * exchanged on _connect/_attach so that a mismatch fails loudly instead of
 * silently misbehaving.
 */
const SHARED_WORKER_PROTOCOL_VERSION = 3;
/**
 * Contains allowed tags, tag attributes, and css properties.
 * Used in the {@link Strophe.createHtml} function to filter incoming html into the allowed XHTML-IM subset.
 * See [XEP-0071](http://xmpp.org/extensions/xep-0071.html#profile-summary) for the list of recommended
 * allowed tags and their attributes.
 */
const XHTML = {
    tags: ['a', 'blockquote', 'br', 'cite', 'em', 'img', 'li', 'ol', 'p', 'span', 'strong', 'ul', 'body'],
    attributes: {
        'a': ['href'],
        'blockquote': ['style'],
        'br': [],
        'cite': ['style'],
        'em': [],
        'img': ['src', 'alt', 'style', 'height', 'width'],
        'li': ['style'],
        'ol': ['style'],
        'p': ['style'],
        'span': ['style'],
        'strong': [],
        'ul': ['style'],
        'body': [],
    },
    css: [
        'background-color',
        'color',
        'font-family',
        'font-size',
        'font-style',
        'font-weight',
        'margin-left',
        'margin-right',
        'text-align',
        'text-decoration',
    ],
};
/**
 * Connection status constants for use by the connection handler
 * callback.
 */
const Status = {
    ERROR: 0,
    CONNECTING: 1,
    CONNFAIL: 2,
    AUTHENTICATING: 3,
    AUTHFAIL: 4,
    CONNECTED: 5,
    DISCONNECTED: 6,
    DISCONNECTING: 7,
    ATTACHED: 8,
    REDIRECT: 9,
    CONNTIMEOUT: 10,
    BINDREQUIRED: 11,
    ATTACHFAIL: 12,
    RECONNECTING: 13,
};
const ErrorCondition = {
    BAD_FORMAT: 'bad-format',
    CONFLICT: 'conflict',
    MISSING_JID_NODE: 'x-strophe-bad-non-anon-jid',
    NO_AUTH_MECH: 'no-auth-mech',
    UNKNOWN_REASON: 'unknown',
};
const LOG_LEVELS = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    FATAL: 4,
};
/**
 * DOM element types.
 *
 * - ElementType.NORMAL - Normal element.
 * - ElementType.TEXT - Text data element.
 * - ElementType.FRAGMENT - XHTML fragment element.
 */
const ElementType = {
    NORMAL: 1,
    TEXT: 3,
    CDATA: 4,
    FRAGMENT: 11,
};

let logLevel = LOG_LEVELS.DEBUG;
const strophe_esm_log = {
    /**
     * Library consumers can use this function to set the log level of Strophe.
     * The default log level is Strophe.LogLevel.INFO.
     * @param level
     * @example Strophe.setLogLevel(Strophe.LogLevel.DEBUG);
     */
    setLogLevel(level) {
        if (level < LOG_LEVELS.DEBUG || level > LOG_LEVELS.FATAL) {
            throw new Error("Invalid log level supplied to setLogLevel");
        }
        logLevel = level;
    },
    /**
     *
     * Please note that data sent and received over the wire is logged
     * via {@link Strophe.Connection#rawInput|Strophe.Connection.rawInput()}
     * and {@link Strophe.Connection#rawOutput|Strophe.Connection.rawOutput()}.
     *
     * The different levels and their meanings are
     *
     *   DEBUG - Messages useful for debugging purposes.
     *   INFO - Informational messages.  This is mostly information like
     *     'disconnect was called' or 'SASL auth succeeded'.
     *   WARN - Warnings about potential problems.  This is mostly used
     *     to report transient connection errors like request timeouts.
     *   ERROR - Some error occurred.
     *   FATAL - A non-recoverable fatal error occurred.
     *
     * @param level - The log level of the log message.
     *     This will be one of the values in Strophe.LOG_LEVELS.
     * @param msg - The log message.
     */
    log(level, msg) {
        if (level < logLevel) {
            return;
        }
        if (level >= LOG_LEVELS.ERROR) {
            console === null || console === void 0 ? void 0 : console.error(msg);
        }
        else if (level === LOG_LEVELS.INFO) {
            console === null || console === void 0 ? void 0 : console.info(msg);
        }
        else if (level === LOG_LEVELS.WARN) {
            console === null || console === void 0 ? void 0 : console.warn(msg);
        }
        else if (level === LOG_LEVELS.DEBUG) {
            console === null || console === void 0 ? void 0 : console.debug(msg);
        }
    },
    /**
     * Log a message at the Strophe.LOG_LEVELS.DEBUG level.
     * @param msg - The log message.
     */
    debug(msg) {
        this.log(LOG_LEVELS.DEBUG, msg);
    },
    /**
     * Log a message at the Strophe.LOG_LEVELS.INFO level.
     * @param msg - The log message.
     */
    info(msg) {
        this.log(LOG_LEVELS.INFO, msg);
    },
    /**
     * Log a message at the Strophe.LOG_LEVELS.WARN level.
     * @param msg - The log message.
     */
    warn(msg) {
        this.log(LOG_LEVELS.WARN, msg);
    },
    /**
     * Log a message at the Strophe.LOG_LEVELS.ERROR level.
     * @param msg - The log message.
     */
    error(msg) {
        this.log(LOG_LEVELS.ERROR, msg);
    },
    /**
     * Log a message at the Strophe.LOG_LEVELS.FATAL level.
     * @param msg - The log message.
     */
    fatal(msg) {
        this.log(LOG_LEVELS.FATAL, msg);
    },
};

/**
 * Takes a string and turns it into an XML Element.
 * @param string
 * @param throwErrorIfInvalidNS
 * @returns
 */
function toElement(string, throwErrorIfInvalidNS) {
    const doc = strophe_esm_xmlHtmlNode(string);
    const parserError = getParserError(doc);
    if (parserError) {
        throw new Error(`Parser Error: ${parserError}`);
    }
    const node = getFirstElementChild(doc);
    if (['message', 'iq', 'presence'].includes(node.nodeName.toLowerCase()) &&
        node.namespaceURI !== 'jabber:client' &&
        node.namespaceURI !== 'jabber:server') {
        const err_msg = `Invalid namespaceURI ${node.namespaceURI}`;
        if (throwErrorIfInvalidNS) {
            throw new Error(err_msg);
        }
        else {
            strophe_esm_log.error(err_msg);
        }
    }
    return node;
}
/**
 * Properly logs an error to the console
 * @param e
 */
function handleError(e) {
    if (typeof e.stack !== 'undefined') {
        strophe_esm_log.fatal(e.stack);
    }
    strophe_esm_log.fatal('error: ' + e.message);
}
/**
 * @param str
 * @returns
 */
function utf16to8(str) {
    let out = '';
    const len = str.length;
    for (let i = 0; i < len; i++) {
        const c = str.charCodeAt(i);
        if (c >= 0x0000 && c <= 0x007f) {
            out += str.charAt(i);
        }
        else if (c > 0x07ff) {
            out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        }
        else {
            out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        }
    }
    return out;
}
/**
 * @param x
 * @param y
 * @returns
 */
function xorArrayBuffers(x, y) {
    const xIntArray = new Uint8Array(x);
    const yIntArray = new Uint8Array(y);
    const zIntArray = new Uint8Array(x.byteLength);
    for (let i = 0; i < x.byteLength; i++) {
        zIntArray[i] = xIntArray[i] ^ yIntArray[i];
    }
    return zIntArray.buffer;
}
/**
 * @param buffer
 * @returns
 */
function arrayBufToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
/**
 * @param str
 * @returns
 */
function base64ToArrayBuf(str) {
    var _a;
    return (_a = Uint8Array.from(atob(str), (c) => c.charCodeAt(0))) === null || _a === void 0 ? void 0 : _a.buffer;
}
/**
 * @param str
 * @returns
 */
function stringToArrayBuf(str) {
    const bytes = new TextEncoder().encode(str);
    return bytes.buffer;
}
/**
 * @param cookies
 */
function addCookies(cookies) {
    if (typeof document === 'undefined') {
        strophe_esm_log.error(`addCookies: not adding any cookies, since there's no document object`);
        return;
    }
    const cookieMap = cookies || {};
    for (const cookieName in cookieMap) {
        if (Object.prototype.hasOwnProperty.call(cookieMap, cookieName)) {
            let expires = '';
            let domain = '';
            let path = '';
            const cookieObj = cookieMap[cookieName];
            const isObj = typeof cookieObj === 'object';
            const cookieValue = escape(unescape(isObj ? cookieObj.value : cookieObj));
            if (isObj) {
                const cv = cookieObj;
                expires = cv.expires ? ';expires=' + cv.expires : '';
                domain = cv.domain ? ';domain=' + cv.domain : '';
                path = cv.path ? ';path=' + cv.path : '';
            }
            document.cookie = cookieName + '=' + cookieValue + expires + domain + path;
        }
    }
}
let _xmlGenerator = null;
/**
 * Get the DOM document to generate elements.
 * @returns The currently used DOM document.
 */
function xmlGenerator() {
    if (!_xmlGenerator) {
        _xmlGenerator = document.implementation.createDocument('jabber:client', 'strophe', null);
    }
    return _xmlGenerator;
}
/**
 * Creates an XML DOM text node.
 * Provides a cross implementation version of document.createTextNode.
 * @param text - The content of the text node.
 * @returns A new XML DOM text node.
 */
function xmlTextNode(text) {
    return xmlGenerator().createTextNode(text);
}
/**
 * @param stanza
 * @returns
 */
function stripWhitespace(stanza) {
    const childNodes = Array.from(stanza.childNodes);
    if (childNodes.length === 1 && childNodes[0].nodeType === ElementType.TEXT) {
        return stanza;
    }
    childNodes.forEach((node) => {
        if (node.nodeName.toLowerCase() === 'body') {
            return;
        }
        if (node.nodeType === ElementType.TEXT && !/\S/.test(node.nodeValue)) {
            stanza.removeChild(node);
        }
        else if (node.nodeType === ElementType.NORMAL) {
            stripWhitespace(node);
        }
    });
    return stanza;
}
/**
 * Creates an XML DOM node.
 * @param text - The contents of the XML element.
 * @returns
 */
function strophe_esm_xmlHtmlNode(text) {
    const parser = new DOMParser();
    return parser.parseFromString(text, 'text/xml');
}
/**
 * @param doc
 * @returns
 */
function getParserError(doc) {
    var _a;
    const el = ((_a = doc.firstElementChild) === null || _a === void 0 ? void 0 : _a.nodeName) === 'parsererror'
        ? doc.firstElementChild
        : doc.getElementsByTagNameNS(PARSE_ERROR_NS, 'parsererror')[0];
    return (el === null || el === void 0 ? void 0 : el.nodeName) === 'parsererror' ? el === null || el === void 0 ? void 0 : el.textContent : null;
}
/**
 * @param el
 * @returns
 */
function getFirstElementChild(el) {
    if (el.firstElementChild)
        return el.firstElementChild;
    let node;
    let i = 0;
    const nodes = el.childNodes;
    while ((node = nodes[i++])) {
        if (node.nodeType === 1)
            return node;
    }
    return null;
}
/**
 * Create an XML DOM element.
 *
 * This function creates an XML DOM element correctly across all
 * implementations. Note that these are not HTML DOM elements, which
 * aren't appropriate for XMPP stanzas.
 *
 * @param name - The name for the element.
 * @param attrs
 *    An optional array or object containing
 *    key/value pairs to use as element attributes.
 *    The object should be in the format `{'key': 'value'}`.
 *    The array should have the format `[['key1', 'value1'], ['key2', 'value2']]`.
 * @param text - The text child data for the element.
 *
 * @returns A new XML DOM element.
 */
function xmlElement(name, attrs, text) {
    if (!name)
        return null;
    const node = xmlGenerator().createElement(name);
    if (text && (typeof text === 'string' || typeof text === 'number')) {
        node.appendChild(xmlTextNode(text.toString()));
    }
    else if (typeof attrs === 'string' || typeof attrs === 'number') {
        node.appendChild(xmlTextNode(attrs.toString()));
        return node;
    }
    if (!attrs) {
        return node;
    }
    else if (Array.isArray(attrs)) {
        for (const attr of attrs) {
            if (Array.isArray(attr)) {
                if (attr[0] != null && attr[1] != null) {
                    node.setAttribute(attr[0], attr[1]);
                }
            }
        }
    }
    else if (typeof attrs === 'object') {
        for (const k of Object.keys(attrs)) {
            if (k && attrs[k] != null) {
                node.setAttribute(k, attrs[k].toString());
            }
        }
    }
    return node;
}
/**
 * Utility method to determine whether a tag is allowed
 * in the XHTML_IM namespace.
 *
 * XHTML tag names are case sensitive and must be lower case.
 * @method Strophe.XHTML.validTag
 * @param tag
 */
function validTag(tag) {
    for (let i = 0; i < XHTML.tags.length; i++) {
        if (tag === XHTML.tags[i]) {
            return true;
        }
    }
    return false;
}
/**
 * Utility method to determine whether an attribute is allowed
 * as recommended per XEP-0071
 *
 * XHTML attribute names are case sensitive and must be lower case.
 * @method Strophe.XHTML.validAttribute
 * @param tag
 * @param attribute
 */
function validAttribute(tag, attribute) {
    const attrs = XHTML.attributes[tag];
    if ((attrs === null || attrs === void 0 ? void 0 : attrs.length) > 0) {
        for (let i = 0; i < attrs.length; i++) {
            if (attribute === attrs[i]) {
                return true;
            }
        }
    }
    return false;
}
/**
 * @method Strophe.XHTML.validCSS
 * @param style
 */
function validCSS(style) {
    for (let i = 0; i < XHTML.css.length; i++) {
        if (style === XHTML.css[i]) {
            return true;
        }
    }
    return false;
}
/**
 * Copy an HTML DOM Element into an XML DOM.
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @param elem - A DOM element.
 * @returns A new, copied DOM element tree.
 */
function createFromHtmlElement(elem) {
    var _a;
    let el;
    const tag = elem.nodeName.toLowerCase();
    if (validTag(tag)) {
        try {
            el = xmlElement(tag);
            if (tag in XHTML.attributes) {
                const attrs = XHTML.attributes[tag];
                for (let i = 0; i < attrs.length; i++) {
                    const attribute = attrs[i];
                    let value = elem.getAttribute(attribute);
                    if (typeof value === 'undefined' || value === null || value === '') {
                        continue;
                    }
                    if (attribute === 'style' && typeof value === 'object') {
                        value = (_a = value.cssText) !== null && _a !== void 0 ? _a : value;
                    }
                    if (attribute === 'style') {
                        const css = [];
                        const cssAttrs = value.split(';');
                        for (let j = 0; j < cssAttrs.length; j++) {
                            const attr = cssAttrs[j].split(':');
                            const cssName = attr[0].replace(/^\s*/, '').replace(/\s*$/, '').toLowerCase();
                            if (validCSS(cssName)) {
                                const cssValue = attr[1].replace(/^\s*/, '').replace(/\s*$/, '');
                                css.push(cssName + ': ' + cssValue);
                            }
                        }
                        if (css.length > 0) {
                            value = css.join('; ');
                            el.setAttribute(attribute, value);
                        }
                    }
                    else {
                        el.setAttribute(attribute, value);
                    }
                }
                for (let i = 0; i < elem.childNodes.length; i++) {
                    el.appendChild(createHtml(elem.childNodes[i]));
                }
            }
        }
        catch (_e) {
            el = xmlTextNode('');
        }
    }
    else {
        el = xmlGenerator().createDocumentFragment();
        for (let i = 0; i < elem.childNodes.length; i++) {
            el.appendChild(createHtml(elem.childNodes[i]));
        }
    }
    return el;
}
/**
 * Copy an HTML DOM Node into an XML DOM.
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @method Strophe.createHtml
 * @param node - A DOM element.
 * @returns A new, copied DOM element tree.
 */
function createHtml(node) {
    if (node.nodeType === ElementType.NORMAL) {
        return createFromHtmlElement(node);
    }
    else if (node.nodeType === ElementType.FRAGMENT) {
        const el = xmlGenerator().createDocumentFragment();
        for (let i = 0; i < node.childNodes.length; i++) {
            el.appendChild(createHtml(node.childNodes[i]));
        }
        return el;
    }
    else if (node.nodeType === ElementType.TEXT) {
        return xmlTextNode(node.nodeValue);
    }
}
/**
 * Copy an XML DOM element.
 *
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @method Strophe.copyElement
 * @param node - A DOM element.
 * @returns A new, copied DOM element tree.
 */
function copyElement(node) {
    let out;
    if (node.nodeType === ElementType.NORMAL) {
        const el = node;
        out = xmlElement(el.tagName);
        for (let i = 0; i < el.attributes.length; i++) {
            out.setAttribute(el.attributes[i].nodeName, el.attributes[i].value);
        }
        for (let i = 0; i < el.childNodes.length; i++) {
            out.appendChild(copyElement(el.childNodes[i]));
        }
    }
    else if (node.nodeType === ElementType.TEXT) {
        out = xmlGenerator().createTextNode(node.nodeValue);
    }
    return out;
}
/**
 * Excapes invalid xml characters.
 * @method Strophe.xmlescape
 * @param text - text to escape.
 * @returns Escaped text.
 */
function xmlescape(text) {
    return text
        .replace(/\&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&apos;')
        .replace(/"/g, '&quot;');
}
/**
 * Unexcapes invalid xml characters.
 * @method Strophe.xmlunescape
 * @param text - text to unescape.
 * @returns Unescaped text.
 */
function xmlunescape(text) {
    text = text.replace(/\&amp;/g, '&');
    text = text.replace(/&lt;/g, '<');
    text = text.replace(/&gt;/g, '>');
    text = text.replace(/&apos;/g, "'");
    text = text.replace(/&quot;/g, '"');
    return text;
}
/**
 * Map a function over some or all child elements of a given element.
 *
 * This is a small convenience function for mapping a function over
 * some or all of the children of an element.  If elemName is null, all
 * children will be passed to the function, otherwise only children
 * whose tag names match elemName will be passed.
 *
 * @method Strophe.forEachChild
 * @param elem - The element to operate on.
 * @param elemName - The child element tag name filter.
 * @param func - The function to apply to each child.  This
 *    function should take a single argument, a DOM element.
 */
function forEachChild(elem, elemName, func) {
    for (let i = 0; i < elem.childNodes.length; i++) {
        const childNode = elem.childNodes[i];
        if (childNode.nodeType === ElementType.NORMAL && (!elemName || isTagEqual(childNode, elemName))) {
            func(childNode);
        }
    }
}
/**
 * Compare an element's tag name with a string.
 * This function is case sensitive.
 * @method Strophe.isTagEqual
 * @param el - A DOM element.
 * @param name - The element name.
 * @returns
 *  true if the element's tag name matches _el_, and false
 *  otherwise.
 */
function isTagEqual(el, name) {
    return el.tagName === name;
}
/**
 * Return the XML namespace of an element.
 *
 * Prefers the serialized `xmlns` attribute and falls back to the DOM
 * `namespaceURI`, because the two diverge depending on how the element was
 * built and neither is reliable on its own:
 *
 *  - Locally-built stanzas (`$iq`, `stx`, {@link Builder}) are created with
 *    `createElement` and carry their namespace only in the `xmlns` attribute;
 *    their `namespaceURI` is null.
 *  - Stanzas received over the XEP-0114 component transport are built with
 *    `createElementNS` and carry their namespace only on `namespaceURI`; the
 *    redundant `xmlns` attribute is omitted.
 *  - WebSocket / BOSH stanzas parsed by `DOMParser` carry both, except on
 *    child elements that inherit the default namespace without redeclaring it
 *    (those have only `namespaceURI`).
 *
 * Checking both is the transport-agnostic way to read an element's namespace.
 *
 * @method Strophe.getNamespace
 * @param elem - The element whose namespace is wanted.
 * @returns The namespace URI, or null if the element has none.
 */
function getNamespace(elem) {
    return elem.getAttribute('xmlns') || elem.namespaceURI;
}
/**
 * Get the concatenation of all text children of an element.
 * @method Strophe.getText
 * @param elem - A DOM element.
 * @returns A String with the concatenated text of all text element children.
 */
function getText(elem) {
    if (!elem)
        return null;
    let str = '';
    if (!elem.childNodes.length && elem.nodeType === ElementType.TEXT) {
        str += elem.nodeValue;
    }
    for (const child of elem.childNodes) {
        if (child.nodeType === ElementType.TEXT) {
            str += child.nodeValue;
        }
    }
    return xmlescape(str);
}
/**
 * Escape the node part (also called local part) of a JID.
 * @method Strophe.escapeNode
 * @param node - A node (or local part).
 * @returns An escaped node (or local part).
 */
function escapeNode(node) {
    if (typeof node !== 'string') {
        return node;
    }
    return node
        .replace(/^\s+|\s+$/g, '')
        .replace(/\\/g, '\\5c')
        .replace(/ /g, '\\20')
        .replace(/\"/g, '\\22')
        .replace(/\&/g, '\\26')
        .replace(/\'/g, '\\27')
        .replace(/\//g, '\\2f')
        .replace(/:/g, '\\3a')
        .replace(/</g, '\\3c')
        .replace(/>/g, '\\3e')
        .replace(/@/g, '\\40');
}
/**
 * Unescape a node part (also called local part) of a JID.
 * @method Strophe.unescapeNode
 * @param node - A node (or local part).
 * @returns An unescaped node (or local part).
 */
function unescapeNode(node) {
    if (typeof node !== 'string') {
        return node;
    }
    return node
        .replace(/\\20/g, ' ')
        .replace(/\\22/g, '"')
        .replace(/\\26/g, '&')
        .replace(/\\27/g, "'")
        .replace(/\\2f/g, '/')
        .replace(/\\3a/g, ':')
        .replace(/\\3c/g, '<')
        .replace(/\\3e/g, '>')
        .replace(/\\40/g, '@')
        .replace(/\\5c/g, '\\');
}
/**
 * Get the node portion of a JID String.
 * @method Strophe.getNodeFromJid
 * @param jid - A JID.
 * @returns A String containing the node.
 */
function getNodeFromJid(jid) {
    if (jid.indexOf('@') < 0) {
        return null;
    }
    return jid.split('@')[0];
}
/**
 * Get the domain portion of a JID String.
 * @method Strophe.getDomainFromJid
 * @param jid - A JID.
 * @returns A String containing the domain.
 */
function getDomainFromJid(jid) {
    const bare = getBareJidFromJid(jid);
    if (bare.indexOf('@') < 0) {
        return bare;
    }
    else {
        const parts = bare.split('@');
        parts.splice(0, 1);
        return parts.join('@');
    }
}
/**
 * Get the resource portion of a JID String.
 * @method Strophe.getResourceFromJid
 * @param jid - A JID.
 * @returns A String containing the resource.
 */
function getResourceFromJid(jid) {
    if (!jid) {
        return null;
    }
    const s = jid.split('/');
    if (s.length < 2) {
        return null;
    }
    s.splice(0, 1);
    return s.join('/');
}
/**
 * Get the bare JID from a JID String.
 * @method Strophe.getBareJidFromJid
 * @param jid - A JID.
 * @returns A String containing the bare JID.
 */
function getBareJidFromJid(jid) {
    return jid ? jid.split('/')[0] : null;
}
const utils = {
    utf16to8,
    xorArrayBuffers,
    arrayBufToBase64,
    base64ToArrayBuf,
    stringToArrayBuf,
    addCookies,
};

var utils$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addCookies: addCookies,
    arrayBufToBase64: arrayBufToBase64,
    base64ToArrayBuf: base64ToArrayBuf,
    copyElement: copyElement,
    createHtml: createHtml,
    default: utils,
    escapeNode: escapeNode,
    forEachChild: forEachChild,
    getBareJidFromJid: getBareJidFromJid,
    getDomainFromJid: getDomainFromJid,
    getFirstElementChild: getFirstElementChild,
    getNamespace: getNamespace,
    getNodeFromJid: getNodeFromJid,
    getParserError: getParserError,
    getResourceFromJid: getResourceFromJid,
    getText: getText,
    handleError: handleError,
    isTagEqual: isTagEqual,
    stringToArrayBuf: stringToArrayBuf,
    stripWhitespace: stripWhitespace,
    toElement: toElement,
    unescapeNode: unescapeNode,
    utf16to8: utf16to8,
    validAttribute: validAttribute,
    validCSS: validCSS,
    validTag: validTag,
    xmlElement: xmlElement,
    xmlGenerator: xmlGenerator,
    xmlHtmlNode: strophe_esm_xmlHtmlNode,
    xmlTextNode: xmlTextNode,
    xmlescape: xmlescape,
    xmlunescape: xmlunescape,
    xorArrayBuffers: xorArrayBuffers
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var _Builder_nodeTree, _Builder_node, _Builder_name, _Builder_attrs;
/**
 * Create a {@link Strophe.Builder}
 * This is an alias for `new Strophe.Builder(name, attrs)`.
 * @param name - The root element name.
 * @param attrs - The attributes for the root element in object notation.
 * @returns A new Strophe.Builder object.
 */
function $build(name, attrs) {
    return new strophe_esm_Builder(name, attrs);
}
/**
 * Create a {@link Strophe.Builder} with a `<message/>` element as the root.
 * @param attrs - The <message/> element attributes in object notation.
 * @returns A new Strophe.Builder object.
 */
function $msg(attrs) {
    return new strophe_esm_Builder('message', attrs);
}
/**
 * Create a {@link Strophe.Builder} with an `<iq/>` element as the root.
 * @param attrs - The <iq/> element attributes in object notation.
 * @returns A new Strophe.Builder object.
 */
function $iq(attrs) {
    return new strophe_esm_Builder('iq', attrs);
}
/**
 * Create a {@link Strophe.Builder} with a `<presence/>` element as the root.
 * @param attrs - The <presence/> element attributes in object notation.
 * @returns A new Strophe.Builder object.
 */
function $pres(attrs) {
    return new strophe_esm_Builder('presence', attrs);
}
/**
 * This class provides an interface similar to JQuery but for building
 * DOM elements easily and rapidly.  All the functions except for `toString()`
 * and tree() return the object, so calls can be chained.
 *
 * The corresponding DOM manipulations to get a similar fragment would be
 * a lot more tedious and probably involve several helper variables.
 *
 * Since adding children makes new operations operate on the child, up()
 * is provided to traverse up the tree.  To add two children, do
 * > builder.c('child1', ...).up().c('child2', ...)
 *
 * The next operation on the Builder will be relative to the second child.
 *
 * @example
 *  // Here's an example using the $iq() builder helper.
 *  $iq({to: 'you', from: 'me', type: 'get', id: '1'})
 *      .c('query', {xmlns: 'strophe:example'})
 *      .c('example')
 *      .toString()
 *
 *  // The above generates this XML fragment
 *  //  <iq to='you' from='me' type='get' id='1'>
 *  //    <query xmlns='strophe:example'>
 *  //      <example/>
 *  //    </query>
 *  //  </iq>
 */
class strophe_esm_Builder {
    /**
     * The attributes should be passed in object notation.
     * @param name - The name of the root element.
     * @param attrs - The attributes for the root element in object notation.
     * @example const b = new Builder('message', {to: 'you', from: 'me'});
     * @example const b = new Builder('messsage', {'xml:lang': 'en'});
     */
    constructor(name, attrs) {
        _Builder_nodeTree.set(this, void 0);
        _Builder_node.set(this, void 0);
        _Builder_name.set(this, void 0);
        _Builder_attrs.set(this, void 0);
        // Set correct namespace for jabber:client elements
        if (name === 'presence' || name === 'message' || name === 'iq') {
            if (attrs && !attrs.xmlns) {
                attrs.xmlns = NS.CLIENT;
            }
            else if (!attrs) {
                attrs = { xmlns: NS.CLIENT };
            }
        }
        __classPrivateFieldSet(this, _Builder_name, name, "f");
        __classPrivateFieldSet(this, _Builder_attrs, attrs, "f");
    }
    /**
     * Creates a new Builder object from an XML string.
     * @param str
     * @returns
     * @example const stanza = Builder.fromString('<presence from="juliet@example.com/chamber"></presence>');
     */
    static fromString(str) {
        const el = toElement(str, true);
        const b = new strophe_esm_Builder('');
        __classPrivateFieldSet(b, _Builder_nodeTree, el, "f");
        return b;
    }
    buildTree() {
        return xmlElement(__classPrivateFieldGet(this, _Builder_name, "f"), __classPrivateFieldGet(this, _Builder_attrs, "f"));
    }
    get nodeTree() {
        if (!__classPrivateFieldGet(this, _Builder_nodeTree, "f")) {
            // Holds the tree being built.
            __classPrivateFieldSet(this, _Builder_nodeTree, this.buildTree(), "f");
        }
        return __classPrivateFieldGet(this, _Builder_nodeTree, "f");
    }
    get node() {
        if (!__classPrivateFieldGet(this, _Builder_node, "f")) {
            __classPrivateFieldSet(this, _Builder_node, this.tree(), "f");
        }
        return __classPrivateFieldGet(this, _Builder_node, "f");
    }
    set node(el) {
        __classPrivateFieldSet(this, _Builder_node, el, "f");
    }
    /**
     * Render a DOM element and all descendants to a String.
     * @param elem - A DOM element.
     * @returns The serialized element tree as a String.
     */
    static serialize(elem) {
        if (!elem)
            return null;
        const el = elem instanceof strophe_esm_Builder ? elem.tree() : elem;
        const names = [...Array(el.attributes.length).keys()].map((i) => el.attributes[i].nodeName);
        names.sort();
        let result = names.reduce((a, n) => `${a} ${n}="${xmlescape(el.attributes.getNamedItem(n).value)}"`, `<${el.nodeName}`);
        if (el.childNodes.length > 0) {
            result += '>';
            for (let i = 0; i < el.childNodes.length; i++) {
                const child = el.childNodes[i];
                switch (child.nodeType) {
                    case ElementType.NORMAL:
                        result += strophe_esm_Builder.serialize(child);
                        break;
                    case ElementType.TEXT:
                        result += xmlescape(child.nodeValue);
                        break;
                    case ElementType.CDATA:
                        result += '<![CDATA[' + child.nodeValue + ']]>';
                }
            }
            result += '</' + el.nodeName + '>';
        }
        else {
            result += '/>';
        }
        return result;
    }
    /**
     * Return the DOM tree.
     *
     * This function returns the current DOM tree as an element object.  This
     * is suitable for passing to functions like Strophe.Connection.send().
     *
     * @returns The DOM tree as a element object.
     */
    tree() {
        return this.nodeTree;
    }
    /**
     * Serialize the DOM tree to a String.
     *
     * This function returns a string serialization of the current DOM
     * tree.  It is often used internally to pass data to a
     * Strophe.Request object.
     *
     * @returns The serialized DOM tree in a String.
     */
    toString() {
        return strophe_esm_Builder.serialize(this.tree());
    }
    /**
     * Make the current parent element the new current element.
     * This function is often used after c() to traverse back up the tree.
     *
     * @example
     *  // For example, to add two children to the same element
     *  builder.c('child1', {}).up().c('child2', {});
     *
     * @returns The Strophe.Builder object.
     */
    up() {
        this.node = this.node.parentElement ? this.node.parentElement : this.node.parentNode;
        return this;
    }
    /**
     * Make the root element the new current element.
     *
     * When at a deeply nested element in the tree, this function can be used
     * to jump back to the root of the tree, instead of having to repeatedly
     * call up().
     *
     * @returns The Strophe.Builder object.
     */
    root() {
        this.node = this.tree();
        return this;
    }
    /**
     * Add or modify attributes of the current element.
     *
     * The attributes should be passed in object notation.
     * This function does not move the current element pointer.
     * @param moreattrs - The attributes to add/modify in object notation.
     *  If an attribute is set to `null` or `undefined`, it will be removed.
     * @returns The Strophe.Builder object.
     */
    attrs(moreattrs) {
        for (const k in moreattrs) {
            if (Object.prototype.hasOwnProperty.call(moreattrs, k)) {
                if (moreattrs[k] != null) {
                    this.node.setAttribute(k, moreattrs[k].toString());
                }
                else {
                    this.node.removeAttribute(k);
                }
            }
        }
        return this;
    }
    /**
     * Add a child to the current element and make it the new current
     * element.
     *
     * This function moves the current element pointer to the child,
     * unless text is provided.  If you need to add another child, it
     * is necessary to use up() to go back to the parent in the tree.
     *
     * @param name - The name of the child.
     * @param attrs - The attributes of the child in object notation.
     * @param text - The text to add to the child.
     *
     * @returns The Strophe.Builder object.
     */
    c(name, attrs, text) {
        const child = xmlElement(name, attrs, text);
        this.node.appendChild(child);
        if (typeof text !== 'string' && typeof text !== 'number') {
            this.node = child;
        }
        return this;
    }
    /**
     * Add a child to the current element and make it the new current
     * element.
     *
     * This function is the same as c() except that instead of using a
     * name and an attributes object to create the child it uses an
     * existing DOM element object.
     *
     * @param elem - A DOM element.
     * @returns The Strophe.Builder object.
     */
    cnode(elem) {
        if (elem instanceof strophe_esm_Builder) {
            elem = elem.tree();
        }
        let impNode;
        const xmlGen = xmlGenerator();
        try {
            impNode = xmlGen.importNode !== undefined;
        }
        catch (_e) {
            impNode = false;
        }
        const newElem = impNode ? xmlGen.importNode(elem, true) : copyElement(elem);
        this.node.appendChild(newElem);
        this.node = newElem;
        return this;
    }
    /**
     * Add a child text element.
     *
     * This *does not* make the child the new current element since there
     * are no children of text elements.
     *
     * @param text - The text data to append to the current element.
     * @returns The Strophe.Builder object.
     */
    t(text) {
        const child = xmlTextNode(text);
        this.node.appendChild(child);
        return this;
    }
    /**
     * Replace current element contents with the HTML passed in.
     *
     * This *does not* make the child the new current element
     *
     * @param html - The html to insert as contents of current element.
     * @returns The Strophe.Builder object.
     */
    h(html) {
        const fragment = xmlGenerator().createElement('body');
        fragment.innerHTML = html;
        const xhtml = createHtml(fragment);
        while (xhtml.childNodes.length > 0) {
            this.node.appendChild(xhtml.childNodes[0]);
        }
        return this;
    }
}
_Builder_nodeTree = new WeakMap(), _Builder_node = new WeakMap(), _Builder_name = new WeakMap(), _Builder_attrs = new WeakMap();

/**
 * _Private_ variable that keeps track of the request ids for connections.
 */
let _requestId = 0;
/**
 * Helper class that provides a cross implementation abstraction
 * for a BOSH related XMLHttpRequest.
 *
 * The Request class is used internally to encapsulate BOSH request
 * information.  It is not meant to be used from user's code.
 */
class Request {
    /**
     * Create and initialize a new Request object.
     *
     * @param elem - The XML data to be sent in the request.
     * @param func - The function that will be called when the
     *     XMLHttpRequest readyState changes.
     * @param rid - The BOSH rid attribute associated with this request.
     * @param sends - The number of times this same request has been sent.
     */
    constructor(elem, func, rid, sends = 0) {
        this.id = ++_requestId;
        this.xmlData = elem;
        this.data = strophe_esm_Builder.serialize(elem);
        this.origFunc = func;
        this.func = func;
        this.rid = rid;
        this.date = NaN;
        this.sends = sends;
        this.abort = false;
        this.dead = null;
        this.age = () => (this.date ? (new Date().valueOf() - this.date.valueOf()) / 1000 : 0);
        this.timeDead = () => (this.dead ? (new Date().valueOf() - this.dead.valueOf()) / 1000 : 0);
        this.xhr = this._newXHR();
    }
    /**
     * Get a response from the underlying XMLHttpRequest.
     * This function attempts to get a response from the request and checks
     * for errors.
     * @throws "parsererror" - A parser error occured.
     * @throws "bad-format" - The entity has sent XML that cannot be processed.
     * @returns The DOM element tree of the response.
     */
    getResponse() {
        var _a;
        const node = (_a = this.xhr.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement;
        if (node) {
            if (node.tagName === 'parsererror') {
                strophe_esm_log.error('invalid response received');
                strophe_esm_log.error('responseText: ' + this.xhr.responseText);
                strophe_esm_log.error('responseXML: ' + strophe_esm_Builder.serialize(node));
                throw new Error('parsererror');
            }
        }
        else if (this.xhr.responseText) {
            strophe_esm_log.debug('Got responseText but no responseXML; attempting to parse it with DOMParser...');
            const doc = strophe_esm_xmlHtmlNode(this.xhr.responseText);
            const parserError = getParserError(doc);
            if (!doc || parserError) {
                if (parserError) {
                    strophe_esm_log.error('invalid response received: ' + parserError);
                    strophe_esm_log.error('responseText: ' + this.xhr.responseText);
                }
                const error = new Error();
                error.name = ErrorCondition.BAD_FORMAT;
                throw error;
            }
        }
        return node !== null && node !== void 0 ? node : null;
    }
    /**
     * _Private_ helper function to create XMLHttpRequests.
     * This function creates XMLHttpRequests across all implementations.
     * @private
     */
    _newXHR() {
        const xhr = new XMLHttpRequest();
        if (xhr.overrideMimeType) {
            xhr.overrideMimeType('text/xml; charset=utf-8');
        }
        xhr.onreadystatechange = this.func.bind(null, this);
        return xhr;
    }
}

/**
 * A JavaScript library to enable BOSH in Strophejs.
 *
 * this library uses Bidirectional-streams Over Synchronous HTTP (BOSH)
 * to emulate a persistent, stateful, two-way connection to an XMPP server.
 * More information on BOSH can be found in XEP 124.
 */
let timeoutMultiplier = 1.1;
let secondaryTimeoutMultiplier = 0.1;
/**
 * _Private_ helper class that handles BOSH Connections
 * The Bosh class is used internally by Connection
 * to encapsulate BOSH sessions. It is not meant to be used from user's code.
 */
class Bosh {
    /**
     * @param connection - The Connection that will use BOSH.
     */
    constructor(connection) {
        var _a;
        this._conn = connection;
        /* request id for body tags */
        this.rid = Math.floor(Math.random() * 4294967295);
        /* The current session ID. */
        this.sid = null;
        // default BOSH values
        this.hold = 1;
        this.wait = 60;
        this.window = 5;
        this.errors = 0;
        this.inactivity = null;
        /**
         * BOSH-Connections will have all stanzas wrapped in a <body> tag when
         * passed to {@link Connection#xmlInput|xmlInput()} or {@link Connection#xmlOutput|xmlOutput()}.
         * To strip this tag, User code can set {@link Bosh#strip|strip} to `true`:
         *
         * > // You can set `strip` on the prototype
         * > Bosh.prototype.strip = true;
         *
         * > // Or you can set it on the Bosh instance (which is `._proto` on the connection instance.
         * > const conn = new Connection();
         * > conn._proto.strip = true;
         *
         * This will enable stripping of the body tag in both
         * {@link Connection#xmlInput|xmlInput} and {@link Connection#xmlOutput|xmlOutput}.
         */
        this.strip = (_a = Bosh.prototype.strip) !== null && _a !== void 0 ? _a : false;
        this.lastResponseHeaders = null;
        this._requests = [];
    }
    static setTimeoutMultiplier(m) {
        timeoutMultiplier = m;
    }
    static getTimeoutMultplier() {
        return timeoutMultiplier;
    }
    static setSecondaryTimeoutMultiplier(m) {
        secondaryTimeoutMultiplier = m;
    }
    static getSecondaryTimeoutMultplier() {
        return secondaryTimeoutMultiplier;
    }
    /**
     * _Private_ helper function to generate the <body/> wrapper for BOSH.
     * @private
     * @returns A Builder with a <body/> element.
     */
    _buildBody() {
        const bodyWrap = $build('body', {
            'rid': this.rid++,
            'xmlns': NS.HTTPBIND,
        });
        if (this.sid !== null) {
            bodyWrap.attrs({ 'sid': this.sid });
        }
        if (this._conn.options.keepalive && this._conn._sessionCachingSupported()) {
            this._cacheSession();
        }
        return bodyWrap;
    }
    /**
     * Reset the connection.
     * This function is called by the reset function of the Connection
     */
    _reset() {
        this.rid = Math.floor(Math.random() * 4294967295);
        this.sid = null;
        this.errors = 0;
        if (this._conn._sessionCachingSupported()) {
            sessionStorage.removeItem('strophe-bosh-session');
        }
        this._conn.nextValidRid(this.rid);
    }
    /**
     * _Private_ function that initializes the BOSH connection.
     * Creates and sends the Request that initializes the BOSH connection.
     * @param wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     *     Other settings will require tweaks to the Strophe.TIMEOUT value.
     * @param hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param route
     */
    _connect(wait, hold, route) {
        this.wait = wait || this.wait;
        this.hold = hold || this.hold;
        this.errors = 0;
        const body = this._buildBody().attrs({
            'to': this._conn.domain,
            'xml:lang': 'en',
            'wait': this.wait,
            'hold': this.hold,
            'content': 'text/xml; charset=utf-8',
            'ver': '1.6',
            'xmpp:version': '1.0',
            'xmlns:xmpp': NS.BOSH,
        });
        if (route) {
            body.attrs({ route });
        }
        const _connect_cb = this._conn._connect_cb;
        this._requests.push(new Request(body.tree(), this._onRequestStateChange.bind(this, _connect_cb.bind(this._conn)), Number(body.tree().getAttribute('rid'))));
        this._throttledRequestHandler();
    }
    /**
     * Attach to an already created and authenticated BOSH session.
     *
     * This function is provided to allow Strophe to attach to BOSH
     * sessions which have been created externally, perhaps by a Web
     * application.  This is often used to support auto-login type features
     * without putting user credentials into the page.
     *
     * @param jid - The full JID that is bound by the session.
     * @param sid - The SID of the BOSH session.
     * @param rid - The current RID of the BOSH session.  This RID
     *     will be used by the next request.
     * @param callback The connect callback function.
     * @param wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     *     Other settings will require tweaks to the Strophe.TIMEOUT value.
     * @param hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param wind - The optional HTTBIND window value.  This is the
     *     allowed range of request ids that are valid.  The default is 5.
     */
    _attach(jid, sid, rid, callback, wait, hold, wind) {
        this._conn.jid = jid;
        this.sid = sid;
        this.rid = rid;
        this._conn.connect_callback = callback;
        this._conn.domain = getDomainFromJid(this._conn.jid);
        this._conn.authenticated = true;
        this._conn.connected = true;
        this.wait = wait || this.wait;
        this.hold = hold || this.hold;
        this.window = wind || this.window;
        this._conn._changeConnectStatus(Status.ATTACHED, null);
    }
    /**
     * Attempt to restore a cached BOSH session
     *
     * @param jid - The full JID that is bound by the session.
     *     This parameter is optional but recommended, specifically in cases
     *     where prebinded BOSH sessions are used where it's important to know
     *     that the right session is being restored.
     * @param callback The connect callback function.
     * @param wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     *     Other settings will require tweaks to the Strophe.TIMEOUT value.
     * @param hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param wind - The optional HTTBIND window value.  This is the
     *     allowed range of request ids that are valid.  The default is 5.
     */
    _restore(jid, callback, wait, hold, wind) {
        const session = JSON.parse(sessionStorage.getItem('strophe-bosh-session'));
        if (typeof session !== 'undefined' &&
            session !== null &&
            session.rid &&
            session.sid &&
            session.jid &&
            (typeof jid === 'undefined' ||
                jid === null ||
                getBareJidFromJid(session.jid) === getBareJidFromJid(jid) ||
                // If authcid is null, then it's an anonymous login, so
                // we compare only the domains:
                (getNodeFromJid(jid) === null && getDomainFromJid(session.jid) === jid))) {
            this._conn.restored = true;
            this._attach(session.jid, session.sid, session.rid, callback, wait, hold, wind);
        }
        else {
            const error = new Error('_restore: no restoreable session.');
            error.name = 'StropheSessionError';
            throw error;
        }
    }
    /**
     * _Private_ handler for the beforeunload event.
     * This handler is used to process the Bosh-part of the initial request.
     * @private
     */
    _cacheSession() {
        if (this._conn.authenticated) {
            if (this._conn.jid && this.rid && this.sid) {
                sessionStorage.setItem('strophe-bosh-session', JSON.stringify({
                    'jid': this._conn.jid,
                    'rid': this.rid,
                    'sid': this.sid,
                }));
            }
        }
        else {
            sessionStorage.removeItem('strophe-bosh-session');
        }
    }
    /**
     * _Private_ handler for initial connection request.
     * This handler is used to process the Bosh-part of the initial request.
     * @param bodyWrap - The received stanza.
     */
    _connect_cb(bodyWrap) {
        const typ = bodyWrap.getAttribute('type');
        if (typ !== null && typ === 'terminate') {
            // an error occurred
            let cond = bodyWrap.getAttribute('condition');
            strophe_esm_log.error('BOSH-Connection failed: ' + cond);
            const conflict = bodyWrap.getElementsByTagName('conflict');
            if (cond !== null) {
                if (cond === 'remote-stream-error' && conflict.length > 0) {
                    cond = 'conflict';
                }
                this._conn._changeConnectStatus(Status.CONNFAIL, cond);
            }
            else {
                this._conn._changeConnectStatus(Status.CONNFAIL, 'unknown');
            }
            this._conn._doDisconnect(cond);
            return Status.CONNFAIL;
        }
        // check to make sure we don't overwrite these if _connect_cb is
        // called multiple times in the case of missing stream:features
        if (!this.sid) {
            this.sid = bodyWrap.getAttribute('sid');
        }
        const wind = bodyWrap.getAttribute('requests');
        if (wind) {
            this.window = parseInt(wind, 10);
        }
        const hold = bodyWrap.getAttribute('hold');
        if (hold) {
            this.hold = parseInt(hold, 10);
        }
        const wait = bodyWrap.getAttribute('wait');
        if (wait) {
            this.wait = parseInt(wait, 10);
        }
        const inactivity = bodyWrap.getAttribute('inactivity');
        if (inactivity) {
            this.inactivity = parseInt(inactivity, 10);
        }
    }
    /**
     * _Private_ part of Connection.disconnect for Bosh
     * @param pres - This stanza will be sent before disconnecting.
     */
    _disconnect(pres) {
        this._sendTerminate(pres);
    }
    /**
     * _Private_ function to disconnect.
     * Resets the SID and RID.
     */
    _doDisconnect() {
        this.sid = null;
        this.rid = Math.floor(Math.random() * 4294967295);
        if (this._conn._sessionCachingSupported()) {
            sessionStorage.removeItem('strophe-bosh-session');
        }
        this._conn.nextValidRid(this.rid);
    }
    /**
     * _Private_ function to check if the Request queue is empty.
     * @returns True, if there are no Requests queued, False otherwise.
     */
    _emptyQueue() {
        return this._requests.length === 0;
    }
    /**
     * _Private_ function to call error handlers registered for HTTP errors.
     * @private
     * @param req - The request that is changing readyState.
     */
    _callProtocolErrorHandlers(req) {
        const reqStatus = Bosh._getRequestStatus(req);
        const err_callback = this._conn.protocolErrorHandlers.HTTP[reqStatus];
        if (err_callback) {
            err_callback.call(this, reqStatus);
        }
    }
    /**
     * _Private_ function to handle the error count.
     *
     * Requests are resent automatically until their error count reaches
     * 5.  Each time an error is encountered, this function is called to
     * increment the count and disconnect if the count is too high.
     * @private
     * @param reqStatus - The request status.
     */
    _hitError(reqStatus) {
        this.errors++;
        strophe_esm_log.warn('request errored, status: ' + reqStatus + ', number of errors: ' + this.errors);
        if (this.errors > 4) {
            this._conn._onDisconnectTimeout();
        }
    }
    /**
     * Called on stream start/restart when no stream:features
     * has been received and sends a blank poll request.
     * @param callback
     */
    _no_auth_received(callback) {
        strophe_esm_log.warn('Server did not yet offer a supported authentication ' + 'mechanism. Sending a blank poll request.');
        if (callback) {
            callback = callback.bind(this._conn);
        }
        else {
            callback = this._conn._connect_cb.bind(this._conn);
        }
        const body = this._buildBody();
        this._requests.push(new Request(body.tree(), this._onRequestStateChange.bind(this, callback), Number(body.tree().getAttribute('rid'))));
        this._throttledRequestHandler();
    }
    /**
     * _Private_ timeout handler for handling non-graceful disconnection.
     * Cancels all remaining Requests and clears the queue.
     */
    _onDisconnectTimeout() {
        this._abortAllRequests();
    }
    /**
     * _Private_ function that makes sure all pending requests are aborted.
     */
    _abortAllRequests() {
        while (this._requests.length > 0) {
            const req = this._requests.pop();
            req.abort = true;
            req.xhr.abort();
            req.xhr.onreadystatechange = function () { };
        }
    }
    /**
     * _Private_ handler called by {@link Connection#_onIdle|Connection._onIdle()}.
     * Sends all queued Requests or polls with empty Request if there are none.
     */
    _onIdle() {
        const data = this._conn._data;
        // if no requests are in progress, poll
        if (this._conn.authenticated && this._requests.length === 0 && data.length === 0 && !this._conn.disconnecting) {
            strophe_esm_log.debug('no requests during idle cycle, sending blank request');
            data.push(null);
        }
        if (this._conn.paused) {
            return;
        }
        if (this._requests.length < 2 && data.length > 0) {
            const body = this._buildBody();
            for (let i = 0; i < data.length; i++) {
                if (data[i] !== null) {
                    if (data[i] === 'restart') {
                        body.attrs({
                            'to': this._conn.domain,
                            'xml:lang': 'en',
                            'xmpp:restart': 'true',
                            'xmlns:xmpp': NS.BOSH,
                        });
                    }
                    else {
                        body.cnode(data[i]).up();
                    }
                }
            }
            delete this._conn._data;
            this._conn._data = [];
            this._requests.push(new Request(body.tree(), this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)), Number(body.tree().getAttribute('rid'))));
            this._throttledRequestHandler();
        }
        if (this._requests.length > 0) {
            const time_elapsed = this._requests[0].age();
            if (this._requests[0].dead !== null) {
                if (this._requests[0].timeDead() > Math.floor(timeoutMultiplier * this.wait)) {
                    this._throttledRequestHandler();
                }
            }
            if (time_elapsed > Math.floor(timeoutMultiplier * this.wait)) {
                strophe_esm_log.warn('Request ' +
                    this._requests[0].id +
                    ' timed out, over ' +
                    Math.floor(timeoutMultiplier * this.wait) +
                    ' seconds since last activity');
                this._throttledRequestHandler();
            }
        }
    }
    /**
     * Returns the HTTP status code from a {@link Request}
     * @private
     * @param req - The {@link Request} instance.
     * @param def - The default value that should be returned if no status value was found.
     */
    static _getRequestStatus(req, def) {
        let reqStatus;
        if (req.xhr.readyState === 4) {
            try {
                reqStatus = req.xhr.status;
            }
            catch (e) {
                // ignore errors from undefined status attribute. Works
                // around a browser bug
                strophe_esm_log.error(`Caught an error while retrieving a request's status, reqStatus: ${reqStatus}, message: ${e.message}`);
            }
        }
        if (typeof reqStatus === 'undefined') {
            reqStatus = typeof def === 'number' ? def : 0;
        }
        return reqStatus;
    }
    /**
     * _Private_ handler for {@link Request} state changes.
     *
     * This function is called when the XMLHttpRequest readyState changes.
     * It contains a lot of error handling logic for the many ways that
     * requests can fail, and calls the request callback when requests
     * succeed.
     * @private
     *
     * @param func - The handler for the request.
     * @param req - The request that is changing readyState.
     */
    _onRequestStateChange(func, req) {
        strophe_esm_log.debug('request id ' + req.id + '.' + req.sends + ' state changed to ' + req.xhr.readyState);
        if (req.abort) {
            req.abort = false;
            return;
        }
        if (req.xhr.readyState !== 4) {
            // The request is not yet complete
            return;
        }
        const reqStatus = Bosh._getRequestStatus(req);
        this.lastResponseHeaders = req.xhr.getAllResponseHeaders();
        if (this._conn.disconnecting && reqStatus >= 400) {
            this._hitError(reqStatus);
            this._callProtocolErrorHandlers(req);
            return;
        }
        const reqIs0 = this._requests[0] === req;
        const reqIs1 = this._requests[1] === req;
        const valid_request = reqStatus > 0 && reqStatus < 500;
        const too_many_retries = req.sends > this._conn.maxRetries;
        if (valid_request || too_many_retries) {
            // remove from internal queue
            this._removeRequest(req);
            strophe_esm_log.debug('request id ' + req.id + ' should now be removed');
        }
        if (reqStatus === 200) {
            // request succeeded
            // if request 1 finished, or request 0 finished and request
            // 1 is over _TIMEOUT seconds old, we need to
            // restart the other - both will be in the first spot, as the
            // completed request has been removed from the queue already
            if (reqIs1 ||
                (reqIs0 &&
                    this._requests.length > 0 &&
                    this._requests[0].age() > Math.floor(timeoutMultiplier * this.wait))) {
                this._restartRequest(0);
            }
            this._conn.nextValidRid(req.rid + 1);
            strophe_esm_log.debug('request id ' + req.id + '.' + req.sends + ' got 200');
            func(req); // call handler
            this.errors = 0;
        }
        else if (reqStatus === 0 || (reqStatus >= 400 && reqStatus < 600) || reqStatus >= 12000) {
            // request failed
            strophe_esm_log.error('request id ' + req.id + '.' + req.sends + ' error ' + reqStatus + ' happened');
            this._hitError(reqStatus);
            this._callProtocolErrorHandlers(req);
            if (reqStatus >= 400 && reqStatus < 500) {
                this._conn._changeConnectStatus(Status.DISCONNECTING, null);
                this._conn._doDisconnect();
            }
        }
        else {
            strophe_esm_log.error('request id ' + req.id + '.' + req.sends + ' error ' + reqStatus + ' happened');
        }
        if (!valid_request && !too_many_retries) {
            this._throttledRequestHandler();
        }
        else if (too_many_retries && !this._conn.connected) {
            this._conn._changeConnectStatus(Status.CONNFAIL, 'giving-up');
        }
    }
    /**
     * _Private_ function to process a request in the queue.
     *
     * This function takes requests off the queue and sends them and
     * restarts dead requests.
     * @private
     *
     * @param i - The index of the request in the queue.
     */
    _processRequest(i) {
        var _a, _b, _c, _d, _e, _f;
        let req = this._requests[i];
        const reqStatus = Bosh._getRequestStatus(req, -1);
        // make sure we limit the number of retries
        if (req.sends > this._conn.maxRetries) {
            this._conn._onDisconnectTimeout();
            return;
        }
        const time_elapsed = req.age();
        const primary_timeout = !isNaN(time_elapsed) && time_elapsed > Math.floor(timeoutMultiplier * this.wait);
        const secondary_timeout = req.dead !== null && req.timeDead() > Math.floor(secondaryTimeoutMultiplier * this.wait);
        const server_error = req.xhr.readyState === 4 && (reqStatus < 1 || reqStatus >= 500);
        if (primary_timeout || secondary_timeout || server_error) {
            if (secondary_timeout) {
                strophe_esm_log.error(`Request ${this._requests[i].id} timed out (secondary), restarting`);
            }
            req.abort = true;
            req.xhr.abort();
            // setting to null fails on IE6, so set to empty function
            req.xhr.onreadystatechange = function () { };
            this._requests[i] = new Request(req.xmlData, req.origFunc, req.rid, req.sends);
            req = this._requests[i];
        }
        if (req.xhr.readyState === 0) {
            strophe_esm_log.debug('request id ' + req.id + '.' + req.sends + ' posting');
            try {
                const content_type = this._conn.options.contentType || 'text/xml; charset=utf-8';
                req.xhr.open('POST', this._conn.service, this._conn.options.sync ? false : true);
                if (typeof req.xhr.setRequestHeader !== 'undefined') {
                    // IE9 doesn't have setRequestHeader
                    req.xhr.setRequestHeader('Content-Type', content_type);
                }
                if (this._conn.options.withCredentials) {
                    req.xhr.withCredentials = true;
                }
            }
            catch (e2) {
                strophe_esm_log.error('XHR open failed: ' + e2.toString());
                if (!this._conn.connected) {
                    this._conn._changeConnectStatus(Status.CONNFAIL, 'bad-service');
                }
                this._conn.disconnect();
                return;
            }
            // Fires the XHR request -- may be invoked immediately
            // or on a gradually expanding retry window for reconnects
            const sendFunc = () => {
                req.date = new Date().valueOf();
                if (this._conn.options.customHeaders) {
                    const headers = this._conn.options.customHeaders;
                    for (const header in headers) {
                        if (Object.prototype.hasOwnProperty.call(headers, header)) {
                            req.xhr.setRequestHeader(header, headers[header]);
                        }
                    }
                }
                req.xhr.send(req.data);
            };
            // Implement progressive backoff for reconnects --
            // First retry (send === 1) should also be instantaneous
            if (req.sends > 1) {
                // Using a cube of the retry number creates a nicely
                // expanding retry window
                const backoff = Math.min(Math.floor(timeoutMultiplier * this.wait), Math.pow(req.sends, 3)) * 1000;
                setTimeout(function () {
                    // XXX: setTimeout should be called only with function expressions (23974bc1)
                    sendFunc();
                }, backoff);
            }
            else {
                sendFunc();
            }
            req.sends++;
            if (this.strip && req.xmlData.nodeName === 'body' && req.xmlData.childNodes.length) {
                (_b = (_a = this._conn).xmlOutput) === null || _b === void 0 ? void 0 : _b.call(_a, req.xmlData.children[0]);
            }
            else {
                (_d = (_c = this._conn).xmlOutput) === null || _d === void 0 ? void 0 : _d.call(_c, req.xmlData);
            }
            (_f = (_e = this._conn).rawOutput) === null || _f === void 0 ? void 0 : _f.call(_e, req.data);
        }
        else {
            strophe_esm_log.debug('_processRequest: ' +
                (i === 0 ? 'first' : 'second') +
                ' request has readyState of ' +
                req.xhr.readyState);
        }
    }
    /**
     * _Private_ function to remove a request from the queue.
     * @private
     * @param req - The request to remove.
     */
    _removeRequest(req) {
        strophe_esm_log.debug('removing request');
        for (let i = this._requests.length - 1; i >= 0; i--) {
            if (req === this._requests[i]) {
                this._requests.splice(i, 1);
            }
        }
        // IE6 fails on setting to null, so set to empty function
        req.xhr.onreadystatechange = function () { };
        this._throttledRequestHandler();
    }
    /**
     * _Private_ function to restart a request that is presumed dead.
     * @private
     *
     * @param i - The index of the request in the queue.
     */
    _restartRequest(i) {
        const req = this._requests[i];
        if (req.dead === null) {
            req.dead = new Date();
        }
        this._processRequest(i);
    }
    /**
     * _Private_ function to get a stanza out of a request.
     * Tries to extract a stanza out of a Request Object.
     * When this fails the current connection will be disconnected.
     *
     * @param req - The Request.
     * @returns The stanza that was passed.
     */
    _reqToData(req) {
        try {
            return req.getResponse();
        }
        catch (e) {
            if (e.message !== 'parsererror') {
                throw e;
            }
            this._conn.disconnect('strophe-parsererror');
        }
    }
    /**
     * _Private_ function to send initial disconnect sequence.
     *
     * This is the first step in a graceful disconnect.  It sends
     * the BOSH server a terminate body and includes an unavailable
     * presence if authentication has completed.
     * @private
     * @param pres
     */
    _sendTerminate(pres) {
        strophe_esm_log.debug('_sendTerminate was called');
        const body = this._buildBody().attrs({ type: 'terminate' });
        const el = pres instanceof strophe_esm_Builder ? pres.tree() : pres;
        if (pres) {
            body.cnode(el);
        }
        const req = new Request(body.tree(), this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)), Number(body.tree().getAttribute('rid')));
        this._requests.push(req);
        this._throttledRequestHandler();
    }
    /**
     * _Private_ part of the Connection.send function for BOSH
     * Just triggers the RequestHandler to send the messages that are in the queue
     */
    _send() {
        clearTimeout(this._conn._idleTimeout);
        this._throttledRequestHandler();
        this._conn._idleTimeout = setTimeout(() => this._conn._onIdle(), 100);
    }
    /**
     * Send an xmpp:restart stanza.
     */
    _sendRestart() {
        this._throttledRequestHandler();
        clearTimeout(this._conn._idleTimeout);
    }
    /**
     * _Private_ function to throttle requests to the connection window.
     *
     * This function makes sure we don't send requests so fast that the
     * request ids overflow the connection window in the case that one
     * request died.
     * @private
     */
    _throttledRequestHandler() {
        if (!this._requests) {
            strophe_esm_log.debug('_throttledRequestHandler called with ' + 'undefined requests');
        }
        else {
            strophe_esm_log.debug('_throttledRequestHandler called with ' + this._requests.length + ' requests');
        }
        if (!this._requests || this._requests.length === 0) {
            return;
        }
        if (this._requests.length > 0) {
            this._processRequest(0);
        }
        if (this._requests.length > 1 && Math.abs(this._requests[0].rid - this._requests[1].rid) < this.window) {
            this._processRequest(1);
        }
    }
}

/**
 * _Private_ helper class for managing stanza handlers.
 *
 * A Handler encapsulates a user provided callback function to be
 * executed when matching stanzas are received by the connection.
 * Handlers can be either one-off or persistant depending on their
 * return value. Returning true will cause a Handler to remain active, and
 * returning false will remove the Handler.
 *
 * Users will not use Handler objects directly, but instead they
 * will use {@link Connection.addHandler} and
 * {@link Connection.deleteHandler}.
 */
class Handler {
    /**
     * Create and initialize a new Handler.
     *
     * @param handler - A function to be executed when the handler is run.
     * @param ns - The namespace to match.
     * @param name - The element name to match.
     * @param type - The stanza type (or types if an array) to match.
     * @param id - The element id attribute to match.
     * @param from - The element from attribute to match.
     * @param options - Handler options
     */
    constructor(handler, ns, name, type, id, from, options) {
        this.handler = handler;
        this.ns = ns;
        this.name = name;
        this.type = type;
        this.id = id;
        this.options = options || { matchBareFromJid: false, ignoreNamespaceFragment: false };
        if (this.options.matchBareFromJid) {
            this.from = from ? getBareJidFromJid(from) : null;
        }
        else {
            this.from = from;
        }
        this.user = true;
    }
    /**
     * Returns the XML namespace of an element.
     * Resolved via {@link Strophe.getNamespace}, which reads the `xmlns`
     * attribute and falls back to `namespaceURI` so matching works regardless
     * of how the stanza's DOM was built (locally, via DOMParser, or via the
     * component transport's `createElementNS`).
     * If `ignoreNamespaceFragment` was passed in for this handler, then the
     * URL fragment will be stripped.
     * @param elem - The XML element with the namespace.
     * @returns The namespace, with optionally the fragment stripped.
     */
    getNamespace(elem) {
        let elNamespace = getNamespace(elem);
        if (elNamespace && this.options.ignoreNamespaceFragment) {
            elNamespace = elNamespace.split('#')[0];
        }
        return elNamespace;
    }
    /**
     * Tests if a stanza element (or any of its children) matches the
     * namespace set for this Handler.
     * @param elem - The XML element to test.
     * @returns true if the stanza matches and false otherwise.
     */
    namespaceMatch(elem) {
        var _a;
        if (!this.ns || this.getNamespace(elem) === this.ns) {
            return true;
        }
        for (const child of (_a = elem.children) !== null && _a !== void 0 ? _a : []) {
            if (this.getNamespace(child) === this.ns) {
                return true;
            }
            else if (this.namespaceMatch(child)) {
                return true;
            }
        }
        return false;
    }
    /**
     * Tests if a stanza matches the Handler.
     * @param elem - The XML element to test.
     * @returns true if the stanza matches and false otherwise.
     */
    isMatch(elem) {
        let from = elem.getAttribute('from');
        if (this.options.matchBareFromJid) {
            from = getBareJidFromJid(from);
        }
        const elem_type = elem.getAttribute('type');
        if (this.namespaceMatch(elem) &&
            (!this.name || isTagEqual(elem, this.name)) &&
            (!this.type ||
                (Array.isArray(this.type) ? this.type.indexOf(elem_type !== null && elem_type !== void 0 ? elem_type : '') !== -1 : elem_type === this.type)) &&
            (!this.id || elem.getAttribute('id') === this.id) &&
            (!this.from || from === this.from)) {
            return true;
        }
        return false;
    }
    /**
     * Run the callback on a matching stanza.
     * @param elem - The DOM element that triggered the Handler.
     * @returns A boolean indicating if the handler should remain active.
     */
    run(elem) {
        let result = null;
        try {
            result = this.handler(elem);
        }
        catch (e) {
            handleError(e);
            throw e;
        }
        return result;
    }
    /**
     * Get a String representation of the Handler object.
     */
    toString() {
        return '{Handler: ' + this.handler + '(' + this.name + ',' + this.id + ',' + this.ns + ')}';
    }
}

/**
 * _Private_ helper class for managing timed handlers.
 *
 * A Strophe.TimedHandler encapsulates a user provided callback that
 * should be called after a certain period of time or at regular
 * intervals.  The return value of the callback determines whether the
 * Strophe.TimedHandler will continue to fire.
 *
 * Users will not use Strophe.TimedHandler objects directly, but instead
 * they will use {@link Strophe.Connection#addTimedHandler|addTimedHandler()} and
 * {@link Strophe.Connection#deleteTimedHandler|deleteTimedHandler()}.
 *
 * @memberof Strophe
 */
class TimedHandler {
    /**
     * Create and initialize a new Strophe.TimedHandler object.
     * @param period - The number of milliseconds to wait before the
     *     handler is called.
     * @param handler - The callback to run when the handler fires.  This
     *     function should take no arguments.
     */
    constructor(period, handler) {
        this.period = period;
        this.handler = handler;
        this.lastCalled = new Date().getTime();
        this.user = true;
    }
    /**
     * Run the callback for the Strophe.TimedHandler.
     *
     * @returns Returns the result of running the handler,
     *  which is `true` if the Strophe.TimedHandler should be called again,
     *  and `false` otherwise.
     */
    run() {
        this.lastCalled = new Date().getTime();
        return this.handler();
    }
    /**
     * Reset the last called time for the Strophe.TimedHandler.
     */
    reset() {
        this.lastCalled = new Date().getTime();
    }
    /**
     * Get a string representation of the Strophe.TimedHandler object.
     */
    toString() {
        return '{TimedHandler: ' + this.handler + '(' + this.period + ')}';
    }
}

/**
 * Encapsulates an SASL authentication mechanism.
 *
 * User code may override the priority for each mechanism or disable it completely.
 * See <priority> for information about changing priority and <test> for informatian on
 * how to disable a mechanism.
 *
 * By default, all mechanisms are enabled and t_he priorities are
 *
 *     SCRAM-SHA-512 - 72
 *     SCRAM-SHA-384 - 71
 *     SCRAM-SHA-256 - 70
 *     SCRAM-SHA-1   - 60
 *     PLAIN         - 50
 *     OAUTHBEARER   - 40
 *     X-OAUTH2      - 30
 *     ANONYMOUS     - 20
 *     EXTERNAL      - 10
 *
 * See: {@link Strophe.Connection#registerSASLMechanisms}
 */
class SASLMechanism {
    /**
     * PrivateConstructor: Strophe.SASLMechanism
     * SASL auth mechanism abstraction.
     * @param name - SASL Mechanism name.
     * @param isClientFirst - If client should send response first without challenge.
     * @param priority - Priority.
     */
    constructor(name, isClientFirst, priority) {
        this.mechname = name;
        this.isClientFirst = isClientFirst;
        this.priority = priority;
        this._connection = null;
    }
    /**
     * Checks if mechanism able to run.
     * To disable a mechanism, make this return false;
     *
     * To disable plain authentication run
     * > Strophe.SASLPlain.test = function() {
     * >   return false;
     * > }
     *
     * See <SASL mechanisms> for a list of available mechanisms.
     * @param _connection - Target Connection.
     * @returns If mechanism was able to run.
     */
    test(_connection) {
        return true;
    }
    /**
     * Called before starting mechanism on some connection.
     * @param connection - Target Connection.
     */
    onStart(connection) {
        this._connection = connection;
    }
    /**
     * Called by protocol implementation on incoming challenge.
     *
     * By deafult, if the client is expected to send data first (isClientFirst === true),
     * this method is called with `challenge` as null on the first call,
     * unless `clientChallenge` is overridden in the relevant subclass.
     * @param _connection - Target Connection.
     * @param _challenge - current challenge to handle.
     * @returns Mechanism response.
     */
    onChallenge(_connection, _challenge) {
        throw new Error('You should implement challenge handling!');
    }
    /**
     * Called by the protocol implementation if the client is expected to send
     * data first in the authentication exchange (i.e. isClientFirst === true).
     * @param connection - Target Connection.
     * @returns Mechanism response.
     */
    clientChallenge(connection) {
        if (!this.isClientFirst) {
            throw new Error('clientChallenge should not be called if isClientFirst is false!');
        }
        return this.onChallenge(connection);
    }
    /**
     * Protocol informs mechanism implementation about SASL failure.
     */
    onFailure() {
        this._connection = null;
    }
    /**
     * Protocol informs mechanism implementation about SASL success.
     */
    onSuccess() {
        this._connection = null;
    }
}

class SASLAnonymous extends SASLMechanism {
    constructor(mechname = 'ANONYMOUS', isClientFirst = false, priority = 20) {
        super(mechname, isClientFirst, priority);
    }
    test(connection) {
        return connection.authcid === null;
    }
}

class SASLExternal extends SASLMechanism {
    constructor(mechname = 'EXTERNAL', isClientFirst = true, priority = 10) {
        super(mechname, isClientFirst, priority);
    }
    onChallenge(connection) {
        return connection.authcid === connection.authzid ? '' : connection.authzid;
    }
}

class SASLOAuthBearer extends SASLMechanism {
    constructor(mechname = 'OAUTHBEARER', isClientFirst = true, priority = 40) {
        super(mechname, isClientFirst, priority);
    }
    test(connection) {
        return connection.pass !== null;
    }
    onChallenge(connection) {
        let auth_str = 'n,';
        if (connection.authcid !== null) {
            auth_str = auth_str + 'a=' + connection.authzid;
        }
        auth_str = auth_str + ',';
        auth_str = auth_str + '\u0001';
        auth_str = auth_str + 'auth=Bearer ';
        auth_str = auth_str + connection.pass;
        auth_str = auth_str + '\u0001';
        auth_str = auth_str + '\u0001';
        return utils.utf16to8(auth_str);
    }
}

class SASLPlain extends SASLMechanism {
    constructor(mechname = 'PLAIN', isClientFirst = true, priority = 50) {
        super(mechname, isClientFirst, priority);
    }
    test(connection) {
        return connection.authcid !== null;
    }
    onChallenge(connection) {
        const { authcid, authzid, domain, pass } = connection;
        if (!domain) {
            throw new Error('SASLPlain onChallenge: domain is not defined!');
        }
        let auth_str = authzid !== `${authcid}@${domain}` ? authzid : '';
        auth_str = auth_str + '\u0000';
        auth_str = auth_str + authcid;
        auth_str = auth_str + '\u0000';
        auth_str = auth_str + pass;
        return utils.utf16to8(auth_str);
    }
}

/**
 * @param authMessage
 * @param clientKey
 * @param hashName
 */
function scramClientProof(authMessage, clientKey, hashName) {
    return __awaiter(this, void 0, void 0, function* () {
        const storedKey = yield crypto.subtle.importKey('raw', yield crypto.subtle.digest(hashName, clientKey), { name: 'HMAC', hash: hashName }, false, ['sign']);
        const clientSignature = yield crypto.subtle.sign('HMAC', storedKey, utils.stringToArrayBuf(authMessage));
        return utils.xorArrayBuffers(clientKey, clientSignature);
    });
}
/**
 * This function parses the information in a SASL SCRAM challenge response,
 * into an object of the form
 * { nonce: String,
 *   salt:  ArrayBuffer,
 *   iter:  Int
 * }
 * Returns undefined on failure.
 * @param challenge
 */
function scramParseChallenge(challenge) {
    let nonce, salt, iter;
    const attribMatch = /([a-z]+)=([^,]+)(,|$)/;
    while (challenge.match(attribMatch)) {
        const matches = challenge.match(attribMatch);
        challenge = challenge.replace(matches[0], '');
        switch (matches[1]) {
            case 'r':
                nonce = matches[2];
                break;
            case 's':
                salt = utils.base64ToArrayBuf(matches[2]);
                break;
            case 'i':
                iter = parseInt(matches[2], 10);
                break;
            case 'm':
                return undefined;
        }
    }
    if (isNaN(iter) || iter < 4096) {
        strophe_esm_log.warn('Failing SCRAM authentication because server supplied iteration count < 4096.');
        return undefined;
    }
    if (!salt) {
        strophe_esm_log.warn('Failing SCRAM authentication because server supplied incorrect salt.');
        return undefined;
    }
    return { nonce, salt, iter };
}
/**
 * Derive the client and server keys given a string password,
 * a hash name, and a bit length.
 * @param password
 * @param salt
 * @param iter
 * @param hashName
 * @param hashBits
 */
function scramDeriveKeys(password, salt, iter, hashName, hashBits) {
    return __awaiter(this, void 0, void 0, function* () {
        const saltedPasswordBits = yield crypto.subtle.deriveBits({ name: 'PBKDF2', salt, iterations: iter, hash: { name: hashName } }, yield crypto.subtle.importKey('raw', utils.stringToArrayBuf(password), 'PBKDF2', false, ['deriveBits']), hashBits);
        const saltedPassword = yield crypto.subtle.importKey('raw', saltedPasswordBits, { name: 'HMAC', hash: hashName }, false, ['sign']);
        return {
            ck: yield crypto.subtle.sign('HMAC', saltedPassword, utils.stringToArrayBuf('Client Key')),
            sk: yield crypto.subtle.sign('HMAC', saltedPassword, utils.stringToArrayBuf('Server Key')),
        };
    });
}
/**
 * @param authMessage
 * @param sk
 * @param hashName
 */
function scramServerSign(authMessage, sk, hashName) {
    return __awaiter(this, void 0, void 0, function* () {
        const serverKey = yield crypto.subtle.importKey('raw', sk, { name: 'HMAC', hash: hashName }, false, ['sign']);
        return crypto.subtle.sign('HMAC', serverKey, utils.stringToArrayBuf(authMessage));
    });
}
/**
 * Generate an ASCII nonce (not containing the ',' character)
 * @returns
 */
function generate_cnonce() {
    const bytes = new Uint8Array(16);
    return utils.arrayBufToBase64(crypto.getRandomValues(bytes).buffer);
}
const scram = {
    /**
     * Whether the Web Crypto `SubtleCrypto` API that SCRAM relies on is available.
     */
    supported() {
        return typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined';
    },
    /**
     * On success, sets
     * connection_sasl_data["server-signature"]
     * and
     * connection._sasl_data.keys
     *
     * The server signature should be verified after this function completes..
     *
     * On failure, returns connection._sasl_failure_cb();
     * @param connection
     * @param challenge
     * @param hashName
     * @param hashBits
     */
    scramResponse(connection, challenge, hashName, hashBits) {
        return __awaiter(this, void 0, void 0, function* () {
            const cnonce = connection._sasl_data.cnonce;
            const challengeData = scramParseChallenge(challenge);
            if (!challengeData || challengeData.nonce.slice(0, cnonce.length) !== cnonce) {
                strophe_esm_log.warn('Failing SCRAM authentication because server supplied incorrect nonce.');
                connection._sasl_data = {};
                return connection._sasl_failure_cb(null);
            }
            let clientKey, serverKey;
            const { pass } = connection;
            if (typeof connection.pass === 'string' || connection.pass instanceof String) {
                const keys = yield scramDeriveKeys(pass, challengeData.salt, challengeData.iter, hashName, hashBits);
                clientKey = keys.ck;
                serverKey = keys.sk;
            }
            else if ((pass === null || pass === void 0 ? void 0 : pass.name) === hashName &&
                (pass === null || pass === void 0 ? void 0 : pass.salt) === utils.arrayBufToBase64(challengeData.salt) &&
                (pass === null || pass === void 0 ? void 0 : pass.iter) === challengeData.iter) {
                const { ck, sk } = pass;
                clientKey = utils.base64ToArrayBuf(ck);
                serverKey = utils.base64ToArrayBuf(sk);
            }
            else {
                return connection._sasl_failure_cb(null);
            }
            const clientFirstMessageBare = connection._sasl_data['client-first-message-bare'];
            const serverFirstMessage = challenge;
            const clientFinalMessageBare = `c=biws,r=${challengeData.nonce}`;
            const authMessage = `${clientFirstMessageBare},${serverFirstMessage},${clientFinalMessageBare}`;
            const clientProof = yield scramClientProof(authMessage, clientKey, hashName);
            const serverSignature = yield scramServerSign(authMessage, serverKey, hashName);
            connection._sasl_data['server-signature'] = utils.arrayBufToBase64(serverSignature);
            connection._sasl_data.keys = {
                name: hashName,
                iter: challengeData.iter,
                salt: utils.arrayBufToBase64(challengeData.salt),
                ck: utils.arrayBufToBase64(clientKey),
                sk: utils.arrayBufToBase64(serverKey),
            };
            return `${clientFinalMessageBare},p=${utils.arrayBufToBase64(clientProof)}`;
        });
    },
    /**
     * Returns a string containing the client first message
     * @param connection
     * @param test_cnonce
     */
    clientChallenge(connection, test_cnonce) {
        const cnonce = test_cnonce || generate_cnonce();
        const client_first_message_bare = `n=${connection.authcid},r=${cnonce}`;
        connection._sasl_data.cnonce = cnonce;
        connection._sasl_data['client-first-message-bare'] = client_first_message_bare;
        return utils.utf16to8(`n,,${client_first_message_bare}`);
    },
};

class SASLSHA1 extends SASLMechanism {
    constructor(mechname = 'SCRAM-SHA-1', isClientFirst = true, priority = 60) {
        super(mechname, isClientFirst, priority);
    }
    test(connection) {
        return connection.authcid !== null && scram.supported();
    }
    onChallenge(connection, challenge) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield scram.scramResponse(connection, challenge, 'SHA-1', 160);
        });
    }
    clientChallenge(connection, test_cnonce) {
        return scram.clientChallenge(connection, test_cnonce);
    }
}

class SASLSHA256 extends SASLMechanism {
    constructor(mechname = 'SCRAM-SHA-256', isClientFirst = true, priority = 70) {
        super(mechname, isClientFirst, priority);
    }
    test(connection) {
        return connection.authcid !== null && scram.supported();
    }
    onChallenge(connection, challenge) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield scram.scramResponse(connection, challenge, 'SHA-256', 256);
        });
    }
    clientChallenge(connection, test_cnonce) {
        return scram.clientChallenge(connection, test_cnonce);
    }
}

class SASLSHA384 extends SASLMechanism {
    constructor(mechname = 'SCRAM-SHA-384', isClientFirst = true, priority = 71) {
        super(mechname, isClientFirst, priority);
    }
    test(connection) {
        return connection.authcid !== null && scram.supported();
    }
    onChallenge(connection, challenge) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield scram.scramResponse(connection, challenge, 'SHA-384', 384);
        });
    }
    clientChallenge(connection, test_cnonce) {
        return scram.clientChallenge(connection, test_cnonce);
    }
}

class SASLSHA512 extends SASLMechanism {
    constructor(mechname = 'SCRAM-SHA-512', isClientFirst = true, priority = 72) {
        super(mechname, isClientFirst, priority);
    }
    test(connection) {
        return connection.authcid !== null && scram.supported();
    }
    onChallenge(connection, challenge) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield scram.scramResponse(connection, challenge, 'SHA-512', 512);
        });
    }
    clientChallenge(connection, test_cnonce) {
        return scram.clientChallenge(connection, test_cnonce);
    }
}

class SASLXOAuth2 extends SASLMechanism {
    constructor(mechname = 'X-OAUTH2', isClientFirst = true, priority = 30) {
        super(mechname, isClientFirst, priority);
    }
    test(connection) {
        return connection.pass !== null;
    }
    onChallenge(connection) {
        let auth_str = '\u0000';
        if (connection.authcid !== null) {
            auth_str = auth_str + connection.authzid;
        }
        auth_str = auth_str + '\u0000';
        auth_str = auth_str + connection.pass;
        return utils.utf16to8(auth_str);
    }
}

class SessionError extends Error {
    constructor(message) {
        super(message);
        this.name = 'StropheSessionError';
    }
}

/**
 * Helper class that handles WebSocket Connections
 *
 * The WebSocket class is used internally by Connection
 * to encapsulate WebSocket sessions. It is not meant to be used from user's code.
 */
class Websocket {
    /**
     * Create and initialize a WebSocket object.
     * Currently only sets the connection Object.
     * @param connection - The Connection that will use WebSockets.
     */
    constructor(connection) {
        this._conn = connection;
        this.strip = 'wrapper';
        const service = connection.service;
        if (service.indexOf('ws:') !== 0 && service.indexOf('wss:') !== 0) {
            let new_service = '';
            if (connection.options.protocol === 'ws' && location.protocol !== 'https:') {
                new_service += 'ws';
            }
            else {
                new_service += 'wss';
            }
            new_service += '://' + location.host;
            if (service.indexOf('/') !== 0) {
                new_service += location.pathname + service;
            }
            else {
                new_service += service;
            }
            connection.service = new_service;
        }
    }
    /**
     * _Private_ helper function to generate the <stream> start tag for WebSockets
     * @private
     * @returns A Builder with a <stream> element.
     */
    _buildStream() {
        return $build('open', {
            'xmlns': NS.FRAMING,
            'to': this._conn.domain,
            'version': '1.0',
        });
    }
    /**
     * _Private_ checks a message for stream:error
     * @private
     * @param bodyWrap - The received stanza.
     * @param connectstatus - The ConnectStatus that will be set on error.
     * @returns true if there was a streamerror, false otherwise.
     */
    _checkStreamError(bodyWrap, connectstatus) {
        let errors;
        if (bodyWrap.getElementsByTagNameNS) {
            errors = bodyWrap.getElementsByTagNameNS(NS.STREAM, 'error');
        }
        else {
            errors = bodyWrap.getElementsByTagName('stream:error');
        }
        if (errors.length === 0) {
            return false;
        }
        const error = errors[0];
        let condition = '';
        let text = '';
        const ns = 'urn:ietf:params:xml:ns:xmpp-streams';
        for (let i = 0; i < error.childNodes.length; i++) {
            const e = error.childNodes[i];
            if (e.nodeType === e.ELEMENT_NODE) {
                const el = e;
                if (el.getAttribute('xmlns') !== ns) {
                    break;
                }
            }
            if (e.nodeName === 'text') {
                text = e.textContent || '';
            }
            else {
                condition = e.nodeName;
            }
        }
        let errorString = 'WebSocket stream error: ';
        if (condition) {
            errorString += condition;
        }
        else {
            errorString += 'unknown';
        }
        if (text) {
            errorString += ' - ' + text;
        }
        strophe_esm_log.error(errorString);
        this._conn._changeConnectStatus(connectstatus, condition);
        this._conn._doDisconnect();
        return true;
    }
    /**
     * Reset the connection.
     *
     * This function is called by the reset function of the Strophe Connection.
     * Is not needed by WebSockets.
     */
    _reset() {
        return;
    }
    /**
     * _Private_ function called by Connection.connect
     *
     * Creates a WebSocket for a connection and assigns Callbacks to it.
     * Does nothing if there already is a WebSocket.
     */
    _connect() {
        this._closeSocket();
        this.socket = new WebSocket(this._conn.service, 'xmpp');
        this.socket.onopen = () => this._onOpen();
        this.socket.onerror = (e) => this._onError(e);
        this.socket.onclose = (e) => this._onClose(e);
        this.socket.onmessage = (message) => this._onInitialMessage(message);
    }
    /**
     * _Private_ function called by Connection._connect_cb
     * checks for stream:error
     * @param bodyWrap - The received stanza.
     */
    _connect_cb(bodyWrap) {
        const error = this._checkStreamError(bodyWrap, Status.CONNFAIL);
        if (error) {
            return Status.CONNFAIL;
        }
    }
    /**
     * _Private_ function that checks the opening <open /> tag for errors.
     *
     * Disconnects if there is an error and returns false, true otherwise.
     * @private
     * @param message - Stanza containing the <open /> tag.
     */
    _handleStreamStart(message) {
        let error = null;
        const ns = message.getAttribute('xmlns');
        if (typeof ns !== 'string') {
            error = 'Missing xmlns in <open />';
        }
        else if (ns !== NS.FRAMING) {
            error = 'Wrong xmlns in <open />: ' + ns;
        }
        const ver = message.getAttribute('version');
        if (typeof ver !== 'string') {
            error = 'Missing version in <open />';
        }
        else if (ver !== '1.0') {
            error = 'Wrong version in <open />: ' + ver;
        }
        if (error) {
            this._conn._changeConnectStatus(Status.CONNFAIL, error);
            this._conn._doDisconnect();
            return false;
        }
        return true;
    }
    /**
     * _Private_ function that handles the first connection messages.
     *
     * On receiving an opening stream tag this callback replaces itself with the real
     * message handler. On receiving a stream error the connection is terminated.
     * @param message
     */
    _onInitialMessage(message) {
        if (message.data.indexOf('<open ') === 0 || message.data.indexOf('<?xml') === 0) {
            const data = message.data.replace(/^(<\?.*?\?>\s*)*/, '');
            if (data === '')
                return;
            const streamStart = new DOMParser().parseFromString(data, 'text/xml').documentElement;
            this._conn.xmlInput(streamStart);
            this._conn.rawInput(message.data);
            if (this._handleStreamStart(streamStart)) {
                this._connect_cb(streamStart);
            }
        }
        else if (message.data.indexOf('<close ') === 0) {
            const parsedMessage = new DOMParser().parseFromString(message.data, 'text/xml').documentElement;
            this._conn.xmlInput(parsedMessage);
            this._conn.rawInput(message.data);
            const see_uri = parsedMessage.getAttribute('see-other-uri');
            if (see_uri) {
                const service = this._conn.service;
                const isSecureRedirect = (service.indexOf('wss:') >= 0 && see_uri.indexOf('wss:') >= 0) || service.indexOf('ws:') >= 0;
                if (isSecureRedirect) {
                    this._conn._changeConnectStatus(Status.REDIRECT, 'Received see-other-uri, resetting connection');
                    this._conn.reset();
                    this._conn.service = see_uri;
                    this._connect();
                }
            }
            else {
                this._conn._changeConnectStatus(Status.CONNFAIL, 'Received closing stream');
                this._conn._doDisconnect();
            }
        }
        else {
            this._replaceMessageHandler();
            const string = this._streamWrap(message.data);
            const elem = new DOMParser().parseFromString(string, 'text/xml').documentElement;
            this._conn._connect_cb(elem, null, message.data);
        }
    }
    /**
     * Called by _onInitialMessage in order to replace itself with the general message handler.
     * This method is overridden by WorkerWebsocket, which manages a
     * websocket connection via a service worker and doesn't have direct access
     * to the socket.
     */
    _replaceMessageHandler() {
        this.socket.onmessage = (m) => this._onMessage(m);
    }
    /**
     * _Private_ function called by Connection.disconnect
     * Disconnects and sends a last stanza if one is given
     * @param pres - This stanza will be sent before disconnecting.
     */
    _disconnect(pres) {
        if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
            if (pres) {
                this._conn.send(pres);
            }
            const close = $build('close', { 'xmlns': NS.FRAMING });
            this._conn.xmlOutput(close.tree());
            const closeString = strophe_esm_Builder.serialize(close);
            this._conn.rawOutput(closeString);
            try {
                this.socket.send(closeString);
            }
            catch (e) {
                strophe_esm_log.warn(`Couldn't send <close /> tag. "${e.message}"`);
            }
        }
        setTimeout(() => this._conn._doDisconnect(), 0);
    }
    /**
     * _Private_ function to disconnect.
     * Just closes the Socket for WebSockets
     */
    _doDisconnect() {
        strophe_esm_log.debug('WebSockets _doDisconnect was called');
        this._closeSocket();
    }
    /**
     * PrivateFunction _streamWrap
     * _Private_ helper function to wrap a stanza in a <stream> tag.
     * This is used so Strophe can process stanzas from WebSockets like BOSH
     * @param stanza
     */
    _streamWrap(stanza) {
        return '<wrapper>' + stanza + '</wrapper>';
    }
    /**
     * _Private_ function to close the WebSocket.
     *
     * Closes the socket if it is still open and deletes it
     */
    _closeSocket() {
        if (this.socket) {
            try {
                this.socket.onclose = null;
                this.socket.onerror = null;
                this.socket.onmessage = null;
                this.socket.close();
            }
            catch (e) {
                strophe_esm_log.debug(e.message);
            }
        }
        this.socket = null;
    }
    /**
     * _Private_ function to check if the message queue is empty.
     * @returns True, because WebSocket messages are send immediately after queueing.
     */
    _emptyQueue() {
        return true;
    }
    /**
     * _Private_ function to handle websockets closing.
     * @param e
     */
    _onClose(e) {
        if (this._conn.connected && !this._conn.disconnecting) {
            strophe_esm_log.error('Websocket closed unexpectedly');
            this._conn._doDisconnect();
        }
        else if (e && e.code === 1006 && !this._conn.connected && this.socket) {
            strophe_esm_log.error('Websocket closed unexcectedly');
            this._conn._changeConnectStatus(Status.CONNFAIL, 'The WebSocket connection could not be established or was disconnected.');
            this._conn._doDisconnect();
        }
        else {
            strophe_esm_log.debug('Websocket closed');
        }
    }
    /**
     * Called on stream start/restart when no stream:features
     * has been received.
     * @param callback
     */
    _no_auth_received(callback) {
        strophe_esm_log.error('Server did not offer a supported authentication mechanism');
        this._conn._changeConnectStatus(Status.CONNFAIL, ErrorCondition.NO_AUTH_MECH);
        callback === null || callback === void 0 ? void 0 : callback.call(this._conn);
        this._conn._doDisconnect();
    }
    /**
     * _Private_ timeout handler for handling non-graceful disconnection.
     *
     * This does nothing for WebSockets
     */
    _onDisconnectTimeout() { }
    /**
     * _Private_ helper function that makes sure all pending requests are aborted.
     */
    _abortAllRequests() { }
    /**
     * _Private_ function to handle websockets errors.
     * @param error - The websocket error.
     */
    _onError(error) {
        strophe_esm_log.error('Websocket error ' + JSON.stringify(error));
        this._conn._changeConnectStatus(Status.CONNFAIL, 'The WebSocket connection could not be established or was disconnected.');
        this._disconnect();
    }
    /**
     * _Private_ function called by Connection._onIdle
     * sends all queued stanzas
     */
    _onIdle() {
        const data = this._conn._data;
        if (data.length > 0 && !this._conn.paused) {
            for (let i = 0; i < data.length; i++) {
                if (data[i] !== null) {
                    const stanza = data[i] === 'restart' ? this._buildStream().tree() : data[i];
                    if (stanza === 'restart')
                        throw new Error('Wrong type for stanza');
                    const rawStanza = strophe_esm_Builder.serialize(stanza);
                    this._conn.xmlOutput(stanza);
                    this._conn.rawOutput(rawStanza);
                    this.socket.send(rawStanza);
                }
            }
            this._conn._data = [];
        }
    }
    /**
     * _Private_ function to handle websockets messages.
     *
     * This function parses each of the messages as if they are full documents.
     * [TODO : We may actually want to use a SAX Push parser].
     *
     * Since all XMPP traffic starts with
     * <stream:stream version='1.0'
     *                xml:lang='en'
     *                xmlns='jabber:client'
     *                xmlns:stream='http://etherx.jabber.org/streams'
     *                id='3697395463'
     *                from='SERVER'>
     *
     * The first stanza will always fail to be parsed.
     *
     * Additionally, the seconds stanza will always be <stream:features> with
     * the stream NS defined in the previous stanza, so we need to 'force'
     * the inclusion of the NS in this stanza.
     *
     * @param message - The websocket message event
     */
    _onMessage(message) {
        let elem;
        const close = '<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />';
        if (message.data === close) {
            this._conn.rawInput(close);
            this._conn.xmlInput(message);
            if (!this._conn.disconnecting) {
                this._conn._doDisconnect();
            }
            return;
        }
        else if (message.data.search('<open ') === 0) {
            elem = new DOMParser().parseFromString(message.data, 'text/xml').documentElement;
            if (!this._handleStreamStart(elem)) {
                return;
            }
        }
        else {
            const data = this._streamWrap(message.data);
            elem = new DOMParser().parseFromString(data, 'text/xml').documentElement;
        }
        if (this._checkStreamError(elem, Status.ERROR)) {
            return;
        }
        if (this._conn.disconnecting &&
            elem.firstElementChild.nodeName === 'presence' &&
            elem.firstElementChild.getAttribute('type') === 'unavailable') {
            this._conn.xmlInput(elem);
            this._conn.rawInput(strophe_esm_Builder.serialize(elem));
            return;
        }
        this._conn._dataRecv(elem, message.data);
    }
    /**
     * _Private_ function to handle websockets connection setup.
     * The opening stream tag is sent here.
     * @private
     */
    _onOpen() {
        strophe_esm_log.debug('Websocket open');
        const start = this._buildStream();
        this._conn.xmlOutput(start.tree());
        const startString = strophe_esm_Builder.serialize(start);
        this._conn.rawOutput(startString);
        this.socket.send(startString);
    }
    /**
     * _Private_ part of the Connection.send function for WebSocket
     * Just flushes the messages that are in the queue
     */
    _send() {
        this._conn.flush();
    }
    /**
     * Send an xmpp:restart stanza.
     */
    _sendRestart() {
        clearTimeout(this._conn._idleTimeout);
        this._conn._onIdle.bind(this._conn)();
    }
}

/**
 * Helper class that handles a websocket connection inside a shared worker.
 */
class WorkerWebsocket extends Websocket {
    /**
     * Create and initialize a WorkerWebsocket object.
     * @param connection - The Connection
     */
    constructor(connection) {
        super(connection);
        this._conn = connection;
        this._initWorker();
    }
    /**
     * (Re)create the SharedWorker. Called for every connection attempt: if
     * the worker for this URL is still running, the browser just opens
     * another port to it (the previous port is said goodbye to and closed),
     * but if it terminated (it shuts itself down when it detects a page from
     * a newer build, and the browser reclaims it when the last tab goes away
     * or it crashes), a fresh worker running the *current* script is
     * spawned. Ports to a dead worker fail silently, so re-creating per
     * attempt is the only reliable way to recover from worker death.
     */
    _initWorker() {
        if (this.worker) {
            this.worker.port.postMessage(['_bye']);
            this.worker.port.close();
        }
        this.worker = new SharedWorker(this._conn.options.worker, 'Strophe XMPP Connection');
        this.worker.onerror = (e) => {
            console === null || console === void 0 ? void 0 : console.error(e);
            strophe_esm_log.error(`Shared Worker Error: ${e}`);
        };
    }
    /**
     * @private
     */
    _setSocket() {
        this.socket = {
            send: (str) => this.worker.port.postMessage(['send', str]),
            close: () => this.worker.port.postMessage(['_closeSocket']),
            onopen: () => { },
            onerror: (e) => this._onError(e),
            onclose: (e) => this._onClose(e),
            onmessage: () => { },
            readyState: null,
        };
    }
    _connect() {
        this._initWorker();
        this._setSocket();
        this._messageHandler = (m) => this._onInitialMessage(m);
        this.worker.port.start();
        this.worker.port.onmessage = (ev) => this._onWorkerMessage(ev);
        this.worker.port.postMessage(['_connect', this._conn.service, this._conn.jid, SHARED_WORKER_PROTOCOL_VERSION]);
        this._attachLifecycleListeners();
    }
    /**
     * @param callback
     */
    _attach(callback) {
        this._initWorker();
        this._setSocket();
        this._messageHandler = (m) => this._onMessage(m);
        this._conn.connect_callback = callback;
        this.worker.port.start();
        this.worker.port.onmessage = (ev) => this._onWorkerMessage(ev);
        this.worker.port.postMessage(['_attach', this._conn.service, SHARED_WORKER_PROTOCOL_VERSION]);
        this._attachLifecycleListeners();
    }
    /**
     * Called by the worker to assign this tab's role. A secondary shares the
     * already-established session, so it must not treat inbound frames as its
     * own connection handshake.
     * @param role
     * @param jid - The shared connection's JID.
     */
    _role(role, jid) {
        this._conn.role = role;
        if (role === 'secondary') {
            this._messageHandler = (m) => this._onMessage(m);
            if (jid)
                this._conn.jid = jid;
        }
        this._conn.onRoleChanged(role);
    }
    /**
     * Called by the worker when this tab is promoted to primary after the
     * previous primary went away. Same socket — no reconnect happens.
     * @param jid - The shared connection's JID.
     */
    _promote(jid) {
        this._conn.role = 'primary';
        if (jid)
            this._conn.jid = jid;
        this._conn.onRoleChanged('primary');
    }
    /**
     * Ask the worker to negotiate XEP-0198 for the freshly authenticated
     * stream (§2.3): it sends <resume/> if it holds resumable state,
     * otherwise it replies with _smNoState and the connection proceeds to
     * bind a resource.
     */
    _smFeatures() {
        this.worker.port.postMessage(['_smFeatures']);
    }
    /**
     * Report that the connect flow completed (resource bound, or legacy
     * auth/session establishment finished). Sent with or without SM: the
     * worker adopts the bound JID as the shared one, releases tabs parked on
     * the handshake, and starts a fresh SM session itself when this stream's
     * features advertised support.
     * @param jid - The server-assigned full JID.
     */
    _bound(jid) {
        this.worker.port.postMessage(['_bound', jid]);
    }
    /**
     * Liveness probe from the worker. Answered from this message handler —
     * which runs even when the browser throttles this tab's timers — so a
     * merely-backgrounded tab never looks dead to the worker.
     */
    _ping() {
        this.worker.port.postMessage(['_pong']);
    }
    /**
     * Called by the worker when another tab sent a message or presence
     * stanza over the shared connection. Handed to its own overridable hook
     * — never into the inbound pipeline (_dataRecv), where it would hit
     * stanza handlers, SM counting and xmlInput as if it were received
     * traffic.
     * @param data - The serialized stanza.
     */
    _onStanzaSent(data) {
        this._conn.onForeignStanzaSent(toElement(data));
    }
    /**
     * Called by the worker when it has no resumable state: continue the
     * connect flow with resource binding.
     */
    _smNoState() {
        this._conn._proceedToBind();
    }
    /**
     * Called by the worker when a fresh SM session was established.
     * @param id - The SM-ID.
     * @param max - The server's preferred maximum resumption time.
     * @param boundJid - The JID that was bound when the session was enabled.
     */
    _smEnabled(id, max, boundJid) {
        var _a;
        (_a = this._conn.sm) === null || _a === void 0 ? void 0 : _a._onEnabled(id, max, boundJid);
    }
    /**
     * Called by the worker when the previous session was resumed. Every tab
     * adopts the originally bound JID; the primary — which drove the connect
     * flow — additionally restores the connection state and emits CONNECTED
     * (the same actions a non-worker connection applies on <resumed/>).
     * @param jid - The worker's boundJid.
     * @param id - The SM-ID of the resumed session.
     * @param max - The server's preferred maximum resumption time.
     */
    _smResumed(jid, id, max) {
        var _a;
        const conn = this._conn;
        (_a = conn.sm) === null || _a === void 0 ? void 0 : _a._onResumed(jid, id, max);
        conn.jid = jid;
        if (conn.role === 'primary') {
            conn.do_bind = false;
            conn.authenticated = true;
            conn.restored = true;
            conn._changeConnectStatus(Status.CONNECTED, null);
        }
    }
    /**
     * Called by the worker when resumption failed: the primary falls back
     * to binding a resource on this same stream (the salvaged queue stays
     * in the worker and is re-sent after the next <enabled/>).
     */
    _smFailed() {
        var _a;
        const conn = this._conn;
        (_a = conn.sm) === null || _a === void 0 ? void 0 : _a._onFailed();
        if (conn.role === 'primary') {
            conn.do_bind = true;
            conn._proceedToBind();
        }
    }
    /**
     * Wire the page lifecycle into the worker's port bookkeeping: `_bye` on
     * pagehide (graceful removal + failover), `_relinquish` on freeze (hand
     * the primary role over *before* this tab's CPU stops), and a `_pong`
     * when the page comes back (which also re-admits this port if the worker
     * dropped it while we were away). Routine liveness is worker-driven
     * ping/pong (see {@link WorkerWebsocket#_ping}) — deliberately no
     * page-side timers, because hidden tabs may only run timers once every
     * ten minutes.
     */
    _attachLifecycleListeners() {
        if (this._lifecycleAttached || typeof window === 'undefined') {
            return;
        }
        window.addEventListener('pagehide', () => this.worker.port.postMessage(['_bye']));
        window.addEventListener('pageshow', () => this.worker.port.postMessage(['_pong']));
        document.addEventListener('freeze', () => this.worker.port.postMessage(['_relinquish']));
        document.addEventListener('resume', () => this.worker.port.postMessage(['_pong']));
        this._lifecycleAttached = true;
    }
    /**
     * Called when the worker reports that the shared socket closed or died.
     * Unlike a page-owned websocket this can arrive while this tab believes
     * it is still connecting. The worker owns the socket, and e.g. its
     * connection attempt to the server can fail. The base implementation
     * ignores closes in that state (it only knows real CloseEvents), which
     * would leave this tab stuck in CONNECTING forever, so fail the
     * connection attempt instead: the embedder's reconnect logic takes it
     * from there.
     * @param e - The close reason from the worker, or a close event.
     */
    _onClose(e) {
        if (this._conn.connected && !this._conn.disconnecting) {
            strophe_esm_log.error('Websocket closed unexpectedly');
            this._conn._doDisconnect();
        }
        else if (!this._conn.connected && !this._conn.disconnecting) {
            const reason = typeof e === 'string' ? e : 'The shared websocket connection could not be established or was lost.';
            strophe_esm_log.error(`Shared websocket closed while connecting: ${reason}`);
            this._conn._changeConnectStatus(Status.CONNFAIL, reason);
            this._conn._doDisconnect();
        }
        else {
            strophe_esm_log.debug('Websocket closed');
        }
    }
    /**
     * @param status
     * @param jid
     */
    _attachCallback(status, jid, _condition) {
        if (status === Status.ATTACHED) {
            this._conn.jid = jid;
            this._conn.authenticated = true;
            this._conn.connected = true;
            this._conn.restored = true;
            this._conn._changeConnectStatus(Status.ATTACHED);
        }
        else if (status === Status.ATTACHFAIL) {
            this._conn.authenticated = false;
            this._conn.connected = false;
            this._conn.restored = false;
            this._conn._changeConnectStatus(Status.ATTACHFAIL);
        }
    }
    /**
     * @param pres - This stanza will be sent before disconnecting.
     */
    _disconnect(pres) {
        pres && this._conn.send(pres);
        const close = $build('close', { 'xmlns': NS.FRAMING });
        this._conn.xmlOutput(close.tree());
        const closeString = strophe_esm_Builder.serialize(close);
        this._conn.rawOutput(closeString);
        this.worker.port.postMessage(['send', closeString]);
        this._conn._doDisconnect();
    }
    _closeSocket() {
        this.socket.close();
    }
    /**
     * Called by _onInitialMessage in order to replace itself with the general message handler.
     * This method is overridden by WorkerWebsocket, which manages a
     * websocket connection via a service worker and doesn't have direct access
     * to the socket.
     */
    _replaceMessageHandler() {
        this._messageHandler = (m) => this._onMessage(m);
    }
    /**
     * function that handles messages received from the service worker
     * @private
     * @param ev
     */
    _onWorkerMessage(ev) {
        const { data } = ev;
        const method_name = data[0];
        if (method_name === '_onMessage') {
            this._messageHandler(data[1]);
        }
        else if (method_name in this) {
            try {
                this[method_name].apply(this, ev.data.slice(1));
            }
            catch (e) {
                strophe_esm_log.error(String(e));
            }
        }
        else if (method_name === 'log') {
            const lmap = {
                debug: LOG_LEVELS.DEBUG,
                info: LOG_LEVELS.INFO,
                warn: LOG_LEVELS.WARN,
                error: LOG_LEVELS.ERROR,
                fatal: LOG_LEVELS.FATAL,
            };
            const level = data[1];
            const msg = data[2];
            strophe_esm_log.log(lmap[level], msg);
        }
        else {
            strophe_esm_log.error(`Found unhandled service worker message: ${data}`);
        }
    }
}

/**
 * XEP-0198 Stream Management
 *
 * Environment-free helpers.
 *
 * IMPORTANT: this module must be loadable in a SharedWorker global (it is
 * bundled into dist/shared-connection-worker.js), so keep it free of imports
 * beyond constants (no ../utils.ts or ../builder.ts, and no *module-level DOM access).
 */
/** The 'h' counter is an unsignedInt that wraps back to zero (XEP-0198 §4). */
const H_WRAP = 2 ** 32;
/** Stanza names that count towards the 'h' counters (XEP-0198 §4). */
const COUNTABLE = ['iq', 'presence', 'message'];
/**
 * Escapes invalid xml characters (duplicated from ../utils.ts so the worker
 * bundle doesn't pull in utils and its dependencies).
 * @param text
 */
function xmlEscape(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&apos;')
        .replace(/"/g, '&quot;');
}
/**
 * @returns A fresh, inactive SM state object.
 */
function freshState() {
    return {
        boundJid: null,
        enableSent: false,
        enabled: false,
        hIn: 0,
        hOutAcked: 0,
        id: null,
        location: null,
        max: null,
        resumeSupported: false,
        resumed: false,
        sinceLastAck: 0,
        unacked: [],
    };
}
/**
 * Parse an 'h' attribute value into a wrapped unsigned 32-bit counter value.
 * @param value - The attribute value (may be undefined).
 * @returns The parsed value, or null if missing or invalid.
 */
function parseH(value) {
    if (typeof value !== 'string')
        return null;
    const h = parseInt(value, 10);
    return Number.isNaN(h) || h < 0 ? null : h % H_WRAP;
}
/**
 * @param name - A top-level element's local tag name.
 * @returns true if the element counts towards the SM 'h' counters.
 */
function isCountableStanza(name) {
    return COUNTABLE.includes(name);
}
/**
 * Remove the `from` attribute from a serialized stanza's root element, so a
 * re-sent stanza cannot carry a stale resource after a failed resumption. Only
 * the root opening tag is touched; nested `from` attributes (forwarded stanzas,
 * MUC addresses) are preserved. The server stamps the authoritative c2s `from`.
 * DOM-free string surgery, mirroring stampDelay.
 * @param serialized - The serialized stanza.
 * @returns The stanza with the root `from` removed (unchanged if none).
 */
function stripFrom(serialized) {
    const end = serialized.indexOf('>');
    if (end === -1) {
        return serialized;
    }
    const openTag = serialized.slice(0, end);
    const rest = serialized.slice(end);
    // Values cannot contain their own delimiter quote (the serializer escapes it),
    // so a non-greedy match to the matching quote is safe. The leading \s is
    // consumed too, leaving no double space. Only the first (root) from is removed.
    const stripped = openTag.replace(/\sfrom=(["'])[\s\S]*?\1/, '');
    return stripped === openTag ? serialized : stripped + rest;
}
/**
 * Insert a XEP-0203 <delay/> child into a serialized stanza (DOM-free string
 * surgery). Used when re-sending salvaged stanzas after a failed resumption,
 * so the receiving client can show the original send time.
 * @param serialized - The serialized stanza.
 * @param name - The stanza's local tag name.
 * @param queuedAt - The original queueing time (ms since epoch).
 * @returns The stanza with a <delay/> child, or the unmodified input if it
 *     already carries one (or is malformed).
 */
function stampDelay(serialized, name, queuedAt) {
    if (serialized.includes(NS.DELAY)) {
        return serialized;
    }
    const delay = `<delay xmlns="${NS.DELAY}" stamp="${new Date(queuedAt).toISOString()}"/>`;
    if (serialized.endsWith('/>')) {
        return `${serialized.slice(0, -2)}>${delay}</${name}>`;
    }
    const idx = serialized.lastIndexOf(`</${name}`);
    if (idx === -1) {
        return serialized;
    }
    return serialized.slice(0, idx) + delay + serialized.slice(idx);
}

/**
 * XEP-0198 Stream Management
 *
 * Storage backends for resumable session state.
 *
 * MemoryStorageBackend is environment-free and safe in the worker bundle.
 * SessionStorageBackend requires a browser page context, but only at
 * construction time, there is no module-level DOM access here.
 */
/**
 * In-memory storage backend (Node, tests, or non-resumable setups).
 * State is serialized on save so callers can't mutate stored state by reference.
 */
class MemoryStorageBackend {
    constructor() {
        this.store = new Map();
    }
    /**
     * @param key
     */
    load(key) {
        const stored = this.store.get(key);
        return stored ? JSON.parse(stored) : null;
    }
    /**
     * @param key
     * @param state
     */
    save(key, state) {
        this.store.set(key, JSON.stringify(state));
    }
    /**
     * @param key
     */
    clear(key) {
        this.store.delete(key);
    }
}
/**
 * sessionStorage-backed storage backend (browser pages).
 * Survives page reloads within a tab, which is exactly the resumption window.
 */
class SessionStorageBackend {
    constructor() {
        if (typeof sessionStorage === 'undefined') {
            throw new Error('SessionStorageBackend requires a sessionStorage global (browser page context)');
        }
    }
    /**
     * @param key
     */
    load(key) {
        const stored = sessionStorage.getItem(key);
        if (!stored)
            return null;
        try {
            return JSON.parse(stored);
        }
        catch (e) {
            strophe_esm_log.warn(`Discarding unparseable SM state for ${key}: ${e.message}`);
            return null;
        }
    }
    /**
     * @param key
     * @param state
     */
    save(key, state) {
        sessionStorage.setItem(key, JSON.stringify(state));
    }
    /**
     * @param key
     */
    clear(key) {
        sessionStorage.removeItem(key);
    }
}

/**
 * XEP-0198 Stream Management engine.
 *
 * This class holds all SM state and logic (counters, the unacked queue, the
 * enable/resume lifecycle) and never touches a DOM Element or a raw websocket
 * frame, so the same class can be hosted by a page-side Connection or inside a
 * SharedWorker. Everything it needs from a stanza is captured in a minimal
 * {@link StanzaView}, produced by whichever side hosts it (dom.ts on the page,
 * parse.ts in the worker). Nonzas are emitted as strings through the injected
 * `sendRaw` function.
 *
 * IMPORTANT: this module must be loadable in a SharedWorker global (it is
 * bundled into dist/shared-connection-worker.js), so keep it free of imports
 * beyond log/constants and its worker-safe siblings, in particular no
 * ../utils.ts or ../builder.ts, and no module-level DOM access.
 */
/**
 * The XEP-0198 Stream Management engine.
 *
 * Hosted by {@link Connection} (page) or by the shared-connection worker; fed
 * {@link StanzaView}s by a thin per-environment adapter. Emits nonzas through
 * the injected `sendRaw` function.
 */
class StreamManagement {
    /**
     * @param sendRaw - Emits a serialized nonza (or re-sent stanza) towards the server.
     * @param options
     */
    constructor(sendRaw, options = {}) {
        this._sendRaw = sendRaw;
        this._options = Object.assign({ maxUnacked: 5, requestResume: true }, options);
        this._storage = this._options.storage || new MemoryStorageBackend();
        this._storageKey = null;
        this._state = freshState();
        this._resumePending = false;
        this._pendingResend = [];
        this.serverSupported = false;
    }
    /** The live SM state. Treat as read-only outside of tests. */
    get state() {
        return this._state;
    }
    /** Whether <enabled/> has been received and the SM session is active. */
    get enabled() {
        return this._state.enabled;
    }
    /** Whether the current session was established by resumption. */
    get resumed() {
        return this._state.resumed;
    }
    /** The full JID bound when the SM session was enabled. */
    get boundJid() {
        return this._state.boundJid;
    }
    /** Whether a <resume/> has been sent and not yet answered. */
    get resumePending() {
        return this._resumePending;
    }
    /**
     * Set the storage key (from the user's bare JID) and load any persisted
     * resumable state. Call before deciding between resume and fresh bind.
     * @param jid - The user's JID (a full JID is reduced to its bare form).
     */
    initialize(jid) {
        this._storageKey = `strophe-sm:${jid.split('/')[0].toLowerCase()}`;
        const stored = this._storage.load(this._storageKey);
        if (stored) {
            this._state = Object.assign(Object.assign({}, freshState()), stored);
        }
    }
    /**
     * @returns true if persisted state allows attempting <resume/>.
     */
    hasResumableState() {
        return !!(this._state.id && this._state.resumeSupported);
    }
    /**
     * Reset the in-memory engine (e.g. from Connection.reset()).
     * Persisted state is NOT touched — clearing storage is tied to intent
     * (clean close, logout, failed resume), not to connection reuse.
     */
    reset() {
        this._state = freshState();
        this._resumePending = false;
        this._pendingResend = [];
        this.serverSupported = false;
    }
    /** Remove persisted state (clean close, logout, failed resume). */
    clearPersistedState() {
        if (this._storageKey) {
            this._storage.clear(this._storageKey);
        }
    }
    /**
     * Send <enable/> to start a new SM session. Call after resource binding,
     * at the point CONNECTED is emitted. At most one <enable/> is sent per
     * stream — a second attempt SHOULD get the stream killed by the server
     * (XEP-0198 §3).
     * @param boundJid - The full JID that was just bound.
     */
    sendEnable(boundJid) {
        const s = this._state;
        if (s.enableSent) {
            strophe_esm_log.warn('StreamManagement.sendEnable called but <enable/> was already sent for this session');
            return;
        }
        s.enableSent = true;
        s.enabled = false;
        s.resumed = false;
        s.id = null;
        s.max = null;
        s.location = null;
        s.resumeSupported = false;
        s.hIn = 0;
        s.hOutAcked = 0;
        s.sinceLastAck = 0;
        s.unacked = [];
        s.boundJid = boundJid;
        const resume = this._options.requestResume ? ' resume="true"' : '';
        const max = this._options.max ? ` max="${this._options.max}"` : '';
        this._sendRaw(`<enable xmlns="${NS.SM}"${resume}${max}/>`);
        this._persist();
    }
    /**
     * Send <resume/> for the persisted previous session. Call instead of
     * binding, once the post-SASL stream features advertise SM support.
     */
    sendResume() {
        const s = this._state;
        if (!this.hasResumableState()) {
            strophe_esm_log.warn('StreamManagement.sendResume called without resumable state');
            return;
        }
        this._resumePending = true;
        this._sendRaw(`<resume xmlns="${NS.SM}" h="${s.hIn}" previd="${xmlEscape(s.id)}"/>`);
    }
    /**
     * @returns true once <enable/> has been sent, i.e. outbound stanzas are
     *     being tracked. Lets the caller skip building a {@link StanzaView}
     *     for {@link trackOutbound} when tracking is inactive, without
     *     reaching into the engine's state.
     */
    isTracking() {
        return this._state.enableSent;
    }
    /**
     * Track an outbound top-level element. Called for every element that
     * enters the send queue; non-countable elements are ignored here.
     * Active from the moment <enable/> is sent (not from <enabled/> receipt —
     * XEP-0198 starts the outbound counter at enable-send).
     * @param view
     */
    trackOutbound(view) {
        const s = this._state;
        if (!s.enableSent || !isCountableStanza(view.name)) {
            return;
        }
        s.unacked.push({ name: view.name, stanza: view.serialized, queuedAt: Date.now() });
        s.sinceLastAck += 1;
        const max = this._options.maxUnacked;
        if (max > 0 && s.sinceLastAck % max === 0) {
            this.requestAck();
        }
        this._persist();
    }
    /**
     * Process one inbound top-level element: count it if it is a countable
     * stanza (when the session is enabled), otherwise handle it as an SM
     * nonza (<r>/<a>/<enabled>/<resumed>/<failed>). Unrecognised elements are
     * ignored. Each host dispatches inbound elements to its own handlers
     * independently of this call, so nothing is returned.
     * @param view
     */
    onInbound(view) {
        if (isCountableStanza(view.name)) {
            this.onInboundStanza(view.name);
            return;
        }
        switch (view.name) {
            case 'r':
                if (this._state.enabled)
                    this.sendAck();
                break;
            case 'a':
                this._handleAck(view);
                break;
            case 'enabled':
                this._handleEnabled(view);
                break;
            case 'resumed':
                this._handleResumed(view);
                break;
            case 'failed':
                this._handleFailed(view);
                break;
        }
    }
    /** Send an unrequested ack request <r/> to the server. */
    requestAck() {
        this._sendRaw(`<r xmlns="${NS.SM}"/>`);
    }
    /**
     * Send an ack <a/> with the current inbound count. Used to answer <r/>,
     * and RECOMMENDED right before gracefully closing the stream (XEP-0198 §4)
     * so the server doesn't redeliver stanzas that were actually received.
     */
    sendAck() {
        this._sendRaw(`<a xmlns="${NS.SM}" h="${this._state.hIn}"/>`);
    }
    /**
     * Count an inbound top-level stanza by name. Adapters call this from
     * their dispatch loop for every inbound child element — non-countable
     * names and inactive sessions are no-ops, so no StanzaView needs to be
     * built for the common case.
     * @param name - The element's local tag name.
     */
    onInboundStanza(name) {
        if (this._state.enabled && isCountableStanza(name)) {
            this._state.hIn = (this._state.hIn + 1) % H_WRAP;
            this._persist();
        }
    }
    /**
     * Call when the stream is about to be closed cleanly: sends a final
     * <a/> so the server doesn't redeliver stanzas that were actually
     * received (RECOMMENDED, XEP-0198 §4), clears persisted state (a
     * cleanly closed stream is not resumable, XEP-0198 §Stream Closure) and
     * deactivates the engine, so nothing sent during teardown is tracked or
     * re-persisted.
     */
    onGracefulClose() {
        if (this._state.enabled) {
            this.sendAck();
        }
        this.clearPersistedState();
        this._state = freshState();
        this._resumePending = false;
        this._pendingResend = [];
    }
    /** Overridable event hook: an SM session was established via <enabled/>. */
    onEnabled() {
        return;
    }
    /** Overridable event hook: the previous session was resumed via <resumed/>. */
    onResumed() {
        return;
    }
    /**
     * Overridable event hook: <enable/> or <resume/> failed.
     * @param _view - The <failed/> nonza (inspect e.g. for <item-not-found/>).
     * @param _resumeFailed - true when the failure answered a <resume/> (the
     *     unacked queue was salvaged for re-send on the next session), false
     *     when it answered an <enable/>.
     */
    onFailed(_view, _resumeFailed) {
        return;
    }
    /**
     * Reconcile the server-reported 'h' against the unacked queue (mod 2^32).
     * An 'h' above our send count is logged and clamped rather than answered
     * with the spec's <handled-count-too-high/> stream close — a client
     * killing the stream over a server bug only hurts the user.
     * @param h
     */
    _reconcile(h) {
        const s = this._state;
        let delta = (h - s.hOutAcked + H_WRAP) % H_WRAP;
        if (delta > s.unacked.length) {
            strophe_esm_log.error(`StreamManagement: server acked ${delta} stanzas but only ` +
                `${s.unacked.length} are unacknowledged (h=${h}, previous h=${s.hOutAcked})`);
            delta = s.unacked.length;
        }
        s.unacked = s.unacked.slice(delta);
        s.hOutAcked = h;
    }
    /**
     * @param view
     */
    _handleAck(view) {
        const s = this._state;
        if (!s.enableSent && !s.enabled) {
            return;
        }
        const h = parseH(view.attrs.h);
        if (h === null) {
            strophe_esm_log.error('StreamManagement: received <a/> without a valid h attribute');
            return;
        }
        this._reconcile(h);
        s.sinceLastAck = 0;
        this._persist();
    }
    /**
     * @param view
     */
    _handleEnabled(view) {
        const s = this._state;
        if (!s.enableSent) {
            strophe_esm_log.warn('StreamManagement: received <enabled/> but <enable/> was not sent; ignoring');
            return;
        }
        s.enabled = true;
        s.id = view.attrs.id || null;
        const max = parseInt(view.attrs.max, 10);
        s.max = Number.isNaN(max) ? null : max;
        s.location = view.attrs.location || null;
        s.resumeSupported = ['true', '1'].includes(view.attrs.resume);
        this._resendPending();
        this._persist();
        this.onEnabled();
    }
    /**
     * @param view
     */
    _handleResumed(view) {
        const s = this._state;
        if (!s.id) {
            strophe_esm_log.warn('StreamManagement: received <resumed/> without resumable state; ignoring');
            return;
        }
        this._resumePending = false;
        s.resumed = true;
        s.enabled = true;
        s.enableSent = true;
        const h = parseH(view.attrs.h);
        if (h !== null) {
            this._reconcile(h);
        }
        s.sinceLastAck = 0;
        // Re-send whatever the server didn't acknowledge (a MUST, XEP-0198
        // §5).The root `from` is stripped for symmetry with the failed-resume path;
        // on a resume the resource is unchanged, so this is a no-op for a valid
        // `from`. No delay stamp here since these go out on the same live session.
        for (const entry of s.unacked) {
            this._sendRaw(stripFrom(entry.stanza));
        }
        if (s.unacked.length) {
            this.requestAck();
        }
        this._persist();
        this.onResumed();
    }
    /**
     * <enable/> or <resume/> failed. Trim the queue by the optional 'h' on
     * <failed/>, reset the dead session and clear its persisted state.
     *
     * Only a failed *resumption* strands sent-but-undelivered stanzas, so
     * only then is the remaining queue salvaged for re-send once a fresh
     * session reaches <enabled/> (a SHOULD, XEP-0198 §4). When <failed/>
     * answers an <enable/> the stream is alive and bound — everything in
     * `unacked` was delivered normally; re-sending it later would duplicate
     * it.
     * @param view
     */
    _handleFailed(view) {
        const s = this._state;
        if (!s.enableSent && !s.id) {
            return;
        }
        const resumeFailed = this._resumePending;
        this._resumePending = false;
        const h = parseH(view.attrs.h);
        if (h !== null) {
            this._reconcile(h);
        }
        if (resumeFailed) {
            this._pendingResend = this._pendingResend.concat(s.unacked);
        }
        this._state = freshState();
        this.clearPersistedState();
        this.onFailed(view, resumeFailed);
    }
    /**
     * Re-send stanzas salvaged from a failed resumption on the freshly
     * enabled session. Messages are stamped with a XEP-0203 <delay/> carrying
     * their original send time. The re-sent stanzas enter the new session's
     * unacked queue in wire order.
     */
    _resendPending() {
        const pending = this._pendingResend;
        if (!pending.length) {
            return;
        }
        this._pendingResend = [];
        const s = this._state;
        for (const entry of pending) {
            // Strip the root `from` first: the salvaged strings still carry the
            // dead session's resource, which the freshly bound session would
            // reject as invalid-from. Then apply the message delay stamp.
            const stripped = stripFrom(entry.stanza);
            const stanza = entry.name === 'message' ? stampDelay(stripped, entry.name, entry.queuedAt) : stripped;
            this._sendRaw(stanza);
            s.unacked.push(Object.assign(Object.assign({}, entry), { stanza }));
            s.sinceLastAck += 1;
        }
        this.requestAck();
    }
    /** Persist the current state, if a storage key has been configured. */
    _persist() {
        if (this._storageKey) {
            this._storage.save(this._storageKey, this._state);
        }
    }
}

/**
 * XEP-0198 Stream Management
 *
 * The page-side state mirror for worker mode.
 *
 * Page-only: never imported by the shared-connection-worker bundle.
 */
/**
 * A page-side stand-in for the worker-resident engine: when the connection
 * runs through a SharedWorker, the worker owns all counting, queueing and
 * nonza handling, and the page only mirrors the session state so that
 * `Connection.hasResumed()` and friends keep working.
 */
class StreamManagementMirror {
    constructor() {
        this.serverSupported = false;
        this._state = freshState();
    }
    /* Read surface. Reflects the worker-owned session state. */
    get state() {
        return this._state;
    }
    get enabled() {
        return this._state.enabled;
    }
    get resumed() {
        return this._state.resumed;
    }
    get boundJid() {
        return this._state.boundJid;
    }
    get resumePending() {
        // The worker owns resumption; the page never has a <resume/> in flight.
        return false;
    }
    /* Inert active surface. The worker owns all counting/queueing/nonzas. */
    initialize(_jid) {
        return;
    }
    hasResumableState() {
        return false;
    }
    reset() {
        this._state = freshState();
        this.serverSupported = false;
    }
    sendResume() {
        return;
    }
    sendEnable(_boundJid) {
        return;
    }
    isTracking() {
        return false;
    }
    trackOutbound(_view) {
        return;
    }
    onInbound(_view) {
        return;
    }
    onInboundStanza(_name) {
        return;
    }
    onGracefulClose() {
        return;
    }
    /* Overridable event hooks (a shim overrides these to re-emit on its bus). */
    onEnabled() {
        return;
    }
    onResumed() {
        return;
    }
    onFailed(_view, _resumeFailed) {
        return;
    }
    /* Mirror updates, driven by the worker's lifecycle messages. */
    /**
     * @param id - The SM-ID of the fresh session.
     * @param max - The server's preferred maximum resumption time.
     * @param boundJid - The JID that was bound when the session was enabled.
     */
    _onEnabled(id, max, boundJid) {
        const s = this._state;
        s.enabled = true;
        s.id = id;
        s.max = max;
        s.boundJid = boundJid;
        this.onEnabled();
    }
    /**
     * @param boundJid - The worker's boundJid for the resumed session.
     * @param id - The SM-ID of the resumed session.
     * @param max - The server's preferred maximum resumption time.
     */
    _onResumed(boundJid, id, max) {
        const s = this._state;
        s.resumed = true;
        s.enabled = true;
        s.boundJid = boundJid;
        // Repopulate id/max too: the tab that drove the reconnect reset its
        // mirror when the reconnect started, and _onResumed is the only SM
        // message it receives.
        if (id !== undefined)
            s.id = id;
        if (max !== undefined)
            s.max = max;
        this.onResumed();
    }
    _onFailed() {
        this._state = freshState();
        // _smFailed is only broadcast for a failed *resumption* (a refused
        // <enable/> stays inside the worker), so resumeFailed is always true.
        this.onFailed(undefined, true);
    }
}

/**
 * Build the environment-free {@link StanzaView} consumed by the XEP-0198
 * engine from a DOM Element.
 * @param el
 */
function toStanzaView(el) {
    const attrs = {};
    for (let i = 0; i < el.attributes.length; i++) {
        const attr = el.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return { name: el.tagName, attrs, serialized: new XMLSerializer().serializeToString(el) };
}

/**
 * _Private_ variable Used to store plugin names that need
 * initialization during Connection construction.
 */
const connectionPlugins = {};
/**
 * _Private_ registry of optional, environment-specific transports keyed by the
 * `protocol` option that selects them. The Node-only XEP-0114 component
 * transport registers itself here (see the Node entry point) so that its
 * Node-only dependencies never reach the browser bundle.
 */
const transportProtocols = {};
/**
 * **XMPP Connection manager**
 *
 * This class is the main part of Strophe.  It manages a BOSH or websocket
 * connection to an XMPP server and dispatches events to the user callbacks
 * as data arrives.
 *
 * It supports various authentication mechanisms (e.g. SASL PLAIN, SASL SCRAM),
 * and more can be added via
 * {@link Connection#registerSASLMechanisms|registerSASLMechanisms()}.
 *
 * After creating a Connection object, the user will typically
 * call {@link Connection#connect|connect()} with a user supplied callback
 * to handle connection level events like authentication failure,
 * disconnection, or connection complete.
 *
 * The user will also have several event handlers defined by using
 * {@link Connection#addHandler|addHandler()} and
 * {@link Connection#addTimedHandler|addTimedHandler()}.
 * These will allow the user code to respond to interesting stanzas or do
 * something periodically with the connection. These handlers will be active
 * once authentication is finished.
 *
 * To send data to the connection, use {@link Connection#send|send()}.
 *
 * @memberof Strophe
 */
class Connection {
    /**
     * Create and initialize a {@link Connection} object.
     *
     * The transport-protocol for this connection will be chosen automatically
     * based on the given service parameter. URLs starting with "ws://" or
     * "wss://" will use WebSockets, URLs starting with "http://", "https://"
     * or without a protocol will use [BOSH](https://xmpp.org/extensions/xep-0124.html).
     *
     * To make Strophe connect to the current host you can leave out the protocol
     * and host part and just pass the path:
     *
     *  const conn = new Strophe.Connection("/http-bind/");
     *
     * @param service - The BOSH or WebSocket service URL.
     * @param options - A object containing configuration options
     */
    constructor(service, options = {}) {
        // The service URL
        this.service = service;
        // Configuration options
        this.options = options;
        this.setProtocol();
        this._smHandlers = [];
        if (options.enableStreamManagement) {
            if (options.worker) {
                // Under a shared worker the page hosts no SM engine since
                // the worker owns all counting and queueing. The mirror
                // only reflects the session state so that hasResumed()
                // and friends keep working in every tab.
                this.sm = new StreamManagementMirror();
            }
            else {
                // The engine is constructed regardless of the current
                // transport since embedders may swap `_proto` after construction.
                const smOptions = Object.assign({}, (options.streamManagement || {}));
                if (!smOptions.storage && typeof sessionStorage !== 'undefined') {
                    smOptions.storage = new SessionStorageBackend();
                }
                // The SM engine emits nonzas (and re-sends queued stanzas) as
                // strings. They are pushed directly onto the send queue and
                // they ride the same FIFO, so an <r/> goes out after the
                // stanzas it covers.
                this.sm = new StreamManagement((data) => {
                    this._data.push(toElement(data));
                    this._proto._send();
                }, smOptions);
            }
        }
        /* The connected JID. */
        this.jid = '';
        /* the JIDs domain */
        this.domain = null;
        /* stream:features */
        this.features = null;
        // SASL
        this._sasl_data = {};
        this.do_bind = false;
        this.do_session = false;
        this.mechanisms = {};
        this.timedHandlers = [];
        this.handlers = [];
        this.removeTimeds = [];
        this.removeHandlers = [];
        this.addTimeds = [];
        this.addHandlers = [];
        this.protocolErrorHandlers = {
            'HTTP': {},
            'websocket': {},
        };
        this._idleTimeout = null;
        this._disconnectTimeout = null;
        this.authenticated = false;
        this.connected = false;
        this.disconnecting = false;
        this.do_authentication = true;
        this.paused = false;
        this.restored = false;
        this._data = [];
        this._uniqueId = 0;
        this._sasl_success_handler = null;
        this._sasl_failure_handler = null;
        this._sasl_challenge_handler = null;
        // Max retries before disconnecting
        this.maxRetries = 5;
        // Call onIdle callback every 1/10th of a second
        this._scheduleIdle();
        addCookies(this.options.cookies);
        this.registerSASLMechanisms(this.options.mechanisms);
        // A client must always respond to incoming IQ "set" and "get" stanzas.
        // See https://datatracker.ietf.org/doc/html/rfc6120#section-8.2.3
        //
        // This is a fallback handler which gets called when no other handler
        // was called for a received IQ "set" or "get".
        this.iqFallbackHandler = new Handler((iq) => {
            this.send($iq({ type: 'error', id: iq.getAttribute('id') })
                .c('error', { 'type': 'cancel' })
                .c('service-unavailable', { 'xmlns': NS.STANZAS }));
            return false;
        }, null, null, ['get', 'set'], null, null);
        // initialize plugins
        for (const k in connectionPlugins) {
            if (Object.prototype.hasOwnProperty.call(connectionPlugins, k)) {
                const F = function () { };
                F.prototype = connectionPlugins[k];
                // @ts-ignore
                this[k] = new F();
                // @ts-ignore
                this[k].init(this);
            }
        }
    }
    /**
     * Extends the Connection object with the given plugin.
     * @param name - The name of the extension.
     * @param ptype - The plugin's prototype.
     */
    static addConnectionPlugin(name, ptype) {
        connectionPlugins[name] = ptype;
    }
    /**
     * Register an optional transport, selectable via the `protocol` connection
     * option. Used to plug in environment-specific transports (such as the
     * Node-only XEP-0114 component transport) without the core browser build
     * depending on them.
     * @param name - The `protocol` option value that selects this transport.
     * @param manager - The transport (protocol-manager) constructor.
     */
    static addProtocol(name, manager) {
        transportProtocols[name] = manager;
    }
    /**
     * Select protocal based on this.options or this.service
     */
    setProtocol() {
        const proto = this.options.protocol || '';
        const RegisteredTransport = transportProtocols[proto];
        if (RegisteredTransport) {
            this._proto = new RegisteredTransport(this);
        }
        else if (this.options.worker) {
            this._proto = new WorkerWebsocket(this);
        }
        else if (this.service.indexOf('ws:') === 0 ||
            this.service.indexOf('wss:') === 0 ||
            proto.indexOf('ws') === 0) {
            this._proto = new Websocket(this);
        }
        else if (proto) {
            throw new Error(`Strophe: unknown connection protocol "${proto}". Valid values are "ws" and "wss"; ` +
                `other transports must first be registered with Connection.addProtocol().`);
        }
        else {
            this._proto = new Bosh(this);
        }
    }
    /**
     * Reset the connection.
     *
     * This function should be called after a connection is disconnected
     * before that connection is reused.
     */
    reset() {
        var _a;
        this._proto._reset();
        // In-memory SM state only. Persisted (resumable) state is kept and
        // reloaded when the next stream advertises SM support.
        (_a = this.sm) === null || _a === void 0 ? void 0 : _a.reset();
        // SASL
        this.do_session = false;
        this.do_bind = false;
        // handler lists
        this.timedHandlers = [];
        this.handlers = [];
        this.removeTimeds = [];
        this.removeHandlers = [];
        this.addTimeds = [];
        this.addHandlers = [];
        this.authenticated = false;
        this.connected = false;
        this.disconnecting = false;
        this.restored = false;
        this._data = [];
        this._requests = [];
        this._uniqueId = 0;
    }
    /**
     * @returns true if the current session was established by resuming a
     *     previous one via XEP-0198 Stream Management (in which case the
     *     previously bound resource is still valid and roster/presence
     *     state was retained by the server).
     */
    hasResumed() {
        var _a;
        return !!((_a = this.sm) === null || _a === void 0 ? void 0 : _a.resumed);
    }
    /**
     * @returns true if a XEP-0198 Stream Management session is currently
     *     active (i.e. <enabled/> was received or a session was resumed).
     */
    isStreamManagementEnabled() {
        var _a;
        return !!((_a = this.sm) === null || _a === void 0 ? void 0 : _a.enabled);
    }
    /**
     * Pause the request manager.
     *
     * This will prevent Strophe from sending any more requests to the
     * server.  This is very useful for temporarily pausing
     * BOSH-Connections while a lot of send() calls are happening quickly.
     * This causes Strophe to send the data in a single request, saving
     * many request trips.
     */
    pause() {
        this.paused = true;
    }
    /**
     * Resume the request manager.
     *
     * This resumes after pause() has been called.
     */
    resume() {
        this.paused = false;
    }
    /**
     * Generate a unique ID for use in <iq/> elements.
     *
     * All <iq/> stanzas are required to have unique id attributes.  This
     * function makes creating these easy.  Each connection instance has
     * a counter which starts from zero, and the value of this counter
     * plus a colon followed by the suffix becomes the unique id. If no
     * suffix is supplied, the counter is used as the unique id.
     *
     * Suffixes are used to make debugging easier when reading the stream
     * data, and their use is recommended.  The counter resets to 0 for
     * every new connection for the same reason.  For connections to the
     * same server that authenticate the same way, all the ids should be
     * the same, which makes it easy to see changes.  This is useful for
     * automated testing as well.
     *
     * @param suffix - A optional suffix to append to the id.
     * @returns A unique string to be used for the id attribute.
     */
    getUniqueId(suffix) {
        const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
        if (typeof suffix === 'string' || typeof suffix === 'number') {
            return uuid + ':' + suffix;
        }
        else {
            return uuid + '';
        }
    }
    /**
     * Register a handler function for when a protocol (websocker or HTTP)
     * error occurs.
     *
     * NOTE: Currently only HTTP errors for BOSH requests are handled.
     * Patches that handle websocket errors would be very welcome.
     *
     * @example
     *  function onError(err_code){
     *    //do stuff
     *  }
     *
     *  const conn = Strophe.connect('http://example.com/http-bind');
     *  conn.addProtocolErrorHandler('HTTP', 500, onError);
     *  // Triggers HTTP 500 error and onError handler will be called
     *  conn.connect('user_jid@incorrect_jabber_host', 'secret', onConnect);
     *
     * @param protocol - 'HTTP' or 'websocket'
     * @param status_code - Error status code (e.g 500, 400 or 404)
     * @param callback - Function that will fire on Http error
     */
    addProtocolErrorHandler(protocol, status_code, callback) {
        this.protocolErrorHandlers[protocol][status_code] = callback;
    }
    /**
     * Starts the connection process.
     *
     * As the connection process proceeds, the user supplied callback will
     * be triggered multiple times with status updates.  The callback
     * should take two arguments - the status code and the error condition.
     *
     * The status code will be one of the values in the Strophe.Status
     * constants.  The error condition will be one of the conditions
     * defined in RFC 3920 or the condition 'strophe-parsererror'.
     *
     * The Parameters _wait_, _hold_ and _route_ are optional and only relevant
     * for BOSH connections. Please see XEP 124 for a more detailed explanation
     * of the optional parameters.
     *
     * @param jid - The user's JID.  This may be a bare JID,
     *     or a full JID.  If a node is not supplied, SASL OAUTHBEARER or
     *     SASL ANONYMOUS authentication will be attempted (OAUTHBEARER will
     *     process the provided password value as an access token).
     *   (String or Object) pass - The user's password, or an object containing
     *     the users SCRAM client and server keys, in a fashion described as follows:
     *
     *     { name: String, representing the hash used (eg. SHA-1),
     *       salt: String, base64 encoded salt used to derive the client key,
     *       iter: Int,    the iteration count used to derive the client key,
     *       ck:   String, the base64 encoding of the SCRAM client key
     *       sk:   String, the base64 encoding of the SCRAM server key
     *     }
     * @param pass - The user password
     * @param callback - The connect callback function.
     * @param wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     * @param hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param route - The optional route value.
     * @param authcid - The optional alternative authentication identity
     *     (username) if intending to impersonate another user.
     *     When using the SASL-EXTERNAL authentication mechanism, for example
     *     with client certificates, then the authcid value is used to
     *     determine whether an authorization JID (authzid) should be sent to
     *     the server. The authzid should NOT be sent to the server if the
     *     authzid and authcid are the same. So to prevent it from being sent
     *     (for example when the JID is already contained in the client
     *     certificate), set authcid to that same JID. See XEP-178 for more
     *     details.
     *  @param disconnection_timeout - The optional disconnection timeout
     *     in milliseconds before _doDisconnect will be called.
     */
    connect(jid, pass, callback, wait, hold, route, authcid, disconnection_timeout = 3000) {
        var _a;
        this.jid = jid;
        /** Authorization identity */
        this.authzid = getBareJidFromJid(this.jid);
        /** Authentication identity (User name) */
        this.authcid = authcid || getNodeFromJid(this.jid);
        /** Authentication identity (User password) */
        this.pass = pass;
        /**
         * The SASL SCRAM client and server keys. This variable will be populated with a non-null
         * object of the above described form after a successful SCRAM connection
         */
        this.scram_keys = null;
        this.connect_callback = callback;
        this.disconnecting = false;
        this.connected = false;
        this.authenticated = false;
        this.restored = false;
        this.disconnection_timeout = disconnection_timeout;
        // Per-stream SM state starts fresh; resumable state is reloaded from
        // storage once the server advertises SM (_onStreamFeaturesAfterSASL).
        (_a = this.sm) === null || _a === void 0 ? void 0 : _a.reset();
        // parse jid for domain
        this.domain = getDomainFromJid(this.jid);
        this._changeConnectStatus(Status.CONNECTING, null);
        this._proto._connect(wait, hold, route);
    }
    /**
     * Attach to an already created and authenticated BOSH session.
     *
     * This function is provided to allow Strophe to attach to BOSH
     * sessions which have been created externally, perhaps by a Web
     * application.  This is often used to support auto-login type features
     * without putting user credentials into the page.
     *
     * @param jid - The full JID that is bound by the session.
     * @param sid - The SID of the BOSH session.
     * @param rid - The current RID of the BOSH session.  This RID
     *     will be used by the next request.
     * @param callback - The connect callback function.
     * @param wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     *     Other settings will require tweaks to the Strophe.TIMEOUT value.
     * @param hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param wind - The optional HTTBIND window value.  This is the
     *     allowed range of request ids that are valid.  The default is 5.
     */
    attach(jid, sid, rid, callback, wait, hold, wind) {
        if (this._proto instanceof Bosh && typeof jid === 'string') {
            return this._proto._attach(jid, sid, rid, callback, wait, hold, wind);
        }
        else if (this._proto instanceof WorkerWebsocket && typeof jid === 'function') {
            return this._proto._attach(jid);
        }
        else {
            throw new SessionError('The "attach" method is not available for your connection protocol');
        }
    }
    /**
     * Attempt to restore a cached BOSH session.
     *
     * This function is only useful in conjunction with providing the
     * "keepalive":true option when instantiating a new {@link Connection}.
     *
     * When "keepalive" is set to true, Strophe will cache the BOSH tokens
     * RID (Request ID) and SID (Session ID) and then when this function is
     * called, it will attempt to restore the session from those cached
     * tokens.
     *
     * This function must therefore be called instead of connect or attach.
     *
     * For an example on how to use it, please see examples/restore.js
     *
     * @param jid - The user's JID.  This may be a bare JID or a full JID.
     * @param callback - The connect callback function.
     * @param wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     * @param hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param wind - The optional HTTBIND window value.  This is the
     *     allowed range of request ids that are valid.  The default is 5.
     */
    restore(jid, callback, wait, hold, wind) {
        if (!(this._proto instanceof Bosh) || !this._sessionCachingSupported()) {
            throw new SessionError('The "restore" method can only be used with a BOSH connection.');
        }
        if (this._sessionCachingSupported()) {
            this._proto._restore(jid, callback, wait, hold, wind);
        }
    }
    /**
     * Checks whether sessionStorage and JSON are supported and whether we're
     * using BOSH.
     */
    _sessionCachingSupported() {
        if (this._proto instanceof Bosh) {
            if (!JSON) {
                return false;
            }
            try {
                sessionStorage.setItem('_strophe_', '_strophe_');
                sessionStorage.removeItem('_strophe_');
            }
            catch (_e) {
                return false;
            }
            return true;
        }
        return false;
    }
    /**
     * User overrideable function that receives XML data coming into the
     * connection.
     *
     * Due to limitations of current Browsers' XML-Parsers the opening and closing
     * <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
     *
     * BOSH-Connections will have all stanzas wrapped in a <body> tag. See
     * <Bosh.strip> if you want to strip this tag.
     *
     * @param _elem - The XML data received by the connection.
     */
    xmlInput(_elem) {
        return;
    }
    /**
     * User overrideable function that receives XML data sent to the
     * connection.
     *
     * Due to limitations of current Browsers' XML-Parsers the opening and closing
     * <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
     *
     * BOSH-Connections will have all stanzas wrapped in a <body> tag. See
     * <Bosh.strip> if you want to strip this tag.
     *
     * @param _elem - The XMLdata sent by the connection.
     */
    xmlOutput(_elem) {
        return;
    }
    /**
     * User overrideable function that receives raw data coming into the
     * connection.
     *
     * @param _data - The data received by the connection.
     */
    rawInput(_data) {
        return;
    }
    /**
     * User overrideable function that receives raw data sent to the
     * connection.
     *
     * @param _data - The data sent by the connection.
     */
    rawOutput(_data) {
        return;
    }
    /**
     * User overrideable function that receives the new valid rid.
     *
     * @param _rid - The next valid rid
     */
    nextValidRid(_rid) {
        return;
    }
    /**
     * User overrideable function that receives the new role of this
     * connection in a shared-worker setup.
     *
     * Called when the shared worker assigns or changes this tab's role,
     * for example when this tab is promoted to 'primary' after the previous
     * primary tab went away.
     *
     * @param _role - The new role ('primary' or 'secondary')
     */
    onRoleChanged(_role) {
        return;
    }
    /**
     * User overrideable function that receives message and presence stanzas
     * sent by *another* tab sharing this connection (via the `worker`
     * option), so every tab can render what any tab sent.
     *
     * Deliberately separate from the inbound handler pipeline: these stanzas
     * were sent, not received, so they must not trigger stanza handlers.
     * IQs are not reflected — they are request/response traffic private to
     * the sending tab.
     *
     * @param _elem - The sent stanza.
     */
    onForeignStanzaSent(_elem) {
        return;
    }
    /**
     * Send a stanza.
     *
     * This function is called to push data onto the send queue to
     * go out over the wire.  Whenever a request is sent to the BOSH
     * server, all pending data is sent and the queue is flushed.
     *
     * @param stanza - The stanza to send
     */
    send(stanza) {
        if (stanza === null)
            return;
        if (Array.isArray(stanza)) {
            stanza.forEach((s) => this._queueData(s instanceof strophe_esm_Builder ? s.tree() : s));
        }
        else {
            const el = stanza instanceof strophe_esm_Builder ? stanza.tree() : stanza;
            this._queueData(el);
        }
        this._proto._send();
    }
    /**
     * Immediately send any pending outgoing data.
     *
     * Normally send() queues outgoing data until the next idle period
     * (100ms), which optimizes network use in the common cases when
     * several send()s are called in succession. flush() can be used to
     * immediately send all pending data.
     */
    flush() {
        // cancel the pending idle period and run the idle function
        // immediately
        clearTimeout(this._idleTimeout);
        this._onIdle();
    }
    /**
     * Helper function to send presence stanzas. The main benefit is for
     * sending presence stanzas for which you expect a responding presence
     * stanza with the same id (for example when leaving a chat room).
     *
     * @param stanza - The stanza to send.
     * @param callback - The callback function for a successful request.
     * @param errback - The callback function for a failed or timed
     *    out request.  On timeout, the stanza will be null.
     * @param timeout - The time specified in milliseconds for a
     *    timeout to occur.
     * @return The id used to send the presence.
     */
    sendPresence(stanza, callback, errback, timeout) {
        let timeoutHandler = null;
        const el = stanza instanceof strophe_esm_Builder ? stanza.tree() : stanza;
        let id = el.getAttribute('id');
        if (!id) {
            // inject id if not found
            id = this.getUniqueId('sendPresence');
            el.setAttribute('id', id);
        }
        if (typeof callback === 'function' || typeof errback === 'function') {
            const handler = this.addHandler((stanza) => {
                // remove timeout handler if there is one
                if (timeoutHandler)
                    this.deleteTimedHandler(timeoutHandler);
                if (stanza.getAttribute('type') === 'error') {
                    errback === null || errback === void 0 ? void 0 : errback(stanza);
                }
                else if (callback) {
                    callback(stanza);
                }
                return false;
            }, null, 'presence', null, id);
            // if timeout specified, set up a timeout handler.
            if (timeout) {
                timeoutHandler = this.addTimedHandler(timeout, () => {
                    // get rid of normal handler
                    this.deleteHandler(handler);
                    // call errback on timeout with null stanza
                    errback === null || errback === void 0 ? void 0 : errback(null);
                    return false;
                });
            }
        }
        this.send(el);
        return id;
    }
    /**
     * Helper function to send IQ stanzas.
     *
     * @param stanza - The stanza to send.
     * @param callback - The callback function for a successful request.
     * @param errback - The callback function for a failed or timed
     *     out request.  On timeout, the stanza will be null.
     * @param timeout - The time specified in milliseconds for a
     *     timeout to occur.
     * @return The id used to send the IQ.
     */
    sendIQ(stanza, callback, errback, timeout) {
        let timeoutHandler = null;
        const el = stanza instanceof strophe_esm_Builder ? stanza.tree() : stanza;
        let id = el.getAttribute('id');
        if (!id) {
            // inject id if not found
            id = this.getUniqueId('sendIQ');
            el.setAttribute('id', id);
        }
        if (typeof callback === 'function' || typeof errback === 'function') {
            const handler = this.addHandler((stanza) => {
                // remove timeout handler if there is one
                if (timeoutHandler)
                    this.deleteTimedHandler(timeoutHandler);
                const iqtype = stanza.getAttribute('type');
                if (iqtype === 'result') {
                    callback === null || callback === void 0 ? void 0 : callback(stanza);
                }
                else if (iqtype === 'error') {
                    errback === null || errback === void 0 ? void 0 : errback(stanza);
                }
                else {
                    const error = new Error(`Got bad IQ type of ${iqtype}`);
                    error.name = 'StropheError';
                    throw error;
                }
                return false;
            }, null, 'iq', ['error', 'result'], id);
            // if timeout specified, set up a timeout handler.
            if (timeout) {
                timeoutHandler = this.addTimedHandler(timeout, () => {
                    // get rid of normal handler
                    this.deleteHandler(handler);
                    // call errback on timeout with null stanza
                    errback === null || errback === void 0 ? void 0 : errback(null);
                    return false;
                });
            }
        }
        this.send(el);
        return id;
    }
    /**
     * Queue outgoing data for later sending.  Also ensures that the data
     * is a DOMElement.
     * @private
     * @param element
     */
    _queueData(element) {
        var _a;
        if (element === null || !element.tagName || !element.childNodes) {
            const error = new Error('Cannot queue non-DOMElement.');
            error.name = 'StropheError';
            throw error;
        }
        this._data.push(element);
        // XEP-0198: every countable outbound stanza is queued here, after the
        // push, so that an <r/> emitted by the engine lands behind it in the
        // send FIFO. Hooking _queueData (rather than send/sendIQ/sendPresence)
        // means raw send() calls can't escape the counting.
        if (((_a = this.sm) === null || _a === void 0 ? void 0 : _a.isTracking()) && isCountableStanza(element.tagName)) {
            this.sm.trackOutbound(toStanzaView(element));
        }
    }
    /**
     * Send an xmpp:restart stanza.
     * @private
     */
    _sendRestart() {
        this._data.push('restart');
        this._proto._sendRestart();
        this._scheduleIdle();
    }
    /**
     * Add a timed handler to the connection.
     *
     * This function adds a timed handler.  The provided handler will
     * be called every period milliseconds until it returns false,
     * the connection is terminated, or the handler is removed.  Handlers
     * that wish to continue being invoked should return true.
     *
     * Because of method binding it is necessary to save the result of
     * this function if you wish to remove a handler with
     * deleteTimedHandler().
     *
     * Note that user handlers are not active until authentication is
     * successful.
     *
     * @param period - The period of the handler.
     * @param handler - The callback function.
     * @return A reference to the handler that can be used to remove it.
     */
    addTimedHandler(period, handler) {
        const thand = new TimedHandler(period, handler);
        this.addTimeds.push(thand);
        return thand;
    }
    /**
     * Delete a timed handler for a connection.
     *
     * This function removes a timed handler from the connection.  The
     * handRef parameter is *not* the function passed to addTimedHandler(),
     * but is the reference returned from addTimedHandler().
     * @param handRef - The handler reference.
     */
    deleteTimedHandler(handRef) {
        // this must be done in the Idle loop so that we don't change
        // the handlers during iteration
        this.removeTimeds.push(handRef);
    }
    /**
     * Add a stanza handler for the connection.
     *
     * This function adds a stanza handler to the connection.  The
     * handler callback will be called for any stanza that matches
     * the parameters.  Note that if multiple parameters are supplied,
     * they must all match for the handler to be invoked.
     *
     * The handler will receive the stanza that triggered it as its argument.
     * *The handler should return true if it is to be invoked again;
     * returning false will remove the handler after it returns.*
     *
     * As a convenience, the ns parameters applies to the top level element
     * and also any of its immediate children.  This is primarily to make
     * matching /iq/query elements easy.
     *
     * ### Options
     *
     * With the options argument, you can specify boolean flags that affect how
     * matches are being done.
     *
     * Currently two flags exist:
     *
     * * *matchBareFromJid*:
     *     When set to true, the from parameter and the
     *     from attribute on the stanza will be matched as bare JIDs instead
     *     of full JIDs. To use this, pass {matchBareFromJid: true} as the
     *     value of options. The default value for matchBareFromJid is false.
     *
     * * *ignoreNamespaceFragment*:
     *     When set to true, a fragment specified on the stanza's namespace
     *     URL will be ignored when it's matched with the one configured for
     *     the handler.
     *
     *     This means that if you register like this:
     *
     *     >   connection.addHandler(
     *     >       handler,
     *     >       'http://jabber.org/protocol/muc',
     *     >       null, null, null, null,
     *     >       {'ignoreNamespaceFragment': true}
     *     >   );
     *
     *     Then a stanza with XML namespace of
     *     'http://jabber.org/protocol/muc#user' will also be matched. If
     *     'ignoreNamespaceFragment' is false, then only stanzas with
     *     'http://jabber.org/protocol/muc' will be matched.
     *
     * ### Deleting the handler
     *
     * The return value should be saved if you wish to remove the handler
     * with `deleteHandler()`.
     *
     * @param handler - The user callback.
     * @param ns - The namespace to match.
     * @param name - The stanza name to match.
     * @param type - The stanza type (or types if an array) to match.
     * @param id - The stanza id attribute to match.
     * @param from - The stanza from attribute to match.
     * @param options - The handler options
     * @return A reference to the handler that can be used to remove it.
     */
    addHandler(handler, ns, name, type, id, from, options) {
        const hand = new Handler(handler, ns, name, type, id, from, options);
        this.addHandlers.push(hand);
        return hand;
    }
    /**
     * Delete a stanza handler for a connection.
     *
     * This function removes a stanza handler from the connection.  The
     * handRef parameter is *not* the function passed to addHandler(),
     * but is the reference returned from addHandler().
     *
     * @param handRef - The handler reference.
     */
    deleteHandler(handRef) {
        // this must be done in the Idle loop so that we don't change
        // the handlers during iteration
        this.removeHandlers.push(handRef);
        // If a handler is being deleted while it is being added,
        // prevent it from getting added
        const i = this.addHandlers.indexOf(handRef);
        if (i >= 0) {
            this.addHandlers.splice(i, 1);
        }
    }
    /**
     * Register the SASL mechanisms which will be supported by this instance of
     * Connection (i.e. which this XMPP client will support).
     * @param mechanisms - Array of objects with SASLMechanism prototypes
     */
    registerSASLMechanisms(mechanisms) {
        this.mechanisms = {};
        (mechanisms || [
            SASLAnonymous,
            SASLExternal,
            SASLOAuthBearer,
            SASLXOAuth2,
            SASLPlain,
            SASLSHA1,
            SASLSHA256,
            SASLSHA384,
            SASLSHA512,
        ]).forEach((m) => this.registerSASLMechanism(m));
    }
    /**
     * Register a single SASL mechanism, to be supported by this client.
     * @param Mechanism - Object with a Strophe.SASLMechanism prototype
     */
    registerSASLMechanism(Mechanism) {
        const mechanism = new Mechanism();
        this.mechanisms[mechanism.mechname] = mechanism;
    }
    /**
     * Start the graceful disconnection process.
     *
     * This function starts the disconnection process.  This process starts
     * by sending unavailable presence and sending BOSH body of type
     * terminate.  A timeout handler makes sure that disconnection happens
     * even if the BOSH server does not respond.
     * If the Connection object isn't connected, at least tries to abort all pending requests
     * so the connection object won't generate successful requests (which were already opened).
     *
     * The user supplied connection callback will be notified of the
     * progress as this process happens.
     *
     * @param reason - The reason the disconnect is occuring.
     */
    disconnect(reason) {
        var _a;
        this._changeConnectStatus(Status.DISCONNECTING, reason);
        if (reason) {
            strophe_esm_log.info('Disconnect was called because: ' + reason);
        }
        else {
            strophe_esm_log.debug('Disconnect was called');
        }
        if (this.connected) {
            let pres = null;
            this.disconnecting = true;
            if (this.authenticated) {
                pres = $pres({
                    'xmlns': NS.CLIENT,
                    'type': 'unavailable',
                }).tree();
            }
            // A cleanly closed stream is not resumable: send a final <a/> so
            // the server doesn't redeliver stanzas we already received, and
            // drop the persisted XEP-0198 state.
            (_a = this.sm) === null || _a === void 0 ? void 0 : _a.onGracefulClose();
            // setup timeout handler
            this._disconnectTimeout = this._addSysTimedHandler(this.disconnection_timeout, this._onDisconnectTimeout.bind(this));
            this._proto._disconnect(pres);
        }
        else {
            strophe_esm_log.debug('Disconnect was called before Strophe connected to the server');
            this._proto._abortAllRequests();
            this._doDisconnect();
        }
    }
    /**
     * _Private_ helper function that makes sure plugins and the user's
     * callback are notified of connection status changes.
     * @param status - the new connection status, one of the values
     *     in Strophe.Status
     * @param condition - the error condition
     * @param elem - The triggering stanza.
     */
    _changeConnectStatus(status, condition, elem) {
        // notify all plugins listening for status changes
        for (const k in connectionPlugins) {
            if (Object.prototype.hasOwnProperty.call(connectionPlugins, k)) {
                // @ts-ignore
                const plugin = this[k];
                if (plugin.statusChanged) {
                    try {
                        plugin.statusChanged(status, condition);
                    }
                    catch (err) {
                        strophe_esm_log.error(`${k} plugin caused an exception changing status: ${err}`);
                    }
                }
            }
        }
        // notify the user's callback
        if (this.connect_callback) {
            try {
                this.connect_callback(status, condition, elem);
            }
            catch (e) {
                handleError(e);
                strophe_esm_log.error(`User connection callback caused an exception: ${e}`);
            }
        }
    }
    /**
     * _Private_ function to disconnect.
     *
     * This is the last piece of the disconnection logic.  This resets the
     * connection and alerts the user's connection callback.
     * @param condition - the error condition
     */
    _doDisconnect(condition) {
        clearTimeout(this._idleTimeout);
        // Cancel Disconnect Timeout
        if (this._disconnectTimeout !== null) {
            this.deleteTimedHandler(this._disconnectTimeout);
            this._disconnectTimeout = null;
        }
        strophe_esm_log.debug('_doDisconnect was called');
        this._proto._doDisconnect();
        this.authenticated = false;
        this.disconnecting = false;
        this.restored = false;
        // delete handlers
        this.handlers = [];
        this.timedHandlers = [];
        this.removeTimeds = [];
        this.removeHandlers = [];
        this.addTimeds = [];
        this.addHandlers = [];
        // tell the parent we disconnected
        this._changeConnectStatus(Status.DISCONNECTED, condition);
        this.connected = false;
    }
    /**
     * _Private_ handler to processes incoming data from the the connection.
     *
     * Except for _connect_cb handling the initial connection request,
     * this function handles the incoming data for all requests.  This
     * function also fires stanza handlers that match each incoming
     * stanza.
     * @param req - The request that has data ready.
     * @param raw - The stanza as raw string.
     */
    _dataRecv(req, raw) {
        const elem = (this._proto instanceof Bosh ? this._proto._reqToData(req) : req);
        if (elem === null) {
            return;
        }
        if (this.xmlInput !== Connection.prototype.xmlInput) {
            if (elem.nodeName === this._proto.strip && elem.childNodes.length) {
                this.xmlInput(elem.childNodes[0]);
            }
            else {
                this.xmlInput(elem);
            }
        }
        if (this.rawInput !== Connection.prototype.rawInput) {
            if (raw) {
                this.rawInput(raw);
            }
            else {
                this.rawInput(strophe_esm_Builder.serialize(elem));
            }
        }
        // remove handlers scheduled for deletion
        while (this.removeHandlers.length > 0) {
            const hand = this.removeHandlers.pop();
            const i = this.handlers.indexOf(hand);
            if (i >= 0) {
                this.handlers.splice(i, 1);
            }
        }
        // add handlers scheduled for addition
        while (this.addHandlers.length > 0) {
            this.handlers.push(this.addHandlers.pop());
        }
        // handle graceful disconnect
        if (this.disconnecting && this._proto._emptyQueue()) {
            this._doDisconnect();
            return;
        }
        const type = elem.getAttribute('type');
        if (type !== null && type === 'terminate') {
            // Don't process stanzas that come in after disconnect
            if (this.disconnecting) {
                return;
            }
            // an error occurred
            let cond = elem.getAttribute('condition');
            const conflict = elem.getElementsByTagName('conflict');
            if (cond !== null) {
                if (cond === 'remote-stream-error' && conflict.length > 0) {
                    cond = 'conflict';
                }
                this._changeConnectStatus(Status.CONNFAIL, cond);
            }
            else {
                this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.UNKNOWN_REASON);
            }
            this._doDisconnect(cond);
            return;
        }
        // send each incoming stanza through the handler chain
        forEachChild(elem, null, (child) => {
            var _a;
            // XEP-0198: count inbound stanzas here in the dispatch loop —
            // exactly-once, in order, and immune to handler churn.
            (_a = this.sm) === null || _a === void 0 ? void 0 : _a.onInboundStanza(child.nodeName);
            const matches = [];
            this.handlers = this.handlers.reduce((handlers, handler) => {
                try {
                    if (handler.isMatch(child) && (this.authenticated || !handler.user)) {
                        if (handler.run(child)) {
                            handlers.push(handler);
                        }
                        matches.push(handler);
                    }
                    else {
                        handlers.push(handler);
                    }
                }
                catch (e) {
                    // if the handler throws an exception, we consider it as false
                    strophe_esm_log.warn('Removing Strophe handlers due to uncaught exception: ' + e.message);
                }
                return handlers;
            }, []);
            // If no handler was fired for an incoming IQ with type="set",
            // then we return an IQ error stanza with service-unavailable.
            if (!matches.length && this.iqFallbackHandler.isMatch(child)) {
                this.iqFallbackHandler.run(child);
            }
        });
    }
    /**
     * _Private_ handler for initial connection request.
     *
     * This handler is used to process the initial connection request
     * response from the BOSH server. It is used to set up authentication
     * handlers and start the authentication process.
     *
     * SASL authentication will be attempted if available, otherwise
     * the code will fall back to legacy authentication.
     *
     * @param req - The current request.
     * @param _callback - low level (xmpp) connect callback function.
     *     Useful for plugins with their own xmpp connect callback (when they
     *     want to do something special).
     * @param raw - The stanza as raw string.
     */
    _connect_cb(req, _callback, raw) {
        strophe_esm_log.debug('_connect_cb was called');
        this.connected = true;
        let bodyWrap;
        try {
            bodyWrap = (this._proto instanceof Bosh ? this._proto._reqToData(req) : req);
        }
        catch (e) {
            if (e.name !== ErrorCondition.BAD_FORMAT) {
                throw e;
            }
            this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.BAD_FORMAT);
            this._doDisconnect(ErrorCondition.BAD_FORMAT);
        }
        if (!bodyWrap) {
            return;
        }
        if (this.xmlInput !== Connection.prototype.xmlInput) {
            if (bodyWrap.nodeName === this._proto.strip && bodyWrap.childNodes.length) {
                this.xmlInput(bodyWrap.childNodes[0]);
            }
            else {
                this.xmlInput(bodyWrap);
            }
        }
        if (this.rawInput !== Connection.prototype.rawInput) {
            if (raw) {
                this.rawInput(raw);
            }
            else {
                this.rawInput(strophe_esm_Builder.serialize(bodyWrap));
            }
        }
        const conncheck = this._proto._connect_cb(bodyWrap);
        if (conncheck === Status.CONNFAIL) {
            return;
        }
        // Check for the stream:features tag
        let hasFeatures;
        if (bodyWrap.getElementsByTagNameNS) {
            hasFeatures = bodyWrap.getElementsByTagNameNS(NS.STREAM, 'features').length > 0;
        }
        else {
            hasFeatures =
                bodyWrap.getElementsByTagName('stream:features').length > 0 ||
                    bodyWrap.getElementsByTagName('features').length > 0;
        }
        if (!hasFeatures) {
            this._proto._no_auth_received(_callback);
            return;
        }
        const matched = Array.from(bodyWrap.getElementsByTagName('mechanism'))
            .map((m) => this.mechanisms[m.textContent])
            .filter((m) => m);
        if (matched.length === 0) {
            if (bodyWrap.getElementsByTagName('auth').length === 0) {
                // There are no matching SASL mechanisms and also no legacy
                // auth available.
                this._proto._no_auth_received(_callback);
                return;
            }
        }
        if (this.do_authentication !== false) {
            this.authenticate(matched);
        }
    }
    /**
     * Sorts an array of objects with prototype SASLMechanism according to
     * their priorities.
     * @param mechanisms - Array of SASL mechanisms.
     */
    sortMechanismsByPriority(mechanisms) {
        // Sorting mechanisms according to priority.
        for (let i = 0; i < mechanisms.length - 1; ++i) {
            let higher = i;
            for (let j = i + 1; j < mechanisms.length; ++j) {
                if (mechanisms[j].priority > mechanisms[higher].priority) {
                    higher = j;
                }
            }
            if (higher !== i) {
                const swap = mechanisms[i];
                mechanisms[i] = mechanisms[higher];
                mechanisms[higher] = swap;
            }
        }
        return mechanisms;
    }
    /**
     * Set up authentication
     *
     * Continues the initial connection request by setting up authentication
     * handlers and starting the authentication process.
     *
     * SASL authentication will be attempted if available, otherwise
     * the code will fall back to legacy authentication.
     *
     * @param matched - Array of SASL mechanisms supported.
     */
    authenticate(matched) {
        if (!this._attemptSASLAuth(matched)) {
            this._attemptLegacyAuth();
        }
    }
    /**
     * Iterate through an array of SASL mechanisms and attempt authentication
     * with the highest priority (enabled) mechanism.
     *
     * @private
     * @param mechanisms - Array of SASL mechanisms.
     * @return mechanism_found - true or false, depending on whether a
     *  valid SASL mechanism was found with which authentication could be started.
     */
    _attemptSASLAuth(mechanisms) {
        mechanisms = this.sortMechanismsByPriority(mechanisms || []);
        let mechanism_found = false;
        for (let i = 0; i < mechanisms.length; ++i) {
            if (!mechanisms[i].test(this)) {
                continue;
            }
            this._sasl_success_handler = this._addSysHandler(this._sasl_success_cb.bind(this), null, 'success', null, null);
            this._sasl_failure_handler = this._addSysHandler(this._sasl_failure_cb.bind(this), null, 'failure', null, null);
            this._sasl_challenge_handler = this._addSysHandler(this._sasl_challenge_cb.bind(this), null, 'challenge', null, null);
            this._sasl_mechanism = mechanisms[i];
            this._sasl_mechanism.onStart(this);
            const request_auth_exchange = $build('auth', {
                'xmlns': NS.SASL,
                'mechanism': this._sasl_mechanism.mechname,
            });
            if (this._sasl_mechanism.isClientFirst) {
                const response = this._sasl_mechanism.clientChallenge(this);
                request_auth_exchange.t(btoa(response));
            }
            this.send(request_auth_exchange.tree());
            mechanism_found = true;
            break;
        }
        return mechanism_found;
    }
    /**
     * _Private_ handler for the SASL challenge
     * @private
     * @param elem
     */
    _sasl_challenge_cb(elem) {
        return __awaiter(this, void 0, void 0, function* () {
            const challenge = atob(getText(elem));
            const response = yield this._sasl_mechanism.onChallenge(this, challenge);
            const stanza = $build('response', { 'xmlns': NS.SASL });
            if (response)
                stanza.t(btoa(response));
            this.send(stanza.tree());
            return true;
        });
    }
    /**
     * Attempt legacy (i.e. non-SASL) authentication.
     * @private
     */
    _attemptLegacyAuth() {
        if (getNodeFromJid(this.jid) === null) {
            // we don't have a node, which is required for non-anonymous
            // client connections
            this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.MISSING_JID_NODE);
            this.disconnect(ErrorCondition.MISSING_JID_NODE);
        }
        else {
            // Fall back to legacy authentication
            this._changeConnectStatus(Status.AUTHENTICATING, null);
            this._addSysHandler(this._onLegacyAuthIQResult.bind(this), null, null, null, '_auth_1');
            this.send($iq({
                'type': 'get',
                'to': this.domain,
                'id': '_auth_1',
            })
                .c('query', { xmlns: NS.AUTH })
                .c('username', {})
                .t(getNodeFromJid(this.jid))
                .tree());
        }
    }
    /**
     * _Private_ handler for legacy authentication.
     *
     * This handler is called in response to the initial <iq type='get'/>
     * for legacy authentication.  It builds an authentication <iq/> and
     * sends it, creating a handler (calling back to _auth2_cb()) to
     * handle the result
     * @private
     * @return `false` to remove the handler.
     */
    _onLegacyAuthIQResult() {
        const pass = typeof this.pass === 'string' ? this.pass : '';
        // build plaintext auth iq
        const iq = $iq({ type: 'set', id: '_auth_2' })
            .c('query', { xmlns: NS.AUTH })
            .c('username', {})
            .t(getNodeFromJid(this.jid))
            .up()
            .c('password')
            .t(pass);
        if (!getResourceFromJid(this.jid)) {
            // since the user has not supplied a resource, we pick
            // a default one here.  unlike other auth methods, the server
            // cannot do this for us.
            this.jid = getBareJidFromJid(this.jid) + '/strophe';
        }
        iq.up().c('resource', {}).t(getResourceFromJid(this.jid));
        this._addSysHandler(this._auth2_cb.bind(this), null, null, null, '_auth_2');
        this.send(iq.tree());
        return false;
    }
    /**
     * _Private_ handler for succesful SASL authentication.
     * @private
     * @param elem - The matching stanza.
     * @return `false` to remove the handler.
     */
    _sasl_success_cb(elem) {
        if (this._sasl_data['server-signature']) {
            let serverSignature;
            const success = atob(getText(elem));
            const attribMatch = /([a-z]+)=([^,]+)(,|$)/;
            const matches = success.match(attribMatch);
            if (matches[1] === 'v') {
                serverSignature = matches[2];
            }
            if (serverSignature !== this._sasl_data['server-signature']) {
                // remove old handlers
                this.deleteHandler(this._sasl_failure_handler);
                this._sasl_failure_handler = null;
                if (this._sasl_challenge_handler) {
                    this.deleteHandler(this._sasl_challenge_handler);
                    this._sasl_challenge_handler = null;
                }
                this._sasl_data = {};
                return this._sasl_failure_cb(null);
            }
        }
        strophe_esm_log.info('SASL authentication succeeded.');
        if (this._sasl_data.keys) {
            this.scram_keys = this._sasl_data.keys;
        }
        if (this._sasl_mechanism) {
            this._sasl_mechanism.onSuccess();
        }
        // remove old handlers
        this.deleteHandler(this._sasl_failure_handler);
        this._sasl_failure_handler = null;
        if (this._sasl_challenge_handler) {
            this.deleteHandler(this._sasl_challenge_handler);
            this._sasl_challenge_handler = null;
        }
        const streamfeature_handlers = [];
        const wrapper = (handlers, elem) => {
            while (handlers.length) {
                this.deleteHandler(handlers.pop());
            }
            this._onStreamFeaturesAfterSASL(elem);
            return false;
        };
        streamfeature_handlers.push(this._addSysHandler((elem) => wrapper(streamfeature_handlers, elem), null, 'stream:features', null, null));
        streamfeature_handlers.push(this._addSysHandler((elem) => wrapper(streamfeature_handlers, elem), NS.STREAM, 'features', null, null));
        // we must send an xmpp:restart now
        this._sendRestart();
        return false;
    }
    /**
     * @private
     * @param elem - The matching stanza.
     * @return `false` to remove the handler.
     */
    _onStreamFeaturesAfterSASL(elem) {
        var _a;
        // save stream:features for future usage
        this.features = elem;
        for (let i = 0; i < elem.childNodes.length; i++) {
            const child = elem.childNodes[i];
            if (child.nodeName === 'bind') {
                this.do_bind = true;
            }
            if (child.nodeName === 'session') {
                this.do_session = true;
            }
            if (this.sm && child.nodeName === 'sm' && child.namespaceURI === NS.SM) {
                this.sm.serverSupported = true;
            }
        }
        if ((_a = this.sm) === null || _a === void 0 ? void 0 : _a.serverSupported) {
            if (this.options.worker) {
                // Only the worker knows whether resumable state exists: it
                // either sends <resume/> itself (answering _smResumed or
                // _smFailed) or replies _smNoState, upon which the
                // connection proceeds to bind (see WorkerWebsocket).
                this._proto._smFeatures();
                return false;
            }
            // SM is only negotiated over websocket. Checked here on the
            // live transport because the transport can be swapped after
            // construction (e.g. XEP-0156 discovery).
            if (this._proto instanceof Websocket) {
                this.sm.initialize(this.jid);
                if (this.sm.hasResumableState()) {
                    // Attempt XEP-0198 stream resumption instead of binding a resource.
                    this._registerSMHandlers();
                    this.sm.sendResume();
                    return false;
                }
            }
        }
        this._proceedToBind();
        return false;
    }
    /**
     * Continue the connect flow with resource binding, once it is clear no
     * XEP-0198 resumption will happen (no SM support, no resumable state, a
     * failed <resume/>, or the shared worker reporting _smNoState).
     */
    _proceedToBind() {
        if (!this.do_bind) {
            this._changeConnectStatus(Status.AUTHFAIL, null);
        }
        else if (!this.options.explicitResourceBinding) {
            this.bind();
        }
        else {
            this._changeConnectStatus(Status.BINDREQUIRED, null);
        }
    }
    /**
     * Register the XEP-0198 nonza handlers (idempotently)
     * They are system handlers, so they run before authentication completes,
     * which the resume flow requires.
     */
    _registerSMHandlers() {
        this._smHandlers.forEach((h) => this.deleteHandler(h));
        const delegate = (el) => {
            this.sm.onInbound(toStanzaView(el));
            return true;
        };
        this._smHandlers = [
            this._addSysHandler(delegate, NS.SM, 'r', null, null),
            this._addSysHandler(delegate, NS.SM, 'a', null, null),
            this._addSysHandler(delegate, NS.SM, 'enabled', null, null),
            this._addSysHandler((el) => this._onStreamResumed(el), NS.SM, 'resumed', null, null),
            this._addSysHandler((el) => this._onStreamResumptionFailed(el), NS.SM, 'failed', null, null),
        ];
    }
    /**
     * _Private_ handler for a successful XEP-0198 stream resumption.
     *
     * The engine reconciles the server's 'h' and re-sends whatever the
     * server didn't acknowledge.
     *
     * The connection state is restored, `this.jid` is set back to the JID that
     * was bound when the SM session was established, *before* CONNECTED is emitted,
     * so no stanza can ever be stamped with a resource the server doesn't know.
     * @param elem - The <resumed/> nonza.
     * @return `true` to keep the handler.
     */
    _onStreamResumed(elem) {
        this.sm.onInbound(toStanzaView(elem));
        this.do_bind = false;
        this.authenticated = true;
        this.restored = true;
        this.jid = this.sm.boundJid;
        this._changeConnectStatus(Status.CONNECTED, null);
        return true;
    }
    /**
     * _Private_ handler for a failed <enable/> or <resume/>.
     *
     * The engine resets its state; after a failed *resumption* it also
     * salvages the unacked queue (re-sent once a fresh session reaches
     * <enabled/>), and the connection falls back to binding a resource on
     * this same stream, per XEP-0198 ("the server SHOULD allow the client
     * to bind a resource at this point"). A refused <enable/> needs neither:
     * the stream is alive and bound, it just runs without SM.
     * @param elem - The <failed/> nonza.
     * @return `true` to keep the handler.
     */
    _onStreamResumptionFailed(elem) {
        // Read before feeding the nonza to the engine, which clears the flag.
        const resuming = this.sm.resumePending;
        this.sm.onInbound(toStanzaView(elem));
        if (resuming) {
            this.do_bind = true;
            this._proceedToBind();
        }
        return true;
    }
    /**
     * Called at the CONNECTED-emission points of the connect flow, just
     * before CONNECTED is emitted i.e. once the full JID is final (resource
     * bound, legacy session established, or legacy auth completed).
     *
     * Under the `worker` option the bound JID is always reported to the
     * shared worker — with or without Stream Management — so it can hand the
     * right JID to attaching tabs, release joins parked on the handshake,
     * and (when this stream's features advertised SM) start a fresh SM
     * session itself (it answers with _smEnabled, which updates the mirror).
     *
     * Otherwise, if the server supports XEP-0198 and nothing was resumed,
     * a fresh SM session is started from here. The XEP allows <enable/> any
     * time after binding.
     */
    _onSessionReady() {
        var _a;
        if (this.options.worker) {
            this._proto._bound(this.jid);
            return;
        }
        if (!((_a = this.sm) === null || _a === void 0 ? void 0 : _a.serverSupported) || this.sm.resumed || !(this._proto instanceof Websocket)) {
            return;
        }
        if (!this.sm.isTracking()) {
            this._registerSMHandlers();
            this.sm.sendEnable(this.jid);
        }
    }
    /**
     * Sends an IQ to the XMPP server to bind a JID resource for this session.
     *
     * https://tools.ietf.org/html/rfc6120#section-7.5
     *
     * If `explicitResourceBinding` was set to a truthy value in the options
     * passed to the Connection constructor, then this function needs
     * to be called explicitly by the client author.
     *
     * Otherwise it'll be called automatically as soon as the XMPP server
     * advertises the "urn:ietf:params:xml:ns:xmpp-bind" stream feature.
     */
    bind() {
        if (!this.do_bind) {
            strophe_esm_log.info(`Connection.prototype.bind called but "do_bind" is false`);
            return;
        }
        this._addSysHandler(this._onResourceBindResultIQ.bind(this), null, null, null, '_bind_auth_2');
        const resource = getResourceFromJid(this.jid);
        if (resource) {
            this.send($iq({ type: 'set', id: '_bind_auth_2' })
                .c('bind', { xmlns: NS.BIND })
                .c('resource', {})
                .t(resource)
                .tree());
        }
        else {
            this.send($iq({ type: 'set', id: '_bind_auth_2' }).c('bind', { xmlns: NS.BIND }).tree());
        }
    }
    /**
     * _Private_ handler for binding result and session start.
     * @private
     * @param elem - The matching stanza.
     * @return `false` to remove the handler.
     */
    _onResourceBindResultIQ(elem) {
        if (elem.getAttribute('type') === 'error') {
            strophe_esm_log.warn('Resource binding failed.');
            const conflict = elem.getElementsByTagName('conflict');
            let condition;
            if (conflict.length > 0) {
                condition = ErrorCondition.CONFLICT;
            }
            this._changeConnectStatus(Status.AUTHFAIL, condition, elem);
            return false;
        }
        // TODO - need to grab errors
        const bind = elem.getElementsByTagName('bind');
        if (bind.length > 0) {
            const jidNode = bind[0].getElementsByTagName('jid');
            if (jidNode.length > 0) {
                this.authenticated = true;
                this.jid = getText(jidNode[0]);
                if (this.do_session) {
                    this._establishSession();
                }
                else {
                    this._onSessionReady();
                    this._changeConnectStatus(Status.CONNECTED, null);
                }
            }
        }
        else {
            strophe_esm_log.warn('Resource binding failed.');
            this._changeConnectStatus(Status.AUTHFAIL, null, elem);
            return false;
        }
    }
    /**
     * Send IQ request to establish a session with the XMPP server.
     *
     * See https://xmpp.org/rfcs/rfc3921.html#session
     *
     * Note: The protocol for session establishment has been determined as
     * unnecessary and removed in RFC-6121.
     * @private
     */
    _establishSession() {
        if (!this.do_session) {
            throw new Error(`Connection.prototype._establishSession ` +
                `called but apparently ${NS.SESSION} wasn't advertised by the server`);
        }
        this._addSysHandler(this._onSessionResultIQ.bind(this), null, null, null, '_session_auth_2');
        this.send($iq({ type: 'set', id: '_session_auth_2' }).c('session', { xmlns: NS.SESSION }).tree());
    }
    /**
     * _Private_ handler for the server's IQ response to a client's session
     * request.
     *
     * This sets Connection.authenticated to true on success, which
     * starts the processing of user handlers.
     *
     * See https://xmpp.org/rfcs/rfc3921.html#session
     *
     * Note: The protocol for session establishment has been determined as
     * unnecessary and removed in RFC-6121.
     * @private
     * @param elem - The matching stanza.
     * @return `false` to remove the handler.
     */
    _onSessionResultIQ(elem) {
        if (elem.getAttribute('type') === 'result') {
            this.authenticated = true;
            this._onSessionReady();
            this._changeConnectStatus(Status.CONNECTED, null);
        }
        else if (elem.getAttribute('type') === 'error') {
            this.authenticated = false;
            strophe_esm_log.warn('Session creation failed.');
            this._changeConnectStatus(Status.AUTHFAIL, null, elem);
            return false;
        }
        return false;
    }
    /**
     * _Private_ handler for SASL authentication failure.
     * @param elem - The matching stanza.
     * @return `false` to remove the handler.
     */
    _sasl_failure_cb(elem) {
        // delete unneeded handlers
        if (this._sasl_success_handler) {
            this.deleteHandler(this._sasl_success_handler);
            this._sasl_success_handler = null;
        }
        if (this._sasl_challenge_handler) {
            this.deleteHandler(this._sasl_challenge_handler);
            this._sasl_challenge_handler = null;
        }
        if (this._sasl_mechanism)
            this._sasl_mechanism.onFailure();
        this._changeConnectStatus(Status.AUTHFAIL, null, elem);
        return false;
    }
    /**
     * _Private_ handler to finish legacy authentication.
     *
     * This handler is called when the result from the jabber:iq:auth
     * <iq/> stanza is returned.
     * @private
     * @param elem - The stanza that triggered the callback.
     * @return `false` to remove the handler.
     */
    _auth2_cb(elem) {
        if (elem.getAttribute('type') === 'result') {
            this.authenticated = true;
            this._onSessionReady();
            this._changeConnectStatus(Status.CONNECTED, null);
        }
        else if (elem.getAttribute('type') === 'error') {
            this._changeConnectStatus(Status.AUTHFAIL, null, elem);
            this.disconnect('authentication failed');
        }
        return false;
    }
    /**
     * _Private_ function to add a system level timed handler.
     *
     * This function is used to add a TimedHandler for the
     * library code.  System timed handlers are allowed to run before
     * authentication is complete.
     * @param period - The period of the handler.
     * @param handler - The callback function.
     */
    _addSysTimedHandler(period, handler) {
        const thand = new TimedHandler(period, handler);
        thand.user = false;
        this.addTimeds.push(thand);
        return thand;
    }
    /**
     * _Private_ function to add a system level stanza handler.
     *
     * This function is used to add a Handler for the
     * library code.  System stanza handlers are allowed to run before
     * authentication is complete.
     * @param handler - The callback function.
     * @param ns - The namespace to match.
     * @param name - The stanza name to match.
     * @param type - The stanza type attribute to match.
     * @param id - The stanza id attribute to match.
     */
    _addSysHandler(handler, ns, name, type, id) {
        const hand = new Handler(handler, ns, name, type, id, null);
        hand.user = false;
        this.addHandlers.push(hand);
        return hand;
    }
    /**
     * _Private_ timeout handler for handling non-graceful disconnection.
     *
     * If the graceful disconnect process does not complete within the
     * time allotted, this handler finishes the disconnect anyway.
     * @return `false` to remove the handler.
     */
    _onDisconnectTimeout() {
        strophe_esm_log.debug('_onDisconnectTimeout was called');
        this._changeConnectStatus(Status.CONNTIMEOUT, null);
        this._proto._onDisconnectTimeout();
        // actually disconnect
        this._doDisconnect();
        return false;
    }
    /**
     * (Re)arm the idle loop.
     *
     * Cancels any pending idle tick and schedules the next call to
     * {@link Connection#_onIdle}. `_onIdle` re-arms itself while connected, so
     * this only needs to be called to (re)start the loop: at construction, on a
     * stream restart, or when a transport becomes connected without having gone
     * through the send path (e.g. a receive-only component after its handshake).
     * @private
     */
    _scheduleIdle() {
        clearTimeout(this._idleTimeout);
        this._idleTimeout = setTimeout(() => this._onIdle(), 100);
    }
    /**
     * _Private_ handler to process events during idle cycle.
     *
     * This handler is called every 100ms to fire timed handlers that
     * are ready and keep poll requests going.
     */
    _onIdle() {
        // add timed handlers scheduled for addition
        // NOTE: we add before remove in the case a timed handler is
        // added and then deleted before the next _onIdle() call.
        while (this.addTimeds.length > 0) {
            this.timedHandlers.push(this.addTimeds.pop());
        }
        // remove timed handlers that have been scheduled for deletion
        while (this.removeTimeds.length > 0) {
            const thand = this.removeTimeds.pop();
            const i = this.timedHandlers.indexOf(thand);
            if (i >= 0) {
                this.timedHandlers.splice(i, 1);
            }
        }
        // call ready timed handlers
        const now = new Date().getTime();
        const newList = [];
        for (let i = 0; i < this.timedHandlers.length; i++) {
            const thand = this.timedHandlers[i];
            if (this.authenticated || !thand.user) {
                const since = thand.lastCalled + thand.period;
                if (since - now <= 0) {
                    if (thand.run()) {
                        newList.push(thand);
                    }
                }
                else {
                    newList.push(thand);
                }
            }
        }
        this.timedHandlers = newList;
        clearTimeout(this._idleTimeout);
        this._proto._onIdle();
        // reactivate the timer only if connected
        if (this.connected) {
            this._idleTimeout = setTimeout(() => this._onIdle(), 100);
        }
    }
}

var _Stanza_string, _Stanza_strings, _Stanza_values;
class UnsafeXML extends String {
}
/**
 * A Stanza represents a XML element used in XMPP (commonly referred to as stanzas).
 */
class Stanza extends strophe_esm_Builder {
    /**
     * @param strings
     * @param values
     */
    constructor(strings, values) {
        super('stanza');
        _Stanza_string.set(this, void 0);
        _Stanza_strings.set(this, void 0);
        _Stanza_values.set(this, void 0);
        __classPrivateFieldSet(this, _Stanza_strings, strings, "f");
        __classPrivateFieldSet(this, _Stanza_values, values, "f");
    }
    /**
     * A directive which can be used to pass a string of XML as a value to the
     * stx tagged template literal.
     *
     * It's considered "unsafe" because it can pose a security risk if used with
     * untrusted input.
     *
     * @param string
     * @returns
     * @example
     *    const status = '<status>I am busy!</status>';
     *    const pres = stx`
     *       <presence from='juliet@example.com/chamber' id='pres1'>
     *           <show>dnd</show>
     *           ${unsafeXML(status)}
     *       </presence>`;
     *    connection.send(pres);
     */
    static unsafeXML(string) {
        return new UnsafeXML(string);
    }
    /**
     * Turns the passed-in string into an XML Element.
     * @param string
     * @param throwErrorIfInvalidNS
     * @returns
     */
    static toElement(string, throwErrorIfInvalidNS) {
        const doc = strophe_esm_xmlHtmlNode(string);
        const parserError = getParserError(doc);
        if (parserError) {
            throw new Error(`Parser Error: ${parserError}`);
        }
        const node = stripWhitespace(getFirstElementChild(doc));
        if (['message', 'iq', 'presence'].includes(node.nodeName.toLowerCase()) &&
            node.namespaceURI !== 'jabber:client' &&
            node.namespaceURI !== 'jabber:server') {
            const err_msg = `Invalid namespaceURI ${node.namespaceURI}`;
            if (throwErrorIfInvalidNS) {
                throw new Error(err_msg);
            }
            else {
                strophe_esm_log.error(err_msg);
            }
        }
        return node;
    }
    buildTree() {
        return Stanza.toElement(this.toString(), true);
    }
    /**
     * @returns
     */
    toString() {
        __classPrivateFieldSet(this, _Stanza_string, __classPrivateFieldGet(this, _Stanza_string, "f") ||
            __classPrivateFieldGet(this, _Stanza_strings, "f")
                .reduce((acc, str, idx) => {
                const value = __classPrivateFieldGet(this, _Stanza_values, "f").length > idx ? __classPrivateFieldGet(this, _Stanza_values, "f")[idx] : '';
                return (acc +
                    str +
                    (Array.isArray(value)
                        ? value
                            .map((v) => v instanceof UnsafeXML || v instanceof strophe_esm_Builder
                            ? v
                            : xmlescape(v.toString()))
                            .join('')
                        : value instanceof UnsafeXML || value instanceof strophe_esm_Builder
                            ? value
                            : xmlescape((value !== null && value !== void 0 ? value : '').toString())));
            }, '')
                .trim(), "f");
        return __classPrivateFieldGet(this, _Stanza_string, "f");
    }
}
_Stanza_string = new WeakMap(), _Stanza_strings = new WeakMap(), _Stanza_values = new WeakMap();
/**
 * Tagged template literal function which generates {@link Stanza} objects
 *
 * @example
 *      const pres = stx`<presence type="${type}" xmlns="jabber:client"><show>${show}</show></presence>`
 *
 *      connection.send(msg);
 *
 * @example
 *      const msg = stx`<message
 *          from='sender@example.org'
 *          id='hgn27af1'
 *          to='recipient@example.org'
 *          type='chat'>
 *          <body>Hello world</body>
 *      </message>`;
 *
 *      connection.send(msg);
 *
 * @param strings
 * @param values
 * @returns
 */
function stx(strings, ...values) {
    return new Stanza(strings, values);
}

const Strophe = Object.assign(Object.assign(Object.assign({ VERSION: '4.0.0', get TIMEOUT() {
        return Bosh.getTimeoutMultplier();
    },
    set TIMEOUT(n) {
        Bosh.setTimeoutMultiplier(n);
    },
    get SECONDARY_TIMEOUT() {
        return Bosh.getSecondaryTimeoutMultplier();
    },
    set SECONDARY_TIMEOUT(n) {
        Bosh.setSecondaryTimeoutMultiplier(n);
    } }, utils$1), strophe_esm_log), { Request,
    Bosh,
    Websocket,
    WorkerWebsocket,
    Connection,
    Handler,
    SASLAnonymous,
    SASLPlain,
    SASLSHA1,
    SASLSHA256,
    SASLSHA384,
    SASLSHA512,
    SASLOAuthBearer,
    SASLExternal,
    SASLXOAuth2,
    Stanza,
    StreamManagement,
    MemoryStorageBackend,
    SessionStorageBackend,
    Builder: strophe_esm_Builder,
    ElementType,
    ErrorCondition, LogLevel: LOG_LEVELS, NS,
    SASLMechanism,
    Status,
    TimedHandler, XHTML: Object.assign(Object.assign({}, XHTML), { validTag: validTag, validCSS: validCSS, validAttribute: validAttribute }), serialize(elem) {
        return strophe_esm_Builder.serialize(elem);
    },
    setLogLevel(level) {
        strophe_esm_log.setLogLevel(level);
    },
    addNamespace(name, value) {
        Strophe.NS[name] = value;
    },
    addConnectionPlugin(name, ptype) {
        Connection.addConnectionPlugin(name, ptype);
    } });
globalThis.$build = $build;
globalThis.$iq = $iq;
globalThis.$msg = $msg;
globalThis.$pres = $pres;
globalThis.Strophe = Strophe;
globalThis.stx = stx;
const toStanza = Stanza.toElement;
globalThis.toStanza = Stanza.toElement;


//# sourceMappingURL=strophe.esm.js.map

// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(67);
;// CONCATENATED MODULE: ./src/headless/utils/html.js



/**
 * @param {unknown} el
 * @returns {boolean}
 */
function isElement(el) {
    // Checked by nodeType rather than `instanceof`, because `HTMLDocument`
    // doesn't exist outside a browser and because stanzas built in another
    // realm (a shared worker, an iframe) fail an `instanceof` check.
    const node_type = /** @type {Node} */ (el)?.nodeType;
    return node_type === 1 /* ELEMENT_NODE */ || node_type === 9; /* DOCUMENT_NODE */
}

const EMPTY_TEXT_REGEX = /\s*\n\s*/;

/**
 * @param {Element|Builder|Stanza} el
 */
function stripEmptyTextNodes(el) {
    if (el instanceof strophe_esm_Builder || el instanceof Stanza) {
        el = el.tree();
    }

    let n;
    const text_nodes = [];
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, (node) => {
        if (node.parentElement.nodeName.toLowerCase() === 'body') {
            return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
    });
    while ((n = walker.nextNode())) text_nodes.push(n);
    text_nodes.forEach((n) => EMPTY_TEXT_REGEX.test(/** @type {Text} */ (n).data) && n.parentElement.removeChild(n));

    return el;
}

/**
 * Given two XML or HTML elements, determine if they're equal
 * @param {Element} actual
 * @param {Element} expected
 * @returns {Boolean}
 */
function isEqualNode(actual, expected) {
    if (!isElement(actual)) {
        if (actual instanceof Strophe.Builder) {
            actual = actual.tree();
        } else {
            throw new Error('Element being compared must be an Element!');
        }
    }

    expected = stripEmptyTextNodes(expected);
    actual = stripEmptyTextNodes(actual);

    let isEqual = actual.isEqualNode(expected);

    if (!isEqual) {
        // XXX: This is a hack.
        // When creating two XML elements, one via DOMParser, and one via
        // createElementNS (or createElement), then "isEqualNode" doesn't match.
        //
        // For example, in the following code `isEqual` is false:
        // ------------------------------------------------------
        // const a = document.createElementNS('foo', 'div');
        // a.setAttribute('xmlns', 'foo');
        //
        // const b = (new DOMParser()).parseFromString('<div xmlns="foo"></div>', 'text/xml').firstElementChild;
        // const isEqual = a.isEqualNode(div); //  false
        //
        // The workaround here is to serialize both elements to string and then use
        // DOMParser again for both (via xmlHtmlNode).
        //
        // This is not efficient, but currently this is only being used in tests.
        //
        const { xmlHtmlNode } = Strophe;
        const actual_string = Strophe.serialize(actual);
        const expected_string = Strophe.serialize(expected);
        isEqual =
            actual_string === expected_string || xmlHtmlNode(actual_string).isEqualNode(xmlHtmlNode(expected_string));
    }
    return isEqual;
}

/**
 * @param {Element | typeof Strophe.Builder} stanza
 * @param {string} name
 * @returns {boolean}
 */
function html_isTagEqual(stanza, name) {
    if (stanza instanceof Strophe.Builder) {
        return html_isTagEqual(stanza.tree(), name);
    } else if (!(stanza instanceof Element)) {
        throw Error("isTagEqual called with value which isn't " + 'an element or Strophe.Builder instance');
    } else {
        return Strophe.isTagEqual(stanza, name);
    }
}

/**
 * Returns a list of children of the DOM element that match the selector.
 * @method u#queryChildren
 * @param {HTMLElement} el - the DOM element
 * @param {string} selector - the selector they should be matched against
 */
function queryChildren(el, selector) {
    return Array.from(el.childNodes).filter((el) => el instanceof Element && el.matches(selector));
}

/**
 * @param {Element} el - the DOM element
 * @return {number}
 */
function siblingIndex(el) {
    /* eslint-disable no-cond-assign */
    for (var i = 0; (el = el.previousElementSibling); i++);
    return i;
}

// A `<` only opens markup when a tag name, an end tag, a comment or a
// declaration follows it. A `<` followed by anything else (`3 < 5`) is text.
const MARKUP_START = /[a-zA-Z!/?]/;

// The name of a start tag, which runs up to the first whitespace, `/` or `>`.
// An end tag is deliberately not matched: only a start tag opens an element.
const TAG_NAME = /^([a-zA-Z][^\s/>]*)/;

// Elements whose content is raw text rather than markup. They're dropped along
// with their content, as the sanitizer this replaced did, because that content
// was never meant to be read as text. A Map rather than an object, so that a
// tag named after something on `Object.prototype` doesn't look like a match.
const RAW_TEXT_END = new Map([
    ['script', /<\/script/i],
    ['style', /<\/style/i],
]);

/**
 * Returns the index just past the markup construct that starts at `start`,
 * where `html[start]` is the opening `<`.
 *
 * A construct that's never closed swallows the rest of the input, which is what
 * an HTML parser does with a tag still open at the end of a document. That's
 * what keeps a truncated `<script src="x` from surviving into the output, and
 * it's the case a `/<[^>]*>/g` style regex misses.
 * @param {string} html
 * @param {number} start
 * @returns {number}
 */
function endOfMarkup(html, start) {
    if (html.startsWith('<!--', start)) {
        const end = html.indexOf('-->', start + 4);
        return end === -1 ? html.length : end + 3;
    }
    // Scan for the `>` that closes the tag, skipping any inside a quoted
    // attribute value. Quotes count wherever they appear rather than only after
    // an `=`, which can consume a little more than an HTML parser would; that
    // can only ever remove more markup, never leave some behind.
    let quote = '';
    for (let i = start + 1; i < html.length; i++) {
        const c = html[i];
        if (quote) {
            if (c === quote) quote = '';
        } else if (c === '"' || c === "'") {
            quote = c;
        } else if (c === '>') {
            return i + 1;
        }
    }
    return html.length;
}

/**
 * Converts an HTML fragment to the plain text a browser's `textContent` would
 * yield for it, without needing a DOM.
 *
 * The markup is scanned rather than matched with a regular expression, because
 * a tag-shaped regex needs the closing `>` and so leaves an unterminated tag
 * behind. Entities are decoded per text run, once the tags are gone, so that an
 * entity-encoded tag (`&lt;b&gt;`) survives as text, and so that a decoded one
 * can't combine with the text beside it into something tag-shaped.
 * @param {string} html
 * @returns {string}
 */
function htmlToText(html) {
    let text = '';
    let i = 0;
    while (i < html.length) {
        const lt = html.indexOf('<', i);
        if (lt === -1) break;

        if (!MARKUP_START.test(html[lt + 1] ?? '')) {
            // A bare `<`. Keep it as text and carry on after it.
            text += he.decode(html.slice(i, lt + 1));
            i = lt + 1;
            continue;
        }

        text += he.decode(html.slice(i, lt));
        i = endOfMarkup(html, lt);

        const tag = TAG_NAME.exec(html.slice(lt + 1, i))?.[1].toLowerCase();
        const end_tag = RAW_TEXT_END.get(tag);
        if (end_tag) {
            const offset = html.slice(i).search(end_tag);
            i = offset === -1 ? html.length : endOfMarkup(html, i + offset);
        }
    }
    return text + he.decode(html.slice(i));
}

/**
 * Strips tags and decodes HTML entities in `str`, returning plain text.
 * Isomorphic: no DOM is involved, so this works under Node too.
 * @param {string} str
 * @return {string}
 */
function decodeHTMLEntities(str) {
    if (str && typeof str === 'string') {
        return htmlToText(str);
    }
    return str;
}

/**
 * Helper method that replace HTML-escaped symbols with equivalent characters
 * (e.g. transform occurrences of '&amp;' to '&')
 * @param {string} string - a String containing the HTML-escaped symbols.
 * @return {string}
 */
function unescapeHTML(string) {
    return typeof string === 'string' ? he.decode(string) : string;
}

;// CONCATENATED MODULE: ./src/headless/utils/stanza.js







/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isErrorStanza (stanza) {
    if (!isElement(stanza)) {
        return false;
    }
    return stanza.getAttribute('type') === 'error';
}

/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isForbiddenError (stanza) {
    if (!isElement(stanza)) {
        return false;
    }
    return sizzle(`error[type="auth"] forbidden[xmlns="${Strophe.NS.STANZAS}"]`, stanza).length > 0;
}

/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isServiceUnavailableError (stanza) {
    if (!isElement(stanza)) {
        return false;
    }
    return sizzle(`error[type="cancel"] service-unavailable[xmlns="${Strophe.NS.STANZAS}"]`, stanza).length > 0;
}

/**
 * Returns an object containing all attribute names and values for a particular element.
 * @param {Element} stanza
 * @returns {object}
 */
function getAttributes (stanza) {
    return stanza.getAttributeNames().reduce((acc, name) => {
        acc[name] = Strophe.xmlunescape(stanza.getAttribute(name));
        return acc;
    }, {});
}

// EXTERNAL MODULE: ./node_modules/sprintf-js/src/sprintf.js
var sprintf = __webpack_require__(604);
;// CONCATENATED MODULE: ./src/headless/shared/i18n.js


/**
 * @namespace i18n
 */
const i18nStub = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    async initialize () {},

    /**
     * Overridable string wrapper method which can be used to provide i18n
     * support.
     *
     * The default implementation in @converse/headless simply calls sprintf
     * with the passed in arguments.
     *
     * If you install the full version of Converse, then this method gets
     * overwritten in src/i18n/index.js to return a translated string.
     * @method __
     * @private
     * @memberOf i18n
     */
    __ (...args) {
        return (0,sprintf/* .sprintf */.n)(...args);
    }
};

/* export default */ const i18n = (i18nStub);

;// CONCATENATED MODULE: ./node_modules/pluggable.js/src/pluggable.js
/*
       ____  __                        __    __         _
      / __ \/ /_  __ ___   ___  ____ _/ /_  / /__      (_)____
     / /_/ / / / / / __ \/ __ \/ __/ / __ \/ / _ \    / / ___/
    / ____/ / /_/ / /_/ / /_/ / /_/ / /_/ / /  __/   / (__  )
   /_/   /_/\__,_/\__, /\__, /\__/_/_.___/_/\___(_)_/ /____/
                 /____//____/                    /___/
 */

// Pluggable.js lets you to make your Javascript code pluggable while still
// keeping sensitive objects and data private through closures.


// `wrappedOverride` creates a partially applied wrapper function
// that makes sure to set the proper super method when the
// overriding method is called. This is done to enable
// chaining of plugin methods, all the way up to the
// original method.
function wrappedOverride (key, value, super_method, default_super, ...args) {
    if (typeof super_method === "function") {
        if (typeof this.__super__ === "undefined") {
            /* We're not on the context of the plugged object.
             * This can happen when the overridden method is called via
             * an event handler or when it's a constructor.
             *
             * In this case, we simply tack on the  __super__ obj.
             */
            this.__super__ = default_super;
        }
        this.__super__[key] = super_method.bind(this);
    }
    return value.apply(this, args);
}


// The `PluginSocket` class contains the plugin architecture, and gets
// created whenever `pluggable.enable(obj);` is called on the object
// that you want to make pluggable.
// You can also see it as the thing into which the plugins are plugged.
// It takes two parameters, first, the object being made pluggable, and
// then the name by which the pluggable object may be referenced on the
// __super__ object (inside overrides).
class PluginSocket {

    constructor (plugged, name) {
        this.name = name;
        this.plugged = plugged;
        if (typeof this.plugged.__super__ === 'undefined') {
            this.plugged.__super__ = {};
        } else if (typeof this.plugged.__super__ === 'string') {
            this.plugged.__super__ = { '__string__': this.plugged.__super__ };
        }
        this.plugged.__super__[name] = this.plugged;
        this.plugins = {};
        this.initialized_plugins = [];
    }

    // `_overrideAttribute` overrides an attribute on the original object
    // (the thing being plugged into).
    //
    // If the attribute being overridden is a function, then the original
    // function will still be available via the `__super__` attribute.
    //
    // If the same function is being overridden multiple times, then
    // the original function will be available at the end of a chain of
    // functions, starting from the most recent override, all the way
    // back to the original function, each being referenced by the
    // previous' __super__ attribute.
    //
    // For example:
    //
    // `plugin2.MyFunc.__super__.myFunc => plugin1.MyFunc.__super__.myFunc => original.myFunc`
    _overrideAttribute (key, plugin) {
        const value = plugin.overrides[key];
        if (typeof value === "function") {
            const default_super = {};
            default_super[this.name] = this.plugged;
            const super_method = this.plugged[key];
            this.plugged[key] = function (...args) {
                return wrappedOverride.apply(this, [key, value, super_method,  default_super, ...args]);
            }
        } else {
            this.plugged[key] = value;
        }
    }

    _extendObject (obj, attributes) {
        if (!obj.prototype.__super__) {
            obj.prototype.__super__ = {};
            obj.prototype.__super__[this.name] = this.plugged;
        }
        for (const [key, value] of Object.entries(attributes)) {
            if (key === 'events') {
                obj.prototype[key] = Object.assign(value, obj.prototype[key]);
            } else if (typeof value === 'function') {
                // We create a partially applied wrapper function, that
                // makes sure to set the proper super method when the
                // overriding method is called. This is done to enable
                // chaining of plugin methods, all the way up to the
                // original method.
                const default_super = {};
                default_super[this.name] = this.plugged;
                const super_method = obj.prototype[key];
                obj.prototype[key] = function (...args) {
                    return wrappedOverride.apply(this, [key, value, super_method, default_super, ...args]);
                }
            } else {
                obj.prototype[key] = value;
            }
        }
    }

    // Plugins can specify dependencies (by means of the
    // `dependencies` list attribute) which refers to dependencies
    // which will be initialized first, before the plugin itself gets initialized.
    //
    // If `strict_plugin_dependencies` is set to `false` (on the object being
    // made pluggable), then no error will be thrown if any of these plugins aren't
    // available.
    loadPluginDependencies (plugin) {
        plugin.dependencies?.forEach(name => {
            const dep = this.plugins[name];
            if (dep) {
                if (dep.dependencies?.includes(plugin.__name__)) {
                    /* FIXME: circular dependency checking is only one level deep. */
                    throw "Found a circular dependency between the plugins \""+
                        plugin.__name__+"\" and \""+name+"\"";
                }
                this.initializePlugin(dep);
            } else {
                this.throwUndefinedDependencyError(
                    "Could not find dependency \""+name+"\" "+
                    "for the plugin \""+plugin.__name__+"\". "+
                    "If it's needed, make sure it's loaded by require.js");
            }
        });
    }

    throwUndefinedDependencyError (msg) {
        if (this.plugged.strict_plugin_dependencies) {
            throw msg;
        } else {
            if (console.warn) {
                console.warn(msg);
            } else {
                console.log(msg);
            }
        }
    }

    // `applyOverrides` is called by initializePlugin. It applies any
    // and all overrides of methods or Backbone views and models that
    // are defined on any of the plugins.
    applyOverrides (plugin) {
        Object.keys(plugin.overrides || {}).forEach(key => {
            const override = plugin.overrides[key];
            if (typeof override === "object") {
                if (typeof this.plugged[key] === 'undefined') {
                    this.throwUndefinedDependencyError(
                        `Plugin "${plugin.__name__}" tried to override "${key}" but it's not found.`);
                } else {
                    this._extendObject(this.plugged[key], override);
                }
            } else {
                this._overrideAttribute(key, plugin);
            }
        });
    }

    // `initializePlugin` applies the overrides (if any) defined on all
    // the registered plugins and then calls the initialize method of the plugin
    initializePlugin (plugin) {
        if (!Object.keys(this.allowed_plugins).includes(plugin.__name__)) {
            /* Don't initialize disallowed plugins. */
            return;
        }
        if (this.initialized_plugins.includes(plugin.__name__)) {
            /* Don't initialize plugins twice, otherwise we get
            * infinite recursion in overridden methods.
            */
            return;
        }
        if (typeof plugin.enabled === 'boolean' && plugin.enabled ||
            plugin.enabled?.(this.plugged) ||
            plugin.enabled == null) { // isNil

            Object.assign(plugin, this.properties);
            if (plugin.dependencies) {
                this.loadPluginDependencies(plugin);
            }
            this.applyOverrides(plugin);
            if (typeof plugin.initialize === "function") {
                plugin.initialize.bind(plugin)(this);
            }
            this.initialized_plugins.push(plugin.__name__);
        }
    }

    // `registerPlugin` registers (or inserts, if you'd like) a plugin,
    // by adding it to the `plugins` map on the PluginSocket instance.
    registerPlugin (name, plugin) {
        if (name in this.plugins) {
            throw new Error('Error: Plugin name '+name+' is already taken');
        }
        plugin.__name__ = name;
        this.plugins[name] = plugin;
    }

    // `initializePlugins` should get called once all plugins have been
    // registered. It will then iterate through all the plugins, calling
    // `initializePlugin` for each.
    // The passed in  properties variable is an object with attributes and methods
    // which will be attached to the plugins.
    initializePlugins (properties={}, whitelist=[], blacklist=[]) {
        if (!Object.keys(this.plugins).length) {
            return;
        }
        this.properties = properties;
        this.allowed_plugins = {};

        for (const [key, plugin] of Object.entries(this.plugins)) {
            if ((!whitelist.length || whitelist.includes(key)) && !blacklist.includes(key)) {
                this.allowed_plugins[key] = plugin;
            }
        }
        Object.values(this.allowed_plugins).forEach(o => this.initializePlugin(o));
    }
}

function enable (object, name, attrname) {
    // Call the `enable` method to make an object pluggable
    //
    // It takes three parameters:
    // - `object`: The object that gets made pluggable.
    // - `name`: The string name by which the now pluggable object
    //     may be referenced on the __super__ obj (in overrides).
    //     The default value is "plugged".
    // - `attrname`: The string name of the attribute on the now
    //     pluggable object, which refers to the PluginSocket instance
    //     that gets created.
    if (typeof attrname === "undefined") {
        attrname = "pluginSocket";
    }
    if (typeof name === 'undefined') {
        name = 'plugged';
    }
    object[attrname] = new PluginSocket(object, name);
    return object;
}


/* export default */ const src_pluggable = ({
    enable
});

;// CONCATENATED MODULE: ./node_modules/@converse/skeletor/dist/skeletor.esm.js
/** Used for built-in method references. */
var objectProto$m = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$m;

  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$l = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$i = objectProto$l.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$i.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$h = objectProto$k.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$k.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$h.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$2.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$j = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$j.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root$1['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$i = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$i.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$g).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var DataView = getNative(root$1, 'DataView');

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root$1, 'Map');

/* Built-in method references that are verified to be native. */
var skeletor_esm_Promise$1 = getNative(root$1, 'Promise');

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root$1, 'Set');

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root$1, 'WeakMap');

/** `Object#toString` result references. */
var mapTag$6 = '[object Map]',
    objectTag$4 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$6 = '[object Set]',
    weakMapTag$2 = '[object WeakMap]';

var dataViewTag$4 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(skeletor_esm_Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$4) ||
    (Map$1 && getTag(new Map$1) != mapTag$6) ||
    (skeletor_esm_Promise$1 && getTag(skeletor_esm_Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag(new Set$1) != setTag$6) ||
    (WeakMap$1 && getTag(new WeakMap$1) != weakMapTag$2)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$4 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$4;
        case mapCtorString: return mapTag$6;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$6;
        case weakMapCtorString: return weakMapTag$2;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$h.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$h.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$f.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var skeletor_esm_isArray = Array.isArray;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$3] =
typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] =
typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] =
typedArrayTags[setTag$5] = typedArrayTags[stringTag$4] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
    setTag$4 = '[object Set]';

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$g.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (skeletor_esm_isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag$4 || tag == setTag$4) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$e.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = skeletor_esm_isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$d.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function skeletor_esm_keys$2(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag$3);
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (skeletor_esm_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function skeletor_esm_toString$1(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return skeletor_esm_toString$1(prefix) + id;
}

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$1(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function skeletor_esm_before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return skeletor_esm_before(2, func);
}

// Regular expression used to split event strings.
const eventSplitter = /\s+/;
/**
 * Iterates over the standard `event, callback` (as well as the fancy multiple
 * space-separated events `"change blur", callback` and jQuery-style event
 * maps `{event: callback}`).
 */
function eventsApi(iteratee, events, name, callback, opts) {
    let i = 0;
    let names;
    if (name && typeof name === 'object') {
        // Handle event maps.
        if (callback !== undefined && 'context' in opts && opts.context === undefined) {
            opts.context = callback;
        }
        for (names = Object.keys(name); i < names.length; i++) {
            events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
        }
    }
    else if (name && typeof name === 'string' && eventSplitter.test(name)) {
        // Handle space-separated event names by delegating them individually.
        for (names = name.split(eventSplitter); i < names.length; i++) {
            const result = iteratee(events, names[i], callback, opts);
            if (result !== undefined) {
                events = result;
            }
        }
    }
    else {
        // Finally, standard events.
        events = iteratee(events, name, callback, opts);
    }
    return events;
}
/**
 * A reducer that adds a callback to the `events` object.
 */
function onApi(events, name, callback, options) {
    if (callback) {
        const handlers = events[name] || (events[name] = []);
        const context = options.context;
        const ctx = options.ctx;
        const listening = options.listening;
        if (listening)
            listening.count++;
        handlers.push({ callback, context, ctx: context || ctx, listening });
    }
    return events;
}
/**
 * An try-catch guarded #on function, to prevent poisoning the global
 * `_listening` variable.
 */
function tryCatchOn(obj, name, callback, context) {
    try {
        obj.on(name, callback, context);
    }
    catch (e) {
        return e;
    }
}
/**
 * The reducing API that removes a callback from the `events` object.
 */
function offApi(events, name, callback, options) {
    if (!events)
        return;
    const context = options.context;
    const listeners = options.listeners;
    let i = 0;
    let names;
    // Delete all event listeners and "drop" events.
    if (!name && !context && !callback) {
        if (listeners) {
            for (names = Object.keys(listeners); i < names.length; i++) {
                listeners[names[i]].cleanup();
            }
        }
        return;
    }
    names = name ? [name] : Object.keys(events);
    for (; i < names.length; i++) {
        const currentName = names[i];
        const handlers = events[currentName];
        // Bail out if there are no events stored.
        if (!handlers) {
            continue;
        }
        // Find any remaining events.
        const remaining = [];
        for (let j = 0; j < handlers.length; j++) {
            const handler = handlers[j];
            if ((callback && callback !== handler.callback && callback !== handler.callback._callback) ||
                (context && context !== handler.context)) {
                remaining.push(handler);
            }
            else {
                const listening = handler.listening;
                if (listening)
                    listening.stop(currentName, callback);
            }
        }
        // Replace events if there are any remaining.  Otherwise, clean up.
        if (remaining.length) {
            events[currentName] = remaining;
        }
        else {
            delete events[currentName];
        }
    }
    return events;
}
/**
 * Reduces the event callbacks into a map of `{event: onceWrapper}`.
 * `offer` unbinds the `onceWrapper` after it has been called.
 */
function onceMap(map, name, callback, offer) {
    if (callback) {
        const _once = once(function (...args) {
            offer(name, _once);
            callback.apply(this, args);
        });
        map[name] = _once;
        _once._callback = callback;
    }
    return map;
}
/** Handles triggering the appropriate event callbacks. */
function triggerApi(objEvents, name, _callback, args) {
    if (objEvents) {
        const events = objEvents[name];
        let allEvents = objEvents.all;
        if (events && allEvents)
            allEvents = allEvents.slice();
        if (events)
            triggerEvents(events, args);
        if (allEvents)
            triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
}
/**
 * A difficult-to-believe, but optimized internal dispatch function for
 * triggering events. Tries to keep the usual cases speedy (most internal
 * Backbone events have 3 arguments).
 */
function triggerEvents(events, args) {
    let ev;
    let i = -1;
    const l = events.length;
    const a1 = args[0];
    const a2 = args[1];
    const a3 = args[2];
    switch (args.length) {
        case 0:
            while (++i < l)
                (ev = events[i]).callback.call(ev.ctx);
            return;
        case 1:
            while (++i < l)
                (ev = events[i]).callback.call(ev.ctx, a1);
            return;
        case 2:
            while (++i < l)
                (ev = events[i]).callback.call(ev.ctx, a1, a2);
            return;
        case 3:
            while (++i < l)
                (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
            return;
        default:
            while (++i < l)
                (ev = events[i]).callback.apply(ev.ctx, args);
            return;
    }
}

/**
 * A listening class that tracks and cleans up memory bindings
 * when all callbacks have been offed.
 */
class Listening {
    constructor(listener, obj) {
        this.id = listener._listenId;
        this.listener = listener;
        this.obj = obj;
        this.interop = true;
        this.count = 0;
        this._events = undefined;
    }
    start(name, callback, context, _listening) {
        const options = {
            context: this.obj,
            ctx: context,
            listening: _listening,
        };
        this._events = eventsApi(onApi, this._events || {}, name, callback, options);
        if (_listening) {
            const listeners = this.obj._listeners || (this.obj._listeners = {});
            listeners[this.id] = this;
            // Allow the listening to use a counter, instead of tracking
            // callbacks for library interop
            this.interop = false;
        }
        return this;
    }
    /**
     * Stop's listening to a callback (or several).
     * Uses an optimized counter if the listenee uses Backbone.Events.
     * Otherwise, falls back to manual tracking to support events
     * library interop.
     */
    stop(name, callback) {
        let cleanup;
        if (this.interop) {
            this._events = eventsApi(offApi, this._events, name, callback, {
                context: undefined,
                listeners: undefined,
            });
            cleanup = !this._events;
        }
        else {
            this.count--;
            cleanup = this.count === 0;
        }
        if (cleanup)
            this.cleanup();
    }
    /**
     * Cleans up memory bindings between the listener and the listenee.
     */
    cleanup() {
        if (this.listener._listeningTo) {
            delete this.listener._listeningTo[this.obj._listenId];
        }
        if (!this.interop && this.obj._listeners) {
            delete this.obj._listeners[this.id];
        }
    }
}

/**
 * @copyright 2010-2019 Jeremy Ashkenas and DocumentCloud
 * @copyright 2023 JC Brand
 */
// A private global variable to share between listeners and listenees.
let skeletor_esm_listening;
/**
 * @public
 */
function skeletor_esm_EventEmitter(Base) {
    return class EventEmitter extends Base {
        /**
         * Bind an event to a `callback` function. Passing `"all"` will bind
         * the callback to all events fired.
         */
        on(name, callback, context) {
            this._events = eventsApi(onApi, this._events || {}, name, callback, {
                context: context,
                ctx: this,
                listening: skeletor_esm_listening,
            });
            if (skeletor_esm_listening) {
                const listeners = this._listeners || (this._listeners = {});
                listeners[skeletor_esm_listening.id] = skeletor_esm_listening;
                // Allow the listening to use a counter, instead of tracking
                // callbacks for library interop
                skeletor_esm_listening.interop = false;
            }
            return this;
        }
        /**
         * Inversion-of-control versions of `on`. Tell *this* object to listen to
         * an event in another object... keeping track of what it's listening to
         * for easier unbinding later.
         */
        listenTo(obj, name, callback) {
            if (!obj)
                return this;
            const id = obj._listenId || (obj._listenId = uniqueId('l'));
            const listeningTo = this._listeningTo || (this._listeningTo = {});
            let listening = (skeletor_esm_listening = listeningTo[id]);
            // This object is not listening to any other events on `obj` yet.
            // Setup the necessary references to track the listening callbacks.
            if (!listening) {
                this._listenId || (this._listenId = uniqueId('l'));
                listening = skeletor_esm_listening = listeningTo[id] = new Listening(this, obj);
            }
            // Bind callbacks on obj.
            const error = tryCatchOn(obj, name, callback, this);
            skeletor_esm_listening = undefined;
            if (error)
                throw error;
            // If the target obj is not Backbone.Events, track events manually.
            if (listening.interop)
                listening.start(name, callback, this, skeletor_esm_listening);
            return this;
        }
        /**
         * Remove one or many callbacks. If `context` is null, removes all
         * callbacks with that function. If `callback` is null, removes all
         * callbacks for the event. If `name` is null, removes all bound
         * callbacks for all events.
         */
        off(name, callback, context) {
            if (!this._events)
                return this;
            this._events = eventsApi(offApi, this._events, name, callback, {
                context: context,
                listeners: this._listeners,
            });
            return this;
        }
        /**
         * Tell this object to stop listening to either specific events ... or
         * to every object it's currently listening to.
         */
        stopListening(obj, name, callback) {
            const listeningTo = this._listeningTo;
            if (!listeningTo)
                return this;
            const ids = obj ? [obj._listenId] : skeletor_esm_keys$2(listeningTo);
            for (let i = 0; i < ids.length; i++) {
                const listening = listeningTo[ids[i]];
                // If listening doesn't exist, this object is not currently
                // listening to obj. Break out early.
                if (!listening)
                    break;
                listening.obj.off(name, callback, this);
                if (listening.interop)
                    listening.stop(name, callback);
            }
            if (isEmpty(listeningTo))
                this._listeningTo = undefined;
            return this;
        }
        /**
         * Bind an event to only be triggered a single time. After the first time
         * the callback is invoked, its listener will be removed. If multiple events
         * are passed in using the space-separated syntax, the handler will fire
         * once for each event, not once for a combination of all events.
         */
        once(name, callback, context) {
            // Map the event into a `{event: once}` object.
            const events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
            if (typeof name === 'string' && (context === null || context === undefined))
                callback = undefined;
            return this.on(events, callback, context);
        }
        /**
         * Inversion-of-control versions of `once`.
         */
        listenToOnce(obj, name, callback) {
            // Map the event into a `{event: once}` object.
            const events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
            return this.listenTo(obj, events);
        }
        /**
         * Trigger one or many events, firing all bound callbacks. Callbacks are
         * passed the same arguments as `trigger` is, apart from the event name
         * (unless you're listening on `"all"`, which will cause your callback to
         * receive the true name of the event as the first argument).
         */
        trigger(name, ...args) {
            if (!this._events)
                return this;
            eventsApi(triggerApi, this._events, name, undefined, args);
            return this;
        }
        /**
         * Subscribe to an event. Returns an unsubscribe function.
         * Compatible with `useSyncExternalStore` and other store-style APIs.
         */
        subscribe(event, callback, context) {
            this.on(event, callback, context);
            return () => this.off(event, callback, context);
        }
    };
}
/**
 * @public
 */
const EventEmitterObject = skeletor_esm_EventEmitter(Object);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function skeletor_esm_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function skeletor_esm_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/*!
MIT License

Copyright (c) 2018 Arturas Molcanovas <a.molcanovas@gmail.com>

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/


/**
 * Abstracts constructing a Blob object, so it also works in older
 * browsers that don't support the native Blob constructor. (i.e.
 * old QtWebKit versions, at least).
 * Abstracts constructing a Blob object, so it also works in older
 * browsers that don't support the native Blob constructor. (i.e.
 * old QtWebKit versions, at least).
 *
 * @param parts
 * @param properties
 */
function skeletor_esm_createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    }
    catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        //tslint:disable-next-line:variable-name
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder
            : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder
                : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder
                    : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

var skeletor_esm_BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
var skeletor_esm_SERIALIZED_MARKER_LENGTH = "__lfsc__:" /* SERIALIZED_MARKER */.length;
var skeletor_esm_TYPE_SERIALIZED_MARKER_LENGTH = skeletor_esm_SERIALIZED_MARKER_LENGTH + "arbf" /* TYPE_ARRAYBUFFER */.length;
//tslint:disable:no-magic-numbers no-bitwise prefer-switch no-unbound-method
var skeletor_esm_toString = Object.prototype.toString;
function skeletor_esm_stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }
    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);
    for (var i = 0, p = 0; i < len; i += 4) {
        var encoded1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */.indexOf(serializedString[i]);
        var encoded2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */.indexOf(serializedString[i + 1]);
        var encoded3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */.indexOf(serializedString[i + 2]);
        var encoded4 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */.indexOf(serializedString[i + 3]);
        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }
    return buffer;
}
/**
 * Converts a buffer to a string to store, serialized, in the backend
 * storage library.
 */
function skeletor_esm_bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    for (var i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */[bytes[i] >> 2];
        base64String += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64String +=
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64String += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" /* BASE_CHARS */[bytes[i + 2] & 63];
    }
    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    }
    else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }
    return base64String;
}
/**
 * Serialize a value, afterwards executing a callback (which usually
 * instructs the `setItem()` callback/promise to be executed). This is how
 * we store binary data with localStorage.
 * @param value
 * @param callback
 */
function serialize$1(value, callback) {
    var valueType = '';
    if (value) {
        valueType = skeletor_esm_toString.call(value);
    }
    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    if (value && (valueType === '[object ArrayBuffer]' ||
        (value.buffer && skeletor_esm_toString.call(value.buffer) === '[object ArrayBuffer]'))) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer = void 0;
        var marker = "__lfsc__:" /* SERIALIZED_MARKER */;
        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += "arbf" /* TYPE_ARRAYBUFFER */;
        }
        else {
            buffer = value.buffer;
            if (valueType === '[object Int8Array]') {
                marker += "si08" /* TYPE_INT8ARRAY */;
            }
            else if (valueType === '[object Uint8Array]') {
                marker += "ui08" /* TYPE_UINT8ARRAY */;
            }
            else if (valueType === '[object Uint8ClampedArray]') {
                marker += "uic8" /* TYPE_UINT8CLAMPEDARRAY */;
            }
            else if (valueType === '[object Int16Array]') {
                marker += "si16" /* TYPE_INT16ARRAY */;
            }
            else if (valueType === '[object Uint16Array]') {
                marker += "ur16" /* TYPE_UINT16ARRAY */;
            }
            else if (valueType === '[object Int32Array]') {
                marker += "si32" /* TYPE_INT32ARRAY */;
            }
            else if (valueType === '[object Uint32Array]') {
                marker += "ui32" /* TYPE_UINT32ARRAY */;
            }
            else if (valueType === '[object Float32Array]') {
                marker += "fl32" /* TYPE_FLOAT32ARRAY */;
            }
            else if (valueType === '[object Float64Array]') {
                marker += "fl64" /* TYPE_FLOAT64ARRAY */;
            }
            else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }
        callback(marker + skeletor_esm_bufferToString(buffer));
    }
    else if (valueType === '[object Blob]') {
        // Convert the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();
        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            //tslint:disable-next-line:restrict-plus-operands
            var str = "~~local_forage_type~" /* BLOB_TYPE_PREFIX */ + value.type + "~" + skeletor_esm_bufferToString(this.result);
            callback("__lfsc__:" /* SERIALIZED_MARKER */ + "blob" /* TYPE_BLOB */ + str);
        };
        fileReader.readAsArrayBuffer(value);
    }
    else {
        try {
            callback(JSON.stringify(value));
        }
        catch (e) {
            console.error('Couldn\'t convert value into a JSON string: ', value);
            callback(null, e);
        }
    }
}
/**
 * Deserialize data we've inserted into a value column/field. We place
 * special markers into our strings to mark them as encoded; this isn't
 * as nice as a meta field, but it's the only sane thing we can do whilst
 * keeping localStorage support intact.
 *
 * Oftentimes this will just deserialize JSON content, but if we have a
 * special marker (SERIALIZED_MARKER, defined above), we will extract
 * some kind of arraybuffer/binary data/typed array out of the string.
 * @param value
 */
function deserialize$1(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, skeletor_esm_SERIALIZED_MARKER_LENGTH) !== "__lfsc__:" /* SERIALIZED_MARKER */) {
        return JSON.parse(value);
    }
    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(skeletor_esm_TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(skeletor_esm_SERIALIZED_MARKER_LENGTH, skeletor_esm_TYPE_SERIALIZED_MARKER_LENGTH);
    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === "blob" /* TYPE_BLOB */ && skeletor_esm_BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(skeletor_esm_BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = skeletor_esm_stringToBuffer(serializedString);
    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case "arbf" /* TYPE_ARRAYBUFFER */:
            return buffer;
        case "blob" /* TYPE_BLOB */:
            return skeletor_esm_createBlob([buffer], { type: blobType });
        case "si08" /* TYPE_INT8ARRAY */:
            return new Int8Array(buffer);
        case "ui08" /* TYPE_UINT8ARRAY */:
            return new Uint8Array(buffer);
        case "uic8" /* TYPE_UINT8CLAMPEDARRAY */:
            return new Uint8ClampedArray(buffer);
        case "si16" /* TYPE_INT16ARRAY */:
            return new Int16Array(buffer);
        case "ur16" /* TYPE_UINT16ARRAY */:
            return new Uint16Array(buffer);
        case "si32" /* TYPE_INT32ARRAY */:
            return new Int32Array(buffer);
        case "ui32" /* TYPE_UINT32ARRAY */:
            return new Uint32Array(buffer);
        case "fl32" /* TYPE_FLOAT32ARRAY */:
            return new Float32Array(buffer);
        case "fl64" /* TYPE_FLOAT64ARRAY */:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

function clone$1(obj) {
    var e_1, _a;
    if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj) {
        return obj;
    }
    var temp = obj instanceof Date ? new Date(obj) : (obj.constructor());
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                obj['isActiveClone'] = null;
                temp[key] = clone$1(obj[key]);
                delete obj['isActiveClone'];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return temp;
}

function getKeyPrefix(options, defaultConfig) {
    return (options.name || defaultConfig.name) + "/" + (options.storeName || defaultConfig.storeName) + "/";
}

function skeletor_esm_executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function getCallback$1() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

//tslint:disable-next-line:no-ignored-initial-value
function dropInstanceCommon(options, callback) {
    var _this = this;
    callback = getCallback$1.apply(this, arguments);
    options = (typeof options !== 'function' && options) || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }
    var promise;
    if (!options.name) {
        promise = Promise.reject('Invalid arguments');
    }
    else {
        promise = new Promise(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + "/");
            }
            else {
                resolve(getKeyPrefix(options, _this._defaultConfig));
            }
        });
    }
    return { promise: promise, callback: callback };
}

function normaliseKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + " used as a key, but it is not a string.");
        key = String(key);
    }
    return key;
}

var serialiser = {
    bufferToString: skeletor_esm_bufferToString,
    deserialize: deserialize$1,
    serialize: serialize$1,
    stringToBuffer: skeletor_esm_stringToBuffer
};

/*!
MIT License

Copyright (c) 2018 Arturas Molcanovas <a.molcanovas@gmail.com>

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/


var _driver = 'localforage-driver-memory';

var stores = {};
/** @internal */
var skeletor_esm_Store = /** @class */ (function () {
    function Store(kp) {
        this.kp = kp;
        this.data = {};
    }
    Store.resolve = function (kp) {
        if (!stores[kp]) {
            stores[kp] = new Store(kp);
        }
        return stores[kp];
    };
    Store.prototype.clear = function () {
        this.data = {};
    };
    Store.prototype.drop = function () {
        this.clear();
        delete stores[this.kp];
    };
    Store.prototype.get = function (key) {
        return this.data[key];
    };
    Store.prototype.key = function (idx) {
        return this.keys()[idx];
    };
    Store.prototype.keys = function () {
        return Object.keys(this.data);
    };
    Store.prototype.rm = function (k) {
        delete this.data[k];
    };
    Store.prototype.set = function (k, v) {
        this.data[k] = v;
    };
    return Store;
}());

function skeletor_esm_initStorage$1(options) {
    var opts = options ? clone$1(options) : {};
    var kp = getKeyPrefix(opts, this._defaultConfig);
    var store = skeletor_esm_Store.resolve(kp);
    this._dbInfo = opts;
    this._dbInfo.serializer = serialiser;
    this._dbInfo.keyPrefix = kp;
    this._dbInfo.mStore = store;
    return Promise.resolve();
}

function skeletor_esm_clear$1(callback) {
    var _this = this;
    var promise = this.ready().then(function () {
        _this._dbInfo.mStore.clear();
    });
    skeletor_esm_executeCallback(promise, callback);
    return promise;
}

function skeletor_esm_dropInstance$1(_options, _cb) {
    var _a = dropInstanceCommon.apply(this, arguments), promise = _a.promise, callback = _a.callback;
    var outPromise = promise.then(function (keyPrefix) {
        skeletor_esm_Store.resolve(keyPrefix).drop();
    });
    skeletor_esm_executeCallback(outPromise, callback);
    return promise;
}

function skeletor_esm_getItem$1(key$, callback) {
    var _this = this;
    key$ = normaliseKey(key$);
    var promise = this.ready().then(function () {
        var result = _this._dbInfo.mStore.get(key$);
        // Deserialise if the result is not null or undefined
        return result == null ? null : _this._dbInfo.serializer.deserialize(result); //tslint:disable-line:triple-equals
    });
    skeletor_esm_executeCallback(promise, callback);
    return promise;
}

function skeletor_esm_iterate$1(iterator, callback) {
    var _this = this;
    var promise = this.ready().then(function () {
        var store = _this._dbInfo.mStore;
        var keys = store.keys();
        for (var i = 0; i < keys.length; i++) {
            var value = store.get(keys[i]);
            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = _this._dbInfo.serializer.deserialize(value);
            }
            value = iterator(value, keys[i], i + 1);
            if (value !== undefined) {
                return value;
            }
        }
    });
    skeletor_esm_executeCallback(promise, callback);
    return promise;
}

function skeletor_esm_key$1(idx, callback) {
    var _this = this;
    var promise = this.ready().then(function () {
        var result;
        try {
            result = _this._dbInfo.mStore.key(idx);
            if (result === undefined) {
                result = null;
            }
        }
        catch (_a) {
            result = null;
        }
        return result;
    });
    skeletor_esm_executeCallback(promise, callback);
    return promise;
}

function skeletor_esm_keys$1(callback) {
    var _this = this;
    var promise = this.ready().then(function () {
        return _this._dbInfo.mStore.keys();
    });
    skeletor_esm_executeCallback(promise, callback);
    return promise;
}

function skeletor_esm_length$1(callback) {
    var promise = this.keys().then(function (keys$) { return keys$.length; });
    skeletor_esm_executeCallback(promise, callback);
    return promise;
}

function skeletor_esm_removeItem$1(key$, callback) {
    var _this = this;
    key$ = normaliseKey(key$);
    var promise = this.ready().then(function () {
        _this._dbInfo.mStore.rm(key$);
    });
    skeletor_esm_executeCallback(promise, callback);
    return promise;
}

function skeletor_esm_setItem$1(key$, value, callback) {
    var _this = this;
    key$ = normaliseKey(key$);
    var promise = this.ready().then(function () {
        if (value === undefined) {
            value = null;
        }
        // Save the original value to pass to the callback.
        var originalValue = value;
        return new Promise(function (resolve, reject) {
            _this._dbInfo.serializer.serialize(value, function (value$, error) {
                if (error) {
                    reject(error);
                }
                else {
                    try {
                        _this._dbInfo.mStore.set(key$, value$);
                        resolve(originalValue);
                    }
                    catch (e) {
                        reject(e);
                    }
                }
            });
        });
    });
    skeletor_esm_executeCallback(promise, callback);
    return promise;
}

var _support = true;

var memoryDriver = /*#__PURE__*/Object.freeze({
  __proto__: null,
  _driver: _driver,
  _initStorage: skeletor_esm_initStorage$1,
  _support: _support,
  clear: skeletor_esm_clear$1,
  dropInstance: skeletor_esm_dropInstance$1,
  getItem: skeletor_esm_getItem$1,
  iterate: skeletor_esm_iterate$1,
  key: skeletor_esm_key$1,
  keys: skeletor_esm_keys$1,
  length: skeletor_esm_length$1,
  removeItem: skeletor_esm_removeItem$1,
  setItem: skeletor_esm_setItem$1
});

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty$b.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$a.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, skeletor_esm_keys$2(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$9.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root$1.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$a.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return skeletor_esm_isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, skeletor_esm_keys$2, getSymbols);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$8.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array$1 = root$1.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);

    case dataViewTag$2:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor;

    case numberTag$2:
    case stringTag$3:
      return new Ctor(object);

    case regexpTag$2:
      return cloneRegExp(object);

    case setTag$3:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag$2;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

/** `Object#toString` result references. */
var setTag$2 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag$2;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$3 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$3 = 4;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] =
cloneableTags[boolTag$1] = cloneableTags[dateTag$1] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag$1] =
cloneableTags[numberTag$1] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$1] = cloneableTags[setTag$1] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$3,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$3;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = skeletor_esm_isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$1 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : skeletor_esm_keys$2);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$2 = 1,
    CLONE_SYMBOLS_FLAG$2 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG$2 | CLONE_SYMBOLS_FLAG$2);
}

/** `Object#toString` result references. */
var stringTag$1 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!skeletor_esm_isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag$1);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var skeletor_esm_localforage = {exports: {}};

/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/

var hasRequiredLocalforage;

function requireLocalforage () {
	if (hasRequiredLocalforage) return skeletor_esm_localforage.exports;
	hasRequiredLocalforage = 1;
	(function (module, exports) {
		(function(f){{module.exports=f();}})(function(){return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof commonjsRequire=="function"&&commonjsRequire;if(!u&&a)return a(o,true);if(i)return i(o,true);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r);}return n[o].exports}var i=typeof commonjsRequire=="function"&&commonjsRequire;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
		(function (global){
		var Mutation = global.MutationObserver || global.WebKitMutationObserver;

		var scheduleDrain;

		{
		  if (Mutation) {
		    var called = 0;
		    var observer = new Mutation(nextTick);
		    var element = global.document.createTextNode('');
		    observer.observe(element, {
		      characterData: true
		    });
		    scheduleDrain = function () {
		      element.data = (called = ++called % 2);
		    };
		  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
		    var channel = new global.MessageChannel();
		    channel.port1.onmessage = nextTick;
		    scheduleDrain = function () {
		      channel.port2.postMessage(0);
		    };
		  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
		    scheduleDrain = function () {

		      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
		      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
		      var scriptEl = global.document.createElement('script');
		      scriptEl.onreadystatechange = function () {
		        nextTick();

		        scriptEl.onreadystatechange = null;
		        scriptEl.parentNode.removeChild(scriptEl);
		        scriptEl = null;
		      };
		      global.document.documentElement.appendChild(scriptEl);
		    };
		  } else {
		    scheduleDrain = function () {
		      setTimeout(nextTick, 0);
		    };
		  }
		}

		var draining;
		var queue = [];
		//named nextTick for less confusing stack traces
		function nextTick() {
		  draining = true;
		  var i, oldQueue;
		  var len = queue.length;
		  while (len) {
		    oldQueue = queue;
		    queue = [];
		    i = -1;
		    while (++i < len) {
		      oldQueue[i]();
		    }
		    len = queue.length;
		  }
		  draining = false;
		}

		module.exports = immediate;
		function immediate(task) {
		  if (queue.push(task) === 1 && !draining) {
		    scheduleDrain();
		  }
		}

		}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
		},{}],2:[function(_dereq_,module,exports){
		var immediate = _dereq_(1);

		/* istanbul ignore next */
		function INTERNAL() {}

		var handlers = {};

		var REJECTED = ['REJECTED'];
		var FULFILLED = ['FULFILLED'];
		var PENDING = ['PENDING'];

		module.exports = Promise;

		function Promise(resolver) {
		  if (typeof resolver !== 'function') {
		    throw new TypeError('resolver must be a function');
		  }
		  this.state = PENDING;
		  this.queue = [];
		  this.outcome = void 0;
		  if (resolver !== INTERNAL) {
		    safelyResolveThenable(this, resolver);
		  }
		}

		Promise.prototype["catch"] = function (onRejected) {
		  return this.then(null, onRejected);
		};
		Promise.prototype.then = function (onFulfilled, onRejected) {
		  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
		    typeof onRejected !== 'function' && this.state === REJECTED) {
		    return this;
		  }
		  var promise = new this.constructor(INTERNAL);
		  if (this.state !== PENDING) {
		    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
		    unwrap(promise, resolver, this.outcome);
		  } else {
		    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
		  }

		  return promise;
		};
		function QueueItem(promise, onFulfilled, onRejected) {
		  this.promise = promise;
		  if (typeof onFulfilled === 'function') {
		    this.onFulfilled = onFulfilled;
		    this.callFulfilled = this.otherCallFulfilled;
		  }
		  if (typeof onRejected === 'function') {
		    this.onRejected = onRejected;
		    this.callRejected = this.otherCallRejected;
		  }
		}
		QueueItem.prototype.callFulfilled = function (value) {
		  handlers.resolve(this.promise, value);
		};
		QueueItem.prototype.otherCallFulfilled = function (value) {
		  unwrap(this.promise, this.onFulfilled, value);
		};
		QueueItem.prototype.callRejected = function (value) {
		  handlers.reject(this.promise, value);
		};
		QueueItem.prototype.otherCallRejected = function (value) {
		  unwrap(this.promise, this.onRejected, value);
		};

		function unwrap(promise, func, value) {
		  immediate(function () {
		    var returnValue;
		    try {
		      returnValue = func(value);
		    } catch (e) {
		      return handlers.reject(promise, e);
		    }
		    if (returnValue === promise) {
		      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
		    } else {
		      handlers.resolve(promise, returnValue);
		    }
		  });
		}

		handlers.resolve = function (self, value) {
		  var result = tryCatch(getThen, value);
		  if (result.status === 'error') {
		    return handlers.reject(self, result.value);
		  }
		  var thenable = result.value;

		  if (thenable) {
		    safelyResolveThenable(self, thenable);
		  } else {
		    self.state = FULFILLED;
		    self.outcome = value;
		    var i = -1;
		    var len = self.queue.length;
		    while (++i < len) {
		      self.queue[i].callFulfilled(value);
		    }
		  }
		  return self;
		};
		handlers.reject = function (self, error) {
		  self.state = REJECTED;
		  self.outcome = error;
		  var i = -1;
		  var len = self.queue.length;
		  while (++i < len) {
		    self.queue[i].callRejected(error);
		  }
		  return self;
		};

		function getThen(obj) {
		  // Make sure we only access the accessor once as required by the spec
		  var then = obj && obj.then;
		  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
		    return function appyThen() {
		      then.apply(obj, arguments);
		    };
		  }
		}

		function safelyResolveThenable(self, thenable) {
		  // Either fulfill, reject or reject with error
		  var called = false;
		  function onError(value) {
		    if (called) {
		      return;
		    }
		    called = true;
		    handlers.reject(self, value);
		  }

		  function onSuccess(value) {
		    if (called) {
		      return;
		    }
		    called = true;
		    handlers.resolve(self, value);
		  }

		  function tryToUnwrap() {
		    thenable(onSuccess, onError);
		  }

		  var result = tryCatch(tryToUnwrap);
		  if (result.status === 'error') {
		    onError(result.value);
		  }
		}

		function tryCatch(func, value) {
		  var out = {};
		  try {
		    out.value = func(value);
		    out.status = 'success';
		  } catch (e) {
		    out.status = 'error';
		    out.value = e;
		  }
		  return out;
		}

		Promise.resolve = resolve;
		function resolve(value) {
		  if (value instanceof this) {
		    return value;
		  }
		  return handlers.resolve(new this(INTERNAL), value);
		}

		Promise.reject = reject;
		function reject(reason) {
		  var promise = new this(INTERNAL);
		  return handlers.reject(promise, reason);
		}

		Promise.all = all;
		function all(iterable) {
		  var self = this;
		  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
		    return this.reject(new TypeError('must be an array'));
		  }

		  var len = iterable.length;
		  var called = false;
		  if (!len) {
		    return this.resolve([]);
		  }

		  var values = new Array(len);
		  var resolved = 0;
		  var i = -1;
		  var promise = new this(INTERNAL);

		  while (++i < len) {
		    allResolver(iterable[i], i);
		  }
		  return promise;
		  function allResolver(value, i) {
		    self.resolve(value).then(resolveFromAll, function (error) {
		      if (!called) {
		        called = true;
		        handlers.reject(promise, error);
		      }
		    });
		    function resolveFromAll(outValue) {
		      values[i] = outValue;
		      if (++resolved === len && !called) {
		        called = true;
		        handlers.resolve(promise, values);
		      }
		    }
		  }
		}

		Promise.race = race;
		function race(iterable) {
		  var self = this;
		  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
		    return this.reject(new TypeError('must be an array'));
		  }

		  var len = iterable.length;
		  var called = false;
		  if (!len) {
		    return this.resolve([]);
		  }

		  var i = -1;
		  var promise = new this(INTERNAL);

		  while (++i < len) {
		    resolver(iterable[i]);
		  }
		  return promise;
		  function resolver(value) {
		    self.resolve(value).then(function (response) {
		      if (!called) {
		        called = true;
		        handlers.resolve(promise, response);
		      }
		    }, function (error) {
		      if (!called) {
		        called = true;
		        handlers.reject(promise, error);
		      }
		    });
		  }
		}

		},{"1":1}],3:[function(_dereq_,module,exports){
		(function (global){
		if (typeof global.Promise !== 'function') {
		  global.Promise = _dereq_(2);
		}

		}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
		},{"2":2}],4:[function(_dereq_,module,exports){

		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		function getIDB() {
		    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
		    try {
		        if (typeof indexedDB !== 'undefined') {
		            return indexedDB;
		        }
		        if (typeof webkitIndexedDB !== 'undefined') {
		            return webkitIndexedDB;
		        }
		        if (typeof mozIndexedDB !== 'undefined') {
		            return mozIndexedDB;
		        }
		        if (typeof OIndexedDB !== 'undefined') {
		            return OIndexedDB;
		        }
		        if (typeof msIndexedDB !== 'undefined') {
		            return msIndexedDB;
		        }
		    } catch (e) {
		        return;
		    }
		}

		var idb = getIDB();

		function isIndexedDBValid() {
		    try {
		        // Initialize IndexedDB; fall back to vendor-prefixed versions
		        // if needed.
		        if (!idb || !idb.open) {
		            return false;
		        }
		        // We mimic PouchDB here;
		        //
		        // We test for openDatabase because IE Mobile identifies itself
		        // as Safari. Oh the lulz...
		        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

		        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

		        // Safari <10.1 does not meet our requirements for IDB support
		        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
		        // Safari 10.1 shipped with fetch, we can use that to detect it.
		        // Note: this creates issues with `window.fetch` polyfills and
		        // overrides; see:
		        // https://github.com/localForage/localForage/issues/856
		        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
		        // some outdated implementations of IDB that appear on Samsung
		        // and HTC Android devices <4.4 are missing IDBKeyRange
		        // See: https://github.com/mozilla/localForage/issues/128
		        // See: https://github.com/mozilla/localForage/issues/272
		        typeof IDBKeyRange !== 'undefined';
		    } catch (e) {
		        return false;
		    }
		}

		// Abstracts constructing a Blob object, so it also works in older
		// browsers that don't support the native Blob constructor. (i.e.
		// old QtWebKit versions, at least).
		// Abstracts constructing a Blob object, so it also works in older
		// browsers that don't support the native Blob constructor. (i.e.
		// old QtWebKit versions, at least).
		function createBlob(parts, properties) {
		    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
		    parts = parts || [];
		    properties = properties || {};
		    try {
		        return new Blob(parts, properties);
		    } catch (e) {
		        if (e.name !== 'TypeError') {
		            throw e;
		        }
		        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
		        var builder = new Builder();
		        for (var i = 0; i < parts.length; i += 1) {
		            builder.append(parts[i]);
		        }
		        return builder.getBlob(properties.type);
		    }
		}

		// This is CommonJS because lie is an external dependency, so Rollup
		// can just ignore it.
		if (typeof Promise === 'undefined') {
		    // In the "nopromises" build this will just throw if you don't have
		    // a global promise object, but it would throw anyway later.
		    _dereq_(3);
		}
		var Promise$1 = Promise;

		function executeCallback(promise, callback) {
		    if (callback) {
		        promise.then(function (result) {
		            callback(null, result);
		        }, function (error) {
		            callback(error);
		        });
		    }
		}

		function executeTwoCallbacks(promise, callback, errorCallback) {
		    if (typeof callback === 'function') {
		        promise.then(callback);
		    }

		    if (typeof errorCallback === 'function') {
		        promise["catch"](errorCallback);
		    }
		}

		function normalizeKey(key) {
		    // Cast the key to a string, as that's all we can set as a key.
		    if (typeof key !== 'string') {
		        console.warn(key + ' used as a key, but it is not a string.');
		        key = String(key);
		    }

		    return key;
		}

		function getCallback() {
		    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
		        return arguments[arguments.length - 1];
		    }
		}

		// Some code originally from async_storage.js in
		// [Gaia](https://github.com/mozilla-b2g/gaia).

		var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
		var supportsBlobs = void 0;
		var dbContexts = {};
		var toString = Object.prototype.toString;

		// Transaction Modes
		var READ_ONLY = 'readonly';
		var READ_WRITE = 'readwrite';

		// Transform a binary string to an array buffer, because otherwise
		// weird stuff happens when you try to work with the binary string directly.
		// It is known.
		// From http://stackoverflow.com/questions/14967647/ (continues on next line)
		// encode-decode-image-with-base64-breaks-image (2013-04-21)
		function _binStringToArrayBuffer(bin) {
		    var length = bin.length;
		    var buf = new ArrayBuffer(length);
		    var arr = new Uint8Array(buf);
		    for (var i = 0; i < length; i++) {
		        arr[i] = bin.charCodeAt(i);
		    }
		    return buf;
		}

		//
		// Blobs are not supported in all versions of IndexedDB, notably
		// Chrome <37 and Android <5. In those versions, storing a blob will throw.
		//
		// Various other blob bugs exist in Chrome v37-42 (inclusive).
		// Detecting them is expensive and confusing to users, and Chrome 37-42
		// is at very low usage worldwide, so we do a hacky userAgent check instead.
		//
		// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
		// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
		// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
		//
		// Code borrowed from PouchDB. See:
		// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
		//
		function _checkBlobSupportWithoutCaching(idb) {
		    return new Promise$1(function (resolve) {
		        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
		        var blob = createBlob(['']);
		        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

		        txn.onabort = function (e) {
		            // If the transaction aborts now its due to not being able to
		            // write to the database, likely due to the disk being full
		            e.preventDefault();
		            e.stopPropagation();
		            resolve(false);
		        };

		        txn.oncomplete = function () {
		            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
		            var matchedEdge = navigator.userAgent.match(/Edge\//);
		            // MS Edge pretends to be Chrome 42:
		            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
		            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
		        };
		    })["catch"](function () {
		        return false; // error, so assume unsupported
		    });
		}

		function _checkBlobSupport(idb) {
		    if (typeof supportsBlobs === 'boolean') {
		        return Promise$1.resolve(supportsBlobs);
		    }
		    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
		        supportsBlobs = value;
		        return supportsBlobs;
		    });
		}

		function _deferReadiness(dbInfo) {
		    var dbContext = dbContexts[dbInfo.name];

		    // Create a deferred object representing the current database operation.
		    var deferredOperation = {};

		    deferredOperation.promise = new Promise$1(function (resolve, reject) {
		        deferredOperation.resolve = resolve;
		        deferredOperation.reject = reject;
		    });

		    // Enqueue the deferred operation.
		    dbContext.deferredOperations.push(deferredOperation);

		    // Chain its promise to the database readiness.
		    if (!dbContext.dbReady) {
		        dbContext.dbReady = deferredOperation.promise;
		    } else {
		        dbContext.dbReady = dbContext.dbReady.then(function () {
		            return deferredOperation.promise;
		        });
		    }
		}

		function _advanceReadiness(dbInfo) {
		    var dbContext = dbContexts[dbInfo.name];

		    // Dequeue a deferred operation.
		    var deferredOperation = dbContext.deferredOperations.pop();

		    // Resolve its promise (which is part of the database readiness
		    // chain of promises).
		    if (deferredOperation) {
		        deferredOperation.resolve();
		        return deferredOperation.promise;
		    }
		}

		function _rejectReadiness(dbInfo, err) {
		    var dbContext = dbContexts[dbInfo.name];

		    // Dequeue a deferred operation.
		    var deferredOperation = dbContext.deferredOperations.pop();

		    // Reject its promise (which is part of the database readiness
		    // chain of promises).
		    if (deferredOperation) {
		        deferredOperation.reject(err);
		        return deferredOperation.promise;
		    }
		}

		function _getConnection(dbInfo, upgradeNeeded) {
		    return new Promise$1(function (resolve, reject) {
		        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

		        if (dbInfo.db) {
		            if (upgradeNeeded) {
		                _deferReadiness(dbInfo);
		                dbInfo.db.close();
		            } else {
		                return resolve(dbInfo.db);
		            }
		        }

		        var dbArgs = [dbInfo.name];

		        if (upgradeNeeded) {
		            dbArgs.push(dbInfo.version);
		        }

		        var openreq = idb.open.apply(idb, dbArgs);

		        if (upgradeNeeded) {
		            openreq.onupgradeneeded = function (e) {
		                var db = openreq.result;
		                try {
		                    db.createObjectStore(dbInfo.storeName);
		                    if (e.oldVersion <= 1) {
		                        // Added when support for blob shims was added
		                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
		                    }
		                } catch (ex) {
		                    if (ex.name === 'ConstraintError') {
		                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
		                    } else {
		                        throw ex;
		                    }
		                }
		            };
		        }

		        openreq.onerror = function (e) {
		            e.preventDefault();
		            reject(openreq.error);
		        };

		        openreq.onsuccess = function () {
		            var db = openreq.result;
		            db.onversionchange = function (e) {
		                // Triggered when the database is modified (e.g. adding an objectStore) or
		                // deleted (even when initiated by other sessions in different tabs).
		                // Closing the connection here prevents those operations from being blocked.
		                // If the database is accessed again later by this instance, the connection
		                // will be reopened or the database recreated as needed.
		                e.target.close();
		            };
		            resolve(db);
		            _advanceReadiness(dbInfo);
		        };
		    });
		}

		function _getOriginalConnection(dbInfo) {
		    return _getConnection(dbInfo, false);
		}

		function _getUpgradedConnection(dbInfo) {
		    return _getConnection(dbInfo, true);
		}

		function _isUpgradeNeeded(dbInfo, defaultVersion) {
		    if (!dbInfo.db) {
		        return true;
		    }

		    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
		    var isDowngrade = dbInfo.version < dbInfo.db.version;
		    var isUpgrade = dbInfo.version > dbInfo.db.version;

		    if (isDowngrade) {
		        // If the version is not the default one
		        // then warn for impossible downgrade.
		        if (dbInfo.version !== defaultVersion) {
		            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
		        }
		        // Align the versions to prevent errors.
		        dbInfo.version = dbInfo.db.version;
		    }

		    if (isUpgrade || isNewStore) {
		        // If the store is new then increment the version (if needed).
		        // This will trigger an "upgradeneeded" event which is required
		        // for creating a store.
		        if (isNewStore) {
		            var incVersion = dbInfo.db.version + 1;
		            if (incVersion > dbInfo.version) {
		                dbInfo.version = incVersion;
		            }
		        }

		        return true;
		    }

		    return false;
		}

		// encode a blob for indexeddb engines that don't support blobs
		function _encodeBlob(blob) {
		    return new Promise$1(function (resolve, reject) {
		        var reader = new FileReader();
		        reader.onerror = reject;
		        reader.onloadend = function (e) {
		            var base64 = btoa(e.target.result || '');
		            resolve({
		                __local_forage_encoded_blob: true,
		                data: base64,
		                type: blob.type
		            });
		        };
		        reader.readAsBinaryString(blob);
		    });
		}

		// decode an encoded blob
		function _decodeBlob(encodedBlob) {
		    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
		    return createBlob([arrayBuff], { type: encodedBlob.type });
		}

		// is this one of our fancy encoded blobs?
		function _isEncodedBlob(value) {
		    return value && value.__local_forage_encoded_blob;
		}

		// Specialize the default `ready()` function by making it dependent
		// on the current database operations. Thus, the driver will be actually
		// ready when it's been initialized (default) *and* there are no pending
		// operations on the database (initiated by some other instances).
		function _fullyReady(callback) {
		    var self = this;

		    var promise = self._initReady().then(function () {
		        var dbContext = dbContexts[self._dbInfo.name];

		        if (dbContext && dbContext.dbReady) {
		            return dbContext.dbReady;
		        }
		    });

		    executeTwoCallbacks(promise, callback, callback);
		    return promise;
		}

		// Try to establish a new db connection to replace the
		// current one which is broken (i.e. experiencing
		// InvalidStateError while creating a transaction).
		function _tryReconnect(dbInfo) {
		    _deferReadiness(dbInfo);

		    var dbContext = dbContexts[dbInfo.name];
		    var forages = dbContext.forages;

		    for (var i = 0; i < forages.length; i++) {
		        var forage = forages[i];
		        if (forage._dbInfo.db) {
		            forage._dbInfo.db.close();
		            forage._dbInfo.db = null;
		        }
		    }
		    dbInfo.db = null;

		    return _getOriginalConnection(dbInfo).then(function (db) {
		        dbInfo.db = db;
		        if (_isUpgradeNeeded(dbInfo)) {
		            // Reopen the database for upgrading.
		            return _getUpgradedConnection(dbInfo);
		        }
		        return db;
		    }).then(function (db) {
		        // store the latest db reference
		        // in case the db was upgraded
		        dbInfo.db = dbContext.db = db;
		        for (var i = 0; i < forages.length; i++) {
		            forages[i]._dbInfo.db = db;
		        }
		    })["catch"](function (err) {
		        _rejectReadiness(dbInfo, err);
		        throw err;
		    });
		}

		// FF doesn't like Promises (micro-tasks) and IDDB store operations,
		// so we have to do it with callbacks
		function createTransaction(dbInfo, mode, callback, retries) {
		    if (retries === undefined) {
		        retries = 1;
		    }

		    try {
		        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
		        callback(null, tx);
		    } catch (err) {
		        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
		            return Promise$1.resolve().then(function () {
		                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
		                    // increase the db version, to create the new ObjectStore
		                    if (dbInfo.db) {
		                        dbInfo.version = dbInfo.db.version + 1;
		                    }
		                    // Reopen the database for upgrading.
		                    return _getUpgradedConnection(dbInfo);
		                }
		            }).then(function () {
		                return _tryReconnect(dbInfo).then(function () {
		                    createTransaction(dbInfo, mode, callback, retries - 1);
		                });
		            })["catch"](callback);
		        }

		        callback(err);
		    }
		}

		function createDbContext() {
		    return {
		        // Running localForages sharing a database.
		        forages: [],
		        // Shared database.
		        db: null,
		        // Database readiness (promise).
		        dbReady: null,
		        // Deferred operations on the database.
		        deferredOperations: []
		    };
		}

		// Open the IndexedDB database (automatically creates one if one didn't
		// previously exist), using any options set in the config.
		function _initStorage(options) {
		    var self = this;
		    var dbInfo = {
		        db: null
		    };

		    if (options) {
		        for (var i in options) {
		            dbInfo[i] = options[i];
		        }
		    }

		    // Get the current context of the database;
		    var dbContext = dbContexts[dbInfo.name];

		    // ...or create a new context.
		    if (!dbContext) {
		        dbContext = createDbContext();
		        // Register the new context in the global container.
		        dbContexts[dbInfo.name] = dbContext;
		    }

		    // Register itself as a running localForage in the current context.
		    dbContext.forages.push(self);

		    // Replace the default `ready()` function with the specialized one.
		    if (!self._initReady) {
		        self._initReady = self.ready;
		        self.ready = _fullyReady;
		    }

		    // Create an array of initialization states of the related localForages.
		    var initPromises = [];

		    function ignoreErrors() {
		        // Don't handle errors here,
		        // just makes sure related localForages aren't pending.
		        return Promise$1.resolve();
		    }

		    for (var j = 0; j < dbContext.forages.length; j++) {
		        var forage = dbContext.forages[j];
		        if (forage !== self) {
		            // Don't wait for itself...
		            initPromises.push(forage._initReady()["catch"](ignoreErrors));
		        }
		    }

		    // Take a snapshot of the related localForages.
		    var forages = dbContext.forages.slice(0);

		    // Initialize the connection process only when
		    // all the related localForages aren't pending.
		    return Promise$1.all(initPromises).then(function () {
		        dbInfo.db = dbContext.db;
		        // Get the connection or open a new one without upgrade.
		        return _getOriginalConnection(dbInfo);
		    }).then(function (db) {
		        dbInfo.db = db;
		        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
		            // Reopen the database for upgrading.
		            return _getUpgradedConnection(dbInfo);
		        }
		        return db;
		    }).then(function (db) {
		        dbInfo.db = dbContext.db = db;
		        self._dbInfo = dbInfo;
		        // Share the final connection amongst related localForages.
		        for (var k = 0; k < forages.length; k++) {
		            var forage = forages[k];
		            if (forage !== self) {
		                // Self is already up-to-date.
		                forage._dbInfo.db = dbInfo.db;
		                forage._dbInfo.version = dbInfo.version;
		            }
		        }
		    });
		}

		function getItem(key, callback) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
		                if (err) {
		                    return reject(err);
		                }

		                try {
		                    var store = transaction.objectStore(self._dbInfo.storeName);
		                    var req = store.get(key);

		                    req.onsuccess = function () {
		                        var value = req.result;
		                        if (value === undefined) {
		                            value = null;
		                        }
		                        if (_isEncodedBlob(value)) {
		                            value = _decodeBlob(value);
		                        }
		                        resolve(value);
		                    };

		                    req.onerror = function () {
		                        reject(req.error);
		                    };
		                } catch (e) {
		                    reject(e);
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Iterate over all items stored in database.
		function iterate(iterator, callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
		                if (err) {
		                    return reject(err);
		                }

		                try {
		                    var store = transaction.objectStore(self._dbInfo.storeName);
		                    var req = store.openCursor();
		                    var iterationNumber = 1;

		                    req.onsuccess = function () {
		                        var cursor = req.result;

		                        if (cursor) {
		                            var value = cursor.value;
		                            if (_isEncodedBlob(value)) {
		                                value = _decodeBlob(value);
		                            }
		                            var result = iterator(value, cursor.key, iterationNumber++);

		                            // when the iterator callback returns any
		                            // (non-`undefined`) value, then we stop
		                            // the iteration immediately
		                            if (result !== void 0) {
		                                resolve(result);
		                            } else {
		                                cursor["continue"]();
		                            }
		                        } else {
		                            resolve();
		                        }
		                    };

		                    req.onerror = function () {
		                        reject(req.error);
		                    };
		                } catch (e) {
		                    reject(e);
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);

		    return promise;
		}

		function setItem(key, value, callback) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = new Promise$1(function (resolve, reject) {
		        var dbInfo;
		        self.ready().then(function () {
		            dbInfo = self._dbInfo;
		            if (toString.call(value) === '[object Blob]') {
		                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
		                    if (blobSupport) {
		                        return value;
		                    }
		                    return _encodeBlob(value);
		                });
		            }
		            return value;
		        }).then(function (value) {
		            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
		                if (err) {
		                    return reject(err);
		                }

		                try {
		                    var store = transaction.objectStore(self._dbInfo.storeName);

		                    // The reason we don't _save_ null is because IE 10 does
		                    // not support saving the `null` type in IndexedDB. How
		                    // ironic, given the bug below!
		                    // See: https://github.com/mozilla/localForage/issues/161
		                    if (value === null) {
		                        value = undefined;
		                    }

		                    var req = store.put(value, key);

		                    transaction.oncomplete = function () {
		                        // Cast to undefined so the value passed to
		                        // callback/promise is the same as what one would get out
		                        // of `getItem()` later. This leads to some weirdness
		                        // (setItem('foo', undefined) will return `null`), but
		                        // it's not my fault localStorage is our baseline and that
		                        // it's weird.
		                        if (value === undefined) {
		                            value = null;
		                        }

		                        resolve(value);
		                    };
		                    transaction.onabort = transaction.onerror = function () {
		                        var err = req.error ? req.error : req.transaction.error;
		                        reject(err);
		                    };
		                } catch (e) {
		                    reject(e);
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function removeItem(key, callback) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
		                if (err) {
		                    return reject(err);
		                }

		                try {
		                    var store = transaction.objectStore(self._dbInfo.storeName);
		                    // We use a Grunt task to make this safe for IE and some
		                    // versions of Android (including those used by Cordova).
		                    // Normally IE won't like `.delete()` and will insist on
		                    // using `['delete']()`, but we have a build step that
		                    // fixes this for us now.
		                    var req = store["delete"](key);
		                    transaction.oncomplete = function () {
		                        resolve();
		                    };

		                    transaction.onerror = function () {
		                        reject(req.error);
		                    };

		                    // The request will be also be aborted if we've exceeded our storage
		                    // space.
		                    transaction.onabort = function () {
		                        var err = req.error ? req.error : req.transaction.error;
		                        reject(err);
		                    };
		                } catch (e) {
		                    reject(e);
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function clear(callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
		                if (err) {
		                    return reject(err);
		                }

		                try {
		                    var store = transaction.objectStore(self._dbInfo.storeName);
		                    var req = store.clear();

		                    transaction.oncomplete = function () {
		                        resolve();
		                    };

		                    transaction.onabort = transaction.onerror = function () {
		                        var err = req.error ? req.error : req.transaction.error;
		                        reject(err);
		                    };
		                } catch (e) {
		                    reject(e);
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function length(callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
		                if (err) {
		                    return reject(err);
		                }

		                try {
		                    var store = transaction.objectStore(self._dbInfo.storeName);
		                    var req = store.count();

		                    req.onsuccess = function () {
		                        resolve(req.result);
		                    };

		                    req.onerror = function () {
		                        reject(req.error);
		                    };
		                } catch (e) {
		                    reject(e);
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function key(n, callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        if (n < 0) {
		            resolve(null);

		            return;
		        }

		        self.ready().then(function () {
		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
		                if (err) {
		                    return reject(err);
		                }

		                try {
		                    var store = transaction.objectStore(self._dbInfo.storeName);
		                    var advanced = false;
		                    var req = store.openKeyCursor();

		                    req.onsuccess = function () {
		                        var cursor = req.result;
		                        if (!cursor) {
		                            // this means there weren't enough keys
		                            resolve(null);

		                            return;
		                        }

		                        if (n === 0) {
		                            // We have the first key, return it if that's what they
		                            // wanted.
		                            resolve(cursor.key);
		                        } else {
		                            if (!advanced) {
		                                // Otherwise, ask the cursor to skip ahead n
		                                // records.
		                                advanced = true;
		                                cursor.advance(n);
		                            } else {
		                                // When we get here, we've got the nth key.
		                                resolve(cursor.key);
		                            }
		                        }
		                    };

		                    req.onerror = function () {
		                        reject(req.error);
		                    };
		                } catch (e) {
		                    reject(e);
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function keys(callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
		                if (err) {
		                    return reject(err);
		                }

		                try {
		                    var store = transaction.objectStore(self._dbInfo.storeName);
		                    var req = store.openKeyCursor();
		                    var keys = [];

		                    req.onsuccess = function () {
		                        var cursor = req.result;

		                        if (!cursor) {
		                            resolve(keys);
		                            return;
		                        }

		                        keys.push(cursor.key);
		                        cursor["continue"]();
		                    };

		                    req.onerror = function () {
		                        reject(req.error);
		                    };
		                } catch (e) {
		                    reject(e);
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function dropInstance(options, callback) {
		    callback = getCallback.apply(this, arguments);

		    var currentConfig = this.config();
		    options = typeof options !== 'function' && options || {};
		    if (!options.name) {
		        options.name = options.name || currentConfig.name;
		        options.storeName = options.storeName || currentConfig.storeName;
		    }

		    var self = this;
		    var promise;
		    if (!options.name) {
		        promise = Promise$1.reject('Invalid arguments');
		    } else {
		        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

		        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
		            var dbContext = dbContexts[options.name];
		            var forages = dbContext.forages;
		            dbContext.db = db;
		            for (var i = 0; i < forages.length; i++) {
		                forages[i]._dbInfo.db = db;
		            }
		            return db;
		        });

		        if (!options.storeName) {
		            promise = dbPromise.then(function (db) {
		                _deferReadiness(options);

		                var dbContext = dbContexts[options.name];
		                var forages = dbContext.forages;

		                db.close();
		                for (var i = 0; i < forages.length; i++) {
		                    var forage = forages[i];
		                    forage._dbInfo.db = null;
		                }

		                var dropDBPromise = new Promise$1(function (resolve, reject) {
		                    var req = idb.deleteDatabase(options.name);

		                    req.onerror = function () {
		                        var db = req.result;
		                        if (db) {
		                            db.close();
		                        }
		                        reject(req.error);
		                    };

		                    req.onblocked = function () {
		                        // Closing all open connections in onversionchange handler should prevent this situation, but if
		                        // we do get here, it just means the request remains pending - eventually it will succeed or error
		                        console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
		                    };

		                    req.onsuccess = function () {
		                        var db = req.result;
		                        if (db) {
		                            db.close();
		                        }
		                        resolve(db);
		                    };
		                });

		                return dropDBPromise.then(function (db) {
		                    dbContext.db = db;
		                    for (var i = 0; i < forages.length; i++) {
		                        var _forage = forages[i];
		                        _advanceReadiness(_forage._dbInfo);
		                    }
		                })["catch"](function (err) {
		                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
		                    throw err;
		                });
		            });
		        } else {
		            promise = dbPromise.then(function (db) {
		                if (!db.objectStoreNames.contains(options.storeName)) {
		                    return;
		                }

		                var newVersion = db.version + 1;

		                _deferReadiness(options);

		                var dbContext = dbContexts[options.name];
		                var forages = dbContext.forages;

		                db.close();
		                for (var i = 0; i < forages.length; i++) {
		                    var forage = forages[i];
		                    forage._dbInfo.db = null;
		                    forage._dbInfo.version = newVersion;
		                }

		                var dropObjectPromise = new Promise$1(function (resolve, reject) {
		                    var req = idb.open(options.name, newVersion);

		                    req.onerror = function (err) {
		                        var db = req.result;
		                        db.close();
		                        reject(err);
		                    };

		                    req.onupgradeneeded = function () {
		                        var db = req.result;
		                        db.deleteObjectStore(options.storeName);
		                    };

		                    req.onsuccess = function () {
		                        var db = req.result;
		                        db.close();
		                        resolve(db);
		                    };
		                });

		                return dropObjectPromise.then(function (db) {
		                    dbContext.db = db;
		                    for (var j = 0; j < forages.length; j++) {
		                        var _forage2 = forages[j];
		                        _forage2._dbInfo.db = db;
		                        _advanceReadiness(_forage2._dbInfo);
		                    }
		                })["catch"](function (err) {
		                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
		                    throw err;
		                });
		            });
		        }
		    }

		    executeCallback(promise, callback);
		    return promise;
		}

		var asyncStorage = {
		    _driver: 'asyncStorage',
		    _initStorage: _initStorage,
		    _support: isIndexedDBValid(),
		    iterate: iterate,
		    getItem: getItem,
		    setItem: setItem,
		    removeItem: removeItem,
		    clear: clear,
		    length: length,
		    key: key,
		    keys: keys,
		    dropInstance: dropInstance
		};

		function isWebSQLValid() {
		    return typeof openDatabase === 'function';
		}

		// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
		// it to Base64, so this is how we store it to prevent very strange errors with less
		// verbose ways of binary <-> string data storage.
		var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

		var BLOB_TYPE_PREFIX = '~~local_forage_type~';
		var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

		var SERIALIZED_MARKER = '__lfsc__:';
		var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

		// OMG the serializations!
		var TYPE_ARRAYBUFFER = 'arbf';
		var TYPE_BLOB = 'blob';
		var TYPE_INT8ARRAY = 'si08';
		var TYPE_UINT8ARRAY = 'ui08';
		var TYPE_UINT8CLAMPEDARRAY = 'uic8';
		var TYPE_INT16ARRAY = 'si16';
		var TYPE_INT32ARRAY = 'si32';
		var TYPE_UINT16ARRAY = 'ur16';
		var TYPE_UINT32ARRAY = 'ui32';
		var TYPE_FLOAT32ARRAY = 'fl32';
		var TYPE_FLOAT64ARRAY = 'fl64';
		var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

		var toString$1 = Object.prototype.toString;

		function stringToBuffer(serializedString) {
		    // Fill the string into a ArrayBuffer.
		    var bufferLength = serializedString.length * 0.75;
		    var len = serializedString.length;
		    var i;
		    var p = 0;
		    var encoded1, encoded2, encoded3, encoded4;

		    if (serializedString[serializedString.length - 1] === '=') {
		        bufferLength--;
		        if (serializedString[serializedString.length - 2] === '=') {
		            bufferLength--;
		        }
		    }

		    var buffer = new ArrayBuffer(bufferLength);
		    var bytes = new Uint8Array(buffer);

		    for (i = 0; i < len; i += 4) {
		        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
		        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
		        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
		        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

		        /*jslint bitwise: true */
		        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
		        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
		        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
		    }
		    return buffer;
		}

		// Converts a buffer to a string to store, serialized, in the backend
		// storage library.
		function bufferToString(buffer) {
		    // base64-arraybuffer
		    var bytes = new Uint8Array(buffer);
		    var base64String = '';
		    var i;

		    for (i = 0; i < bytes.length; i += 3) {
		        /*jslint bitwise: true */
		        base64String += BASE_CHARS[bytes[i] >> 2];
		        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
		        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
		        base64String += BASE_CHARS[bytes[i + 2] & 63];
		    }

		    if (bytes.length % 3 === 2) {
		        base64String = base64String.substring(0, base64String.length - 1) + '=';
		    } else if (bytes.length % 3 === 1) {
		        base64String = base64String.substring(0, base64String.length - 2) + '==';
		    }

		    return base64String;
		}

		// Serialize a value, afterwards executing a callback (which usually
		// instructs the `setItem()` callback/promise to be executed). This is how
		// we store binary data with localStorage.
		function serialize(value, callback) {
		    var valueType = '';
		    if (value) {
		        valueType = toString$1.call(value);
		    }

		    // Cannot use `value instanceof ArrayBuffer` or such here, as these
		    // checks fail when running the tests using casper.js...
		    //
		    // TODO: See why those tests fail and use a better solution.
		    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
		        // Convert binary arrays to a string and prefix the string with
		        // a special marker.
		        var buffer;
		        var marker = SERIALIZED_MARKER;

		        if (value instanceof ArrayBuffer) {
		            buffer = value;
		            marker += TYPE_ARRAYBUFFER;
		        } else {
		            buffer = value.buffer;

		            if (valueType === '[object Int8Array]') {
		                marker += TYPE_INT8ARRAY;
		            } else if (valueType === '[object Uint8Array]') {
		                marker += TYPE_UINT8ARRAY;
		            } else if (valueType === '[object Uint8ClampedArray]') {
		                marker += TYPE_UINT8CLAMPEDARRAY;
		            } else if (valueType === '[object Int16Array]') {
		                marker += TYPE_INT16ARRAY;
		            } else if (valueType === '[object Uint16Array]') {
		                marker += TYPE_UINT16ARRAY;
		            } else if (valueType === '[object Int32Array]') {
		                marker += TYPE_INT32ARRAY;
		            } else if (valueType === '[object Uint32Array]') {
		                marker += TYPE_UINT32ARRAY;
		            } else if (valueType === '[object Float32Array]') {
		                marker += TYPE_FLOAT32ARRAY;
		            } else if (valueType === '[object Float64Array]') {
		                marker += TYPE_FLOAT64ARRAY;
		            } else {
		                callback(new Error('Failed to get type for BinaryArray'));
		            }
		        }

		        callback(marker + bufferToString(buffer));
		    } else if (valueType === '[object Blob]') {
		        // Conver the blob to a binaryArray and then to a string.
		        var fileReader = new FileReader();

		        fileReader.onload = function () {
		            // Backwards-compatible prefix for the blob type.
		            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

		            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
		        };

		        fileReader.readAsArrayBuffer(value);
		    } else {
		        try {
		            callback(JSON.stringify(value));
		        } catch (e) {
		            console.error("Couldn't convert value into a JSON string: ", value);

		            callback(null, e);
		        }
		    }
		}

		// Deserialize data we've inserted into a value column/field. We place
		// special markers into our strings to mark them as encoded; this isn't
		// as nice as a meta field, but it's the only sane thing we can do whilst
		// keeping localStorage support intact.
		//
		// Oftentimes this will just deserialize JSON content, but if we have a
		// special marker (SERIALIZED_MARKER, defined above), we will extract
		// some kind of arraybuffer/binary data/typed array out of the string.
		function deserialize(value) {
		    // If we haven't marked this string as being specially serialized (i.e.
		    // something other than serialized JSON), we can just return it and be
		    // done with it.
		    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
		        return JSON.parse(value);
		    }

		    // The following code deals with deserializing some kind of Blob or
		    // TypedArray. First we separate out the type of data we're dealing
		    // with from the data itself.
		    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
		    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

		    var blobType;
		    // Backwards-compatible blob type serialization strategy.
		    // DBs created with older versions of localForage will simply not have the blob type.
		    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
		        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
		        blobType = matcher[1];
		        serializedString = serializedString.substring(matcher[0].length);
		    }
		    var buffer = stringToBuffer(serializedString);

		    // Return the right type based on the code/type set during
		    // serialization.
		    switch (type) {
		        case TYPE_ARRAYBUFFER:
		            return buffer;
		        case TYPE_BLOB:
		            return createBlob([buffer], { type: blobType });
		        case TYPE_INT8ARRAY:
		            return new Int8Array(buffer);
		        case TYPE_UINT8ARRAY:
		            return new Uint8Array(buffer);
		        case TYPE_UINT8CLAMPEDARRAY:
		            return new Uint8ClampedArray(buffer);
		        case TYPE_INT16ARRAY:
		            return new Int16Array(buffer);
		        case TYPE_UINT16ARRAY:
		            return new Uint16Array(buffer);
		        case TYPE_INT32ARRAY:
		            return new Int32Array(buffer);
		        case TYPE_UINT32ARRAY:
		            return new Uint32Array(buffer);
		        case TYPE_FLOAT32ARRAY:
		            return new Float32Array(buffer);
		        case TYPE_FLOAT64ARRAY:
		            return new Float64Array(buffer);
		        default:
		            throw new Error('Unkown type: ' + type);
		    }
		}

		var localforageSerializer = {
		    serialize: serialize,
		    deserialize: deserialize,
		    stringToBuffer: stringToBuffer,
		    bufferToString: bufferToString
		};

		/*
		 * Includes code from:
		 *
		 * base64-arraybuffer
		 * https://github.com/niklasvh/base64-arraybuffer
		 *
		 * Copyright (c) 2012 Niklas von Hertzen
		 * Licensed under the MIT license.
		 */

		function createDbTable(t, dbInfo, callback, errorCallback) {
		    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
		}

		// Open the WebSQL database (automatically creates one if one didn't
		// previously exist), using any options set in the config.
		function _initStorage$1(options) {
		    var self = this;
		    var dbInfo = {
		        db: null
		    };

		    if (options) {
		        for (var i in options) {
		            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
		        }
		    }

		    var dbInfoPromise = new Promise$1(function (resolve, reject) {
		        // Open the database; the openDatabase API will automatically
		        // create it for us if it doesn't exist.
		        try {
		            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
		        } catch (e) {
		            return reject(e);
		        }

		        // Create our key/value table if it doesn't exist.
		        dbInfo.db.transaction(function (t) {
		            createDbTable(t, dbInfo, function () {
		                self._dbInfo = dbInfo;
		                resolve();
		            }, function (t, error) {
		                reject(error);
		            });
		        }, reject);
		    });

		    dbInfo.serializer = localforageSerializer;
		    return dbInfoPromise;
		}

		function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
		    t.executeSql(sqlStatement, args, callback, function (t, error) {
		        if (error.code === error.SYNTAX_ERR) {
		            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
		                if (!results.rows.length) {
		                    // if the table is missing (was deleted)
		                    // re-create it table and retry
		                    createDbTable(t, dbInfo, function () {
		                        t.executeSql(sqlStatement, args, callback, errorCallback);
		                    }, errorCallback);
		                } else {
		                    errorCallback(t, error);
		                }
		            }, errorCallback);
		        } else {
		            errorCallback(t, error);
		        }
		    }, errorCallback);
		}

		function getItem$1(key, callback) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            var dbInfo = self._dbInfo;
		            dbInfo.db.transaction(function (t) {
		                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
		                    var result = results.rows.length ? results.rows.item(0).value : null;

		                    // Check to see if this is serialized content we need to
		                    // unpack.
		                    if (result) {
		                        result = dbInfo.serializer.deserialize(result);
		                    }

		                    resolve(result);
		                }, function (t, error) {
		                    reject(error);
		                });
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function iterate$1(iterator, callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            var dbInfo = self._dbInfo;

		            dbInfo.db.transaction(function (t) {
		                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
		                    var rows = results.rows;
		                    var length = rows.length;

		                    for (var i = 0; i < length; i++) {
		                        var item = rows.item(i);
		                        var result = item.value;

		                        // Check to see if this is serialized content
		                        // we need to unpack.
		                        if (result) {
		                            result = dbInfo.serializer.deserialize(result);
		                        }

		                        result = iterator(result, item.key, i + 1);

		                        // void(0) prevents problems with redefinition
		                        // of `undefined`.
		                        if (result !== void 0) {
		                            resolve(result);
		                            return;
		                        }
		                    }

		                    resolve();
		                }, function (t, error) {
		                    reject(error);
		                });
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function _setItem(key, value, callback, retriesLeft) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            // The localStorage API doesn't return undefined values in an
		            // "expected" way, so undefined is always cast to null in all
		            // drivers. See: https://github.com/mozilla/localForage/pull/42
		            if (value === undefined) {
		                value = null;
		            }

		            // Save the original value to pass to the callback.
		            var originalValue = value;

		            var dbInfo = self._dbInfo;
		            dbInfo.serializer.serialize(value, function (value, error) {
		                if (error) {
		                    reject(error);
		                } else {
		                    dbInfo.db.transaction(function (t) {
		                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
		                            resolve(originalValue);
		                        }, function (t, error) {
		                            reject(error);
		                        });
		                    }, function (sqlError) {
		                        // The transaction failed; check
		                        // to see if it's a quota error.
		                        if (sqlError.code === sqlError.QUOTA_ERR) {
		                            // We reject the callback outright for now, but
		                            // it's worth trying to re-run the transaction.
		                            // Even if the user accepts the prompt to use
		                            // more storage on Safari, this error will
		                            // be called.
		                            //
		                            // Try to re-run the transaction.
		                            if (retriesLeft > 0) {
		                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
		                                return;
		                            }
		                            reject(sqlError);
		                        }
		                    });
		                }
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function setItem$1(key, value, callback) {
		    return _setItem.apply(this, [key, value, callback, 1]);
		}

		function removeItem$1(key, callback) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            var dbInfo = self._dbInfo;
		            dbInfo.db.transaction(function (t) {
		                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
		                    resolve();
		                }, function (t, error) {
		                    reject(error);
		                });
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Deletes every item in the table.
		// TODO: Find out if this resets the AUTO_INCREMENT number.
		function clear$1(callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            var dbInfo = self._dbInfo;
		            dbInfo.db.transaction(function (t) {
		                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
		                    resolve();
		                }, function (t, error) {
		                    reject(error);
		                });
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Does a simple `COUNT(key)` to get the number of items stored in
		// localForage.
		function length$1(callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            var dbInfo = self._dbInfo;
		            dbInfo.db.transaction(function (t) {
		                // Ahhh, SQL makes this one soooooo easy.
		                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
		                    var result = results.rows.item(0).c;
		                    resolve(result);
		                }, function (t, error) {
		                    reject(error);
		                });
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Return the key located at key index X; essentially gets the key from a
		// `WHERE id = ?`. This is the most efficient way I can think to implement
		// this rarely-used (in my experience) part of the API, but it can seem
		// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
		// the ID of each key will change every time it's updated. Perhaps a stored
		// procedure for the `setItem()` SQL would solve this problem?
		// TODO: Don't change ID on `setItem()`.
		function key$1(n, callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            var dbInfo = self._dbInfo;
		            dbInfo.db.transaction(function (t) {
		                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
		                    var result = results.rows.length ? results.rows.item(0).key : null;
		                    resolve(result);
		                }, function (t, error) {
		                    reject(error);
		                });
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function keys$1(callback) {
		    var self = this;

		    var promise = new Promise$1(function (resolve, reject) {
		        self.ready().then(function () {
		            var dbInfo = self._dbInfo;
		            dbInfo.db.transaction(function (t) {
		                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
		                    var keys = [];

		                    for (var i = 0; i < results.rows.length; i++) {
		                        keys.push(results.rows.item(i).key);
		                    }

		                    resolve(keys);
		                }, function (t, error) {
		                    reject(error);
		                });
		            });
		        })["catch"](reject);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// https://www.w3.org/TR/webdatabase/#databases
		// > There is no way to enumerate or delete the databases available for an origin from this API.
		function getAllStoreNames(db) {
		    return new Promise$1(function (resolve, reject) {
		        db.transaction(function (t) {
		            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
		                var storeNames = [];

		                for (var i = 0; i < results.rows.length; i++) {
		                    storeNames.push(results.rows.item(i).name);
		                }

		                resolve({
		                    db: db,
		                    storeNames: storeNames
		                });
		            }, function (t, error) {
		                reject(error);
		            });
		        }, function (sqlError) {
		            reject(sqlError);
		        });
		    });
		}

		function dropInstance$1(options, callback) {
		    callback = getCallback.apply(this, arguments);

		    var currentConfig = this.config();
		    options = typeof options !== 'function' && options || {};
		    if (!options.name) {
		        options.name = options.name || currentConfig.name;
		        options.storeName = options.storeName || currentConfig.storeName;
		    }

		    var self = this;
		    var promise;
		    if (!options.name) {
		        promise = Promise$1.reject('Invalid arguments');
		    } else {
		        promise = new Promise$1(function (resolve) {
		            var db;
		            if (options.name === currentConfig.name) {
		                // use the db reference of the current instance
		                db = self._dbInfo.db;
		            } else {
		                db = openDatabase(options.name, '', '', 0);
		            }

		            if (!options.storeName) {
		                // drop all database tables
		                resolve(getAllStoreNames(db));
		            } else {
		                resolve({
		                    db: db,
		                    storeNames: [options.storeName]
		                });
		            }
		        }).then(function (operationInfo) {
		            return new Promise$1(function (resolve, reject) {
		                operationInfo.db.transaction(function (t) {
		                    function dropTable(storeName) {
		                        return new Promise$1(function (resolve, reject) {
		                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
		                                resolve();
		                            }, function (t, error) {
		                                reject(error);
		                            });
		                        });
		                    }

		                    var operations = [];
		                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
		                        operations.push(dropTable(operationInfo.storeNames[i]));
		                    }

		                    Promise$1.all(operations).then(function () {
		                        resolve();
		                    })["catch"](function (e) {
		                        reject(e);
		                    });
		                }, function (sqlError) {
		                    reject(sqlError);
		                });
		            });
		        });
		    }

		    executeCallback(promise, callback);
		    return promise;
		}

		var webSQLStorage = {
		    _driver: 'webSQLStorage',
		    _initStorage: _initStorage$1,
		    _support: isWebSQLValid(),
		    iterate: iterate$1,
		    getItem: getItem$1,
		    setItem: setItem$1,
		    removeItem: removeItem$1,
		    clear: clear$1,
		    length: length$1,
		    key: key$1,
		    keys: keys$1,
		    dropInstance: dropInstance$1
		};

		function isLocalStorageValid() {
		    try {
		        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
		        // in IE8 typeof localStorage.setItem === 'object'
		        !!localStorage.setItem;
		    } catch (e) {
		        return false;
		    }
		}

		function _getKeyPrefix(options, defaultConfig) {
		    var keyPrefix = options.name + '/';

		    if (options.storeName !== defaultConfig.storeName) {
		        keyPrefix += options.storeName + '/';
		    }
		    return keyPrefix;
		}

		// Check if localStorage throws when saving an item
		function checkIfLocalStorageThrows() {
		    var localStorageTestKey = '_localforage_support_test';

		    try {
		        localStorage.setItem(localStorageTestKey, true);
		        localStorage.removeItem(localStorageTestKey);

		        return false;
		    } catch (e) {
		        return true;
		    }
		}

		// Check if localStorage is usable and allows to save an item
		// This method checks if localStorage is usable in Safari Private Browsing
		// mode, or in any other case where the available quota for localStorage
		// is 0 and there wasn't any saved items yet.
		function _isLocalStorageUsable() {
		    return !checkIfLocalStorageThrows() || localStorage.length > 0;
		}

		// Config the localStorage backend, using options set in the config.
		function _initStorage$2(options) {
		    var self = this;
		    var dbInfo = {};
		    if (options) {
		        for (var i in options) {
		            dbInfo[i] = options[i];
		        }
		    }

		    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

		    if (!_isLocalStorageUsable()) {
		        return Promise$1.reject();
		    }

		    self._dbInfo = dbInfo;
		    dbInfo.serializer = localforageSerializer;

		    return Promise$1.resolve();
		}

		// Remove all keys from the datastore, effectively destroying all data in
		// the app's key/value store!
		function clear$2(callback) {
		    var self = this;
		    var promise = self.ready().then(function () {
		        var keyPrefix = self._dbInfo.keyPrefix;

		        for (var i = localStorage.length - 1; i >= 0; i--) {
		            var key = localStorage.key(i);

		            if (key.indexOf(keyPrefix) === 0) {
		                localStorage.removeItem(key);
		            }
		        }
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Retrieve an item from the store. Unlike the original async_storage
		// library in Gaia, we don't modify return values at all. If a key's value
		// is `undefined`, we pass that value to the callback function.
		function getItem$2(key, callback) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = self.ready().then(function () {
		        var dbInfo = self._dbInfo;
		        var result = localStorage.getItem(dbInfo.keyPrefix + key);

		        // If a result was found, parse it from the serialized
		        // string into a JS object. If result isn't truthy, the key
		        // is likely undefined and we'll pass it straight to the
		        // callback.
		        if (result) {
		            result = dbInfo.serializer.deserialize(result);
		        }

		        return result;
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Iterate over all items in the store.
		function iterate$2(iterator, callback) {
		    var self = this;

		    var promise = self.ready().then(function () {
		        var dbInfo = self._dbInfo;
		        var keyPrefix = dbInfo.keyPrefix;
		        var keyPrefixLength = keyPrefix.length;
		        var length = localStorage.length;

		        // We use a dedicated iterator instead of the `i` variable below
		        // so other keys we fetch in localStorage aren't counted in
		        // the `iterationNumber` argument passed to the `iterate()`
		        // callback.
		        //
		        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
		        var iterationNumber = 1;

		        for (var i = 0; i < length; i++) {
		            var key = localStorage.key(i);
		            if (key.indexOf(keyPrefix) !== 0) {
		                continue;
		            }
		            var value = localStorage.getItem(key);

		            // If a result was found, parse it from the serialized
		            // string into a JS object. If result isn't truthy, the
		            // key is likely undefined and we'll pass it straight
		            // to the iterator.
		            if (value) {
		                value = dbInfo.serializer.deserialize(value);
		            }

		            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

		            if (value !== void 0) {
		                return value;
		            }
		        }
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Same as localStorage's key() method, except takes a callback.
		function key$2(n, callback) {
		    var self = this;
		    var promise = self.ready().then(function () {
		        var dbInfo = self._dbInfo;
		        var result;
		        try {
		            result = localStorage.key(n);
		        } catch (error) {
		            result = null;
		        }

		        // Remove the prefix from the key, if a key is found.
		        if (result) {
		            result = result.substring(dbInfo.keyPrefix.length);
		        }

		        return result;
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function keys$2(callback) {
		    var self = this;
		    var promise = self.ready().then(function () {
		        var dbInfo = self._dbInfo;
		        var length = localStorage.length;
		        var keys = [];

		        for (var i = 0; i < length; i++) {
		            var itemKey = localStorage.key(i);
		            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
		                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
		            }
		        }

		        return keys;
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Supply the number of keys in the datastore to the callback function.
		function length$2(callback) {
		    var self = this;
		    var promise = self.keys().then(function (keys) {
		        return keys.length;
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Remove an item from the store, nice and simple.
		function removeItem$2(key, callback) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = self.ready().then(function () {
		        var dbInfo = self._dbInfo;
		        localStorage.removeItem(dbInfo.keyPrefix + key);
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		// Set a key's value and run an optional callback once the value is set.
		// Unlike Gaia's implementation, the callback function is passed the value,
		// in case you want to operate on that value only after you're sure it
		// saved, or something like that.
		function setItem$2(key, value, callback) {
		    var self = this;

		    key = normalizeKey(key);

		    var promise = self.ready().then(function () {
		        // Convert undefined values to null.
		        // https://github.com/mozilla/localForage/pull/42
		        if (value === undefined) {
		            value = null;
		        }

		        // Save the original value to pass to the callback.
		        var originalValue = value;

		        return new Promise$1(function (resolve, reject) {
		            var dbInfo = self._dbInfo;
		            dbInfo.serializer.serialize(value, function (value, error) {
		                if (error) {
		                    reject(error);
		                } else {
		                    try {
		                        localStorage.setItem(dbInfo.keyPrefix + key, value);
		                        resolve(originalValue);
		                    } catch (e) {
		                        // localStorage capacity exceeded.
		                        // TODO: Make this a specific error/event.
		                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
		                            reject(e);
		                        }
		                        reject(e);
		                    }
		                }
		            });
		        });
		    });

		    executeCallback(promise, callback);
		    return promise;
		}

		function dropInstance$2(options, callback) {
		    callback = getCallback.apply(this, arguments);

		    options = typeof options !== 'function' && options || {};
		    if (!options.name) {
		        var currentConfig = this.config();
		        options.name = options.name || currentConfig.name;
		        options.storeName = options.storeName || currentConfig.storeName;
		    }

		    var self = this;
		    var promise;
		    if (!options.name) {
		        promise = Promise$1.reject('Invalid arguments');
		    } else {
		        promise = new Promise$1(function (resolve) {
		            if (!options.storeName) {
		                resolve(options.name + '/');
		            } else {
		                resolve(_getKeyPrefix(options, self._defaultConfig));
		            }
		        }).then(function (keyPrefix) {
		            for (var i = localStorage.length - 1; i >= 0; i--) {
		                var key = localStorage.key(i);

		                if (key.indexOf(keyPrefix) === 0) {
		                    localStorage.removeItem(key);
		                }
		            }
		        });
		    }

		    executeCallback(promise, callback);
		    return promise;
		}

		var localStorageWrapper = {
		    _driver: 'localStorageWrapper',
		    _initStorage: _initStorage$2,
		    _support: isLocalStorageValid(),
		    iterate: iterate$2,
		    getItem: getItem$2,
		    setItem: setItem$2,
		    removeItem: removeItem$2,
		    clear: clear$2,
		    length: length$2,
		    key: key$2,
		    keys: keys$2,
		    dropInstance: dropInstance$2
		};

		var sameValue = function sameValue(x, y) {
		    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
		};

		var includes = function includes(array, searchElement) {
		    var len = array.length;
		    var i = 0;
		    while (i < len) {
		        if (sameValue(array[i], searchElement)) {
		            return true;
		        }
		        i++;
		    }

		    return false;
		};

		var isArray = Array.isArray || function (arg) {
		    return Object.prototype.toString.call(arg) === '[object Array]';
		};

		// Drivers are stored here when `defineDriver()` is called.
		// They are shared across all instances of localForage.
		var DefinedDrivers = {};

		var DriverSupport = {};

		var DefaultDrivers = {
		    INDEXEDDB: asyncStorage,
		    WEBSQL: webSQLStorage,
		    LOCALSTORAGE: localStorageWrapper
		};

		var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

		var OptionalDriverMethods = ['dropInstance'];

		var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

		var DefaultConfig = {
		    description: '',
		    driver: DefaultDriverOrder.slice(),
		    name: 'localforage',
		    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
		    // we can use without a prompt.
		    size: 4980736,
		    storeName: 'keyvaluepairs',
		    version: 1.0
		};

		function callWhenReady(localForageInstance, libraryMethod) {
		    localForageInstance[libraryMethod] = function () {
		        var _args = arguments;
		        return localForageInstance.ready().then(function () {
		            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
		        });
		    };
		}

		function extend() {
		    for (var i = 1; i < arguments.length; i++) {
		        var arg = arguments[i];

		        if (arg) {
		            for (var _key in arg) {
		                if (arg.hasOwnProperty(_key)) {
		                    if (isArray(arg[_key])) {
		                        arguments[0][_key] = arg[_key].slice();
		                    } else {
		                        arguments[0][_key] = arg[_key];
		                    }
		                }
		            }
		        }
		    }

		    return arguments[0];
		}

		var LocalForage = function () {
		    function LocalForage(options) {
		        _classCallCheck(this, LocalForage);

		        for (var driverTypeKey in DefaultDrivers) {
		            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
		                var driver = DefaultDrivers[driverTypeKey];
		                var driverName = driver._driver;
		                this[driverTypeKey] = driverName;

		                if (!DefinedDrivers[driverName]) {
		                    // we don't need to wait for the promise,
		                    // since the default drivers can be defined
		                    // in a blocking manner
		                    this.defineDriver(driver);
		                }
		            }
		        }

		        this._defaultConfig = extend({}, DefaultConfig);
		        this._config = extend({}, this._defaultConfig, options);
		        this._driverSet = null;
		        this._initDriver = null;
		        this._ready = false;
		        this._dbInfo = null;

		        this._wrapLibraryMethodsWithReady();
		        this.setDriver(this._config.driver)["catch"](function () {});
		    }

		    // Set any config values for localForage; can be called anytime before
		    // the first API call (e.g. `getItem`, `setItem`).
		    // We loop through options so we don't overwrite existing config
		    // values.


		    LocalForage.prototype.config = function config(options) {
		        // If the options argument is an object, we use it to set values.
		        // Otherwise, we return either a specified config value or all
		        // config values.
		        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
		            // If localforage is ready and fully initialized, we can't set
		            // any new configuration values. Instead, we return an error.
		            if (this._ready) {
		                return new Error("Can't call config() after localforage " + 'has been used.');
		            }

		            for (var i in options) {
		                if (i === 'storeName') {
		                    options[i] = options[i].replace(/\W/g, '_');
		                }

		                if (i === 'version' && typeof options[i] !== 'number') {
		                    return new Error('Database version must be a number.');
		                }

		                this._config[i] = options[i];
		            }

		            // after all config options are set and
		            // the driver option is used, try setting it
		            if ('driver' in options && options.driver) {
		                return this.setDriver(this._config.driver);
		            }

		            return true;
		        } else if (typeof options === 'string') {
		            return this._config[options];
		        } else {
		            return this._config;
		        }
		    };

		    // Used to define a custom driver, shared across all instances of
		    // localForage.


		    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
		        var promise = new Promise$1(function (resolve, reject) {
		            try {
		                var driverName = driverObject._driver;
		                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

		                // A driver name should be defined and not overlap with the
		                // library-defined, default drivers.
		                if (!driverObject._driver) {
		                    reject(complianceError);
		                    return;
		                }

		                var driverMethods = LibraryMethods.concat('_initStorage');
		                for (var i = 0, len = driverMethods.length; i < len; i++) {
		                    var driverMethodName = driverMethods[i];

		                    // when the property is there,
		                    // it should be a method even when optional
		                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
		                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
		                        reject(complianceError);
		                        return;
		                    }
		                }

		                var configureMissingMethods = function configureMissingMethods() {
		                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
		                        return function () {
		                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
		                            var promise = Promise$1.reject(error);
		                            executeCallback(promise, arguments[arguments.length - 1]);
		                            return promise;
		                        };
		                    };

		                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
		                        var optionalDriverMethod = OptionalDriverMethods[_i];
		                        if (!driverObject[optionalDriverMethod]) {
		                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
		                        }
		                    }
		                };

		                configureMissingMethods();

		                var setDriverSupport = function setDriverSupport(support) {
		                    if (DefinedDrivers[driverName]) {
		                        console.info('Redefining LocalForage driver: ' + driverName);
		                    }
		                    DefinedDrivers[driverName] = driverObject;
		                    DriverSupport[driverName] = support;
		                    // don't use a then, so that we can define
		                    // drivers that have simple _support methods
		                    // in a blocking manner
		                    resolve();
		                };

		                if ('_support' in driverObject) {
		                    if (driverObject._support && typeof driverObject._support === 'function') {
		                        driverObject._support().then(setDriverSupport, reject);
		                    } else {
		                        setDriverSupport(!!driverObject._support);
		                    }
		                } else {
		                    setDriverSupport(true);
		                }
		            } catch (e) {
		                reject(e);
		            }
		        });

		        executeTwoCallbacks(promise, callback, errorCallback);
		        return promise;
		    };

		    LocalForage.prototype.driver = function driver() {
		        return this._driver || null;
		    };

		    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
		        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

		        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
		        return getDriverPromise;
		    };

		    LocalForage.prototype.getSerializer = function getSerializer(callback) {
		        var serializerPromise = Promise$1.resolve(localforageSerializer);
		        executeTwoCallbacks(serializerPromise, callback);
		        return serializerPromise;
		    };

		    LocalForage.prototype.ready = function ready(callback) {
		        var self = this;

		        var promise = self._driverSet.then(function () {
		            if (self._ready === null) {
		                self._ready = self._initDriver();
		            }

		            return self._ready;
		        });

		        executeTwoCallbacks(promise, callback, callback);
		        return promise;
		    };

		    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
		        var self = this;

		        if (!isArray(drivers)) {
		            drivers = [drivers];
		        }

		        var supportedDrivers = this._getSupportedDrivers(drivers);

		        function setDriverToConfig() {
		            self._config.driver = self.driver();
		        }

		        function extendSelfWithDriver(driver) {
		            self._extend(driver);
		            setDriverToConfig();

		            self._ready = self._initStorage(self._config);
		            return self._ready;
		        }

		        function initDriver(supportedDrivers) {
		            return function () {
		                var currentDriverIndex = 0;

		                function driverPromiseLoop() {
		                    while (currentDriverIndex < supportedDrivers.length) {
		                        var driverName = supportedDrivers[currentDriverIndex];
		                        currentDriverIndex++;

		                        self._dbInfo = null;
		                        self._ready = null;

		                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
		                    }

		                    setDriverToConfig();
		                    var error = new Error('No available storage method found.');
		                    self._driverSet = Promise$1.reject(error);
		                    return self._driverSet;
		                }

		                return driverPromiseLoop();
		            };
		        }

		        // There might be a driver initialization in progress
		        // so wait for it to finish in order to avoid a possible
		        // race condition to set _dbInfo
		        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
		            return Promise$1.resolve();
		        }) : Promise$1.resolve();

		        this._driverSet = oldDriverSetDone.then(function () {
		            var driverName = supportedDrivers[0];
		            self._dbInfo = null;
		            self._ready = null;

		            return self.getDriver(driverName).then(function (driver) {
		                self._driver = driver._driver;
		                setDriverToConfig();
		                self._wrapLibraryMethodsWithReady();
		                self._initDriver = initDriver(supportedDrivers);
		            });
		        })["catch"](function () {
		            setDriverToConfig();
		            var error = new Error('No available storage method found.');
		            self._driverSet = Promise$1.reject(error);
		            return self._driverSet;
		        });

		        executeTwoCallbacks(this._driverSet, callback, errorCallback);
		        return this._driverSet;
		    };

		    LocalForage.prototype.supports = function supports(driverName) {
		        return !!DriverSupport[driverName];
		    };

		    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
		        extend(this, libraryMethodsAndProperties);
		    };

		    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
		        var supportedDrivers = [];
		        for (var i = 0, len = drivers.length; i < len; i++) {
		            var driverName = drivers[i];
		            if (this.supports(driverName)) {
		                supportedDrivers.push(driverName);
		            }
		        }
		        return supportedDrivers;
		    };

		    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
		        // Add a stub for each driver API method that delays the call to the
		        // corresponding driver method until localForage is ready. These stubs
		        // will be replaced by the driver methods as soon as the driver is
		        // loaded, so there is no performance impact.
		        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
		            callWhenReady(this, LibraryMethods[i]);
		        }
		    };

		    LocalForage.prototype.createInstance = function createInstance(options) {
		        return new LocalForage(options);
		    };

		    return LocalForage;
		}();

		// The actual localForage object that we expose as a module or via a
		// global. It's extended by pulling in one of our other libraries.


		var localforage_js = new LocalForage();

		module.exports = localforage_js;

		},{"3":3}]},{},[4])(4)
		}); 
	} (skeletor_esm_localforage));
	return skeletor_esm_localforage.exports;
}

var localforageExports = requireLocalforage();
var localForage = /*@__PURE__*/getDefaultExportFromCjs(localforageExports);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$8 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$1) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$7.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = skeletor_esm_isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (skeletor_esm_isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject$1(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject$1(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function skeletor_esm_identity(value) {
  return value;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? skeletor_esm_identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, skeletor_esm_identity), func + '');
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject$1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var skeletor_esm_merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

function getOpenPromise() {
    const wrapper = {
        isResolved: false,
        isPending: true,
        isRejected: false
    };
    let promise;
    let resolve = () => { };
    let reject = () => { };
    if (typeof Promise.withResolvers === 'function') {
        const { promise: p, resolve: r, reject: j } = Promise.withResolvers();
        promise = p;
        resolve = r;
        reject = j;
    }
    else {
        promise = new Promise((r, j) => {
            resolve = r;
            reject = j;
        });
    }
    Object.assign(promise, {
        ...wrapper,
        resolve,
        reject
    });
    promise.then((v) => {
        promise.isResolved = true;
        promise.isPending = false;
        promise.isRejected = false;
        return v;
    }, (e) => {
        promise.isResolved = false;
        promise.isPending = false;
        promise.isRejected = true;
        throw e;
    });
    return promise;
}

/** Error message constants. */
const FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
const nativeMax = Math.max;
const nativeMin = Math.min;

function toNumber(value) {
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
}

function isObject(value) {
  const type = typeof value;
  return value != null && (type === 'object' || type === 'function');
}

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 *
 * This function differs from lodash's debounce by merging all passed objects
 * before passing them to the final invoked function.
 *
 * Because of this, invoking can only happen on the trailing edge, since
 * passed-in data would be discarded if invoking happened on the leading edge.
 *
 * If `wait` is `0`, `func` invocation is deferred until to the next tick,
 * similar to `setTimeout` with a timeout of `0`.
 *
 * @static
 * @category Function
 * @param {Function} func The function to mergebounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.concatArrays=false]
 *  By default arrays will be treated as objects when being merged. When
 *  merging two arrays, the values in the 2nd arrray will replace the
 *  corresponding values (i.e. those with the same indexes) in the first array.
 *  When `concatArrays` is set to `true`, arrays will be concatenated instead.
 * @param {boolean} [options.dedupeArrays=false]
 *  This option is similar to `concatArrays`, except that the concatenated
 *  array will also be deduplicated. Thus any entries that are concatenated to the
 *  existing array, which are already contained in the existing array, will
 *  first be removed.
 * @param {boolean} [options.promise=false]
 *  By default, when calling a merge-debounced function that doesn't execute
 *  immediately, you'll receive the result from its previous execution, or
 *  `undefined` if it has never executed before. By setting the `promise`
 *  option to `true`, a promise will be returned instead of the previous
 *  execution result when the function is debounced. The promise will resolve
 *  with the result of the next execution, as soon as it happens.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * window.addEventListener('resize', mergebounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * element.addEventListner('click', mergebounce(sendMail, 300));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * const mergebounced = mergebounce(batchLog, 250, { 'maxWait': 1000 });
 * const source = new EventSource('/stream');
 * jQuery(source).on('message', mergebounced);
 *
 * // Cancel the trailing debounced invocation.
 * window.addEventListener('popstate', mergebounced.cancel);
 */
function mergebounce(func, wait, options={}) {
  let lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      maxing = false;

  let promise = options.promise ? getOpenPromise() : null;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
  }

  function invokeFunc(time) {
    const args = lastArgs;
    const thisArg = lastThis;
    const existingPromise = promise;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    if (options.promise) {
      existingPromise.resolve(result);
      promise = getOpenPromise();
    }
    return options.promise ? existingPromise : result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    return options.promise ? promise : result;
  }

  function remainingWait(time) {
    const timeSinceLastCall = time - lastCallTime;
    const timeSinceLastInvoke = time - lastInvokeTime;
    const timeWaiting = wait - timeSinceLastCall;
    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    const timeSinceLastCall = time - lastCallTime;
    const timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    const time = Date.now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return options.promise ? promise : result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Date.now());
  }

  function concatArrays(objValue, srcValue) {
    if (Array.isArray(objValue) && Array.isArray(srcValue)) {
      if (options?.dedupeArrays) {
        return objValue.concat(srcValue.filter(i => objValue.indexOf(i) === -1));
      } else {
        return objValue.concat(srcValue);
      }
    }
  }

  function mergeArguments(args) {
    if (lastArgs?.length) {
      if (!args.length) {
        return lastArgs;
      }
      if (options?.concatArrays || options?.dedupeArrays) {
        return mergeWith(lastArgs, args, concatArrays);
      } else {
        return skeletor_esm_merge(lastArgs, args);
      }
    } else {
      return args || [];
    }
  }

  function debounced() {
    const time = Date.now();
    const isInvoking = shouldInvoke(time);

    lastArgs = mergeArguments(Array.from(arguments));
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return options.promise ? promise : result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

function chainCallback(promise, callback) {
    if (callback) {
        promise.then((result) => callback(null, result), (err) => callback(err));
    }
}
function skeletor_esm_getCallback(...args) {
    if (args.length && typeof args[args.length - 1] === 'function') {
        return args[args.length - 1];
    }
}
function skeletor_esm_normalizeKey(key) {
    if (typeof key !== 'string') {
        console.warn(`${key} used as a key, but it is not a string.`);
        key = String(key);
    }
    return key;
}
function serializeSync(value) {
    return JSON.stringify(value, (_key, val) => {
        if (val instanceof Date) {
            return val.toISOString();
        }
        return val;
    });
}
function skeletor_esm_serialize(value, callback) {
    try {
        callback(serializeSync(value), null);
    }
    catch (e) {
        callback('', e);
    }
}
function skeletor_esm_deserialize(value) {
    return JSON.parse(value);
}

// Copyright 2014 Mozilla
// Copyright 2015 Thodoris Greasidis
// Copyright 2018-2025 JC Brand
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function isSessionStorageValid() {
    try {
        if (sessionStorage && 'setItem' in sessionStorage) {
            return true;
        }
    }
    catch (e) {
        console.log(e);
    }
    return false;
}
function skeletor_esm_getKeyPrefix(options, defaultConfig) {
    let keyPrefix = options.name + '/';
    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}
const skeletor_esm_dbInfo = {
    keyPrefix: '',
    serializer: {
        serialize: skeletor_esm_serialize,
        deserialize: skeletor_esm_deserialize,
    },
};
function skeletor_esm_initStorage(options) {
    skeletor_esm_dbInfo.keyPrefix = skeletor_esm_getKeyPrefix(options, this._defaultConfig);
    if (options) {
        for (const i in options) {
            skeletor_esm_dbInfo[i] = options[i];
        }
    }
}
// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function skeletor_esm_clear(callback) {
    const promise = this.ready().then(function () {
        const keyPrefix = skeletor_esm_dbInfo.keyPrefix;
        for (let i = sessionStorage.length - 1; i >= 0; i--) {
            const key = sessionStorage.key(i);
            if (key && key.indexOf(keyPrefix) === 0) {
                sessionStorage.removeItem(key);
            }
        }
    });
    chainCallback(promise, callback);
    return promise;
}
function skeletor_esm_getItem(key, callback) {
    key = skeletor_esm_normalizeKey(key);
    const promise = this.ready().then(function () {
        const result = sessionStorage.getItem(skeletor_esm_dbInfo.keyPrefix + key);
        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            return skeletor_esm_dbInfo.serializer.deserialize(result);
        }
        return null;
    });
    chainCallback(promise, callback);
    return promise;
}
function skeletor_esm_iterate(iterator, callback) {
    const self = this;
    const promise = self.ready().then(function () {
        const keyPrefix = skeletor_esm_dbInfo.keyPrefix;
        const keyPrefixLength = keyPrefix.length;
        const length = sessionStorage.length;
        let iterationNumber = 1;
        for (let i = 0; i < length; i++) {
            const key = sessionStorage.key(i);
            if (!key || key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            const item = sessionStorage.getItem(key);
            const value = item ? skeletor_esm_dbInfo.serializer.deserialize(item) : item;
            const result = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
            if (result !== void 0) {
                return result;
            }
        }
        return;
    });
    chainCallback(promise, callback);
    return promise;
}
// Same as sessionStorage's key() method, except takes a callback.
function skeletor_esm_key(n, callback) {
    const self = this;
    const promise = self.ready().then(function () {
        let result;
        try {
            result = sessionStorage.key(n);
        }
        catch (error) {
            result = null;
        }
        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(skeletor_esm_dbInfo.keyPrefix.length);
        }
        return result;
    });
    chainCallback(promise, callback);
    return promise;
}
function skeletor_esm_keys(callback) {
    const self = this;
    const promise = self.ready().then(function () {
        const length = sessionStorage.length;
        const keys = [];
        for (let i = 0; i < length; i++) {
            const itemKey = sessionStorage.key(i);
            if (itemKey && itemKey.indexOf(skeletor_esm_dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(skeletor_esm_dbInfo.keyPrefix.length));
            }
        }
        return keys;
    });
    chainCallback(promise, callback);
    return promise;
}
// Supply the number of keys in the datastore to the callback function.
function skeletor_esm_length(callback) {
    const self = this;
    const promise = self.keys().then(function (keys) {
        return keys.length;
    });
    chainCallback(promise, callback);
    return promise;
}
function skeletor_esm_removeItem(key, callback) {
    key = skeletor_esm_normalizeKey(key);
    const promise = this.ready().then(function () {
        sessionStorage.removeItem(skeletor_esm_dbInfo.keyPrefix + key);
    });
    chainCallback(promise, callback);
    return promise;
}
async function skeletor_esm_setItem(key, value, callback) {
    key = skeletor_esm_normalizeKey(key);
    await this.ready();
    value = value ?? null;
    const originalValue = value;
    return new Promise((resolve, reject) => {
        skeletor_esm_dbInfo.serializer.serialize(value, (serializedValue, error) => {
            if (error) {
                reject(error);
                chainCallback(Promise.reject(error), callback);
                return;
            }
            try {
                sessionStorage.setItem(skeletor_esm_dbInfo.keyPrefix + key, serializedValue);
                resolve(originalValue);
                chainCallback(Promise.resolve(originalValue), callback);
            }
            catch (e) {
                if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                    console.error('Your sessionStorage capacity is used up.');
                }
                reject(e);
                chainCallback(Promise.reject(e), callback);
            }
        });
    });
}
function skeletor_esm_dropInstance(...args) {
    const callback = skeletor_esm_getCallback(...args);
    let options = (typeof args[0] !== 'function' && args[0]) || {};
    if (!options.name) {
        const currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }
    const self = this;
    let promise;
    if (!options.name) {
        promise = Promise.reject(new Error('Invalid arguments'));
    }
    else {
        promise = new Promise(function (resolve) {
            if (!options.storeName) {
                resolve(`${options.name}/`);
            }
            else {
                resolve(skeletor_esm_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (let i = sessionStorage.length - 1; i >= 0; i--) {
                const key = sessionStorage.key(i);
                if (key && key.indexOf(keyPrefix) === 0) {
                    sessionStorage.removeItem(key);
                }
            }
        });
    }
    chainCallback(promise, callback);
    return promise;
}
const sessionStorageWrapper = {
    _driver: 'sessionStorageWrapper',
    _initStorage: skeletor_esm_initStorage,
    _support: isSessionStorageValid(),
    iterate: skeletor_esm_iterate,
    getItem: skeletor_esm_getItem,
    setItem: skeletor_esm_setItem,
    removeItem: skeletor_esm_removeItem,
    clear: skeletor_esm_clear,
    length: skeletor_esm_length,
    key: skeletor_esm_key,
    keys: skeletor_esm_keys,
    dropInstance: skeletor_esm_dropInstance,
};

var localforageSetitems$1 = {exports: {}};

var localforageSetitems = localforageSetitems$1.exports;

var hasRequiredLocalforageSetitems;

function requireLocalforageSetitems () {
	if (hasRequiredLocalforageSetitems) return localforageSetitems$1.exports;
	hasRequiredLocalforageSetitems = 1;
	(function (module, exports) {
		(function (global, factory) {
		    factory(exports, requireLocalforage()) ;
		}(localforageSetitems, (function (exports,localforage) {
		localforage = 'default' in localforage ? localforage['default'] : localforage;

		function getSerializerPromise(localForageInstance) {
		    if (getSerializerPromise.result) {
		        return getSerializerPromise.result;
		    }
		    if (!localForageInstance || typeof localForageInstance.getSerializer !== 'function') {
		        return Promise.reject(new Error('localforage.getSerializer() was not available! ' + 'localforage v1.4+ is required!'));
		    }
		    getSerializerPromise.result = localForageInstance.getSerializer();
		    return getSerializerPromise.result;
		}



		function executeCallback(promise, callback) {
		    if (callback) {
		        promise.then(function (result) {
		            callback(null, result);
		        }, function (error) {
		            callback(error);
		        });
		    }
		}

		function forEachItem(items, keyFn, valueFn, loopFn) {
		    function ensurePropGetterMethod(propFn, defaultPropName) {
		        var propName = propFn || defaultPropName;

		        if ((!propFn || typeof propFn !== 'function') && typeof propName === 'string') {
		            propFn = function propFn(item) {
		                return item[propName];
		            };
		        }
		        return propFn;
		    }

		    var result = [];
		    // http://stackoverflow.com/questions/4775722/check-if-object-is-array
		    if (Object.prototype.toString.call(items) === '[object Array]') {
		        keyFn = ensurePropGetterMethod(keyFn, 'key');
		        valueFn = ensurePropGetterMethod(valueFn, 'value');

		        for (var i = 0, len = items.length; i < len; i++) {
		            var item = items[i];
		            result.push(loopFn(keyFn(item), valueFn(item)));
		        }
		    } else {
		        for (var prop in items) {
		            if (items.hasOwnProperty(prop)) {
		                result.push(loopFn(prop, items[prop]));
		            }
		        }
		    }
		    return result;
		}

		function setItemsIndexedDB(items, keyFn, valueFn, callback) {
		    var localforageInstance = this;

		    var promise = localforageInstance.ready().then(function () {
		        return new Promise(function (resolve, reject) {
		            // Inspired from @lu4 PR mozilla/localForage#318
		            var dbInfo = localforageInstance._dbInfo;
		            var transaction = dbInfo.db.transaction(dbInfo.storeName, 'readwrite');
		            var store = transaction.objectStore(dbInfo.storeName);
		            var lastError;

		            transaction.oncomplete = function () {
		                resolve(items);
		            };
		            transaction.onabort = transaction.onerror = function (event) {
		                reject(lastError || event.target);
		            };

		            function requestOnError(evt) {
		                var request = evt.target || this;
		                lastError = request.error || request.transaction.error;
		                reject(lastError);
		            }

		            forEachItem(items, keyFn, valueFn, function (key, value) {
		                // The reason we don't _save_ null is because IE 10 does
		                // not support saving the `null` type in IndexedDB. How
		                // ironic, given the bug below!
		                // See: https://github.com/mozilla/localForage/issues/161
		                if (value === null) {
		                    value = undefined;
		                }
		                var request = store.put(value, key);
		                request.onerror = requestOnError;
		            });
		        });
		    });
		    executeCallback(promise, callback);
		    return promise;
		}

		function setItemsWebsql(items, keyFn, valueFn, callback) {
		    var localforageInstance = this;
		    var promise = new Promise(function (resolve, reject) {
		        localforageInstance.ready().then(function () {
		            return getSerializerPromise(localforageInstance);
		        }).then(function (serializer) {
		            // Inspired from @lu4 PR mozilla/localForage#318
		            var dbInfo = localforageInstance._dbInfo;
		            dbInfo.db.transaction(function (t) {

		                var query = 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' (key, value) VALUES (?, ?)';

		                var itemPromises = forEachItem(items, keyFn, valueFn, function (key, value) {
		                    return new Promise(function (resolve, reject) {
		                        serializer.serialize(value, function (value, error) {
		                            if (error) {
		                                reject(error);
		                            } else {
		                                t.executeSql(query, [key, value], function () {
		                                    resolve();
		                                }, function (t, error) {
		                                    reject(error);
		                                });
		                            }
		                        });
		                    });
		                });

		                Promise.all(itemPromises).then(function () {
		                    resolve(items);
		                }, reject);
		            }, function (sqlError) {
		                reject(sqlError);
		            } /*, function() {
		                 if (resolving) {
		                     resolve(items);
		                 }
		              }*/);
		        }).catch(reject);
		    });
		    executeCallback(promise, callback);
		    return promise;
		}

		function setItemsGeneric(items, keyFn, valueFn, callback) {
		    var localforageInstance = this;

		    var itemPromises = forEachItem(items, keyFn, valueFn, function (key, value) {
		        return localforageInstance.setItem(key, value);
		    });
		    var promise = Promise.all(itemPromises);

		    executeCallback(promise, callback);
		    return promise;
		}

		function localforageSetItems(items, keyFn, valueFn, callback) {
		    var localforageInstance = this;
		    var currentDriver = localforageInstance.driver();

		    if (currentDriver === localforageInstance.INDEXEDDB) {
		        return setItemsIndexedDB.call(localforageInstance, items, keyFn, valueFn, callback);
		    } else if (currentDriver === localforageInstance.WEBSQL) {
		        return setItemsWebsql.call(localforageInstance, items, keyFn, valueFn, callback);
		    } else {
		        return setItemsGeneric.call(localforageInstance, items, keyFn, valueFn, callback);
		    }
		}

		function extendPrototype(localforage$$1) {
		    var localforagePrototype = Object.getPrototypeOf(localforage$$1);
		    if (localforagePrototype) {
		        localforagePrototype.setItems = localforageSetItems;
		        localforagePrototype.setItems.indexedDB = function () {
		            return setItemsIndexedDB.apply(this, arguments);
		        };
		        localforagePrototype.setItems.websql = function () {
		            return setItemsWebsql.apply(this, arguments);
		        };
		        localforagePrototype.setItems.generic = function () {
		            return setItemsGeneric.apply(this, arguments);
		        };
		    }
		}

		var extendPrototypeResult = extendPrototype(localforage);

		exports.setItemsGeneric = setItemsGeneric;
		exports.localforageSetItems = localforageSetItems;
		exports.extendPrototype = extendPrototype;
		exports.extendPrototypeResult = extendPrototypeResult;

		Object.defineProperty(exports, '__esModule', { value: true });

		}))); 
	} (localforageSetitems$1, localforageSetitems$1.exports));
	return localforageSetitems$1.exports;
}

var localforageSetitemsExports = requireLocalforageSetitems();

var localforageGetitems$1 = {exports: {}};

var localforageGetitems = localforageGetitems$1.exports;

var hasRequiredLocalforageGetitems;

function requireLocalforageGetitems () {
	if (hasRequiredLocalforageGetitems) return localforageGetitems$1.exports;
	hasRequiredLocalforageGetitems = 1;
	(function (module, exports) {
		(function (global, factory) {
		    factory(exports, requireLocalforage()) ;
		}(localforageGetitems, (function (exports,localforage) {
		localforage = 'default' in localforage ? localforage['default'] : localforage;

		function getSerializerPromise(localForageInstance) {
		    if (getSerializerPromise.result) {
		        return getSerializerPromise.result;
		    }
		    if (!localForageInstance || typeof localForageInstance.getSerializer !== 'function') {
		        return Promise.reject(new Error('localforage.getSerializer() was not available! ' + 'localforage v1.4+ is required!'));
		    }
		    getSerializerPromise.result = localForageInstance.getSerializer();
		    return getSerializerPromise.result;
		}



		function executeCallback(promise, callback) {
		    if (callback) {
		        promise.then(function (result) {
		            callback(null, result);
		        }, function (error) {
		            callback(error);
		        });
		    }
		    return promise;
		}

		function getItemKeyValue(key, callback) {
		    var localforageInstance = this;
		    var promise = localforageInstance.getItem(key).then(function (value) {
		        return {
		            key: key,
		            value: value
		        };
		    });
		    executeCallback(promise, callback);
		    return promise;
		}

		function getItemsGeneric(keys /*, callback*/) {
		    var localforageInstance = this;
		    var promise = new Promise(function (resolve, reject) {
		        var itemPromises = [];

		        for (var i = 0, len = keys.length; i < len; i++) {
		            itemPromises.push(getItemKeyValue.call(localforageInstance, keys[i]));
		        }

		        Promise.all(itemPromises).then(function (keyValuePairs) {
		            var result = {};
		            for (var i = 0, len = keyValuePairs.length; i < len; i++) {
		                var keyValuePair = keyValuePairs[i];

		                result[keyValuePair.key] = keyValuePair.value;
		            }
		            resolve(result);
		        }).catch(reject);
		    });
		    return promise;
		}





		function getAllItemsUsingIterate() {
		    var localforageInstance = this;
		    var accumulator = {};
		    return localforageInstance.iterate(function (value, key /*, iterationNumber*/) {
		        accumulator[key] = value;
		    }).then(function () {
		        return accumulator;
		    });
		}

		function getIDBKeyRange() {
		    /* global IDBKeyRange, webkitIDBKeyRange, mozIDBKeyRange */
		    if (typeof IDBKeyRange !== 'undefined') {
		        return IDBKeyRange;
		    }
		    if (typeof webkitIDBKeyRange !== 'undefined') {
		        return webkitIDBKeyRange;
		    }
		    if (typeof mozIDBKeyRange !== 'undefined') {
		        return mozIDBKeyRange;
		    }
		}

		var idbKeyRange = getIDBKeyRange();

		function getItemsIndexedDB(keys /*, callback*/) {
		    keys = keys.slice();
		    var localforageInstance = this;
		    function comparer(a, b) {
		        return a < b ? -1 : a > b ? 1 : 0;
		    }

		    var promise = new Promise(function (resolve, reject) {
		        localforageInstance.ready().then(function () {
		            // Thanks https://hacks.mozilla.org/2014/06/breaking-the-borders-of-indexeddb/
		            var dbInfo = localforageInstance._dbInfo;
		            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);

		            var set = keys.sort(comparer);

		            var keyRangeValue = idbKeyRange.bound(keys[0], keys[keys.length - 1], false, false);

		            var req;

		            if ('getAll' in store) {
		                req = store.getAll(keyRangeValue);
		                req.onsuccess = function () {
		                    var value = req.result;
		                    if (value === undefined) {
		                        value = null;
		                    }
		                    resolve(value);
		                };
		            } else {
		                req = store.openCursor(keyRangeValue);
		                var result = {};
		                var i = 0;

		                req.onsuccess = function () /*event*/{
		                    var cursor = req.result; // event.target.result;

		                    if (!cursor) {
		                        resolve(result);
		                        return;
		                    }

		                    var key = cursor.key;

		                    while (key > set[i]) {
		                        i++; // The cursor has passed beyond this key. Check next.

		                        if (i === set.length) {
		                            // There is no next. Stop searching.
		                            resolve(result);
		                            return;
		                        }
		                    }

		                    if (key === set[i]) {
		                        // The current cursor value should be included and we should continue
		                        // a single step in case next item has the same key or possibly our
		                        // next key in set.
		                        var value = cursor.value;
		                        if (value === undefined) {
		                            value = null;
		                        }

		                        result[key] = value;
		                        // onfound(cursor.value);
		                        cursor.continue();
		                    } else {
		                        // cursor.key not yet at set[i]. Forward cursor to the next key to hunt for.
		                        cursor.continue(set[i]);
		                    }
		                };
		            }

		            req.onerror = function () /*event*/{
		                reject(req.error);
		            };
		        }).catch(reject);
		    });
		    return promise;
		}

		function getItemsWebsql(keys /*, callback*/) {
		    var localforageInstance = this;
		    var promise = new Promise(function (resolve, reject) {
		        localforageInstance.ready().then(function () {
		            return getSerializerPromise(localforageInstance);
		        }).then(function (serializer) {
		            var dbInfo = localforageInstance._dbInfo;
		            dbInfo.db.transaction(function (t) {

		                var queryParts = new Array(keys.length);
		                for (var i = 0, len = keys.length; i < len; i++) {
		                    queryParts[i] = '?';
		                }

		                t.executeSql('SELECT * FROM ' + dbInfo.storeName + ' WHERE (key IN (' + queryParts.join(',') + '))', keys, function (t, results) {

		                    var result = {};

		                    var rows = results.rows;
		                    for (var i = 0, len = rows.length; i < len; i++) {
		                        var item = rows.item(i);
		                        var value = item.value;

		                        // Check to see if this is serialized content we need to
		                        // unpack.
		                        if (value) {
		                            value = serializer.deserialize(value);
		                        }

		                        result[item.key] = value;
		                    }

		                    resolve(result);
		                }, function (t, error) {
		                    reject(error);
		                });
		            });
		        }).catch(reject);
		    });
		    return promise;
		}

		function localforageGetItems(keys, callback) {
		    var localforageInstance = this;

		    var promise;
		    if (!arguments.length || keys === null) {
		        promise = getAllItemsUsingIterate.apply(localforageInstance);
		    } else {
		        var currentDriver = localforageInstance.driver();
		        if (currentDriver === localforageInstance.INDEXEDDB) {
		            promise = getItemsIndexedDB.apply(localforageInstance, arguments);
		        } else if (currentDriver === localforageInstance.WEBSQL) {
		            promise = getItemsWebsql.apply(localforageInstance, arguments);
		        } else {
		            promise = getItemsGeneric.apply(localforageInstance, arguments);
		        }
		    }

		    executeCallback(promise, callback);
		    return promise;
		}

		function extendPrototype(localforage$$1) {
		    var localforagePrototype = Object.getPrototypeOf(localforage$$1);
		    if (localforagePrototype) {
		        localforagePrototype.getItems = localforageGetItems;
		        localforagePrototype.getItems.indexedDB = function () {
		            return getItemsIndexedDB.apply(this, arguments);
		        };
		        localforagePrototype.getItems.websql = function () {
		            return getItemsWebsql.apply(this, arguments);
		        };
		        localforagePrototype.getItems.generic = function () {
		            return getItemsGeneric.apply(this, arguments);
		        };
		    }
		}

		var extendPrototypeResult = extendPrototype(localforage);

		exports.localforageGetItems = localforageGetItems;
		exports.extendPrototype = extendPrototype;
		exports.extendPrototypeResult = extendPrototypeResult;
		exports.getItemsGeneric = getItemsGeneric;

		Object.defineProperty(exports, '__esModule', { value: true });

		}))); 
	} (localforageGetitems$1, localforageGetitems$1.exports));
	return localforageGetitems$1.exports;
}

var localforageGetitemsExports = requireLocalforageGetitems();

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty$6.call(object, key);
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (skeletor_esm_isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (skeletor_esm_isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(skeletor_esm_toString$1(value));
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (skeletor_esm_isArray(object) || isArguments(object));
}

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function skeletor_esm_has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function skeletor_esm_result(object, path, defaultValue) {
  path = castPath(path, object);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

// (c) 2010-2019 Jeremy Ashkenas and DocumentCloud
// (c) 2018-2025 JC Brand
function S4() {
    // Generate four random hex digits.
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
function guid() {
    // Generate a pseudo-GUID by concatenating random hexadecimal.
    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}
function getResolveablePromise() {
    const wrapper = {
        isResolved: false,
        isPending: true,
        isRejected: false,
        resolve: null,
        reject: null,
    };
    const promise = new Promise((resolve, reject) => {
        wrapper.resolve = resolve;
        wrapper.reject = reject;
    });
    Object.assign(promise, wrapper);
    // This `then` only mirrors settlement into the state flags. It must NOT
    // rethrow on rejection: the derived promise is discarded, so rethrowing would
    // surface as an unhandled rejection whenever the promise is rejected. The real
    // consumer still awaits `promise` itself, which rejects normally.
    promise.then(function () {
        promise.isResolved = true;
        promise.isPending = false;
        promise.isRejected = false;
    }, function () {
        promise.isResolved = false;
        promise.isPending = false;
        promise.isRejected = true;
    });
    return promise;
}
// Throw an error when a URL is needed, and none is supplied.
function urlError() {
    throw new Error('A "url" property or function must be specified');
}
// Wrap an optional error callback with a fallback error event. When a
// `promise` is supplied (the `{ promise: true }` fetch/save path), the error is
// also forwarded to `promise.reject` so the returned promise settles on failure.
function wrapError(model, options, promise) {
    const error = options.error;
    options.error = function (resp) {
        if (error)
            error.call(options.context, model, resp, options);
        model.trigger('error', model, resp, options);
        promise && promise.reject && promise.reject(resp);
    };
}
// Map from CRUD to HTTP for our default `sync` implementation.
const methodMap = {
    create: 'POST',
    update: 'PUT',
    patch: 'PATCH',
    delete: 'DELETE',
    read: 'GET',
};
// Tracks the classes we've already warned about, so the `browserStorage`
// deprecation notice is logged at most once per class rather than once per
// instance (a collection can resolve storage once per contained model).
const warnedBrowserStorage = new WeakSet();
/**
 * Emit a one-time-per-class deprecation warning nudging downstream code from
 * the `browserStorage` alias to the canonical `storage` accessor.
 */
function warnBrowserStorageDeprecation(obj) {
    const ctor = obj?.constructor;
    if (!ctor || warnedBrowserStorage.has(ctor))
        return;
    warnedBrowserStorage.add(ctor);
    const name = ctor.name;
    console.warn(`Skeletor: \`browserStorage\` is deprecated and will be removed in a future major version; ` +
        `use \`storage\` instead${name ? ` (on \`${name}\`)` : ''}.`);
}
/**
 * Return the PersistentStorage instance configured on `obj`, checking both
 * the canonical `storage` accessor and the deprecated `browserStorage` alias
 * so that subclasses that still override `get browserStorage()` continue to work.
 * @public
 */
function getStorage(obj) {
    if (!obj)
        return undefined;
    const storage = skeletor_esm_result(obj, 'storage');
    if (storage != null)
        return storage;
    // Fall back to the deprecated alias; warn only when it actually supplies the
    // store, so storage-less models/collections don't trip the notice.
    const legacy = skeletor_esm_result(obj, 'browserStorage');
    if (legacy != null)
        warnBrowserStorageDeprecation(obj);
    return legacy;
}
function getSyncMethod(model) {
    const store = getStorage(model) || getStorage(model.collection);
    return store ? store.sync() : skeletor_esm_sync;
}
/**
 * Override this function to change the manner in which Backbone persists
 * models to the server. You will be passed the type of request, and the
 * model in question. By default makes a `fetch()` API call
 * to the model's `url()`.
 *
 * Some possible customizations could be:
 *
 * - Use `setTimeout` to batch rapid-fire updates into a single request.
 * - Persist models via WebSockets instead of Ajax.
 * - Persist models to browser storage
 */
/**
 * @public
 */
function skeletor_esm_sync(method, model, options = {}) {
    let data = options.data;
    // Ensure that we have the appropriate request data.
    if (data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
        data = options.attrs || model.toJSON();
    }
    const type = methodMap[method];
    const params = {
        method: type,
        body: data ? JSON.stringify(data) : '',
        headers: {
            'Content-Type': 'application/json',
        },
        success: options.success,
        error: options.error,
    };
    const url = options.url || skeletor_esm_result(model, 'url') || urlError();
    const xhr = fetch(url, params);
    if (options) {
        options.xhr = xhr;
    }
    model.trigger('request', model, xhr, { ...params, xhr });
    return xhr;
}

/**
 * IndexedDB, localStorage and sessionStorage adapter
 */
const IN_MEMORY = _driver;
localForage.defineDriver(memoryDriver);
localforageSetitemsExports.extendPrototype(localForage);
localforageGetitemsExports.extendPrototype(localForage);
// Every storage instance is registered with a WeakRef so that flushAll() can
// reach pending writes without keeping instances alive. There's no leak and no
// lifecycle hook to maintain: an instance is collected once its owning model or
// collection is gone, at which point nothing is writing through it anyway.
// Models with a pending debounced save stay reachable via the autosync `pending`
// map until the timer fires, so flushAll() always reaches in-flight writes.
const weakInstances = new Set();
// Tracks which instances already have a WeakRef in `weakInstances`, so repeated
// `storage =` assignments (or a store shared across models) don't register the
// same instance twice and make flushAll() flush it more than once.
const registered = new WeakSet();
/**
 * @public
 */
class PersistentStorage {
    /** Register a storage instance with a weak reference. @public */
    static register(instance) {
        if (registered.has(instance))
            return;
        registered.add(instance);
        weakInstances.add(new WeakRef(instance));
    }
    /**
     * Flush the debounced write buffer of every registered PersistentStorage
     * instance. Called automatically on pagehide/visibilitychange when autoSync
     * is in use; can also be called manually.
     * @public
     */
    static flushAll() {
        for (const ref of weakInstances) {
            const instance = ref.deref();
            if (!instance) {
                weakInstances.delete(ref);
            }
            else {
                instance.flush();
            }
        }
    }
    constructor(id, type, batchedWrites = false) {
        // Set once `storeInitialized` resolves. Lets `sync()` skip awaiting it on the
        // hot path so a save buffers/issues its write *synchronously*, which is what
        // makes the synchronous unload flush (`flushPending` -> `flushAll`) able to
        // push a pending write out before the page is torn down.
        this.storeReady = false;
        this.name = id;
        if (type === 'local' && typeof window !== 'undefined' && !window.localStorage) {
            throw new Error('Skeletor.storage: Environment does not support localStorage.');
        }
        else if (type === 'session' && typeof window !== 'undefined' && !window.sessionStorage) {
            throw new Error('Skeletor.storage: Environment does not support sessionStorage.');
        }
        if (isString(type)) {
            this.storeInitialized = this.initStore(type, batchedWrites);
        }
        else {
            this.store = type;
            if (batchedWrites) {
                this.store.debouncedSetItems = mergebounce((items) => this.store.setItems(items), 50, {
                    'promise': true,
                });
            }
            this.storeInitialized = Promise.resolve();
        }
        // Flip the synchronous-readiness flag once init settles. Callers that await
        // `storeInitialized` directly still see any rejection; this branch only
        // exists to set the flag and must not raise an unhandled rejection.
        this.storeInitialized.then(() => (this.storeReady = true)).catch(() => { });
    }
    /**
     * @param type - The storage type: 'local', 'session', 'indexed', 'node', or 'in_memory'
     * @param batchedWrites - Whether to enable batched writes
     */
    async initStore(type, batchedWrites) {
        if (type === 'session') {
            await localForage.setDriver(sessionStorageWrapper._driver);
        }
        else if (type === 'local') {
            await localForage.config({ 'driver': localForage.LOCALSTORAGE });
        }
        else if (type === 'in_memory') {
            await localForage.config({ 'driver': IN_MEMORY });
        }
        else if (type === 'node') {
            const NodeSQLiteStorage = PersistentStorage.nodeStorage;
            if (!NodeSQLiteStorage) {
                throw new Error("Skeletor.storage: the 'node' storage type is only available in Node.js builds. " +
                    "Import from '@converse/skeletor/node' instead of '@converse/skeletor'.");
            }
            this.store = new NodeSQLiteStorage(this.name, PersistentStorage.nodeStorageDir ?? undefined);
            if (batchedWrites) {
                this.store.debouncedSetItems = mergebounce((items) => this.store.setItems(items), 50, {
                    'promise': true,
                });
            }
            return;
        }
        else if (type !== 'indexed') {
            throw new Error('Skeletor.storage: No storage type was specified');
        }
        this.store = localForage;
        if (batchedWrites) {
            this.store.debouncedSetItems = mergebounce((items) => this.store.setItems(items), 50, {
                'promise': true,
            });
        }
    }
    flush() {
        if (this.store.debouncedSetItems && typeof this.store.debouncedSetItems.flush === 'function') {
            this.store.debouncedSetItems.flush();
        }
    }
    async clear() {
        await this.storeInitialized;
        await this.store.removeItem(this.name).catch((e) => console.error(e));
        const re = new RegExp(`^${this.name}-`);
        const keys = await this.store.keys();
        const removed_keys = keys.filter((k) => re.test(k));
        await Promise.all(removed_keys.map((k) => this.store.removeItem(k).catch((e) => console.error(e))));
    }
    sync() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        async function localSync(method, model, options) {
            let resp, caughtError, promise, new_attributes;
            // We get the collection (and if necessary the model attribute.
            // Waiting for storeInitialized will cause another iteration of
            // the event loop, after which the collection reference will
            // be removed from the model. `options.collection` lets a deferred
            // delete (sequenced behind an in-flight auto-save by Model.destroy)
            // supply the collection captured before its optimistic removal.
            const collection = options.collection ?? model.collection;
            if (['patch', 'update'].includes(method)) {
                new_attributes = cloneDeep(model.attributes);
            }
            // Skip `await` if not necessary to allow for sync flushing
            if (!that.storeReady)
                await that.storeInitialized;
            try {
                const original_attributes = model.attributes;
                switch (method) {
                    case 'read':
                        if (model.id !== undefined) {
                            resp = await that.find(model);
                        }
                        else {
                            resp = await that.findAll();
                        }
                        break;
                    case 'create':
                        resp = await that.create(model, options);
                        break;
                    case 'patch':
                    case 'update':
                        if (options.wait) {
                            // When `wait` is set to true, Skeletor waits until
                            // confirmation of storage before setting the values on
                            // the model.
                            // However, the new attributes needs to be sent, so it
                            // sets them manually on the model and then removes
                            // them after calling `sync`.
                            // Because our `sync` method is asynchronous and we
                            // wait for `storeInitialized`, the attributes are
                            // already restored once we get here, so we need to do
                            // the attributes dance again.
                            model.attributes = new_attributes;
                        }
                        promise = that.update(model);
                        if (options.wait) {
                            model.attributes = original_attributes;
                        }
                        resp = await promise;
                        break;
                    case 'delete':
                        resp = await that.destroy(model, collection);
                        break;
                }
            }
            catch (error) {
                const storageSize = await that.getStorageSize();
                if (error.code === 22 && storageSize === 0) {
                    caughtError = new Error('Private browsing is unsupported');
                }
                else {
                    // Preserve a real Error (stack/name); wrap anything else so the
                    // error path always surfaces an Error, never a bare string.
                    caughtError = error instanceof Error ? error : new Error(error?.message ?? String(error));
                }
            }
            if (caughtError) {
                options?.error?.(caughtError);
            }
            else if (options?.success) {
                // When storing, we don't pass back the response (which is the set
                // attributes returned from localforage) because Skeletor sets them
                // again on the model and due to the async nature of localforage it can
                // cause stale attributes to be set on a model after it's been updated
                // in the meantime.
                const data = method === 'read' ? (resp ?? null) : null;
                options.success(data, options);
            }
        }
        localSync.__name__ = 'localSync';
        return localSync;
    }
    removeCollectionReference(model, collection) {
        if (!collection) {
            return;
        }
        const ids = collection.filter((m) => m.id !== model.id).map((m) => this.getItemName(m.id));
        return this.store.setItem(this.name, ids);
    }
    addCollectionReference(model, collection) {
        if (!collection) {
            return;
        }
        const ids = collection.map((m) => this.getItemName(m.id));
        const new_id = this.getItemName(model.id);
        if (!ids.includes(new_id)) {
            ids.push(new_id);
        }
        return this.store.setItem(this.name, ids);
    }
    getCollectionReferenceData(model) {
        if (!model.collection) {
            return {};
        }
        const ids = model.collection.map((m) => this.getItemName(m.id));
        const new_id = this.getItemName(model.id);
        if (!ids.includes(new_id)) {
            ids.push(new_id);
        }
        const result = {};
        result[this.name] = ids;
        return result;
    }
    async save(model) {
        if (this.store.setItems) {
            const items = {};
            items[this.getItemName(model.id)] = model.toJSON();
            Object.assign(items, this.getCollectionReferenceData(model));
            return this.store.debouncedSetItems ? this.store.debouncedSetItems(items) : this.store.setItems(items);
        }
        else {
            const key = this.getItemName(model.id);
            const data = await this.store.setItem(key, model.toJSON());
            await this.addCollectionReference(model, model.collection);
            return data;
        }
    }
    create(model, options) {
        /* Add a model, giving it a (hopefully)-unique GUID, if it doesn't already
         * have an id of it's own.
         */
        if (!model.id) {
            model.id = guid();
            model.set(model.idAttribute, model.id, options);
        }
        return this.save(model);
    }
    update(model) {
        return this.save(model);
    }
    find(model) {
        return this.store.getItem(this.getItemName(model.id));
    }
    async findAll() {
        /* Return the array of all models currently in storage.
         */
        const keys = (await this.store.getItem(this.name));
        if (keys?.length) {
            const items = await this.store.getItems(keys);
            return Object.values(items);
        }
        return [];
    }
    async destroy(model, collection) {
        await this.flush();
        await this.store.removeItem(this.getItemName(model.id));
        await this.removeCollectionReference(model, collection);
        return model;
    }
    async getStorageSize() {
        return await this.store.length();
    }
    getItemName(id) {
        return this.name + '-' + id;
    }
}
// The Node.js SQLite storage driver. Left null in browser builds so the
// node-only driver (and its `node:sqlite` import) never enters the browser
// bundle; the `@converse/skeletor/node` entry sets it.
PersistentStorage.nodeStorage = null;
/**
 * Directory the `'node'` store type writes its database files to. The driver's
 * own default is relative, so it resolves against `process.cwd()` and a process
 * started from two directories ends up with two separate sets of state. Set an
 * absolute path (`$XDG_STATE_HOME/<app>`, say) to pin it. Left `null`, the
 * driver's default applies.
 *
 * Only the `'node'` string store type reads this; passing a driver instance to
 * the constructor means you've already chosen a directory yourself.
 * @public
 */
PersistentStorage.nodeStorageDir = null;
PersistentStorage.sessionStorageInitialized = localForage.defineDriver(sessionStorageWrapper);
PersistentStorage.localForage = localForage;

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$1);
}

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, skeletor_esm_keys$2);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = -1,
        iterable = Object(collection);

    while ((++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$5.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = skeletor_esm_isArray(object),
      othIsArr = skeletor_esm_isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$4.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$4.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      var result; 
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject$1(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = skeletor_esm_keys$2(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function skeletor_esm_property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return skeletor_esm_identity;
  }
  if (typeof value == 'object') {
    return skeletor_esm_isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return skeletor_esm_property(value);
}

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = skeletor_esm_isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = {};

    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty$3.call(result, key)) {
    ++result[key];
  } else {
    baseAssignValue(result, key, 1);
  }
});

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty$2.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

/** Built-in value references. */
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return skeletor_esm_isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (predicate(value)) {
      {
        arrayPush(result, value);
      }
    } else {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (skeletor_esm_isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [skeletor_esm_identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees), []);
});

const skeletor_esm_pending = new Map();
const inFlight = new Set();
// Per-object view of `inFlight`, so a caller (notably `Model.destroy`) can
// await the saves for a single object without blocking on unrelated writes.
const inFlightByObj = new Map();
let unloadListenerAttached = false;
/**
 * Execute a save `run` now and track the resulting promise as in-flight until
 * it settles, both globally (`inFlight`) and per object (`inFlightByObj`), so
 * `flushPending({ wait: true })` can await every save and `Model.destroy` can
 * await just its own.
 *
 * @internal
 * @param obj - The owning model/collection (or `null` when the save isn't tied to one).
 *    A rejection is logged and re-surfaced on `obj`'s `error` event.
 *    Called when a debounce timer fires or a flush forces it.
 */
function fireRun(obj, run) {
    const p = Promise.resolve(run()).catch((e) => {
        console.error('Skeletor autoSync save error:', e);
        // Surface failures that bypassed `options.error` on the model's `error` event,
        // the same channel storage-layer failures already use. Storage saves route
        // errors through `options.error` and then resolve, so they never reach this
        // catch and won't double-emit.
        obj?.trigger?.('error', obj, e);
    });
    inFlight.add(p);
    let perObj;
    if (obj) {
        perObj = inFlightByObj.get(obj);
        if (!perObj) {
            perObj = new Set();
            inFlightByObj.set(obj, perObj);
        }
        perObj.add(p);
    }
    p.finally(() => {
        inFlight.delete(p);
        if (perObj) {
            perObj.delete(p);
            if (perObj.size === 0)
                inFlightByObj.delete(obj);
        }
    });
}
/**
 * Schedule a debounced auto-save for `obj`. Replaces any pending schedule
 * for the same object.
 * @internal
 */
function scheduleAutoSave(obj, run, delay) {
    const existing = skeletor_esm_pending.get(obj);
    if (existing)
        clearTimeout(existing.timerId);
    const timerId = setTimeout(() => {
        skeletor_esm_pending.delete(obj);
        fireRun(obj, run);
    }, delay);
    skeletor_esm_pending.set(obj, { timerId, run });
}
/**
 * Cancel any pending auto-save for `obj`.
 *
 * This only stops a *pending* (not-yet-fired) debounce timer. A save whose
 * timer has already fired is in flight and beyond cancellation — sequence
 * against it with {@link awaitInFlightSaves} instead.
 * @internal
 */
function cancelAutoSave(obj) {
    const existing = skeletor_esm_pending.get(obj);
    if (existing) {
        clearTimeout(existing.timerId);
        skeletor_esm_pending.delete(obj);
    }
}
/**
 * Return a promise that settles once every in-flight auto-save for `obj` has
 * completed, or `null` when none are in flight. `Model.destroy` uses this to
 * sequence its delete after a save that has already fired, so a late write
 * cannot land after the delete and resurrect the record.
 * @internal
 */
function awaitInFlightSaves(obj) {
    const set = inFlightByObj.get(obj);
    if (!set || set.size === 0)
        return null;
    return Promise.all([...set]).then(() => undefined);
}
function flushPending({ storage, wait = false, } = {}) {
    for (const [obj, { timerId, run }] of skeletor_esm_pending.entries()) {
        clearTimeout(timerId);
        fireRun(obj, run);
    }
    skeletor_esm_pending.clear();
    if (storage)
        storage.flushAll();
    if (wait)
        return Promise.all([...inFlight]).then(() => undefined);
}
/**
 * Lazily attach pagehide/visibilitychange listeners in browser environments
 * to flush pending writes when the page is hidden/unloading. This is a
 * best-effort durability measure: the flush initiates writes synchronously but
 * cannot guarantee an asynchronous backend finishes persisting them before the
 * page goes away. Called at most once.
 * @internal
 */
function ensureUnloadListener(storage) {
    if (unloadListenerAttached || typeof window === 'undefined')
        return;
    unloadListenerAttached = true;
    const flush = () => flushPending({ storage });
    window.addEventListener('pagehide', flush);
    window.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden')
            flush();
    });
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto$2[key]) && !hasOwnProperty$1.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = baseRest(function(func, args) {
  return baseDelay(func, 1, args);
});

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$1.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, constant(skeletor_esm_identity));

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function skeletor_esm_isEqual(value, other) {
  return baseIsEqual(value, other);
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function skeletor_esm_iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG$1));
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function skeletor_esm_last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function skeletor_esm_parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var skeletor_esm_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);

  // Prevent prototype pollution:
  // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
  // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
  var index = -1,
      length = path.length;

  if (!length) {
    return true;
  }

  while (++index < length) {
    var key = toKey(path[index]);

    // Always block "__proto__" anywhere in the path if it's not expected
    if (key === '__proto__' && !skeletor_esm_hasOwnProperty.call(object, '__proto__')) {
      return false;
    }

    // Block constructor/prototype as non-terminal traversal keys to prevent
    // escaping the object graph into built-in constructors and prototypes.
    if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
      return false;
    }
  }

  var obj = skeletor_esm_parent(object, path);
  return obj == null || delete obj[toKey(skeletor_esm_last(path))];
}

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array) : [];
}

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject$1(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = undefined;
      if (newValue === undefined) {
        newValue = isObject$1(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

var _Model_instances, _Model_computedCache, _Model_computedDefs, _Model_state, skeletor_esm_Model_hydrate, skeletor_esm_Model_doAutoSave, skeletor_esm_Model_updateComputed, skeletor_esm_Model_initComputed;
/**
 * @public
 * **Models** are the basic data object in the framework --
 * frequently representing a row in a table in a database on your server.
 * A discrete chunk of data and a bunch of useful, related methods for
 * performing computations and transformations on that data.
 */
class skeletor_esm_Model extends EventEmitterObject {
    /**
     * Create a new model with the specified attributes. A client id (`cid`)
     * is automatically generated and assigned for you.
     */
    constructor(attributes, options) {
        super();
        _Model_instances.add(this);
        _Model_computedCache.set(this, void 0);
        _Model_computedDefs.set(this, void 0);
        _Model_state.set(this, 'constructing');
        this._changing = false;
        this._pending = false;
        this._url = '';
        this.changed = {};
        this.validationError = null;
        let attrs = attributes || {};
        options = options || {};
        this.preinitialize.apply(this, arguments);
        this.cid = uniqueId(this.cidPrefix);
        this.attributes = {};
        if (options.collection)
            this.collection = options.collection;
        if (options.parse)
            attrs = this.parse(attrs, options) || {};
        const default_attrs = skeletor_esm_result(this, 'defaults');
        attrs = defaults(Object.assign({}, default_attrs, attrs), default_attrs);
        this.set(attrs, options);
        skeletor_esm_classPrivateFieldGet(this, _Model_instances, "m", skeletor_esm_Model_initComputed).call(this);
        this.attrs = new Proxy(this.attributes, {
            get: (_target, key) => {
                if (typeof key !== 'symbol' && skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f") && key in skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f")) {
                    return skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f")[key];
                }
                return this.attributes[key];
            },
            set: (_target, key, value) => {
                this.set(key, value);
                return true;
            },
        });
        this.initialize.apply(this, arguments);
        // Reset changed after initial set
        this.changed = {};
        // When autoSync is on, `hydrated` is always a Promise so callers can
        // uniformly `await model.hydrated`. It only hydrates from storage when
        // there's something to load (storage configured and the model isn't new);
        // otherwise it's already ready and resolves immediately.
        if (this.autoSync) {
            if (getStorage(this) && !this.isNew()) {
                skeletor_esm_classPrivateFieldSet(this, _Model_state, 'hydrating', "f");
                this.hydrated = skeletor_esm_classPrivateFieldGet(this, _Model_instances, "m", skeletor_esm_Model_hydrate).call(this);
            }
            else {
                skeletor_esm_classPrivateFieldSet(this, _Model_state, 'ready', "f");
                this.hydrated = Promise.resolve();
            }
        }
        else {
            skeletor_esm_classPrivateFieldSet(this, _Model_state, 'ready', "f");
        }
    }
    /**
     * The canonical storage accessor. Set to a `PersistentStorage` instance
     * to enable local persistence for this model.
     */
    get storage() {
        return this._storage;
    }
    set storage(s) {
        this._storage = s;
        PersistentStorage.register(s);
    }
    /**
     * @deprecated Use `storage` instead.
     */
    get browserStorage() {
        return this._storage;
    }
    set browserStorage(s) {
        warnBrowserStorageDeprecation(this);
        this.storage = s;
    }
    /**
     * Override to enable automatic persistence. When true, any `set()` call
     * that changes attributes will schedule a debounced save to `storage`, and
     * the model will auto-hydrate from storage on construction.
     */
    get autoSync() {
        return false;
    }
    /**
     * Debounce delay (ms) for auto-save writes. Override to tune.
     */
    get autoSyncDelay() {
        return 100;
    }
    /**
     * The default name for the JSON `id` attribute is `"id"`. MongoDB and
     * CouchDB users may want to set this to `"_id"` (by overriding this getter
     * in a subclass).
     */
    get idAttribute() {
        return 'id';
    }
    /**
     * The prefix is used to create the client id which is used to identify models locally.
     * You may want to override this if you're experiencing name clashes with model ids.
     */
    get cidPrefix() {
        return 'c';
    }
    /**
     * preinitialize is an empty function by default. You can override it with a function
     * or object.  preinitialize will run before any instantiation logic is run in the Model.
     */
    preinitialize(...args) { }
    /**
     * Initialize is an empty function by default. Override it with your own
     * initialization logic.
     */
    initialize(attrs, options) { }
    validate(attrs, options) {
        return null;
    }
    /**
     * Return a hash of defaults for the model's attributes.
     */
    defaults() {
        return {};
    }
    /**
     * Declare computed properties. Override in subclasses to define properties
     * that derive their value from other attributes. Each entry specifies the
     * attribute keys it depends on (`deps`) and a function (`fn`) that receives
     * the model and returns the computed value. The value is cached and
     * recalculated automatically when any dep changes, firing a `change:key`
     * event.
     */
    get computed() {
        return {};
    }
    /**
     * Return a copy of the model's `attributes` object.
     */
    toJSON() {
        return clone(this.attributes);
    }
    /**
     * Override this if you need custom syncing semantics for *this* particular model.
     */
    sync(method, model, options) {
        return getSyncMethod(model)(method, model, options);
    }
    /**
     * Get the value of an attribute, or a computed property.
     */
    get(attr) {
        if (skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f") && attr in skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f")) {
            return skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f")[attr];
        }
        return this.attributes[attr];
    }
    keys() {
        return Object.keys(this.attributes);
    }
    values() {
        return Object.values(this.attributes);
    }
    pairs() {
        return this.entries();
    }
    entries() {
        return Object.entries(this.attributes);
    }
    invert() {
        return invert(this.attributes);
    }
    pick(...args) {
        if (args.length === 1 && Array.isArray(args[0])) {
            args = args[0];
        }
        return pick(this.attributes, args);
    }
    omit(...args) {
        if (args.length === 1 && Array.isArray(args[0])) {
            args = args[0];
        }
        return omit(this.attributes, args);
    }
    isEmpty() {
        return isEmpty(this.attributes);
    }
    /**
     * Returns `true` if the attribute contains a value that is not null
     * or undefined.
     */
    has(attr) {
        return this.get(attr) != null;
    }
    /**
     * Special-cased proxy to lodash's `matches` method.
     */
    matches(attrs) {
        return !!skeletor_esm_iteratee(attrs)(this.attributes);
    }
    /**
     * Set a hash of model attributes on the object, firing `"change"`. This is
     * the core primitive operation of a model, updating the data and notifying
     * anyone who needs to know about the change in state. The heart of the beast.
     */
    set(key, val, options) {
        if (key == null)
            return this;
        // Handle both `"key", value` and `{key: value}` -style arguments.
        let attrs;
        if (typeof key === 'object') {
            attrs = key;
            options = val;
        }
        else {
            attrs = {};
            attrs[key] = val;
        }
        options = options || {};
        // Guard must come after arg normalization: when called as set(obj, opts),
        // fromStorage lives in `val` (second arg), not `options` (third arg).
        if (this.autoSync && skeletor_esm_classPrivateFieldGet(this, _Model_state, "f") === 'hydrating' && !options.fromStorage) {
            throw new Error(`Skeletor: set() called on an autoSync model before hydration resolved. Await model.hydrated first.`);
        }
        // Run validation.
        if (!this._validate(attrs, options))
            return null;
        // Extract attributes and options.
        const unset = options.unset;
        const silent = options.silent;
        const changes = [];
        const changing = this._changing;
        this._changing = true;
        if (!changing) {
            this._previousAttributes = clone(this.attributes);
            this.changed = {};
        }
        const current = this.attributes;
        const changed = this.changed;
        const prev = this._previousAttributes;
        // For each `set` attribute, update or delete the current value.
        for (const attr in attrs) {
            val = attrs[attr];
            if (!skeletor_esm_isEqual(current[attr], val))
                changes.push(attr);
            if (!skeletor_esm_isEqual(prev[attr], val)) {
                changed[attr] = val;
            }
            else {
                delete changed[attr];
            }
            unset ? delete current[attr] : (current[attr] = val);
        }
        // Update the `id`.
        if (this.idAttribute in attrs)
            this.id = this.get(this.idAttribute);
        // Trigger all relevant attribute changes.
        if (!silent) {
            if (changes.length)
                this._pending = options;
            for (let i = 0; i < changes.length; i++) {
                this.trigger('change:' + changes[i], this, current[changes[i]], options);
            }
        }
        // Recalculate computed properties whose deps changed.
        if (changes.length && skeletor_esm_classPrivateFieldGet(this, _Model_computedDefs, "f")) {
            for (const [key, def] of Object.entries(skeletor_esm_classPrivateFieldGet(this, _Model_computedDefs, "f"))) {
                if (def.deps.some((dep) => changes.includes(dep))) {
                    skeletor_esm_classPrivateFieldGet(this, _Model_instances, "m", skeletor_esm_Model_updateComputed).call(this, key, def, silent, options);
                }
            }
        }
        if (changing)
            return this;
        if (!silent) {
            // You might be wondering why there's a `while` loop here. Changes can
            // be recursively nested within `"change"` events.
            while (this._pending) {
                options = this._pending;
                this._pending = false;
                this.trigger('change', this, options);
            }
        }
        this._pending = false;
        this._changing = false;
        // Auto-save: schedule a debounced write when autoSync is on and there
        // were actual changes that originated from application code (not a
        // storage read or an explicit noAutoSave call).
        if (skeletor_esm_classPrivateFieldGet(this, _Model_state, "f") === 'ready' &&
            this.autoSync &&
            getStorage(this) &&
            changes.length &&
            !options.fromStorage &&
            !options.noAutoSave) {
            scheduleAutoSave(this, () => skeletor_esm_classPrivateFieldGet(this, _Model_instances, "m", skeletor_esm_Model_doAutoSave).call(this), this.autoSyncDelay);
        }
        return this;
    }
    /**
     * Remove an attribute from the model, firing `"change"`. `unset` is a noop
     * if the attribute doesn't exist.
     */
    unset(attr, options) {
        return this.set(attr, undefined, Object.assign({}, options, { unset: true }));
    }
    /**
     * Clear all attributes on the model, firing `"change"`.
     */
    clear(options) {
        const attrs = {};
        for (const key in this.attributes)
            attrs[key] = undefined;
        return this.set(attrs, Object.assign({}, options, { unset: true }));
    }
    /**
     * Determine if the model has changed since the last `"change"` event.
     * If you specify an attribute name, determine if that attribute has changed.
     */
    hasChanged(attr) {
        if (attr == null)
            return !isEmpty(this.changed);
        return skeletor_esm_has(this.changed, attr);
    }
    /**
     * Return an object containing all the attributes that have changed, or
     * false if there are no changed attributes. Useful for determining what
     * parts of a view need to be updated and/or what attributes need to be
     * persisted to the server. Unset attributes will be set to undefined.
     * You can also pass an attributes object to diff against the model,
     * determining if there *would be* a change.
     */
    changedAttributes(diff) {
        if (!diff) {
            return this.hasChanged() ? clone(this.changed) : false;
        }
        const old = this._changing ? this._previousAttributes : this.attributes;
        const changed = {};
        let hasChanged = false;
        for (const attr in diff) {
            const val = diff[attr];
            if (skeletor_esm_isEqual(old[attr], val))
                continue;
            changed[attr] = val;
            hasChanged = true;
        }
        return hasChanged ? changed : false;
    }
    /**
     * Get the previous value of an attribute, recorded at the time the last
     * `"change"` event was fired.
     */
    previous(attr) {
        if (attr == null || !this._previousAttributes)
            return null;
        return this._previousAttributes[attr];
    }
    /**
     * Get all of the attributes of the model at the time of the previous
     * `"change"` event.
     */
    previousAttributes() {
        return this._previousAttributes ? clone(this._previousAttributes) : undefined;
    }
    /**
     * Fetch the model from the server, merging the response with the model's
     * local attributes. Any changed attributes will trigger a "change" event.
     */
    fetch(options = {}) {
        options = Object.assign({ parse: true }, options);
        const success = options.success;
        const promise = options.promise ? getResolveablePromise() : undefined;
        // Tracks whether sync invoked one of the callbacks. A sync may instead
        // settle its returned promise; the `.then`/`.catch` below bridges that to
        // the callbacks so the fetch promise never hangs. The flag is set
        // synchronously inside each callback (before sync's promise resolves), so
        // it's reliable by the time those handlers run.
        let settled = false;
        options.success = (resp) => {
            settled = true;
            const serverAttrs = options.parse ? this.parse(resp, options) : resp;
            // fromStorage prevents the set() from triggering auto-save on reads
            if (!this.set(serverAttrs, Object.assign({}, options, { fromStorage: true })))
                return false;
            if (success)
                success.call(options.context, this, resp, options);
            this.trigger('sync', this, resp, options);
            promise && promise.resolve(resp);
        };
        wrapError(this, options, promise);
        if (promise) {
            const onError = options.error;
            options.error = (resp) => {
                settled = true;
                onError(resp);
            };
        }
        const result = this.sync('read', this, options);
        if (promise) {
            Promise.resolve(result).then(
            // A sync that resolves its promise without invoking options.success:
            // treat the resolved value as the response, so the model is still
            // merged and the promise settles instead of hanging.
            (value) => {
                if (!settled)
                    options.success(value);
            }, 
            // A sync that rejects instead of invoking options.error; settling
            // twice is a harmless no-op.
            (e) => promise.reject(e));
            return promise;
        }
        return result;
    }
    /**
     * Set a hash of model attributes, and sync the model to the server.
     * If the server returns an attributes hash that differs, the model's
     * state will be `set` again.
     */
    save(key, val, options) {
        // Handle both `"key", value` and `{key: value}` -style arguments.
        let attrs;
        if (key == null || typeof key === 'object') {
            attrs = key;
            options = val;
        }
        else {
            attrs = {};
            attrs[key] = val;
        }
        options = Object.assign({ validate: true, parse: true }, options);
        const wait = options.wait;
        const return_promise = options.promise;
        const promise = return_promise && getResolveablePromise();
        // If we're not waiting and attributes exist, save acts as
        // `set(attr).save(null, opts)` with validation. Otherwise, check if
        // the model will be valid when the attributes, if any, are set.
        if (attrs && !wait) {
            if (!this.set(attrs, options))
                return false;
        }
        else if (!this._validate(attrs || {}, options)) {
            return false;
        }
        // After a successful server-side save, the client is (optionally)
        // updated with the server-side state.
        const success = options.success;
        const error = options.error;
        const attributes = this.attributes;
        options.success = (resp) => {
            // Ensure attributes are restored during synchronous saves.
            this.attributes = attributes;
            let serverAttrs = options.parse ? this.parse(resp, options) : resp;
            if (wait)
                serverAttrs = Object.assign({}, attrs, serverAttrs);
            if (serverAttrs && !this.set(serverAttrs, options))
                return false;
            if (success)
                success.call(options.context, this, resp, options);
            this.trigger('sync', this, resp, options);
            return_promise && promise.resolve();
        };
        options.error = (model, e, options) => {
            error && error.call(options.context, model, e, options);
            return_promise && promise.reject(e);
        };
        wrapError(this, options);
        // Set temporary attributes if `{wait: true}` to properly find new ids.
        if (attrs && wait)
            this.attributes = Object.assign({}, attributes, attrs);
        const method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
        if (method === 'patch' && !options.attrs)
            options.attrs = attrs;
        const xhr = this.sync(method, this, options);
        // Restore attributes.
        this.attributes = attributes;
        if (return_promise) {
            return promise;
        }
        else {
            return xhr;
        }
    }
    /**
     * Destroy this model on the server if it was already persisted.
     * Optimistically removes the model from its collection, if it has one.
     * If `wait: true` is passed, waits for the server to respond before removal.
     */
    destroy(options) {
        cancelAutoSave(this);
        options = options ? clone(options) : {};
        const success = options.success;
        const wait = options.wait;
        const destroy = () => {
            this.stopListening();
            this.trigger('destroy', this, this.collection, options);
        };
        options.success = (resp) => {
            if (wait)
                destroy();
            if (success)
                success.call(options.context, this, resp, options);
            if (!this.isNew())
                this.trigger('sync', this, resp, options);
        };
        // A debounced auto-save may already have fired and be in flight.
        // cancelAutoSave() above only stops a *pending* timer, so sequence the
        // delete after any in-flight save; otherwise the late write could land
        // after the delete and resurrect the record. Capture the collection now,
        // the optimistic in-memory removal below nulls `model.collection` before
        // the deferred sync runs, but the storage layer still needs it to drop
        // this id from the collection's persisted index.
        const inFlightSave = awaitInFlightSaves(this);
        if (inFlightSave && this.collection)
            options.collection = this.collection;
        let xhr = false;
        if (this.isNew()) {
            defer(options.success);
        }
        else {
            wrapError(this, options);
            xhr = inFlightSave
                ? inFlightSave.then(() => this.sync('delete', this, options))
                : this.sync('delete', this, options);
        }
        if (!wait)
            destroy();
        return xhr;
    }
    get urlRoot() {
        return this._urlRoot;
    }
    set urlRoot(root) {
        this._urlRoot = root;
    }
    /**
     * Default URL for the model's representation on the server -- if you're
     * using Backbone's restful methods, override this to change the endpoint
     * that will be called.
     */
    get url() {
        if (this._url)
            return this._url;
        const base = skeletor_esm_result(this, 'urlRoot') || skeletor_esm_result(this.collection, 'url') || urlError();
        if (this.isNew())
            return base;
        const id = this.get(this.idAttribute);
        return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(String(id));
    }
    set url(url) {
        this._url = url;
    }
    /**
     * **parse** converts a response into the hash of attributes to be `set` on
     * the model. The default implementation is just to pass the response along.
     */
    parse(resp, options) {
        return resp;
    }
    /**
     * A model is new if it has never been saved to the server, and lacks an id.
     */
    isNew() {
        return !this.has(this.idAttribute);
    }
    /**
     * Check if the model is currently in a valid state.
     */
    isValid(options) {
        return this._validate({}, Object.assign({}, options, { validate: true }));
    }
    subscribe(eventOrCallback, callback, context) {
        if (typeof eventOrCallback === 'function') {
            const cb = (model) => eventOrCallback(model, this.changed);
            this.on('change', cb);
            return () => this.off('change', cb);
        }
        return super.subscribe(eventOrCallback, callback, context);
    }
    /**
     * Run validation against the next complete set of model attributes,
     * returning `true` if all is well. Otherwise, fire an `"invalid"` event.
     */
    _validate(attrs, options) {
        if (!options?.validate || !this.validate)
            return true;
        attrs = Object.assign({}, this.attributes, attrs);
        const error = (this.validationError = this.validate(attrs, options) || null);
        if (!error)
            return true;
        this.trigger('invalid', this, error, Object.assign(options, { validationError: error }));
        return false;
    }
}
_Model_computedCache = new WeakMap(), _Model_computedDefs = new WeakMap(), _Model_state = new WeakMap(), _Model_instances = new WeakSet(), skeletor_esm_Model_hydrate = async function _Model_hydrate() {
    ensureUnloadListener(PersistentStorage);
    try {
        await this.fetch({ fromStorage: true, promise: true });
    }
    finally {
        skeletor_esm_classPrivateFieldSet(this, _Model_state, 'ready', "f");
    }
}, skeletor_esm_Model_doAutoSave = function _Model_doAutoSave() {
    return this.save(null, { noAutoSave: true });
}, skeletor_esm_Model_updateComputed = function _Model_updateComputed(key, def, silent, options) {
    const newVal = def.fn(this);
    if (!skeletor_esm_isEqual(skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f")[key], newVal)) {
        skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f")[key] = newVal;
        if (!silent) {
            this.changed[key] = newVal;
            this.trigger('change:' + key, this, newVal, options);
        }
    }
}, skeletor_esm_Model_initComputed = function _Model_initComputed() {
    const defs = skeletor_esm_result(this, 'computed');
    if (!defs || isEmpty(defs))
        return;
    skeletor_esm_classPrivateFieldSet(this, _Model_computedDefs, defs, "f");
    skeletor_esm_classPrivateFieldSet(this, _Model_computedCache, {}, "f");
    for (const [key, def] of Object.entries(defs)) {
        skeletor_esm_classPrivateFieldGet(this, _Model_computedCache, "f")[key] = def.fn(this);
    }
};

var _Collection_instances, skeletor_esm_Collection_hydrate, skeletor_esm_a;
// Default options for `Collection#set`.
const setOptions = { add: true, remove: true, merge: true };
const addOptions = { add: true, remove: false };
/**
 * @public
 * If models tend to represent a single row of data, a Collection is
 * more analogous to a table full of data ... or a small slice or page of that
 * table, or a collection of rows that belong together for a particular reason
 * -- all of the messages in this particular folder, all of the documents
 * belonging to this particular author, and so on. Collections maintain
 * indexes of their models, both in order, and for lookup by `id`.
 */
class Collection extends EventEmitterObject {
    /**
     * Create a new **Collection**, perhaps to contain a specific type of `model`.
     * If a `comparator` is specified, the Collection will maintain
     * its models in sort order, as they're added and removed.
     */
    constructor(models, options) {
        super();
        _Collection_instances.add(this);
        this._url = '';
        /**
         * @public
         * Enable for...of iteration over the collection.
         */
        this[skeletor_esm_a] = this.values;
        options = options || {};
        this.preinitialize.apply(this, arguments);
        if (options.model)
            this._model = options.model;
        if (options.comparator !== undefined)
            this.comparator = options.comparator;
        this._reset();
        this.initialize.apply(this, arguments);
        if (models)
            this.reset(models, Object.assign({ silent: true }, options));
        this[Symbol.iterator] = this.values;
        // When autoSync is on, `hydrated` is always a Promise so callers can
        // uniformly `await collection.hydrated`; it resolves immediately when
        // there's no storage to hydrate from.
        if (this.autoSync) {
            this.hydrated = getStorage(this) ? skeletor_esm_classPrivateFieldGet(this, _Collection_instances, "m", skeletor_esm_Collection_hydrate).call(this) : Promise.resolve();
        }
    }
    get comparator() {
        return this._comparator;
    }
    set comparator(c) {
        this._comparator = c;
    }
    /**
     * The canonical storage accessor. Set to a `PersistentStorage` instance
     * to enable local persistence for this collection.
     */
    get storage() {
        return this._storage;
    }
    set storage(s) {
        this._storage = s;
        PersistentStorage.register(s);
    }
    /**
     * @deprecated Use `storage` instead.
     */
    get browserStorage() {
        return this._storage;
    }
    set browserStorage(s) {
        warnBrowserStorageDeprecation(this);
        this.storage = s;
    }
    /**
     * Override to return `true` to automatically load the collection from
     * storage on construction. Await `hydrated` to know when hydration
     * is complete.
     *
     * Note: collection `autoSync` is hydrate-only. Unlike `Model`, it does
     * **not** schedule auto-saves when the collection changes (`add`/`remove`/
     * `reset`). Persisting members is each model's responsibility — enable
     * `autoSync` on the contained model class and every model writes its own
     * record. A collection-level write would be redundant with that.
     */
    get autoSync() {
        return false;
    }
    /**
     * The default model for a collection is just a **Model**.
     * This should be overridden in most cases.
     */
    get model() {
        return this._model ?? skeletor_esm_Model;
    }
    set model(model) {
        this._model = model;
    }
    get length() {
        return this.models.length;
    }
    get url() {
        return this._url;
    }
    set url(url) {
        this._url = url;
    }
    /**
     * preinitialize is an empty function by default. You can override it with a function
     * or object.  preinitialize will run before any instantiation logic is run in the Collection.
     */
    preinitialize(..._args) { }
    /**
     * Initialize is an empty function by default. Override it with your own
     * initialization logic.
     */
    initialize(..._args) { }
    /**
     * The JSON representation of a Collection is an array of the
     * models' attributes.
     */
    toJSON() {
        return this.map(function (model) {
            return model.toJSON();
        });
    }
    sync(method, model, options) {
        return getSyncMethod(this)(method, model, options);
    }
    /**
     * Add a model, or list of models to the set. `models` may be
     * Models or raw JavaScript objects to be converted to Models, or any
     * combination of the two.
     */
    add(models, options) {
        return this.set(models, Object.assign({ merge: false }, options, addOptions));
    }
    /**
     * Remove a model, or a list of models from the set.
     */
    remove(models, options) {
        options = Object.assign({}, options);
        const singular = !Array.isArray(models);
        const modelsArray = singular ? [models] : models.slice();
        const removed = this._removeModels(modelsArray, options);
        if (!options.silent && removed.length) {
            options.changes = { added: [], merged: [], removed: removed };
            this.trigger('update', this, options);
        }
        return singular ? removed[0] : removed;
    }
    /**
     * Update a collection by `set`-ing a new list of models, adding new ones,
     * removing models that are no longer present, and merging models that
     * already exist in the collection, as necessary. Similar to **Model#set**,
     * the core operation for updating the data contained by the collection.
     */
    set(models, options) {
        if (models == null)
            return;
        options = Object.assign({}, setOptions, options);
        if (options.parse && !this._isModel(models)) {
            models = this.parse(models, options) || [];
        }
        const singular = !Array.isArray(models);
        models = singular ? [models] : models.slice();
        let at = options.at;
        if (at != null)
            at = +at;
        if (at > this.length)
            at = this.length;
        if (at < 0)
            at += this.length + 1;
        const set = [];
        const toAdd = [];
        const toMerge = [];
        const toRemove = [];
        const modelMap = {};
        const add = options.add;
        const merge = options.merge;
        const remove = options.remove;
        let sort = false;
        const sortable = this.comparator && at == null && options.sort !== false;
        const sortAttr = isString(this.comparator) ? this.comparator : null;
        // Turn bare objects into model references, and prevent invalid models
        // from being added.
        let model, i;
        for (i = 0; i < models.length; i++) {
            model = models[i];
            // If a duplicate is found, prevent it from being added and
            // optionally merge it into the existing model.
            const existing = this.get(model);
            if (existing) {
                if (merge && model !== existing) {
                    let attrs = this._isModel(model) ? model.attributes : model;
                    if (options.parse)
                        attrs = existing.parse(attrs, options);
                    existing.set(attrs, options);
                    toMerge.push(existing);
                    if (sortable && !sort)
                        sort = existing.hasChanged(sortAttr);
                }
                if (!modelMap[existing.cid]) {
                    modelMap[existing.cid] = true;
                    set.push(existing);
                }
                models[i] = existing;
                // If this is a new, valid model, push it to the `toAdd` list.
            }
            else if (add) {
                model = models[i] = this._prepareModel(model, options);
                if (model) {
                    toAdd.push(model);
                    this._addReference(model, options);
                    modelMap[model.cid] = true;
                    set.push(model);
                }
            }
        }
        // Remove stale models.
        if (remove) {
            for (i = 0; i < this.length; i++) {
                model = this.models[i];
                if (!modelMap[model.cid])
                    toRemove.push(model);
            }
            if (toRemove.length)
                this._removeModels(toRemove, options);
        }
        // See if sorting is needed, update `length` and splice in new models.
        let orderChanged = false;
        const replace = !sortable && add && remove;
        if (set.length && replace) {
            orderChanged = this.length !== set.length || this.models.some((m, idx) => m !== set[idx]);
            this.models.length = 0;
            this.models.splice(0, 0, ...set);
        }
        else if (toAdd.length) {
            if (sortable)
                sort = true;
            let idx = at == null ? this.length : at;
            idx = Math.min(Math.max(idx, 0), this.models.length);
            this.models.splice(idx, 0, ...toAdd);
        }
        // Silently sort the collection if appropriate.
        if (sort)
            this.sort({ silent: true });
        // Unless silenced, it's time to fire all appropriate add/sort/update events.
        if (!options.silent) {
            for (i = 0; i < toAdd.length; i++) {
                if (at != null)
                    options.index = at + i;
                model = toAdd[i];
                model.trigger('add', model, this, options);
            }
            if (sort || orderChanged)
                this.trigger('sort', this, options);
            if (toAdd.length || toRemove.length || toMerge.length) {
                options.changes = {
                    added: toAdd,
                    removed: toRemove,
                    merged: toMerge,
                };
                this.trigger('update', this, options);
            }
        }
        // Return the added (or merged) model (or models).
        return singular ? models[0] : models;
    }
    async clearStore(options = {}, filter = () => true) {
        await Promise.all(this.models.filter(filter).map((m) => {
            return new Promise((resolve) => {
                m.destroy(Object.assign(options, {
                    'success': resolve,
                    'error': (_m, e) => {
                        console.error(e);
                        resolve();
                    },
                }));
            });
        }));
        await getStorage(this)?.clear();
        this.reset();
    }
    /**
     * When you have more items than you want to add or remove individually,
     * you can reset the entire set with a new list of models, without firing
     * any granular `add` or `remove` events. Fires `reset` when finished.
     * Useful for bulk operations and optimizations.
     */
    reset(models, options) {
        options = options ? clone(options) : {};
        for (let i = 0; i < this.models.length; i++) {
            this._removeReference(this.models[i], options);
        }
        options.previousModels = this.models;
        this._reset();
        models = this.add(models, Object.assign({ silent: true }, options));
        if (!options.silent)
            this.trigger('reset', this, options);
        return models;
    }
    /**
     * Add a model to the end of the collection.
     */
    push(model, options) {
        return this.add(model, Object.assign({ at: this.length }, options));
    }
    /**
     * Remove a model from the end of the collection.
     */
    pop(options) {
        const model = this.at(this.length - 1);
        return this.remove(model, options);
    }
    /**
     * Add a model to the beginning of the collection.
     */
    unshift(model, options) {
        return this.add(model, Object.assign({ at: 0 }, options));
    }
    /**
     * Remove a model from the beginning of the collection.
     */
    shift(options) {
        const model = this.at(0);
        return this.remove(model, options);
    }
    /** Slice out a sub-array of models from the collection. */
    slice(start, end) {
        return this.models.slice(start, end);
    }
    filter(callback, thisArg) {
        return this.models.filter(isFunction(callback)
            ? callback
            : (m) => m.matches(callback), thisArg);
    }
    every(pred) {
        if (isFunction(pred)) {
            return this.models.map((m) => m.attributes).every(pred);
        }
        else {
            return this.models.every((m) => m.matches(pred));
        }
    }
    difference(values) {
        return this.models.filter((m) => !values.includes(m));
    }
    max() {
        return Math.max.apply(Math, this.models);
    }
    min() {
        return Math.min.apply(Math, this.models);
    }
    drop(n = 1) {
        return this.models.slice(n);
    }
    some(pred) {
        if (isFunction(pred)) {
            return this.models.map((m) => m.attributes).some(pred);
        }
        else {
            return this.models.some((m) => m.matches(pred));
        }
    }
    sortBy(iteratee) {
        return sortBy(this.models, isFunction(iteratee)
            ? iteratee
            : (m) => (isString(iteratee) ? m.get(iteratee) : m.matches(iteratee)));
    }
    isEmpty() {
        return !this.models.length;
    }
    keyBy(iteratee) {
        return keyBy(this.models, iteratee);
    }
    each(callback, thisArg) {
        return this.forEach(callback, thisArg);
    }
    forEach(callback, thisArg) {
        return this.models.forEach(callback, thisArg);
    }
    includes(item) {
        return this.models.includes(item);
    }
    size() {
        return this.models.length;
    }
    countBy(f) {
        return countBy(this.models, isFunction(f) ? f : (m) => (isString(f) ? m.get(f) : m.matches(f)));
    }
    groupBy(pred) {
        return groupBy(this.models, isFunction(pred) ? pred : (m) => (isString(pred) ? m.get(pred) : m.matches(pred)));
    }
    indexOf(model, fromIndex) {
        return this.models.indexOf(model, fromIndex);
    }
    findLastIndex(pred, fromIndex) {
        return this.models.findLastIndex(isFunction(pred)
            ? pred
            : (m) => (isString(pred) ? m.get(pred) : m.matches(pred)), fromIndex);
    }
    lastIndexOf(model, fromIndex) {
        return this.models.lastIndexOf(model, fromIndex);
    }
    findIndex(pred) {
        return this.models.findIndex(isFunction(pred)
            ? pred
            : (m) => (isString(pred) ? m.get(pred) : m.matches(pred)));
    }
    last() {
        const length = this.models == null ? 0 : this.models.length;
        return length ? this.models[length - 1] : undefined;
    }
    head() {
        return this.models[0];
    }
    first() {
        return this.head();
    }
    map(cb, thisArg) {
        return this.models.map(isFunction(cb)
            ? cb
            : (m) => (isString(cb) ? m.get(cb) : m.matches(cb)), thisArg);
    }
    reduce(callback, initialValue) {
        return this.models.reduce(callback, initialValue || this.models[0]);
    }
    reduceRight(callback, initialValue) {
        return this.models.reduceRight(callback, initialValue || this.models[0]);
    }
    toArray() {
        return Array.from(this.models);
    }
    /**
     * Get a model from the set by id, cid, model object with id or cid
     * properties, or an attributes object that is transformed through modelId.
     */
    get(obj) {
        if (obj == null)
            return undefined;
        return (this._byId[obj] ||
            this._byId[this.modelId(this._isModel(obj) ? obj.attributes : obj)] ||
            (obj.cid && this._byId[obj.cid]));
    }
    /**
     * Returns `true` if the model is in the collection.
     */
    has(obj) {
        return this.get(obj) != null;
    }
    /**
     * Get the model at the given index.
     */
    at(index) {
        if (index < 0)
            index += this.length;
        return this.models[index];
    }
    /**
     * Return models with matching attributes. Useful for simple cases of
     * `filter`.
     */
    where(attrs, first) {
        return this[first ? 'find' : 'filter'](attrs);
    }
    /**
     * Return the first model with matching attributes. Useful for simple cases
     * of `find`.
     */
    findWhere(attrs) {
        return this.where(attrs, true);
    }
    find(predicate, fromIndex) {
        const pred = isFunction(predicate)
            ? predicate
            : (m) => m.matches(predicate);
        return this.models.find(pred, fromIndex);
    }
    /**
     * Force the collection to re-sort itself. You don't need to call this under
     * normal circumstances, as the set will maintain sort order as each item
     * is added.
     */
    sort(options) {
        let comparator = this.comparator;
        if (!comparator)
            throw new Error('Cannot sort a set without a comparator');
        options = options || {};
        const length = isFunction(comparator) ? comparator.length : 0;
        if (isFunction(comparator))
            comparator = comparator.bind(this);
        // Run sort based on type of `comparator`.
        if (length === 1 || isString(comparator)) {
            this.models = this.sortBy(comparator);
        }
        else {
            this.models.sort(comparator);
        }
        if (!options.silent)
            this.trigger('sort', this, options);
        return this;
    }
    /**
     * Pluck an attribute from each model in the collection.
     */
    pluck(attr) {
        return this.map(attr + '');
    }
    /**
     * Fetch the default set of models for this collection, resetting the
     * collection when they arrive. If `reset: true` is passed, the response
     * data will be passed through the `reset` method instead of `set`.
     */
    fetch(options) {
        options = Object.assign({ parse: true }, options);
        const success = options.success;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const collection = this;
        const promise = options.promise ? getResolveablePromise() : undefined;
        // Tracks whether sync invoked one of the callbacks. A sync may instead
        // settle its returned promise; the `.then`/`.catch` below bridges that to
        // the callbacks so the fetch promise never hangs. The flag is set
        // synchronously inside each callback (before sync's promise resolves), so
        // it's reliable by the time those handlers run.
        let settled = false;
        options.success = function (resp) {
            settled = true;
            const method = options.reset ? 'reset' : 'set';
            // fromStorage prevents individual model set() calls from triggering auto-save on reads
            collection[method](resp, Object.assign({}, options, { fromStorage: true }));
            if (success)
                success.call(options.context, collection, resp, options);
            promise && promise.resolve();
            collection.trigger('sync', collection, resp, options);
        };
        wrapError(this, options, promise);
        if (promise) {
            const onError = options.error;
            options.error = (resp) => {
                settled = true;
                onError(resp);
            };
        }
        const result = this.sync('read', this, options);
        if (promise) {
            Promise.resolve(result).then(
            // A sync that resolves its promise without invoking options.success:
            // treat the resolved value as the response, so the collection is still
            // populated and the promise settles instead of hanging.
            (value) => {
                if (!settled)
                    options.success(value);
            }, 
            // A sync that rejects instead of invoking options.error; settling
            // twice is a harmless no-op.
            (e) => promise.reject(e));
            return promise;
        }
        return result;
    }
    /**
     * Create a new instance of a model in this collection. Add the model to the
     * collection immediately, unless `wait: true` is passed, in which case we
     * wait for the server to agree.
     */
    create(model, options) {
        options = options ? clone(options) : {};
        const wait = options.wait;
        const return_promise = options.promise;
        const promise = return_promise && getResolveablePromise();
        const preparedModel = this._prepareModel(model, options);
        if (!preparedModel)
            return null;
        if (!wait)
            this.add(preparedModel, options);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const collection = this;
        const success = options.success;
        const error = options.error;
        options.success = function (m, resp, callbackOpts) {
            if (wait) {
                collection.add(m, callbackOpts);
            }
            if (success) {
                success.call(callbackOpts.context, m, resp, callbackOpts);
            }
            if (return_promise) {
                promise.resolve(m);
            }
        };
        options.error = function (model, e, options) {
            error && error.call(options.context, model, e, options);
            return_promise && promise.reject(e);
        };
        preparedModel.save(null, Object.assign(options, { 'promise': false }));
        if (return_promise) {
            return promise;
        }
        else {
            return preparedModel;
        }
    }
    subscribe(eventOrCallback, callback, context) {
        if (typeof eventOrCallback === 'function') {
            const cb = () => eventOrCallback(this);
            this.on('update reset sort', cb);
            return () => this.off('update reset sort', cb);
        }
        return super.subscribe(eventOrCallback, callback, context);
    }
    /**
     * **parse** converts a response into a list of models to be added to the
     * collection. The default implementation is just to pass it through.
     */
    parse(resp, _options) {
        return resp;
    }
    /**
     * Define how to uniquely identify models in the collection.
     */
    modelId(attrs) {
        return attrs[this.model.prototype?.idAttribute || 'id'];
    }
    /** Get an iterator of all models in this collection. */
    values() {
        return new CollectionIterator(this, ITERATOR_VALUES);
    }
    /** Get an iterator of all model IDs in this collection. */
    keys() {
        return new CollectionIterator(this, ITERATOR_KEYS);
    }
    /** Get an iterator of all [ID, model] tuples in this collection. */
    entries() {
        return new CollectionIterator(this, ITERATOR_KEYSVALUES);
    }
    /**
     * Private method to reset all internal state. Called when the collection
     * is first initialized or reset.
     */
    _reset() {
        this.models = [];
        this._byId = {};
    }
    createModel(attrs, options) {
        const Klass = this.model;
        return new Klass(attrs, options);
    }
    /**
     * Prepare a hash of attributes (or other model) to be added to this
     * collection.
     */
    _prepareModel(attrs, options) {
        if (this._isModel(attrs)) {
            if (!attrs.collection)
                attrs.collection = this;
            return attrs;
        }
        options = options ? clone(options) : {};
        options.collection = this;
        const model = this.createModel(attrs, options);
        if (!model.validationError)
            return model;
        this.trigger('invalid', this, model.validationError, options);
        return null;
    }
    /**
     * Internal method called by both remove and set.
     */
    _removeModels(models, options) {
        const removed = [];
        for (let i = 0; i < models.length; i++) {
            const model = this.get(models[i]);
            if (!model)
                continue;
            const index = this.indexOf(model);
            this.models.splice(index, 1);
            // Remove references before triggering 'remove' event to prevent an
            // infinite loop. #3693
            delete this._byId[model.cid];
            const id = this.modelId(model.attributes);
            if (id != null)
                delete this._byId[id];
            if (!options?.silent) {
                options = options || {};
                options.index = index;
                model.trigger('remove', model, this, options);
            }
            removed.push(model);
            this._removeReference(model, options);
        }
        return removed;
    }
    /**
     * Method for checking whether an object should be considered a model for
     * the purposes of adding to the collection.
     */
    _isModel(model) {
        return model instanceof skeletor_esm_Model;
    }
    /**
     * Internal method to create a model's ties to a collection.
     */
    _addReference(model, _options) {
        this._byId[model.cid] = model;
        const id = this.modelId(model.attributes);
        if (id != null)
            this._byId[id] = model;
        model.on('all', this._onModelEvent, this);
    }
    /**
     * Internal method to sever a model's ties to a collection.
     */
    _removeReference(model, _options) {
        delete this._byId[model.cid];
        const id = this.modelId(model.attributes);
        if (id != null)
            delete this._byId[id];
        if (this === model.collection)
            delete model.collection;
        model.off('all', this._onModelEvent, this);
    }
    /**
     * Internal method called every time a model in the set fires an event.
     * Sets need to update their indexes when models change ids. All other
     * events simply proxy through. "add" and "remove" events that originate
     * in other collections are ignored.
     */
    _onModelEvent(event, model, collection, options) {
        if (model) {
            if ((event === 'add' || event === 'remove') && collection !== this)
                return;
            if (event === 'destroy')
                this.remove(model, options);
            if (event === 'change') {
                const prevId = this.modelId(model.previousAttributes());
                const id = this.modelId(model.attributes);
                if (prevId !== id) {
                    if (prevId != null)
                        delete this._byId[prevId];
                    if (id != null)
                        this._byId[id] = model;
                }
            }
        }
        this.trigger.apply(this, arguments);
    }
}
_Collection_instances = new WeakSet(), skeletor_esm_Collection_hydrate = async function _Collection_hydrate() {
    ensureUnloadListener(PersistentStorage);
    // An empty store is a normal first-run state: findAll() returns [] and a
    // missing model record resolves to null, so hydration resolves rather
    // than rejecting.
    await this.fetch({ fromStorage: true, promise: true });
}, skeletor_esm_a = Symbol.iterator;
// This "enum" defines the three possible kinds of values which can be emitted
// by a CollectionIterator that correspond to the values(), keys() and entries()
// methods on Collection, respectively.
const ITERATOR_VALUES = 1;
const ITERATOR_KEYS = 2;
const ITERATOR_KEYSVALUES = 3;
/**
 * @public
 */
class CollectionIterator {
    /**
     * A CollectionIterator implements JavaScript's Iterator protocol, allowing the
     * use of `for of` loops in modern browsers and interoperation between
     * Collection and other JavaScript functions and third-party libraries
     * which can operate on Iterables.
     */
    constructor(collection, kind) {
        this._collection = collection;
        this._kind = kind;
        this._index = 0;
    }
    next() {
        if (this._collection) {
            // Only continue iterating if the iterated collection is long enough.
            if (this._index < this._collection.length) {
                const model = this._collection.at(this._index);
                this._index++;
                if (!model) {
                    return { value: undefined, done: true };
                }
                // Construct a value depending on what kind of values should be iterated.
                let value;
                if (this._kind === ITERATOR_VALUES) {
                    value = model;
                }
                else {
                    const id = this._collection.modelId(model.attributes);
                    if (this._kind === ITERATOR_KEYS) {
                        value = id;
                    }
                    else {
                        // ITERATOR_KEYSVALUES
                        value = [id, model];
                    }
                }
                return { value, done: false };
            }
            // Once exhausted, remove the reference to the collection so future
            // calls to the next method always return done.
            this._collection = undefined;
        }
        return { value: undefined, done: true };
    }
    [Symbol.iterator]() {
        return this;
    }
}

/* global global */
/**
 * @public
 */
const skeletor = {
    Collection,
    EventEmitter: skeletor_esm_EventEmitter,
    Model: skeletor_esm_Model,
    sync: skeletor_esm_sync,
};
// Establish the root object, `window` (`self`) in the browser, or `global` on the server.
// We use `self` instead of `window` for `WebWorker` support.
const skeletor_esm_root = (typeof self == 'object' && self.self === self && self) ||
    (typeof global == 'object' && global.global === global && global);
// Current version of the library. Keep in sync with `package.json`.
skeletor.VERSION = '0.0.1';
// Save the previous value of the `Skeletor` variable, so that it can be
// restored later on, if `noConflict` is used.
const previousSkeletor = skeletor_esm_root.Skeletor;
// Runs Skeletor.js in *noConflict* mode, returning the `Skeletor` variable
// to its previous owner. Returns a reference to this Skeletor object.
/**
 * @public
 */
function noConflict() {
    skeletor_esm_root.Skeletor = previousSkeletor;
    return this;
}
skeletor.noConflict = noConflict;
skeletor_esm_root.Skeletor = skeletor;
/**
 * @deprecated Use `PersistentStorage` instead.
 * @public
 */
const BrowserStorage = PersistentStorage;


//# sourceMappingURL=skeletor.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@converse/openpromise/dist/openpromise.js
function openpromise_getOpenPromise() {
    const wrapper = {
        isResolved: false,
        isPending: true,
        isRejected: false
    };
    let promise;
    let resolve = () => { };
    let reject = () => { };
    if (typeof Promise.withResolvers === 'function') {
        const { promise: p, resolve: r, reject: j } = Promise.withResolvers();
        promise = p;
        resolve = r;
        reject = j;
    }
    else {
        promise = new Promise((r, j) => {
            resolve = r;
            reject = j;
        });
    }
    Object.assign(promise, {
        ...wrapper,
        resolve,
        reject
    });
    promise.then((v) => {
        promise.isResolved = true;
        promise.isPending = false;
        promise.isRejected = false;
        return v;
    }, (e) => {
        promise.isResolved = false;
        promise.isPending = false;
        promise.isRejected = true;
        throw e;
    });
    return promise;
}
//# sourceMappingURL=openpromise.js.map
;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function _listCacheClear_listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* export default */ const _listCacheClear = (_listCacheClear_listCacheClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq_eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* export default */ const lodash_es_eq = (eq_eq);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function _assocIndexOf_assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* export default */ const _assocIndexOf = (_assocIndexOf_assocIndexOf);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var _listCacheDelete_arrayProto = Array.prototype;

/** Built-in value references. */
var _listCacheDelete_splice = _listCacheDelete_arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function _listCacheDelete_listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    _listCacheDelete_splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* export default */ const _listCacheDelete = (_listCacheDelete_listCacheDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function _listCacheGet_listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* export default */ const _listCacheGet = (_listCacheGet_listCacheGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function _listCacheHas_listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* export default */ const _listCacheHas = (_listCacheHas_listCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function _listCacheSet_listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* export default */ const _listCacheSet = (_listCacheSet_listCacheSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function _ListCache_ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
_ListCache_ListCache.prototype.clear = _listCacheClear;
_ListCache_ListCache.prototype['delete'] = _listCacheDelete;
_ListCache_ListCache.prototype.get = _listCacheGet;
_ListCache_ListCache.prototype.has = _listCacheHas;
_ListCache_ListCache.prototype.set = _listCacheSet;

/* export default */ const _ListCache = (_ListCache_ListCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function _stackClear_stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* export default */ const _stackClear = (_stackClear_stackClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function _stackDelete_stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* export default */ const _stackDelete = (_stackDelete_stackDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function _stackGet_stackGet(key) {
  return this.__data__.get(key);
}

/* export default */ const _stackGet = (_stackGet_stackGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function _stackHas_stackHas(key) {
  return this.__data__.has(key);
}

/* export default */ const _stackHas = (_stackHas_stackHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_freeGlobal.js
/** Detect free variable `global` from Node.js. */
var _freeGlobal_freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* export default */ const _freeGlobal = (_freeGlobal_freeGlobal);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var _root_freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var _root_root = _freeGlobal || _root_freeSelf || Function('return this')();

/* export default */ const _root = (_root_root);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var _Symbol_Symbol = _root.Symbol;

/* export default */ const _Symbol = (_Symbol_Symbol);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var _getRawTag_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = _getRawTag_objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _getRawTag_nativeObjectToString = _getRawTag_objectProto.toString;

/** Built-in value references. */
var _getRawTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function _getRawTag_getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, _getRawTag_symToStringTag),
      tag = value[_getRawTag_symToStringTag];

  try {
    value[_getRawTag_symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = _getRawTag_nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[_getRawTag_symToStringTag] = tag;
    } else {
      delete value[_getRawTag_symToStringTag];
    }
  }
  return result;
}

/* export default */ const _getRawTag = (_getRawTag_getRawTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function _objectToString_objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* export default */ const _objectToString = (_objectToString_objectToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var _baseGetTag_nullTag = '[object Null]',
    _baseGetTag_undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function _baseGetTag_baseGetTag(value) {
  if (value == null) {
    return value === undefined ? _baseGetTag_undefinedTag : _baseGetTag_nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* export default */ const _baseGetTag = (_baseGetTag_baseGetTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject_isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* export default */ const lodash_es_isObject = (isObject_isObject);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var isFunction_asyncTag = '[object AsyncFunction]',
    isFunction_funcTag = '[object Function]',
    isFunction_genTag = '[object GeneratorFunction]',
    isFunction_proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction_isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == isFunction_funcTag || tag == isFunction_genTag || tag == isFunction_asyncTag || tag == isFunction_proxyTag;
}

/* export default */ const lodash_es_isFunction = (isFunction_isFunction);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var _coreJsData_coreJsData = _root["__core-js_shared__"];

/* export default */ const _coreJsData = (_coreJsData_coreJsData);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var _isMasked_maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function _isMasked_isMasked(func) {
  return !!_isMasked_maskSrcKey && (_isMasked_maskSrcKey in func);
}

/* export default */ const _isMasked = (_isMasked_isMasked);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var _toSource_funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var _toSource_funcToString = _toSource_funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function _toSource_toSource(func) {
  if (func != null) {
    try {
      return _toSource_funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* export default */ const _toSource = (_toSource_toSource);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var _baseIsNative_reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var _baseIsNative_reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var _baseIsNative_reIsNative = RegExp('^' +
  _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(_baseIsNative_reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function _baseIsNative_baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? _baseIsNative_reIsNative : _baseIsNative_reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* export default */ const _baseIsNative = (_baseIsNative_baseIsNative);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function _getValue_getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* export default */ const _getValue = (_getValue_getValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function _getNative_getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* export default */ const _getNative = (_getNative_getNative);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var _Map_Map = _getNative(_root, 'Map');

/* export default */ const _Map = (_Map_Map);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var _nativeCreate_nativeCreate = _getNative(Object, 'create');

/* export default */ const _nativeCreate = (_nativeCreate_nativeCreate);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function _hashClear_hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* export default */ const _hashClear = (_hashClear_hashClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function _hashDelete_hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* export default */ const _hashDelete = (_hashDelete_hashDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var _hashGet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function _hashGet_hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === _hashGet_HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* export default */ const _hashGet = (_hashGet_hashGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function _hashHas_hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* export default */ const _hashHas = (_hashHas_hashHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function _hashSet_hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* export default */ const _hashSet = (_hashSet_hashSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function _Hash_Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
_Hash_Hash.prototype.clear = _hashClear;
_Hash_Hash.prototype['delete'] = _hashDelete;
_Hash_Hash.prototype.get = _hashGet;
_Hash_Hash.prototype.has = _hashHas;
_Hash_Hash.prototype.set = _hashSet;

/* export default */ const _Hash = (_Hash_Hash);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function _mapCacheClear_mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* export default */ const _mapCacheClear = (_mapCacheClear_mapCacheClear);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function _isKeyable_isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* export default */ const _isKeyable = (_isKeyable_isKeyable);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function _getMapData_getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* export default */ const _getMapData = (_getMapData_getMapData);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function _mapCacheDelete_mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* export default */ const _mapCacheDelete = (_mapCacheDelete_mapCacheDelete);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function _mapCacheGet_mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* export default */ const _mapCacheGet = (_mapCacheGet_mapCacheGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function _mapCacheHas_mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* export default */ const _mapCacheHas = (_mapCacheHas_mapCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function _mapCacheSet_mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* export default */ const _mapCacheSet = (_mapCacheSet_mapCacheSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function _MapCache_MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
_MapCache_MapCache.prototype.clear = _mapCacheClear;
_MapCache_MapCache.prototype['delete'] = _mapCacheDelete;
_MapCache_MapCache.prototype.get = _mapCacheGet;
_MapCache_MapCache.prototype.has = _mapCacheHas;
_MapCache_MapCache.prototype.set = _mapCacheSet;

/* export default */ const _MapCache = (_MapCache_MapCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var _stackSet_LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function _stackSet_stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < _stackSet_LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* export default */ const _stackSet = (_stackSet_stackSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function _Stack_Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
_Stack_Stack.prototype.clear = _stackClear;
_Stack_Stack.prototype['delete'] = _stackDelete;
_Stack_Stack.prototype.get = _stackGet;
_Stack_Stack.prototype.has = _stackHas;
_Stack_Stack.prototype.set = _stackSet;

/* export default */ const _Stack = (_Stack_Stack);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheAdd.js
/** Used to stand-in for `undefined` hash values. */
var _setCacheAdd_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function _setCacheAdd_setCacheAdd(value) {
  this.__data__.set(value, _setCacheAdd_HASH_UNDEFINED);
  return this;
}

/* export default */ const _setCacheAdd = (_setCacheAdd_setCacheAdd);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheHas.js
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function _setCacheHas_setCacheHas(value) {
  return this.__data__.has(value);
}

/* export default */ const _setCacheHas = (_setCacheHas_setCacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_SetCache.js




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function _SetCache_SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
_SetCache_SetCache.prototype.add = _SetCache_SetCache.prototype.push = _setCacheAdd;
_SetCache_SetCache.prototype.has = _setCacheHas;

/* export default */ const _SetCache = (_SetCache_SetCache);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySome.js
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function _arraySome_arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* export default */ const _arraySome = (_arraySome_arraySome);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_cacheHas.js
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function _cacheHas_cacheHas(cache, key) {
  return cache.has(key);
}

/* export default */ const _cacheHas = (_cacheHas_cacheHas);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalArrays.js




/** Used to compose bitmasks for value comparisons. */
var _equalArrays_COMPARE_PARTIAL_FLAG = 1,
    _equalArrays_COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function _equalArrays_equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalArrays_COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & _equalArrays_COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* export default */ const _equalArrays = (_equalArrays_equalArrays);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var _Uint8Array_Uint8Array = _root.Uint8Array;

/* export default */ const _Uint8Array = (_Uint8Array_Uint8Array);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_mapToArray.js
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function _mapToArray_mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* export default */ const _mapToArray = (_mapToArray_mapToArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setToArray.js
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function _setToArray_setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* export default */ const _setToArray = (_setToArray_setToArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalByTag.js







/** Used to compose bitmasks for value comparisons. */
var _equalByTag_COMPARE_PARTIAL_FLAG = 1,
    _equalByTag_COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var _equalByTag_boolTag = '[object Boolean]',
    _equalByTag_dateTag = '[object Date]',
    _equalByTag_errorTag = '[object Error]',
    _equalByTag_mapTag = '[object Map]',
    _equalByTag_numberTag = '[object Number]',
    _equalByTag_regexpTag = '[object RegExp]',
    _equalByTag_setTag = '[object Set]',
    _equalByTag_stringTag = '[object String]',
    _equalByTag_symbolTag = '[object Symbol]';

var _equalByTag_arrayBufferTag = '[object ArrayBuffer]',
    _equalByTag_dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var _equalByTag_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    _equalByTag_symbolValueOf = _equalByTag_symbolProto ? _equalByTag_symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function _equalByTag_equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case _equalByTag_dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case _equalByTag_arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case _equalByTag_boolTag:
    case _equalByTag_dateTag:
    case _equalByTag_numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return lodash_es_eq(+object, +other);

    case _equalByTag_errorTag:
      return object.name == other.name && object.message == other.message;

    case _equalByTag_regexpTag:
    case _equalByTag_stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case _equalByTag_mapTag:
      var convert = _mapToArray;

    case _equalByTag_setTag:
      var isPartial = bitmask & _equalByTag_COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= _equalByTag_COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case _equalByTag_symbolTag:
      if (_equalByTag_symbolValueOf) {
        return _equalByTag_symbolValueOf.call(object) == _equalByTag_symbolValueOf.call(other);
      }
  }
  return false;
}

/* export default */ const _equalByTag = (_equalByTag_equalByTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function _arrayPush_arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* export default */ const _arrayPush = (_arrayPush_arrayPush);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray_isArray = Array.isArray;

/* export default */ const lodash_es_isArray = (isArray_isArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function _baseGetAllKeys_baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return lodash_es_isArray(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* export default */ const _baseGetAllKeys = (_baseGetAllKeys_baseGetAllKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function _arrayFilter_arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* export default */ const _arrayFilter = (_arrayFilter_arrayFilter);

;// CONCATENATED MODULE: ./node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray_stubArray() {
  return [];
}

/* export default */ const lodash_es_stubArray = (stubArray_stubArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var _getSymbols_propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var _getSymbols_nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var _getSymbols_getSymbols = !_getSymbols_nativeGetSymbols ? lodash_es_stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(_getSymbols_nativeGetSymbols(object), function(symbol) {
    return _getSymbols_propertyIsEnumerable.call(object, symbol);
  });
};

/* export default */ const _getSymbols = (_getSymbols_getSymbols);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function _baseTimes_baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* export default */ const _baseTimes = (_baseTimes_baseTimes);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike_isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* export default */ const lodash_es_isObjectLike = (isObjectLike_isObjectLike);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var _baseIsArguments_argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function _baseIsArguments_baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == _baseIsArguments_argsTag;
}

/* export default */ const _baseIsArguments = (_baseIsArguments_baseIsArguments);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var isArguments_propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments_isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !isArguments_propertyIsEnumerable.call(value, 'callee');
};

/* export default */ const lodash_es_isArguments = (isArguments_isArguments);

;// CONCATENATED MODULE: ./node_modules/lodash-es/stubFalse.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse_stubFalse() {
  return false;
}

/* export default */ const lodash_es_stubFalse = (stubFalse_stubFalse);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isBuffer.js



/** Detect free variable `exports`. */
var isBuffer_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var isBuffer_freeModule = isBuffer_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var isBuffer_moduleExports = isBuffer_freeModule && isBuffer_freeModule.exports === isBuffer_freeExports;

/** Built-in value references. */
var isBuffer_Buffer = isBuffer_moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var isBuffer_nativeIsBuffer = isBuffer_Buffer ? isBuffer_Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer_isBuffer = isBuffer_nativeIsBuffer || lodash_es_stubFalse;

/* export default */ const lodash_es_isBuffer = (isBuffer_isBuffer);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isIndex.js
/** Used as references for various `Number` constants. */
var _isIndex_MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var _isIndex_reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function _isIndex_isIndex(value, length) {
  var type = typeof value;
  length = length == null ? _isIndex_MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && _isIndex_reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* export default */ const _isIndex = (_isIndex_isIndex);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var isLength_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength_isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= isLength_MAX_SAFE_INTEGER;
}

/* export default */ const lodash_es_isLength = (isLength_isLength);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    _baseIsTypedArray_arrayTag = '[object Array]',
    _baseIsTypedArray_boolTag = '[object Boolean]',
    _baseIsTypedArray_dateTag = '[object Date]',
    _baseIsTypedArray_errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    _baseIsTypedArray_mapTag = '[object Map]',
    _baseIsTypedArray_numberTag = '[object Number]',
    _baseIsTypedArray_objectTag = '[object Object]',
    _baseIsTypedArray_regexpTag = '[object RegExp]',
    _baseIsTypedArray_setTag = '[object Set]',
    _baseIsTypedArray_stringTag = '[object String]',
    _baseIsTypedArray_weakMapTag = '[object WeakMap]';

var _baseIsTypedArray_arrayBufferTag = '[object ArrayBuffer]',
    _baseIsTypedArray_dataViewTag = '[object DataView]',
    _baseIsTypedArray_float32Tag = '[object Float32Array]',
    _baseIsTypedArray_float64Tag = '[object Float64Array]',
    _baseIsTypedArray_int8Tag = '[object Int8Array]',
    _baseIsTypedArray_int16Tag = '[object Int16Array]',
    _baseIsTypedArray_int32Tag = '[object Int32Array]',
    _baseIsTypedArray_uint8Tag = '[object Uint8Array]',
    _baseIsTypedArray_uint8ClampedTag = '[object Uint8ClampedArray]',
    _baseIsTypedArray_uint16Tag = '[object Uint16Array]',
    _baseIsTypedArray_uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var _baseIsTypedArray_typedArrayTags = {};
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_float32Tag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_float64Tag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_int8Tag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_int16Tag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_int32Tag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_uint8Tag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_uint8ClampedTag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_uint16Tag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_uint32Tag] = true;
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_argsTag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_arrayTag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_arrayBufferTag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_boolTag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_dataViewTag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_dateTag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_errorTag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_funcTag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_mapTag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_numberTag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_objectTag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_regexpTag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_setTag] = _baseIsTypedArray_typedArrayTags[_baseIsTypedArray_stringTag] =
_baseIsTypedArray_typedArrayTags[_baseIsTypedArray_weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function _baseIsTypedArray_baseIsTypedArray(value) {
  return lodash_es_isObjectLike(value) &&
    lodash_es_isLength(value.length) && !!_baseIsTypedArray_typedArrayTags[_baseGetTag(value)];
}

/* export default */ const _baseIsTypedArray = (_baseIsTypedArray_baseIsTypedArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function _baseUnary_baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* export default */ const _baseUnary = (_baseUnary_baseUnary);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nodeUtil.js


/** Detect free variable `exports`. */
var _nodeUtil_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var _nodeUtil_freeModule = _nodeUtil_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var _nodeUtil_moduleExports = _nodeUtil_freeModule && _nodeUtil_freeModule.exports === _nodeUtil_freeExports;

/** Detect free variable `process` from Node.js. */
var _nodeUtil_freeProcess = _nodeUtil_moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var _nodeUtil_nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = _nodeUtil_freeModule && _nodeUtil_freeModule.require && _nodeUtil_freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return _nodeUtil_freeProcess && _nodeUtil_freeProcess.binding && _nodeUtil_freeProcess.binding('util');
  } catch (e) {}
}());

/* export default */ const _nodeUtil = (_nodeUtil_nodeUtil);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var isTypedArray_nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray_isTypedArray = isTypedArray_nodeIsTypedArray ? _baseUnary(isTypedArray_nodeIsTypedArray) : _baseIsTypedArray;

/* export default */ const lodash_es_isTypedArray = (isTypedArray_isTypedArray);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function _arrayLikeKeys_arrayLikeKeys(value, inherited) {
  var isArr = lodash_es_isArray(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && lodash_es_isBuffer(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* export default */ const _arrayLikeKeys = (_arrayLikeKeys_arrayLikeKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function _isPrototype_isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* export default */ const _isPrototype = (_isPrototype_isPrototype);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function _overArg_overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* export default */ const _overArg = (_overArg_overArg);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var _nativeKeys_nativeKeys = _overArg(Object.keys, Object);

/* export default */ const _nativeKeys = (_nativeKeys_nativeKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function _baseKeys_baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* export default */ const _baseKeys = (_baseKeys_baseKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike_isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* export default */ const lodash_es_isArrayLike = (isArrayLike_isArrayLike);

;// CONCATENATED MODULE: ./node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys_keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* export default */ const lodash_es_keys = (keys_keys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function _getAllKeys_getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* export default */ const _getAllKeys = (_getAllKeys_getAllKeys);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_equalObjects.js


/** Used to compose bitmasks for value comparisons. */
var _equalObjects_COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var _equalObjects_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _equalObjects_hasOwnProperty = _equalObjects_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function _equalObjects_equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalObjects_COMPARE_PARTIAL_FLAG,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : _equalObjects_hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* export default */ const _equalObjects = (_equalObjects_equalObjects);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var _DataView_DataView = _getNative(_root, 'DataView');

/* export default */ const _DataView = (_DataView_DataView);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var _Promise_Promise = _getNative(_root, 'Promise');

/* export default */ const _Promise = (_Promise_Promise);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var _Set_Set = _getNative(_root, 'Set');

/* export default */ const _Set = (_Set_Set);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var _WeakMap_WeakMap = _getNative(_root, 'WeakMap');

/* export default */ const _WeakMap = (_WeakMap_WeakMap);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    _getTag_promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var _getTag_dataViewCtorString = _toSource(_DataView),
    _getTag_mapCtorString = _toSource(_Map),
    _getTag_promiseCtorString = _toSource(_Promise),
    _getTag_setCtorString = _toSource(_Set),
    _getTag_weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var _getTag_getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && _getTag_getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag) ||
    (_Map && _getTag_getTag(new _Map) != _getTag_mapTag) ||
    (_Promise && _getTag_getTag(_Promise.resolve()) != _getTag_promiseTag) ||
    (_Set && _getTag_getTag(new _Set) != _getTag_setTag) ||
    (_WeakMap && _getTag_getTag(new _WeakMap) != _getTag_weakMapTag)) {
  _getTag_getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == _getTag_objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case _getTag_dataViewCtorString: return _getTag_dataViewTag;
        case _getTag_mapCtorString: return _getTag_mapTag;
        case _getTag_promiseCtorString: return _getTag_promiseTag;
        case _getTag_setCtorString: return _getTag_setTag;
        case _getTag_weakMapCtorString: return _getTag_weakMapTag;
      }
    }
    return result;
  };
}

/* export default */ const _getTag = (_getTag_getTag);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqualDeep.js









/** Used to compose bitmasks for value comparisons. */
var _baseIsEqualDeep_COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var _baseIsEqualDeep_argsTag = '[object Arguments]',
    _baseIsEqualDeep_arrayTag = '[object Array]',
    _baseIsEqualDeep_objectTag = '[object Object]';

/** Used for built-in method references. */
var _baseIsEqualDeep_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseIsEqualDeep_hasOwnProperty = _baseIsEqualDeep_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function _baseIsEqualDeep_baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = lodash_es_isArray(object),
      othIsArr = lodash_es_isArray(other),
      objTag = objIsArr ? _baseIsEqualDeep_arrayTag : _getTag(object),
      othTag = othIsArr ? _baseIsEqualDeep_arrayTag : _getTag(other);

  objTag = objTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : objTag;
  othTag = othTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : othTag;

  var objIsObj = objTag == _baseIsEqualDeep_objectTag,
      othIsObj = othTag == _baseIsEqualDeep_objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && lodash_es_isBuffer(object)) {
    if (!lodash_es_isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || lodash_es_isTypedArray(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & _baseIsEqualDeep_COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && _baseIsEqualDeep_hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && _baseIsEqualDeep_hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/* export default */ const _baseIsEqualDeep = (_baseIsEqualDeep_baseIsEqualDeep);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqual.js



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function _baseIsEqual_baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!lodash_es_isObjectLike(value) && !lodash_es_isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, _baseIsEqual_baseIsEqual, stack);
}

/* export default */ const _baseIsEqual = (_baseIsEqual_baseIsEqual);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isEqual.js


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual_isEqual(value, other) {
  return _baseIsEqual(value, other);
}

/* export default */ const lodash_es_isEqual = (isEqual_isEqual);

;// CONCATENATED MODULE: ./node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var isSymbol_symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol_isSymbol(value) {
  return typeof value == 'symbol' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == isSymbol_symbolTag);
}

/* export default */ const lodash_es_isSymbol = (isSymbol_isSymbol);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isKey.js



/** Used to match property names within property paths. */
var _isKey_reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    _isKey_reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function _isKey_isKey(value, object) {
  if (lodash_es_isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || lodash_es_isSymbol(value)) {
    return true;
  }
  return _isKey_reIsPlainProp.test(value) || !_isKey_reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* export default */ const _isKey = (_isKey_isKey);

;// CONCATENATED MODULE: ./node_modules/lodash-es/memoize.js


/** Error message constants. */
var memoize_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize_memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(memoize_FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize_memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize_memoize.Cache = _MapCache;

/* export default */ const lodash_es_memoize = (memoize_memoize);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var _memoizeCapped_MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function _memoizeCapped_memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === _memoizeCapped_MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* export default */ const _memoizeCapped = (_memoizeCapped_memoizeCapped);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var _stringToPath_rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var _stringToPath_reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var _stringToPath_stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(_stringToPath_rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(_stringToPath_reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* export default */ const _stringToPath = (_stringToPath_stringToPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function _arrayMap_arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* export default */ const _arrayMap = (_arrayMap_arrayMap);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var _baseToString_INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var _baseToString_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    _baseToString_symbolToString = _baseToString_symbolProto ? _baseToString_symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function _baseToString_baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, _baseToString_baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return _baseToString_symbolToString ? _baseToString_symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_baseToString_INFINITY) ? '-0' : result;
}

/* export default */ const _baseToString = (_baseToString_baseToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* export default */ const lodash_es_toString = (toString_toString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_castPath.js





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function _castPath_castPath(value, object) {
  if (lodash_es_isArray(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(lodash_es_toString(value));
}

/* export default */ const _castPath = (_castPath_castPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var _toKey_INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function _toKey_toKey(value) {
  if (typeof value == 'string' || lodash_es_isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_toKey_INFINITY) ? '-0' : result;
}

/* export default */ const _toKey = (_toKey_toKey);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGet.js



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function _baseGet_baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* export default */ const _baseGet = (_baseGet_baseGet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_defineProperty.js


var _defineProperty_defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* export default */ const _defineProperty = (_defineProperty_defineProperty);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function _baseAssignValue_baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* export default */ const _baseAssignValue = (_baseAssignValue_baseAssignValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function _assignValue_assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* export default */ const _assignValue = (_assignValue_assignValue);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSet.js






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function _baseSet_baseSet(object, path, value, customizer) {
  if (!lodash_es_isObject(object)) {
    return object;
  }
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = _toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = lodash_es_isObject(objValue)
          ? objValue
          : (_isIndex(path[index + 1]) ? [] : {});
      }
    }
    _assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* export default */ const _baseSet = (_baseSet_baseSet);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_basePickBy.js




/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function _basePickBy_basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = _baseGet(object, path);

    if (predicate(value, path)) {
      _baseSet(result, _castPath(path, object), value);
    }
  }
  return result;
}

/* export default */ const _basePickBy = (_basePickBy_basePickBy);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function _baseHasIn_baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* export default */ const _baseHasIn = (_baseHasIn_baseHasIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function _hasPath_hasPath(object, path, hasFunc) {
  path = _castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = _toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && lodash_es_isLength(length) && _isIndex(key, length) &&
    (lodash_es_isArray(object) || lodash_es_isArguments(object));
}

/* export default */ const _hasPath = (_hasPath_hasPath);

;// CONCATENATED MODULE: ./node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn_hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* export default */ const lodash_es_hasIn = (hasIn_hasIn);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_basePick.js



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function _basePick_basePick(object, paths) {
  return _basePickBy(object, paths, function(value, path) {
    return lodash_es_hasIn(object, path);
  });
}

/* export default */ const _basePick = (_basePick_basePick);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_isFlattenable.js




/** Built-in value references. */
var _isFlattenable_spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function _isFlattenable_isFlattenable(value) {
  return lodash_es_isArray(value) || lodash_es_isArguments(value) ||
    !!(_isFlattenable_spreadableSymbol && value && value[_isFlattenable_spreadableSymbol]);
}

/* export default */ const _isFlattenable = (_isFlattenable_isFlattenable);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFlatten.js



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function _baseFlatten_baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        _baseFlatten_baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* export default */ const _baseFlatten = (_baseFlatten_baseFlatten);

;// CONCATENATED MODULE: ./node_modules/lodash-es/flatten.js


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten_flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

/* export default */ const lodash_es_flatten = (flatten_flatten);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_apply.js
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function _apply_apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* export default */ const _apply = (_apply_apply);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var _overRest_nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function _overRest_overRest(func, start, transform) {
  start = _overRest_nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = _overRest_nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

/* export default */ const _overRest = (_overRest_overRest);

;// CONCATENATED MODULE: ./node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant_constant(value) {
  return function() {
    return value;
  };
}

/* export default */ const lodash_es_constant = (constant_constant);

;// CONCATENATED MODULE: ./node_modules/lodash-es/identity.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity_identity(value) {
  return value;
}

/* export default */ const lodash_es_identity = (identity_identity);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var _baseSetToString_baseSetToString = !_defineProperty ? lodash_es_identity : function(func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* export default */ const _baseSetToString = (_baseSetToString_baseSetToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var _shortOut_HOT_COUNT = 800,
    _shortOut_HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var _shortOut_nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function _shortOut_shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = _shortOut_nativeNow(),
        remaining = _shortOut_HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= _shortOut_HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* export default */ const _shortOut = (_shortOut_shortOut);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var _setToString_setToString = _shortOut(_baseSetToString);

/* export default */ const _setToString = (_setToString_setToString);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_flatRest.js




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function _flatRest_flatRest(func) {
  return _setToString(_overRest(func, undefined, lodash_es_flatten), func + '');
}

/* export default */ const _flatRest = (_flatRest_flatRest);

;// CONCATENATED MODULE: ./node_modules/lodash-es/pick.js



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick_pick = _flatRest(function(object, paths) {
  return object == null ? {} : _basePick(object, paths);
});

/* export default */ const lodash_es_pick = (pick_pick);

;// CONCATENATED MODULE: ./src/headless/utils/environment.js
/**
 * Helpers for the parts of Converse that assume a browser page.
 *
 * Converse re-joins MUCs when the tab becomes visible again, flushes storage
 * before the page goes away and reads routes off the location hash. None of
 * that exists in Node, so every call site goes through here rather than
 * touching `window`, `document` or `location` directly.
 *
 * Outside a browser the listeners are no-ops, `getRouteHash()` is empty and
 * `isAppHidden()` reports the app as visible, which is the truthful answer for
 * a process that is never backgrounded: pings keep flowing and rooms stay
 * joined, which is what a long-running headless client wants.
 *
 * @module utils/environment
 */

/**
 * Whether we're running in a browser page, as opposed to Node.js.
 * @type {boolean}
 */
const IS_BROWSER = typeof window !== 'undefined' && typeof window.addEventListener === 'function';

/**
 * The event that fires when the page is going away.
 * @returns {'pagehide'|'beforeunload'|'unload'}
 */
function getUnloadEvent() {
    if (!IS_BROWSER) return 'unload';

    if ('onpagehide' in window) {
        // Pagehide gets thrown in more cases than unload. Specifically it
        // gets thrown when the page is cached and not just
        // closed/destroyed. It's the only viable event on mobile Safari.
        // https://www.webkit.org/blog/516/webkit-page-cache-ii-the-unload-event/
        return 'pagehide';
    } else if ('onbeforeunload' in window) {
        return 'beforeunload';
    }
    return 'unload';
}

/**
 * @param {EventListener} listener
 * @param {AddEventListenerOptions} [options]
 */
function addUnloadListener(listener, options) {
    if (IS_BROWSER) window.addEventListener(getUnloadEvent(), listener, options);
}

/**
 * @param {EventListener} listener
 */
function removeUnloadListener(listener) {
    if (IS_BROWSER) window.removeEventListener(getUnloadEvent(), listener);
}

/**
 * Whether the app is currently out of sight, e.g. in a background tab.
 * @returns {boolean}
 */
function isAppHidden() {
    return IS_BROWSER ? document.hidden : false;
}

/**
 * @param {EventListener} listener
 */
function addVisibilityListener(listener) {
    if (IS_BROWSER) document.addEventListener('visibilitychange', listener);
}

/**
 * @param {EventListener} listener
 */
function removeVisibilityListener(listener) {
    if (IS_BROWSER) document.removeEventListener('visibilitychange', listener);
}

/**
 * The URL fragment Converse routes on, e.g. `#converse/room?jid=...`.
 * @returns {string}
 */
function getRouteHash() {
    return IS_BROWSER ? location.hash : '';
}

/**
 * @param {EventListener} listener
 */
function addRouteListener(listener) {
    if (IS_BROWSER) window.addEventListener('hashchange', listener);
}

/**
 * @param {EventListener} listener
 */
function removeRouteListener(listener) {
    if (IS_BROWSER) window.removeEventListener('hashchange', listener);
}

/**
 * Reads from `localStorage`, which Converse uses to remember the JID to offer
 * at the next login. Outside a browser there's nothing to read, and nothing is
 * lost by that: a headless client is told its JID by whoever starts it.
 * @param {string} key
 * @returns {string|null}
 */
function getLocalStorageItem(key) {
    return IS_BROWSER ? localStorage.getItem(key) : null;
}

/**
 * @param {string} key
 * @param {string} value
 */
function setLocalStorageItem(key, value) {
    if (IS_BROWSER) localStorage.setItem(key, value);
}

/**
 * @param {string} key
 */
function removeLocalStorageItem(key) {
    if (IS_BROWSER) localStorage.removeItem(key);
}

/**
 * Whether the browser exposes the Credential Management API, which Converse
 * can log in with.
 * @returns {boolean}
 */
function hasCredentialsAPI() {
    return IS_BROWSER && 'credentials' in navigator;
}

;// CONCATENATED MODULE: ./src/headless/shared/settings/constants.js
/**
 * @typedef {Object } ConfigurationSettings
 * Converse's core configuration values
 * @property {Boolean} [allow_non_roster_messaging=false]
 * @property {Boolean} [allow_url_history_change=true]
 * @property {String} [assets_path='/dist']
 * @property {('login'|'prebind'|'anonymous'|'external')} [authentication='login']
 * @property {Boolean} [auto_login=false] - Currently only used in connection with anonymous login
 * @property {Boolean} [reuse_scram_keys=true] - Save SCRAM keys after login to allow for future auto login
 * @property {Boolean} [auto_reconnect=true]
 * @property {Array<String>} [blacklisted_plugins]
 * @property {Boolean} [clear_cache_on_logout=false]
 * @property {Object} [connection_options]
 * @property {String} [credentials_url] - URL from where login credentials can be fetched
 * @property {Boolean} [discover_connection_methods=true]
 * @property {RegExp} [geouri_regex]
 * @property {RegExp} [geouri_replacement='https://www.openstreetmap.org/?mlat=$1&mlon=$2#map=18/$1/$2']
 * @property {String} [i18n]
 * @property {String} [jid]
 * @property {Boolean} [keepalive=true]
 * @property {('debug'|'info'|'error')} [loglevel='info']
 * @property {Array<String>} [locales]
 * @property {String} [nickname]
 * @property {String} [password]
 * @property {('IndexedDB'|'localStorage')} [persistent_store='IndexedDB']
 * @property {String} [rid]
 * @property {Element} [root=window.document] - The DOM node Converse renders into. Null outside a browser.
 * @property {String} [sid]
 * @property {String} [storage_path] - Node.js only. Directory for the SQLite database.
 *  Defaults to `$XDG_STATE_HOME/converse`, or `~/.local/state/converse`.
 * @property {Boolean} [singleton=false]
 * @property {Boolean} [strict_plugin_dependencies=false]
 * @property {('fullscreen'|'embedded'|'overlayed')} [view_mode='fullscreen']
 * @property {String} [websocket_url]
 * @property {Array<String>} [whitelisted_plugins]
 */

const DEFAULT_SETTINGS = {
    allow_non_roster_messaging: true,
    allow_url_history_change: true,
    assets_path: '/dist',
    authentication: 'login', // Available values are "login", "prebind", "anonymous" and "external".
    auto_login: false, // Currently only used in connection with anonymous login
    auto_reconnect: true,
    blacklisted_plugins: [],
    clear_cache_on_logout: false,
    connection_options: {},
    credentials_url: null, // URL from where login credentials can be fetched
    disable_effects: false, // Disabled UI transition effects. Mainly used for tests.
    discover_connection_methods: true,
    embed_3rd_party_media_players: true,
    geouri_regex: /https\:\/\/www.openstreetmap.org\/.*#map=[0-9]+\/([\-0-9.]+)\/([\-0-9.]+)\S*/g,
    geouri_replacement: 'https://www.openstreetmap.org/?mlat=$1&mlon=$2#map=18/$1/$2',
    i18n: undefined,
    jid: undefined,
    reuse_scram_keys: true,
    keepalive: true,
    loglevel: 'info',
    locales: [
        'af',
        'ar',
        'bg',
        'ca',
        'cs',
        'da',
        'de',
        'el',
        'en',
        'eo',
        'es',
        'eu',
        'fa',
        'fi',
        'fr',
        'gl',
        'he',
        'hi',
        'hu',
        'id',
        'it',
        'ja',
        'lt',
        'mn',
        'mr',
        'nb',
        'nl',
        'oc',
        'pl',
        'pt',
        'pt_BR',
        'ro',
        'ru',
        'sv',
        'ta',
        'th',
        'tr',
        'ug',
        'uk',
        'vi',
        'zh_CN',
        'zh_TW',
    ],
    nickname: undefined,
    password: undefined,
    persistent_store: 'IndexedDB',
    rid: undefined,
    root: IS_BROWSER ? window.document : null,
    sid: undefined,
    storage_path: undefined,
    singleton: false,
    strict_plugin_dependencies: false,
    stanza_timeout: 60000,
    view_mode: 'fullscreen',
    websocket_url: undefined,
    whitelisted_plugins: [],
};

;// CONCATENATED MODULE: ./src/headless/shared/settings/schema.js


/**
 * Wraps a plain coercion function as a minimal Standard Schema (v1) validator.
 *
 * This is the zero-dependency degenerate case of a schema: it only ever
 * transforms, never rejects. When richer validation is wanted, replace the
 * registry value with a real schema (e.g. a Valibot or Zod schema) — the
 * `~standard` shape is identical, so {@link normalizeSettings} keeps working.
 *
 * @param {(value: unknown) => unknown} fn
 * @returns {import('./types').StandardSchemaV1}
 */
function coerce(fn) {
    return {
        '~standard': {
            version: 1,
            vendor: 'converse',
            validate: (value) => ({ value: fn(value) }),
        },
    };
}

const stripTrailingSlashes = (v) => (typeof v === 'string' ? v.replace(/\/+$/, '') : v);

/**
 * Registry of per-setting schemas, keyed by setting name. Values are Standard
 * Schema (v1) compliant. Normalizing at the point settings are *written* (rather
 * than read) means every consumer — and every future consumer — sees an
 * already-normalized value.
 * @type {Map<string, import('./types').StandardSchemaV1>}
 */
const SETTING_SCHEMAS = new Map([
    ['assets_path', coerce(stripTrailingSlashes)],
]);

/**
 * Register (or override) the schema for a setting. This is the seam through
 * which `api.settings.extend` can eventually let plugins declare validation for
 * their own settings.
 * @param {string} key
 * @param {import('./types').StandardSchemaV1} schema
 */
function registerSettingSchema(key, schema) {
    SETTING_SCHEMAS.set(key, schema);
}

/**
 * Validate/coerce a single value against its registered schema. Returns the
 * value unchanged when no schema is registered for the key.
 *
 * Settings normalization is synchronous, so async Standard Schema validators are
 * unsupported: their (pending) result is ignored and the original value is
 * passed through with a warning.
 * @param {string} key
 * @param {unknown} value
 * @returns {*}
 */
function normalizeSetting(key, value) {
    const schema = SETTING_SCHEMAS.get(key);
    if (!schema) return value;

    const result = schema['~standard'].validate(value);
    if (result instanceof Promise) {
        src_log.warn(`Ignoring async schema for setting "${key}"; settings validation is synchronous.`);
        return value;
    }
    if (result.issues?.length) {
        src_log.warn(`Invalid value for setting "${key}": ${result.issues.map((i) => i.message).join(', ')}`);
        return value;
    }
    return result.value;
}

/**
 * Return a copy of `attrs` with each value passed through its registered schema.
 * Keys without a registered schema pass through untouched.
 * @param {Record<string, any>} attrs
 * @returns {Record<string, any>}
 */
function normalizeSettings(attrs) {
    const out = { ...attrs };
    for (const key of Object.keys(out)) {
        out[key] = normalizeSetting(key, out[key]);
    }
    return out;
}

;// CONCATENATED MODULE: ./src/headless/utils/object.js
/**
 * Merge the second object into the first one.
 * @param {Object} dst
 * @param {Object} src
 */
function object_merge(dst, src) {
    for (const k in src) {
        if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
        if (k === "__proto__" || k === "constructor") continue;

        if (dst[k] instanceof Object) {
            object_merge(dst[k], src[k]);
        } else {
            dst[k] = src[k];
        }
    }
}

/**
 * @param {unknown} obj - The object to check.
 * @returns {boolean} True if the object is an Error, false otherwise.
 */
function isError(obj) {
    return Object.prototype.toString.call(obj) === "[object Error]";
}

/**
 * @param {unknown} val - The value to check.
 * @returns {boolean} True if the value is a function, false otherwise.
 */
function object_isFunction(val) {
    return typeof val === "function";
}

/**
 * @param {unknown} x - The value to check.
 * @returns {boolean} True if the value is undefined, false otherwise.
 */
function isUndefined(x) {
    return typeof x === "undefined";
}

/**
 * @param {unknown} o - The value to check.
 * @returns {boolean} True if the value is an Error
 */
function isErrorObject(o) {
    return o instanceof Error;
}

/**
 * @param {import('@converse/skeletor').Model} model
 * @returns {import('@converse/skeletor').BrowserStorage}
 */
function isPersistableModel(model) {
    return model.storage || model.collection?.storage;
}

/**
 * Check if an object is empty (null, undefined, not an object, or has no own keys).
 * @param {Object|undefined|null} obj
 * @returns {boolean} True if the object is empty.
 */
function object_isEmpty(obj) {
    return obj === null || obj === undefined || typeof obj !== 'object' || Object.keys(obj).length === 0;
}

;// CONCATENATED MODULE: ./src/headless/shared/settings/utils.js







let app_settings;
let init_settings = {}; // Container for settings passed in via converse.initialize

/**
 * Settings whose user-provided value is *deep-merged* onto the default (and onto
 * the current value, for `api.settings.set`) instead of replacing it wholesale.
 * Opt in per setting via the `deep_merge` option of `api.settings.extend`.
 *
 * Only suitable for plain-object settings: array, function, RegExp or DOM-node
 * values can't be structured-cloned/merged and fall back to replace semantics.
 * @type {Set<string>}
 */
const deep_merge_settings = new Set();

/** @param {unknown} o */
function utils_isPlainObject(o) {
    return o !== null && typeof o === 'object' && !Array.isArray(o);
}

/**
 * Deep-merge `override` onto a *clone* of `base`, returning a new object so the
 * default (or current) value is never mutated. Falls back to returning
 * `override` when either side isn't a plain object, preserving replace semantics.
 * @param {*} base
 * @param {*} override
 * @returns {*}
 */
function deepMergeSetting(base, override) {
    if (!utils_isPlainObject(base) || !utils_isPlainObject(override)) return override;
    const merged = structuredClone(base);
    object_merge(merged, override);
    return merged;
}

class AppSettings extends skeletor_esm_EventEmitter(Object) {}

function getAppSettings() {
    return app_settings;
}

function initAppSettings(settings) {
    init_settings = settings;

    app_settings = new AppSettings();

    // Allow only whitelisted settings to be overwritten via converse.initialize
    const allowed_settings = normalizeSettings(lodash_es_pick(settings, Object.keys(DEFAULT_SETTINGS)));
    Object.assign(app_settings, DEFAULT_SETTINGS);
    for (const [k, v] of Object.entries(allowed_settings)) {
        // Deep-merge keys keep the default's unspecified sub-keys; the rest replace.
        app_settings[k] = deep_merge_settings.has(k) ? deepMergeSetting(DEFAULT_SETTINGS[k], v) : v;
    }
}

function getInitSettings() {
    return init_settings;
}

function getAppSetting(key) {
    if (app_settings && Object.keys(DEFAULT_SETTINGS).includes(key)) {
        return app_settings[key];
    }
}

/**
 * @param {Object} settings - New settings (or new defaults for existing settings).
 * @param {Object} [options]
 * @param {string[]} [options.deep_merge] - Keys whose user-provided object value
 *  should be deep-merged onto the default instead of replacing it wholesale. The
 *  setting must be a plain object (see {@link deepMergeSetting}).
 */
function extendAppSettings(settings, options = {}) {
    options.deep_merge?.forEach((k) => deep_merge_settings.add(k));

    object_merge(DEFAULT_SETTINGS, settings);
    // When updating the settings, we need to avoid overwriting the
    // initialization_settings (i.e. the settings passed in via converse.initialize).
    const allowed_keys = Object.keys(settings).filter((k) => k in DEFAULT_SETTINGS);
    const allowed_site_settings = lodash_es_pick(init_settings, allowed_keys);
    const combined = {};
    for (const k of allowed_keys) {
        if (!(k in allowed_site_settings)) {
            combined[k] = settings[k]; // No site override: use the (new) default.
        } else if (deep_merge_settings.has(k)) {
            // Deep-merge the site override onto the default so unspecified
            // sub-keys keep their default value instead of being dropped.
            combined[k] = deepMergeSetting(DEFAULT_SETTINGS[k], allowed_site_settings[k]);
        } else {
            combined[k] = allowed_site_settings[k]; // Site override replaces the default.
        }
    }
    const updated_settings = normalizeSettings(combined);
    object_merge(app_settings, updated_settings);
}

/**
 * @param {string} name
 * @param {Function} func
 * @param {any} context
 */
function registerListener(name, func, context) {
    app_settings.on(name, func, context);
}

/**
 * @param {string} name
 * @param {Function} func
 */
function unregisterListener(name, func) {
    app_settings.off(name, func);
}

/**
 * @param {Object|string} key An object containing config settings or alternatively a string key
 * @param {string} [val] The value, if the previous parameter is a key
 */
function updateAppSettings(key, val) {
    if (key == null) return this; // eslint-disable-line no-eq-null

    let attrs;
    if (key instanceof Object) {
        attrs = key;
    } else if (typeof key === 'string') {
        attrs = {};
        attrs[key] = val;
    }

    attrs = normalizeSettings(attrs);
    const allowed_keys = Object.keys(attrs).filter((k) => k in DEFAULT_SETTINGS);
    const changed = {};
    allowed_keys.forEach((k) => {
        // Deep-merge settings patch their current value; everything else replaces it.
        const new_val = deep_merge_settings.has(k) ? deepMergeSetting(app_settings[k], attrs[k]) : attrs[k];
        if (!lodash_es_isEqual(app_settings[k], new_val)) {
            changed[k] = new_val;
            app_settings[k] = new_val;
        }
    });
    Object.keys(changed).forEach((k) => app_settings.trigger('change:' + k, changed[k]));
    app_settings.trigger('change', changed);
}

;// CONCATENATED MODULE: ./src/headless/shared/settings/api.js
/**
 * @typedef {import('@converse/skeletor').Model} Model
 */


/**
 * This grouping allows access to the
 * [configuration settings](/docs/configuration/#configuration-settings)
 * of Converse.
 *
 * @namespace _converse.api.settings
 * @memberOf _converse.api
 */
const settings_api = {
    /**
     * Allows new configuration settings to be specified, or new default values for
     * existing configuration settings to be specified.
     *
     * Note, calling this method *after* converse.initialize has been
     * called will *not* change the initialization settings provided via
     * `converse.initialize`.
     *
     * @method api.settings.extend
     * @param {object} settings The configuration settings
     * @param {object} [options]
     * @param {string[]} [options.deep_merge] Keys of object-valued settings whose
     *  user-provided value should be *deep-merged* onto the default (so unspecified
     *  sub-keys keep their default), instead of replacing the default object
     *  wholesale. Only valid for plain-object settings.
     * @example
     * api.settings.extend({
     *    'enable_foo': true
     * });
     *
     * // The user can then override the default value of the configuration setting when
     * // calling `converse.initialize`.
     * converse.initialize({
     *     'enable_foo': false
     * });
     * @example
     * // Deep-merge an object setting: a partial override fills in rather than
     * // replaces, so `converse.initialize({ visible_toolbar_buttons: { call: true } })`
     * // keeps every other default button.
     * api.settings.extend(
     *     { 'visible_toolbar_buttons': { call: false, emoji: true, fileupload: true } },
     *     { deep_merge: ['visible_toolbar_buttons'] }
     * );
     */
    extend (settings, options) {
        return extendAppSettings(settings, options);
    },

    /**
     * @method _converse.api.settings.get
     * @param {string} [key]
     * @returns {*} Value of the particular configuration setting, or all
     *  settings if no key was specified.
     * @example api.settings.get("play_sounds");
     */
    get (key) {
        return key ? getAppSetting(key) : getAppSettings();
    },

    /**
     * Set one or many configuration settings.
     *
     * Note, this is not an alternative to calling {@link converse.initialize}, which still needs
     * to be called. Generally, you'd use this method after Converse is already
     * running and you want to change the configuration on-the-fly.
     *
     * @method _converse.api.settings.set
     * @param { Object | string } [settings_or_key]
     *  An object containing configuration settings.
     *  Alternatively to passing in an object, you can pass in a key and a value.
     * @param { string } [value]
     * @example api.settings.set("play_sounds", true);
     * @example
     * api.settings.set({
     *     "play_sounds": true,
     *     "hide_offline_users": true
     * });
     */
    set (settings_or_key, value) {
        updateAppSettings(settings_or_key, value);
    },

    /**
     * The `listen` namespace exposes methods for creating event listeners
     * (aka handlers) for events related to settings.
     *
     * @namespace _converse.api.settings.listen
     * @memberOf _converse.api.settings
     */
    listen: {
        /**
         * Register an event listener for the passed in event.
         * @method _converse.api.settings.listen.on
         * @param { ('change') } name - The name of the event to listen for.
         *  Currently there is only the 'change' event.
         * @param { Function } handler - The event handler function
         * @param { Object } [context] - The context of the `this` attribute of the
         *  handler function.
         * @example api.settings.listen.on('change', callback);
         */
        on (name, handler, context) {
            registerListener(name, handler, context);
        },

        /**
         * To stop listening to an event, you can use the `not` method.
         * @method _converse.api.settings.listen.not
         * @param { String } name The event's name
         * @param { Function } handler The callback method that is to no longer be called when the event fires
         * @example api.settings.listen.not('change', callback);
         */
        not (name, handler) {
            unregisterListener(name, handler);
        }
    }
};

;// CONCATENATED MODULE: ./src/headless/utils/session.js
/**
 * @typedef {module:shared-api-public.ConversePrivateGlobal} ConversePrivateGlobal
 */





const session_settings = settings_api;

/**
 * We distinguish between UniView and MultiView instances.
 *
 * UniView means that only one chat is visible, even though there might be multiple ongoing chats.
 * MultiView means that multiple chats may be visible simultaneously.
 */
function isUniView () {
    return ['fullscreen', 'embedded'].includes(session_settings.get("view_mode"));
}

function isTestEnv () {
    return getInitSettings()['bosh_service_url'] === 'montague.lit/http-bind';
}

/**
 * @param {ConversePrivateGlobal} _converse
 * @param {string} name
 */
function replacePromise (_converse, name) {
    const existing_promise = _converse.promises[name];
    if (!existing_promise) {
        throw new Error(`Tried to replace non-existing promise: ${name}`);
    }
    if (existing_promise.replace) {
        /** @type {import('../shared/types').ReplaceableOpenPromise} */
        const promise = openpromise_getOpenPromise();
        promise.replace = existing_promise.replace;
        _converse.promises[name] = promise;
    } else {
        src_log.debug(`Not replacing promise "${name}"`);
    }
}

/**
 * @param {ConversePrivateGlobal} _converse
 * @returns {boolean}
 */
function shouldClearCache (_converse) {
    const { api } = _converse;
    return !_converse.state.config.get('trusted') ||
        api.settings.get('clear_cache_on_logout') ||
        isTestEnv();
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
async function tearDown (_converse) {
    const { api } = _converse;
    await api.trigger('beforeTearDown', {'synchronous': true});
    api.trigger('afterTearDown');
    return _converse;
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
function clearSession (_converse) {
    if (shouldClearCache(_converse)) {
        _converse.api.user.settings.clear();
        _converse.state.login_info?.destroy();
    }
    _converse.initSession();
    /**
     * Synchronouse event triggered once the user session has been cleared,
     * for example when the user has logged out or when Converse has
     * disconnected for some other reason.
     * @event _converse#clearSession
     */
    return _converse.api.trigger('clearSession', {'synchronous': true});
}

;// CONCATENATED MODULE: ./src/headless/shared/constants.js


const BOSH_WAIT = 59;
const VERSION_NAME = "v14.0.0";

const PRES_SHOW_VALUES = ['chat', 'dnd', 'away', 'xa'];
const PRES_TYPE_VALUES = [
    'available',
    'unavailable',
    'error',
    'probe',
    'subscribe',
    'subscribed',
    'unsubscribe',
    'unsubscribed',
];

const STATUS_WEIGHTS = {
    offline: 6,
    unavailable: 5,
    xa: 4,
    away: 3,
    dnd: 2,
    chat: 1, // We don't differentiate between "chat" and "online"
    online: 1,
};

const METADATA_ATTRIBUTES = [
    "og:article:author",
    "og:article:published_time",
    "og:description",
    "og:image",
    "og:image:height",
    "og:image:width",
    "og:site_name",
    "og:title",
    "og:type",
    "og:url",
    "og:video:height",
    "og:video:secure_url",
    "og:video:tag",
    "og:video:type",
    "og:video:url",
    "og:video:width"
];

const ANONYMOUS = 'anonymous';
const CLOSED = 'closed';
const EXTERNAL = 'external';
const LOGIN = 'login';
const LOGOUT = 'logout';
const OPENED = 'opened';
const PREBIND = 'prebind';
const SUCCESS = 'success';
const FAILURE = 'failure';

// XEP-0085 Chat states
// https =//xmpp.org/extensions/xep-0085.html
const INACTIVE = 'inactive';
const ACTIVE = 'active';
const COMPOSING = 'composing';
const PAUSED = 'paused';
const GONE = 'gone';

// Chat types
const PRIVATE_CHAT_TYPE = 'chatbox';
const CHATROOMS_TYPE = 'chatroom';
const HEADLINES_TYPE = 'headline';
const CONTROLBOX_TYPE = 'controlbox';

const CONNECTION_STATUS = {};
CONNECTION_STATUS[Strophe.Status.ATTACHED] = 'ATTACHED';
CONNECTION_STATUS[Strophe.Status.AUTHENTICATING] = 'AUTHENTICATING';
CONNECTION_STATUS[Strophe.Status.AUTHFAIL] = 'AUTHFAIL';
CONNECTION_STATUS[Strophe.Status.CONNECTED] = 'CONNECTED';
CONNECTION_STATUS[Strophe.Status.CONNECTING] = 'CONNECTING';
CONNECTION_STATUS[Strophe.Status.CONNFAIL] = 'CONNFAIL';
CONNECTION_STATUS[Strophe.Status.DISCONNECTED] = 'DISCONNECTED';
CONNECTION_STATUS[Strophe.Status.DISCONNECTING] = 'DISCONNECTING';
CONNECTION_STATUS[Strophe.Status.ERROR] = 'ERROR';
CONNECTION_STATUS[Strophe.Status.RECONNECTING] = 'RECONNECTING';
CONNECTION_STATUS[Strophe.Status.REDIRECT] = 'REDIRECT';

// Add Strophe Namespaces
Strophe.addNamespace('ACTIVITY', 'http://jabber.org/protocol/activity');
Strophe.addNamespace('CARBONS', 'urn:xmpp:carbons:2');
Strophe.addNamespace('CHATSTATES', 'http://jabber.org/protocol/chatstates');
Strophe.addNamespace('CSI', 'urn:xmpp:csi:0');
Strophe.addNamespace('DELAY', 'urn:xmpp:delay');
Strophe.addNamespace('EME', 'urn:xmpp:eme:0');
Strophe.addNamespace('FALLBACK', 'urn:xmpp:fallback:0');
Strophe.addNamespace('FASTEN', 'urn:xmpp:fasten:0');
Strophe.addNamespace('FORWARD', 'urn:xmpp:forward:0');
Strophe.addNamespace('HINTS', 'urn:xmpp:hints');
Strophe.addNamespace('HTTPUPLOAD', 'urn:xmpp:http:upload:0');
Strophe.addNamespace('MAM', 'urn:xmpp:mam:2');
Strophe.addNamespace('MARKERS', 'urn:xmpp:chat-markers:0');
Strophe.addNamespace('MENTIONS', 'urn:xmpp:mmn:0');
Strophe.addNamespace('MESSAGE_CORRECT', 'urn:xmpp:message-correct:0');
Strophe.addNamespace('MODERATE', 'urn:xmpp:message-moderate:1');
Strophe.addNamespace('MODERATE0', 'urn:xmpp:message-moderate:0');
Strophe.addNamespace('NICK', 'http://jabber.org/protocol/nick');
Strophe.addNamespace('OCCUPANTID', 'urn:xmpp:occupant-id:0');
Strophe.addNamespace('OMEMO', 'eu.siacs.conversations.axolotl');
Strophe.addNamespace('OUTOFBAND', 'jabber:x:oob');
Strophe.addNamespace('PUBSUB', 'http://jabber.org/protocol/pubsub');
Strophe.addNamespace('RAI', 'urn:xmpp:rai:0');
Strophe.addNamespace('RECEIPTS', 'urn:xmpp:receipts');
Strophe.addNamespace('REFERENCE', 'urn:xmpp:reference:0');
Strophe.addNamespace('REGISTER', 'jabber:iq:register');
Strophe.addNamespace('REPLY', 'urn:xmpp:reply:0');
Strophe.addNamespace('RETRACT', 'urn:xmpp:message-retract:1');
Strophe.addNamespace('RETRACT0', 'urn:xmpp:message-retract:0');
Strophe.addNamespace('ROSTERX', 'http://jabber.org/protocol/rosterx');
Strophe.addNamespace('RSM', 'http://jabber.org/protocol/rsm');
Strophe.addNamespace('SID', 'urn:xmpp:sid:0');
Strophe.addNamespace('SPOILER', 'urn:xmpp:spoiler:0');
Strophe.addNamespace('STANZAS', 'urn:ietf:params:xml:ns:xmpp-stanzas');
Strophe.addNamespace('STYLING', 'urn:xmpp:styling:0');
Strophe.addNamespace('TIME', 'urn:xmpp:time');
Strophe.addNamespace('VCARD', 'vcard-temp');
Strophe.addNamespace('VCARDUPDATE', 'vcard-temp:x:update');
Strophe.addNamespace('XFORM', 'jabber:x:data');
Strophe.addNamespace('XHTML', 'http://www.w3.org/1999/xhtml');

// Core plugins are whitelisted automatically
// These are just the @converse/headless plugins, for the full converse,
// the other plugins are whitelisted in src/consts.js
const CORE_PLUGINS = [
    'converse-adhoc',
    'converse-bookmarks',
    'converse-blocklist',
    'converse-bosh',
    'converse-caps',
    'converse-chat',
    'converse-chatboxes',
    'converse-disco',
    'converse-emoji',
    'converse-headlines',
    'converse-mam',
    'converse-microblog',
    'converse-muc',
    'converse-ping',
    'converse-pubsub',
    'converse-reactions',
    'converse-roster',
    'converse-smacks',
    'converse-status',
    'converse-time',
    'converse-vcard',
    'converse-version',
    'converse-omemo',
];

const CHAT_STATES = ['active', 'composing', 'gone', 'inactive', 'paused'];
const MARKER_TYPES = ['displayed', 'received', 'acknowledged'];

const KEYCODES = {
    TAB: "Tab",
    ENTER: "Enter",
    SHIFT: "Shift",
    CTRL: "Control",
    ALT: "Alt",
    ESCAPE: "Escape",
    LEFT_ARROW: "ArrowLeft",
    UP_ARROW: "ArrowUp",
    RIGHT_ARROW: "ArrowRight",
    DOWN_ARROW: "ArrowDown",
    FORWARD_SLASH: "Divide",
    AT: "Alt",
    META: "Meta",
};

const XFORM_TYPE_MAP = {
    'text-multi': 'textarea',
    'text-private': 'password',
    'text-single': 'text',
    'fixed': 'label',
    'boolean': 'checkbox',
    'hidden': 'hidden',
    'jid-multi': 'textarea',
    'list-single': 'dropdown',
    'list-multi': 'dropdown'
};

const XFORM_VALIDATE_TYPE_MAP = {
    'xs:anyURI': 'url',
    'xs:byte': 'number',
    'xs:date': 'date',
    'xs:dateTime': 'datetime',
    'xs:int': 'number',
    'xs:integer': 'number',
    'xs:time': 'time',
};

;// CONCATENATED MODULE: ./src/headless/shared/_converse.js
/**
 * @module:shared.converse
 * @typedef {import('@converse/skeletor').BrowserStorage} BrowserStorage
 * @typedef {import('@converse/skeletor').Collection} Collection
 * @typedef {import('../plugins/disco/index').DiscoState} DiscoState
 * @typedef {import('../plugins/status/profile').default} Profile
 * @typedef {import('../plugins/vcard/vcard').default} VCards
 */









const DEPRECATED_ATTRS = {
    chatboxes: null,
    bookmarks: null,

    ANONYMOUS: ANONYMOUS,
    CLOSED: CLOSED,
    EXTERNAL: EXTERNAL,
    LOGIN: LOGIN,
    LOGOUT: LOGOUT,
    OPENED: OPENED,
    PREBIND: PREBIND,
    SUCCESS: SUCCESS,
    FAILURE: FAILURE,
    INACTIVE: INACTIVE,
    ACTIVE: ACTIVE,
    COMPOSING: COMPOSING,
    PAUSED: PAUSED,
    GONE: GONE,
};

/**
 * A private, closured namespace containing the private api (via {@link _converse.api})
 * as well as private methods and internal data-structures.
 * @global
 * @namespace _converse
 */
class ConversePrivateGlobal extends skeletor_esm_EventEmitter(Object) {
    constructor() {
        super();
        const proxy = new Proxy(this, {
            get: (target, key) => {
                if (!isTestEnv() && typeof key === 'string') {
                    if (Object.keys(DEPRECATED_ATTRS).includes(key)) {
                        src_log.warn(`Accessing ${key} on _converse is DEPRECATED`);
                    }
                }
                return Reflect.get(target, key);
            },
        });
        proxy.initialize();
        return proxy;
    }

    initialize() {
        this.VERSION_NAME = VERSION_NAME;

        this.strict_plugin_dependencies = false;

        this.pluggable = null;

        this.templates = {};

        this.storage = /** @type {Record<string, BrowserStorage.LocalForage>} */ {};

        this.promises = {
            initialized: openpromise_getOpenPromise(),
        };

        this.NUM_PREKEYS = 100; // DEPRECATED. Set here so that tests can override

        // Set as module attr so that we can override in tests.
        // TODO: replace with config settings
        this.TIMEOUTS = {
            PAUSED: 10000,
            INACTIVE: 90000,
        };

        Object.assign(this, DEPRECATED_ATTRS);

        this.api = /** @type {module:shared-api.APIEndpoint} */ null;

        /**
         * Namespace for storing translated strings.
         *
         * @typedef {Record<string, string>} UserMessage
         * @typedef {Record<string, string|UserMessage>} UserMessages
         */
        this.labels = /** @type {UserMessages} */ ({});

        /**
         * Namespace for storing code that might be useful to 3rd party
         * plugins. We want to make it possible for 3rd party plugins to have
         * access to code (e.g. classes) from converse.js without having to add
         * converse.js as a dependency.
         */
        this.exports = /** @type {Record<string, Object>} */ ({});

        /**
         * Provides a way for 3rd party plugins to access constants used by
         * Converse.
         */
        this.constants = /** @type {Record<string, string|Object>} */ ({});

        /**
         * Utility methods and globals from bundled 3rd party libraries.
         */
        this.env = /** @type {import("./api/types.js").ConverseEnv} */ ({});

        /**
         * Namespace for storing the state, as represented by instances of
         * Models and Collections.
         *
         * @typedef {Object & Record<string, Collection|Model|VCards|Profile|DiscoState>} ConverseState
         * @property {VCards} [vcards]
         * @property {Profile} profile
         * @property {DiscoState} disco
         */
        this.state = /** @type {ConverseState} */ ({});

        this.initSession();
    }

    initSession() {
        this.state.session?.destroy();
        this.state.session = new skeletor_esm_Model();

        // XXX DEPRECATED
        this.session = this.state.session;
        Object.assign(this, {
            jid: undefined,
            bare_jid: undefined,
            domain: undefined,
            resource: undefined,
        });
    }

    /**
     * Translate the given string based on the current locale.
     * @method __
     * @memberOf _converse
     * @param {...String} args
     */
    __(...args) {
        return i18n.__(...args);
    }

    /**
     * A no-op method which is used to signal to gettext that the passed in string
     * should be included in the pot translation file.
     *
     * In contrast to the double-underscore method, the triple underscore method
     * doesn't actually translate the strings.
     *
     * One reason for this method might be because we're using strings we cannot
     * send to the translation function because they require variable interpolation
     * and we don't yet have the variables at scan time.
     *
     * @method ___
     * @memberOf _converse
     * @param {String} str
     */
    ___(str) {
        return str;
    }
}

const _converse_converse = new ConversePrivateGlobal();

// Make _converse pluggable
src_pluggable.enable(_converse_converse, '_converse', 'pluggable');

/* export default */ const shared_converse = (_converse_converse);

;// CONCATENATED MODULE: ./src/headless/shared/api/events.js




/* export default */ const api_events = ({
    /**
     * Lets you trigger events, which can be listened to via
     * {@link _converse.api.listen.on} or {@link _converse.api.listen.once}
     *
     * Some events also double as promises and can be waited on via {@link _converse.api.waitUntil}.
     *
     * @typedef {object} Options
     * @property {boolean} [Options.synchronous] - Whether the event is synchronous or not.
     *  When a synchronous event is fired, a promise will be returned
     *  by {@link _converse.api.trigger} which resolves once all the
     *  event handlers' promises have been resolved.
     *
     * @method _converse.api.trigger
     * @param {string} name - The event name
     */
    async trigger (name) {
        if (!shared_converse._events) {
            return;
        }
        const args = Array.from(arguments);
        const options = /** @type {Options} */(args.pop());
        if (options && options.synchronous) {
            const events = shared_converse._events[name] || [];
            const event_args = args.splice(1);
            await Promise.all(events.map(e => e.callback.apply(e.ctx, event_args)));
        } else {
            shared_converse.trigger.apply(shared_converse, arguments);
        }
        const promise = shared_converse.promises[name];
        if (promise !== undefined) {
            promise.resolve(arguments[1]);
        }
    },

    /**
     * Triggers a hook which can be intercepted by registered listeners via
     * {@link _converse.api.listen.on} or {@link _converse.api.listen.once}.
     *
     * A hook is a special kind of event which allows you to intercept a data
     * structure in order to modify it, before passing it back.
     * @async
     * @param {string} name - The hook name
     * @param {...any} context - The context to which the hook applies
     *  (could be for example, a {@link _converse.ChatBox}).
     * @param {...any} data - The data structure to be intercepted and modified by the hook listeners.
     * @param {...any} extra_args - Additional passthrough arguments for hook listeners.
     * @returns {Promise<any>} - A promise that resolves with the modified data structure.
     */
    hook (name, context, data, ...extra_args) {
        const events = shared_converse._events[name] || [];
        if (events.length) {
            // Create a chain of promises, with each one feeding its output to
            // the next. The first input is a promise with the original data
            // sent to this hook.
            return events.reduce((o, e) => o.then(d => e.callback(context, d, ...extra_args)), Promise.resolve(data));
        } else {
            return data;
        }
    },

    /**
     * Converse emits events to which you can subscribe to.
     *
     * The `listen` namespace exposes methods for creating event listeners
     * (aka handlers) for these events.
     *
     * @namespace _converse.api.listen
     * @memberOf _converse
     */
    listen: {
        /**
         * Lets you listen to an event exactly once.
         * @method _converse.api.listen.once
         * @param {string} name The event's name
         * @param {function} callback The callback method to be called when the event is emitted.
         * @param {object} [context] The value of the `this` parameter for the callback.
         * @example _converse.api.listen.once('message', function (messageXML) { ... });
         */
        once: shared_converse.once.bind(shared_converse),

        /**
         * Lets you subscribe to an event.
         * Every time the event fires, the callback method specified by `callback` will be called.
         * @method _converse.api.listen.on
         * @param {string} name The event's name
         * @param {function} callback The callback method to be called when the event is emitted.
         * @param {object} [context] The value of the `this` parameter for the callback.
         * @example _converse.api.listen.on('message', function (messageXML) { ... });
         */
        on: shared_converse.on.bind(shared_converse),

        /**
         * To stop listening to an event, you can use the `not` method.
         * @method _converse.api.listen.not
         * @param {string} name The event's name
         * @param {function} callback The callback method that is to no longer be called when the event fires
         * @example _converse.api.listen.not('message', function (messageXML);
         */
        not: shared_converse.off.bind(shared_converse),

        /**
         * An options object which lets you set filter criteria for matching
         * against stanzas.
         * @typedef {object} MatchingOptions
         * @property {string} [ns] - The namespace to match against
         * @property {string} [type] - The stanza type to match against
         * @property {string} [id] - The stanza id to match against
         * @property {string} [from] - The stanza sender to match against
         */

        /**
         * Subscribe to an incoming stanza
         * Every a matched stanza is received, the callback method specified by
         * `callback` will be called.
         * @method _converse.api.listen.stanza
         * @param {string} name The stanza's name
         * @param {MatchingOptions|Function} options Matching options or callback
         * @param {function} handler The callback method to be called when the stanza appears
         */
        stanza (name, options, handler) {
            if (object_isFunction(options)) {
                handler = /** @type {Function} */(options);
                options = {};
            } else {
                options = options || {};
            }
            shared_converse.api.connection.get().addHandler(
                handler,
                options.ns,
                name,
                options.type,
                options.id,
                options.from,
                options
            );
        }
    },
});

;// CONCATENATED MODULE: ./node_modules/lodash-es/now.js


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now_now = function() {
  return _root.Date.now();
};

/* export default */ const lodash_es_now = (now_now);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_trimmedEndIndex.js
/** Used to match a single whitespace character. */
var _trimmedEndIndex_reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function _trimmedEndIndex_trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && _trimmedEndIndex_reWhitespace.test(string.charAt(index))) {}
  return index;
}

/* export default */ const _trimmedEndIndex = (_trimmedEndIndex_trimmedEndIndex);

;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTrim.js


/** Used to match leading whitespace. */
var _baseTrim_reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function _baseTrim_baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(_baseTrim_reTrimStart, '')
    : string;
}

/* export default */ const _baseTrim = (_baseTrim_baseTrim);

;// CONCATENATED MODULE: ./node_modules/lodash-es/toNumber.js




/** Used as references for various `Number` constants. */
var toNumber_NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var toNumber_reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var toNumber_reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var toNumber_reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var toNumber_freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber_toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (lodash_es_isSymbol(value)) {
    return toNumber_NAN;
  }
  if (lodash_es_isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = lodash_es_isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = toNumber_reIsBinary.test(value);
  return (isBinary || toNumber_reIsOctal.test(value))
    ? toNumber_freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (toNumber_reIsBadHex.test(value) ? toNumber_NAN : +value);
}

/* export default */ const lodash_es_toNumber = (toNumber_toNumber);

;// CONCATENATED MODULE: ./node_modules/lodash-es/debounce.js




/** Error message constants. */
var debounce_FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var debounce_nativeMax = Math.max,
    debounce_nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(debounce_FUNC_ERROR_TEXT);
  }
  wait = lodash_es_toNumber(wait) || 0;
  if (lodash_es_isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? debounce_nativeMax(lodash_es_toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? debounce_nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = lodash_es_now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(lodash_es_now());
  }

  function debounced() {
    var time = lodash_es_now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* export default */ const lodash_es_debounce = (debounce);

// EXTERNAL MODULE: ./node_modules/localforage-webextensionstorage-driver/local.js
var local = __webpack_require__(735);
// EXTERNAL MODULE: ./node_modules/localforage-webextensionstorage-driver/sync.js
var localforage_webextensionstorage_driver_sync = __webpack_require__(685);
;// CONCATENATED MODULE: ./src/headless/utils/storage.js





const storage_settings = settings_api;

/**
 * @returns {import('./types').StorageType}
 */
function getDefaultStorageType() {
    if (shared_converse.state.config.get('trusted')) {
        const is_non_persistent = storage_settings.get('persistent_store') === 'sessionStorage';
        return is_non_persistent ? 'session' : 'persistent';
    } else {
        return 'session';
    }
}

/**
 * @param {import('./types').StorageType} type
 */
function storeUsesIndexedDB(type) {
    return IS_BROWSER && type === 'persistent' && storage_settings.get('persistent_store') === 'IndexedDB';
}

/**
 * @returns {boolean}
 */
function isPersistentStorageAvailable() {
    // Every store type Converse knows about is a browser API. Node currently
    // keeps everything in memory, so nothing survives a restart.
    if (!IS_BROWSER) return false;

    const store = storage_settings.get('persistent_store');
    if (store === 'sessionStorage') {
        try {
            return typeof globalThis.sessionStorage !== 'undefined';
        } catch {
            return false;
        }
    } else if (store === 'BrowserExtLocal' || store === 'BrowserExtSync') {
        return true;
    }

    const driver =
        store === 'localStorage'
            ? PersistentStorage.localForage.LOCALSTORAGE
            : store === 'IndexedDB'
              ? PersistentStorage.localForage.INDEXEDDB
              : undefined;
    return driver ? PersistentStorage.localForage.supports(driver) : true;
}

/**
 * @param {string} id
 * @param {import('./types').StorageType} [type]
 * @returns {PersistentStorage}
 */
function createStore(id, type) {
    const name = type || getDefaultStorageType();
    const s = shared_converse.storage[name];
    if (typeof s === 'undefined') {
        throw new TypeError(`createStore: Could not find store for ${id}`);
    }
    return new PersistentStorage(id, s, storeUsesIndexedDB(type));
}

/**
 * @param {import('./types').StorageModel} model
 * @param {string} id
 * @param {import('./types').StorageType} [type]
 */
function initStorage(model, id, type) {
    type = type || getDefaultStorageType();
    model.storage = createStore(id, type);
    if (storeUsesIndexedDB(type)) {
        const flush = () => model.storage.flush();
        addUnloadListener(flush);
        model.on('destroy', () => removeUnloadListener(flush));
        model.listenTo(shared_converse, 'beforeLogout', flush);
    }
}

;// CONCATENATED MODULE: ./src/headless/utils/node-store.js
/**
 * The storage driver Node uses.
 *
 * Kept out of `utils/storage.js` because everything that module exports is
 * spread into the public `u` namespace, and neither of these belongs there:
 * `registerNodeStoreFactory` does nothing useful to a browser consumer and
 * `getNodeStore` throws for one.
 *
 * @module utils/node-store
 */

/**
 * Builds the storage driver Node uses. Registered by `shims/node-storage.js`,
 * which the Node entry point imports; left null in the browser so that nothing
 * Node-only can reach the bundle.
 * @type {(() => import('@converse/skeletor').StorageDriver)|null}
 */
let node_store_factory = null;

/** @type {import('@converse/skeletor').StorageDriver|null} */
let node_store = null;

/**
 * @param {() => import('@converse/skeletor').StorageDriver} factory
 */
function registerNodeStoreFactory(factory) {
    node_store_factory = factory;
    node_store = null;
}

/**
 * The single storage driver shared by every store under Node, built on first
 * use so that no database file is created before Converse is configured.
 *
 * Sharing one driver is what keeps Node to a single database file: skeletor's
 * `'node'` store type would otherwise build a `NodeSQLiteStorage` per store,
 * and a single login opens around forty of them. Keys can't collide across
 * stores because `PersistentStorage.getItemName()` already prefixes each one
 * with the store's name. This mirrors the browser, where a single shared
 * localForage instance backs every `PersistentStorage`.
 *
 * @returns {import('@converse/skeletor').StorageDriver}
 */
function getNodeStore() {
    if (!node_store_factory) {
        throw new Error(
            'getNodeStore: no Node storage driver was registered. ' +
                "Import @converse/headless from Node (or via '@converse/headless/node') rather than the browser bundle.",
        );
    }
    node_store ??= node_store_factory();
    return node_store;
}

;// CONCATENATED MODULE: ./src/headless/shared/connection/utils.js




function generateResource () {
    return `/converse.js-${Math.floor(Math.random() * 139749528).toString()}`;
}

function setStropheLogLevel () {
    const level = settings_api.get('loglevel');
    Strophe.setLogLevel(Strophe.LogLevel[level.toUpperCase()]);

    const lmap = {};
    lmap[Strophe.LogLevel.DEBUG] = 'debug';
    lmap[Strophe.LogLevel.INFO] = 'info';
    lmap[Strophe.LogLevel.WARN] = 'warn';
    lmap[Strophe.LogLevel.ERROR] = 'error';
    lmap[Strophe.LogLevel.FATAL] = 'fatal';

    Strophe.log = (l, msg) => src_log.log(msg, lmap[l]);
    Strophe.error = (msg) => src_log.error(msg);
}

function getConnectionServiceURL () {
    if (('WebSocket' in globalThis || 'MozWebSocket' in globalThis) && settings_api.get('websocket_url')) {
        return settings_api.get('websocket_url');
    } else if (settings_api.get('bosh_service_url')) {
        return settings_api.get('bosh_service_url');
    }
    return '';
}

;// CONCATENATED MODULE: ./src/headless/utils/jid.js




/**
 * @param {string|null} [jid]
 * @returns {boolean}
 */
function isValidJID(jid) {
    if (!(typeof jid === 'string')) {
        return false;
    }

    const num_slashes = jid.split('/').length - 1;
    if (num_slashes > 1) {
        return false;
    }

    return jid.split('@').filter((s) => !!s).length === 2 && !jid.startsWith('@') && !jid.endsWith('@');
}

/**
 * @param {string} jid
 * @returns {boolean}
 */
function isValidMUCJID(jid) {
    return !jid.startsWith('@') && !jid.endsWith('@');
}

/**
 * @param {string} jid1
 * @param {string} jid2
 * @returns {boolean}
 */
function isSameBareJID(jid1, jid2) {
    if (typeof jid1 !== 'string' || typeof jid2 !== 'string') {
        return false;
    }
    return Strophe.getBareJidFromJid(jid1).toLowerCase() === Strophe.getBareJidFromJid(jid2).toLowerCase();
}

/**
 * @param {string} jid1
 * @param {string} jid2
 * @returns {boolean}
 */
function isSameDomain(jid1, jid2) {
    if (typeof jid1 !== 'string' || typeof jid2 !== 'string') {
        return false;
    }
    return Strophe.getDomainFromJid(jid1).toLowerCase() === Strophe.getDomainFromJid(jid2).toLowerCase();
}

/**
 * @param {string} jid
 */
function getJIDFromURI(jid) {
    let result = jid;
    if (result.startsWith('xmpp:')) {
        result = result.substring(5);
    }
    const idx = result.indexOf('?');
    if (idx >= 0) {
        result = result.substring(0, idx);
    }
    return result;
}

/**
 * Extract the `node` query parameter from an XMPP URI (RFC 5122),
 * e.g. `xmpp:romeo@montague.lit?;node=urn:xmpp:microblog:0;item=1` → `urn:xmpp:microblog:0`.
 * @param {string} [uri]
 * @returns {string|undefined}
 */
function getNodeFromURI(uri) {
    if (!uri) return undefined;
    const m = uri.match(/[?;&]node=([^;&]+)/);
    return m ? decodeURIComponent(m[1]) : undefined;
}

/**
 * Extract the `item` query parameter from an XMPP URI (RFC 5122),
 * e.g. `xmpp:romeo@montague.lit?;node=urn:xmpp:microblog:0;item=1` → `1`.
 * @param {string} [uri]
 * @returns {string|undefined}
 */
function getItemFromURI(uri) {
    if (!uri) return undefined;
    const m = uri.match(/[?;&]item=([^;&]+)/);
    return m ? decodeURIComponent(m[1]) : undefined;
}

/**
 * @param {string} jid
 * @param {boolean} [include_resource=false]
 * @returns {boolean}
 */
function isOwnJID(jid, include_resource = false) {
    if (include_resource) {
        return jid === shared_converse.session.get('full_jid');
    }
    return Strophe.getBareJidFromJid(jid) === shared_converse.session.get('bare_jid');
}

/**
 * Resolves a JID to the full JID of the contact's highest-priority resource.
 *
 * Needed whenever a query has to reach the contact's client rather than their
 * server. An IQ addressed to a bare JID is answered by the server on their
 * behalf (RFC 6121 § 8.5.2), which is the wrong respondent for anything about
 * the person, such as XEP-0202 entity time.
 *
 * @param {string} jid - Bare or full; only the bare part is used to look up
 * @returns {string|null}
 */
function getFullJID(jid) {
    if (typeof jid !== 'string') return null;

    const bare_jid = Strophe.getBareJidFromJid(jid);
    const resource = shared_converse.state.presences?.get(bare_jid)?.getHighestPriorityResource();
    return resource ? `${bare_jid}/${resource.get('name')}` : null;
}

/**
 * Appends locked_domain or default_domain to a JID if configured.
 * When locked_domain is set, it will:
 * - Strip the locked_domain if already present in the input
 * - Escape the username part using Strophe.escapeNode()
 * - Append the locked_domain
 * When default_domain is set and the input is not already a valid JID:
 * - Escape the username part using Strophe.escapeNode()
 * - Append the default_domain
 * @param {string} jid - The JID or username to process
 * @returns {string} The full JID with domain appended if applicable
 */
function maybeAppendDomain(jid) {
    const locked_domain = settings_api.get('locked_domain');
    const default_domain = settings_api.get('default_domain');

    if (locked_domain) {
        const last_part = '@' + locked_domain;
        if (jid.endsWith(last_part)) {
            jid = jid.substring(0, jid.length - last_part.length);
        }
        jid = Strophe.escapeNode(jid) + last_part;
    } else if (default_domain && !isValidJID(jid)) {
        jid = Strophe.escapeNode(jid) + '@' + default_domain;
    }

    return jid;
}

;// CONCATENATED MODULE: ./src/headless/utils/init.js
/**
 * @typedef {module:shared.converse.ConversePrivateGlobal} ConversePrivateGlobal
 */
















/**
 * Initializes the plugins for the Converse instance.
 * @param {ConversePrivateGlobal} _converse
 * @fires _converse#pluginsInitialized - Triggered once all plugins have been initialized.
 * @memberOf _converse
 */
function initPlugins(_converse) {
    // If initialize gets called a second time (e.g. during tests), then we
    // need to re-apply all plugins (for a new converse instance), and we
    // therefore need to clear this array that prevents plugins from being
    // initialized twice.
    // If initialize is called for the first time, then this array is empty
    // in any case.
    _converse.pluggable.initialized_plugins = [];
    const whitelist = CORE_PLUGINS.concat(_converse.api.settings.get('whitelisted_plugins'));

    if (_converse.api.settings.get('singleton')) {
        ['converse-bookmarks', 'converse-controlbox', 'converse-headline', 'converse-register'].forEach((name) =>
            _converse.api.settings.get('blacklisted_plugins').push(name),
        );
    }

    _converse.pluggable.initializePlugins({ _converse }, whitelist, _converse.api.settings.get('blacklisted_plugins'));

    /**
     * Triggered once all plugins have been initialized. This is a useful event if you want to
     * register event handlers but would like your own handlers to be overridable by
     * plugins. In that case, you need to first wait until all plugins have been
     * initialized, so that their overrides are active. One example where this is used
     * is in [converse-notifications.js](https://github.com/jcbrand/converse.js/blob/master/src/converse-notification.js)`.
     *
     * Also available as an [ES2015 Promise](http://es6-features.org/#PromiseUsage)
     * which can be listened to with `_converse.api.waitUntil`.
     *
     * @event _converse#pluginsInitialized
     * @memberOf _converse
     * @example _converse.api.listen.on('pluginsInitialized', () => { ... });
     */
    _converse.api.trigger('pluginsInitialized');
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
async function initClientConfig(_converse) {
    /* The client config refers to configuration of the client which is
     * independent of any particular user.
     * What this means is that config values need to persist across
     * user sessions.
     */
    const id = 'converse.client-config';
    const config = new skeletor_esm_Model({ id, 'trusted': true });
    config.storage = createStore(id, 'session');

    Object.assign(_converse, { config }); // XXX DEPRECATED
    Object.assign(_converse.state, { config });

    await new Promise((r) => config.fetch({ 'success': r, 'error': r }));
    /**
     * Triggered once the XMPP-client configuration has been initialized.
     * The client configuration is independent of any particular and its values
     * persist across user sessions.
     *
     * @event _converse#clientConfigInitialized
     * @example
     * _converse.api.listen.on('clientConfigInitialized', () => { ... });
     */
    _converse.api.trigger('clientConfigInitialized');
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
async function initSessionStorage(_converse) {
    if (!IS_BROWSER) {
        // Node has no sessionStorage, so the session store is the same SQLite
        // store as the persistent one. Nothing depends on it being cleared when
        // the process exits: `clear_cache_on_logout` and the logout path both
        // clear it explicitly.
        _converse.storage['session'] = getNodeStore();
        return;
    }
    await BrowserStorage.sessionStorageInitialized;
    _converse.storage['session'] = BrowserStorage.localForage.createInstance({
        name: isTestEnv() ? 'converse-test-session' : 'converse-session',
        description: 'sessionStorage instance',
        driver: ['sessionStorageWrapper'],
    });
}

/**
 * Initializes persistent storage
 * @param {ConversePrivateGlobal} _converse
 * @param {string} store_name - The name of the store.
 * @param {string} [key="persistent"] - The key for `_converse.storage`.
 */
function initPersistentStorage(_converse, store_name, key = 'persistent') {
    const { api } = _converse;
    if (!IS_BROWSER) {
        // IndexedDB, localStorage and sessionStorage are all browser APIs, so
        // `persistent_store` has nothing to select between under Node. Every
        // store shares one SQLite database, the same way they share one
        // localForage instance in the browser.
        _converse.storage[key] = getNodeStore();
        return;
    }
    if (api.settings.get('persistent_store') === 'sessionStorage') {
        _converse.storage[key] = _converse.storage['session'];
        return;
    } else if (api.settings.get('persistent_store') === 'BrowserExtLocal') {
        BrowserStorage.localForage.defineDriver(local)
            .then(() => BrowserStorage.localForage.setDriver('webExtensionLocalStorage'));
        _converse.storage[key] = BrowserStorage.localForage;
        return;
    } else if (api.settings.get('persistent_store') === 'BrowserExtSync') {
        BrowserStorage.localForage.defineDriver(localforage_webextensionstorage_driver_sync)
            .then(() => BrowserStorage.localForage.setDriver('webExtensionSyncStorage'));
        _converse.storage[key] = BrowserStorage.localForage;
        return;
    }

    const config = {
        name: isTestEnv() ? 'converse-test-persistent' : 'converse-persistent',
        storeName: store_name,
    };
    if (api.settings.get('persistent_store') === 'localStorage') {
        config['description'] = 'localStorage instance';
        config['driver'] = [BrowserStorage.localForage.LOCALSTORAGE];
    } else if (api.settings.get('persistent_store') === 'IndexedDB') {
        config['description'] = 'indexedDB instance';
        config['driver'] = [BrowserStorage.localForage.INDEXEDDB];
    }
    _converse.storage[key] = BrowserStorage.localForage.createInstance(config);
}

/**
 * @param {ConversePrivateGlobal} _converse
 * @param {string} jid
 */
function saveJIDtoSession(_converse, jid) {
    const { api, session } = _converse;

    if (api.settings.get('authentication') !== ANONYMOUS && !Strophe.getResourceFromJid(jid)) {
        jid = jid.toLowerCase() + generateResource();
    }

    const bare_jid = Strophe.getBareJidFromJid(jid);
    const resource = Strophe.getResourceFromJid(jid);
    const domain = Strophe.getDomainFromJid(jid);

    // TODO: Storing directly on _converse is deprecated
    Object.assign(_converse, { jid, bare_jid, resource, domain });

    session.save({
        jid,
        bare_jid,
        resource,
        domain,
        // We use the `active` flag to determine whether we should use the values from sessionStorage.
        // When "cloning" a tab (e.g. via middle-click), the `active` flag will be set and we'll create
        // a new empty user session, otherwise it'll be false and we can reuse the user session.
        // When the tab is reloaded, the `active` flag is set to `false`.
        'active': true,
    });
    // Set JID on the connection object so that when we call `connection.bind`
    // the new resource is found by Strophe.js and sent to the XMPP server.
    api.connection.get().jid = jid;
}

/**
 * Stores the passed in JID for the current user, potentially creating a
 * resource if the JID is bare.
 *
 * Given that we can only create an XMPP connection if we know the domain of
 * the server connect to and we only know this once we know the JID, we also
 * call {@link api.connection.init} (if necessary) to make sure that the
 * connection is set up.
 *
 * @emits _converse#setUserJID
 * @param {string} jid
 */
async function setUserJID(jid) {
    await initSession(shared_converse, jid);

    /**
     * Triggered whenever the user's JID has been updated
     * @event _converse#setUserJID
     */
    shared_converse.api.trigger('setUserJID');
    return jid;
}

/**
 * @param {ConversePrivateGlobal} _converse
 * @param {string} jid
 */
async function initSession(_converse, jid) {
    const is_shared_session = _converse.api.settings.get('connection_options').worker;

    const bare_jid = Strophe.getBareJidFromJid(jid).toLowerCase();
    const id = `converse.session-${bare_jid}`;
    if (_converse.session?.get('id') !== id) {
        initPersistentStorage(_converse, bare_jid);

        _converse.session.set({ id });
        initStorage(_converse.session, id, is_shared_session ? 'persistent' : 'session');
        await new Promise((r) => _converse.session.fetch({ success: r, error: r }));

        if (!is_shared_session && _converse.session.get('active')) {
            // If the `active` flag is set, it means this tab was cloned from
            // another (e.g. via middle-click), and its session data was copied over.
            _converse.session.clear();
            _converse.session.save({ id });
        }
        saveJIDtoSession(_converse, jid);

        // Set `active` flag to false when the tab gets reloaded
        addUnloadListener(() => safeSave(_converse.session, { active: false }));

        /**
         * Triggered once the user's session has been initialized. The session is a
         * cache which stores information about the user's current session.
         * @event _converse#userSessionInitialized
         * @memberOf _converse
         */
        _converse.api.trigger('userSessionInitialized');
    } else {
        saveJIDtoSession(_converse, jid);
    }
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
function registerGlobalEventHandlers(_converse) {
    /**
     * Plugins can listen to this event as cue to register their
     * global event handlers.
     * @event _converse#registeredGlobalEventHandlers
     * @example _converse.api.listen.on('registeredGlobalEventHandlers', () => { ... });
     */
    _converse.api.trigger('registeredGlobalEventHandlers');
}

/**
 * @param {ConversePrivateGlobal} _converse
 */
function unregisterGlobalEventHandlers(_converse) {
    _converse.api.trigger('unregisteredGlobalEventHandlers');
}

/**
 * Make sure everything is reset in case this is a subsequent call to
 * converse.initialize (happens during tests).
 * @param {ConversePrivateGlobal} _converse
 */
async function init_cleanup(_converse) {
    const { api } = _converse;
    await api.trigger('cleanup', { 'synchronous': true });
    unregisterGlobalEventHandlers(_converse);
    api.connection.get()?.reset();
    _converse.stopListening();
    _converse.off();
    if (_converse.promises['initialized'].isResolved) {
        api.promises.add('initialized');
    }
}

/**
 * Fetches login credentials from the server.
 * @param {number} [wait=0]
 *  The time to wait and debounce subsequent calls to this function before making the request.
 * @returns {Promise<import('./types').Credentials>}
 *  A promise that resolves with the provided login credentials (JID and password).
 * @throws {Error} If the request fails or returns an error status.
 */
function fetchLoginCredentials(wait = 0) {
    return new Promise(
        lodash_es_debounce(async (resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', shared_converse.api.settings.get('credentials_url'), true);
            xhr.setRequestHeader('Accept', 'application/json, text/javascript');
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 400) {
                    const data = JSON.parse(xhr.responseText);
                    setUserJID(data.jid).then(() => {
                        resolve({
                            jid: data.jid,
                            password: data.password,
                        });
                    });
                } else {
                    reject(new Error(`${xhr.status}: ${xhr.responseText}`));
                }
            };
            xhr.onerror = reject;
            /**
             * *Hook* which allows modifying the server request
             * @event _converse#beforeFetchLoginCredentials
             */
            xhr = await shared_converse.api.hook('beforeFetchLoginCredentials', this, xhr);
            xhr.send();
        }, wait),
    );
}

/**
 * @returns {Promise<import('./types').Credentials>}
 */
async function getLoginCredentialsFromURL() {
    let credentials;
    let wait = 0;
    while (!credentials) {
        try {
            credentials = await fetchLoginCredentials(wait); // eslint-disable-line no-await-in-loop
        } catch (e) {
            src_log.error('Could not fetch login credentials');
            src_log.error(e);
        }
        // If unsuccessful, we wait 2 seconds between subsequent attempts to
        // fetch the credentials.
        wait = 2000;
    }
    return credentials;
}

async function getLoginCredentialsFromBrowser() {
    const jid = getLocalStorageItem('conversejs-session-jid');
    if (!jid) return null;

    try {
        const creds = await navigator.credentials.get({ password: true });
        if (creds && creds.type == 'password' && isValidJID(creds.id)) {
            // XXX: We don't actually compare `creds.id` with `jid` because
            // the user might have been presented a list of credentials with
            // which to log in, and we want to respect their wish.
            await setUserJID(creds.id);
            return { 'jid': creds.id, 'password': creds.password };
        }
    } catch (e) {
        src_log.error(e);
        return null;
    }
}

async function getLoginCredentialsFromSCRAMKeys() {
    const jid = getLocalStorageItem('conversejs-session-jid');
    if (!jid) return null;

    await setUserJID(jid);

    const login_info = await savedLoginInfo(jid);
    const scram_keys = login_info.get('scram_keys');
    return scram_keys ? { jid, password: scram_keys } : null;
}

/**
 * @param {import('./types').Credentials} [credentials]
 * @param {boolean} [automatic]
 */
async function attemptNonPreboundSession(credentials, automatic) {
    const { api } = shared_converse;
    /**
     * *Hook* to allow 3rd party plugins to provide their own login credentials.
     * @event _converse#beforeAttemptNonPreboundSession
     */
    const { credentials: new_creds } = await api.hook('beforeAttemptNonPreboundSession', this, {
        credentials,
        automatic,
    });
    if (new_creds) return connect(new_creds);

    if (api.settings.get('authentication') === LOGIN) {
        const jid = shared_converse.session.get('jid');
        // XXX: If EITHER ``keepalive`` or ``auto_login`` is ``true`` and
        // ``authentication`` is set to ``login``, then Converse will try to log the user in,
        // since we don't have a way to distinguish between whether we're
        // restoring a previous session (``keepalive``) or whether we're
        // automatically setting up a new session (``auto_login``).
        // So we can't do the check (!automatic || _converse.api.settings.get("auto_login")) here.
        if (credentials) {
            return connect(credentials);
        } else if (api.settings.get('credentials_url')) {
            // We give credentials_url preference, because
            // connection.pass might be an expired token.
            return connect(await getLoginCredentialsFromURL());
        } else if (jid && (api.settings.get('password') || api.connection.get().pass)) {
            return connect();
        }

        if (api.settings.get('reuse_scram_keys')) {
            const credentials = await getLoginCredentialsFromSCRAMKeys();
            if (credentials) return connect(credentials);
        }

        if (!isTestEnv() && hasCredentialsAPI()) {
            const credentials = await getLoginCredentialsFromBrowser();
            if (credentials) return connect(credentials);
        }

        if (!isTestEnv()) src_log.debug("attemptNonPreboundSession: Couldn't find credentials to log in with");
    } else if (
        [ANONYMOUS, EXTERNAL].includes(api.settings.get('authentication')) &&
        (!automatic || api.settings.get('auto_login'))
    ) {
        connect();
    }
}

/**
 * Fetch the stored SCRAM keys for the given JID, if available.
 *
 * The user's plaintext password is not stored, nor any material from which
 * the user's plaintext password could be recovered.
 *
 * @param {String} jid - The XMPP address for which to fetch the SCRAM keys
 * @returns {Promise<Model>} A promise which resolves once we've fetched the previously
 *  used login keys.
 */
async function savedLoginInfo(jid) {
    const id = `converse.scram-keys-${Strophe.getBareJidFromJid(jid)}`;
    if (shared_converse.state.login_info?.get('id') === id) {
        return shared_converse.state.login_info;
    }
    const login_info = /** @type {Model} */ (new skeletor_esm_Model({ id }));
    shared_converse.state.login_info = login_info;
    initStorage(login_info, id, 'persistent');
    await new Promise((f) => login_info.fetch({ 'success': f, 'error': f }));
    return login_info;
}

/**
 * @param {Object} [credentials]
 * @param {string} credentials.password
 * @param {Object} credentials.password
 * @param {string} credentials.password.ck
 * @returns {Promise<void>}
 */
async function connect(credentials) {
    const { api } = shared_converse;
    const jid = shared_converse.session.get('jid');
    const connection = api.connection.get();
    if ([ANONYMOUS, EXTERNAL].includes(api.settings.get('authentication'))) {
        if (!jid) {
            throw new Error(
                'Config Error: when using anonymous login ' +
                    "you need to provide the server's domain via the 'jid' option. " +
                    'Either when calling converse.initialize, or when calling ' +
                    '_converse.api.user.login.',
            );
        }
        if (!connection.reconnecting) {
            connection.reset();
        }
        connection.connect(jid.toLowerCase());
    } else if (api.settings.get('authentication') === LOGIN) {
        const password = credentials?.password ?? (connection?.pass || api.settings.get('password'));
        if (!password) {
            if (api.settings.get('auto_login')) {
                throw new Error(
                    'autoLogin: If you use auto_login and ' +
                        "authentication='login' then you also need to provide a password.",
                );
            }
            connection.setDisconnectionCause(Strophe.Status.AUTHFAIL, undefined, true);
            api.connection.disconnect();
            return;
        }
        if (!connection.reconnecting) {
            connection.reset();
            connection.service = getConnectionServiceURL();
        }

        let callback;
        // Save the SCRAM data if we're not already logged in with SCRAM
        if (shared_converse.state.config.get('trusted') && jid && api.settings.get('reuse_scram_keys') && !password?.ck) {
            // Store scram keys in scram storage
            const login_info = await savedLoginInfo(jid);
            callback =
                /**
                 * @param {string} status
                 * @param {string} message
                 */
                (status, message) => {
                    const { scram_keys } = connection;
                    if (scram_keys) login_info.save({ scram_keys });
                    connection.onConnectStatusChanged(status, message);
                };
        }
        connection.connect(jid, password, callback);
    }
}

/**
 * @param {Model} model
 * @param {Object} attributes
 * @param {Object} options
 */
function safeSave(model, attributes, options) {
    if (isPersistableModel(model)) {
        model.save(attributes, options);
    } else {
        model.set(attributes, options);
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/connection/index.js












/**
 * The Connection class manages the connection to the XMPP server. It's
 * agnostic concerning the underlying protocol (i.e. websocket, long-polling
 * via BOSH or websocket inside a shared worker).
 */
class connection_Connection extends Strophe.Connection {
    /**
     * @param {string} service - The BOSH or WebSocket service URL.
     * @param {import('strophe.js').ConnectionOptions} options
     */
    constructor(service, options) {
        super(service, options);
        // For new sessions, we need to send out a presence stanza to notify
        // the server/network that we're online.
        // When re-attaching to an existing session we don't need to again send out a presence stanza,
        // because it's as if "we never left" (see onConnectStatusChanged).
        this.send_initial_presence = true;
        this.debouncedReconnect = lodash_es_debounce(this.reconnect, 3000);
    }

    /** @param {Element} body */
    xmlInput(body) {
        src_log.debug('%c%s', 'color: darkgoldenrod', body.outerHTML);
    }

    /** @param {Element} body */
    xmlOutput(body) {
        src_log.debug('%c%s', 'color: darkcyan', body.outerHTML);
    }

    async bind() {
        const { api } = shared_converse;
        /**
         * Synchronous event triggered before we send an IQ to bind the user's
         * JID resource for this session.
         * @event _converse#beforeResourceBinding
         */
        await api.trigger('beforeResourceBinding', { 'synchronous': true });
        super.bind();
    }

    async onDomainDiscovered(response) {
        const { api } = shared_converse;
        const text = await response.text();
        const xrd = new DOMParser().parseFromString(text, 'text/xml').firstElementChild;
        if (xrd.nodeName != 'XRD' || xrd.namespaceURI != 'http://docs.oasis-open.org/ns/xri/xrd-1.0') {
            return src_log.info('Could not discover XEP-0156 connection methods');
        }
        const bosh_links = sizzle(`Link[rel="urn:xmpp:alt-connections:xbosh"]`, xrd);
        const ws_links = sizzle(`Link[rel="urn:xmpp:alt-connections:websocket"]`, xrd);
        const bosh_methods = bosh_links.map((el) => el.getAttribute('href')).filter((uri) => uri.startsWith('https:'));
        const ws_methods = ws_links.map((el) => el.getAttribute('href')).filter((uri) => uri.startsWith('wss:'));
        if (bosh_methods.length === 0 && ws_methods.length === 0) {
            src_log.info('Neither BOSH nor WebSocket connection methods have been specified with XEP-0156.');
        } else {
            // TODO: support multiple endpoints
            api.settings.set('websocket_url', ws_methods.pop());
            api.settings.set('bosh_service_url', bosh_methods.pop());
            this.service = api.settings.get('websocket_url') || api.settings.get('bosh_service_url');
            this.setProtocol();
        }
    }

    /**
     * Adds support for XEP-0156 by querying the XMPP server for alternate
     * connection methods. This allows users to use the websocket or BOSH
     * connection of their own XMPP server instead of a proxy provided by the
     * host of Converse.js.
     * @method Connection.discoverConnectionMethods
     * @param {string} domain
     */
    async discoverConnectionMethods(domain) {
        // Use XEP-0156 to check whether this host advertises websocket or BOSH connection methods.
        const options = {
            mode: /** @type {RequestMode} */ ('cors'),
            headers: {
                Accept: 'application/xrd+xml, text/xml',
            },
        };
        const url = `https://${domain}/.well-known/host-meta`;
        let response;
        try {
            response = await fetch(url, options);
        } catch (e) {
            src_log.info(`Failed to discover alternative connection methods at ${url}`);
            src_log.error(e);
            return;
        }
        if (response.status >= 200 && response.status < 400) {
            await this.onDomainDiscovered(response);
        } else {
            src_log.info('Could not discover XEP-0156 connection methods');
        }
    }

    /**
     * Establish a new XMPP session by logging in with the supplied JID and
     * password.
     * @param {String} jid
     * @param {String} password
     * @param {import('strophe.js').ConnectCallback} [callback]
     */
    async connect(jid, password, callback) {
        const { __, api } = shared_converse;

        if (api.settings.get('discover_connection_methods')) {
            const domain = Strophe.getDomainFromJid(jid);
            await this.discoverConnectionMethods(domain);
        }
        if (!api.settings.get('bosh_service_url') && !api.settings.get('websocket_url')) {
            // If we don't have a connection URL, we show an input for the user
            // to manually provide it.
            api.settings.set('show_connection_url_input', true);
            (callback || this.onConnectStatusChanged.bind(this))(
                Strophe.Status.DISCONNECTED,
                __('Could not automatically determine a connection URL'),
            );
            return;
        }
        super.connect(jid, password, callback || this.onConnectStatusChanged, BOSH_WAIT);
    }

    /**
     * @param {string} [reason]
     */
    disconnect(reason) {
        super.disconnect(reason);
        this.send_initial_presence = true;
    }

    /**
     * Switch to a different transport if a service URL is available for it.
     *
     * When reconnecting with a new transport, we call setUserJID
     * so that a new resource is generated, to avoid multiple
     * server-side sessions with the same resource.
     *
     * We also call `_proto._doDisconnect` so that connection event handlers
     * for the old transport are removed.
     */
    async switchTransport() {
        const { api } = shared_converse;

        const bare_jid = shared_converse.session.get('bare_jid');
        if (api.connection.isType('websocket') && api.settings.get('bosh_service_url')) {
            await setUserJID(bare_jid);
            this._proto._doDisconnect();
            this._proto = new Strophe.Bosh(this);
            this.service = api.settings.get('bosh_service_url');
        } else if (api.connection.isType('bosh') && api.settings.get('websocket_url')) {
            if (api.settings.get('authentication') === ANONYMOUS) {
                // When reconnecting anonymously, we need to connect with only
                // the domain, not the full JID that we had in our previous
                // (now failed) session.
                await setUserJID(api.settings.get('jid'));
            } else {
                await setUserJID(bare_jid);
            }
            this._proto._doDisconnect();
            this._proto = new Strophe.Websocket(this);
            this.service = api.settings.get('websocket_url');
        }
    }

    async reconnect() {
        const { api } = shared_converse;

        src_log.debug('RECONNECTING: the connection has dropped, attempting to reconnect.');
        this.reconnecting = true;
        await tearDown(shared_converse);

        const conn_status = shared_converse.state.connfeedback.get('connection_status');
        if (conn_status === Strophe.Status.CONNFAIL) {
            this.switchTransport();
        } else if (conn_status === Strophe.Status.AUTHFAIL && api.settings.get('authentication') === ANONYMOUS) {
            // When reconnecting anonymously, we need to connect with only
            // the domain, not the full JID that we had in our previous
            // (now failed) session.
            await setUserJID(api.settings.get('jid'));
        }

        /**
         * Triggered when the connection has dropped, but Converse will attempt
         * to reconnect again.
         * @event _converse#will-reconnect
         */
        api.trigger('will-reconnect');

        if (api.settings.get('authentication') === ANONYMOUS) {
            await clearSession(shared_converse);
        }
        const jid = shared_converse.session.get('jid');
        return api.user.login(jid);
    }

    /**
     * Called as soon as a new connection has been established, either
     * by logging in or by attaching to an existing BOSH session.
     * @method Connection.onConnected
     * @param {Boolean} [reconnecting] - Whether Converse.js reconnected from an earlier dropped session.
     */
    async onConnected(reconnecting) {
        const { api } = shared_converse;

        delete this.reconnecting;
        if (this.isType('bosh')) {
            // Solves problem of returned PubSub BOSH response not received by browser
            this.flush();
        }

        await setUserJID(this.jid);

        // Save the current JID in persistent storage so that we can attempt to
        // recreate the session from SCRAM keys
        if (shared_converse.state.config.get('trusted')) {
            const bare_jid = shared_converse.session.get('bare_jid');
            setLocalStorageItem('conversejs-session-jid', bare_jid);
        }

        /**
         * Synchronous event triggered after we've sent an IQ to bind the
         * user's JID resource for this session.
         * @event _converse#afterResourceBinding
         */
        await api.trigger('afterResourceBinding', reconnecting, { 'synchronous': true });

        if (reconnecting) {
            /**
             * After the connection has dropped and converse.js has reconnected.
             * Any Strophe stanza handlers (as registered via `converse.listen.stanza`) will
             * have to be registered anew.
             * @event _converse#reconnected
             * @example _converse.api.listen.on('reconnected', () => { ... });
             */
            api.trigger('reconnected');
        } else {
            /**
             * Triggered after the connection has been established and Converse
             * has got all its ducks in a row.
             * @event _converse#initialized
             */
            api.trigger('connected');
        }
    }

    /**
     * Used to keep track of why we got disconnected, so that we can
     * decide on what the next appropriate action is (in onDisconnected)
     * @param {Number|'logout'} [cause] - The status number as received from Strophe.
     * @param {String} [reason] - An optional user-facing message as to why
     *  there was a disconnection.
     * @param {Boolean} [override] - An optional flag to replace any previous
     *  disconnection cause and reason.
     */
    setDisconnectionCause(cause, reason, override) {
        if (cause === undefined) {
            delete this.disconnection_cause;
            delete this.disconnection_reason;
        } else if (this.disconnection_cause === undefined || override) {
            this.disconnection_cause = cause;
            this.disconnection_reason = reason;
        }
    }

    /**
     * @param {Number} [status] - The status number as received from Strophe.
     * @param {String} [message] - An optional user-facing message
     */
    setConnectionStatus(status, message) {
        this.status = status;
        shared_converse.state.connfeedback.set({ connection_status: status, message });
    }

    async finishDisconnection() {
        this.setConnectionStatus(Strophe.Status.DISCONNECTED, this.disconnection_reason);
        const { api } = shared_converse;
        // Properly tear down the session so that it's possible to manually connect again.
        src_log.debug('DISCONNECTED');
        delete this.reconnecting;
        this.reset();
        tearDown(shared_converse);
        await clearSession(shared_converse);
        api.connection.destroy();

        /**
         * Triggered after converse.js has disconnected from the XMPP server.
         * @event _converse#disconnected
         * @memberOf _converse
         * @example _converse.api.listen.on('disconnected', () => { ... });
         */
        api.trigger('disconnected');
    }

    /**
     * Gets called once strophe's status reaches Strophe.Status.DISCONNECTED.
     * Will either start a teardown process for converse.js or attempt
     * to reconnect.
     * @method onDisconnected
     */
    onDisconnected() {
        const { api } = shared_converse;
        if (api.settings.get('auto_reconnect')) {
            const reason = this.disconnection_reason;
            if (this.disconnection_cause === Strophe.Status.AUTHFAIL) {
                if (api.settings.get('credentials_url') || api.settings.get('authentication') === ANONYMOUS) {
                    // If `credentials_url` is set, we reconnect, because we might
                    // be receiving expirable tokens from the credentials_url.
                    //
                    // If `authentication` is anonymous, we reconnect because we
                    // might have tried to attach with stale BOSH session tokens
                    // or with a cached JID and password
                    return api.connection.reconnect();
                } else {
                    return this.finishDisconnection();
                }
            } else if (this.status === Strophe.Status.CONNECTING) {
                // Don't try to reconnect if we were never connected to begin
                // with, otherwise an infinite loop can occur (e.g. when the
                // BOSH service URL returns a 404).
                const { __ } = shared_converse;
                this.setConnectionStatus(
                    Strophe.Status.CONNFAIL,
                    __('An error occurred while connecting to the chat server.'),
                );
                return this.finishDisconnection();
            } else if (
                this.disconnection_cause === LOGOUT ||
                reason === Strophe.ErrorCondition.NO_AUTH_MECH ||
                reason === 'host-unknown' ||
                reason === 'remote-connection-failed' ||
                reason === 'not-well-formed'
            ) {
                return this.finishDisconnection();
            }
            api.connection.reconnect();
        } else {
            return this.finishDisconnection();
        }
    }

    /**
     * Callback method called by Strophe as the Connection goes
     * through various states while establishing or tearing down a
     * connection.
     * @param {Number} status
     * @param {String} [condition]
     */
    onConnectStatusChanged(status, condition) {
        const { __ } = shared_converse;
        src_log.debug(`Status changed to: ${CONNECTION_STATUS[status]}`);
        if (status === Strophe.Status.ATTACHFAIL) {
            this.setConnectionStatus(status);
            this.worker_attach_promise?.resolve(false);
        } else if (status === Strophe.Status.CONNECTED || status === Strophe.Status.ATTACHED) {
            if (this.worker_attach_promise?.isResolved && this.status === Strophe.Status.ATTACHED) {
                // A different tab must have attached, so nothing to do for us here.
                return;
            }
            this.setConnectionStatus(status);
            this.worker_attach_promise?.resolve(true);

            this.setDisconnectionCause();
            if (this.restored) {
                // No need to send an initial presence stanza when
                // we're restoring an existing session (e.g. via SMACKS resume).
                this.send_initial_presence = false;
            }
            if (this.reconnecting) {
                src_log.debug(status === Strophe.Status.CONNECTED ? 'Reconnected' : 'Reattached');
                this.onConnected(true);
            } else {
                src_log.debug(status === Strophe.Status.CONNECTED ? 'Connected' : 'Attached');
                this.onConnected();
            }
        } else if (status === Strophe.Status.DISCONNECTED) {
            this.setDisconnectionCause(status, condition);
            this.onDisconnected();
        } else if (status === Strophe.Status.BINDREQUIRED) {
            this.bind();
        } else if (status === Strophe.Status.ERROR) {
            this.setConnectionStatus(status, __('An error occurred while connecting to the chat server.'));
        } else if (status === Strophe.Status.CONNECTING) {
            this.setConnectionStatus(status);
        } else if (status === Strophe.Status.AUTHENTICATING) {
            this.setConnectionStatus(status);
        } else if (status === Strophe.Status.AUTHFAIL) {
            if (!condition) {
                condition = __('Your XMPP address and/or password is incorrect. Please try again.');
            }
            this.setConnectionStatus(status, condition);
            this.setDisconnectionCause(status, condition, true);
            this.onDisconnected();
        } else if (status === Strophe.Status.CONNFAIL) {
            let feedback = condition;
            if (condition === 'host-unknown' || condition == 'remote-connection-failed') {
                feedback = __(
                    'We could not connect to %1$s, is your XMPP address correct?',
                    Strophe.getDomainFromJid(this.jid),
                );
            } else if (condition === 'policy-violation') {
                feedback = __('The XMPP server rejected the connection because of a policy violation');
            } else if (condition !== undefined && condition === Strophe?.ErrorCondition?.NO_AUTH_MECH) {
                feedback = __('The XMPP server did not offer a supported authentication mechanism');
            }
            this.setConnectionStatus(status, feedback);
            this.setDisconnectionCause(status, condition);
        } else if (status === Strophe.Status.DISCONNECTING) {
            this.setConnectionStatus(status);
            this.setDisconnectionCause(status, condition);
        }
    }

    /**
     * @param {string} type
     */
    isType(type) {
        if (type.toLowerCase() === 'websocket') {
            return this._proto instanceof Strophe.Websocket;
        } else if (type.toLowerCase() === 'bosh') {
            return Strophe.Bosh && this._proto instanceof Strophe.Bosh;
        }
    }

    hasResumed() {
        const { api } = shared_converse;
        if (api.settings.get('connection_options')?.worker || this.isType('bosh')) {
            return shared_converse.state.connfeedback.get('connection_status') === Strophe.Status.ATTACHED;
        }
        // Strophe knows whether its XEP-0198 engine resumed the session.
        return super.hasResumed();
    }

    restoreWorkerSession() {
        this.attach(this.onConnectStatusChanged);
        this.worker_attach_promise = openpromise_getOpenPromise();
        return this.worker_attach_promise;
    }
}

/**
 * The MockConnection class is used during testing, to mock an XMPP connection.
 */
class MockConnection extends connection_Connection {
    /**
     * @param {string} service - The BOSH or WebSocket service URL.
     * @param {import('strophe.js').ConnectionOptions} options - The configuration options
     */
    constructor(service, options) {
        super(service, {
            ...options,
            // Tests must not leak resumable XEP-0198 state into each other
            // via sessionStorage, so default to in-memory storage. A test
            // can still supply its own (pre-seeded) backend via
            // connection_options.streamManagement.storage.
            streamManagement: { storage: new MemoryStorageBackend(), ...options.streamManagement },
        });

        this.sent_stanzas = [];
        this.IQ_stanzas = [];
        this.IQ_ids = [];

        this.features = Strophe.xmlHtmlNode(
            '<stream:features xmlns:stream="http://etherx.jabber.org/streams" xmlns="jabber:client">' +
                '<ver xmlns="urn:xmpp:features:rosterver"/>' +
                '<csi xmlns="urn:xmpp:csi:0"/>' +
                '<this xmlns="http://jabber.org/protocol/caps" ver="UwBpfJpEt3IoLYfWma/o/p3FFRo=" hash="sha-1" node="http://prosody.im"/>' +
                '<bind xmlns="urn:ietf:params:xml:ns:xmpp-bind">' +
                '<required/>' +
                '</bind>' +
                `<sm xmlns='urn:xmpp:sm:3'/>` +
                '<session xmlns="urn:ietf:params:xml:ns:xmpp-session">' +
                '<optional/>' +
                '</session>' +
                '</stream:features>',
        ).firstElementChild;

        // @ts-ignore
        this._proto._processRequest = () => {};
        this._proto._disconnect = () => this._onDisconnectTimeout();
        this._proto._onDisconnectTimeout = () => {};

        // Drain the send queue synchronously into sent_stanzas: this
        // captures everything Strophe queues in wire order (stanzas as
        // well as the XEP-0198 nonzas that the SM engine pushes directly
        // onto _data).
        this._proto._send = () => {
            while (this._data.length) {
                const el = this._data.shift();
                if (typeof el !== 'string') this.sent_stanzas.push(el);
            }
        };
        this._proto._connect = () => {
            this.connected = true;
            this.mock = true;
            this.jid = 'romeo@montague.lit/orchard';
            // Feed the mock stream features through the same post-SASL
            // decision point the real connect flow uses. With Stream
            // Management enabled this is where Strophe chooses between
            // <resume/> and resource binding; without it, it proceeds
            // straight to binding (BINDREQUIRED, since Converse uses
            // explicitResourceBinding).
            this._onStreamFeaturesAfterSASL(this.features);
        };
    }

    /**
     * Strophe's `Connection._dataRecv` unwraps an injected request into its
     * stanza element via the transport's `_reqToData`, but only for BOSH; on
     * websocket it expects the element directly. Tests inject a Request-shaped
     * object on both transports (see `createRequest`), so unwrap it here for
     * the websocket case before Strophe processes it.
     * @param {any} req
     * @param {string} [raw]
     */
    _dataRecv(req, raw) {
        const elem = this._proto instanceof Strophe.Bosh ? req : (req?.getResponse?.() ?? req);
        return super._dataRecv(elem, raw);
    }

    // @ts-ignore
    get _sasl_mechanism() {
        return new Strophe.SASLSHA256();
    }

    _processRequest() {
        // eslint-disable-line class-methods-use-this
        // Don't attempt to send out stanzas
    }

    sendIQ(iq, callback, errback) {
        iq = iq.tree?.() ?? iq;

        this.IQ_stanzas.push(iq);
        const id = super.sendIQ(iq, callback, errback);
        this.IQ_ids.push(id);
        return id;
    }

    send(stanza) {
        stanza = stanza.tree?.() ?? stanza;
        // No sent_stanzas.push here: the stanza lands there via the
        // _proto._send drain (see constructor), like all outbound traffic.
        return super.send(stanza);
    }

    async bind() {
        const { api } = shared_converse;
        await api.trigger('beforeResourceBinding', { 'synchronous': true });
        this.authenticated = true;
        // The real bind-result handler calls this before emitting
        // CONNECTED; with SM enabled it sends the native <enable/>.
        this._onSessionReady();
        this._changeConnectStatus(Strophe.Status.CONNECTED);
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/connection/api.js









let api_connection;

const default_connection_options = { 'explicitResourceBinding': true };

/**
 * This grouping collects API functions related to the XMPP connection.
 *
 * @namespace api.connection
 * @memberOf api
 */
/* export default */ const connection_api = ({
    /**
     * @method api.connection.init
     * @memberOf api.connection
     * @param {string} [jid]
     * @return {Connection|MockConnection}
     */
    init(jid) {
        if (jid && api_connection?.jid && isSameDomain(api_connection.jid, jid)) return api_connection;

        if (!settings_api.get('bosh_service_url') && settings_api.get('authentication') === PREBIND) {
            throw new Error("authentication is set to 'prebind' but we don't have a BOSH connection");
        }

        const XMPPConnection = isTestEnv() ? MockConnection : connection_Connection;
        const user_options = settings_api.get('connection_options') ?? {};
        api_connection = new XMPPConnection(
            getConnectionServiceURL(),
            Object.assign(default_connection_options, user_options, {
                'keepalive': settings_api.get('keepalive'),
                // XEP-0198 Stream Management is handled natively by Strophe
                'enableStreamManagement': !!settings_api.get('enable_smacks'),
                'streamManagement': {
                    'maxUnacked': settings_api.get('smacks_max_unacked_stanzas') ?? 5,
                    // Let embedders (and tests) override e.g. the storage backend.
                    ...(user_options.streamManagement ?? {}),
                },
            }),
        );

        setStropheLogLevel();
        /**
         * Triggered once the `Connection` constructor has been initialized, which
         * will be responsible for managing the connection to the XMPP server.
         *
         * @event connectionInitialized
         */
        api_events.trigger('connectionInitialized');

        return api_connection;
    },

    /**
     * @method api.connection.get
     * @memberOf api.connection
     * @return {Connection|MockConnection}
     */
    get() {
        return api_connection;
    },

    destroy() {
        this.disconnect();
        api_connection?.disconnect();
        api_connection = undefined;
    },

    /**
     * @method api.connection.authenticated
     * @memberOf api.connection
     * @returns {boolean} Whether we're authenticated to the XMPP server or not
     */
    authenticated() {
        return api_connection?.authenticated && true;
    },

    /**
     * @method api.connection.connected
     * @memberOf api.connection
     * @returns {boolean} Whether there is an established connection or not.
     */
    connected() {
        return api_connection?.connected && true;
    },

    /**
     * Terminates the connection.
     *
     * @method api.connection.disconnect
     * @memberOf api.connection
     */
    disconnect() {
        api_connection?.disconnect();
    },

    /**
     * Can be called once the XMPP connection has dropped and we want
     * to attempt reconnection.
     * Only needs to be called once, if reconnect fails Converse will
     * attempt to reconnect every two seconds, alternating between BOSH and
     * Websocket if URLs for both were provided.
     * @method reconnect
     * @memberOf api.connection
     */
    reconnect() {
        api_connection.setConnectionStatus(
            Strophe.Status.RECONNECTING,
            'The connection has dropped, attempting to reconnect.',
        );
        if (api_connection?.reconnecting) {
            return api_connection.debouncedReconnect();
        } else {
            return api_connection.reconnect();
        }
    },

    /**
     * Utility method to determine the type of connection we have
     * @method isType
     * @memberOf api.connection
     * @returns {boolean}
     */
    isType(type) {
        return api_connection.isType(type);
    },
});

;// CONCATENATED MODULE: ./src/headless/utils/promise.js





/**
 * Debounces a function by waiting for the timeout period before calling it.
 * If the function gets called again, the timeout period resets.
 * The returned function has a `.flush()` method to invoke immediately.
 * @param {Function} func
 * @param {number} timeout
 */
function promise_debounce(func, timeout) {
    let timer;
    let lastArgs = [];
    let lastThis;

    function debounced(...args) {
        lastArgs = args;
        lastThis = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(lastThis, lastArgs);
        }, timeout);
    }

    debounced.flush = function () {
        clearTimeout(timer);
        func.apply(lastThis, lastArgs);
    };

    return debounced;
}

/**
 * Clears the specified timeout and interval.
 * @method u#clearTimers
 * @param {ReturnType<typeof setTimeout>} timeout - Id if the timeout to clear.
 * @param {ReturnType<typeof setInterval>} interval - Id of the interval to clear.
 * @copyright Simen Bekkhus 2016
 * @license MIT
 */
function clearTimers(timeout, interval) {
    clearTimeout(timeout);
    clearInterval(interval);
}

/**
 * Creates a {@link Promise} that resolves if the passed in function returns a truthy value.
 * Rejects if it throws or does not return truthy within the given max_wait.
 * @param { Function } func - The function called every check_delay,
 *  and the result of which is the resolved value of the promise.
 * @param { number } [max_wait=2000] - The time to wait before rejecting the promise.
 * @param { number } [check_delay=3] - The time to wait before each invocation of {func}.
 * @returns {Promise} A promise resolved with the value of func,
 *  or rejected with the exception thrown by it or it times out.
 * @copyright Simen Bekkhus 2016
 * @license MIT
 */
function waitUntil(func, max_wait = 2000, check_delay = 3) {
    // Run the function once without setting up any listeners in case it's already true
    try {
        const result = func();
        if (result) {
            return Promise.resolve(result);
        }
    } catch (e) {
        return Promise.reject(e);
    }

    const promise = openpromise_getOpenPromise();
    const timeout_err = new Error();

    function checker() {
        try {
            const result = func();
            if (result) {
                clearTimers(max_wait_timeout, interval);
                promise.resolve(result);
            }
        } catch (e) {
            clearTimers(max_wait_timeout, interval);
            promise.reject(e);
        }
    }

    const interval = setInterval(checker, check_delay);

    function handler() {
        clearTimers(max_wait_timeout, interval);
        const err_msg = `Wait until promise timed out: \n\n${timeout_err.stack}`;
        console.trace();
        src_log.error(err_msg);
        promise.reject(new Error(err_msg));
    }

    const max_wait_timeout = setTimeout(handler, max_wait);

    return promise;
}

;// CONCATENATED MODULE: ./src/headless/shared/api/promise.js





/* export default */ const api_promise = ({
    /**
     * Converse and its plugins trigger various events which you can listen to via the
     * {@link _converse.api.listen} namespace.
     *
     * Some of these events are also available as Promises although not all of them could
     * logically act as promises, since some events might be fired multiple times whereas
     * promises are to be resolved (or rejected) only once.
     *
     * Events which are also promises include:
     *
     * * cachedRoster
     * * chatBoxesFetched
     * * pluginsInitialized
     * * roster
     * * rosterContactsFetched
     * * rosterGroupsFetched
     * * rosterInitialized
     *
     * The various plugins might also provide promises, and they do this by using the
     * `promises.add` api method.
     *
     * @namespace _converse.api.promises
     * @memberOf _converse.api
     */
    promises: {
        /**
         * By calling `promises.add`, a new [Promise](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
         * is made available for other code or plugins to depend on via the
         * {@link _converse.api.waitUntil} method.
         *
         * Generally, it's the responsibility of the plugin which adds the promise to
         * also resolve it.
         *
         * This is done by calling {@link _converse.api.trigger}, which not only resolves the
         * promise, but also emits an event with the same name (which can be listened to
         * via {@link _converse.api.listen}).
         *
         * @method _converse.api.promises.add
         * @param {string|array} [promises] The name or an array of names for the promise(s) to be added
         * @param {boolean} [replace=true] Whether this promise should be replaced with a new one when the user logs out.
         * @example _converse.api.promises.add('foo-completed');
         */
        add(promises, replace = true) {
            promises = Array.isArray(promises) ? promises : [promises];
            promises.forEach((name) => {
                /** @type {import('../types').ReplaceableOpenPromise} */
                const promise = openpromise_getOpenPromise();
                promise.replace = replace;
                shared_converse.promises[name] = promise;
            });
        },
    },

    /**
     * Wait until a promise is resolved or until the passed in function returns
     * a truthy value.
     * @method _converse.api.waitUntil
     * @param {string|function} condition - The name of the promise to wait for,
     * or a function which should eventually return a truthy value.
     * @returns {Promise}
     */
    waitUntil(condition) {
        if (object_isFunction(condition)) {
            return waitUntil(/** @type {Function} */ (condition));
        } else {
            const promise = shared_converse.promises[condition];
            if (promise === undefined) {
                return null;
            }
            return promise;
        }
    },
});

;// CONCATENATED MODULE: ./src/headless/shared/errors.js
class MethodNotImplementedError extends Error {}

class UserFacingError extends Error {
    /**
     * @param {string} message
     */
    constructor (message) {
        super(message);
        this.name = 'UserFacingError';
        this.user_facing = true;
    }
}

class IQError extends Error {
    /**
     * @param {string} message
     * @param {Element} iq
     */
    constructor (message, iq) {
        super(message);
        this.name = 'IQError';
        this.iq = iq;
    }
}

/**
 * Custom error for indicating timeouts
 * @namespace converse.env
 */
class TimeoutError extends Error {
    /**
     * @param  {string} message
     */
    constructor(message) {
        super(message);
        this.retry_event_id = null;
    }
}

class StanzaError extends Error {
    /**
     * @typedef {import("./types").ErrorName} ErrorName
     * @typedef {import("./types").ErrorType} ErrorType
     * @typedef {import("./types").ErrorExtra} ErrorExtra
     */

    /**
     * @param {ErrorName|'unknown'} name
     * @param {Element} e - The <error> element from a stanza
     * @param {Object} extra - Extra properties from plugin parsers
     */
    constructor(name, e, extra) {
        super(e.querySelector('text')?.textContent ?? '');
        /** @type {ErrorName} */
        this.name = name
        /** @type {string} */
        this.message = name;
        /** @type {ErrorType} */
        this.type = /** @type {ErrorType} */ (e.getAttribute('type'));
        /** @type {Element} */
        this.el = e;
        /** @type {ErrorExtra} */
        this.extra = extra;
    }
}

class StanzaParseError extends Error {
    /**
     * @param {Element} stanza
     * @param {string} [message]
     */
    constructor(stanza, message) {
        super(message);
        this.name = 'StanzaParseError';
        this.stanza = stanza;
    }
}

class BadRequestError extends StanzaError {}
class ConflictError extends StanzaError {}
class FeatureNotImplementedError extends StanzaError {}
class ForbiddenError extends StanzaError {}
class GoneError extends StanzaError {}
class InternalServerError extends StanzaError {}
class ItemNotFoundError extends StanzaError {}
class JIDMalformedError extends StanzaError {}
class NotAcceptableError extends StanzaError {}
class NotAllowedError extends StanzaError {}
class NotAuthorizedError extends StanzaError {}
class PaymentRequiredError extends StanzaError {}
class RecipientUnavailableError extends StanzaError {}
class RedirectError extends StanzaError {}
class RegistrationRequiredError extends StanzaError {}
class RemoteServerNotFoundError extends StanzaError {}
class RemoteServerTimeoutError extends StanzaError {}
class ResourceConstraintError extends StanzaError {}
class ServiceUnavailableError extends StanzaError {}
class SubscriptionRequiredError extends StanzaError {}
class UndefinedConditionError extends StanzaError {}
class UnexpectedRequestError extends StanzaError {}

;// CONCATENATED MODULE: ./src/headless/shared/api/send.js





/* export default */ const send = ({
    /**
     * @typedef {import('strophe.js').Builder} Builder
     *
     * Allows you to send XML stanzas.
     * @method _converse.api.send
     * @param {Element|Builder} stanza
     * @returns {void}
     * @example
     *     const { stx } = _converse.env;
     *     const msg = stx`<message from="juliet@example.com/balcony" to="romeo@example.net" type="chat"/>`;
     *     _converse.api.send(msg);
     */
    send(stanza) {
        const { api } = shared_converse;
        if (!api.connection.connected()) {
            // TODO: queue unsent messages and send once we're connected again
            src_log.warn("Not sending stanza because we're not connected!");
            src_log.warn(stanza);
            return;
        }
        const el = stanza instanceof Element ? stanza : stanza.tree();
        if (el.tagName === 'iq') {
            return api.sendIQ(el);
        } else {
            api.connection.get().send(el);
            api.trigger('send', el);
        }
    },

    /**
     * Send an IQ stanza
     * @method _converse.api.sendIQ
     * @param {Element|Builder} stanza
     * @param {number} [timeout] - The default timeout value is taken from
     *  the `stanza_timeout` configuration setting.
     * @param {boolean} [reject=true] - Whether an error IQ should cause the promise
     *  to be rejected. If `false`, the promise will resolve instead of being rejected.
     * @returns {Promise} A promise which resolves (or potentially rejected) once we
     *  receive a `result` or `error` stanza or once a timeout is reached.
     *  If the IQ stanza being sent is of type `result` or `error`, there's
     *  nothing to wait for, so an already resolved promise is returned.
     */
    sendIQ(stanza, timeout, reject = true) {
        const { api } = shared_converse;
        if (!api.connection.connected()) {
            throw new Error("Not sending IQ stanza because we're not connected!");
        }

        const connection = api.connection.get();

        let promise;
        const el = stanza instanceof Element ? stanza : stanza.tree();
        if (['get', 'set'].includes(el.getAttribute('type'))) {
            timeout = timeout || api.settings.get('stanza_timeout');
            if (reject) {
                promise = new Promise((resolve, reject) => connection.sendIQ(el, resolve, reject, timeout));
                promise.catch((e) => {
                    if (e === null) {
                        src_log.error(el);
                        throw new TimeoutError(`Timeout error after ${timeout}ms for IQ stanza`);
                    }
                });
            } else {
                promise = new Promise((resolve) => connection.sendIQ(el, resolve, resolve, timeout));
            }
        } else {
            connection.sendIQ(el);
            promise = Promise.resolve();
        }
        api.trigger('send', el);
        return promise;
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/chatboxes/utils.js
/**
 * @typedef {import('../chat/model.js').default} ChatBox
 */






async function onClearSession() {
    if (shouldClearCache(shared_converse)) {
        const { chatboxes } = shared_converse.state;
        await Promise.all(chatboxes.map(/** @param {ChatBox} c */ (c) => c.messages?.clearStore({ 'silent': true })));
        chatboxes.clearStore(
            { silent: true },
            /** @param {import('../../shared/chatbox').default} o */ (o) => o.get('type') !== CONTROLBOX_TYPE
        );
    }
}

/**
 * @param {string} jid
 * @param {object} attrs
 * @param {new (attrs: object, options: object) => ChatBox} Model
 */
async function createChatBox(jid, attrs, Model) {
    jid = Strophe.getBareJidFromJid(jid.toLowerCase());
    Object.assign(attrs, { 'jid': jid, 'id': jid });
    let chatbox;
    try {
        chatbox = new Model(attrs, { 'collection': shared_converse.state.chatboxes });
    } catch (e) {
        src_log.error(e);
        return null;
    }
    await chatbox.initialized;
    if (!chatbox.isValid()) {
        chatbox.destroy();
        return null;
    }
    shared_converse.state.chatboxes.add(chatbox);
    return chatbox;
}

;// CONCATENATED MODULE: ./src/headless/plugins/chatboxes/api.js
/**
 * @typedef {import('@converse/skeletor').Model} Model
 * @typedef {import('../chat/model.js').default} ChatBox
 */




const { waitUntil: api_waitUntil } = api_promise;
const _chatBoxTypes = {};

/**
 * The "chatboxes" namespace.
 *
 * @namespace api.chatboxes
 * @memberOf api
 */
/* export default */ const chatboxes_api = ({
    /**
     * @typedef {new (attrs: object, options: object) => ChatBox} ModelClass
     */

    /**
     * @method api.chatboxes.create
     * @param {string|string[]} jids - A JID or array of JIDs
     * @param {Object} attrs An object containing configuration attributes
     * @param {ModelClass} model - The type of chatbox that should be created
     */
    async create (jids=[], attrs={}, model) {
        await api_waitUntil('chatBoxesFetched');
        if (typeof jids === 'string') {
            return createChatBox(jids, attrs, model);
        } else {
            return Promise.all(jids.map(jid => createChatBox(jid, attrs, model)));
        }
    },

    /**
     * @method api.chatboxes.get
     * @param {string|string[]} [jids] - A JID or array of JIDs
     */
    async get (jids) {
        await api_waitUntil('chatBoxesFetched');
        const { chatboxes } = shared_converse.state;
        if (jids === undefined) {
            return chatboxes.models;
        } else if (typeof jids === 'string') {
            return chatboxes.get(jids.toLowerCase());
        } else {
            jids = jids.map(j => j.toLowerCase());
            return chatboxes.models.filter(m => jids.includes(m.get('jid')));
        }
    },

    /**
     * The "chatboxes" registry.
     * Allows you to register more chatbox types that can be created via
     * `api.chatboxes.create`.
     * @namespace api.chatboxes.registry
     * @memberOf api.chatboxes
     */
    registry: {

        /**
         * @method api.chatboxes.registry.add
         * Add another type of chatbox that can be added to this collection.
         * This is used in the `createModel` function to determine what type of
         * chatbox class to instantiate (e.g. ChatBox, MUC, Feed etc.) based on the
         * passed in attributes.
         * @param {string} type - The type name
         * @param {ModelClass} model - The model which will be instantiated for the given type name.
         */
        add(type, model) {
            _chatBoxTypes[type] = model;
        },

        /**
         * @method api.chatboxes.registry.get
         * @param {string} type - The type name
         * @return {ModelClass} model - The model which will be instantiated for the given type name.
         */
        get(type) {
            return _chatBoxTypes[type];
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/muc/api.js
/**
 * @typedef {import('./muc.js').default} MUC
 */









const { waitUntil: muc_api_waitUntil } = api_promise;

/**
 * The "rooms" namespace groups methods relevant to chatrooms
 * (aka groupchats).
 *
 * @namespace api.rooms
 * @memberOf api
 */
const api_rooms = {
    /**
     * Creates a new MUC chatroom (aka groupchat)
     *
     * Similar to {@link api.rooms.open}, but creates
     * the chatroom in the background (i.e. doesn't cause a view to open).
     *
     * @method api.rooms.create
     * @param {(string[]|string)} jids The JID or array of
     *     JIDs of the chatroom(s) to create
     * @param {object} [attrs] attrs The room attributes
     * @returns {Promise<MUC[]|MUC>} Promise which resolves with the Model representing the chat.
     */
    create(jids, attrs = {}) {
        attrs = typeof attrs === 'string' ? { 'nick': attrs } : attrs || {};
        if (!attrs.nick && settings_api.get('muc_nickname_from_jid')) {
            const bare_jid = shared_converse.session.get('bare_jid');
            attrs.nick = Strophe.getNodeFromJid(bare_jid);
        }
        if (jids === undefined) {
            throw new TypeError('rooms.create: You need to provide at least one JID');
        } else if (typeof jids === 'string') {
            return api_rooms.get(getJIDFromURI(jids), attrs, true);
        }
        return Promise.all(jids.map((jid) => /** @type {Promise<MUC>} */ (api_rooms.get(getJIDFromURI(jid), attrs, true))));
    },

    /**
     * Opens a MUC chatroom (aka groupchat)
     *
     * Similar to {@link api.chats.open}, but for groupchats.
     *
     * @method api.rooms.open
     * @param {string|string[]} jids The room JID or JIDs (if not specified, all
     *     currently open rooms will be returned).
     * @param {object} attrs A map  containing any extra room attributes.
     * @param {string} [attrs.nick] The current user's nickname for the MUC
     * @param {boolean} [attrs.hidden]
     * @param {boolean} [attrs.auto_configure] A boolean, indicating
     *     whether the room should be configured automatically or not.
     *     If set to `true`, then it makes sense to pass in configuration settings.
     * @param {object} [attrs.roomconfig] A map of configuration settings to be used when the room gets
     *     configured automatically. Currently it doesn't make sense to specify
     *     `roomconfig` values if `auto_configure` is set to `false`.
     *     For a list of configuration values that can be passed in, refer to these values
     *     in the [XEP-0045 MUC specification](https://xmpp.org/extensions/xep-0045.html#registrar-formtype-owner).
     *     The values should be named without the `muc#roomconfig_` prefix.
     * @param {boolean} [attrs.minimized] A boolean, indicating whether the room should be opened minimized or not.
     * @param {boolean} [force=false] - By default, a minimized
     *   room won't be maximized (in `overlayed` view mode) and in
     *   `fullscreen` view mode a newly opened room won't replace
     *   another chat already in the foreground.
     *   Set `force` to `true` if you want to force the room to be
     *   maximized or shown.
     * @returns {Promise<MUC[]|MUC>} Promise which resolves with the Model representing the chat.
     *
     * @example
     * api.rooms.open('group@muc.example.com')
     *
     * @example
     * // To return an array of rooms, provide an array of room JIDs:
     * api.rooms.open(['group1@muc.example.com', 'group2@muc.example.com'])
     *
     * @example
     * // To setup a custom nickname when joining the room, provide the optional nick argument:
     * api.rooms.open('group@muc.example.com', {'nick': 'mycustomnick'})
     *
     * @example
     * // For example, opening a room with a specific default configuration:
     * api.rooms.open(
     *     'myroom@conference.example.org',
     *     { 'nick': 'coolguy69',
     *       'auto_configure': true,
     *       'roomconfig': {
     *           'changesubject': false,
     *           'membersonly': true,
     *           'persistentroom': true,
     *           'publicroom': true,
     *           'roomdesc': 'Comfy room for hanging out',
     *           'whois': 'anyone'
     *       }
     *     }
     * );
     */
    async open(jids, attrs = {}, force = false) {
        await muc_api_waitUntil('chatBoxesFetched');
        if (jids === undefined) {
            const err_msg = 'rooms.open: You need to provide at least one JID';
            src_log.error(err_msg);
            throw new TypeError(err_msg);
        } else if (typeof jids === 'string') {
            const room = /** @type {MUC} */ (await api_rooms.get(jids, attrs, true));
            !attrs.hidden && room?.maybeShow(force);
            return room;
        } else {
            const rooms = await Promise.all(jids.map((jid) => rooms.get(jid, attrs, true)));
            rooms.forEach((r) => !attrs.hidden && r.maybeShow(force));
            return rooms;
        }
    },

    /**
     * Fetches the object representing a MUC chatroom (aka groupchat)
     *
     * @method api.rooms.get
     * @param {string|string[]} [jids] The room JID (if not specified, all rooms will be returned).
     * @param {object} [attrs] A map containing any extra room attributes
     *  to be set if `create` is set to `true`
     * @param {string} [attrs.nick] Specify the nickname
     * @param {string} [attrs.password ] Specify a password if needed to enter a new room
     * @param {boolean} create A boolean indicating whether the room should be created
     *     if not found (default: `false`)
     * @returns {Promise<MUC[]|MUC>}
     * @example
     * api.waitUntil('roomsAutoJoined').then(() => {
     *     const create_if_not_found = true;
     *     api.rooms.get(
     *         'group@muc.example.com',
     *         {'nick': 'dread-pirate-roberts', 'password': 'secret'},
     *         create_if_not_found
     *     )
     * });
     */
    async get(jids, attrs = {}, create = false) {
        await muc_api_waitUntil('chatBoxesFetched');

        /** @param {string} jid */
        async function _get(jid) {
            jid = getJIDFromURI(jid);
            let model = await chatboxes_api.get(jid);
            if (!model && create) {
                model = await chatboxes_api.create(jid, attrs, shared_converse.exports.MUC);
            } else {
                model = model && model.get('type') === CHATROOMS_TYPE ? model : null;
                if (model && Object.keys(attrs).length) {
                    model.save(attrs);
                }
            }
            return model;
        }
        if (jids === undefined) {
            const chats = await chatboxes_api.get();
            return chats?.filter((c) => c.get('type') === CHATROOMS_TYPE) ?? [];
        } else if (typeof jids === 'string') {
            return _get(jids);
        }
        return Promise.all(jids.map((jid) => _get(jid)));
    },
};

const rooms_api = { rooms: api_rooms };

/* export default */ const muc_api = (rooms_api);

;// CONCATENATED MODULE: ./src/headless/shared/api/presence.js
/**
 * @typedef {import('strophe.js').Builder} Builder
 * @typedef {import('../../plugins/status/profile').default} Profile
 * @typedef {import('../../plugins/muc/muc.js').default} MUC
 */





const { waitUntil: presence_waitUntil } = api_promise;
const { send: presence_send } = send;
const { rooms: presence_rooms } = muc_api;

/* export default */ const api_presence = ({
    /**
     * @namespace _converse.api.user.presence
     * @memberOf _converse.api.user
     */
    presence: {
        /**
         * Send out a presence stanza
         * @method _converse.api.user.presence.send
         * @param {import('../../plugins/status/types').PresenceAttrs} [attrs]
         * @param {Array<Element>|Array<Builder>|Element|Builder} [nodes]
         *  Nodes(s) to be added as child nodes of the `presence` XML element.
         */
        async send(attrs, nodes) {
            await presence_waitUntil('statusInitialized');

            let children = [];
            if (nodes) {
                children = Array.isArray(nodes) ? nodes : [nodes];
            }

            const model = /** @type {Profile} */ (shared_converse.state.profile);
            const presence = await model.constructPresence(attrs);
            children.map((c) => c?.tree() ?? c).forEach((c) => presence.cnode(c).up());
            presence_send(presence);

            const { show, type } = attrs || {};
            if (show || !type) {
                const mucs = /** @type {MUC[]} */ (await presence_rooms.get());
                mucs.forEach((muc) => muc.sendStatusPresence(attrs, children));
            }
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/shared/settings/user/utils.js





let utils_user_settings; // User settings, populated via api.users.settings

/**
 * @returns {Promise<void>|void} A promise when the user settings object
 *  is created anew and it's contents fetched from storage.
 */
function initUserSettings () {
    const bare_jid = shared_converse.session.get('bare_jid');
    if (!bare_jid) {
        const msg = "No JID to fetch user settings for";
        src_log.error(msg);
        throw Error(msg);
    }
    const id = `converse.user-settings.${bare_jid}`;
    if (utils_user_settings?.get('id') !== id) {
        utils_user_settings = new skeletor_esm_Model({id});
        initStorage(utils_user_settings, id);
        return utils_user_settings.fetch({'promise': true});
    }
}

async function getUserSettings () {
    await initUserSettings();
    return utils_user_settings;
}

async function updateUserSettings (data, options) {
    await initUserSettings();
    return utils_user_settings.save(data, options);
}

async function clearUserSettings () {
    const bare_jid = shared_converse.session.get('bare_jid');
    if (bare_jid) {
        await initUserSettings();
        return utils_user_settings.clear();
    }
    utils_user_settings = undefined;
}

;// CONCATENATED MODULE: ./src/headless/shared/settings/user/api.js
/**
 * @typedef {import('@converse/skeletor').Model} Model
 */


/**
 * API for accessing and setting user settings. User settings are
 * different from the application settings from {@link _converse.api.settings}
 * because they are per-user and set via user action.
 * @namespace _converse.api.user.settings
 * @memberOf _converse.api.user
 */
const user_settings_api = {
    /**
     * Returns the user settings model. Useful when you want to listen for change events.
     * @async
     * @method _converse.api.user.settings.getModel
     * @returns {Promise<Model>}
     * @example const settings = await api.user.settings.getModel();
     */
    getModel () {
        return getUserSettings();
    },

    /**
     * Get the value of a particular user setting.
     * @method _converse.api.user.settings.get
     * @param {string} key - The setting name
     * @param {*} [fallback] - An optional fallback value if the user setting is undefined
     * @returns {Promise} Promise which resolves with the value of the particular configuration setting.
     * @example api.user.settings.get("foo");
     */
    async get (key, fallback) {
        const user_settings = await getUserSettings();
        return user_settings.get(key) === undefined ? fallback : user_settings.get(key);
    },

    /**
     * Set one or many user settings.
     * @async
     * @method _converse.api.user.settings.set
     * @param {Object|string} key An object containing config settings or alternatively a string key
     * @param {string} [val] The value, if the previous parameter is a key
     * @example api.user.settings.set("foo", "bar");
     * @example
     * api.user.settings.set({
     *     "foo": "bar",
     *     "baz": "buz"
     * });
     */
    set (key, val) {
        if (key instanceof Object) {
            return updateUserSettings(key, {'promise': true});
        } else {
            const o = {};
            o[key] = val;
            return updateUserSettings(o, {'promise': true});
        }
    },

    /**
     * Clears all the user settings
     * @async
     * @method api.user.settings.clear
     */
    clear () {
        return clearUserSettings();
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/api/user.js
/**
 * @module:shared.api.user
 */










const user_api = {
    /**
     * This grouping collects API functions related to the current logged in user.
     *
     * @namespace _converse.api.user
     * @memberOf _converse.api
     */
    user: {
        settings: user_settings_api,
        ...api_presence,

        /**
         * @method _converse.api.user.jid
         * @returns {string} The current user's full JID (Jabber ID)
         * @example _converse.api.user.jid())
         */
        jid() {
            return connection_api.get()?.jid;
        },

        /**
         * Logs the user in.
         *
         * If called without any parameters, Converse will try
         * to log the user in by calling the `prebind_url` or `credentials_url` depending
         * on whether prebinding is used or not.
         *
         * @method _converse.api.user.login
         * @param { string } [jid]
         * @param { string } [password]
         * @param { boolean } [automatic=false] - An internally used flag that indicates whether
         *  this method was called automatically once the connection has been
         *  initialized. It's used together with the `auto_login` configuration flag
         *  to determine whether Converse should try to log the user in if it
         *  fails to restore a previous auth'd session.
         *  @returns  { Promise<void> }
         */
        async login(jid, password, automatic = false) {
            const { api } = shared_converse;
            jid = jid || api.settings.get('jid');

            const connection = connection_api.init(jid);

            if (api.settings.get('connection_options')?.worker && (await connection.restoreWorkerSession())) {
                return;
            }
            if (jid) {
                jid = await setUserJID(jid);
            }

            /**
             * *Hook* which allows 3rd party code to attempt logging in before
             * the core code attempts it.
             *
             * Note: If the hook handler has logged the user in, it should set the
             * `success` flag on the payload to `true`.
             *
             * @typedef {Object} LoginHookPayload
             * @property {string} jid
             * @property {string} password
             * @property {boolean} [automatic] - An internally used flag that indicates whether
             *  this method was called automatically once the connection has been initialized.
             * @property {boolean} [success] - A flag which indicates whether
             * login has succeeded. If a hook handler receives a payload with
             * this flag, it should NOT attempt to log in.
             * If a handler has successfully logged in, it should return the
             * payload with this flag set to true.
             *
             * @event _converse#login
             * @param {typeof api.user} context
             * @param {LoginHookPayload} payload
             */
            const { success } = await shared_converse.api.hook('login', this, { jid, password, automatic });
            if (success) return;

            password = password || api.settings.get('password');
            const credentials = jid && password ? { jid, password } : null;
            await attemptNonPreboundSession(credentials, automatic);
        },

        /**
         * Logs the user out of the current XMPP session.
         * @method _converse.api.user.logout
         * @example _converse.api.user.logout();
         */
        async logout() {
            const { api } = shared_converse;
            /**
             * Triggered before the user is logged out
             * @event _converse#beforeLogout
             */
            await api.trigger('beforeLogout', { 'synchronous': true });

            const promise = openpromise_getOpenPromise();
            const complete = () => {
                // Recreate all the promises
                Object.keys(shared_converse.promises).forEach((p) => replacePromise(shared_converse, p));

                // Remove the session JID, otherwise the user would just be logged
                // in again upon reload. See #2759
                removeLocalStorageItem('conversejs-session-jid');

                /**
                 * Triggered once the user has logged out.
                 * @event _converse#logout
                 */
                api.trigger('logout');
                promise.resolve();
            };

            const connection = connection_api.get();
            if (connection) {
                connection.setDisconnectionCause(LOGOUT, undefined, true);
                api.listen.once('disconnected', () => complete());
                connection.disconnect();
            } else {
                complete();
            }
            return promise;
        },
    },
};

/* export default */ const user = (user_api);

;// CONCATENATED MODULE: ./src/headless/shared/api/index.js
/**
 * @typedef {import('../_converse.js').default} _converse
 * @typedef {module:shared-api.APIEndpoint} APIEndpoint
 */







/**
 * ### The private API
 *
 * The private API methods are only accessible via the closured {@link _converse}
 * object, which is only available to plugins.
 *
 * These methods are kept private (i.e. not global) because they may return
 * sensitive data which should be kept off-limits to other 3rd-party scripts
 * that might be running in the page.
 *
 * @memberOf _converse
 * @namespace api
 * @typedef {Record<string, Function>} module:shared-api.APIEndpoint
 * @typedef {Record<string, APIEndpoint|Function>} APINamespace
 * @typedef {Record<string, APINamespace|APIEndpoint|Function>} API
 * @type {API}
 */
const api_api = {
    connection: connection_api,
    settings: settings_api,
    ...send,
    ...user,
    ...api_events,
    ...api_promise,

    disco: null,
    elements: null,
    contacts: null,
};

/* export default */ const shared_api = (api_api);

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(353);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/advancedFormat.js
var advancedFormat = __webpack_require__(375);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/localizedFormat.js
var localizedFormat = __webpack_require__(750);
;// CONCATENATED MODULE: ./node_modules/filesize/dist/filesize.js
/**
 * filesize
 *
 * @copyright 2026 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 11.0.22
 */
// Error Messages
const INVALID_NUMBER = "Invalid number";
const INVALID_ROUND = "Invalid rounding method";

// Standard Types
const IEC = "iec";
const JEDEC = "jedec";
const SI = "si";

// Unit Types
const BIT = "bit";
const BITS = "bits";
const BYTE = "byte";
const BYTES = "bytes";
const SI_KBIT = "kbit";
const SI_KBYTE = "kB";

// Output Format Types
const ARRAY = "array";
const FUNCTION = "function";
const OBJECT = "object";
const STRING = "string";

// Processing Constants
const EXPONENT = "exponent";
const ROUND = "round";

// Special Characters and Values
const E = "e";
const EMPTY = "";
const PERIOD = ".";
const filesize_S = "s";
const SPACE = " ";
const ZERO = "0";

// Data Structures
const STRINGS = {
	symbol: {
		iec: {
			bits: ["bit", "Kibit", "Mibit", "Gibit", "Tibit", "Pibit", "Eibit", "Zibit", "Yibit"],
			bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"],
		},
		jedec: {
			bits: ["bit", "Kbit", "Mbit", "Gbit", "Tbit", "Pbit", "Ebit", "Zbit", "Ybit"],
			bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
		},
	},
	fullform: {
		iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
		jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"],
	},
};

// Pre-computed lookup tables for performance optimization
const BINARY_POWERS = [
	1, // 2^0
	1024, // 2^10
	1048576, // 2^20
	1073741824, // 2^30
	1099511627776, // 2^40
	1125899906842624, // 2^50
	1152921504606846976, // 2^60
	1180591620717411303424, // 2^70
	1208925819614629174706176, // 2^80
];

const DECIMAL_POWERS = [
	1, // 10^0
	1000, // 10^3
	1000000, // 10^6
	1000000000, // 10^9
	1000000000000, // 10^12
	1000000000000000, // 10^15
	1000000000000000000, // 10^18
	1000000000000000000000, // 10^21
	1000000000000000000000000, // 10^24
];

// Pre-computed log values for faster exponent calculation
const LOG_2_1024 = Math.log(1024);
const LOG_10_1000 = Math.log(1000);// Cached configuration lookup for better performance
const STANDARD_CONFIGS = {
	[SI]: { isDecimal: true, ceil: 1000, actualStandard: JEDEC },
	[IEC]: { isDecimal: false, ceil: 1024, actualStandard: IEC },
	[JEDEC]: { isDecimal: false, ceil: 1024, actualStandard: JEDEC },
};

/**
 * Optimized base configuration lookup
 * @param {string} standard - Standard type
 * @param {number} base - Base number
 * @returns {Object} Configuration object
 */
function getBaseConfiguration(standard, base) {
	// Use cached lookup table for better performance
	if (STANDARD_CONFIGS[standard]) {
		return STANDARD_CONFIGS[standard];
	}

	// Base override
	if (base === 2) {
		return { isDecimal: false, ceil: 1024, actualStandard: IEC };
	}

	// Default
	return { isDecimal: true, ceil: 1000, actualStandard: JEDEC };
}

/**
 * Optimized zero value handling
 * @param {number} precision - Precision value
 * @param {string} actualStandard - Standard to use
 * @param {boolean} bits - Whether to use bits
 * @param {Object} symbols - Custom symbols
 * @param {boolean} full - Whether to use full form
 * @param {Array} fullforms - Custom full forms
 * @param {string} output - Output format
 * @param {string} spacer - Spacer character
 * @param {boolean} pad - Whether to pad decimal places
 * @param {number} round - Number of decimal places for padding
 * @param {string} [symbol] - Symbol to use (defaults based on bits/standard)
 * @returns {string|Array|Object|number} Formatted result
 */
function handleZeroValue(
	precision,
	actualStandard,
	bits,
	symbols,
	full,
	fullforms,
	output,
	spacer,
	pad,
	round,
	symbol,
) {
	let value;
	if (precision > 0) {
		value = (0).toPrecision(precision);
	} else if (pad && round > 0) {
		value = (0).toFixed(round);
	} else {
		value = 0;
	}

	if (output === EXPONENT) {
		return 0;
	}

	// Set default symbol if not provided
	if (!symbol) {
		symbol = bits
			? STRINGS.symbol[actualStandard].bits[0]
			: STRINGS.symbol[actualStandard].bytes[0];
	}

	// Apply symbol customization
	if (symbols[symbol]) {
		symbol = symbols[symbol];
	}

	// Apply full form
	if (full) {
		if (fullforms[0]) {
			symbol = fullforms[0];
		} else {
			symbol = STRINGS.fullform[actualStandard][0];
			if (bits) {
				symbol += BIT;
			} else {
				symbol += BYTE;
			}
		}
	}

	// Return in requested format
	if (output === ARRAY) {
		return [value, symbol];
	}

	if (output === OBJECT) {
		return { value, symbol, exponent: 0, unit: symbol };
	}

	return value + spacer + symbol;
}

/**
 * Optimized value calculation with bits handling
 * @param {number} num - Input number
 * @param {number} e - Exponent
 * @param {boolean} isDecimal - Whether to use decimal powers
 * @param {boolean} bits - Whether to calculate bits
 * @param {number} ceil - Ceiling value for auto-increment
 * @param {boolean} autoExponent - Whether exponent is auto (-1 or NaN)
 * @returns {Object} Object with result and e properties
 */
function calculateOptimizedValue(num, e, isDecimal, bits, ceil, autoExponent = true) {
	let d;
	if (isDecimal) {
		d = DECIMAL_POWERS[e];
	} else {
		d = BINARY_POWERS[e];
	}
	let result = num / d;

	if (bits) {
		result *= 8;
		// Handle auto-increment for bits (only when exponent is auto)
		if (autoExponent && result >= ceil && e < 8) {
			result /= ceil;
			e++;
		}
	}

	return { result, e };
}

/**
 * Optimized precision handling with scientific notation correction
 * @param {number} value - Current value
 * @param {number} precision - Precision to apply
 * @param {number} e - Current exponent
 * @param {number} num - Original number
 * @param {boolean} isDecimal - Whether using decimal base
 * @param {boolean} bits - Whether calculating bits
 * @param {number} ceil - Ceiling value
 * @param {Function} roundingFunc - Rounding function
 * @param {number} round - Round value
 * @param {number} exponent - Forced exponent (-1 for auto)
 * @returns {Object} Object with value and e properties
 */
function applyPrecisionHandling(
	value,
	precision,
	e,
	num,
	isDecimal,
	bits,
	ceil,
	roundingFunc,
	round,
	exponent,
) {
	if (typeof value === "string") {
		value = parseFloat(value);
	}

	let result = value.toPrecision(precision);

	const autoExponent = exponent === -1 || isNaN(exponent);

	// Handle scientific notation by recalculating with incremented exponent
	if (result.includes(E) && e < 8 && autoExponent) {
		e++;
		const { result: valueResult } = calculateOptimizedValue(num, e, isDecimal, bits, ceil);
		let p;
		if (round > 0) {
			p = Math.pow(10, round);
		} else {
			p = 1;
		}
		let computed;
		if (p === 1) {
			computed = roundingFunc(valueResult);
		} else {
			computed = roundingFunc(valueResult * p) / p;
		}
		result = computed.toPrecision(precision);
	}

	return { value: result, e };
}

/**
 * Optimized number formatting with locale, separator, and padding
 * @param {number|string} value - Value to format
 * @param {string|boolean} locale - Locale setting
 * @param {Object} localeOptions - Locale options
 * @param {string} separator - Custom separator
 * @param {boolean} pad - Whether to pad
 * @param {number} round - Round value
 * @returns {string|number} Formatted value
 */
function applyNumberFormatting(
	value,
	locale,
	localeOptions,
	separator,
	pad,
	round,
	roundingFunc,
) {
	let result = value;

	// When padding alongside a locale, let the locale formatter emit the fixed
	// number of fraction digits. The manual string padding below cannot tell a
	// locale-inserted grouping separator from the decimal separator, so it
	// dropped digits (e.g. "1,234,500" became "1,234").
	const localePad =
		pad && round > 0 ? { minimumFractionDigits: round, maximumFractionDigits: round } : undefined;

	// Apply locale formatting
	if (locale === true) {
		result = result.toLocaleString(undefined, localePad);
	} else if (locale.length > 0) {
		result = result.toLocaleString(locale, { ...localeOptions, ...localePad });
	} else if (separator.length > 0) {
		// Round before separator replacement to ensure excess decimal places
		// are truncated when pad is also set (fixes padding + separator bug).
		if (pad && round > 0) {
			const p = Math.pow(10, round);
			result = roundingFunc(result * p) / p;
		}
		result = result.toString().replace(PERIOD, separator);
	}

	// Apply padding for the non-locale paths, where the string has a single
	// decimal separator and no grouping is inserted.
	if (pad && round > 0 && locale !== true && locale.length === 0) {
		const resultStr = result.toString();
		const x = separator || PERIOD;
		const tmp = resultStr.split(x);
		const s = tmp[1] || EMPTY;

		result = `${tmp[0]}${x}${s.padEnd(round, ZERO)}`;
	}

	return result;
}

/**
 * Calculates exponent from the input value using pre-computed log values and clamps to supported range
 * Also adjusts precision when exponent exceeds the lookup table bounds
 * @param {number} num - Input file size in bytes
 * @param {number} e - Current exponent value
 * @param {number} exponent - Original user-provided exponent option (-1 for auto)
 * @param {boolean} isDecimal - Whether to use decimal (SI) base
 * @param {number} precision - Current precision value (modified when e > 8)
 * @returns {Object} Object with computed e value and possibly adjusted precision
 */
function calculateExponent(num, e, exponent, isDecimal, precision) {
	if (e === -1 || isNaN(e)) {
		if (isDecimal) {
			e = Math.floor(Math.log(num) / LOG_10_1000);
		} else {
			e = Math.floor(Math.log(num) / LOG_2_1024);
		}
		if (e < 0) {
			e = 0;
		}
	} else if (e < 0) {
		// A forced exponent below the auto sentinel (-1) has no meaning and
		// would otherwise index the power-of-ten/two lookup tables out of
		// bounds (producing NaN). Clamp to 0, mirroring the e > 8 clamp below.
		e = 0;
	}

	if (e > 8) {
		if (precision > 0) {
			precision += 8 - e;
		}
		return { e: 8, precision };
	}

	return { e, precision };
}

/**
 * Applies rounding to the raw calculated value and handles auto-increment ceiling
 * @param {number} val - Raw value before rounding
 * @param {number} ceil - Ceiling threshold (1000 for SI, 1024 for IEC)
 * @param {number} e - Current exponent value
 * @param {number} round - Number of decimal places
 * @param {Function} roundingFunc - Rounding method (Math.round, Math.floor, Math.ceil)
 * @param {boolean} autoExponent - Whether exponent is auto-calculated (-1 or NaN)
 * @returns {Object} Object with rounded value and possibly incremented exponent
 */
function applyRounding(val, ceil, e, round, roundingFunc, autoExponent) {
	let p;
	if (e > 0 && round > 0) {
		p = Math.pow(10, round);
	} else {
		p = 1;
	}
	let r;
	if (p === 1) {
		r = roundingFunc(val);
	} else {
		r = roundingFunc(val * p) / p;
	}

	if (r === ceil && e < 8 && autoExponent) {
		r = 1;
		e++;
	}

	return { value: r, e };
}

/**
 * Resolves the unit symbol for the given standard, bits mode, and exponent
 * Handles SI standard special case where exponent 1 always uses "kB" or "kbit"
 * @param {string} actualStandard - The resolved standard (iec, jedec)
 * @param {boolean} bits - Whether formatting bit values
 * @param {number} e - Current exponent index
 * @param {boolean} isDecimal - Whether using decimal (SI) base
 * @returns {string} The resolved unit symbol string
 */
function resolveSymbol(actualStandard, bits, e, isDecimal) {
	const symbolTable = STRINGS.symbol[actualStandard][bits ? BITS : BYTES];
	let result;
	if (isDecimal && e === 1) {
		if (bits) {
			result = SI_KBIT;
		} else {
			result = SI_KBYTE;
		}
	} else {
		result = symbolTable[e];
	}
	return result;
}

/**
 * Decorates the result: applies negation, custom symbols, number formatting, and full form names
 * Mutates the result array in-place for both value (index 0) and symbol (index 1)
 * @param {Array} result - Result array with numeric value at [0] and string symbol at [1]
 * @param {boolean} neg - Whether the original input was negative
 * @param {Object} symbols - Custom symbol override map
 * @param {string|boolean} locale - Locale string for formatting
 * @param {Object} localeOptions - Additional locale formatting options
 * @param {string} separator - Custom decimal separator
 * @param {boolean} pad - Whether zero-pad decimals
 * @param {number} round - Target decimal count for padding
 * @param {boolean} full - Whether to use full unit names
 * @param {Array} fullforms - Custom full unit name overrides
 * @param {string} actualStandard - Unit standard for full form lookup
 * @param {number} e - Current exponent index
 * @param {boolean} bits - Whether formatting bit values
 * @returns {void} Mutates result array in place
 */
function decorateResult(
	result,
	neg,
	symbols,
	locale,
	localeOptions,
	separator,
	pad,
	round,
	full,
	fullforms,
	actualStandard,
	e,
	bits,
	roundingFunc,
) {
	if (neg) {
		result[0] = -result[0];
	}

	if (symbols[result[1]]) {
		result[1] = symbols[result[1]];
	}

	// Capture the numeric value before formatting; a comma decimal separator
	// (via separator or a locale such as de-DE) would otherwise make parseFloat
	// read "1,5" as 1 and select the singular unit name.
	let numericValue;
	if (typeof result[0] === "string") {
		numericValue = parseFloat(result[0]);
	} else {
		numericValue = result[0];
	}

	result[0] = applyNumberFormatting(
		result[0],
		locale,
		localeOptions,
		separator,
		pad,
		round,
		roundingFunc,
	);

	if (full) {
		let unit;
		if (bits) {
			unit = BIT;
		} else {
			unit = BYTE;
		}
		// Determine singular/plural suffix
		let suffix;
		if (numericValue === 1) {
			suffix = EMPTY;
		} else {
			suffix = filesize_S;
		}
		// Determine symbol — custom fullforms are the complete name, defaults get unit+suffix
		if (fullforms[e]) {
			result[1] = fullforms[e];
		} else {
			result[1] = STRINGS.fullform[actualStandard][e] + unit + suffix;
		}
	}
}

/**
 * Formats the computed result array into the requested output type
 * @param {Array} result - Result array with formatted value at [0] and symbol at [1]
 * @param {number} e - Current exponent
 * @param {string} u - Original resolved symbol (before custom override)
 * @param {string} output - Output type (ARRAY, OBJECT, STRING)
 * @param {string} spacer - String separator between value and unit
 * @returns {string|Array|Object|number} Formatted result in requested type
 */
function formatOutput(result, e, u, output, spacer) {
	if (output === ARRAY) {
		return result;
	}

	if (output === OBJECT) {
		return {
			value: result[0],
			symbol: result[1],
			exponent: e,
			unit: u,
		};
	}

	let formatted;
	if (spacer === SPACE) {
		formatted = `${result[0]} ${result[1]}`;
	} else {
		formatted = result.join(spacer);
	}
	return formatted;
}/**
 * Converts a file size in bytes to a human-readable string with appropriate units
 * @param {number|string|bigint} arg - The file size in bytes to convert
 * @param {Object} [options={}] - Configuration options for formatting
 * @param {boolean} [options.bits=false] - If true, calculates bits instead of bytes
 * @param {boolean} [options.pad=false] - If true, pads decimal places to match round parameter
 * @param {number} [options.base=-1] - Number base (2 for binary, 10 for decimal, -1 for auto)
 * @param {number} [options.round=2] - Number of decimal places to round to
 * @param {string|boolean} [options.locale=""] - Locale for number formatting, true for system locale
 * @param {Object} [options.localeOptions={}] - Additional options for locale formatting
 * @param {string} [options.separator=""] - Custom decimal separator
 * @param {string} [options.spacer=" "] - String to separate value and unit
 * @param {Object} [options.symbols={}] - Custom unit symbols
 * @param {string} [options.standard=""] - Unit standard to use (SI, IEC, JEDEC)
 * @param {string} [options.output="string"] - Output format: "string", "array", "object", or "exponent"
 * @param {boolean} [options.fullform=false] - If true, uses full unit names instead of abbreviations
 * @param {Array} [options.fullforms=[]] - Custom full unit names
 * @param {number} [options.exponent=-1] - Force specific exponent (-1 for auto)
 * @param {string} [options.roundingMethod="round"] - Math rounding method to use
 * @param {number} [options.precision=0] - Number of significant digits (0 for auto)
 * @returns {string|Array|Object|number} Formatted file size based on output option
 * @throws {TypeError} When arg is not a valid number or roundingMethod is invalid
 * @example
 * filesize(1024) // "1.02 kB"
 * filesize(1024, {bits: true}) // "8.19 kbit"
 * filesize(1024, {output: "object"}) // {value: 1.02, symbol: "kB", exponent: 1, unit: "kB"}
 */
function filesize(
	arg,
	{
		bits = false,
		pad = false,
		base = -1,
		round = 2,
		locale = EMPTY,
		localeOptions = {},
		separator = EMPTY,
		spacer = SPACE,
		symbols = {},
		standard = EMPTY,
		output = STRING,
		fullform = false,
		fullforms = [],
		exponent = -1,
		roundingMethod = ROUND,
		precision = 0,
	} = {},
) {
	let e = exponent,
		num,
		result = [],
		val = 0,
		u = EMPTY;

	if (typeof arg === "bigint") {
		num = Number(arg);
	} else {
		num = Number(arg);

		if (isNaN(num)) {
			throw new TypeError(INVALID_NUMBER);
		}

		if (!isFinite(num)) {
			throw new TypeError(INVALID_NUMBER);
		}
	}

	const { isDecimal, ceil, actualStandard } = getBaseConfiguration(standard, base);

	const full = fullform === true,
		neg = num < 0,
		roundingFunc = Math[roundingMethod];

	if (typeof roundingFunc !== FUNCTION) {
		throw new TypeError(INVALID_ROUND);
	}

	if (neg) {
		num = -num;
	}

	if (num === 0) {
		return handleZeroValue(
			precision,
			actualStandard,
			bits,
			symbols,
			full,
			fullforms,
			output,
			spacer,
			pad,
			round,
		);
	}

	// Exponent calculation + clamp + precision adjustment
	const { e: calculatedE, precision: precisionAdjusted } = calculateExponent(
		num,
		e,
		exponent,
		isDecimal,
		precision,
	);
	e = calculatedE;
	const autoExponent = exponent === -1 || isNaN(exponent);

	const { result: valueResult, e: valueExponent } = calculateOptimizedValue(
		num,
		e,
		isDecimal,
		bits,
		ceil,
		autoExponent,
	);
	val = valueResult;
	e = valueExponent;

	// Rounding + auto-increment ceiling
	const rounded = applyRounding(val, ceil, e, round, roundingFunc, autoExponent);
	result[0] = rounded.value;
	e = rounded.e;

	// Precision handling
	if (precisionAdjusted > 0) {
		const precisionResult = applyPrecisionHandling(
			result[0],
			precisionAdjusted,
			e,
			num,
			isDecimal,
			bits,
			ceil,
			roundingFunc,
			round,
			exponent,
		);
		result[0] = precisionResult.value;
		e = precisionResult.e;
	}

	// Return the exponent only after every adjustment that other output
	// modes apply (bits auto-increment, rounding overflow, precision), so
	// it always matches the exponent reported by object output.
	if (output === EXPONENT) {
		return e;
	}

	u = resolveSymbol(actualStandard, bits, e, isDecimal);
	result[1] = u;

	decorateResult(
		result,
		neg,
		symbols,
		locale,
		localeOptions,
		separator,
		pad,
		round,
		full,
		fullforms,
		actualStandard,
		e,
		bits,
		roundingFunc,
	);

	return formatOutput(result, e, u, output, spacer);
}

/**
 * Creates a partially applied version of filesize with preset options
 * @param {Object} [options={}] - Configuration options (same as filesize)
 * @param {boolean} [options.bits=false] - If true, calculates bits instead of bytes
 * @param {boolean} [options.pad=false] - If true, pads decimal places to match round parameter
 * @param {number} [options.base=-1] - Number base (2 for binary, 10 for decimal, -1 for auto)
 * @param {number} [options.round=2] - Number of decimal places to round to
 * @param {string|boolean} [options.locale=""] - Locale for number formatting, true for system locale
 * @param {Object} [options.localeOptions={}] - Additional options for locale formatting
 * @param {string} [options.separator=""] - Custom decimal separator
 * @param {string} [options.spacer=" "] - String to separate value and unit
 * @param {Object} [options.symbols={}] - Custom unit symbols
 * @param {string} [options.standard=""] - Unit standard to use (SI, IEC, JEDEC)
 * @param {string} [options.output="string"] - Output format: "string", "array", "object", or "exponent"
 * @param {boolean} [options.fullform=false] - If true, uses full unit names instead of abbreviations
 * @param {Array} [options.fullforms=[]] - Custom full unit names
 * @param {number} [options.exponent=-1] - Force specific exponent (-1 for auto)
 * @param {string} [options.roundingMethod="round"] - Math rounding method to use
 * @param {number} [options.precision=0] - Number of significant digits (0 for auto)
 * @returns {Function} A function that takes a file size and returns formatted output
 * @example
 * const formatBytes = partial({round: 1, standard: "iec"});
 * formatBytes(1024) // "1 KiB"
 * formatBytes(2048) // "2 KiB"
 * formatBytes(1536) // "1.5 KiB"
 */
function partial({
	bits = false,
	pad = false,
	base = -1,
	round = 2,
	locale = EMPTY,
	separator = EMPTY,
	spacer = SPACE,
	standard = EMPTY,
	output = STRING,
	fullform = false,
	exponent = -1,
	roundingMethod = ROUND,
	precision = 0,
	localeOptions = {},
	symbols = {},
	fullforms = [],
} = {}) {
	/**
	 * Safely clone an object using structuredClone with JSON fallback.
	 * structuredClone can throw for functions, circular refs, etc.
	 */
	function safeClone(value) {
		try {
			return typeof structuredClone === "function"
				? structuredClone(value)
				: JSON.parse(JSON.stringify(value));
		} catch {
			return JSON.parse(JSON.stringify(value));
		}
	}

	const cloned = {
		localeOptions: safeClone(localeOptions),
		symbols: safeClone(symbols),
		fullforms: safeClone(fullforms),
	};

	return (arg) =>
		filesize(arg, {
			bits,
			pad,
			base,
			round,
			locale,
			localeOptions: cloned.localeOptions,
			separator,
			spacer,
			symbols: cloned.symbols,
			standard,
			output,
			fullform,
			fullforms: cloned.fullforms,
			exponent,
			roundingMethod,
			precision,
		});
}

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/css-tag.js
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const css_tag_t=globalThis,css_tag_e=css_tag_t.ShadowRoot&&(void 0===css_tag_t.ShadyCSS||css_tag_t.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,css_tag_s=Symbol(),css_tag_o=new WeakMap;class css_tag_n{constructor(t,e,o){if(this._$cssResult$=!0,o!==css_tag_s)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e}get styleSheet(){let t=this.o;const s=this.t;if(css_tag_e&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=css_tag_o.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&css_tag_o.set(s,t))}return t}toString(){return this.cssText}}const css_tag_r=t=>new css_tag_n("string"==typeof t?t:t+"",void 0,css_tag_s),css_tag_i=(t,...e)=>{const o=1===t.length?t[0]:e.reduce((e,s,o)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+t[o+1],t[0]);return new css_tag_n(o,t,css_tag_s)},css_tag_S=(s,o)=>{if(css_tag_e)s.adoptedStyleSheets=o.map(t=>t instanceof CSSStyleSheet?t:t.styleSheet);else for(const e of o){const o=document.createElement("style"),n=css_tag_t.litNonce;void 0!==n&&o.setAttribute("nonce",n),o.textContent=e.cssText,s.appendChild(o)}},css_tag_c=css_tag_e?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return css_tag_r(e)})(t):t;
//# sourceMappingURL=css-tag.js.map

;// CONCATENATED MODULE: ./node_modules/@lit/reactive-element/reactive-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{is:reactive_element_i,defineProperty:reactive_element_e,getOwnPropertyDescriptor:reactive_element_h,getOwnPropertyNames:reactive_element_r,getOwnPropertySymbols:reactive_element_o,getPrototypeOf:reactive_element_n}=Object,reactive_element_a=globalThis,reactive_element_c=reactive_element_a.trustedTypes,reactive_element_l=reactive_element_c?reactive_element_c.emptyScript:"",reactive_element_p=reactive_element_a.reactiveElementPolyfillSupport,reactive_element_d=(t,s)=>t,reactive_element_u={toAttribute(t,s){switch(s){case Boolean:t=t?reactive_element_l:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t)}return t},fromAttribute(t,s){let i=t;switch(s){case Boolean:i=null!==t;break;case Number:i=null===t?null:Number(t);break;case Object:case Array:try{i=JSON.parse(t)}catch(t){i=null}}return i}},reactive_element_f=(t,s)=>!reactive_element_i(t,s),reactive_element_b={attribute:!0,type:String,converter:reactive_element_u,reflect:!1,useDefault:!1,hasChanged:reactive_element_f};Symbol.metadata??=Symbol("metadata"),reactive_element_a.litPropertyMetadata??=new WeakMap;class reactive_element_y extends HTMLElement{static addInitializer(t){this._$Ei(),(this.l??=[]).push(t)}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,s=reactive_element_b){if(s.state&&(s.attribute=!1),this._$Ei(),this.prototype.hasOwnProperty(t)&&((s=Object.create(s)).wrapped=!0),this.elementProperties.set(t,s),!s.noAccessor){const i=Symbol(),h=this.getPropertyDescriptor(t,i,s);void 0!==h&&reactive_element_e(this.prototype,t,h)}}static getPropertyDescriptor(t,s,i){const{get:e,set:r}=reactive_element_h(this.prototype,t)??{get(){return this[s]},set(t){this[s]=t}};return{get:e,set(s){const h=e?.call(this);r?.call(this,s),this.requestUpdate(t,h,i)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)??reactive_element_b}static _$Ei(){if(this.hasOwnProperty(reactive_element_d("elementProperties")))return;const t=reactive_element_n(this);t.finalize(),void 0!==t.l&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties)}static finalize(){if(this.hasOwnProperty(reactive_element_d("finalized")))return;if(this.finalized=!0,this._$Ei(),this.hasOwnProperty(reactive_element_d("properties"))){const t=this.properties,s=[...reactive_element_r(t),...reactive_element_o(t)];for(const i of s)this.createProperty(i,t[i])}const t=this[Symbol.metadata];if(null!==t){const s=litPropertyMetadata.get(t);if(void 0!==s)for(const[t,i]of s)this.elementProperties.set(t,i)}this._$Eh=new Map;for(const[t,s]of this.elementProperties){const i=this._$Eu(t,s);void 0!==i&&this._$Eh.set(i,t)}this.elementStyles=this.finalizeStyles(this.styles)}static finalizeStyles(s){const i=[];if(Array.isArray(s)){const e=new Set(s.flat(1/0).reverse());for(const s of e)i.unshift(css_tag_c(s))}else void 0!==s&&i.push(css_tag_c(s));return i}static _$Eu(t,s){const i=s.attribute;return!1===i?void 0:"string"==typeof i?i:"string"==typeof t?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Em=null,this._$Ev()}_$Ev(){this._$ES=new Promise(t=>this.enableUpdating=t),this._$AL=new Map,this._$E_(),this.requestUpdate(),this.constructor.l?.forEach(t=>t(this))}addController(t){(this._$EO??=new Set).add(t),void 0!==this.renderRoot&&this.isConnected&&t.hostConnected?.()}removeController(t){this._$EO?.delete(t)}_$E_(){const t=new Map,s=this.constructor.elementProperties;for(const i of s.keys())this.hasOwnProperty(i)&&(t.set(i,this[i]),delete this[i]);t.size>0&&(this._$Ep=t)}createRenderRoot(){const t=this.shadowRoot??this.attachShadow(this.constructor.shadowRootOptions);return css_tag_S(t,this.constructor.elementStyles),t}connectedCallback(){this.renderRoot??=this.createRenderRoot(),this.enableUpdating(!0),this._$EO?.forEach(t=>t.hostConnected?.())}enableUpdating(t){}disconnectedCallback(){this._$EO?.forEach(t=>t.hostDisconnected?.())}attributeChangedCallback(t,s,i){this._$AK(t,i)}_$ET(t,s){const i=this.constructor.elementProperties.get(t),e=this.constructor._$Eu(t,i);if(void 0!==e&&!0===i.reflect){const h=(void 0!==i.converter?.toAttribute?i.converter:reactive_element_u).toAttribute(s,i.type);this._$Em=t,null==h?this.removeAttribute(e):this.setAttribute(e,h),this._$Em=null}}_$AK(t,s){const i=this.constructor,e=i._$Eh.get(t);if(void 0!==e&&this._$Em!==e){const t=i.getPropertyOptions(e),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==t.converter?.fromAttribute?t.converter:reactive_element_u;this._$Em=e;const r=h.fromAttribute(s,t.type);this[e]=r??this._$Ej?.get(e)??r,this._$Em=null}}requestUpdate(t,s,i,e=!1,h){if(void 0!==t){const r=this.constructor;if(!1===e&&(h=this[t]),i??=r.getPropertyOptions(t),!((i.hasChanged??reactive_element_f)(h,s)||i.useDefault&&i.reflect&&h===this._$Ej?.get(t)&&!this.hasAttribute(r._$Eu(t,i))))return;this.C(t,s,i)}!1===this.isUpdatePending&&(this._$ES=this._$EP())}C(t,s,{useDefault:i,reflect:e,wrapped:h},r){i&&!(this._$Ej??=new Map).has(t)&&(this._$Ej.set(t,r??s??this[t]),!0!==h||void 0!==r)||(this._$AL.has(t)||(this.hasUpdated||i||(s=void 0),this._$AL.set(t,s)),!0===e&&this._$Em!==t&&(this._$Eq??=new Set).add(t))}async _$EP(){this.isUpdatePending=!0;try{await this._$ES}catch(t){Promise.reject(t)}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){if(!this.isUpdatePending)return;if(!this.hasUpdated){if(this.renderRoot??=this.createRenderRoot(),this._$Ep){for(const[t,s]of this._$Ep)this[t]=s;this._$Ep=void 0}const t=this.constructor.elementProperties;if(t.size>0)for(const[s,i]of t){const{wrapped:t}=i,e=this[s];!0!==t||this._$AL.has(s)||void 0===e||this.C(s,void 0,i,e)}}let t=!1;const s=this._$AL;try{t=this.shouldUpdate(s),t?(this.willUpdate(s),this._$EO?.forEach(t=>t.hostUpdate?.()),this.update(s)):this._$EM()}catch(s){throw t=!1,this._$EM(),s}t&&this._$AE(s)}willUpdate(t){}_$AE(t){this._$EO?.forEach(t=>t.hostUpdated?.()),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$EM(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return!0}update(t){this._$Eq&&=this._$Eq.forEach(t=>this._$ET(t,this[t])),this._$EM()}updated(t){}firstUpdated(t){}}reactive_element_y.elementStyles=[],reactive_element_y.shadowRootOptions={mode:"open"},reactive_element_y[reactive_element_d("elementProperties")]=new Map,reactive_element_y[reactive_element_d("finalized")]=new Map,reactive_element_p?.({ReactiveElement:reactive_element_y}),(reactive_element_a.reactiveElementVersions??=[]).push("2.1.2");
//# sourceMappingURL=reactive-element.js.map

;// CONCATENATED MODULE: ./node_modules/lit-html/lit-html.js
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const lit_html_t=globalThis,lit_html_i=t=>t,lit_html_s=lit_html_t.trustedTypes,lit_html_e=lit_html_s?lit_html_s.createPolicy("lit-html",{createHTML:t=>t}):void 0,lit_html_h="$lit$",lit_html_o=`lit$${Math.random().toFixed(9).slice(2)}$`,lit_html_n="?"+lit_html_o,lit_html_r=`<${lit_html_n}>`,lit_html_l=document,lit_html_c=()=>lit_html_l.createComment(""),lit_html_a=t=>null===t||"object"!=typeof t&&"function"!=typeof t,lit_html_u=Array.isArray,lit_html_d=t=>lit_html_u(t)||"function"==typeof t?.[Symbol.iterator],lit_html_f="[ \t\n\f\r]",lit_html_v=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,lit_html_=/-->/g,lit_html_m=/>/g,lit_html_p=RegExp(`>|${lit_html_f}(?:([^\\s"'>=/]+)(${lit_html_f}*=${lit_html_f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),lit_html_g=/'/g,$=/"/g,lit_html_y=/^(?:script|style|textarea|title)$/i,lit_html_x=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),lit_html_b=lit_html_x(1),w=(/* unused pure expression or super */ null && (lit_html_x(2))),T=(/* unused pure expression or super */ null && (lit_html_x(3))),lit_html_E=Symbol.for("lit-noChange"),A=Symbol.for("lit-nothing"),C=new WeakMap,lit_html_P=lit_html_l.createTreeWalker(lit_html_l,129);function V(t,i){if(!lit_html_u(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==lit_html_e?lit_html_e.createHTML(i):i}const N=(t,i)=>{const s=t.length-1,e=[];let n,l=2===i?"<svg>":3===i?"<math>":"",c=lit_html_v;for(let i=0;i<s;i++){const s=t[i];let a,u,d=-1,f=0;for(;f<s.length&&(c.lastIndex=f,u=c.exec(s),null!==u);)f=c.lastIndex,c===lit_html_v?"!--"===u[1]?c=lit_html_:void 0!==u[1]?c=lit_html_m:void 0!==u[2]?(lit_html_y.test(u[2])&&(n=RegExp("</"+u[2],"g")),c=lit_html_p):void 0!==u[3]&&(c=lit_html_p):c===lit_html_p?">"===u[0]?(c=n??lit_html_v,d=-1):void 0===u[1]?d=-2:(d=c.lastIndex-u[2].length,a=u[1],c=void 0===u[3]?lit_html_p:'"'===u[3]?$:lit_html_g):c===$||c===lit_html_g?c=lit_html_p:c===lit_html_||c===lit_html_m?c=lit_html_v:(c=lit_html_p,n=void 0);const x=c===lit_html_p&&t[i+1].startsWith("/>")?" ":"";l+=c===lit_html_v?s+lit_html_r:d>=0?(e.push(a),s.slice(0,d)+lit_html_h+s.slice(d)+lit_html_o+x):s+lit_html_o+(-2===d?i:x)}return[V(t,l+(t[s]||"<?>")+(2===i?"</svg>":3===i?"</math>":"")),e]};class lit_html_S{constructor({strings:t,_$litType$:i},e){let r;this.parts=[];let l=0,a=0;const u=t.length-1,d=this.parts,[f,v]=N(t,i);if(this.el=lit_html_S.createElement(f,e),lit_html_P.currentNode=this.el.content,2===i||3===i){const t=this.el.content.firstChild;t.replaceWith(...t.childNodes)}for(;null!==(r=lit_html_P.nextNode())&&d.length<u;){if(1===r.nodeType){if(r.hasAttributes())for(const t of r.getAttributeNames())if(t.endsWith(lit_html_h)){const i=v[a++],s=r.getAttribute(t).split(lit_html_o),e=/([.?@])?(.*)/.exec(i);d.push({type:1,index:l,name:e[2],strings:s,ctor:"."===e[1]?I:"?"===e[1]?lit_html_L:"@"===e[1]?z:H}),r.removeAttribute(t)}else t.startsWith(lit_html_o)&&(d.push({type:6,index:l}),r.removeAttribute(t));if(lit_html_y.test(r.tagName)){const t=r.textContent.split(lit_html_o),i=t.length-1;if(i>0){r.textContent=lit_html_s?lit_html_s.emptyScript:"";for(let s=0;s<i;s++)r.append(t[s],lit_html_c()),lit_html_P.nextNode(),d.push({type:2,index:++l});r.append(t[i],lit_html_c())}}}else if(8===r.nodeType)if(r.data===lit_html_n)d.push({type:2,index:l});else{let t=-1;for(;-1!==(t=r.data.indexOf(lit_html_o,t+1));)d.push({type:7,index:l}),t+=lit_html_o.length-1}l++}}static createElement(t,i){const s=lit_html_l.createElement("template");return s.innerHTML=t,s}}function M(t,i,s=t,e){if(i===lit_html_E)return i;let h=void 0!==e?s._$Co?.[e]:s._$Cl;const o=lit_html_a(i)?void 0:i._$litDirective$;return h?.constructor!==o&&(h?._$AO?.(!1),void 0===o?h=void 0:(h=new o(t),h._$AT(t,s,e)),void 0!==e?(s._$Co??=[])[e]=h:s._$Cl=h),void 0!==h&&(i=M(t,h._$AS(t,i.values),h,e)),i}class R{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){const{el:{content:i},parts:s}=this._$AD,e=(t?.creationScope??lit_html_l).importNode(i,!0);lit_html_P.currentNode=e;let h=lit_html_P.nextNode(),o=0,n=0,r=s[0];for(;void 0!==r;){if(o===r.index){let i;2===r.type?i=new lit_html_k(h,h.nextSibling,this,t):1===r.type?i=new r.ctor(h,r.name,r.strings,this,t):6===r.type&&(i=new Z(h,this,t)),this._$AV.push(i),r=s[++n]}o!==r?.index&&(h=lit_html_P.nextNode(),o++)}return lit_html_P.currentNode=lit_html_l,e}p(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++}}class lit_html_k{get _$AU(){return this._$AM?._$AU??this._$Cv}constructor(t,i,s,e){this.type=2,this._$AH=A,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cv=e?.isConnected??!0}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t?.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=M(this,t,i),lit_html_a(t)?t===A||null==t||""===t?(this._$AH!==A&&this._$AR(),this._$AH=A):t!==this._$AH&&t!==lit_html_E&&this._(t):void 0!==t._$litType$?this.$(t):void 0!==t.nodeType?this.T(t):lit_html_d(t)?this.k(t):this._(t)}O(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.O(t))}_(t){this._$AH!==A&&lit_html_a(this._$AH)?this._$AA.nextSibling.data=t:this.T(lit_html_l.createTextNode(t)),this._$AH=t}$(t){const{values:i,_$litType$:s}=t,e="number"==typeof s?this._$AC(t):(void 0===s.el&&(s.el=lit_html_S.createElement(V(s.h,s.h[0]),this.options)),s);if(this._$AH?._$AD===e)this._$AH.p(i);else{const t=new R(e,this),s=t.u(this.options);t.p(i),this.T(s),this._$AH=t}}_$AC(t){let i=C.get(t.strings);return void 0===i&&C.set(t.strings,i=new lit_html_S(t)),i}k(t){lit_html_u(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const h of t)e===i.length?i.push(s=new lit_html_k(this.O(lit_html_c()),this.O(lit_html_c()),this,this.options)):s=i[e],s._$AI(h),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e)}_$AR(t=this._$AA.nextSibling,s){for(this._$AP?.(!1,!0,s);t!==this._$AB;){const s=lit_html_i(t).nextSibling;lit_html_i(t).remove(),t=s}}setConnected(t){void 0===this._$AM&&(this._$Cv=t,this._$AP?.(t))}}class H{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,i,s,e,h){this.type=1,this._$AH=A,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=h,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A}_$AI(t,i=this,s,e){const h=this.strings;let o=!1;if(void 0===h)t=M(this,t,i,0),o=!lit_html_a(t)||t!==this._$AH&&t!==lit_html_E,o&&(this._$AH=t);else{const e=t;let n,r;for(t=h[0],n=0;n<h.length-1;n++)r=M(this,e[s+n],i,n),r===lit_html_E&&(r=this._$AH[n]),o||=!lit_html_a(r)||r!==this._$AH[n],r===A?t=A:t!==A&&(t+=(r??"")+h[n+1]),this._$AH[n]=r}o&&!e&&this.j(t)}j(t){t===A?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t??"")}}class I extends H{constructor(){super(...arguments),this.type=3}j(t){this.element[this.name]=t===A?void 0:t}}class lit_html_L extends H{constructor(){super(...arguments),this.type=4}j(t){this.element.toggleAttribute(this.name,!!t&&t!==A)}}class z extends H{constructor(t,i,s,e,h){super(t,i,s,e,h),this.type=5}_$AI(t,i=this){if((t=M(this,t,i,0)??A)===lit_html_E)return;const s=this._$AH,e=t===A&&s!==A||t.capture!==s.capture||t.once!==s.once||t.passive!==s.passive,h=t!==A&&(s===A||e);e&&this.element.removeEventListener(this.name,this,s),h&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){"function"==typeof this._$AH?this._$AH.call(this.options?.host??this.element,t):this._$AH.handleEvent(t)}}class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s}get _$AU(){return this._$AM._$AU}_$AI(t){M(this,t)}}const lit_html_j=(/* unused pure expression or super */ null && ({M:lit_html_h,P:lit_html_o,A:lit_html_n,C:1,L:N,R,D:lit_html_d,V:M,I:lit_html_k,H,N:lit_html_L,U:z,B:I,F:Z})),B=lit_html_t.litHtmlPolyfillSupport;B?.(lit_html_S,lit_html_k),(lit_html_t.litHtmlVersions??=[]).push("3.3.3");const D=(t,i,s)=>{const e=s?.renderBefore??i;let h=e._$litPart$;if(void 0===h){const t=s?.renderBefore??null;e._$litPart$=h=new lit_html_k(i.insertBefore(lit_html_c(),t),t,void 0,s??{})}return h._$AI(t),h};
//# sourceMappingURL=lit-html.js.map

;// CONCATENATED MODULE: ./node_modules/lit-element/lit-element.js

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const lit_element_s=globalThis;class lit_element_i extends reactive_element_y{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0}createRenderRoot(){const t=super.createRenderRoot();return this.renderOptions.renderBefore??=t.firstChild,t}update(t){const r=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=D(r,this.renderRoot,this.renderOptions)}connectedCallback(){super.connectedCallback(),this._$Do?.setConnected(!0)}disconnectedCallback(){super.disconnectedCallback(),this._$Do?.setConnected(!1)}render(){return lit_html_E}}lit_element_i._$litElement$=!0,lit_element_i["finalized"]=!0,lit_element_s.litElementHydrateSupport?.({LitElement:lit_element_i});const lit_element_o=lit_element_s.litElementPolyfillSupport;lit_element_o?.({LitElement:lit_element_i});const lit_element_n=(/* unused pure expression or super */ null && ({_$AK:(t,e,r)=>{t._$AK(e,r)},_$AL:t=>t._$AL}));(lit_element_s.litElementVersions??=[]).push("4.2.2");
//# sourceMappingURL=lit-element.js.map

;// CONCATENATED MODULE: ./node_modules/lit/index.js

//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./src/headless/shared/connection/feedback.js




class Feedback extends skeletor_esm_Model {
    defaults() {
        return {
            'connection_status': Strophe.Status.DISCONNECTED,
            'message': '',
        };
    }

    initialize() {
        super.initialize();
        const { api } = shared_converse;
        this.on('change', () => api.trigger('connfeedback', shared_converse.state.connfeedback));
    }
}

/* export default */ const connection_feedback = (Feedback);

;// CONCATENATED MODULE: ./src/headless/utils/array.js
/**
 * @template {any} T
 * @param {Array<T>} arr
 * @returns {Array<T>} A new array containing only unique elements from the input array.
 */
function array_unique (arr) {
    return [...new Set(arr)];
}

;// CONCATENATED MODULE: ./src/headless/utils/arraybuffer.js
function appendArrayBuffer (buffer1, buffer2) {
    const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(new Uint8Array(buffer1), 0);
    tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return tmp.buffer;
}

function arrayBufferToHex (ab) {
    // https://stackoverflow.com/questions/40031688/javascript-arraybuffer-to-hex#40031979
    return Array.prototype.map.call(new Uint8Array(ab), x => ('00' + x.toString(16)).slice(-2)).join('');
}

function arrayBufferToString (ab) {
    return new TextDecoder("utf-8").decode(ab);
}

function stringToArrayBuffer (string) {
    const bytes = new TextEncoder().encode(string);
    return bytes.buffer;
}

function arrayBufferToBase64 (ab) {
    return btoa((new Uint8Array(ab)).reduce((data, byte) => data + String.fromCharCode(byte), ''));
}

function base64ToArrayBuffer (b64) {
    const binary_string = atob(b64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i)
    }
    return bytes.buffer
}

function hexToArrayBuffer (hex) {
    const typedArray = new Uint8Array(hex.match(/[\da-f]{2}/gi).map(h => parseInt(h, 16)))
    return typedArray.buffer
}

;// CONCATENATED MODULE: ./node_modules/hsluv/dist/hsluv.mjs
class Hsluv {
    constructor() {
        // RGB
        this.hex = '#000000';
        this.rgb_r = 0;
        this.rgb_g = 0;
        this.rgb_b = 0;
        // CIE XYZ
        this.xyz_x = 0;
        this.xyz_y = 0;
        this.xyz_z = 0;
        // CIE LUV
        this.luv_l = 0;
        this.luv_u = 0;
        this.luv_v = 0;
        // CIE LUV LCh
        this.lch_l = 0;
        this.lch_c = 0;
        this.lch_h = 0;
        // HSLuv
        this.hsluv_h = 0;
        this.hsluv_s = 0;
        this.hsluv_l = 0;
        // HPLuv
        this.hpluv_h = 0;
        this.hpluv_p = 0;
        this.hpluv_l = 0;
        // 6 lines in slope-intercept format: R < 0, R > 1, G < 0, G > 1, B < 0, B > 1
        this.r0s = 0;
        this.r0i = 0;
        this.r1s = 0;
        this.r1i = 0;
        this.g0s = 0;
        this.g0i = 0;
        this.g1s = 0;
        this.g1i = 0;
        this.b0s = 0;
        this.b0i = 0;
        this.b1s = 0;
        this.b1i = 0;
    }
    static fromLinear(c) {
        if (c <= 0.0031308) {
            return 12.92 * c;
        }
        else {
            return 1.055 * Math.pow(c, 1 / 2.4) - 0.055;
        }
    }
    static toLinear(c) {
        if (c > 0.04045) {
            return Math.pow((c + 0.055) / 1.055, 2.4);
        }
        else {
            return c / 12.92;
        }
    }
    static yToL(Y) {
        if (Y <= Hsluv.epsilon) {
            return Y / Hsluv.refY * Hsluv.kappa;
        }
        else {
            return 116 * Math.pow(Y / Hsluv.refY, 1 / 3) - 16;
        }
    }
    static lToY(L) {
        if (L <= 8) {
            return Hsluv.refY * L / Hsluv.kappa;
        }
        else {
            return Hsluv.refY * Math.pow((L + 16) / 116, 3);
        }
    }
    static rgbChannelToHex(chan) {
        const c = Math.round(chan * 255);
        const digit2 = c % 16;
        const digit1 = (c - digit2) / 16 | 0;
        return Hsluv.hexChars.charAt(digit1) + Hsluv.hexChars.charAt(digit2);
    }
    static hexToRgbChannel(hex, offset) {
        const digit1 = Hsluv.hexChars.indexOf(hex.charAt(offset));
        const digit2 = Hsluv.hexChars.indexOf(hex.charAt(offset + 1));
        const n = digit1 * 16 + digit2;
        return n / 255.0;
    }
    static distanceFromOriginAngle(slope, intercept, angle) {
        const d = intercept / (Math.sin(angle) - slope * Math.cos(angle));
        if (d < 0) {
            return Infinity;
        }
        else {
            return d;
        }
    }
    static distanceFromOrigin(slope, intercept) {
        return Math.abs(intercept) / Math.sqrt(Math.pow(slope, 2) + 1);
    }
    static min6(f1, f2, f3, f4, f5, f6) {
        return Math.min(f1, Math.min(f2, Math.min(f3, Math.min(f4, Math.min(f5, f6)))));
    }
    rgbToHex() {
        this.hex = "#";
        this.hex += Hsluv.rgbChannelToHex(this.rgb_r);
        this.hex += Hsluv.rgbChannelToHex(this.rgb_g);
        this.hex += Hsluv.rgbChannelToHex(this.rgb_b);
    }
    hexToRgb() {
        this.hex = this.hex.toLowerCase();
        this.rgb_r = Hsluv.hexToRgbChannel(this.hex, 1);
        this.rgb_g = Hsluv.hexToRgbChannel(this.hex, 3);
        this.rgb_b = Hsluv.hexToRgbChannel(this.hex, 5);
    }
    xyzToRgb() {
        this.rgb_r = Hsluv.fromLinear(Hsluv.m_r0 * this.xyz_x + Hsluv.m_r1 * this.xyz_y + Hsluv.m_r2 * this.xyz_z);
        this.rgb_g = Hsluv.fromLinear(Hsluv.m_g0 * this.xyz_x + Hsluv.m_g1 * this.xyz_y + Hsluv.m_g2 * this.xyz_z);
        this.rgb_b = Hsluv.fromLinear(Hsluv.m_b0 * this.xyz_x + Hsluv.m_b1 * this.xyz_y + Hsluv.m_b2 * this.xyz_z);
    }
    rgbToXyz() {
        const lr = Hsluv.toLinear(this.rgb_r);
        const lg = Hsluv.toLinear(this.rgb_g);
        const lb = Hsluv.toLinear(this.rgb_b);
        this.xyz_x = 0.41239079926595 * lr + 0.35758433938387 * lg + 0.18048078840183 * lb;
        this.xyz_y = 0.21263900587151 * lr + 0.71516867876775 * lg + 0.072192315360733 * lb;
        this.xyz_z = 0.019330818715591 * lr + 0.11919477979462 * lg + 0.95053215224966 * lb;
    }
    xyzToLuv() {
        const divider = this.xyz_x + 15 * this.xyz_y + 3 * this.xyz_z;
        let varU = 4 * this.xyz_x;
        let varV = 9 * this.xyz_y;
        if (divider !== 0) {
            varU /= divider;
            varV /= divider;
        }
        else {
            varU = NaN;
            varV = NaN;
        }
        this.luv_l = Hsluv.yToL(this.xyz_y);
        if (this.luv_l === 0) {
            this.luv_u = 0;
            this.luv_v = 0;
        }
        else {
            this.luv_u = 13 * this.luv_l * (varU - Hsluv.refU);
            this.luv_v = 13 * this.luv_l * (varV - Hsluv.refV);
        }
    }
    luvToXyz() {
        if (this.luv_l === 0) {
            this.xyz_x = 0;
            this.xyz_y = 0;
            this.xyz_z = 0;
            return;
        }
        const varU = this.luv_u / (13 * this.luv_l) + Hsluv.refU;
        const varV = this.luv_v / (13 * this.luv_l) + Hsluv.refV;
        this.xyz_y = Hsluv.lToY(this.luv_l);
        this.xyz_x = 0 - 9 * this.xyz_y * varU / ((varU - 4) * varV - varU * varV);
        this.xyz_z = (9 * this.xyz_y - 15 * varV * this.xyz_y - varV * this.xyz_x) / (3 * varV);
    }
    luvToLch() {
        this.lch_l = this.luv_l;
        this.lch_c = Math.sqrt(this.luv_u * this.luv_u + this.luv_v * this.luv_v);
        if (this.lch_c < 0.00000001) {
            this.lch_h = 0;
        }
        else {
            const hrad = Math.atan2(this.luv_v, this.luv_u);
            this.lch_h = hrad * 180.0 / Math.PI;
            if (this.lch_h < 0) {
                this.lch_h = 360 + this.lch_h;
            }
        }
    }
    lchToLuv() {
        const hrad = this.lch_h / 180.0 * Math.PI;
        this.luv_l = this.lch_l;
        this.luv_u = Math.cos(hrad) * this.lch_c;
        this.luv_v = Math.sin(hrad) * this.lch_c;
    }
    calculateBoundingLines(l) {
        const sub1 = Math.pow(l + 16, 3) / 1560896;
        const sub2 = sub1 > Hsluv.epsilon ? sub1 : l / Hsluv.kappa;
        const s1r = sub2 * (284517 * Hsluv.m_r0 - 94839 * Hsluv.m_r2);
        const s2r = sub2 * (838422 * Hsluv.m_r2 + 769860 * Hsluv.m_r1 + 731718 * Hsluv.m_r0);
        const s3r = sub2 * (632260 * Hsluv.m_r2 - 126452 * Hsluv.m_r1);
        const s1g = sub2 * (284517 * Hsluv.m_g0 - 94839 * Hsluv.m_g2);
        const s2g = sub2 * (838422 * Hsluv.m_g2 + 769860 * Hsluv.m_g1 + 731718 * Hsluv.m_g0);
        const s3g = sub2 * (632260 * Hsluv.m_g2 - 126452 * Hsluv.m_g1);
        const s1b = sub2 * (284517 * Hsluv.m_b0 - 94839 * Hsluv.m_b2);
        const s2b = sub2 * (838422 * Hsluv.m_b2 + 769860 * Hsluv.m_b1 + 731718 * Hsluv.m_b0);
        const s3b = sub2 * (632260 * Hsluv.m_b2 - 126452 * Hsluv.m_b1);
        this.r0s = s1r / s3r;
        this.r0i = s2r * l / s3r;
        this.r1s = s1r / (s3r + 126452);
        this.r1i = (s2r - 769860) * l / (s3r + 126452);
        this.g0s = s1g / s3g;
        this.g0i = s2g * l / s3g;
        this.g1s = s1g / (s3g + 126452);
        this.g1i = (s2g - 769860) * l / (s3g + 126452);
        this.b0s = s1b / s3b;
        this.b0i = s2b * l / s3b;
        this.b1s = s1b / (s3b + 126452);
        this.b1i = (s2b - 769860) * l / (s3b + 126452);
    }
    calcMaxChromaHpluv() {
        const r0 = Hsluv.distanceFromOrigin(this.r0s, this.r0i);
        const r1 = Hsluv.distanceFromOrigin(this.r1s, this.r1i);
        const g0 = Hsluv.distanceFromOrigin(this.g0s, this.g0i);
        const g1 = Hsluv.distanceFromOrigin(this.g1s, this.g1i);
        const b0 = Hsluv.distanceFromOrigin(this.b0s, this.b0i);
        const b1 = Hsluv.distanceFromOrigin(this.b1s, this.b1i);
        return Hsluv.min6(r0, r1, g0, g1, b0, b1);
    }
    calcMaxChromaHsluv(h) {
        const hueRad = h / 360 * Math.PI * 2;
        const r0 = Hsluv.distanceFromOriginAngle(this.r0s, this.r0i, hueRad);
        const r1 = Hsluv.distanceFromOriginAngle(this.r1s, this.r1i, hueRad);
        const g0 = Hsluv.distanceFromOriginAngle(this.g0s, this.g0i, hueRad);
        const g1 = Hsluv.distanceFromOriginAngle(this.g1s, this.g1i, hueRad);
        const b0 = Hsluv.distanceFromOriginAngle(this.b0s, this.b0i, hueRad);
        const b1 = Hsluv.distanceFromOriginAngle(this.b1s, this.b1i, hueRad);
        return Hsluv.min6(r0, r1, g0, g1, b0, b1);
    }
    hsluvToLch() {
        if (this.hsluv_l > 99.9999999) {
            this.lch_l = 100;
            this.lch_c = 0;
        }
        else if (this.hsluv_l < 0.00000001) {
            this.lch_l = 0;
            this.lch_c = 0;
        }
        else {
            this.lch_l = this.hsluv_l;
            this.calculateBoundingLines(this.hsluv_l);
            const max = this.calcMaxChromaHsluv(this.hsluv_h);
            this.lch_c = max / 100 * this.hsluv_s;
        }
        this.lch_h = this.hsluv_h;
    }
    lchToHsluv() {
        if (this.lch_l > 99.9999999) {
            this.hsluv_s = 0;
            this.hsluv_l = 100;
        }
        else if (this.lch_l < 0.00000001) {
            this.hsluv_s = 0;
            this.hsluv_l = 0;
        }
        else {
            this.calculateBoundingLines(this.lch_l);
            const max = this.calcMaxChromaHsluv(this.lch_h);
            this.hsluv_s = this.lch_c / max * 100;
            this.hsluv_l = this.lch_l;
        }
        this.hsluv_h = this.lch_h;
    }
    hpluvToLch() {
        if (this.hpluv_l > 99.9999999) {
            this.lch_l = 100;
            this.lch_c = 0;
        }
        else if (this.hpluv_l < 0.00000001) {
            this.lch_l = 0;
            this.lch_c = 0;
        }
        else {
            this.lch_l = this.hpluv_l;
            this.calculateBoundingLines(this.hpluv_l);
            const max = this.calcMaxChromaHpluv();
            this.lch_c = max / 100 * this.hpluv_p;
        }
        this.lch_h = this.hpluv_h;
    }
    lchToHpluv() {
        if (this.lch_l > 99.9999999) {
            this.hpluv_p = 0;
            this.hpluv_l = 100;
        }
        else if (this.lch_l < 0.00000001) {
            this.hpluv_p = 0;
            this.hpluv_l = 0;
        }
        else {
            this.calculateBoundingLines(this.lch_l);
            const max = this.calcMaxChromaHpluv();
            this.hpluv_p = this.lch_c / max * 100;
            this.hpluv_l = this.lch_l;
        }
        this.hpluv_h = this.lch_h;
    }
    hsluvToRgb() {
        this.hsluvToLch();
        this.lchToLuv();
        this.luvToXyz();
        this.xyzToRgb();
    }
    hpluvToRgb() {
        this.hpluvToLch();
        this.lchToLuv();
        this.luvToXyz();
        this.xyzToRgb();
    }
    hsluvToHex() {
        this.hsluvToRgb();
        this.rgbToHex();
    }
    hpluvToHex() {
        this.hpluvToRgb();
        this.rgbToHex();
    }
    rgbToHsluv() {
        this.rgbToXyz();
        this.xyzToLuv();
        this.luvToLch();
        this.lchToHpluv();
        this.lchToHsluv();
    }
    rgbToHpluv() {
        this.rgbToXyz();
        this.xyzToLuv();
        this.luvToLch();
        this.lchToHpluv();
        this.lchToHpluv();
    }
    hexToHsluv() {
        this.hexToRgb();
        this.rgbToHsluv();
    }
    hexToHpluv() {
        this.hexToRgb();
        this.rgbToHpluv();
    }
}
Hsluv.hexChars = "0123456789abcdef";
Hsluv.refY = 1.0;
Hsluv.refU = 0.19783000664283;
Hsluv.refV = 0.46831999493879;
Hsluv.kappa = 903.2962962;
Hsluv.epsilon = 0.0088564516;
Hsluv.m_r0 = 3.240969941904521;
Hsluv.m_r1 = -1.537383177570093;
Hsluv.m_r2 = -0.498610760293;
Hsluv.m_g0 = -0.96924363628087;
Hsluv.m_g1 = 1.87596750150772;
Hsluv.m_g2 = 0.041555057407175;
Hsluv.m_b0 = 0.055630079696993;
Hsluv.m_b1 = -0.20397695888897;
Hsluv.m_b2 = 1.056971514242878;

;// CONCATENATED MODULE: ./src/headless/utils/color.js


const color_cache = new Map();

/**
 * Computes an RGB color as specified in XEP-0392
 * https://xmpp.org/extensions/xep-0392.html
 *
 * @param {string} s JID or nickname to colorize
 * @returns {Promise<string>}
 */
async function colorize(s) {
    // We cache results in `cache`, to avoid unnecessary computing (as it can be called very often)
    const v = color_cache.get(s);
    if (v) return v;

    // Run the input through SHA-1
    const digest = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-1', new TextEncoder().encode(s))));

    // Treat the output as little endian and extract the least-significant 16 bits.
    // (These are the first two bytes of the output, with the second byte being the most significant one.)
    // Divide the value by 65536 (use float division) and multiply it by 360 (to map it to degrees in a full circle).
    const angle = ((digest[0] + digest[1] * 256) / 65536.0) * 360;

    // Convert HSLuv angle to RGB Hex notation
    const hsluv = new Hsluv();
    hsluv.hsluv_h = angle;
    hsluv.hsluv_s = 100;
    hsluv.hsluv_l = 50;
    hsluv.hsluvToHex();

    color_cache.set(s, hsluv.hex);
    return hsluv.hex;
}

;// CONCATENATED MODULE: ./src/headless/utils/text.js
/**
 * @param {string} text
 * @returns {string}
 */
function firstCharToUpperCase(text) {
    if (!text) {
        return '';
    }

    if ('\uD83D\uDE00'.length === 1) {
        return text.charAt(0).toLocaleUpperCase() + text.substring(1);
    }

    const firstChar = text.codePointAt(0);
    const index = firstChar > 0xffff ? 2 : 1;

    return String.fromCodePoint(firstChar).toLocaleUpperCase() + text.substring(index);
}

/**
 * @param {string} string
 * @param {string[]} candidates
 * @returns {string}
 */
function getLongestSubstring(string, candidates) {
    /**
     * @param {string} accumulator
     * @param {string} current_value
     * @returns {string}
     */
    function reducer(accumulator, current_value) {
        if (string.startsWith(current_value)) {
            if (current_value.length > accumulator.length) {
                return current_value;
            } else {
                return accumulator;
            }
        } else {
            return accumulator;
        }
    }
    return candidates.reduce(reducer, '');
}

/**
 * @param {any} s
 * @returns {boolean}
 */
function text_isString(s) {
    return typeof s === 'string' || s instanceof String;
}

;// CONCATENATED MODULE: ./src/headless/utils/url.js



const url_settings = settings_api;

const URL_REGEXES = {
    // valid "scheme://" or "www."
    start: /(\b|_)(?:([a-z][a-z0-9.+-]*:\/\/)|xmpp:|mailto:|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
};

/**
 * Will return false if URL is malformed or contains disallowed characters
 * @param {string} text
 * @returns {boolean}
 */
function isValidURL(text) {
    try {
        if (text.startsWith("www.")) {
            return !!getURL(`http://${text}`);
        }
        return !!getURL(text);
    } catch {
        return false;
    }
}

/**
 * @param {string|URL} url
 * @returns {URL}
 */
function getURL(url) {
    if (url instanceof URL) {
        return url;
    }
    return url.toLowerCase().startsWith("www.") ? getURL(`http://${url}`) : new URL(url);
}

/**
 * Given the an array of file extensions, check whether a URL points to a file
 * ending in one of them.
 * @param {string[]} types - An array of file extensions
 * @param {string|URL} url
 * @returns {boolean}
 * @example
 *  checkFileTypes(['.gif'], 'https://conversejs.org/cat.gif?foo=bar');
 */
function checkFileTypes(types, url) {
    let parsed_url;
    try {
        parsed_url = getURL(url);
    } catch (error) {
        throw new Error(`checkFileTypes: could not parse url ${url}`);
    }
    const filename = parsed_url.pathname.split("/").pop().toLowerCase();
    return !!types.filter((ext) => filename.endsWith(ext)).length;
}

/**
 * @param {string|URL} url
 * @returns {boolean}
 */
function isURLWithImageExtension(url) {
    return checkFileTypes([".jpg", ".jpeg", ".png", ".gif", ".bmp", ".tiff", ".svg"], url);
}

/**
 * @param {string|URL} url
 */
function isGIFURL(url) {
    return checkFileTypes([".gif"], url);
}

/**
 * @param {string|URL} url
 * @param {Headers} [headers]
 */
function isAudioURL(url, headers) {
    if (headers?.get("content-type")?.startsWith("audio")) {
        return true;
    }
    return checkFileTypes([".ogg", ".mp3", ".m4a"], url);
}

/**
 * @param {string|URL} url
 * @param {Headers} [headers]
 */
function isVideoURL(url, headers) {
    if (headers?.get("content-type")?.startsWith("video")) {
        return true;
    }
    return checkFileTypes([".mp4", ".webm"], url);
}

/**
 * @param {string|URL} url
 * @param {Headers} [headers]
 * @returns {boolean}
 */
function isImageURL(url, headers) {
    if (headers?.get("content-type")?.startsWith("video")) {
        return true;
    }
    const regex = url_settings.get("image_urls_regex");
    return regex?.test(url) || isURLWithImageExtension(url);
}

/**
 * @param {string|URL} url
 */
function isEncryptedFileURL(url) {
    return getURL(url).href.startsWith("aesgcm://");
}

/**
 * Processes a string to find and manipulate substrings based on a callback function.
 * This function searches for patterns defined by the provided start and end regular expressions,
 * and applies the callback to each matched substring, allowing for modifications
 * @copyright Copyright (c) 2011 Rodney Rehm
 *
 * @param {string} string - The input string to be processed.
 * @param {function} callback - A function that takes the matched substring and its start and end indices,
 *                              and returns a modified substring or undefined to skip modification.
 * @param {import("./types").ProcessStringOptions} [options]
 * @returns {string} The modified string after processing all matches.
 */
function withinString(string, callback, options) {
    options = options || {};
    const _start = options.start || URL_REGEXES.start;
    const _end = options.end || URL_REGEXES.end;
    const _trim = options.trim || URL_REGEXES.trim;
    const _parens = options.parens || URL_REGEXES.parens;
    const _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
        const match = _start.exec(string);
        if (!match) break;

        let start = match.index;
        if (options.ignoreHtml) {
            const attributeOpen = string.slice(Math.max(start - 3, 0), start);
            if (attributeOpen && _attributeOpen.test(attributeOpen)) {
                continue;
            }
        }

        let end = start + string.slice(start).search(_end);
        let slice = string.slice(start, end);
        let parensEnd = -1;
        while (true) {
            const parensMatch = _parens.exec(slice);
            if (!parensMatch) break;

            const parensMatchEnd = parensMatch.index + parensMatch[0].length;
            parensEnd = Math.max(parensEnd, parensMatchEnd);
        }

        if (parensEnd > -1) {
            slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, "");
        } else {
            slice = slice.replace(_trim, "");
        }

        if (slice.length <= match[0].length) continue;
        if (options.ignore && options.ignore.test(slice)) continue;

        end = start + slice.length;
        const result = callback(slice, start, end);
        if (result === undefined) {
            _start.lastIndex = end;
            continue;
        }

        string = string.slice(0, start) + String(result) + string.slice(end);
        _start.lastIndex = start + String(result).length;
    }

    _start.lastIndex = 0;
    return string;
}

/**
 * @param {string} url
 * @returns {Promise<Headers>}
 */
async function getHeaders(url) {
    try {
        const response = await fetch(url, { method: "HEAD" });
        return response.headers;
    } catch (e) {
        console.debug(`Error calling HEAD on url ${url}: ${e}`);
        return null;
    }
}

/**
 * @param {import("./types").MediaURLIndexes} o
 * @returns {Promise<import("./types").MediaURLMetadata>}
 */
async function getMetadataForURL(o) {
    const fetch_headers = settings_api.get("fetch_url_headers");
    const headers = fetch_headers ? await getHeaders(o.url) : null;
    return {
        ...o,
        is_gif: isGIFURL(o.url),
        is_audio: isAudioURL(o.url, headers),
        is_image: isImageURL(o.url, headers),
        is_video: isVideoURL(o.url, headers),
        is_encrypted: isEncryptedFileURL(o.url),
    };
}

/**
 * @param {string} text
 * @param {number} offset
 * @returns {Promise<{media_urls?: import("./types").MediaURLMetadata[]}>}
 */
async function getMediaURLsMetadata(text, offset = 0) {
    const objs = [];
    if (!text) {
        return {};
    }
    try {
        withinString(
            text,
            /**
             * @param {string} url
             * @param {number} start
             * @param {number} end
             * @returns {string|undefined}
             */
            (url, start, end) => {
                if (url.startsWith("_")) {
                    url = url.slice(1);
                    start += 1;
                }
                if (url.endsWith("_")) {
                    url = url.slice(0, url.length - 1);
                    end -= 1;
                }

                if (isValidURL(url)) {
                    objs.push({ url, start: start + offset, end: end + offset });
                }
                return url;
            }
        );
    } catch (error) {
        src_log.debug(error);
    }

    const media_urls = await Promise.all(objs.map(getMetadataForURL));
    return media_urls.length ? { media_urls } : {};
}

/**
 * @param {Array<import("./types").MediaURLMetadata>} arr
 * @param {string} text
 * @returns {import("./types").MediaURLMetadata[]}
 */
function getMediaURLs(arr, text) {
    return arr
        .map((o) => {
            if (o.start < 0 || o.start >= text.length) {
                return null;
            }
            const url = text.substring(o.start, o.end);
            return {
                ...o,
                url,
            };
        })
        .filter((o) => o);
}

/**
 * @param {Array<import("./types").MediaURLMetadata>} arr
 * @param {string} text
 * @returns {import("./types").MediaURLMetadata[]}
 */
function addMediaURLsOffset(arr, text, offset = 0) {
    return arr
        .map((o) => {
            const start = o.start - offset;
            const end = o.end - offset;
            if (start < 0 || start >= text.length) {
                return null;
            }
            return Object.assign({}, o, {
                start,
                end,
                url: text.substring(o.start-offset, o.end-offset), // BBB
            });
        })
        .filter((o) => o);
}

;// CONCATENATED MODULE: ./src/headless/utils/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description This is the core utilities module.
 */

















/**
 * The utils object
 * @namespace u
 * @type {import('./types').CommonUtils & import('./types').PluginUtils}
 */
const utils_u = {
    bookmarks: null,
    emojis: null,
    mam: null,
    muc: null,
    omemo: null,
    reactions: null,
    roster: null,
};

/**
 * @param {Event} [event]
 */
function setLogLevelFromRoute(event) {
    const hash = getRouteHash();
    if (hash.startsWith('#converse?loglevel=')) {
        event?.preventDefault();
        const level = hash.split('=').pop();
        if (Object.keys(LEVELS).includes(level)) {
            src_log.setLogLevel(/** @type {keyof LEVELS} */ (level));
        } else {
            src_log.error(`Could not set loglevel of ${level}`);
        }
    }
}

function isEmptyMessage(attrs) {
    if (attrs instanceof skeletor_esm_Model) {
        attrs = attrs.attributes;
    }
    return (
        !attrs['oob_url'] &&
        !attrs['file'] &&
        !(attrs['is_encrypted'] && attrs['plaintext']) &&
        !attrs['message'] &&
        !attrs['body']
    );
}

/**
 * Given a message object, return its text with @ chars
 * inserted before the mentioned nicknames.
 * @param {import('../shared/message').default} message
 */
function prefixMentions(message) {
    let text = message.getMessageText();
    (message.get('references') || [])
        .sort((a, b) => b.begin - a.begin)
        .forEach((ref) => {
            text = `${text.slice(0, ref.begin)}@${text.slice(ref.begin)}`;
        });
    return text;
}

function shouldCreateMessage(attrs) {
    return (
        attrs['retracted'] || // Retraction received *before* the message
        // An error (e.g. a failed OMEMO decryption) should be surfaced to the
        // user rather than silently dropped, even when the stanza carried no
        // fallback body for us to show. See #2097.
        attrs['is_error'] ||
        !isEmptyMessage(attrs)
    );
}

/**
 * Call the callback once all the events have been triggered
 * @param { Array } events: An array of objects, with keys `object` and
 *   `event`, representing the event name and the object it's triggered upon.
 * @param { Function } callback: The function to call once all events have
 *    been triggered.
 */
function onMultipleEvents(events = [], callback) {
    let triggered = [];

    function handler(result) {
        triggered.push(result);
        if (events.length === triggered.length) {
            callback(triggered);
            triggered = [];
        }
    }
    events.forEach((e) => e.object.on(e.event, handler));
}

/**
 * @param {Element} el
 * @param {string} name
 * @param {string} [type]
 * @param {boolean} [bubbles]
 * @param {boolean} [cancelable]
 */
function triggerEvent(el, name, type = 'Event', bubbles = true, cancelable = true) {
    const evt = document.createEvent(type);
    evt.initEvent(name, bubbles, cancelable);
    el.dispatchEvent(evt);
}

function getRandomInt(max) {
    return (Math.random() * max) | 0;
}

/**
 * @param {string} [suffix]
 * @return {string}
 */
function getUniqueId(suffix) {
    const uuid =
        crypto.randomUUID?.() ??
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = getRandomInt(16);
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    if (typeof suffix === 'string' || typeof suffix === 'number') {
        return uuid + ':' + suffix;
    } else {
        return uuid;
    }
}

/* export default */ const headless_utils = (Object.assign(
    {
        ...array_namespaceObject,
        ...arraybuffer_namespaceObject,
        ...color_namespaceObject,
        ...environment_namespaceObject,
        ...html_namespaceObject,
        ...init_namespaceObject,
        ...jid_namespaceObject,
        ...object_namespaceObject,
        ...promise_namespaceObject,
        ...session_namespaceObject,
        ...stanza_namespaceObject,
        ...storage_namespaceObject,
        ...text_namespaceObject,
        ...url_namespaceObject,
        getRandomInt,
        getUniqueId,
        isEmptyMessage,
        onMultipleEvents,
        prefixMentions,
        shouldCreateMessage,
        triggerEvent,
    },
    utils_u,
));

;// CONCATENATED MODULE: ./src/headless/shared/api/public.js
/**
 * @typedef {module:shared-api-public.ConversePrivateGlobal} ConversePrivateGlobal
 */
























shared_converse.api = shared_api;

dayjs_min.extend(advancedFormat);
dayjs_min.extend(localizedFormat);

const env = /** @type {import('./types').ConverseEnv} */ {
    $build: $build,
    $iq: $iq,
    $msg: $msg,
    $pres: $pres,
    Collection: Collection,
    Model: skeletor_esm_Model,
    Stanza: Stanza,
    Strophe: Strophe,
    TimeoutError: TimeoutError,
    VERSION_NAME: VERSION_NAME,
    css: css_tag_i,
    dayjs: dayjs_min,
    errors: errors_namespaceObject,
    filesize: filesize,
    html: lit_html_b,
    log: src_log,
    nothing: A,
    render: D,
    sizzle: sizzle,
    sprintf: sprintf/* .sprintf */.n,
    stx: stx,
    u: headless_utils,
    utils: headless_utils,
};

/**
 * @typedef {Window & {converse: ConversePrivateGlobal} } window
 *
 * ### The Public API
 *
 * This namespace contains public API methods which are are
 * accessible on the global `converse` object.
 * They are public, because any JavaScript in the
 * page can call them. Public methods therefore don’t expose any sensitive
 * or closured data. To do that, you’ll need to create a plugin, which has
 * access to the private API method.
 *
 * @global
 * @namespace converse
 */
const public_converse = Object.assign(/** @type {ConversePrivateGlobal} */ (globalThis).converse || {}, {
    CHAT_STATES: CHAT_STATES,

    keycodes: KEYCODES,

    /**
     * Public API method which initializes Converse.
     * This method must always be called when using Converse.
     * @async
     * @memberOf converse
     * @method initialize
     * @param { object } settings A map of [configuration-settings](https://conversejs.org/docs/configuration/#configuration-settings).
     * @example
     * converse.initialize({
     *     auto_list_rooms: false,
     *     auto_subscribe: false,
     *     bosh_service_url: 'https://bind.example.com',
     *     hide_muc_server: false,
     *     i18n: 'en',
     *     play_sounds: true,
     *     show_controlbox_by_default: true,
     *     debug: false,
     *     roster_groups: true
     * });
     */
    async initialize(settings) {
        const { api } = shared_converse;
        await init_cleanup(shared_converse);

        initAppSettings(settings);
        shared_converse.strict_plugin_dependencies = settings.strict_plugin_dependencies; // Needed by pluggable.js
        src_log.setLogLevel(api.settings.get('loglevel'));

        if (api.settings.get('authentication') === ANONYMOUS) {
            if (api.settings.get('auto_login') && !api.settings.get('jid')) {
                throw new Error(
                    "Config Error: you need to provide the server's " +
                        "domain via the 'jid' option when using anonymous " +
                        'authentication with auto_login.',
                );
            }
        }

        setLogLevelFromRoute();
        addRouteListener(setLogLevelFromRoute);

        const connfeedback = new connection_feedback();
        Object.assign(shared_converse, { connfeedback }); // XXX: DEPRECATED
        Object.assign(shared_converse.state, { connfeedback });
        shared_converse.env = env;

        await initSessionStorage(shared_converse);
        await initClientConfig(shared_converse);
        await i18n.initialize();
        initPlugins(shared_converse);

        // Register all custom elements
        // XXX: api.elements is defined in the UI part of Converse, outside of @converse/headless.
        // This line should probably be moved to the UI code as part of a larger refactoring.
        api.elements?.register();

        registerGlobalEventHandlers(shared_converse);

        const plugins = shared_converse.pluggable.plugins;
        if (api.settings.get('auto_login') || (api.settings.get('keepalive') && plugins['converse-bosh']?.enabled())) {
            await api.user.login(null, null, true);
        }

        /**
         * Triggered once converse.initialize has finished.
         * @event _converse#initialized
         */
        api.trigger('initialized');

        if (isTestEnv()) {
            return shared_converse;
        }
    },

    /**
     * Exposes methods for adding and removing plugins. You'll need to write a plugin
     * if you want to have access to the private API methods defined further down below.
     *
     * For more information on plugins, read the documentation on
     * [writing a plugin](https://conversejs.org/docs/development/plugin-development/).
     * @namespace plugins
     * @memberOf converse
     */
    plugins: {
        /**
         * Registers a new plugin.
         * @method converse.plugins.add
         * @param { string } name The name of the plugin
         * @param { object } plugin The plugin object
         * @example
         *  const plugin = {
         *      initialize: function () {
         *          // Gets called as soon as the plugin has been loaded.
         *
         *          // Inside this method, you have access to the private
         *          // API via `_covnerse.api`.
         *
         *          // The private _converse object contains the core logic
         *          // and data-structures of Converse.
         *      }
         *  }
         *  converse.plugins.add('myplugin', plugin);
         */
        add(name, plugin) {
            plugin.__name__ = name;
            if (shared_converse.pluggable.plugins[name] !== undefined) {
                throw new TypeError(`Error: plugin with name "${name}" has already been ` + 'registered!');
            } else {
                shared_converse.pluggable.plugins[name] = plugin;
            }
        },
    },
    env,
});

/* export default */ const api_public = (public_converse);

;// CONCATENATED MODULE: ./src/headless/shared/actions.js







const { u: actions_u, stx: actions_stx, Stanza: actions_Stanza } = api_public.env;

/**
 * Reject an incoming message by replying with an error message of type "cancel".
 * @param {Element} stanza
 * @param {string} text
 * @return void
 */
function rejectMessage(stanza, text) {
    shared_api.send(
        actions_stx`<message to="${stanza.getAttribute('from')}"
                    type="error"
                    id="${stanza.getAttribute('id')}"
                    xmlns="jabber:client">
                <error type="cancel">
                    <not-allowed xmlns="${Strophe.NS.STANZAS}"/>
                    <text xmlns="${Strophe.NS.STANZAS}">${text}</text>
                </error>
            </message>`,
    );
    src_log.warn(`Rejecting message stanza with the following reason: ${text}`);
    src_log.warn(stanza);
}

/**
 * Send out a XEP-0333 chat marker.
 * @fires sendMarker
 * @param {string} to_jid
 * @param {string} id - The id of the message being marked
 * @param {import("./types").MessageMarkerType} type - The marker type
 * @param {string} [msg_type]
 */
async function sendMarker(to_jid, id, type, msg_type) {
    if (!MARKER_TYPES.includes(type)) {
        src_log.error(`Invalid marker type: ${type}`);
        return;
    }
    const bare_jid = Strophe.getBareJidFromJid(to_jid);
    const chatbox = shared_converse.state.chatboxes?.get(bare_jid);

    /**
     * Hook which lets plugins handle sending a chat marker (such as OMEMO
     * which sends an encrypted version). If any hook listener returns
     * `{ handled: true }` the cleartext stanza is suppressed.
     *
     * Context: the {@link ChatBox} / {@link MUC} model for `to_jid`, or
     * `undefined` if not found.
     *
     * Hook data: `{ to_jid, id, type, msg_type, handled: false }`
     *
     * @example
     *  api.listen.on('sendMarker', async (chatbox, data) => {
     *      if (!chatbox?.get('omemo_active')) return data;
     *      await sendEncryptedMarker(chatbox, data);
     *      return { ...data, handled: true };
     *  });
     */
    const { handled } = await shared_api.hook('sendMarker', chatbox, { to_jid, id, type, msg_type, handled: false });
    if (handled) return;

    const stanza = actions_stx`
        <message from="${shared_api.connection.get().jid}"
                id="${actions_u.getUniqueId()}"
                to="${to_jid}"
                type="${msg_type ? msg_type : 'chat'}"
                xmlns="jabber:client">
            <${actions_Stanza.unsafeXML(type)} xmlns="${Strophe.NS.MARKERS}" id="${id}"/>
        </message>`;
    shared_api.send(stanza);
}

/**
 * @param {string} to_jid
 * @param {string} id
 * @return void
 */
function sendReceiptStanza(to_jid, id) {
    const receipt_stanza = actions_stx`
        <message from="${shared_api.connection.get().jid}"
                id="${actions_u.getUniqueId()}"
                to="${to_jid}"
                type="chat"
                xmlns="jabber:client">
            <received xmlns="${Strophe.NS.RECEIPTS}" id="${id}"/>
            <store xmlns="${Strophe.NS.HINTS}"/>
        </message>`;
    shared_api.send(receipt_stanza);
}

/**
 * Sends a message with the given XEP-0085 chat state.
 * @param {string} jid
 * @param {import("./types").ChatStateType} chat_state
 */
function sendChatState(jid, chat_state) {
    if (!jid) {
        src_log.error(`sendChatState called with no JID`);
        return;
    } else if (!CHAT_STATES.includes(chat_state)) {
        src_log.error(`Invalid chat state: ${chat_state}`);
        return;
    }

    if (shared_api.settings.get('send_chat_state_notifications') && chat_state) {
        const allowed = shared_api.settings.get('send_chat_state_notifications');
        if (Array.isArray(allowed) && !allowed.includes(chat_state)) {
            return;
        }
        // When OMEMO is active the OMEMO plugin sends an encrypted SCE version;
        // suppress the cleartext stanza so only one notification goes out.
        if (shared_converse.state.chatboxes?.get(jid)?.get('omemo_active')) return;
        shared_api.send(
            actions_stx`<message id="${actions_u.getUniqueId()}" to="${jid}" type="chat" xmlns="jabber:client">
                <${actions_Stanza.unsafeXML(chat_state)} xmlns="${Strophe.NS.CHATSTATES}"/>
                <no-store xmlns="${Strophe.NS.HINTS}"/>
                <no-permanent-store xmlns="${Strophe.NS.HINTS}"/>
            </message>`,
        );
    }
}

/**
 * Sends a message stanza to retract a message in this chat
 * @param {string} jid
 * @param {import('../shared/message').default} message - The message which we're retracting.
 * @param {string} retraction_id - Unique ID for the retraction message
 */
function sendRetractionMessage(jid, message, retraction_id) {
    const origin_id = message.get('origin_id');
    if (!origin_id) {
        throw new Error("Can't retract message without a XEP-0359 Origin ID");
    }
    const stanza = actions_stx`
        <message id="${retraction_id}"
                 to="${jid}"
                 type="chat"
                 xmlns="jabber:client">
            <retract id="${origin_id}" xmlns="${Strophe.NS.RETRACT}"/>
            <body>/me retracted a message</body>
            <store xmlns="${Strophe.NS.HINTS}"/>
            <fallback xmlns="${Strophe.NS.FALLBACK}" for="${Strophe.NS.RETRACT}" />
        </message>`;
    return shared_api.connection.get().send(stanza);
}

;// CONCATENATED MODULE: ./src/headless/shared/parsers.js
/**
 * @module:headless-shared-parsers
 */












const { dayjs } = api_public.env;
const { NS: parsers_NS } = Strophe;

/**
 * @param {Element|Error|null} stanza - The stanza to be parsed. As a convenience,
 * an Error element can be passed in as well, so that this function can be
 * called in a catch block without first checking if a stanza or Error
 * element was received.
 * @returns {Promise<Error|errors.StanzaError|null>}
 */
async function parseErrorStanza(stanza) {
    if (stanza === null) return null;
    if (stanza instanceof Error) return stanza;
    if (stanza.getAttribute('type') !== 'error') return null;

    const error = stanza.querySelector('error');
    if (!error) return null;

    const els = sizzle(`[xmlns="${Strophe.NS.STANZAS}"]`, error);
    const name = els.filter((el) => el.nodeName && el.nodeName !== 'text').pop()?.nodeName;

    /**
     * *Hook* which allows plugins to add application-specific error parsing
     * @event _converse#parseErrorStanza
     */
    const extra = await shared_api.hook('parseErrorStanza', stanza, {});

    if (name === 'bad-request') {
        return new BadRequestError(name, error, extra);
    } else if (name === 'conflict') {
        return new ConflictError(name, error, extra);
    } else if (name === 'feature-not-implemented') {
        return new FeatureNotImplementedError(name, error, extra);
    } else if (name === 'forbidden') {
        return new ForbiddenError(name, error, extra);
    } else if (name === 'gone') {
        return new GoneError(name, error, extra);
    } else if (name === 'internal-server-error') {
        return new InternalServerError(name, error, extra);
    } else if (name === 'item-not-found') {
        return new ItemNotFoundError(name, error, extra);
    } else if (name === 'jid-malformed') {
        return new JIDMalformedError(name, error, extra);
    } else if (name === 'not-acceptable') {
        return new NotAcceptableError(name, error, extra);
    } else if (name === 'not-allowed') {
        return new NotAllowedError(name, error, extra);
    } else if (name === 'not-authorized') {
        return new NotAuthorizedError(name, error, extra);
    } else if (name === 'payment-required') {
        return new PaymentRequiredError(name, error, extra);
    } else if (name === 'recipient-unavailable') {
        return new RecipientUnavailableError(name, error, extra);
    } else if (name === 'redirect') {
        return new RedirectError(name, error, extra);
    } else if (name === 'registration-required') {
        return new RegistrationRequiredError(name, error, extra);
    } else if (name === 'remote-server-not-found') {
        return new RemoteServerNotFoundError(name, error, extra);
    } else if (name === 'remote-server-timeout') {
        return new RemoteServerTimeoutError(name, error, extra);
    } else if (name === 'resource-constraint') {
        return new ResourceConstraintError(name, error, extra);
    } else if (name === 'service-unavailable') {
        return new ServiceUnavailableError(name, error, extra);
    } else if (name === 'subscription-required') {
        return new SubscriptionRequiredError(name, error, extra);
    } else if (name === 'undefined-condition') {
        return new UndefinedConditionError(name, error, extra);
    } else if (name === 'unexpected-request') {
        return new UnexpectedRequestError(name, error, extra);
    }
    return new StanzaError('unknown', error);
}

/**
 * Extract the XEP-0359 stanza IDs from the passed in stanza
 * and return a map containing them.
 * @param {Element} stanza - The message stanza
 * @param {Element} original_stanza - The encapsulating stanza which contains
 *      the message stanza.
 * @returns {Object}
 */
function getStanzaIDs(stanza, original_stanza) {
    // Generic stanza ids
    const sids = sizzle(`stanza-id[xmlns="${Strophe.NS.SID}"]`, stanza);
    const sid_attrs = sids.reduce((acc, s) => {
        acc[`stanza_id ${s.getAttribute('by')}`] = s.getAttribute('id');
        return acc;
    }, {});

    // Origin id
    const origin_id = sizzle(`origin-id[xmlns="${Strophe.NS.SID}"]`, stanza).pop()?.getAttribute('id');

    const attrs = {
        origin_id,
        msgid: stanza.getAttribute('id') || original_stanza.getAttribute('id'),
        ...sid_attrs,
    };

    // Store the archive id
    const result = sizzle(`message > result[xmlns="${Strophe.NS.MAM}"]`, original_stanza).pop();
    if (result) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const by_jid = original_stanza.getAttribute('from') || bare_jid;
        attrs[`stanza_id ${by_jid}`] = result.getAttribute('id');
    }

    return attrs;
}

/**
 * @param {Element} stanza
 * @returns {import('./types').EncryptionAttrs}
 */
function getEncryptionAttributes(stanza) {
    const eme_tag = sizzle(`encryption[xmlns="${Strophe.NS.EME}"]`, stanza).pop();
    const namespace = eme_tag?.getAttribute('namespace');
    const attrs = {};
    if (namespace) {
        attrs.is_encrypted = true;
        attrs.encryption_namespace = namespace;
    } else if (sizzle(`encrypted[xmlns="${Strophe.NS.OMEMO2}"]`, stanza).pop()) {
        attrs.is_encrypted = true;
        attrs.encryption_namespace = Strophe.NS.OMEMO2;
    } else if (sizzle(`encrypted[xmlns="${Strophe.NS.OMEMO}"]`, stanza).pop()) {
        attrs.is_encrypted = true;
        attrs.encryption_namespace = Strophe.NS.OMEMO;
    }
    return attrs;
}

/**
 * @param {Element} stanza - The message stanza
 * @param {Element} original_stanza - The original stanza, that contains the
 *  message stanza, if it was contained, otherwise it's the message stanza itself.
 * @returns {import('./types').RetractionAttrs | {}}
 */
function getDeprecatedRetractionAttributes(stanza, original_stanza) {
    const fastening = sizzle(`> apply-to[xmlns="${Strophe.NS.FASTEN}"]`, stanza).pop();
    if (fastening) {
        const applies_to_id = fastening.getAttribute('id');
        const retracted = sizzle(`> retract[xmlns="${Strophe.NS.RETRACT0}"]`, fastening).pop();
        if (retracted) {
            const delay = sizzle(`delay[xmlns="${Strophe.NS.DELAY}"]`, original_stanza).pop();
            const time = delay ? dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString();
            return {
                editable: false,
                retracted: time,
                retracted_id: applies_to_id,
            };
        }
    }
    return {};
}

/**
 * @param {Element} stanza - The message stanza
 * @param {Element} original_stanza - The original stanza, that contains the
 *  message stanza, if it was contained, otherwise it's the message stanza itself.
 * @returns {import('./types').RetractionAttrs | {}}
 */
function getRetractionAttributes(stanza, original_stanza) {
    const retraction = sizzle(`> retract[xmlns="${Strophe.NS.RETRACT}"]`, stanza).pop();
    if (retraction) {
        const delay = sizzle(`> delay[xmlns="${Strophe.NS.DELAY}"]`, original_stanza).pop();
        const time = delay ? dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString();
        return {
            editable: false,
            retracted: time,
            retracted_id: retraction.getAttribute('id'),
        };
    } else {
        const tombstone =
            sizzle(`> retracted[xmlns="${Strophe.NS.RETRACT}"]`, stanza).pop() ||
            sizzle(`> retracted[xmlns="${Strophe.NS.RETRACT0}"]`, stanza).pop();
        if (tombstone) {
            return {
                editable: false,
                is_tombstone: true,
                retracted: tombstone.getAttribute('stamp'),
                retraction_id: tombstone.getAttribute('id'),
            };
        }
    }
    return getDeprecatedRetractionAttributes(stanza, original_stanza);
}

/**
 * @param {Element} stanza
 * @param {Element} original_stanza
 */
function getCorrectionAttributes(stanza, original_stanza) {
    const el = sizzle(`replace[xmlns="${Strophe.NS.MESSAGE_CORRECT}"]`, stanza).pop();
    if (el) {
        const replace_id = el.getAttribute('id');
        if (replace_id) {
            const delay = sizzle(`delay[xmlns="${Strophe.NS.DELAY}"]`, original_stanza).pop();
            const time = delay ? dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString();
            return {
                replace_id,
                'edited': time,
            };
        }
    }
    return {};
}

/**
 * @param {Element} stanza
 */
function getOpenGraphMetadata(stanza) {
    const fastening = sizzle(`> apply-to[xmlns="${Strophe.NS.FASTEN}"]`, stanza).pop();
    if (fastening) {
        const applies_to_id = fastening.getAttribute('id');
        const meta = sizzle(`> meta[xmlns="${Strophe.NS.XHTML}"]`, fastening);
        if (meta.length) {
            const msg_limit = shared_api.settings.get('message_limit');
            const data = meta.reduce(
                (acc, el) => {
                    const property = el.getAttribute('property');
                    if (property) {
                        let value = decodeHTMLEntities(el.getAttribute('content') || '');
                        if (msg_limit && property === 'og:description' && value.length >= msg_limit) {
                            value = `${value.slice(0, msg_limit)}${decodeHTMLEntities('&#8230;')}`;
                        }
                        acc[property] = value;
                    }
                    return acc;
                },
                {
                    ogp_for_id: applies_to_id,
                },
            );

            const url = data['og:url'];
            if (url?.startsWith('/') && data['og:site_name']?.toLowerCase() === 'github') {
                data['og:url'] = `https://github.com${url}`;
            }

            if ('og:description' in data || 'og:title' in data || 'og:image' in data) {
                return data;
            }
        }
    }
    return {};
}

/**
 * @param {Element} stanza
 */
function getSpoilerAttributes(stanza) {
    const spoiler = sizzle(`spoiler[xmlns="${Strophe.NS.SPOILER}"]`, stanza).pop();
    return {
        'is_spoiler': !!spoiler,
        'spoiler_hint': spoiler?.textContent,
    };
}

/**
 * @param {Element} stanza
 */
function getOutOfBandAttributes(stanza) {
    const xform = sizzle(`x[xmlns="${Strophe.NS.OUTOFBAND}"]`, stanza).pop();
    if (xform) {
        return {
            'oob_url': xform.querySelector('url')?.textContent,
            'oob_desc': xform.querySelector('desc')?.textContent,
        };
    }
    return {};
}

/**
 * Returns the human readable error message contained in a `groupchat` message stanza of type `error`.
 * @param {Element} stanza - The message stanza
 */
function getErrorAttributes(stanza) {
    if (stanza.getAttribute('type') === 'error') {
        const error = stanza.querySelector('error');
        const text = sizzle(`text[xmlns="${Strophe.NS.STANZAS}"]`, error).pop();
        return {
            is_error: true,
            error_text: text?.textContent,
            error_type: error.getAttribute('type'),
            error_condition: error.firstElementChild.nodeName,
            errors: Array.from(error.children).map((e) => ({ name: e.nodeName, xmlns: e.getAttribute('xmlns') })),
        };
    }
    return {};
}

/**
 * Given a message stanza, extract XEP-0461 reply attributes
 * @param {Element} stanza - The message stanza
 * @returns {Object} An object containing reply_to_id and reply_to if present
 */
function getReplyAttributes(stanza) {
    const reply = sizzle(`reply[xmlns="${Strophe.NS.REPLY}"]`, stanza).pop();
    if (reply) {
        return {
            reply_to_id: reply.getAttribute('id'),
            reply_to: reply.getAttribute('to'),
        };
    }
    return {};
}

/**
 * Parse all XEP-0428 `<fallback>` elements and return them as a
 * namespace-keyed map.
 *
 * The value for each namespace is:
 *  - `{ start, end }` when `<body start="…" end="…"/>` provides a code-point
 *    range (XEP-0461 reply fallback), so the range can be stripped from display.
 *  - `null` when there is no range — either a bare `<body/>` or no `<body>`
 *    child at all (XEP-0444 reaction fallback, XEP-0424 retraction fallback),
 *    meaning the whole body is a fallback for clients that lack the feature.
 *
 * @param {Element} stanza - The message stanza (or decrypted SCE `<content>`)
 * @returns {{ fallback?: Record<string, {start: number, end: number}|null> }}
 */
function getFallbackAttributes(stanza) {
    /** @type {Record<string, {start: number, end: number}|null>} */
    const fallback = {};

    for (const el of sizzle(`fallback[xmlns="${Strophe.NS.FALLBACK}"]`, stanza)) {
        const ns = el.getAttribute('for');
        if (!ns) continue;
        const body = sizzle('> body', el).pop();
        const start = body?.getAttribute('start');
        const end = body?.getAttribute('end');
        fallback[ns] = start != null && end != null ? { start: Number(start), end: Number(end) } : null;
    }

    return Object.keys(fallback).length ? { fallback } : {};
}

/**
 * Given a message stanza, find and return any XEP-0372 references
 * @param {Element} stanza - The message stanza
 * @returns {import('./types').XEP372Reference[]}
 */
function getReferences(stanza) {
    return sizzle(`reference[xmlns="${Strophe.NS.REFERENCE}"]`, stanza)
        .map((ref) => {
            const anchor = ref.getAttribute('anchor');
            const text = stanza.querySelector(anchor ? `#${anchor}` : 'body')?.textContent;
            if (!text) {
                src_log.warn(`Could not find referenced text for ${ref}`);
                return null;
            }
            const begin = Number(ref.getAttribute('begin'));
            const end = Number(ref.getAttribute('end'));
            return {
                begin,
                end,
                type: ref.getAttribute('type'),
                value: text.slice(begin, end),
                uri: ref.getAttribute('uri'),
            };
        })
        .filter((r) => r);
}

/**
 * @param {Element} stanza
 */
function getReceiptId(stanza) {
    const receipt = sizzle(`received[xmlns="${Strophe.NS.RECEIPTS}"]`, stanza).pop();
    return receipt?.getAttribute('id');
}

/**
 * Determines whether the passed in stanza is a XEP-0280 Carbon
 * @param {Element} stanza - The message stanza
 * @returns {Boolean}
 */
function isCarbon(stanza) {
    const xmlns = Strophe.NS.CARBONS;
    return (
        sizzle(`message > received[xmlns="${xmlns}"]`, stanza).length > 0 ||
        sizzle(`message > sent[xmlns="${xmlns}"]`, stanza).length > 0
    );
}

/**
 * Returns the XEP-0085 chat state contained in a message stanza
 * @param {Element} stanza - The message stanza
 */
function getChatState(stanza) {
    return sizzle(
        `
        composing[xmlns="${parsers_NS.CHATSTATES}"],
        paused[xmlns="${parsers_NS.CHATSTATES}"],
        inactive[xmlns="${parsers_NS.CHATSTATES}"],
        active[xmlns="${parsers_NS.CHATSTATES}"],
        gone[xmlns="${parsers_NS.CHATSTATES}"]`,
        stanza,
    ).pop()?.nodeName;
}

/**
 * @param {Element} stanza
 * @param {Object} attrs
 */
function isValidReceiptRequest(stanza, attrs) {
    return (
        attrs.sender !== 'me' &&
        !attrs.is_carbon &&
        !attrs.is_archived &&
        sizzle(`request[xmlns="${Strophe.NS.RECEIPTS}"]`, stanza).length
    );
}

/**
 * Check whether the passed-in stanza is a forwarded message that is "bare",
 * i.e. it's not forwarded as part of a larger protocol, like MAM.
 * @param { Element } stanza
 */
function throwErrorIfInvalidForward(stanza) {
    const bare_forward = sizzle(`message > forwarded[xmlns="${Strophe.NS.FORWARD}"]`, stanza).length;
    if (bare_forward) {
        rejectMessage(stanza, 'Forwarded messages not part of an encapsulating protocol are not supported');
        const from_jid = stanza.getAttribute('from');
        throw new StanzaParseError(stanza, `Ignoring unencapsulated forwarded message from ${from_jid}`);
    }
}

/**
 * Determines whether the passed in stanza is a XEP-0333 Chat Marker
 * @method getChatMarker
 * @param {Element} stanza - The message stanza
 * @returns {Element}
 */
function getChatMarker(stanza) {
    // If we receive more than one marker (which shouldn't happen), we take
    // the highest level of acknowledgement.
    return sizzle(
        `
        acknowledged[xmlns="${Strophe.NS.MARKERS}"],
        displayed[xmlns="${Strophe.NS.MARKERS}"],
        received[xmlns="${Strophe.NS.MARKERS}"]`,
        stanza,
    ).pop();
}

/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isHeadline(stanza) {
    return stanza.getAttribute('type') === 'headline';
}

/**
 * @param {Element} stanza
 * @returns {Promise<boolean>}
 */
async function isMUCPrivateMessage(stanza) {
    const bare_jid = Strophe.getBareJidFromJid(stanza.getAttribute('from'));
    return !!(await shared_api.rooms.get(bare_jid));
}

/**
 * @param {Element} stanza
 * @returns {boolean}
 */
function isServerMessage(stanza) {
    if (sizzle(`mentions[xmlns="${Strophe.NS.MENTIONS}"]`, stanza).pop()) {
        return false;
    }
    const from_jid = stanza.getAttribute('from');
    if (stanza.getAttribute('type') !== 'error' && from_jid && !from_jid.includes('@')) {
        // Some servers (e.g. Prosody) don't set the stanza
        // type to "headline" when sending server messages.
        // For now we check if an @ signal is included, and if not,
        // we assume it's a headline stanza unless we have a relationship with that host.
        //
        // A bare-host JID can sometimes be chatted with, e.g. a pubsub text interface,
        // a XEP-0100 gateway or a transport. When it's in our roster, or we already have a
        // chat open with it, we asked to talk to it, so its own declared type is
        // more trustworthy than this guess. See #1509.
        return !hasChatRelationshipWith(from_jid);
    }
    return false;
}

/**
 * Whether we've deliberately entered into a conversation with `jid`, which is
 * what lets {@link isServerMessage} tell a correspondent that happens to be a
 * host apart from an unsolicited server notice.
 * @param {string} jid
 * @returns {boolean}
 */
function hasChatRelationshipWith(jid) {
    const { roster, chatboxes } = shared_converse.state;
    if (roster?.get(jid)) return true;

    return chatboxes?.get(jid)?.get('type') === PRIVATE_CHAT_TYPE;
}

/**
 * Determines whether the passed in stanza is a XEP-0313 MAM stanza
 * @method isArchived
 * @param {Element} original_stanza - The message stanza
 * @returns {boolean}
 */
function isArchived(original_stanza) {
    return !!sizzle(`message > result[xmlns="${Strophe.NS.MAM}"]`, original_stanza).pop();
}

/**
 * @param {Element} field
 * @param {boolean} readonly
 * @param {Element} stanza
 * @return {import('./types').XFormField}
 */
function parseXFormField(field, readonly, stanza) {
    const v = field.getAttribute('var');
    const label = field.getAttribute('label') || '';
    const type = field.getAttribute('type');
    const desc = field.querySelector('desc')?.textContent;
    const result = { readonly, desc };

    if (type === 'list-single' || type === 'list-multi') {
        const values = Array.from(field.querySelectorAll(':scope > value')).map((el) => el?.textContent);
        const options = Array.from(field.querySelectorAll(':scope > option')).map(
            (/** @type {HTMLElement} */ option) => {
                const value = option.querySelector('value')?.textContent;
                return {
                    value,
                    label: option.getAttribute('label'),
                    selected: values.includes(value),
                    required: !!field.querySelector('required'),
                    ...result,
                };
            },
        );
        return {
            type,
            options,
            // The field's current value(s), not just the selectable options —
            // needed to echo a form back without wiping list fields.
            ...(type === 'list-single' ? { value: values[0] } : { values }),
            label: field.getAttribute('label'),
            var: v,
            required: !!field.querySelector('required'),
            ...result,
        };
    } else if (type === 'fixed') {
        const text = field.querySelector('value')?.textContent;
        return { text, label, type, var: v, ...result };
    } else if (type === 'jid-multi' || type === 'text-multi') {
        const values = Array.from(field.querySelectorAll(':scope > value')).map((el) => el?.textContent);
        return {
            type,
            var: v,
            label,
            values,
            required: !!field.querySelector('required'),
            ...result,
        };
    } else if (type === 'boolean') {
        const value = field.querySelector('value')?.textContent;
        return {
            type,
            var: v,
            label,
            checked: ((value === '1' || value === 'true') && true) || false,
            ...result,
        };
    } else if (v === 'url') {
        return {
            var: v,
            label,
            value: field.querySelector('value')?.textContent,
            ...result,
        };
    } else if (v === 'username') {
        return {
            var: v,
            label,
            value: field.querySelector('value')?.textContent,
            required: !!field.querySelector('required'),
            type: getInputType(field),
            ...result,
        };
    } else if (v === 'password') {
        return {
            var: v,
            label,
            value: field.querySelector('value')?.textContent,
            required: !!field.querySelector('required'),
            ...result,
        };
    } else if (v === 'ocr') {
        // Captcha
        const uri = field.querySelector('uri');
        const el = sizzle('data[cid="' + uri.textContent.replace(/^cid:/, '') + '"]', stanza)[0];
        return {
            label: field.getAttribute('label'),
            var: v,
            uri: {
                type: uri.getAttribute('type'),
                data: el?.textContent,
            },
            required: !!field.querySelector('required'),
            ...result,
        };
    } else {
        return {
            label,
            var: v,
            required: !!field.querySelector('required'),
            value: field.querySelector('value')?.textContent,
            type: getInputType(field),
            ...result,
        };
    }
}

/**
 * @param {Element} field
 */
function getInputType(field) {
    const type = XFORM_TYPE_MAP[field.getAttribute('type')];
    if (type == 'text') {
        const datatypes = field.getElementsByTagNameNS('http://jabber.org/protocol/xdata-validate', 'validate');
        if (datatypes.length === 1) {
            const datatype = datatypes[0].getAttribute('datatype');
            return XFORM_VALIDATE_TYPE_MAP[datatype] || type;
        }
    }
    return type;
}

/**
 * @param {Element} stanza
 * @returns {import('./types').XForm}
 */
function parseXForm(stanza) {
    const xs = sizzle(`x[xmlns="${Strophe.NS.XFORM}"]`, stanza);
    if (xs.length > 1) {
        src_log.error(stanza);
        throw new Error('Invalid stanza');
    } else if (xs.length === 0) {
        return null;
    }

    const x = xs[0];
    const type = /** @type {import('./types').XFormResponseType} */ (x.getAttribute('type'));
    const result = {
        type,
        title: x.querySelector('title')?.textContent,
    };

    if (type === 'result') {
        const reported = x.querySelector(':scope > reported');
        if (reported) {
            const reported_fields = reported ? Array.from(reported.querySelectorAll(':scope > field')) : [];
            const items = Array.from(x.querySelectorAll(':scope > item'));
            return /** @type {import('./types').XForm} */ ({
                ...result,
                reported: /** @type {import('./types').XFormReportedField[]} */ (reported_fields.map(getAttributes)),
                items: items.map((item) => {
                    return Array.from(item.querySelectorAll('field')).map((field) => {
                        return /** @type {import('./types').XFormResultItemField} */ ({
                            ...getAttributes(field),
                            value: field.querySelector('value')?.textContent ?? '',
                        });
                    });
                }),
            });
        }
        return {
            ...result,
            fields: Array.from(x.querySelectorAll('field')).map((field) => parseXFormField(field, true, stanza)),
        };
    } else if (type === 'form') {
        return {
            ...result,
            instructions: x.querySelector('instructions')?.textContent,
            fields: Array.from(x.querySelectorAll('field')).map((field) => parseXFormField(field, false, stanza)),
        };
    } else {
        throw new Error(`Invalid type in XForm response stanza: ${type}`);
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/index.js









;// CONCATENATED MODULE: ./src/headless/shared/color.js



const { safeSave: color_safeSave, colorize: color_colorize } = headless_utils;

/**
 * @template {import('./types').ModelExtender} T
 * @param {T} BaseModel
 */
function color_ColorAwareModel(BaseModel) {

    return class ColorAwareModel extends BaseModel {
        async setColor() {
            const color = await color_colorize(this.getIdentifier());
            color_safeSave(this, { color });
        }

        getIdentifier() {
            if (this.get('type') === CHATROOMS_TYPE) {
                return this.get('jid');
            } else if (this.get('type') === 'groupchat') {
                return this.get('from_real_jid') || this.get('from');
            } else {
                return this.get('occupant_id') || this.get('jid') || this.get('from') || this.get('nick');
            }
        }

        /**
        * @returns {Promise<string>}
        */
        async getColor() {
            if (!this.get('color')) {
                await this.setColor();
            }
            return this.get('color');
        }

        /**
        * @param {string} append_style
        * @returns {Promise<string>}
        */
        async getAvatarStyle(append_style = '') {
            try {
                const color = await this.getColor();
                return `background-color: ${color} !important; ${append_style}`;
            } catch {
                return `background-color: gray !important; ${append_style}`;
            }
        }
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/model-with-contact.js







/**
 * @template {import('./types').ModelExtender} T
 * @param {T} BaseModel
 */
function model_with_contact_ModelWithContact(BaseModel) {
    return class ModelWithContact extends BaseModel {
        /**
         * @typedef {import('../plugins/roster/contact').default} RosterContact
         * @typedef {import('./_converse.js').Profile} Profile
         */

        initialize() {
            super.initialize();

            this.on('change:num_unread', () => this.updateContactUnreadCounter());
            this.on('contact:add', () => this.updateContactUnreadCounter());

            this.rosterContactAdded = openpromise_getOpenPromise();
            this.onClosedChanged = () => this.setModelContact(this.get('jid'));
            /**
             * @public
             * @type {RosterContact|Profile}
             */
            this.contact = null;
        }

        updateContactUnreadCounter() {
            if (this.contact && this.get('type') === PRIVATE_CHAT_TYPE) {
                headless_utils.safeSave(this.contact, { num_unread: this.get('num_unread') });
            }
        }

        /**
         * @param {string} jid
         * @param {object} [options]
         * @param {boolean} [options.create=true] - Whether to add a (non-persistent)
         *     roster contact when none exists. Pass `false` to resolve only an
         *     existing contact (or our own profile) without touching the roster.
         */
        async setModelContact(jid, { create = true } = {}) {
            if (this.contact?.get('jid') === jid) return;

            if (this.get('type') === PRIVATE_CHAT_TYPE && this.get('closed')) {
                this.off('change:closed', this.onClosedChanged);
                this.on('change:closed', this.onClosedChanged);
                return;
            }

            const { session, state } = shared_converse;

            let contact;
            if (Strophe.getBareJidFromJid(jid) === session.get('bare_jid')) {
                contact = state.profile;
            } else {
                contact = await shared_api.contacts.get(jid);

                // A JID without a localpart (a server, a service or XEP-0100 gateway)
                // can't be made into a roster contact, but we can still chat with it.
                if (!contact && create && headless_utils.isValidJID(jid) && !(await shared_api.blocklist.get()).get(jid)) {
                    contact = await shared_api.contacts.add({ jid }, false, false);
                }
            }

            if (contact) {
                this.contact = contact;
                this.set('nickname', contact.get('nickname'));

                this.listenTo(this.contact, 'vcard:add', (changed) => {
                    this.trigger('contact:change', changed);
                });

                this.listenTo(this.contact, 'vcard:change', (changed) => {
                    this.trigger('contact:change', changed);
                });

                this.listenTo(this.contact, 'change', (changed) => {
                    if (changed.nickname) {
                        this.set('nickname', changed.nickname);
                    }
                    this.trigger('contact:change', changed);
                });

                this.listenTo(this.contact, 'destroy', () => {
                    delete this.contact;
                    this.trigger('contact:destroy');
                });

                this.rosterContactAdded.resolve();
                this.trigger('contact:add', this.contact);
            }
        }
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/parsers.js


const { u: parsers_u } = api_public.env;

/**
 * @param {Element} iq
 * @returns {Promise<import("./types").VCardResult>}
 */

async function parseVCardResultStanza(iq) {
    const image = iq.querySelector(':scope > vCard PHOTO BINVAL')?.textContent;
    const image_hash = image
        ? parsers_u.arrayBufferToHex(await crypto.subtle.digest('SHA-1', parsers_u.base64ToArrayBuffer(image)))
        : undefined;

    return {
        email: iq.querySelector(':scope > vCard EMAIL USERID')?.textContent,
        error: undefined,
        fullname: iq.querySelector(':scope > vCard FN')?.textContent,
        image,
        image_hash,
        image_type: iq.querySelector(':scope > vCard PHOTO TYPE')?.textContent,
        nickname: iq.querySelector(':scope > vCard NICKNAME')?.textContent,
        role: iq.querySelector(':scope > vCard ROLE')?.textContent,
        stanza: iq, // TODO: remove?
        url: iq.querySelector(':scope > vCard URL')?.textContent,
        vcard_error: undefined,
        vcard_updated: new Date().toISOString(),
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/utils.js
/**
 * @typedef {import('../../plugins/chat/message').default} Message
 * @typedef {import('../../plugins/muc/message').default} MUCMessage
 * @typedef {import('../../plugins/status/profile').default} Profile
 * @typedef {import('../../plugins/vcard/vcards').default} VCards
 * @typedef {import('../../plugins/vcard/vcard').default} VCard
 * @typedef {import('../../shared/model-with-contact.js').default} ModelWithContact
 * @typedef {import('../muc/occupant.js').default} MUCOccupant
 * @typedef {import('@converse/skeletor').Model} Model
 */









const { Stanza: utils_Stanza, Strophe: utils_Strophe, sizzle: utils_sizzle, stx: utils_stx } = api_public.env;

utils_Strophe.addNamespace('VCARD_UPDATE', 'vcard-temp:x:update');

/**
 * @param {"get"|"set"|"result"} type
 * @param {string} jid
 * @param {Element} [vcard_el]
 */
function createStanza(type, jid, vcard_el) {
    const iq = utils_stx`
        <iq type="${type}"
            ${jid ? utils_Stanza.unsafeXML(`to="${jid}"`) : ''}
            xmlns="jabber:client">
            ${vcard_el ? '' : utils_stx`<vCard xmlns="${utils_Strophe.NS.VCARD}"></vCard>`}
        </iq>`;

    if (vcard_el) iq.cnode(vcard_el);

    return iq;
}

/**
 * @param {MUCOccupant} occupant
 */
function onOccupantAvatarChanged(occupant) {
    const hash = occupant.get('image_hash');
    const vcards = [];
    if (occupant.get('jid')) {
        vcards.push(shared_converse.state.vcards.get(occupant.get('jid')));
    }
    vcards.push(shared_converse.state.vcards.get(occupant.get('from')));
    vcards.forEach((v) => hash && v && v?.get('image_hash') !== hash && shared_api.vcard.update(v, true));
}

/**
 * @param {Model|MUCOccupant|MUCMessage} model
 * @param {boolean} [lazy_load=false]
 * @returns {Promise<VCard|null>}
 */
async function getVCardForModel(model, lazy_load = false) {
    await shared_api.waitUntil('VCardsInitialized');

    let vcard;
    if (model instanceof shared_converse.exports.MUCOccupant) {
        vcard = await getVCardForOccupant(/** @type {MUCOccupant} */ (model), lazy_load);
    } else if (model instanceof shared_converse.exports.MUCMessage) {
        vcard = await getVCardForMUCMessage(/** @type {MUCMessage} */ (model), lazy_load);
    } else {
        let jid;
        if (model instanceof shared_converse.exports.Message) {
            const message = /** @type {Message} */ (model);
            if (['error', 'info'].includes(message.get('type'))) {
                return;
            }
            jid = utils_Strophe.getBareJidFromJid(message.get('from'));
        } else if (typeof (/** @type {Model} */ (model).getVCardJID) === 'function') {
            // A model can name the JID whose vCard represents it.
            jid = /** @type {Model} */ (model).getVCardJID();
        } else {
            jid = /** @type {Model} */ (model).get('jid');
        }

        if (!jid) {
            src_log.warn(`Could not set VCard on model because no JID found!`);
            return null;
        }
        const { vcards } = shared_converse.state;
        vcard = vcards.get(jid) || vcards.create({ jid }, { lazy_load });
    }

    if (vcard) {
        vcard.on('change', () => model.trigger('vcard:change'));
    }
    return vcard;
}

/**
 * @param {MUCOccupant} occupant
 * @param {boolean} [lazy_load=false]
 * @returns {Promise<VCard|null>}
 */
async function getVCardForOccupant(occupant, lazy_load = true) {
    await shared_api.waitUntil('VCardsInitialized');

    const { vcards, profile } = shared_converse.state;
    const muc = occupant?.collection?.chatroom;
    const nick = occupant.get('nick');

    if (nick && muc?.get('nick') === nick) {
        return profile.vcard;
    } else {
        const jid = occupant.get('jid') || occupant.get('from');
        if (jid) {
            return vcards.get(jid) || vcards.create({ jid }, { lazy_load });
        } else {
            src_log.debug(`Could not get VCard for occupant because no JID found!`);
            return null;
        }
    }
}

/**
 * @param {MUCMessage} message
 * @param {boolean} [lazy_load=true]
 * @returns {Promise<VCard|null>}
 */
async function getVCardForMUCMessage(message, lazy_load = true) {
    if (['error', 'info'].includes(message.get('type'))) return;

    await shared_api.waitUntil('VCardsInitialized');
    const { vcards, profile } = shared_converse.state;
    const muc = message?.collection?.chatbox;
    const nick = utils_Strophe.getResourceFromJid(message.get('from'));

    if (nick && muc?.get('nick') === nick) {
        return profile.vcard;
    } else {
        const jid = message.occupant?.get('jid') || message.get('from');
        if (jid) {
            return vcards.get(jid) || vcards.create({ jid }, { lazy_load });
        } else {
            src_log.warn(`Could not get VCard for message because no JID found! msgid: ${message.get('msgid')}`);
            return null;
        }
    }
}

function clearVCardsSession() {
    if (shouldClearCache(shared_converse)) {
        shared_api.promises.add('VCardsInitialized');
        if (shared_converse.state.vcards) {
            shared_converse.state.vcards.clearStore();
            Object.assign(shared_converse, { vcards: undefined }); // XXX DEPRECATED
            delete shared_converse.state.vcards;
        }
    }
}

// Bare JIDs whose XEP-0172 nick node we've already retrieved this session, so we
// fetch it at most once per contact (see maybeFetchPublishedNick).
const nick_fetched = new Set();

/**
 * Best-effort XEP-0172 active retrieval (XEP-0060 § 6.5): fetch a contact's
 * published nickname from their PEP node and apply it, once per session and only
 * for our own JID and roster contacts (the XEP-0172 audience), so it doesn't fan
 * out to MUC occupants or arbitrary social-feed authors. Runs fire-and-forget so
 * it never blocks the vcard-temp result; a missing/unreadable node leaves any
 * existing `pep_nickname` untouched.
 * @param {string} jid
 */
function maybeFetchPublishedNick(jid) {
    if (!shared_api.pubsub?.items) return;
    const bare = utils_Strophe.getBareJidFromJid(jid);
    const is_target = bare === shared_converse.session.get('bare_jid') || !!shared_converse.state.roster?.get(bare);
    if (!is_target || nick_fetched.has(bare)) return;
    nick_fetched.add(bare);

    shared_api.pubsub.items.get(jid, utils_Strophe.NS.NICK, { max_items: 1 })
        .then(({ items }) => {
            const item = items?.[0];
            const nick = item ? utils_sizzle(`nick[xmlns="${utils_Strophe.NS.NICK}"]`, item).pop()?.textContent?.trim() : undefined;
            if (nick) setNickForJID(bare, nick);
        })
        .catch(() => {
            // Node absent, access denied, or unsupported: nothing to apply.
        });
}

/**
 * @param {string} jid
 */
async function fetchVCard(jid) {
    const bare_jid = shared_converse.session.get('bare_jid');
    const to = utils_Strophe.getBareJidFromJid(jid) === bare_jid ? null : jid;
    maybeFetchPublishedNick(jid);
    let iq;
    try {
        iq = await shared_api.sendIQ(createStanza('get', to));
    } catch (error) {
        const parsed_error = isElement(error) ? await parseErrorStanza(error) : error;
        const error_msg = parsed_error?.message;
        return {
            jid,
            stanza: isElement(error) ? error : null, // TODO: remove?
            error: error_msg,
            vcard_error: new Date().toISOString(),
        };
    }
    return parseVCardResultStanza(iq);
}

/**
 * Apply an XEP-0172 nickname to a JID's VCard model, storing it under
 * `pep_nickname` (never `nickname`, which vcard-temp owns and would clobber on
 * refetch). The VCard is created if we don't have one yet. An empty/undefined
 * nick clears the value, so the display name falls back to the vCard name and
 * then the JID.
 * @param {string} jid - The bare JID asserting the nickname.
 * @param {string} [nick]
 */
function setNickForJID(jid, nick) {
    const { vcards } = shared_converse.state;
    const vcard = vcards.get(jid) || vcards.create({ jid }, { lazy_load: true });
    // Idempotent: saving an unchanged value fires no `change`.
    vcard?.save({ pep_nickname: nick || undefined });
}

/**
 * @param {Element} pres
 */
async function handleVCardUpdatePresence(pres) {
    await shared_api.waitUntil('VCardsInitialized');

    // MUC occupant updates are handled in onOccupantAvatarChanged
    const is_muc = utils_sizzle(`x[xmlns="http://jabber.org/protocol/muc#user"]`, pres).length > 0;
    if (is_muc) return;

    const from_jid = utils_Strophe.getBareJidFromJid(pres.getAttribute('from'));

    // XEP-0153: refetch the vCard when the advertised avatar hash changed.
    const photo = utils_sizzle(`x[xmlns="${utils_Strophe.NS.VCARD_UPDATE}"] photo`, pres).pop();
    if (photo) {
        const avatar_hash = photo.textContent;
        const vcard = await shared_converse.state.vcards.get(from_jid);
        if (vcard?.get('image_hash') !== avatar_hash) {
            shared_api.vcard.update(from_jid, true).catch((e) => src_log.error(e));
        }
    }

    // XEP-0172: apply a nickname hint carried directly in the presence.
    const nick_el = utils_sizzle(`nick[xmlns="${utils_Strophe.NS.NICK}"]`, pres).pop();
    if (nick_el) {
        setNickForJID(from_jid, nick_el.textContent?.trim());
    }
}

let presence_ref;

function unregisterPresenceHandler() {
    if (presence_ref) {
        const connection = shared_api.connection.get();
        connection.deleteHandler(presence_ref);
        presence_ref = null;
    }
}

function registerPresenceHandler() {
    unregisterPresenceHandler();
    const connection = shared_api.connection.get();
    presence_ref = connection.addHandler(
        /** @param {Element} pres */
        (pres) => {
            try {
                handleVCardUpdatePresence(pres);
            } catch (e) {
                src_log.error(e);
            }
            return true;
        },
        null,
        'presence',
        null,
    );
}

/**
 * Handle an inbound XEP-0172 User Nickname update delivered as a PEP event
 * (node `http://jabber.org/protocol/nick`), so a contact's display name
 * re-renders when they change it.
 * @param {Element} message
 */
async function handleNickUpdate(message) {
    const items = utils_sizzle(`event[xmlns="${utils_Strophe.NS.PUBSUB}#event"] items[node="${utils_Strophe.NS.NICK}"]`, message).pop();
    if (!items) return;

    const from_jid = utils_Strophe.getBareJidFromJid(message.getAttribute('from'));
    if (!from_jid) return;

    await shared_api.waitUntil('VCardsInitialized');

    const nick = utils_sizzle(`item nick[xmlns="${utils_Strophe.NS.NICK}"]`, items).pop()?.textContent?.trim();
    setNickForJID(from_jid, nick);
}

let nick_ref;

function unregisterNickHandler() {
    if (nick_ref) {
        const connection = shared_api.connection.get();
        connection.deleteHandler(nick_ref);
        nick_ref = null;
    }
}

function registerNickHandler() {
    unregisterNickHandler();
    const connection = shared_api.connection.get();
    nick_ref = connection.addHandler(
        /** @param {Element} message */
        (message) => {
            handleNickUpdate(message).catch((e) => src_log.error(e));
            return true;
        },
        `${utils_Strophe.NS.PUBSUB}#event`,
        'message',
    );
}

let last_published_nick;

/**
 * Reset the module-level XEP-0172 session state (own published nick and the
 * once-per-contact retrieval guard), so a fresh session republishes and refetches.
 */
function resetNickState() {
    last_published_nick = undefined;
    nick_fetched.clear();
}

/**
 * Publish our own nickname to our PEP node (XEP-0172 § 3), so contacts
 * are notified when it changes.
 * @returns {Promise<void>}
 */
async function publishOwnNickname() {
    if (!shared_api.pubsub?.publish) return;

    const { profile } = shared_converse.state;
    if (!profile) return;

    const nick = profile.getNickname() || '';
    if (nick === (last_published_nick ?? '')) return; // unchanged since last publish
    if (last_published_nick === undefined && !nick) return; // nothing published yet, nothing to clear

    const item = utils_stx`<item id="current"><nick xmlns="${utils_Strophe.NS.NICK}">${nick}</nick></item>`;
    try {
        await shared_api.pubsub.publish(null, utils_Strophe.NS.NICK, item, { persist_items: true, max_items: 1 }, false);
        last_published_nick = nick;
    } catch (e) {
        src_log.error(e);
    }
}

/**
 * @param {import('strophe.js').Builder} stanza
 */
function updatePresence(stanza) {
    if (utils_sizzle(`x[xmlns=${utils_Strophe.NS.VCARD_UPDATE}"]`, stanza.root()).length === 0) {
        const node = utils_stx`<x xmlns="${utils_Strophe.NS.VCARD_UPDATE}"></x>`;
        stanza.root().cnode(node).up();
    }
    return stanza;
}

;// CONCATENATED MODULE: ./src/headless/shared/model-with-vcard.js



/**
 * @template {import('./types').ModelExtender} T
 * @param {T} BaseModel
 */
function model_with_vcard_ModelWithVCard(BaseModel) {
    /**
     * @typedef {import('../plugins/vcard/vcard').default} VCard
     */

    return class ModelWithVCard extends BaseModel {
        /**
         * @param {any[]} args
         */
        constructor(...args) {
            super(...args);
            this._vcard = null;
            this.lazy_load_vcard = false;
        }

        initialize() {
            super.initialize();
            this.getVCard();
        }

        get vcard() {
            return this._vcard;
        }

        /**
         * @returns {Promise<VCard|null>}
         */
        async getVCard() {
            const { pluggable } = shared_converse;
            if (!pluggable.plugins["converse-vcard"]?.enabled(shared_converse)) return null;

            if (this._vcard) return this._vcard;

            this._vcard = await getVCardForModel(this, this.lazy_load_vcard);
            this.trigger("vcard:add", { vcard: this._vcard });

            return this._vcard;
        }
    };
}

;// CONCATENATED MODULE: ./src/headless/shared/http-upload.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 *
 * XEP-0363 HTTP File Upload: discover the upload service, request a slot, and PUT the
 * file.
 *
 * Two ways in. {@link uploadFile} does the whole flow and resolves to the public GET
 * URL, which is what a consumer without a chat wants (the Social composer). Chat instead
 * drives {@link requestSlot} and {@link putFile} itself, because it has to record the
 * slot URLs and the progress on a message model as it goes, and reports failures as
 * messages in the conversation rather than as exceptions.
 */








const { stx: http_upload_stx } = api_public.env;

/**
 * Discover the HTTP-Upload service (XEP-0363 § 3) advertised by `domain`.
 * @param {string} [domain] - Defaults to our own server's domain.
 * @returns {Promise<import('./types').UploadService|null>} `null` when the server offers
 *      no upload service.
 */
async function getUploadService(domain) {
    domain = domain || shared_converse.session.get('domain');
    const items = await shared_api.disco.features.get(Strophe.NS.HTTPUPLOAD, domain);
    const item = items.pop();
    if (!item?.id) return null;

    const data = item.dataforms?.where({ FORM_TYPE: { value: Strophe.NS.HTTPUPLOAD, type: 'hidden' } }).pop();
    const max = parseInt((data?.attributes || {})['max-file-size']?.value, 10);
    return { slot_request_url: item.id, max_file_size: isNaN(max) ? Infinity : max };
}

/**
 * The `code` on the error {@link requestSlot} throws when the service answered, but with
 * no slot in it. Distinguishable from the IQ itself failing, which the chat upload path
 * reports differently.
 */
const NO_SLOT = 'no-slot';

/**
 * Request an upload slot for `file` (XEP-0363 § 4).
 * @param {File} file
 * @param {string} slot_request_url
 * @returns {Promise<import('./types').UploadSlot>}
 * @throws The IQ error on failure, or an `Error` with `code === NO_SLOT` if the response
 *      carried no slot.
 */
async function requestSlot(file, slot_request_url) {
    const iq = http_upload_stx`
        <iq from="${shared_converse.session.get('jid')}"
            to="${slot_request_url}"
            type="get"
            xmlns="jabber:client">
            <request xmlns="${Strophe.NS.HTTPUPLOAD}"
                     filename="${file.name}"
                     size="${file.size}"
                     content-type="${file.type}"></request>
        </iq>`;

    const stanza = await shared_api.sendIQ(iq);
    const slot = sizzle(`slot[xmlns="${Strophe.NS.HTTPUPLOAD}"]`, stanza).pop();
    if (!slot) throw Object.assign(new Error('The upload service returned no slot'), { code: NO_SLOT });

    // Only Authorization and Expires can be set from JS. Cookie can't: it has to be set
    // via document.cookie instead, so it is dropped here (XEP-0363 § 4).
    const headers = sizzle('put header', slot)
        .map((h) => ({ name: h.getAttribute('name'), value: h.textContent }))
        .filter((h) => ['Authorization', 'Expires'].includes(h.name));
    return {
        get: slot.querySelector('get').getAttribute('url'),
        put: slot.querySelector('put').getAttribute('url'),
        headers,
    };
}

/**
 * PUT `file` to the slot's put URL (XEP-0363 § 5).
 *
 * The browser and Node take different paths because `XMLHttpRequest` is
 * the only API that reports upload progress and Node has no `XMLHttpRequest`.
 * Under Node the simpler `fetch` path is used and `onProgress` is ignored.
 * @param {File} file
 * @param {import('./types').UploadTarget} slot
 * @param {(fraction: number) => void} [onProgress]
 * @returns {Promise<void>}
 * @throws An `Error` carrying the `status` and `responseText`, so a caller can quote the
 *      server's own complaint back to the user.
 */
function putFile(file, slot, onProgress) {
    return IS_BROWSER ? putFileWithXHR(file, slot, onProgress) : putFileWithFetch(file, slot);
}

/**
 * The browser upload: `XMLHttpRequest` so that `onProgress` can be driven from
 * the `upload` progress events.
 * @param {File} file
 * @param {import('./types').UploadTarget} slot
 * @param {(fraction: number) => void} [onProgress]
 * @returns {Promise<void>}
 */
function putFileWithXHR(file, slot, onProgress) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const fail = (/** @type {string} */ msg) =>
            reject(Object.assign(new Error(msg), { status: xhr.status, responseText: xhr.responseText }));

        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;
            src_log.info(`http-upload: PUT status ${xhr.status}`);
            if (xhr.status === 200 || xhr.status === 201) resolve();
            else fail(`Upload failed (HTTP ${xhr.status})`);
        };
        if (onProgress) {
            xhr.upload.addEventListener('progress', (evt) => {
                if (evt.lengthComputable) onProgress(evt.loaded / evt.total);
            });
        }
        xhr.onerror = () => fail('The file upload failed');
        xhr.open('PUT', slot.put, true);
        xhr.setRequestHeader('Content-type', file.type);
        slot.headers?.forEach((h) => xhr.setRequestHeader(h.name, h.value));
        xhr.send(file);
    });
}

/**
 * The Node upload: `fetch` with the file as the body. No progress is reported,
 * because `fetch` cannot without a streamed request body. Throws with the same
 * `status`/`responseText` shape as the XHR path, so callers handle both alike.
 * @param {File} file
 * @param {import('./types').UploadTarget} slot
 * @returns {Promise<void>}
 */
async function putFileWithFetch(file, slot) {
    const headers = /** @type {Record<string, string>} */ ({ 'Content-type': file.type });
    slot.headers?.forEach((h) => (headers[h.name] = h.value));

    let response;
    try {
        response = await fetch(slot.put, { method: 'PUT', body: file, headers });
    } catch (e) {
        throw Object.assign(new Error('The file upload failed'), { status: 0, responseText: String(e) });
    }

    src_log.info(`http-upload: PUT status ${response.status}`);
    if (response.status !== 200 && response.status !== 201) {
        const responseText = await response.text().catch(() => '');
        throw Object.assign(new Error(`Upload failed (HTTP ${response.status})`), {
            status: response.status,
            responseText,
        });
    }
}

/**
 * Upload `file` via XEP-0363 and resolve to its public URL plus metadata.
 * @param {File} file
 * @param {object} [opts]
 * @param {string} [opts.domain] - Upload service host (defaults to our own domain).
 * @param {(fraction: number) => void} [opts.onProgress] - Upload progress (0..1).
 * @returns {Promise<import('./types').UploadedFile>}
 * @throws when no service is available, the file is too large, or the PUT fails.
 */
async function uploadFile(file, { domain, onProgress } = {}) {
    const service = await getUploadService(domain);
    if (!service) throw new Error('No HTTP file upload service is available');
    if (file.size > service.max_file_size) throw new Error('The file is too large to upload');

    const slot = await requestSlot(file, service.slot_request_url);
    await putFile(file, slot, onProgress);
    src_log.info(`http-upload: uploaded ${file.name} -> ${slot.get}`);
    return { url: slot.get, name: file.name, type: file.type, size: file.size };
}

;// CONCATENATED MODULE: ./src/headless/shared/message.js













const { dayjs: message_dayjs } = api_public.env;

/**
 * @extends {Model<import('./types').BaseMessageAttributes>}
 */
class BaseMessage extends model_with_vcard_ModelWithVCard(model_with_contact_ModelWithContact(color_ColorAwareModel(skeletor_esm_Model))) {
    defaults() {
        return {
            msgid: getUniqueId(),
            time: new Date().toISOString(),
            is_ephemeral: false,
        };
    }

    /**
     * @param {import('./types').MessageAttributes} attrs
     * @param {import('@converse/skeletor').ModelOptions} options
     */
    constructor(attrs, options) {
        super(attrs, options);
        this.file = null;
    }

    initialize() {
        this.lazy_load_vcard = true;
        super.initialize();

        this.chatbox = this.collection?.chatbox;
        if (!this.checkValidity()) return;

        if (this.get('file')) {
            this.on('change:put', () => this.uploadFile());
        }
        this.on('change:is_ephemeral', () => this.setTimerForEphemeralMessage());
        this.setTimerForEphemeralMessage();
    }

    checkValidity() {
        if (Object.keys(this.attributes).length === 3) {
            // XXX: This is an empty message with only the 3 default values.
            // This seems to happen when saving a newly created message
            // fails for some reason.
            // TODO: This is likely fixable by setting `wait` when
            // creating messages. See the wait-for-messages branch.
            this.validationError = 'Empty message';
            this.safeDestroy();
            return false;
        }
        return true;
    }

    safeDestroy() {
        try {
            this.destroy();
        } catch (e) {
            src_log.warn(`safeDestroy: ${e}`);
        }
    }

    /**
     * Sets an auto-destruct timer for this message, if it's is_ephemeral.
     */
    setTimerForEphemeralMessage() {
        if (this.ephemeral_timer) {
            clearTimeout(this.ephemeral_timer);
            this.ephemeral_timer = null;
        }
        if (!this.isEphemeral()) return;

        // Some ephemeral messages (e.g. an OMEMO "couldn't be decrypted" notice)
        // shouldn't start counting down until we're confident the user has seen
        // them. For those the countdown is started externally (by the view, once
        // the message scrolls into view) via `startEphemeralTimer`.
        if (this.get('defer_ephemeral_timer')) return;

        this.startEphemeralTimer();
    }

    /**
     * Start the auto-destruct countdown for this ephemeral message.
     * Safe to call more than once; the running timer is reset each time.
     */
    startEphemeralTimer() {
        const is_ephemeral = this.isEphemeral();
        if (!is_ephemeral) return;
        if (this.ephemeral_timer) clearTimeout(this.ephemeral_timer);
        const timeout = typeof is_ephemeral === 'number' ? is_ephemeral : 10000;
        this.ephemeral_timer = setTimeout(() => this.safeDestroy(), timeout);
    }

    /**
     * Returns a boolean indicating whether this message is ephemeral,
     * meaning it will get automatically removed after ten seconds.
     * @returns {boolean | number}
     */
    isEphemeral() {
        return this.get('is_ephemeral');
    }

    /**
     * Returns a boolean indicating whether this message is a XEP-0245 /me command.
     * @returns {boolean}
     */
    isMeCommand() {
        const text = this.getMessageText();
        if (!text) {
            return false;
        }
        return text.startsWith('/me ');
    }

    /**
     * @returns {boolean}
     */
    isRetracted() {
        return !!(this.get('retracted') || this.get('moderated') === 'retracted');
    }

    /**
     * Returns a boolean indicating whether this message is considered a followup
     * message from the previous one. Followup messages are shown grouped together
     * under one author heading.
     * A message is considered a followup of it's predecessor when it's a chat
     * message from the same author, within 10 minutes.
     * @returns {boolean}
     */
    isFollowup() {
        const messages = this.collection?.models;
        if (!messages) {
            // Happens during tests
            return false;
        }
        const idx = messages.indexOf(this);
        const prev_model = idx ? messages[idx - 1] : null;
        if (prev_model === null) {
            return false;
        }
        const date = message_dayjs(this.get('time'));
        return (
            this.get('from') === prev_model.get('from') &&
            !this.isRetracted() &&
            !prev_model.isRetracted() &&
            !this.isMeCommand() &&
            !prev_model.isMeCommand() &&
            !!this.get('is_encrypted') === !!prev_model.get('is_encrypted') &&
            this.get('type') === prev_model.get('type') &&
            this.get('type') !== 'info' &&
            date.isBefore(message_dayjs(prev_model.get('time')).add(10, 'minutes')) &&
            (this.get('type') === 'groupchat' ? this.get('occupant_id') === prev_model.get('occupant_id') : true)
        );
    }

    /**
     * Determines whether this message may be retracted by the current user.
     * @returns { Boolean }
     */
    mayBeRetracted() {
        const is_own_message = this.get('sender') === 'me';
        const not_canceled = this.get('error_type') !== 'cancel';
        return is_own_message && not_canceled && ['all', 'own'].includes(shared_api.settings.get('allow_message_retraction'));
    }

    getMessageText() {
        let text;
        if (this.get('is_encrypted')) {
            const { __ } = shared_converse;
            text = this.get('plaintext') || this.get('body') || __('Undecryptable OMEMO message');
        } else if (['groupchat', 'chat', 'normal'].includes(this.get('type'))) {
            text = this.get('body');
        } else {
            text = this.get('message');
        }
        return this.stripReplyFallback(text);
    }

    /**
     * Strip the XEP-0461 compatibility fallback — the `>`-quoted copy of the
     * replied-to message — from `text`. Converse renders the reply context from
     * the structured `<reply>`, so per XEP-0461 it must not also show the quoted
     * fallback. Offsets are XEP-0426 Unicode code points, so we slice on the
     * code-point array rather than UTF-16 units.
     * @param {string} text
     * @returns {string}
     */
    stripReplyFallback(text) {
        const fallback = this.get('fallback')?.[Strophe.NS.REPLY];
        if (!text || !fallback || !this.get('reply_to_id')) return text;
        const chars = [...text];
        return chars.slice(0, fallback.start).join('') + chars.slice(fallback.end).join('');
    }

    /**
     * Request an upload slot (XEP-0363 § 4) and record it on the message, which starts
     * the upload: saving `put` fires the `change:put` handler set up in `initialize`.
     *
     * The protocol itself lives in `http-upload.js`; what belongs here is reporting a
     * failure as an ephemeral error message in the conversation.
     */
    async getRequestSlotURL() {
        const { __ } = shared_converse;
        if (!this.file) {
            src_log.error('getRequestSlotURL called with no file');
            return;
        }
        let slot;
        try {
            slot = await requestSlot(this.file, this.get('slot_request_url'));
        } catch (e) {
            src_log.error(e);
            return this.save({
                is_ephemeral: true,
                message:
                    e.code === NO_SLOT
                        ? __('Sorry, could not determine file upload URL.')
                        : __('Sorry, could not determine upload URL.'),
                type: 'error',
            });
        }
        this.upload_metadata = { headers: slot.headers };
        this.save({ get: slot.get, put: slot.put });
    }

    /**
     * PUT the file to the slot recorded by {@link getRequestSlotURL}, tracking progress
     * on the message so the UI can show a progress bar.
     *
     * Called off a `change:put` listener, so nothing awaits it: it has to settle its own
     * failures rather than reject.
     */
    async uploadFile() {
        const { __ } = shared_converse;
        try {
            await putFile(this.file, { put: this.get('put'), headers: this.upload_metadata?.headers }, (fraction) =>
                this.set('progress', fraction),
            );
        } catch (e) {
            src_log.error(e);
            return this.save({
                is_ephemeral: true,
                message: e.responseText
                    ? __(
                          'Sorry, could not successfully upload your file. Your server’s response: "%1$s"',
                          e.responseText,
                      )
                    : __('Sorry, could not successfully upload your file.'),
                type: 'error',
                upload: FAILURE,
            });
        }

        let attrs = {
            body: this.get('get'),
            message: this.get('get'),
            oob_url: this.get('get'),
            upload: SUCCESS,
        };
        /**
         * *Hook* which allows plugins to change the attributes
         * saved on the message once a file has been uploaded.
         * @event _converse#afterFileUploaded
         */
        attrs = await shared_api.hook('afterFileUploaded', this, attrs);
        this.save(attrs);
    }
}

/* export default */ const shared_message = (BaseMessage);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/parsers.js
/**
 * @module:plugin-chat-parsers
 */









const { Strophe: parsers_Strophe, dayjs: parsers_dayjs, sizzle: parsers_sizzle } = api_public.env;

/**
 * Parses a passed in message stanza and returns an object of attributes.
 * @param {Element} stanza - The message stanza
 * @returns {Promise<import('../../shared/types.ts').MessageAttributes|StanzaParseError>}
 */
async function parseMessage(stanza) {
    throwErrorIfInvalidForward(stanza);

    let to_jid = stanza.getAttribute('to');
    const to_resource = parsers_Strophe.getResourceFromJid(to_jid);
    const resource = shared_converse.session.get('resource');
    if (shared_api.settings.get('filter_by_resource') && to_resource && to_resource !== resource) {
        return new StanzaParseError(stanza, `Ignoring incoming message intended for a different resource: ${to_jid}`);
    }

    const bare_jid = shared_converse.session.get('bare_jid');
    const original_stanza = stanza;
    let from_jid = stanza.getAttribute('from') || bare_jid;
    if (isCarbon(stanza)) {
        if (from_jid === bare_jid) {
            const selector = `[xmlns="${parsers_Strophe.NS.CARBONS}"] > forwarded[xmlns="${parsers_Strophe.NS.FORWARD}"] > message`;
            stanza = parsers_sizzle(selector, stanza).pop();
            to_jid = stanza.getAttribute('to');
            from_jid = stanza.getAttribute('from');
        } else {
            // Prevent message forging via carbons: https://xmpp.org/extensions/xep-0280.html#security
            rejectMessage(stanza, 'Rejecting carbon from invalid JID');
            return new StanzaParseError(stanza, `Rejecting carbon from invalid JID ${to_jid}`);
        }
    }

    const is_archived = isArchived(stanza);
    if (is_archived) {
        if (from_jid === bare_jid) {
            const selector = `[xmlns="${parsers_Strophe.NS.MAM}"] > forwarded[xmlns="${parsers_Strophe.NS.FORWARD}"] > message`;
            stanza = parsers_sizzle(selector, stanza).pop();
            to_jid = stanza.getAttribute('to');
            from_jid = stanza.getAttribute('from');
        } else {
            return new StanzaParseError(
                stanza,
                `Invalid Stanza: alleged MAM message from ${stanza.getAttribute('from')}`,
            );
        }
    }

    const from_bare_jid = parsers_Strophe.getBareJidFromJid(from_jid);
    const is_me = from_bare_jid === bare_jid;
    if (is_me && to_jid === null) {
        return new StanzaParseError(
            stanza,
            `Don't know how to handle message stanza without 'to' attribute. ${stanza.outerHTML}`,
        );
    }

    const is_headline = isHeadline(stanza);
    const is_server_message = isServerMessage(stanza);
    let contact_jid;

    if (!is_headline && !is_server_message) {
        contact_jid = is_me ? parsers_Strophe.getBareJidFromJid(to_jid) : from_bare_jid;
        if (!shared_api.settings.get('allow_non_roster_messaging')) {
            const contact = await shared_api.contacts.get(contact_jid);
            if (contact === undefined) {
                src_log.error(stanza);
                return new StanzaParseError(
                    stanza,
                    `Blocking messaging with a JID not in our roster because allow_non_roster_messaging is false.`,
                );
            }
        }
    }
    const delay = parsers_sizzle(`delay[xmlns="${parsers_Strophe.NS.DELAY}"]`, original_stanza).pop();
    const marker = getChatMarker(stanza);
    const now = new Date().toISOString();
    let attrs = Object.assign(
        {
            contact_jid,
            is_archived,
            is_headline,
            is_server_message,
            'body': stanza.querySelector('body')?.textContent?.trim(),
            'chat_state': getChatState(stanza),
            'from': stanza.getAttribute('from'),
            'is_carbon': isCarbon(original_stanza),
            'is_delayed': !!delay,
            'is_markable': !!parsers_sizzle(`markable[xmlns="${parsers_Strophe.NS.MARKERS}"]`, stanza).length,
            'is_marker': !!marker,
            'is_unstyled': !!parsers_sizzle(`unstyled[xmlns="${parsers_Strophe.NS.STYLING}"]`, stanza).length,
            'marker_id': marker && marker.getAttribute('id'),
            'receipt_id': getReceiptId(stanza),
            'received': new Date().toISOString(),
            'references': getReferences(stanza),
            'sender': is_me ? 'me' : 'them',
            'subject': stanza.querySelector('subject')?.textContent,
            'thread': stanza.querySelector('thread')?.textContent,
            'time': delay ? parsers_dayjs(delay.getAttribute('stamp')).toISOString() : now,
            'to': stanza.getAttribute('to'),
            'type': stanza.getAttribute('type') || 'normal',
        },
        getErrorAttributes(stanza),
        getOutOfBandAttributes(stanza),
        getSpoilerAttributes(stanza),
        getCorrectionAttributes(stanza, original_stanza),
        getStanzaIDs(stanza, original_stanza),
        getRetractionAttributes(stanza, original_stanza),
        getEncryptionAttributes(stanza),
        getReplyAttributes(stanza),
        getFallbackAttributes(stanza),
    );

    if (attrs.is_archived) {
        const from = original_stanza.getAttribute('from');
        if (from && from !== bare_jid) {
            return new StanzaParseError(stanza, `Invalid Stanza: Forged MAM message from ${from}`);
        }
    }
    attrs = Object.assign(
        {
            'message': attrs.body || attrs.error, // TODO: Remove and use body and error attributes instead
            'is_valid_receipt_request': isValidReceiptRequest(stanza, attrs),
        },
        attrs,
    );

    // We prefer to use one of the XEP-0359 unique and stable stanza IDs
    // as the Model id, to avoid duplicates.
    attrs['id'] = attrs['origin_id'] || attrs[`stanza_id ${attrs.from}`] || headless_utils.getUniqueId();

    /**
     * *Hook* which allows plugins to add additional parsing
     * @event _converse#parseMessage
     */
    attrs = await shared_api.hook('parseMessage', stanza, attrs);

    // We call this after the hook, to allow plugins (like omemo) to decrypt encrypted
    // messages, since we need to parse the message text to determine whether
    // there are media urls.
    const metadata = await headless_utils.getMediaURLsMetadata(attrs.is_encrypted ? attrs.plaintext : attrs.body);
    return Object.assign(attrs, metadata);
}

;// CONCATENATED MODULE: ./src/headless/plugins/chat/utils.js
/**
 * @module:headless-plugins-chat-utils
 * @typedef {import('./model.js').default} ChatBox
 * @typedef {import('../../shared/types.ts').MessageAttributes} MessageAttributes
 * @typedef {import('../../shared/errors').StanzaParseError} StanzaParseError
 * @typedef {import('strophe.js').Builder} Builder
 */











const { Strophe: chat_utils_Strophe, u: chat_utils_u } = api_public.env;

/**
 * @param {Event} [event]
 */
function routeToChat(event) {
    // In fullscreen with URL routing on, the Chat app's own router owns the
    // `#converse/chat...` space (it also accepts this legacy `?jid=` form and
    // canonicalizes it), so bow out to avoid double-opening.
    if (shared_api.settings.get('enable_url_routing') && shared_api.settings.get('view_mode') === 'fullscreen') {
        return;
    }
    const hash = getRouteHash();
    if (!hash.startsWith('#converse/chat?jid=')) {
        return;
    }
    event?.preventDefault();
    const jid = hash.split('=').pop();
    if (!chat_utils_u.isValidJID(jid)) {
        return src_log.warn(`Invalid JID "${jid}" provided in URL fragment`);
    }
    shared_api.chats.open(jid);
}

/**
 * Given a stanza, determine whether it's a new
 * message, i.e. not a MAM archived one.
 * @param {Element|Model|object} message
 */
function isNewMessage(message) {
    if (message instanceof Element) {
        return !(
            sizzle(`result[xmlns="${chat_utils_Strophe.NS.MAM}"]`, message).length &&
            sizzle(`delay[xmlns="${chat_utils_Strophe.NS.DELAY}"]`, message).length
        );
    } else if (message instanceof skeletor_esm_Model) {
        message = message.attributes;
    }
    return !(message['is_delayed'] && message['is_archived']);
}

/**
 * @param {Element} stanza
 */
async function handleErrorMessage(stanza) {
    const from_jid = chat_utils_Strophe.getBareJidFromJid(stanza.getAttribute('from'));
    const bare_jid = shared_converse.session.get('bare_jid');
    if (chat_utils_u.isSameBareJID(from_jid, bare_jid)) {
        return;
    }
    const chatbox = await shared_api.chatboxes.get(from_jid);
    if (chatbox?.get('type') === PRIVATE_CHAT_TYPE) {
        chatbox?.handleErrorMessageStanza(stanza);
    }
}

function autoJoinChats() {
    // Automatically join private chats, based on the
    // "auto_join_private_chats" configuration setting.
    shared_api.settings.get('auto_join_private_chats').forEach(
        /** @param {string} jid */ (jid) => {
            if (shared_converse.state.chatboxes.where({ 'jid': jid }).length) {
                return;
            }
            if (typeof jid === 'string') {
                shared_api.chats.open(jid);
            } else {
                src_log.error('Invalid jid criteria specified for "auto_join_private_chats"');
            }
        },
    );
    /**
     * Triggered once any private chats have been automatically joined as
     * specified by the `auto_join_private_chats` setting.
     * See: https://conversejs.org/docs/configuration/#auto-join-private-chats
     *
     * @event _converse#privateChatsAutoJoined
     * @example _converse.api.listen.on('privateChatsAutoJoined', () => { ... });
     * @example _converse.api.waitUntil('privateChatsAutoJoined').then(() => { ... });
     */
    shared_api.trigger('privateChatsAutoJoined');
}

function registerMessageHandlers() {
    shared_api.connection.get().addHandler(
        /** @param {Element} stanza */
        (stanza) => {
            if (
                ['groupchat', 'error'].includes(stanza.getAttribute('type')) ||
                isHeadline(stanza) ||
                isServerMessage(stanza) ||
                isArchived(stanza)
            ) {
                return true;
            }
            return shared_converse.exports.handleMessageStanza(stanza) || true;
        },
        null,
        'message',
    );

    shared_api.connection.get().addHandler(
        /** @param {Element} stanza */
        (stanza) => {
            handleErrorMessage(stanza);
            return true;
        },
        null,
        'message',
        'error',
    );
}

/**
 * Handler method for all incoming single-user chat "message" stanzas.
 * @param {Element|Builder} stanza
 */
async function handleMessageStanza(stanza) {
    stanza = stanza instanceof Element ? stanza : stanza.tree();

    if (isServerMessage(stanza)) {
        // Prosody sends headline messages with type `chat`, so we need to filter them out here.
        const from = stanza.getAttribute('from');
        return src_log.info(`handleMessageStanza: Ignoring incoming server message from JID: ${from}`);
    }
    if (await isMUCPrivateMessage(stanza)) {
        return true;
    }

    let attrs;
    try {
        attrs = await parseMessage(stanza);
    } catch (e) {
        return src_log.error(e);
    }
    if (chat_utils_u.isErrorObject(attrs)) {
        const { stanza, message } = /** @type {StanzaParseError} */ (attrs);
        if (stanza) src_log.error(stanza);
        return src_log.error(message);
    }

    const { body, plaintext, contact_jid } = /** @type {MessageAttributes} */ (attrs);

    // XXX: Need to take XEP-428 <fallback> into consideration
    const has_body = !!(body || plaintext);
    const chatbox = await shared_api.chats.get(contact_jid, {}, has_body);
    await chatbox?.queueMessage(attrs);
    /**
     * @typedef {Object} MessageData
     * An object containing the original message stanza, as well as the
     * parsed attributes.
     * @property {Element} stanza
     * @property {MessageAttributes} stanza
     * @property {ChatBox} chatbox
     */
    const data = { stanza, attrs, chatbox };
    /**
     * Triggered when a message stanza is been received and processed.
     * @event _converse#message
     * @type {MessageData} data
     */
    shared_api.trigger('message', data);
}

/**
 * Ask the XMPP server to enable Message Carbons
 * See [XEP-0280](https://xmpp.org/extensions/xep-0280.html#enabling)
 */
async function enableCarbons() {
    const bare_jid = shared_converse.session.get('bare_jid');
    const domain = chat_utils_Strophe.getDomainFromJid(bare_jid);
    const supported = await shared_api.disco.supports(chat_utils_Strophe.NS.CARBONS, domain);

    if (!supported) {
        src_log.warn("Not enabling carbons because it's not supported!");
        return;
    }

    const iq = new chat_utils_Strophe.Builder('iq', {
        'from': shared_api.connection.get().jid,
        'type': 'set',
    }).c('enable', { xmlns: chat_utils_Strophe.NS.CARBONS });

    const result = await shared_api.sendIQ(iq, null, false);
    if (result === null) {
        src_log.warn(`A timeout occurred while trying to enable carbons`);
    } else if (chat_utils_u.isErrorStanza(result)) {
        src_log.warn('An error occurred while trying to enable message carbons.');
        src_log.error(result);
    } else {
        src_log.debug('Message carbons have been enabled.');
    }
}

;// CONCATENATED MODULE: ./src/headless/shared/model-with-messages.js

















const { Strophe: model_with_messages_Strophe, stx: model_with_messages_stx, u: model_with_messages_u } = api_public.env;

// How many code points of the replied-to message to quote in the XEP-0461
// compatibility fallback. Matches the preview length shown by the reply-context
// UI (shared/chat/reply-context.js), so we never quote more than we'd display.
const REPLY_FALLBACK_QUOTE_LENGTH = 80;

/**
 * Adds a messages collection to a model and various methods related to sending
 * and receiving chat messages.
 *
 * This model should be UX-agnostic, except when it comes to the rendering of
 * messages. So there's no assumption of uniformity with regards to UI elements
 * represented by this object.
 *
 * @template {import('./types').ModelExtender} T
 * @param {T} BaseModel
 */
function model_with_messages_ModelWithMessages(BaseModel) {
    /**
     * @typedef {import('../plugins/chat/model').default} ChatBox
     * @typedef {import('../plugins/muc/muc').default} MUC
     * @typedef {import('../plugins/muc/parsers').MUCMessageAttributes} MUCMessageAttributes
     * @typedef {import('../shared/types').ErrorMessageAttributes} ErrorMessageAttributes
     * @typedef {import('../shared/types').InfoMessageAttributes} InfoMessageAttributes
     * @typedef {import('../shared/types').MessageAttributes} MessageAttributes
     * @typedef {import('./message').default} BaseMessage
     */

    return class ModelWithMessages extends BaseModel {
        /** @param {...any} args */
        constructor(...args) {
            super(args[0], args[1]);
            this.disable_mam = false;
        }

        initialize() {
            super.initialize();

            this.initUI();
            this.initMessages();
            this.initNotifications();

            this.ui.on('change:scrolled', () => this.onScrolledChanged());
        }

        initNotifications() {
            this.notifications = new skeletor_esm_Model();
        }

        initUI() {
            this.ui = new skeletor_esm_Model();
        }

        /**
         * @returns {string}
         */
        getDisplayName() {
            return this.get('jid');
        }

        canPostMessages() {
            // Can be overridden in subclasses.
            return true;
        }

        /**
         * Queue the creation of a message, to make sure that we don't run
         * into a race condition whereby we're creating a new message
         * before the collection has been fetched.
         * @param {MessageAttributes|ErrorMessageAttributes|InfoMessageAttributes} attrs
         * @param {import('@converse/skeletor').FetchOrCreateOptions} [options]
         */
        async createMessage(attrs, options) {
            attrs.time = attrs.time || new Date().toISOString();
            await this.messages.fetched;
            return this.messages.create(attrs, options);
        }

        getMessagesCacheKey() {
            return `converse.messages-${this.get('jid')}-${shared_converse.session.get('bare_jid')}`;
        }

        getMessagesCollection() {
            return new shared_converse.exports.Messages();
        }

        getNotificationsText() {
            const { __ } = shared_converse;
            if (this.notifications?.get('chat_state') === COMPOSING) {
                return __('%1$s is typing', this.getDisplayName());
            } else if (this.notifications?.get('chat_state') === PAUSED) {
                return __('%1$s has stopped typing', this.getDisplayName());
            } else if (this.notifications?.get('chat_state') === GONE) {
                return __('%1$s has gone away', this.getDisplayName());
            } else {
                return '';
            }
        }

        initMessages() {
            this.messages = this.getMessagesCollection();
            this.messages.fetched = openpromise_getOpenPromise();
            this.messages.chatbox = this;
            initStorage(this.messages, this.getMessagesCacheKey());

            this.listenTo(this.messages, 'add', (m) => this.onMessageAdded(m));
            this.listenTo(this.messages, 'change:upload', (m) => this.onMessageUploadChanged(m));
            this.listenTo(this.messages, 'change:correcting', (m) => this.onMessageCorrecting(m));
        }

        fetchMessages() {
            if (this.messages.fetched_flag) {
                src_log.info(`Not re-fetching messages for ${this.get('jid')}`);
                return;
            }
            this.messages.fetched_flag = true;
            const resolve = this.messages.fetched.resolve;
            this.messages.fetch({
                add: true,
                success: () => {
                    this.afterMessagesFetched();
                    resolve();
                },
                error: () => {
                    this.afterMessagesFetched();
                    resolve();
                },
            });
            return this.messages.fetched;
        }

        afterMessagesFetched() {
            this.pruneHistoryWhenScrolledDown();
            /**
             * Triggered whenever a {@link ModelWithMessages}
             * has fetched its messages from the local cache.
             * @event _converse#afterMessagesFetched
             * @type {ModelWithMessages}
             * @example _converse.api.listen.on('afterMessagesFetched', (model) => { ... });
             */
            shared_api.trigger('afterMessagesFetched', this);
        }

        /**
         * @param {MessageAttributes|Error} _attrs_or_error
         */
        async onMessage(_attrs_or_error) {
            throw new MethodNotImplementedError('onMessage is not implemented');
        }

        /**
         * @param {BaseMessage} message
         * @param {MessageAttributes} attrs
         * @returns {Promise<object>}
         */
        async getUpdatedMessageAttributes(message, attrs) {
            let new_attrs;
            if (!attrs.error_type && message.get('error_type') === 'Decryption') {
                // Looks like we have a failed decrypted message stored, and now
                // we have a properly decrypted version of the same message.
                // See issue: https://github.com/conversejs/converse.js/issues/2733#issuecomment-1035493594
                new_attrs = Object.assign({}, attrs, {
                    error_condition: undefined,
                    error_message: undefined,
                    error_text: undefined,
                    error_type: undefined,
                    is_archived: attrs.is_archived,
                    is_ephemeral: false,
                    is_error: false,
                });
            } else {
                new_attrs = {
                    is_archived: attrs.is_archived,
                    ...(attrs.is_archived && attrs.time && { time: attrs.time }),
                };
            }

            /**
             * *Hook* which allows plugins to update the attributes that will be
             * set on an existing message when new attributes are received.
             * @event _converse#getUpdatedMessageAttributes
             */
            return await shared_api.hook('getUpdatedMessageAttributes', message, new_attrs, attrs);
        }

        /**
         * @param {BaseMessage} message
         * @param {MessageAttributes} attrs
         */
        async updateMessage(message, attrs) {
            const new_attrs = await this.getUpdatedMessageAttributes(message, attrs);
            if (new_attrs) message.save(new_attrs);
        }

        /**
         * Determines whether the given attributes of an incoming message
         * represent a XEP-0308 correction and, if so, handles it appropriately.
         * @param {MessageAttributes|MUCMessageAttributes} attrs - Attributes representing a received
         *  message, as returned by {@link parseMessage}
         * @returns {Promise<BaseMessage|void>} Returns the corrected
         *  message or `undefined` if not applicable.
         */
        async handleCorrection(attrs) {
            if (!attrs.replace_id || !attrs.from) {
                return;
            }

            let query;
            if (attrs.type === 'groupchat') {
                const { occupant_id, replace_id } = /** @type {MUCMessageAttributes} */ (attrs);
                query = occupant_id
                    ? ({ attributes: m }) => m.msgid === replace_id && m.occupant_id == occupant_id
                    : ({ attributes: m }) =>
                          m.msgid === attrs.replace_id && m.from === attrs.from && m.occupant_id == null;
            } else {
                query = ({ attributes: m }) =>
                    m.msgid === attrs.replace_id && m.from === attrs.from && m.occupant_id == null;
            }

            const message = this.messages.models.find(query);
            if (!message) {
                attrs['older_versions'] = {};
                return await this.createMessage(attrs);
            }

            const older_versions = message.get('older_versions') || {};
            if (attrs.time < message.get('time') && message.get('edited')) {
                // This is an older message which has been corrected afterwards
                older_versions[attrs.time] = attrs['message'];
                message.save({ older_versions });
            } else {
                // This is a correction of an earlier message we already received
                if (Object.keys(older_versions).length) {
                    older_versions[message.get('edited')] = message.getMessageText();
                } else {
                    older_versions[message.get('time')] = message.getMessageText();
                }
                attrs = Object.assign(attrs, { older_versions });
                delete attrs['msgid']; // We want to keep the msgid of the original message
                delete attrs['id']; // Delete id, otherwise a new cache entry gets created
                attrs['time'] = message.get('time');
                message.save(attrs);
            }
            return message;
        }

        /**
         * Queue an incoming `chat` message stanza for processing.
         * @param {MessageAttributes} attrs - A promise which resolves to the message attributes
         */
        queueMessage(attrs) {
            this.msg_chain = (this.msg_chain || this.messages.fetched)
                .then(() => this.onMessage(attrs))
                .catch((e) => src_log.error(e));
            return this.msg_chain;
        }

        /**
         * @param {MessageAttributes} [_attrs]
         * @return {Promise<MessageAttributes>}
         */
        async getOutgoingMessageAttributes(_attrs) {
            throw new MethodNotImplementedError('getOutgoingMessageAttributes is not implemented');
        }

        /**
         * Look up the message being replied to (XEP-0461). For groupchat the
         * `reply_to_id` is a XEP-0359 stanza_id; otherwise it's the origin_id or msgid.
         * @param {string} reply_to_id
         * @returns {BaseMessage|undefined}
         */
        getReferencedMessage(reply_to_id) {
            if (!reply_to_id) return undefined;

            if (this.get('message_type') === 'groupchat') {
                const muc_jid = this.get('jid');
                return this.messages.models.find((m) => m.get(`stanza_id ${muc_jid}`) === reply_to_id);
            }
            return this.messages.models.find(
                (m) => m.get('origin_id') === reply_to_id || m.get('msgid') === reply_to_id,
            );
        }

        /**
         * XEP-0461 compatibility fallback. When sending a reply, prepend a
         * XEP-0393 `>`-quoted copy of the replied-to text to the body, so clients
         * that don't support structured replies still see the context.
         * @param {MessageAttributes} attrs
         * @returns {MessageAttributes}
         */
        addReplyFallback(attrs) {
            if (!attrs.reply_to_id || !attrs.body) return attrs;
            const replied = this.getReferencedMessage(attrs.reply_to_id);
            const quoted = replied?.getMessageText();
            if (!quoted) return attrs;

            // Truncate the quoted original (by code points, XEP-0426) so replying
            // to a long message doesn't prepend the whole thing to the body. Only
            // the quote is truncated — never the user's own reply text.
            const chars = [...quoted];
            const truncated =
                chars.length > REPLY_FALLBACK_QUOTE_LENGTH
                    ? chars.slice(0, REPLY_FALLBACK_QUOTE_LENGTH).join('') + '…'
                    : quoted;

            const quote =
                `> ${replied.getDisplayName()}:\n` +
                truncated
                    .split('\n')
                    .map((line) => `> ${line}`)
                    .join('\n') +
                '\n';
            attrs.body = quote + attrs.body;
            attrs.message = attrs.body;

            // References use UTF-16 offsets (match.index); shift by the same unit.
            if (attrs.references?.length) {
                const shift = quote.length;
                attrs.references = attrs.references.map((r) => ({
                    ...r,
                    begin: r.begin + shift,
                    end: r.end + shift,
                }));
            }

            // XEP-0426/0428 count fallback offsets in Unicode code points.
            attrs.fallback = { [model_with_messages_Strophe.NS.REPLY]: { start: 0, end: [...quote].length } };
            return attrs;
        }

        /**
         * Responsible for sending off a text message inside an ongoing chat conversation.
         * @param {Object} [attrs] - A map of attributes to be saved on the message
         * @returns {Promise<BaseMessage>}
         * @example
         *  const chat = api.chats.get('buddy1@example.org');
         *  chat.sendMessage({'body': 'hello world'});
         */
        async sendMessage(attrs) {
            await shared_api.emojis.initialize();

            if (!this.canPostMessages()) {
                src_log.warn('sendMessage was called but canPostMessages is false');
                return;
            }

            attrs = await this.getOutgoingMessageAttributes(attrs);
            let message = this.messages.findWhere('correcting');
            if (message) {
                const older_versions = message.get('older_versions') || {};
                const edited_time = message.get('edited') || message.get('time');
                older_versions[edited_time] = message.getMessageText();

                message.save({
                    ...['body', 'is_only_emojis', 'media_urls', 'references', 'is_encrypted'].reduce((obj, k) => {
                        if (attrs.hasOwnProperty(k)) obj[k] = attrs[k];
                        return obj;
                    }, {}),
                    ...{
                        correcting: false,
                        edited: new Date().toISOString(),
                        message: attrs.body,
                        ogp_metadata: [],
                        older_versions,
                        origin_id: model_with_messages_u.getUniqueId(),
                        plaintext: attrs.is_encrypted ? attrs.message : undefined,
                        received: undefined,
                    },
                });
            } else {
                this.setEditable(attrs, new Date().toISOString());
                message = await this.createMessage(attrs);
            }

            try {
                const stanza = await this.createMessageStanza(message);
                shared_api.send(stanza);
            } catch (e) {
                message.destroy();
                src_log.error(e);
                return;
            }

            /**
             * Triggered when a message is being sent out
             * @event _converse#sendMessage
             * @type {Object}
             * @param {Object} data
             * @property {(ChatBox|MUC)} data.chatbox
             * @property {(BaseMessage)} data.message
             */
            shared_api.trigger('sendMessage', { chatbox: this, message });
            return message;
        }

        /**
         * Retract one of your messages in this chat
         * @param {BaseMessage} message - The message which we're retracting.
         */
        retractOwnMessage(message) {
            const retraction_id = model_with_messages_u.getUniqueId();
            sendRetractionMessage(this.get('jid'), message, retraction_id);
            message.save({
                'retracted': new Date().toISOString(),
                'retracted_id': message.get('origin_id'),
                'retraction_id': retraction_id,
                'is_ephemeral': true,
                'editable': false,
            });
        }

        /**
         * @param {File[]} files'
         */
        async sendFiles(files) {
            const { __, session } = shared_converse;
            const result = await shared_api.disco.features.get(model_with_messages_Strophe.NS.HTTPUPLOAD, session.get('domain'));
            const item = result.pop();
            if (!item) {
                this.createMessage({
                    message: __('Sorry, looks like file upload is not supported by your server.'),
                    type: 'error',
                    is_ephemeral: true,
                });
                return;
            }
            const data = item.dataforms
                .where({ 'FORM_TYPE': { 'value': model_with_messages_Strophe.NS.HTTPUPLOAD, 'type': 'hidden' } })
                .pop();
            const max_file_size = parseInt((data?.attributes || {})['max-file-size']?.value, 10);
            const slot_request_url = item?.id;

            if (!slot_request_url) {
                this.createMessage({
                    message: __('Sorry, looks like file upload is not supported by your server.'),
                    type: 'error',
                    is_ephemeral: true,
                });
                return;
            }
            Array.from(files).forEach(async (file) => {
                /**
                 * *Hook* which allows plugins to transform files before they'll be
                 * uploaded. The main use-case is to encrypt the files.
                 * @event _converse#beforeFileUpload
                 * @param {ChatBox|MUC} chat - The chat from which this file will be uploaded.
                 * @param {File} file - The file that will be uploaded
                 */
                file = await shared_api.hook('beforeFileUpload', this, file);

                if (!isNaN(max_file_size) && file.size > max_file_size) {
                    const size = filesize(max_file_size);
                    const message = Array.isArray(size)
                        ? __('The size of your file, %1$s, exceeds the maximum allowed by your server.', file.name)
                        : __(
                              'The size of your file, %1$s, exceeds the maximum allowed by your server, which is %2$s.',
                              file.name,
                              size,
                          );
                    return this.createMessage({
                        message,
                        type: 'error',
                        is_ephemeral: true,
                    });
                } else {
                    const initial_attrs = await this.getOutgoingMessageAttributes();
                    const attrs = Object.assign(initial_attrs, {
                        'file': true,
                        'progress': 0,
                        'slot_request_url': slot_request_url,
                    });
                    this.setEditable(attrs, new Date().toISOString());
                    const message = await this.createMessage(attrs, { 'silent': true });
                    message.file = file;
                    this.messages.trigger('add', message);
                    message.getRequestSlotURL();
                }
            });
        }

        /**
         * Responsible for setting the editable attribute of messages.
         * If api.settings.get('allow_message_corrections') is "last", then only the last
         * message sent from me will be editable. If set to "all" all messages
         * will be editable. Otherwise no messages will be editable.
         * @param {Object} attrs An object containing message attributes.
         * @param {String} send_time - time when the message was sent
         */
        setEditable(attrs, send_time) {
            if (attrs.is_headline || model_with_messages_u.isEmptyMessage(attrs) || attrs.sender !== 'me') {
                return;
            }
            if (shared_api.settings.get('allow_message_corrections') === 'all') {
                attrs.editable = !(attrs.file || attrs.retracted || 'oob_url' in attrs);
            } else if (shared_api.settings.get('allow_message_corrections') === 'last' && send_time > this.get('time_sent')) {
                this.set({ 'time_sent': send_time });
                this.messages.findWhere({ 'editable': true })?.save({ 'editable': false });
                attrs.editable = !(attrs.file || attrs.retracted || 'oob_url' in attrs);
            }
        }

        /**
         * Mutator for setting the chat state of this chat session.
         * Handles clearing of any chat state notification timeouts and
         * setting new ones if necessary.
         * Timeouts are set when the  state being set is COMPOSING or PAUSED.
         * After the timeout, COMPOSING will become PAUSED and PAUSED will become INACTIVE.
         * See XEP-0085 Chat State Notifications.
         * @param {string} state - The chat state (consts ACTIVE, COMPOSING, PAUSED, INACTIVE, GONE)
         * @param {object} [options]
         */
        setChatState(state, options) {
            if (this.chat_state_timeout !== undefined) {
                clearTimeout(this.chat_state_timeout);
                delete this.chat_state_timeout;
            }
            if (state === COMPOSING) {
                this.chat_state_timeout = setTimeout(
                    this.setChatState.bind(this),
                    shared_converse.TIMEOUTS.PAUSED,
                    PAUSED,
                );
            } else if (state === PAUSED) {
                this.chat_state_timeout = setTimeout(
                    this.setChatState.bind(this),
                    shared_converse.TIMEOUTS.INACTIVE,
                    INACTIVE,
                );
            }
            this.set('chat_state', state, options);
            return this;
        }

        /**
         * @param {BaseMessage} message
         */
        onMessageAdded(message) {
            if (
                shared_api.settings.get('prune_messages_above') &&
                (shared_api.settings.get('pruning_behavior') === 'scrolled' || !this.ui.get('scrolled')) &&
                !model_with_messages_u.isEmptyMessage(message)
            ) {
                this.debouncedPruneHistory();
            }
        }

        /**
         * @param {BaseMessage} message
         */
        async onMessageUploadChanged(message) {
            if (message.get('upload') === SUCCESS) {
                const attrs = {
                    'body': message.get('body'),
                    'spoiler_hint': message.get('spoiler_hint'),
                    'oob_url': message.get('oob_url'),
                };
                await this.sendMessage(attrs);
                message.destroy();
            }
        }

        /**
         * @param {BaseMessage} message
         */
        onMessageCorrecting(message) {
            if (message.get('correcting')) {
                this.save({ correcting: message.get('id'), draft: model_with_messages_u.prefixMentions(message) });
            } else {
                this.save({ correcting: undefined, draft: undefined });
            }
        }

        onScrolledChanged() {
            if (!this.ui.get('scrolled')) {
                this.clearUnreadMsgCounter();
                this.pruneHistoryWhenScrolledDown();
            }
        }

        pruneHistoryWhenScrolledDown() {
            if (
                shared_api.settings.get('prune_messages_above') &&
                shared_api.settings.get('pruning_behavior') === 'unscrolled' &&
                !this.ui.get('scrolled')
            ) {
                this.debouncedPruneHistory();
            }
        }

        /**
         * @param {MessageAttributes} attrs
         * @returns {Promise<boolean>}
         */
        shouldShowErrorMessage(attrs) {
            const msg = this.getMessageReferencedByError(attrs);
            if (!msg && attrs.chat_state) {
                // If the error refers to a message not included in our store,
                // and it has a chat state tag, we assume that this was a
                // CSI message (which we don't store).
                // See https://github.com/conversejs/converse.js/issues/1317
                return;
            }
            // Gets overridden
            // Return promise because subclasses need to return promises
            return Promise.resolve(true);
        }

        async clearMessages() {
            try {
                await this.messages.clearStore();
            } catch (e) {
                this.messages.trigger('reset');
                src_log.error(e);
            } finally {
                // No point in fetching messages from the cache if it's been cleared.
                // Make sure to resolve the fetched promise to avoid freezes.
                this.messages.fetched.resolve();
            }
        }

        editEarlierMessage() {
            let message;
            let idx = this.messages.findLastIndex('correcting');
            if (idx >= 0) {
                this.messages.at(idx).save('correcting', false);
                while (idx > 0) {
                    idx -= 1;
                    const candidate = this.messages.at(idx);
                    if (candidate.get('editable')) {
                        message = candidate;
                        break;
                    }
                }
            }
            message =
                message ||
                this.messages
                    .filter({ sender: 'me' })
                    .reverse()
                    .find(/** @param {BaseMessage} m */ (m) => m.get('editable'));

            message?.save('correcting', true);
        }

        editLaterMessage() {
            let message;
            let idx = this.messages.findLastIndex('correcting');
            if (idx >= 0) {
                this.messages.at(idx).save('correcting', false);
                while (idx < this.messages.length - 1) {
                    idx += 1;
                    const candidate = this.messages.at(idx);
                    if (candidate.get('editable')) {
                        message = candidate;
                        message.save('correcting', true);
                        break;
                    }
                }
            }
            return message;
        }

        /**
         * Used by sub-classes to indicate whether a message is a chat
         * message, as opposed to error or info messages.
         * @param {BaseMessage} _message
         * @returns {boolean}
         */
        isChatMessage(_message) {
            throw new MethodNotImplementedError();
        }

        /** @returns {BaseMessage} */
        getOldestMessage() {
            for (let i = 0; i < this.messages.length; i++) {
                const message = this.messages.at(i);
                if (this.isChatMessage(message)) {
                    return message;
                }
            }
        }

        /** @returns {BaseMessage} */
        getMostRecentMessage() {
            for (let i = this.messages.length - 1; i >= 0; i--) {
                const message = this.messages.at(i);
                if (this.isChatMessage(message)) {
                    return message;
                }
            }
        }

        /**
         * Given an error `<message>` stanza's attributes, find the saved message model which is
         * referenced by that error.
         * @param {object} attrs
         */
        getMessageReferencedByError(attrs) {
            if (attrs.msgid) {
                return this.messages.models.find(
                    /** @param {BaseMessage} m */ (m) =>
                        [m.get('msgid'), m.get('retraction_id'), m.get('origin_id')].includes(attrs.msgid),
                );
            } else if (attrs.reaction_to_id) {
                return this.messages.models.find(
                    /** @param {BaseMessage} m */ (m) =>
                        [m.get('msgid'), m.get('origin_id')].includes(attrs.reaction_to_id),
                );
            }
        }

        /**
         * Looks whether we already have a retraction for this
         * incoming message. If so, it's considered "dangling" because it
         * probably hasn't been applied to anything yet, given that the
         * relevant message is only coming in now.
         * @param {object} attrs - Attributes representing a received
         *  message, as returned by {@link parseMessage}
         * @returns {BaseMessage|null}
         */
        findDanglingRetraction(attrs) {
            if (!attrs.origin_id || !this.messages.length) {
                return null;
            }
            // Only look for dangling retractions if there are newer
            // messages than this one, since retractions come after.
            if (this.messages.last().get('time') > attrs.time) {
                // Search from latest backwards
                const messages = Array.from(this.messages.models);
                messages.reverse();
                return messages.find(
                    ({ attributes }) =>
                        attributes.retracted_id === attrs.origin_id &&
                        attributes.from === attrs.from &&
                        !attributes.moderated_by,
                );
            }
            return null;
        }

        /**
         * Returns an already cached message (if it exists) based on the
         * passed in attributes map.
         *
         * @fires getDuplicateMessageQueries
         * @param {object} attrs - Attributes representing a received
         *  message, as returned by {@link parseMessage}
         * @returns {Promise<BaseMessage|undefined>}
         */
        async getDuplicateMessage(attrs) {
            /**
             * Hook to let plugins contribute additional query objects.
             * Each query object is a plain `{ attribute: value }` map;
             * a message matches if every key in the object equals the corresponding
             * attribute on the stored model. The built-in queries cover stanza_id,
             * origin_id, and body deduplication; plugins add their own criteria.
             */
            const extra_queries = await shared_api.hook('getDuplicateMessageQueries', this, [], attrs);

            const queries = [
                ...this.getStanzaIdQueryAttrs(attrs),
                this.getOriginIdQueryAttrs(attrs),
                this.getMessageBodyQueryAttrs(attrs),
                ...extra_queries,
            ].filter((s) => s);

            return this.messages.models.find(
                /** @param {BaseMessage} m */
                (m) => queries.find((q) => Object.keys(q).every((k) => m.get(k) === q[k])),
            );
        }

        /**
         * @param {object} attrs - Attributes representing a received
         */
        getOriginIdQueryAttrs(attrs) {
            return attrs.origin_id && { origin_id: attrs.origin_id, from: attrs.from };
        }

        /**
         * @param {object} attrs - Attributes representing a received
         */
        getStanzaIdQueryAttrs(attrs) {
            const keys = Object.keys(attrs).filter((k) => k.startsWith('stanza_id '));
            return keys.map((key) => {
                const by_jid = key.replace(/^stanza_id /, '');
                const query = {};
                query[`stanza_id ${by_jid}`] = attrs[key];
                return query;
            });
        }

        /**
         * @param {object} attrs - Attributes representing a received
         */
        getMessageBodyQueryAttrs(attrs) {
            if (attrs.msgid) {
                const query = {
                    from: attrs.from,
                    msgid: attrs.msgid,
                };
                if (!attrs.is_encrypted && !attrs.fallback && attrs.body) {
                    // Skip body matching for encrypted messages (body is ciphertext /
                    // EME fallback, not the plaintext) and for messages with a XEP-0428
                    // <fallback> body marker (body includes display-only content such as
                    // quoted text or reaction emoji — msgid + from is sufficient for
                    // identity in those cases).
                    query['body'] = attrs.body;
                }
                return query;
            }
        }

        /**
         * Given the passed in message object, send a XEP-0333 chat marker.
         * @param {BaseMessage} msg
         * @param {('received'|'displayed'|'acknowledged')} [type='displayed']
         * @param {boolean} [force=false] - Whether a marker should be sent for the
         *  message, even if it didn't include a `markable` element.
         */
        async sendMarkerForMessage(msg, type = 'displayed', force = false) {
            if (!msg || msg?.get('type') === 'groupchat' || !shared_api.settings.get('send_chat_markers').includes(type)) {
                return;
            }

            // Don't send chat markers to contacts that are not subscribed
            // to our presence.
            const contact = await shared_api.contacts.get(this.get('jid'));
            const subscription = contact?.get('subscription');
            if (!contact || subscription === 'none' || subscription === 'to') {
                return;
            }

            if (msg?.get('is_markable') || force) {
                const from_jid = model_with_messages_Strophe.getBareJidFromJid(msg.get('from'));
                sendMarker(from_jid, msg.get('msgid'), type, msg.get('type'));
            }
        }

        /**
         * Given a newly received {@link BaseMessage} instance,
         * update the unread counter if necessary.
         * @param {BaseMessage} message
         */
        handleUnreadMessage(message) {
            if (!message?.get('body')) {
                return;
            }

            if (isNewMessage(message)) {
                if (message.get('sender') === 'me') {
                    // We remove the "scrolled" flag so that the chat area
                    // gets scrolled down. We always want to scroll down
                    // when the user writes a message as opposed to when a
                    // message is received.
                    this.ui.set('scrolled', false);
                } else if (this.isHidden()) {
                    this.incrementUnreadMsgsCounter(message);
                } else {
                    this.sendMarkerForMessage(message);
                }
            }
        }

        /**
         * @param {BaseMessage} message
         * @param {MessageAttributes} attrs
         */
        async getErrorAttributesForMessage(message, attrs) {
            const { __ } = shared_converse;
            const new_attrs = {
                editable: false,
                error: attrs.error,
                error_condition: attrs.error_condition,
                error_text: attrs.error_text,
                error_type: attrs.error_type,
                is_error: true,
            };
            if (attrs.msgid === message.get('retraction_id')) {
                // The error message refers to a retraction
                new_attrs.retraction_id = undefined;
                if (!attrs.error) {
                    if (attrs.error_condition === 'forbidden') {
                        new_attrs.error = __("You're not allowed to retract your message.");
                    } else {
                        new_attrs.error = __('Sorry, an error occurred while trying to retract your message.');
                    }
                }
            } else if (!attrs.error) {
                if (attrs.error_condition === 'forbidden') {
                    new_attrs.error = __("You're not allowed to send a message.");
                } else {
                    new_attrs.error = __('Sorry, an error occurred while trying to send your message.');
                }
            }
            /**
             * *Hook* which allows plugins to add application-specific attributes
             * @event _converse#getErrorAttributesForMessage
             * @param {BaseMessage} message - The message context
             * @param {Object} new_attrs - The newly created error attributes
             * @param {Object} attrs - The original stanza attributes
             */
            return await shared_api.hook('getErrorAttributesForMessage', message, new_attrs, attrs);
        }

        /**
         * @param {Element} stanza
         */
        async handleErrorMessageStanza(stanza) {
            const attrs_or_error = await parseMessage(stanza);
            if (model_with_messages_u.isErrorObject(attrs_or_error)) {
                const { stanza, message } = /** @type {errors.StanzaParseError} */ (attrs_or_error);
                if (stanza) src_log.error(stanza);
                return src_log.error(message);
            }

            const attrs = /** @type {MessageAttributes} */ (attrs_or_error);
            if (!(await this.shouldShowErrorMessage(attrs))) {
                return;
            }

            const message = this.getMessageReferencedByError(attrs);
            if (message) {
                const new_attrs = await this.getErrorAttributesForMessage(message, attrs);
                message.save(new_attrs);
            } else {
                this.createMessage(attrs);
            }
        }

        /**
         * @param {BaseMessage} message
         */
        incrementUnreadMsgsCounter(message) {
            this.save({
                num_unread: this.get('num_unread') + 1,
                ...(this.get('num_unread') === 0 ? { first_unread_id: message.get('id') } : null),
            });
        }

        clearUnreadMsgCounter() {
            if (this.get('num_unread') > 0) {
                this.sendMarkerForMessage(this.messages.last());
                model_with_messages_u.safeSave(this, { num_unread: 0 });
            }
        }

        /**
         * Handles message retraction based on the passed in attributes.
         * @param {MessageAttributes} attrs - Attributes representing a received
         *  message, as returned by {@link parseMessage}
         * @returns {Promise<Boolean>} Returns `true` or `false` depending on
         *  whether a message was retracted or not.
         */
        async handleRetraction(attrs) {
            const RETRACTION_ATTRIBUTES = ['retracted', 'retracted_id', 'editable'];
            if (attrs.retracted) {
                if (attrs.is_tombstone) return false;

                for (const m of this.messages.models) {
                    if (m.get('from') !== attrs.from) continue;
                    if (m.get('origin_id') === attrs.retracted_id || m.get('msgid') === attrs.retracted_id) {
                        m.save(lodash_es_pick(attrs, RETRACTION_ATTRIBUTES));
                        return true;
                    }
                }

                attrs['dangling_retraction'] = true;
                await this.createMessage(attrs);
                return true;
            } else {
                // Check if we have dangling retraction
                const message = this.findDanglingRetraction(attrs);
                if (message) {
                    const retraction_attrs = lodash_es_pick(message.attributes, RETRACTION_ATTRIBUTES);
                    const new_attrs = Object.assign({ dangling_retraction: false }, attrs, retraction_attrs);
                    delete new_attrs['id']; // Delete id, otherwise a new cache entry gets created
                    message.save(new_attrs);
                    return true;
                }
            }
            return false;
        }

        /**
         * @param {MessageAttributes} attrs
         */
        handleReceipt(attrs) {
            if (attrs.sender === 'them') {
                if (attrs.is_valid_receipt_request) {
                    sendReceiptStanza(attrs.from, attrs.msgid);
                } else if (attrs.receipt_id) {
                    const message = this.messages.findWhere({ 'msgid': attrs.receipt_id });
                    if (message && !message.get('received')) {
                        message.save({ 'received': new Date().toISOString() });
                    }
                    return true;
                }
            }
            return false;
        }

        /**
         * Given a {@link BaseMessage} return the XML stanza that represents it.
         * @method ChatBox#createMessageStanza
         * @param {BaseMessage} message - The message object
         */
        async createMessageStanza(message) {
            const {
                body,
                edited,
                is_encrypted,
                is_spoiler,
                msgid,
                oob_url,
                origin_id,
                references,
                reply_to_id,
                reply_to,
                spoiler_hint,
                type,
            } = message.attributes;
            const reply_fallback = message.get('fallback')?.[model_with_messages_Strophe.NS.REPLY];

            const stanza = model_with_messages_stx`
                <message xmlns="jabber:client"
                        from="${message.get('type') === 'groupchat' ? shared_api.connection.get().jid : message.get('from')}"
                        to="${message.get('to') || this.get('jid')}"
                        type="${this.get('message_type')}"
                        id="${(edited && model_with_messages_u.getUniqueId()) || msgid}">
                    ${body ? model_with_messages_stx`<body>${body}</body>` : ''}
                    ${!is_encrypted ? model_with_messages_stx`<active xmlns="${model_with_messages_Strophe.NS.CHATSTATES}"/>` : ''}
                    ${type === 'chat' ? model_with_messages_stx`<request xmlns="${model_with_messages_Strophe.NS.RECEIPTS}"></request>` : ''}
                    ${!is_encrypted && oob_url ? model_with_messages_stx`<x xmlns="${model_with_messages_Strophe.NS.OUTOFBAND}"><url>${oob_url}</url></x>` : ''}
                    ${!is_encrypted && is_spoiler ? model_with_messages_stx`<spoiler xmlns="${model_with_messages_Strophe.NS.SPOILER}">${spoiler_hint ?? ''}</spoiler>` : ''}
                    ${
                        !is_encrypted
                            ? references?.map(
                                  (ref) => model_with_messages_stx`<reference xmlns="${model_with_messages_Strophe.NS.REFERENCE}"
                                                begin="${ref.begin}"
                                                end="${ref.end}"
                                                type="${ref.type}"
                                                uri="${ref.uri}"></reference>`,
                              )
                            : ''
                    }
                    ${!is_encrypted && reply_to_id ? model_with_messages_stx`<reply xmlns="${model_with_messages_Strophe.NS.REPLY}" id="${reply_to_id}" to="${reply_to || ''}"></reply>` : ''}
                    ${
                        !is_encrypted && reply_to_id && reply_fallback
                            ? model_with_messages_stx`<fallback xmlns="${model_with_messages_Strophe.NS.FALLBACK}" for="${model_with_messages_Strophe.NS.REPLY}">
                                    <body start="${reply_fallback.start}" end="${reply_fallback.end}"/>
                                </fallback>`
                            : ''
                    }
                    ${edited ? model_with_messages_stx`<replace xmlns="${model_with_messages_Strophe.NS.MESSAGE_CORRECT}" id="${msgid}"></replace>` : ''}
                    ${origin_id ? model_with_messages_stx`<origin-id xmlns="${model_with_messages_Strophe.NS.SID}" id="${origin_id}"></origin-id>` : ''}
                </message>`;

            /**
             * *Hook* which allows plugins to update an outgoing message stanza
             * @event _converse#createMessageStanza
             * @param {ChatBox|MUC} chat - The chat from which this message stanza is being sent.
             * @param {import('./types').MessageAndStanza} data - BaseMessage data
             */
            const data = await shared_api.hook('createMessageStanza', this, { message, stanza });
            return data.stanza;
        }

        /**
         * Prunes the message history to ensure it does not exceed the maximum
         * number of messages specified in the settings.
         */
        pruneHistory() {
            const max_history = shared_api.settings.get('prune_messages_above');
            if (max_history && typeof max_history === 'number') {
                if (this.messages.length > max_history) {
                    const non_empty_messages = this.messages.filter((m) => !model_with_messages_u.isEmptyMessage(m));
                    if (non_empty_messages.length > max_history) {
                        while (non_empty_messages.length > max_history) {
                            non_empty_messages.shift().destroy();
                        }
                        /**
                         * Triggered once the message history has been pruned, i.e.
                         * once older messages have been removed to keep the
                         * number of messages below the value set in `prune_messages_above`.
                         */
                        this.trigger('historyPruned');
                    }
                }
            }
        }
        debouncedPruneHistory = lodash_es_debounce(() => this.pruneHistory(), 500, { maxWait: 2000 });

        isScrolledUp() {
            return this.ui.get('scrolled');
        }

        /**
         * Indicates whether the chat is hidden and therefore
         * whether a newly received message will be visible to the user or not.
         * @returns {boolean}
         */
        isHidden() {
            return this.get('hidden') || this.isScrolledUp() || isAppHidden();
        }
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/picker.js


/**
 * Model for storing data related to the Emoji picker widget
 */
class EmojiPicker extends skeletor_esm_Model {
    defaults () {
        return {
            'current_category': 'smileys',
            'current_skintone': '',
            'scroll_position': 0
        }
    }
}

/* export default */ const picker = (EmojiPicker);

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/api.js



/** @type {(() => Promise<object>)|null} */
let _json_loader = null;

/**
 * Overrides how `emoji.json` is loaded. Registered by `shims/node-emoji.js`
 * under Node, where the file is read from the package rather than fetched from
 * the asset directory served next to the bundle.
 * @param {() => Promise<object>} loader
 */
function setEmojiJSONLoader(loader) {
    _json_loader = loader;
}

/**
 * @returns {Promise<object>}
 */
async function loadEmojiJSON() {
    if (_json_loader) return _json_loader();

    const path = shared_api.settings.get('assets_path');
    const response = await fetch(`${path}/emoji.json`);
    if (!response.ok) throw new Error('Failed to fetch emoji.json');

    return response.json();
}

/**
 * @namespace api.emojis
 * @memberOf api
 */
const api_emojis = {
    /**
     * Initializes Emoji support by downloading the emojis JSON (and any applicable images).
     * @method api.emojis.initialize
     * @returns {Promise}
     */
    async initialize() {
        if (!api_public.emojis.initialized) {
            api_public.emojis.initialized = true;

            let json;
            try {
                json = await loadEmojiJSON();
            } catch (e) {
                console.error('Failed to load emoji.json:', e);
                json = {};
            }

            /**
             * *Hook* which allows plugins to modify emojis definition.
             *
             * Note: This hook is only fired one time, when Converse is initialized.
             *
             * @event _converse#loadEmojis
             * @param context
             *      An empty context object.
             * @param json
             *      See {@link src/headless/emojis.json} for more information about the content of
             *      this parameter.
             * @example
             *  api.listen.on('loadEmojis', (context, json) => {
             *      json.custom??= {};
             *      json.custom[":my_emoji"] = {
             *          "sn":":my_emoji:","url":"https://example.com/my_emoji.png","c":"custom"
             *      };
             *      delete json.custom[":converse:"];
             *      return json;
             *  });
             */
            json = await shared_api.hook('loadEmojis', {}, json);
            api_public.emojis.json = json;

            api_public.emojis.by_sn = Object.keys(json).reduce((result, cat) => Object.assign(result, json[cat]), {});
            api_public.emojis.list = Object.values(api_public.emojis.by_sn);
            api_public.emojis.list.sort((a, b) => (a.sn < b.sn ? -1 : a.sn > b.sn ? 1 : 0));
            api_public.emojis.shortnames = api_public.emojis.list.map((m) => m.sn);
            // Sort by length descending for the regex so longer shortnames
            // match before shorter ones.
            const getShortNames = () =>
                api_public.emojis.shortnames.map((s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
                    .sort((a, b) => b.length - a.length)
                    .join('|');
            // Shortnames are matched case-sensitively, because `by_sn` is keyed on the exact
            // shortname and may legitimately contain both `:abc:` and `:ABC:` as distinct emoji.
            api_public.emojis.shortnames_regex = new RegExp(getShortNames(), 'g');
            api_public.emojis.initialized_promise.resolve();
        }
        return api_public.emojis.initialized_promise;
    },
};

const emojis_api = { emojis: api_emojis };

/* export default */ const emoji_api = (emojis_api);

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/regexes.js
const ASCII_REGEX = '(\\*\\\\0\\/\\*|\\*\\\\O\\/\\*|\\-___\\-|\\:\'\\-\\)|\'\\:\\-\\)|\'\\:\\-D|\\>\\:\\-\\)|>\\:\\-\\)|\'\\:\\-\\(|\\>\\:\\-\\(|>\\:\\-\\(|\\:\'\\-\\(|O\\:\\-\\)|0\\:\\-3|0\\:\\-\\)|0;\\^\\)|O;\\-\\)|0;\\-\\)|O\\:\\-3|\\-__\\-|\\:\\-Þ|\\:\\-Þ|\\<\\/3|<\\/3|\\:\'\\)|\\:\\-D|\'\\:\\)|\'\\=\\)|\'\\:D|\'\\=D|\\>\\:\\)|>\\:\\)|\\>;\\)|>;\\)|\\>\\=\\)|>\\=\\)|;\\-\\)|\\*\\-\\)|;\\-\\]|;\\^\\)|\'\\:\\(|\'\\=\\(|\\:\\-\\*|\\:\\^\\*|\\>\\:P|>\\:P|X\\-P|\\>\\:\\[|>\\:\\[|\\:\\-\\(|\\:\\-\\[|\\>\\:\\(|>\\:\\(|\\:\'\\(|;\\-\\(|\\>\\.\\<|>\\.<|#\\-\\)|%\\-\\)|X\\-\\)|\\\\0\\/|\\\\O\\/|0\\:3|0\\:\\)|O\\:\\)|O\\=\\)|O\\:3|B\\-\\)|8\\-\\)|B\\-D|8\\-D|\\-_\\-|\\>\\:\\\\|>\\:\\\\|\\>\\:\\/|>\\:\\/|\\:\\-\\/|\\:\\-\\.|\\:\\-P|\\:Þ|\\:Þ|\\:\\-b|\\:\\-O|O_O|\\>\\:O|>\\:O|\\:\\-X|\\:\\-#|\\:\\-\\)|\\(y\\)|\\<3|<3|\\:D|\\=D|;\\)|\\*\\)|;\\]|;D|\\:\\*|\\=\\*|\\:\\(|\\:\\[|\\=\\(|\\:@|;\\(|D\\:|\\:\\$|\\=\\$|#\\)|%\\)|X\\)|B\\)|8\\)|\\:\\/|\\:\\\\|\\=\\/|\\=\\\\|\\:L|\\=L|\\:P|\\=P|\\:b|\\:O|\\:X|\\:#|\\=X|\\=#|\\:\\)|\\=\\]|\\=\\)|\\:\\])';
const ASCII_REPLACE_REGEX = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|((\\s|^)"+ASCII_REGEX+"(?=\\s|$|[!,.?]))", "gi");
const CODEPOINTS_REGEX = /(?:\ud83d\udc68\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc68\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc68\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\u200d\ud83e\udd1d\u200d\ud83e\uddd1|\ud83d\udc6b\ud83c[\udffb-\udfff]|\ud83d\udc6c\ud83c[\udffb-\udfff]|\ud83d\udc6d\ud83c[\udffb-\udfff]|\ud83d[\udc6b-\udc6d])|(?:\ud83d[\udc68\udc69]|\ud83e\uddd1)(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddaf-\uddb3\uddbc\uddbd])|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddcd-\uddcf\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|(?:\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\u26a7\ufe0f|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc15\u200d\ud83e\uddba|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26a7\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd0f\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\uddb5\uddb6\uddb8\uddb9\uddbb\uddcd-\uddcf\uddd1-\udddd]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\uded5\udeeb\udeec\udef4-\udefa\udfe0-\udfeb]|\ud83e[\udd0d\udd0e\udd10-\udd17\udd1d\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd3f-\udd45\udd47-\udd71\udd73-\udd76\udd7a-\udda2\udda5-\uddaa\uddae-\uddb4\uddb7\uddba\uddbc-\uddca\uddd0\uddde-\uddff\ude70-\ude73\ude78-\ude7a\ude80-\ude82\ude90-\ude95]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g;

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/constants.js

// Regex to detect shortname keys (e.g. ':thumbsup:')
const SHORTNAME_RE = /^:[a-zA-Z0-9_+*-]+:$/;
// How long to debounce/wait before publishing popular emojis
const PUBLISH_DEBOUNCE_MILLIS = 30_000;

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/utils.js






const { u: emoji_utils_u } = api_public.env;

// Closured cache
const emojis_by_attribute = {};

const ASCII_LIST = {
    '*\\0/*': '1f646',
    '*\\O/*': '1f646',
    '-___-': '1f611',
    ":'-)": '1f602',
    "':-)": '1f605',
    "':-D": '1f605',
    '>:-)': '1f606',
    "':-(": '1f613',
    '>:-(': '1f620',
    ":'-(": '1f622',
    'O:-)': '1f607',
    '0:-3': '1f607',
    '0:-)': '1f607',
    '0;^)': '1f607',
    'O;-)': '1f607',
    '0;-)': '1f607',
    'O:-3': '1f607',
    '-__-': '1f611',
    ':-Þ': '1f61b',
    '</3': '1f494',
    ":')": '1f602',
    ':-D': '1f603',
    "':)": '1f605',
    "'=)": '1f605',
    "':D": '1f605',
    "'=D": '1f605',
    '>:)': '1f606',
    '>;)': '1f606',
    '>=)': '1f606',
    ';-)': '1f609',
    '*-)': '1f609',
    ';-]': '1f609',
    ';^)': '1f609',
    "':(": '1f613',
    "'=(": '1f613',
    ':-*': '1f618',
    ':^*': '1f618',
    '>:P': '1f61c',
    'X-P': '1f61c',
    '>:[': '1f61e',
    ':-(': '1f61e',
    ':-[': '1f61e',
    '>:(': '1f620',
    ":'(": '1f622',
    ';-(': '1f622',
    '>.<': '1f623',
    '#-)': '1f635',
    '%-)': '1f635',
    'X-)': '1f635',
    '\\0/': '1f646',
    '\\O/': '1f646',
    '0:3': '1f607',
    '0:)': '1f607',
    'O:)': '1f607',
    'O=)': '1f607',
    'O:3': '1f607',
    'B-)': '1f60e',
    '8-)': '1f60e',
    'B-D': '1f60e',
    '8-D': '1f60e',
    '-_-': '1f611',
    '>:\\': '1f615',
    '>:/': '1f615',
    ':-/': '1f615',
    ':-.': '1f615',
    ':-P': '1f61b',
    ':Þ': '1f61b',
    ':-b': '1f61b',
    ':-O': '1f62e',
    'O_O': '1f62e',
    '>:O': '1f62e',
    ':-X': '1f636',
    ':-#': '1f636',
    ':-)': '1f642',
    '(y)': '1f44d',
    '<3': '2764',
    ':D': '1f603',
    '=D': '1f603',
    ';)': '1f609',
    '*)': '1f609',
    ';]': '1f609',
    ';D': '1f609',
    ':*': '1f618',
    '=*': '1f618',
    ':(': '1f61e',
    ':[': '1f61e',
    '=(': '1f61e',
    ':@': '1f620',
    ';(': '1f622',
    'D:': '1f628',
    ':$': '1f633',
    '=$': '1f633',
    '#)': '1f635',
    '%)': '1f635',
    'X)': '1f635',
    'B)': '1f60e',
    '8)': '1f60e',
    ':/': '1f615',
    ':\\': '1f615',
    '=/': '1f615',
    '=\\': '1f615',
    ':L': '1f615',
    '=L': '1f615',
    ':P': '1f61b',
    '=P': '1f61b',
    ':b': '1f61b',
    ':O': '1f62e',
    ':X': '1f636',
    ':#': '1f636',
    '=X': '1f636',
    '=#': '1f636',
    ':)': '1f642',
    '=]': '1f642',
    '=)': '1f642',
    ':]': '1f642',
};

function toCodePoint(unicode_surrogates) {
    const r = [];
    let p = 0;
    let i = 0;
    while (i < unicode_surrogates.length) {
        const c = unicode_surrogates.charCodeAt(i++);
        if (p) {
            r.push((0x10000 + ((p - 0xd800) << 10) + (c - 0xdc00)).toString(16));
            p = 0;
        } else if (0xd800 <= c && c <= 0xdbff) {
            p = c;
        } else {
            r.push(c.toString(16));
        }
    }
    return r.join('-');
}

/**
 * If it already looks like a shortname, use it directly.
 * Otherwise try to resolve it via codepoint.
 *
 * @param {string} emoji - A unicode emoji or shortname
 */
function emojiToShortname(emoji) {
    if (emoji.match(SHORTNAME_RE)) {
        return emoji;
    } else {
        const by_cp = getEmojisByAttribute('cp');
        const cp = emoji_utils_u.emojis.emojiToCodepointKey(emoji);
        return by_cp[cp]?.sn ?? emoji;
    }
}

/**
 * Convert a unicode emoji string to its codepoint key as used in the emoji data
 * (e.g. '❤️' → '2764-fe0f', '👍' → '1f44d').
 * @param {string} emoji
 * @returns {string}
 */
function emojiToCodepointKey(emoji) {
    return [...emoji].map((c) => c.codePointAt(0).toString(16)).join('-');
}

/**
 * @param {number|string} codepoint
 * @returns {string}
 */
function fromCodePoint(codepoint) {
    let code = typeof codepoint === 'string' ? parseInt(codepoint, 16) : codepoint;
    if (code < 0x10000) {
        return String.fromCharCode(code);
    }
    code -= 0x10000;
    return String.fromCharCode(0xd800 + (code >> 10), 0xdc00 + (code & 0x3ff));
}

/**
 * Converts unicode code points and code pairs to their respective characters
 * @param {string} unicode
 */
function utils_convert(unicode) {
    if (unicode.indexOf('-') > -1) {
        const parts = [];
        const s = unicode.split('-');

        for (let i = 0; i < s.length; i++) {
            const part = parseInt(s[i], 16);
            if (part >= 0x10000 && part <= 0x10ffff) {
                const hi = Math.floor((part - 0x10000) / 0x400) + 0xd800;
                const lo = ((part - 0x10000) % 0x400) + 0xdc00;
                parts.push(String.fromCharCode(hi) + String.fromCharCode(lo));
            } else {
                parts.push(String.fromCharCode(part));
            }
        }
        return parts.join('');
    }
    return fromCodePoint(unicode);
}

/**
 * @param {string} str
 */
function convertASCII2Emoji(str) {
    // Replace ASCII smileys
    return str.replace(ASCII_REPLACE_REGEX, (entire, _, m2, m3) => {
        if (typeof m3 === 'undefined' || m3 === '' || !(unescapeHTML(m3) in ASCII_LIST)) {
            // if the ascii doesn't exist just return the entire match
            return entire;
        }
        m3 = unescapeHTML(m3);
        const unicode = ASCII_LIST[m3].toUpperCase();
        return m2 + utils_convert(unicode);
    });
}

/**
 * @param {string} text
 * @returns {import('./types').EmojiReference[]}
 */
function getShortnameReferences(text) {
    if (!api_public.emojis.initialized) {
        throw new Error(
            'getShortnameReferences called before emojis are initialized. ' +
                'To avoid this problem, first await the converse.emojis.initialized_promise',
        );
    }
    const references = [...text.matchAll(api_public.emojis.shortnames_regex)].filter((ref) => ref[0].length > 0);
    return references.map((ref) => {
        const cp = api_public.emojis.by_sn[ref[0]]?.cp;
        return {
            cp,
            begin: ref.index,
            end: ref.index + ref[0].length,
            shortname: ref[0],
            emoji: cp ? utils_convert(cp) : null,
        };
    });
}

/**
 * @param {string} str
 * @param {Function} callback
 */
function parseStringForEmojis(str, callback) {
    const UFE0Fg = /\uFE0F/g;
    const U200D = String.fromCharCode(0x200d);
    return String(str).replace(CODEPOINTS_REGEX, (emoji, _, offset) => {
        const icon_id = toCodePoint(emoji.indexOf(U200D) < 0 ? emoji.replace(UFE0Fg, '') : emoji);
        if (icon_id) callback(icon_id, emoji, offset);
        return emoji;
    });
}

/**
 * @param {string} text
 * @returns {import('./types').EmojiReference[]}
 */
function getCodePointReferences(text) {
    const references = [];
    parseStringForEmojis(text, (icon_id, emoji, offset) => {
        references.push({
            begin: offset,
            cp: icon_id,
            emoji: emoji,
            end: offset + emoji.length,
            shortname: getEmojisByAttribute('cp')[icon_id]?.sn || '',
        });
    });
    return references;
}

/**
 * @param {string} text
 * @returns {string[]}
 */
function addEmojisMarkup(text) {
    let list = [text];
    [...getShortnameReferences(text), ...getCodePointReferences(text)]
        .sort((a, b) => b.begin - a.begin)
        .forEach((ref) => {
            const text = list.shift();
            const emoji = ref.emoji || ref.shortname;
            list = [text.slice(0, ref.begin) + emoji + text.slice(ref.end), ...list];
        });
    return list;
}

/**
 * Replaces all shortnames in the passed in string with their
 * unicode (emoji) representation.
 * @param {String} str - String containing the shortname(s)
 * @returns {String}
 */
function shortnamesToUnicode(str) {
    return addEmojisMarkup(convertASCII2Emoji(str)).pop();
}

/**
 * Determines whether the passed in string is just a single emoji shortname;
 * @namespace u
 * @method u.isOnlyEmojis
 * @param {String} text - A string which might be just an emoji shortname
 * @returns {Boolean}
 */
function isOnlyEmojis(text) {
    const words = text.trim().split(/\s+/);
    if (words.length === 0 || words.length > 3) {
        return false;
    }
    const emojis = words.filter((text) => {
        const refs = getCodePointReferences(emoji_utils_u.emojis.shortnamesToUnicode(text));
        return refs.length === 1 && (text === refs[0]['shortname'] || text === refs[0]['emoji']);
    });
    return emojis.length === words.length;
}

/**
 * @param { 'category'|'cp'|'sn' } attr
 *  The attribute according to which the returned map should be keyed.
 * @returns { Object }
 *  Map of emojis with the passed in `attr` used as key and a list of emojis as values.
 */
function getEmojisByAttribute(attr) {
    if (emojis_by_attribute[attr]) {
        return emojis_by_attribute[attr];
    }
    if (attr === 'category') {
        return api_public.emojis.json;
    }
    const all_variants = api_public.emojis.list.map((e) => e[attr]).filter((c, i, arr) => arr.indexOf(c) == i);

    emojis_by_attribute[attr] = {};
    all_variants.forEach((v) => (emojis_by_attribute[attr][v] = api_public.emojis.list.find((i) => i[attr] === v)));
    return emojis_by_attribute[attr];
}

Object.assign(emoji_utils_u, {
    emojis: {
        convert: utils_convert,
        convertASCII2Emoji,
        emojiToCodepointKey,
        emojiToShortname,
        getCodePointReferences,
        getEmojisByAttribute,
        getShortnameReferences,
        isOnlyEmojis,
        shortnamesToUnicode,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/handlers.js





const { Strophe: handlers_Strophe } = api_public.env;

function registerPEPPushHandler() {
    const bare_jid = shared_converse.session.get('bare_jid');
    shared_api.connection.get().addHandler(
        /** @param {Element} stanza */
        (stanza) => {
            const { popular_emojis } = shared_converse.state;
            popular_emojis?.applyPopularEmojisFromStanza(stanza);
            return true;
        },
        handlers_Strophe.NS.REACTIONS_POPULAR,
        'message',
        'headline',
        null,
        bare_jid,
    );
}

/**
 * Given a message, extract emojis from it and use them to update the list of
 * popular emojis.
 * @param {import('../../plugins/reactions/utils').BaseMessage} message
 */
async function updatePopularEmojis(message) {
    const body = message.get('body');
    if (!body) return;

    await shared_api.emojis.initialize();

    const { popular_emojis } = shared_converse.state;
    if (!popular_emojis) return;

    const shortname_refs = new Set(getShortnameReferences(body).map(({ shortname }) => shortname));
    const cp_refs = new Set(getCodePointReferences(body).map(({ emoji }) => emoji));
    const emojis = [...shortname_refs, ...cp_refs];

    if (emojis.length) {
        popular_emojis.recordUsage(emojis);
    }
}

/**
 * @param {import('../../shared/types').MessageAttributes} attrs
 * @param {String} text
 * @returns {Promise<import('../../shared/types').MessageAttributes & { is_only_emojis: boolean }>}
 */
async function handlers_parseMessage(attrs, text) {
    await shared_api.emojis.initialize();
    return {
        ...attrs,
        is_only_emojis: text ? isOnlyEmojis(text) : false,
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/popular-emojis.js










const { Strophe: popular_emojis_Strophe, sizzle: popular_emojis_sizzle, stx: popular_emojis_stx, u: popular_emojis_u } = api_public.env;

class PopularEmojis extends skeletor_esm_Model {
    defaults() {
        return {
            // Format: { 'unicode_emoji': 'ISO8601-timestamp', ... }
            timestamps: {},
        };
    }

    initialize() {
        super.initialize();
        const { session } = shared_converse;
        const storage_key = `converse.popular_emojis_frequencies.${session.get('bare_jid')}`;
        const fetched_flag_key = `${storage_key}-fetched`;

        this.fetched_flag = fetched_flag_key;
        this.debouncedPublish = promise_debounce(() => this.publish(), (/* inlined export .PUBLISH_DEBOUNCE_MILLIS */30000));
        popular_emojis_u.initStorage(this, storage_key);
        this.fetchPopularEmojis();
    }

    async fetchPopularEmojis() {
        if (shared_converse.state.session.get(this.fetched_flag)) {
            const deferred = openpromise_getOpenPromise();
            this.fetch({
                success: () => deferred.resolve(),
                error: () => deferred.resolve(),
            });
            return deferred;
        } else {
            await this.fetchPopularEmojisFromServer();
        }
    }

    /**
     * Fetch the user's stored popular emojis from their PEP node and apply them.
     * If no item is stored, the default `popular_emojis` setting is left unchanged.
     */
    async fetchPopularEmojisFromServer() {
        const bare_jid = shared_converse.state.session.get('bare_jid');
        let iq;
        try {
            iq = await shared_api.sendIQ(
                popular_emojis_stx`<iq type="get" from="${bare_jid}" to="${bare_jid}" xmlns="jabber:client">
                    <pubsub xmlns="${popular_emojis_Strophe.NS.PUBSUB}">
                        <items node="${popular_emojis_Strophe.NS.REACTIONS_POPULAR}" max_items="1"/>
                    </pubsub>
                </iq>`,
            );
            this.applyPopularEmojisFromStanza(iq);
        } catch (e) {
            // item-not-found is expected when the user has never saved a custom list
            if (e?.querySelector?.('item-not-found')) return;
            src_log.warn('fetchPopularEmojisFromServer: could not fetch popular emojis from PubSub');
            src_log.error(e);
            return;
        }
    }

    /**
     * Parse a list of unicode emoji from a popular-reactions PubSub item and
     * merge the received timestamps with local ones, keeping the most recent
     * timestamp per emoji (last-write-wins per slot).
     *
     * @param {Element} stanza - An IQ result or headline message containing the pubsub item
     */
    applyPopularEmojisFromStanza(stanza) {
        const item = popular_emojis_sizzle(`items[node="${popular_emojis_Strophe.NS.REACTIONS_POPULAR}"] item`, stanza).pop();
        if (!item) return;

        const popular_el = item.getElementsByTagNameNS(popular_emojis_Strophe.NS.REACTIONS_POPULAR, 'popular-reactions')[0];
        if (!popular_el) return;

        const reactions = Array.from(popular_el.querySelectorAll('reaction'))
            .map((el) => ({ emoji: el.textContent?.trim(), stamp: el.getAttribute('stamp') }))
            .filter(({ emoji, stamp }) => emoji && stamp);

        if (!reactions.length) return;

        const local_timestamps = { ...(this.get('timestamps') || {}) };

        for (const { emoji, stamp } of reactions) {
            const remote_ms = new Date(stamp).getTime();
            if (isNaN(remote_ms)) continue;

            // Normalise to UTC ISO string so stored values are always comparable
            // as strings, regardless of the timezone used by the sending device.
            const normalised_stamp = new Date(remote_ms).toISOString();

            const local_stamp = local_timestamps[emoji];
            const local_ms = local_stamp ? new Date(local_stamp).getTime() : 0;

            // Keep whichever timestamp is more recent (last-write-wins per emoji)
            if (remote_ms > local_ms) {
                local_timestamps[emoji] = normalised_stamp;
            }
        }

        this.save({ timestamps: local_timestamps });
    }

    /**
     * Record that an emoji was just used, setting its timestamp to now.
     * Accepts unicode emoji or shortnames. Shortnames are converted to unicode
     * before storage to prevent duplicates. Unicode is stored as-is (preserving
     * variation selectors like U+FE0F).
     *
     * @param {string[]} emojis - An array of unicode emojis and/or shortnames
     */
    recordUsage(emojis) {
        const timestamps = { ...(this.get('timestamps') || {}) };
        const by_sn = api_public.emojis.by_sn || {};

        emojis.forEach((emoji) => {
            let unicode;
            if (SHORTNAME_RE.test(emoji)) {
                const emoji_data = by_sn[emoji];
                if (emoji_data?.cp) {
                    unicode = popular_emojis_u.emojis.convert(emoji_data.cp);
                } else {
                    return;
                }
            } else {
                unicode = emoji;
            }
            timestamps[unicode] = new Date().toISOString();
        });
        this.save({ timestamps });
        this.debouncedPublish();
    }

    /**
     * Get emojis sorted by most recently used first.
     * @param {number} [maxLength=5] - Maximum number of emojis to return
     * @returns {string[]} - Array of unicode emoji keys sorted by timestamp descending
     */
    getSortedEmojis(maxLength = 5) {
        const timestamps = this.get('timestamps') || {};
        return Object.entries(timestamps)
            .sort((a, b) => new Date(b[1]).getTime() - new Date(a[1]).getTime() || a[0].localeCompare(b[0]))
            .map((entry) => entry[0])
            .slice(0, maxLength);
    }

    /**
     * @returns {Promise<import('./types').EmojiDataByUnicode>} Map from unicode emoji to data
     */
    async getPopularEmojis() {
        await shared_api.emojis.initialize();

        const result = /** @type{import('./types').EmojiDataByUnicode} */ ({});

        const default_setting = shared_api.settings.get('popular_emojis') ?? [];
        const max = default_setting.length || 5;
        const sorted = this.getSortedEmojis(max);
        const by_cp = popular_emojis_u.emojis.getEmojisByAttribute('cp');

        for (const key of sorted) {
            const emoji_data = by_cp[emojiToCodepointKey(key)];
            if (!emoji_data) continue;

            result[key] = emoji_data;
        }

        if (Object.keys(result).length < max) {
            const by_sn = api_public.emojis.by_sn || {};
            for (const sn of default_setting) {
                if (Object.keys(result).length >= max) break;
                const data = by_sn[sn];
                const unicode = data?.cp ? popular_emojis_u.emojis.convert(data.cp) : null;
                if (unicode && !result[unicode]) {
                    const emoji_data = by_cp[emojiToCodepointKey(unicode)];
                    if (emoji_data) result[unicode] = emoji_data;
                }
            }
        }

        return result;
    }

    async publish() {
        // `publish` is debounced and fire-and-forget; the session may have been
        // torn down before it fires. There's nothing to publish to without a
        // connection (and the hooks/api it relies on would be gone).
        if (!shared_api.connection.connected()) return;

        await shared_api.emojis.initialize();

        const default_setting = shared_api.settings.get('popular_emojis') ?? [];
        const max = default_setting.length || 5;
        const sorted = this.getSortedEmojis(max);
        const timestamps = this.get('timestamps') || {};

        const item = popular_emojis_stx`
            <item id="current">
                <popular-reactions xmlns="${popular_emojis_Strophe.NS.REACTIONS_POPULAR}">
                    ${sorted.map((e) => popular_emojis_stx`<reaction stamp="${timestamps[e]}">${e}</reaction>`)}
                </popular-reactions>
            </item>`;

        try {
            await shared_api.pubsub.publish(null, popular_emojis_Strophe.NS.REACTIONS_POPULAR, item, {
                persist_items: 'true',
                access_model: 'whitelist',
            });
        } catch (e) {
            src_log.warn('PopularEmojis#publish: failed to update popular emojis');
            src_log.error(e);
        }
    }
}

/* export default */ const emoji_popular_emojis = (PopularEmojis);

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/plugin.js
/**
 * @module converse-emoji
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */









const { Strophe: plugin_Strophe } = api_public.env;

plugin_Strophe.addNamespace('REACTIONS_POPULAR', 'urn:xmpp:reactions:popular:0');

api_public.emojis = {
    initialized: false,
    initialized_promise: openpromise_getOpenPromise(),
};

api_public.plugins.add('converse-emoji', {
    initialize() {
        /* The initialize function gets called as soon as the plugin is
         * loaded by converse.js's plugin machinery.
         */
        const { ___ } = shared_converse;

        shared_api.settings.extend({
            emoji_image_path: 'https://twemoji.maxcdn.com/v/12.1.6/',
            emoji_categories: {
                popular: ':star:',
                smileys: ':grinning:',
                people: ':thumbsup:',
                activity: ':soccer:',
                travel: ':motorcycle:',
                objects: ':bomb:',
                nature: ':rainbow:',
                food: ':hotdog:',
                symbols: ':musical_note:',
                flags: ':flag_ac:',
                custom: null,
            },
            popular_emojis: [':thumbsup:', ':heart:', ':laughing:', ':joy:', ':tada:'],
            // We use the triple-underscore method which doesn't actually
            // translate but does signify to gettext that these strings should
            // go into the POT file. The translation then happens in the
            // template. We do this so that users can pass in their own
            // strings via converse.initialize, which is before __ is
            // available.
            emoji_category_labels: {
                popular: ___('Frequently used'),
                smileys: ___('Smileys and emotions'),
                people: ___('People'),
                activity: ___('Activities'),
                travel: ___('Travel'),
                objects: ___('Objects'),
                nature: ___('Animals and nature'),
                food: ___('Food and drink'),
                symbols: ___('Symbols'),
                flags: ___('Flags'),
                custom: ___('Stickers'),
            },
        });

        const exports = { EmojiPicker: picker };
        Object.assign(shared_converse, exports); // XXX: DEPRECATED
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_api, emoji_api);

        shared_api.listen.on('connected', () => {
            registerPEPPushHandler();
            if (shared_converse.state.popular_emojis) return;

            const popular_emojis = new emoji_popular_emojis();
            Object.assign(shared_converse.state, { popular_emojis });
        });

        shared_api.listen.on('clearSession', () => {
            shared_converse.state.popular_emojis?.debouncedPublish.flush();
            delete shared_converse.state.popular_emojis;
        });

        shared_api.listen.on('getOutgoingMessageAttributes', async (_chat, attrs) => handlers_parseMessage(attrs, attrs.original_text));
        shared_api.listen.on('parseMUCMessage', (_chat, attrs) => handlers_parseMessage(attrs, attrs.body));
        shared_api.listen.on('parseMessage', (_chat, attrs) => handlers_parseMessage(attrs, attrs.body));
        shared_api.listen.on('sendMessage', async ({ message }) => updatePopularEmojis(message));
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/emoji/index.js





;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/model.js



const { Strophe: model_Strophe } = api_public.env;

class Bookmark extends skeletor_esm_Model {
    get idAttribute() {
        return 'jid';
    }

    getDisplayName() {
        return this.get('name') && model_Strophe.xmlunescape(this.get('name')) || this.get('jid');
    }
}

/* export default */ const bookmarks_model = (Bookmark);

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/parsers.js




const { Strophe: bookmarks_parsers_Strophe, sizzle: bookmarks_parsers_sizzle } = api_public.env;

/**
 * @param {Element} stanza
 * @returns {Promise<Array<import('./types.js').BookmarkAttrs>>}
 */
async function parseStanzaForBookmarks(stanza) {
    let ns;
    let sel;
    const bare_jid = shared_converse.session.get('bare_jid');
    if (await shared_api.disco.supports(`${bookmarks_parsers_Strophe.NS.BOOKMARKS2}#compat`, bare_jid)) {
        ns = bookmarks_parsers_Strophe.NS.BOOKMARKS2;
        sel = `items[node="${ns}"] item conference`;
    } else {
        ns = bookmarks_parsers_Strophe.NS.BOOKMARKS;
        sel = `items[node="${ns}"] item storage[xmlns="${ns}"] conference`;
    }
    return bookmarks_parsers_sizzle(sel, stanza).map(
        /** @param {Element} el */ (el) => {
            const jid = ns === bookmarks_parsers_Strophe.NS.BOOKMARKS2 ? el.parentElement.getAttribute('id') : el.getAttribute('jid');
            return {
                jid,
                name: el.getAttribute('name') || jid,
                autojoin: ['1', 'true'].includes(el.getAttribute('autojoin')),
                nick: el.querySelector('nick')?.textContent ?? '',
                password: el.querySelector('password')?.textContent ?? '',
                extensions: Array.from(el.querySelector('extensions')?.children ?? []).map(c => c.outerHTML),
            };
        }
    );
}

;// CONCATENATED MODULE: ./src/headless/plugins/muc/message.js




class MUCMessage extends shared_message {
    /**
     * @typedef {import('./occupant').default} MUCOccupant
     */
    initialize() {
        super.initialize();

        // If `type` changes from `error` to `groupchat`, we want to set the occupant. See #2733
        this.on('change:type', () => this.setOccupant());
        this.setOccupant();

        /**
         * Triggered once a { @link MUCMessage} has been created and initialized.
         * @event _converse#chatRoomMessageInitialized
         * @type {MUCMessage}
         * @example _converse.api.listen.on('chatRoomMessageInitialized', model => { ... });
         */
        shared_api.trigger('chatRoomMessageInitialized', this);
    }

    get occupants() {
        return this.get('type') === 'chat' ? this.chatbox.collection : this.chatbox.occupants;
    }

    getDisplayName() {
        return this.occupant?.getDisplayName() || this.get('nick');
    }

    /**
     * Determines whether this message may be moderated,
     * based on configuration settings and server support.
     * @method _converse.ChatRoomMessages#mayBeModerated
     * @returns {Promise<boolean>}
     */
    async mayBeModerated() {
        if (typeof this.get('from_muc') === 'undefined') {
            // If from_muc is not defined, then this message hasn't been
            // reflected yet, which means we won't have a XEP-0359 stanza id.
            return;
        }
        return (
            ['all', 'moderator'].includes(shared_api.settings.get('allow_message_retraction')) &&
            this.get(`stanza_id ${this.get('from_muc')}`) &&
            (await this.chatbox.canModerateMessages())
        );
    }

    checkValidity() {
        const result = super.checkValidity();
        !result && this.chatbox.debouncedRejoin();
        return result;
    }

    onOccupantRemoved() {
        this.stopListening(this.occupant);
        delete this.occupant;
        this.listenTo(this.occupants, 'add', this.onOccupantAdded);
    }

    /**
     * @param {MUCOccupant} [occupant]
     */
    onOccupantAdded(occupant) {
        if (this.get('occupant_id')) {
            if (occupant.get('occupant_id') !== this.get('occupant_id')) {
                return;
            }
        } else if (occupant.get('nick') !== Strophe.getResourceFromJid(this.get('from'))) {
            return;
        }
        this.setOccupant(occupant);
    }

    getOccupant() {
        return this.occupant || this.setOccupant();
    }

    /**
     * @param {MUCOccupant} [occupant]
     * @return {MUCOccupant}
     */
    setOccupant(occupant) {
        if (!['groupchat', 'chat'].includes(this.get('type')) || this.isEphemeral()) {
            return;
        }

        if (occupant) {
            this.occupant = occupant;
        } else if (this.get('type') === 'chat' && this.get('sender') === 'them') {
            this.occupant = this.chatbox;
        } else {
            if (this.occupant) return;

            const nick = Strophe.getResourceFromJid(this.get('from'));
            const occupant_id = this.get('occupant_id');
            this.occupant = nick || occupant_id ? this.occupants.findOccupant({ nick, occupant_id }) : null;

            if (!this.occupant) {
                const jid = this.get('from_real_jid');
                if (!nick && !occupant_id && !jid) {
                    // Tombstones of retracted messages might have no occupant info
                    return;
                }

                this.occupant = this.occupants.create({ nick, occupant_id, jid });

                if (shared_api.settings.get('muc_send_probes')) {
                    const jid = `${this.chatbox.get('jid')}/${nick}`;
                    shared_api.user.presence.send({ to: jid, type: 'probe' });
                }
            }
        }

        if (this.get('from_real_jid') !== this.occupant.get('jid')) {
            this.save('from_real_jid', this.occupant.get('jid'));
        }

        this.trigger('occupant:add');
        this.listenTo(this.occupant, 'change', (changed) => this.trigger('occupant:change', changed));
        this.listenTo(this.occupant, 'vcard:add', (changed) => this.trigger('occupant:change', changed));
        this.listenTo(this.occupant, 'vcard:change', (changed) => this.trigger('occupant:change', changed));
        this.listenTo(this.occupant, 'destroy', this.onOccupantRemoved);
        this.stopListening(this.occupants, 'add', this.onOccupantAdded);

        return this.occupant;
    }
}

/* export default */ const muc_message = (MUCMessage);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/messages.js



/**
 * Collection which stores MUC messages
 * @extends {Collection<MUCMessage>}
 */
class MUCMessages extends Collection {
    /**
     * @param {import('@converse/skeletor').ModelAttributes[]} [models]
     * @param {import('@converse/skeletor').CollectionOptions<MUCMessage>} [options]
     */
    constructor(models, options = {}) {
        super(models, Object.assign({ comparator: 'time' }, options));
        this.model = muc_message;
        this.fetched = null;
    }
}

/* export default */ const muc_messages = (MUCMessages);

;// CONCATENATED MODULE: ./src/headless/utils/parse-helpers.js
/**
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Pure functions to help functionally parse messages.
 * @todo Other parsing helpers can be made more abstract and placed here.
 */
const helpers = {};

const escapeRegexChars = (string, char) => string.replace(RegExp('\\' + char, 'ig'), '\\' + char);

helpers.escapeCharacters = characters => string =>
    characters.split('').reduce(escapeRegexChars, string);

helpers.escapeRegexString = helpers.escapeCharacters('[\\^$.?*+(){}|');

// `for` is ~25% faster than using `Array.find()`
helpers.findFirstMatchInArray = array => text => {
    for (let i = 0; i < array.length; i++) {
        if (text.localeCompare(array[i], undefined, {sensitivity: 'base'}) === 0) {
            return array[i];
        }
    }
    return null;
};

const reduceReferences = ([text, refs], ref, index) => {
    let updated_text = text;
    let { begin, end } = ref;
    const { value } = ref;
    begin = begin - index;
    end = end - index - 1; // -1 to compensate for the removed @
    updated_text = `${updated_text.slice(0, begin)}${value}${updated_text.slice(end + 1)}`;
    return [updated_text, [...refs, { ...ref, begin, end }]]
}

helpers.reduceTextFromReferences = (text, refs) => refs.reduce(reduceReferences, [text, []]);

/* export default */ const parse_helpers = (helpers);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/constants.js
const ACTION_INFO_CODES = ['301', '333', '307', '321', '322'];
const NEW_NICK_CODES = ['210', '303'];
const ADMIN_COMMANDS = ['admin', 'ban', 'deop', 'destroy', 'member', 'op', 'revoke'];
const AFFILIATIONS = ['owner', 'admin', 'member', 'outcast', 'none'];
const DISCONNECT_CODES = ['301', '333', '307', '321', '322', '332'];
const MODERATOR_COMMANDS = ['kick', 'mute', 'voice', 'modtools'];
const OWNER_COMMANDS = ['owner'];
const ROLES = ['moderator', 'participant', 'visitor'];
const VISITOR_COMMANDS = ['nick'];

// Which types of stanzas a status code might appear in.
const STATUS_CODE_STANZAS = {
    '100': ['message', 'presence'],
    '101': ['message'],
    '102': ['message'],
    '103': ['message'],
    '104': ['message'],
    '110': ['presence'],
    '170': ['message', 'presence'],
    '171': ['message'],
    '172': ['message'],
    '173': ['message'],
    '174': ['message'],
    '201': ['presence'],
    '210': ['presence'],
    '301': ['presence'],
    '303': ['presence'],
    '307': ['presence'],
    '321': ['presence'],
    '322': ['presence'],
    '332': ['presence'],
    '333': ['presence'],
};

const MUC_ROLE_WEIGHTS = {
    'moderator': 1,
    'participant': 2,
    'visitor': 3,
    'none': 2,
};

const AFFILIATION_CHANGES = {
    OWNER: 'owner',
    ADMIN: 'admin',
    MEMBER: 'member',
    EXADMIN: 'exadmin',
    EXOWNER: 'exowner',
    EXOUTCAST: 'exoutcast',
    EXMEMBER: 'exmember',
};

const AFFILIATION_CHANGES_LIST = Object.values(AFFILIATION_CHANGES);
const MUC_TRAFFIC_STATES = { ENTERED: 'entered', EXITED: 'exited' };
const MUC_TRAFFIC_STATES_LIST = Object.values(MUC_TRAFFIC_STATES);
const MUC_ROLE_CHANGES = { OP: 'op', DEOP: 'deop', VOICE: 'voice', MUTE: 'mute' };
const MUC_ROLE_CHANGES_LIST = Object.values(MUC_ROLE_CHANGES);

const INFO_CODES = {
    'visibility_changes': ['100', '102', '103', '172', '173', '174'],
    'self': ['110'],
    'non_privacy_changes': ['104', '201'],
    'muc_logging_changes': ['170', '171'],
    'nickname_changes': ['210', '303'],
    'disconnected': ['301', '307', '321', '322', '332', '333'],
    'affiliation_changes': [...AFFILIATION_CHANGES_LIST],
    'join_leave_events': [...MUC_TRAFFIC_STATES_LIST],
    'role_changes': [...MUC_ROLE_CHANGES_LIST],
};

const ROOMSTATUS = {
    CONNECTED: 0,
    CONNECTING: 1,
    NICKNAME_REQUIRED: 2,
    PASSWORD_REQUIRED: 3,
    DISCONNECTED: 4,
    ENTERED: 5,
    DESTROYED: 6,
    BANNED: 7,
    CLOSING: 8,
};

const ROOM_FEATURES = [
    'passwordprotected',
    'unsecured',
    'hidden',
    'publicroom',
    'membersonly',
    'open',
    'persistent',
    'temporary',
    'nonanonymous',
    'semianonymous',
    'moderated',
    'unmoderated',
    'mam_enabled',
    'vcard-temp',
];

const MUC_NICK_CHANGED_CODE = '303';

// No longer used in code, but useful as reference.
//
// const ROOM_FEATURES_MAP = {
//     'passwordprotected': 'unsecured',
//     'unsecured': 'passwordprotected',
//     'hidden': 'publicroom',
//     'publicroom': 'hidden',
//     'membersonly': 'open',
//     'open': 'membersonly',
//     'persistent': 'temporary',
//     'temporary': 'persistent',
//     'nonanonymous': 'semianonymous',
//     'semianonymous': 'nonanonymous',
//     'moderated': 'unmoderated',
//     'unmoderated': 'moderated'
// };

;// CONCATENATED MODULE: ./src/headless/plugins/muc/parsers.js
/**
 * @module:plugin-muc-parsers
 * @typedef {import('../muc/muc.js').default} MUC
 * @typedef {import('./types').MUCMessageAttributes} MUCMessageAttributes
 */







const { Strophe: muc_parsers_Strophe, dayjs: muc_parsers_dayjs, sizzle: muc_parsers_sizzle, u: muc_parsers_u } = api_public.env;
const { NS: muc_parsers_NS } = muc_parsers_Strophe;

/**
 * Parses a message stanza for XEP-0316 MEP notification data
 * @param {Element} stanza - The message stanza
 * @returns {Array} Returns an array of objects representing <activity> elements.
 */
function getMEPActivities(stanza) {
    const items_el = muc_parsers_sizzle(`items[node="${muc_parsers_Strophe.NS.CONFINFO}"]`, stanza).pop();
    if (!items_el) {
        return null;
    }
    const from = stanza.getAttribute('from');
    const msgid = stanza.getAttribute('id');
    const selector =
        `item ` + `conference-info[xmlns="${muc_parsers_Strophe.NS.CONFINFO}"] ` + `activity[xmlns="${muc_parsers_Strophe.NS.ACTIVITY}"]`;
    return muc_parsers_sizzle(selector, items_el).map(
        /** @param {Element} el */ (el) => {
            const message = el.querySelector('text')?.textContent;
            if (message) {
                const references = getReferences(stanza);
                const reason = el.querySelector('reason')?.textContent;
                return { from, msgid, message, reason, references, 'type': 'mep' };
            }
            return {};
        },
    );
}

/**
 * Given a MUC stanza, check whether it has extended message information that
 * includes the sender's real JID, as described here:
 * https://xmpp.org/extensions/xep-0313.html#business-storeret-muc-archives
 *
 * If so, parse and return that data and return the user's JID
 *
 * Note, this function doesn't check whether this is actually a MAM archived stanza.
 *
 * @param {Element} stanza - The message stanza
 * @returns {Object}
 */
function getJIDFromMUCUserData(stanza) {
    const item = muc_parsers_sizzle(`message > x[xmlns="${muc_parsers_Strophe.NS.MUC_USER}"] item`, stanza).pop();
    return item?.getAttribute('jid');
}

/**
 * @param {Element} stanza - The message stanza
 *  message stanza, if it was contained, otherwise it's the message stanza itself.
 * @returns {Object}
 */
function getDeprecatedModerationAttributes(stanza) {
    const fastening = muc_parsers_sizzle(`apply-to[xmlns="${muc_parsers_Strophe.NS.FASTEN}"]`, stanza).pop();
    if (fastening) {
        const applies_to_id = fastening.getAttribute('id');
        const moderated = muc_parsers_sizzle(`moderated[xmlns="${muc_parsers_Strophe.NS.MODERATE0}"]`, fastening).pop();
        if (moderated) {
            const retracted = muc_parsers_sizzle(`retract[xmlns="${muc_parsers_Strophe.NS.RETRACT0}"]`, moderated).pop();
            if (retracted) {
                return {
                    editable: false,
                    moderated: 'retracted',
                    moderated_by: moderated.getAttribute('by'),
                    moderated_id: applies_to_id,
                    moderation_reason: moderated.querySelector('reason')?.textContent,
                };
            }
        }
    } else {
        const tombstone = muc_parsers_sizzle(`> moderated[xmlns="${muc_parsers_Strophe.NS.MODERATE0}"]`, stanza).pop();
        if (tombstone) {
            const retracted = muc_parsers_sizzle(`retracted[xmlns="${muc_parsers_Strophe.NS.RETRACT0}"]`, tombstone).pop();
            if (retracted) {
                return {
                    editable: false,
                    is_tombstone: true,
                    moderated_by: tombstone.getAttribute('by'),
                    retracted: tombstone.getAttribute('stamp'),
                    moderation_reason: tombstone.querySelector('reason')?.textContent,
                };
            }
        }
    }
    return {};
}

/**
 * @param {Element} stanza - The message stanza
 *  message stanza, if it was contained, otherwise it's the message stanza itself.
 * @returns {Object}
 */
function getModerationAttributes(stanza) {
    const retract = muc_parsers_sizzle(`> retract[xmlns="${muc_parsers_Strophe.NS.RETRACT}"]`, stanza).pop();
    if (retract) {
        const moderated = muc_parsers_sizzle(`moderated[xmlns="${muc_parsers_Strophe.NS.MODERATE}"]`, retract).pop();
        if (moderated) {
            return {
                editable: false,
                moderated: 'retracted',
                moderated_by: moderated.getAttribute('by'),
                moderated_by_id: moderated.querySelector('occupant-id')?.getAttribute('id'),
                moderated_id: retract.getAttribute('id'),
                moderation_reason: retract.querySelector('reason')?.textContent,
            };
        }
    } else {
        const tombstone = muc_parsers_sizzle(`retracted[xmlns="${muc_parsers_Strophe.NS.RETRACT}"]`, stanza).pop();
        if (tombstone) {
            return {
                editable: false,
                is_tombstone: true,
                moderated_by: tombstone.getAttribute('by'),
                moderated_by_id: tombstone.querySelector('occupant-id')?.getAttribute('id'),
                retracted: tombstone.getAttribute('stamp'),
                moderation_reason: tombstone.querySelector('reason')?.textContent,
            };
        }
    }
    return getDeprecatedModerationAttributes(stanza);
}

/**
 * @param {Element} stanza
 * @param {'presence'|'message'} type
 * @returns {{codes: Array<import('./types').MUCStatusCode>, is_self: boolean}}
 */
function getStatusCodes(stanza, type) {
    /**
     * @typedef {import('./types').MUCStatusCode} MUCStatusCode
     */
    const codes = muc_parsers_sizzle(`${type} > x[xmlns="${muc_parsers_Strophe.NS.MUC_USER}"] status`, stanza)
        .map(/** @param {Element} s */ (s) => s.getAttribute('code'))
        .filter(
            /** @param {MUCStatusCode} c */
            (c) => STATUS_CODE_STANZAS[c]?.includes(type),
        );

    if (type === 'presence' && codes.includes('333') && codes.includes('307')) {
        // See: https://github.com/xsf/xeps/pull/969/files#diff-ac5113766e59219806793c1f7d967f1bR4966
        codes.splice(codes.indexOf('307'), 1);
    }

    return {
        codes,
        is_self: codes.includes('110'),
    };
}

/**
 * @param {Element} stanza
 * @param {MUC} chatbox
 */
function getOccupantID(stanza, chatbox) {
    if (chatbox.features.get(muc_parsers_Strophe.NS.OCCUPANTID)) {
        return muc_parsers_sizzle(`occupant-id[xmlns="${muc_parsers_Strophe.NS.OCCUPANTID}"]`, stanza).pop()?.getAttribute('id');
    }
}

/**
 * Determines whether the sender of this MUC message is the current user or
 * someone else.
 * @param {MUCMessageAttributes} attrs
 * @param {MUC} chatbox
 * @returns {'me'|'them'}
 */
function getSender(attrs, chatbox) {
    let is_me;
    const own_occupant_id = chatbox.get('occupant_id');

    if (own_occupant_id) {
        is_me = attrs.occupant_id === own_occupant_id;
    } else if (attrs.from_real_jid) {
        const bare_jid = shared_converse.session.get('bare_jid');
        is_me = muc_parsers_Strophe.getBareJidFromJid(attrs.from_real_jid) === bare_jid;
    } else {
        is_me = attrs.nick === chatbox.get('nick');
    }
    return is_me ? 'me' : 'them';
}

/**
 * Parses a passed in message stanza and returns an object of attributes.
 * @param {Element} original_stanza - The message stanza
 * @param {MUC} chatbox
 * @returns {Promise<MUCMessageAttributes|StanzaParseError>}
 */
async function parseMUCMessage(original_stanza, chatbox) {
    throwErrorIfInvalidForward(original_stanza);

    const forwarded_stanza = muc_parsers_sizzle(
        `result[xmlns="${muc_parsers_NS.MAM}"] > forwarded[xmlns="${muc_parsers_NS.FORWARD}"] > message`,
        original_stanza,
    ).pop();

    const stanza = forwarded_stanza || original_stanza;
    if (muc_parsers_sizzle(`message > forwarded[xmlns="${muc_parsers_Strophe.NS.FORWARD}"]`, stanza).length) {
        return new StanzaParseError(
            stanza,
            `Invalid Stanza: Forged MAM groupchat message from ${stanza.getAttribute('from')}`,
        );
    }

    let delay;
    let body;

    if (forwarded_stanza) {
        if (muc_parsers_sizzle(`message > forwarded[xmlns="${muc_parsers_Strophe.NS.FORWARD}"]`, forwarded_stanza).length) {
            return new StanzaParseError(
                original_stanza,
                `Invalid Stanza: Forged MAM groupchat message from ${original_stanza.getAttribute('from')}`,
            );
        }
        delay = muc_parsers_sizzle(`delay[xmlns="${muc_parsers_Strophe.NS.DELAY}"]`, forwarded_stanza.parentElement).pop();
        body = forwarded_stanza.querySelector(':scope > body')?.textContent?.trim();
    } else {
        delay = muc_parsers_sizzle(`message > delay[xmlns="${muc_parsers_Strophe.NS.DELAY}"]`, original_stanza).pop();
        body = original_stanza.querySelector(':scope > body')?.textContent?.trim();
    }

    const from = stanza.getAttribute('from');
    const marker = getChatMarker(stanza);

    let attrs = /** @type {MUCMessageAttributes} */ (
        Object.assign(
            {
                from,
                body,
                'activities': getMEPActivities(stanza),
                'chat_state': getChatState(stanza),
                'from_muc': muc_parsers_Strophe.getBareJidFromJid(from),
                'is_archived': isArchived(original_stanza),
                'is_carbon': isCarbon(original_stanza),
                'is_delayed': !!delay,
                'is_forwarded': !!muc_parsers_sizzle(`message > forwarded[xmlns="${muc_parsers_Strophe.NS.FORWARD}"]`, stanza).length,
                'is_headline': isHeadline(stanza),
                'is_markable': !!muc_parsers_sizzle(`message > markable[xmlns="${muc_parsers_Strophe.NS.MARKERS}"]`, stanza).length,
                'is_marker': !!marker,
                'is_unstyled': !!muc_parsers_sizzle(`message > unstyled[xmlns="${muc_parsers_Strophe.NS.STYLING}"]`, stanza).length,
                'marker_id': marker && marker.getAttribute('id'),
                'nick': muc_parsers_Strophe.unescapeNode(muc_parsers_Strophe.getResourceFromJid(from)),
                'occupant_id': getOccupantID(stanza, chatbox),
                'receipt_id': getReceiptId(stanza),
                'received': new Date().toISOString(),
                'references': getReferences(stanza),
                'subject': stanza.querySelector(':scope > subject')?.textContent,
                'thread': stanza.querySelector(':scope > thread')?.textContent,
                'time': delay ? muc_parsers_dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString(),
                'to': stanza.getAttribute('to'),
                'type': stanza.getAttribute('type'),
            },
            getErrorAttributes(stanza),
            getOutOfBandAttributes(stanza),
            getSpoilerAttributes(stanza),
            getCorrectionAttributes(stanza, original_stanza),
            getStanzaIDs(stanza, original_stanza),
            getOpenGraphMetadata(stanza),
            getRetractionAttributes(stanza, original_stanza),
            getModerationAttributes(stanza),
            getEncryptionAttributes(stanza),
            getReplyAttributes(stanza),
            getFallbackAttributes(stanza),
            getStatusCodes(stanza, 'message'),
        )
    );

    attrs.from_real_jid =
        (attrs.is_archived && getJIDFromMUCUserData(stanza)) || chatbox.occupants.findOccupant(attrs)?.get('jid');

    attrs = Object.assign(
        {
            'is_valid_receipt_request': isValidReceiptRequest(stanza, attrs),
            'message': attrs.body || attrs.error, // TODO: Should only be used for error and info messages
            'sender': getSender(attrs, chatbox),
        },
        attrs,
    );

    if (attrs.is_archived && original_stanza.getAttribute('from') !== attrs.from_muc) {
        return new StanzaParseError(
            original_stanza,
            `Invalid Stanza: Forged MAM message from ${original_stanza.getAttribute('from')}`,
        );
    } else if (attrs.is_archived && original_stanza.getAttribute('from') !== chatbox.get('jid')) {
        return new StanzaParseError(
            original_stanza,
            `Invalid Stanza: Forged MAM groupchat message from ${stanza.getAttribute('from')}`,
        );
    } else if (attrs.is_carbon) {
        return new StanzaParseError(
            original_stanza,
            'Invalid Stanza: MUC messages SHOULD NOT be XEP-0280 carbon copied',
        );
    }

    // We prefer to use one of the XEP-0359 unique and stable stanza IDs as the Model id, to avoid duplicates.
    attrs['id'] = attrs['origin_id'] || attrs[`stanza_id ${attrs.from_muc || attrs.from}`] || muc_parsers_u.getUniqueId();

    /**
     * *Hook* which allows plugins to add additional parsing.
     * Listeners receive `(stanza, attrs, chatbox)` — the chatbox is passed as
     * an extra argument so that plugins can inspect room features (e.g.
     * anonymity mode) without having to look it up themselves.
     * @event _converse#parseMUCMessage
     */
    attrs = await shared_api.hook('parseMUCMessage', original_stanza, attrs, chatbox);

    // We call this after the hook, to allow plugins to decrypt encrypted
    // messages, since we need to parse the message text to determine whether
    // there are media urls.
    const metadata = await muc_parsers_u.getMediaURLsMetadata(attrs.is_encrypted ? attrs.plaintext : attrs.body);
    return Object.assign(attrs, metadata);
}

/**
 * Given an IQ stanza with a member list, create an array of objects containing
 * known member data (e.g. jid, nick, role, affiliation).
 *
 * @param {Element} iq
 * @returns {import('./types').MemberListItem[]}
 */
function parseMemberListIQ(iq) {
    return muc_parsers_sizzle(`query[xmlns="${muc_parsers_Strophe.NS.MUC_ADMIN}"] item`, iq).map(
        /** @param {Element} item */ (item) => {
            const data = {
                'affiliation': item.getAttribute('affiliation'),
            };
            const jid = item.getAttribute('jid');
            if (muc_parsers_u.isValidJID(jid)) {
                data['jid'] = jid;
            } else {
                // XXX: Prosody sends nick for the jid attribute value
                // Perhaps for anonymous room?
                data['nick'] = jid;
            }
            const nick = item.getAttribute('nick');
            if (nick) {
                data['nick'] = nick;
            }
            const role = item.getAttribute('role');
            if (role) {
                data['role'] = nick;
            }
            return data;
        },
    );
}

/**
 * @param {Element} stanza - The presence stanza
 * @param {string} nick
 * @returns {import('./types').MUCPresenceItemAttributes}
 */
function parsePresenceUserItem(stanza, nick) {
    /**
     * @typedef {import('./types').MUCAffiliation} MUCAffiliation
     * @typedef {import('./types').MUCRole} MUCRole
     */
    const item = muc_parsers_sizzle(`presence > x[xmlns="${muc_parsers_Strophe.NS.MUC_USER}"] item`, stanza).pop();
    if (item) {
        const actor = item.querySelector('actor');
        return {
            affiliation: /** @type {MUCAffiliation} */ (item.getAttribute('affiliation')),
            role: /** @type {MUCRole} */ (item.getAttribute('role')),
            jid: item.getAttribute('jid'),
            nick: item.getAttribute('nick') || nick,
            ...(actor
                ? {
                      actor: {
                          nick: actor?.getAttribute('nick') ?? null,
                          jid: actor?.getAttribute('jid') ?? null,
                      },
                  }
                : {}),
            reason: item.querySelector('reason')?.textContent ?? null,
        };
    }
}

/**
 * Parses a passed in MUC presence stanza and returns an object of attributes.
 * @param {Element} stanza - The presence stanza
 * @param {MUC} chatbox
 * @returns {Promise<import('./types').MUCPresenceAttributes>}
 */
async function parseMUCPresence(stanza, chatbox) {
    await chatbox.initialized;

    /**
     * @typedef {import('./types').MUCPresenceAttributes} MUCPresenceAttributes
     */
    const from = stanza.getAttribute('from');
    const type = stanza.getAttribute('type');
    const nick = muc_parsers_Strophe.getResourceFromJid(from);
    const attrs = /** @type {MUCPresenceAttributes} */ ({
        from,
        nick,
        type,
        muc_jid: muc_parsers_Strophe.getBareJidFromJid(from),
        occupant_id: getOccupantID(stanza, chatbox),
        status: stanza.querySelector(':scope > status')?.textContent ?? undefined,
        show: stanza.querySelector(':scope > show')?.textContent ?? undefined,
        image_hash: muc_parsers_sizzle(`presence > x[xmlns="${muc_parsers_Strophe.NS.VCARDUPDATE}"] photo`, stanza).pop()?.textContent,
        hats: muc_parsers_sizzle(`presence > hats[xmlns="${muc_parsers_Strophe.NS.MUC_HATS}"] hat`, stanza).map(
            /** @param {Element} h */ (h) => ({
                title: h.getAttribute('title'),
                uri: h.getAttribute('uri'),
            }),
        ),
        ...getStatusCodes(stanza, 'presence'),
        ...parsePresenceUserItem(stanza, nick),
    });

    /**
     * *Hook* which allows plugins to add additional parsing
     * @event _converse#parseMUCPresence
     */
    return /** @type {import('./types').MUCPresenceAttributes}*/ (await shared_api.hook('parseMUCPresence', stanza, attrs));
}

;// CONCATENATED MODULE: ./src/headless/plugins/muc/affiliations/utils.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @module:muc-affiliations-utils
 * @typedef {module:plugin-muc-parsers.MemberListItem} MemberListItem
 * @typedef {module:plugin-muc-affiliations-api.User} User
 * @typedef {import('@converse/skeletor').Model} Model
 * @typedef {import('../constants').AFFILIATIONS} AFFILIATIONS
 */






const { Stanza: affiliations_utils_Stanza, Strophe: affiliations_utils_Strophe, u: affiliations_utils_u, stx: affiliations_utils_stx } = api_public.env;

/**
 * Sends an IQ stanza to the server, asking it for the relevant affiliation list .
 * Returns an array of {@link MemberListItem} objects, representing occupants
 * that have the given affiliation.
 * See: https://xmpp.org/extensions/xep-0045.html#modifymember
 * @param {import('../types').NonOutcastAffiliation} affiliation
 * @param {string} muc_jid - The JID of the MUC for which the affiliation list should be fetched
 * @returns {Promise<MemberListItem[]|Error>}
 */
async function getAffiliationList(affiliation, muc_jid) {
    const iq = affiliations_utils_stx`
        <iq xmlns="jabber:client" to="${muc_jid}" type="get">
            <query xmlns="${affiliations_utils_Strophe.NS.MUC_ADMIN}">
                <item affiliation="${affiliation}"/>
            </query>
        </iq>`;

    const result = await shared_api.sendIQ(iq, null, false);
    if (result === null) {
        const err_msg = `Error: timeout while fetching ${affiliation} list for MUC ${muc_jid}`;
        const err = new Error(err_msg);
        src_log.warn(err_msg);
        return err;
    }
    if (affiliations_utils_u.isErrorStanza(result)) {
        const err_msg = `Error: not allowed to fetch ${affiliation} list for MUC ${muc_jid}`;
        const err = new Error(err_msg);
        src_log.warn(err_msg);
        src_log.warn(result);
        return err;
    }
    return parseMemberListIQ(result)
        .filter((p) => p)
        .sort((a, b) => (a.nick < b.nick ? -1 : a.nick > b.nick ? 1 : 0));
}

/**
 * Send IQ stanzas to the server to modify affiliations for users in this groupchat.
 * See: https://xmpp.org/extensions/xep-0045.html#modifymember
 * @param {String|Array<String>} muc_jid - The JID(s) of the MUCs in which the
 * @param {Array<User>} users
 * @returns {Promise}
 */
function setAffiliations(muc_jid, users) {
    const affiliations = [...new Set(users.map((u) => u.affiliation))];
    return Promise.all(affiliations.map((a) => setAffiliation(a, muc_jid, users)));
}

/**
 * Send IQ stanzas to the server to set an affiliation for
 * the provided JIDs.
 * See: https://xmpp.org/extensions/xep-0045.html#modifymember
 *
 * Prosody doesn't accept multiple JIDs' affiliations
 * being set in one IQ stanza, so as a workaround we send
 * a separate stanza for each JID.
 * Related ticket: https://issues.prosody.im/345
 *
 * @param {AFFILIATIONS[number]} affiliation - The affiliation to be set
 * @param {String|Array<String>} muc_jids - The JID(s) of the MUCs in which the
 *  affiliations need to be set.
 * @param {object} members - A map of jids, affiliations and
 *  optionally reasons. Only those entries with the
 *  same affiliation as being currently set will be considered.
 * @returns {Promise} A promise which resolves and fails depending on the XMPP server response.
 */
function setAffiliation(affiliation, muc_jids, members) {
    if (!Array.isArray(muc_jids)) {
        muc_jids = [muc_jids];
    }
    members = members.filter((m) => [undefined, affiliation].includes(m.affiliation));
    return Promise.all(
        muc_jids.reduce((acc, jid) => [...acc, ...members.map((m) => sendAffiliationIQ(affiliation, jid, m))], []),
    );
}

/**
 * Send an IQ stanza specifying an affiliation change.
 * @param {AFFILIATIONS[number]} affiliation - Affiliation (could also be stored on the member object).
 * @param {string} muc_jid - The JID of the MUC in which the affiliation should be set.
 * @param {object} member - Map containing the member's jid and optionally a reason and affiliation.
 */
function sendAffiliationIQ(affiliation, muc_jid, member) {
    affiliation = member.affiliation || affiliation;
    const iq = affiliations_utils_stx`
        <iq to="${muc_jid}" type="set" xmlns="jabber:client">
            <query xmlns="${affiliations_utils_Strophe.NS.MUC_ADMIN}">
                <item affiliation="${affiliation}"
                      ${affiliation !== 'outcast' && member.nick ? affiliations_utils_Stanza.unsafeXML(`nick="${member.nick}"`) : ''}
                      jid="${member.jid}">
                    ${member.reason ? affiliations_utils_stx`<reason>${member.reason}</reason>` : ''}
                </item>
            </query>
        </iq>`;
    return shared_api.sendIQ(iq);
}

/**
 * Given two lists of objects with 'jid', 'affiliation' and
 * 'reason' properties, return a new list containing
 * those objects that are new, changed or removed
 * (depending on the 'remove_absentees' boolean).
 *
 * The affiliations for new and changed members stay the
 * same, for removed members, the affiliation is set to 'none'.
 *
 * The 'reason' property is not taken into account when
 * comparing whether affiliations have been changed.
 * @param {boolean} exclude_existing - Indicates whether JIDs from
 *      the new list which are also in the old list
 *      (regardless of affiliation) should be excluded
 *      from the delta. One reason to do this
 *      would be when you want to add a JID only if it
 *      doesn't have *any* existing affiliation at all.
 * @param {boolean} remove_absentees - Indicates whether JIDs
 *      from the old list which are not in the new list
 *      should be considered removed and therefore be
 *      included in the delta with affiliation set
 *      to 'none'.
 * @param {array} new_list - Array containing the new affiliations
 * @param {array} old_list - Array containing the old affiliations
 * @returns {array}
 */
function computeAffiliationsDelta(exclude_existing, remove_absentees, new_list, old_list) {
    const new_jids = new_list.map((o) => o.jid);
    const old_jids = old_list.map((o) => o.jid);
    // Get the new affiliations
    let delta = new_jids.filter((jid) => !old_jids.includes(jid)).map((jid) => new_list[new_jids.indexOf(jid)]);
    if (!exclude_existing) {
        // Get the changed affiliations
        delta = delta.concat(
            new_list.filter((item) => {
                const idx = old_jids.indexOf(item.jid);
                return idx >= 0 ? item.affiliation !== old_list[idx].affiliation : false;
            }),
        );
    }
    if (remove_absentees) {
        // Get the removed affiliations
        delta = delta.concat(
            old_jids.filter((jid) => !new_jids.includes(jid)).map((jid) => ({ jid, 'affiliation': 'none' })),
        );
    }
    return delta;
}

;// CONCATENATED MODULE: ./src/headless/shared/chatbox.js








const { u: chatbox_u } = api_public.env;

/**
 * Base class for all chat boxes. Provides common methods.
 */
class ChatBoxBase extends model_with_messages_ModelWithMessages(skeletor_esm_Model) {
    initialize() {
        super.initialize();
        const jid = this.get('jid');
        if (!jid) {
            // XXX: The `validate` method will prevent this model
            // from being persisted if there's no jid, but that gets
            // called after model instantiation, so we have to deal
            // with invalid models here also.
            // This happens when the controlbox is in browser storage,
            // but we're in embedded mode.
            return;
        }
        this.set({ 'box_id': `box-${jid}` });
    }

    validate(attrs) {
        if (!attrs.jid) {
            return 'Ignored ChatBox without JID';
        }
        const room_jids = shared_api.settings.get('auto_join_rooms').map((s) => (s instanceof Object ? s.jid : s));
        const auto_join = shared_api.settings.get('auto_join_private_chats').concat(room_jids);
        if (
            shared_api.settings.get('singleton') &&
            !auto_join.includes(attrs.jid) &&
            !shared_api.settings.get('auto_join_on_invite')
        ) {
            const msg = `${attrs.jid} is not allowed because singleton is true and it's not being auto_joined`;
            src_log.warn(msg);
            return msg;
        }
    }

    /**
     * @param {boolean} force
     */
    maybeShow(force) {
        if (isUniView()) {
            const filter = (c) => !c.get('hidden') && c.get('jid') !== this.get('jid') && c.get('id') !== 'controlbox';
            const other_chats = shared_converse.state.chatboxes.filter(filter);
            if (force || other_chats.length === 0) {
                // We only have one chat visible at any one time.
                // So before opening a chat, we make sure all other chats are hidden.
                other_chats.forEach((c) => chatbox_u.safeSave(c, { hidden: true }));
                chatbox_u.safeSave(this, { hidden: false, closed: false });
                this.trigger('show');
            }
            return this;
        }
        // Overlayed view mode
        chatbox_u.safeSave(this, { hidden: false, closed: false });
        this.trigger('show');
        return this;
    }

    async shouldDestroyOnClose() {
        /**
         * *Hook* which allows plugins to determine whether a chat should be destroyed when it's closed.
         * For example, used by the converse-dragresize plugin to prevent resized chats
         * from being destroyed, thereby losing the resize dimensions.
         * @event _converse#shouldDestroyOnClose
         * @param {ChatBoxBase} chatbox
         * @param {boolean} should_destroy
         */
        return await shared_api.hook('shouldDestroyOnClose', this, true);
    }

    /**
     * @param {Object} [_ev]
     */
    async close(_ev) {
        if (await this.shouldDestroyOnClose()) {
            try {
                await new Promise((success, reject) => {
                    return this.destroy({
                        success,
                        error: (_m, e) => reject(e),
                    });
                });
            } catch (e) {
                src_log.debug(e);
            }
        } else {
            chatbox_u.safeSave(this, { closed: true });
        }

        if (shared_api.settings.get('clear_messages_on_reconnection')) {
            await this.clearMessages();
        }
        /**
         * Triggered once a chatbox has been closed.
         * @event _converse#chatBoxClosed
         * @type {ChatBoxBase}
         * @example _converse.api.listen.on('chatBoxClosed', chat => { ... });
         */
        shared_api.trigger('chatBoxClosed', this);
    }

    announceReconnection() {
        /**
         * Triggered whenever a `ChatBox` instance has reconnected after an outage
         * @event _converse#onChatReconnected
         * @type {ChatBoxBase}
         * @example _converse.api.listen.on('onChatReconnected', chat => { ... });
         */
        shared_api.trigger('chatReconnected', this);
    }

    async onReconnection() {
        if (shared_api.settings.get('clear_messages_on_reconnection')) {
            await this.clearMessages();
        }
        this.announceReconnection();
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/muc/utils.js









const { Strophe: muc_utils_Strophe, sizzle: muc_utils_sizzle, u: muc_utils_u } = api_public.env;

/**
 * @returns {Promise<string|undefined>}
 */
async function getDefaultMUCService() {
    let muc_service = shared_api.settings.get('muc_domain') || shared_converse.session.get('default_muc_service');
    if (!muc_service) {
        const domain = shared_converse.session.get('domain');
        const items = await shared_api.disco.entities.items(domain);
        for (const item of items) {
            if (await shared_api.disco.features.has(muc_utils_Strophe.NS.MUC, item.get('jid'))) {
                muc_service = item.get('jid');
                shared_converse.session.save({ default_muc_service: muc_service });
                break;
            }
        }
    }
    return muc_service;
}

/**
 * @param {import('@converse/skeletor').Model} model
 */
function isChatRoom(model) {
    return model?.get('type') === 'chatroom';
}

function shouldCreateGroupchatMessage(attrs) {
    return attrs.nick && (muc_utils_u.shouldCreateMessage(attrs) || attrs.is_tombstone);
}

/**
 * Hook handler for the `getDuplicateMessageQueries` hook.
 *
 * Adds a query object to match MEP (MUC Extended Presence) activity messages
 * by their `msgid`. MEP messages carry an `activities` array and are stored
 * with `type: 'mep'`; the standard stanza_id / origin_id queries in
 * {@link getDuplicateMessage} do not cover this case, so we contribute the
 * extra query here rather than overriding `getDuplicateMessage` in the MUC
 * model.
 *
 * @param {import('../../shared/types').ChatBoxOrMUC} _
 * @param {object[]} queries
 * @param {object} attrs
 * @returns {object[]}
 */
function getMUCDuplicateMessageQueries(_, queries, attrs) {
    if (attrs.activities?.length) {
        return [...queries, { type: 'mep', msgid: attrs.msgid }];
    }
    return queries;
}

/**
 * @param {import('./occupant').default} occupant1
 * @param {import('./occupant').default} occupant2
 */
function occupantsComparator(occupant1, occupant2) {
    const role1 = occupant1.get('role') || 'none';
    const role2 = occupant2.get('role') || 'none';
    if (MUC_ROLE_WEIGHTS[role1] === MUC_ROLE_WEIGHTS[role2]) {
        const nick1 = occupant1.getDisplayName().toLowerCase();
        const nick2 = occupant2.getDisplayName().toLowerCase();
        return nick1 < nick2 ? -1 : nick1 > nick2 ? 1 : 0;
    } else {
        return MUC_ROLE_WEIGHTS[role1] < MUC_ROLE_WEIGHTS[role2] ? -1 : 1;
    }
}

function registerDirectInvitationHandler() {
    shared_api.connection.get().addHandler(
        /** @param {Element} message */
        (message) => {
            shared_converse.exports.onDirectMUCInvitation(message);
            return true;
        },
        'jabber:x:conference',
        'message',
    );
}

function disconnectChatRooms() {
    /* When disconnecting, mark all groupchats as
     * disconnected, so that they will be properly entered again
     * when fetched from session storage.
     */
    return shared_converse.state.chatboxes.filter((m) => m.get('type') === CHATROOMS_TYPE)
        .forEach((m) => m.session.save({ 'connection_status': api_public.ROOMSTATUS.DISCONNECTED }));
}

async function onWindowStateChanged() {
    if (!isAppHidden() && shared_api.connection.connected()) {
        const rooms = await shared_api.rooms.get();
        rooms.forEach((room) => room.rejoinIfNecessary());
    }
}

/**
 * @param {Event} [event]
 */
async function routeToRoom(event) {
    // In fullscreen with URL routing on, the Chat app's own router owns the
    // `#converse/room...` space (it also accepts this legacy `?jid=` form and
    // canonicalizes it), so bow out to avoid double-opening.
    if (shared_api.settings.get('enable_url_routing') && shared_api.settings.get('view_mode') === 'fullscreen') {
        return;
    }
    const hash = getRouteHash();
    if (!hash.startsWith('#converse/room?jid=')) {
        return;
    }
    event?.preventDefault();
    const jid = hash.split('=').pop();
    if (!muc_utils_u.isValidMUCJID(jid)) {
        return src_log.warn(`invalid jid "${jid}" provided in url fragment`);
    }
    await shared_api.waitUntil('roomsAutoJoined');
    if (shared_api.settings.get('allow_bookmarks')) {
        await shared_api.waitUntil('bookmarksInitialized');
    }
    shared_api.rooms.open(jid, {}, true);
}

/**
 * Opens a groupchat, making sure that certain attributes
 * are correct, for example that the "type" is set to
 * "chatroom".
 * @param {string} jid
 * @param {Object} settings
 */
async function openChatRoom(jid, settings) {
    settings.type = CHATROOMS_TYPE;
    settings.id = jid;
    const chatbox = await shared_api.rooms.get(jid, settings, true);
    chatbox.maybeShow(true);
    return chatbox;
}

/**
 * A direct MUC invitation to join a groupchat has been received
 * See XEP-0249: Direct MUC invitations.
 * @method _converse.ChatRoom#onDirectMUCInvitation
 * @param {Element} message - The message stanza containing the invitation.
 */
async function onDirectMUCInvitation(message) {
    const x_el = muc_utils_sizzle('x[xmlns="jabber:x:conference"]', message).pop(),
        from = muc_utils_Strophe.getBareJidFromJid(message.getAttribute('from')),
        room_jid = x_el.getAttribute('jid'),
        reason = x_el.getAttribute('reason');

    let result;

    const { api } = shared_converse;
    const room = await api.rooms.get(room_jid);

    if (room) {
        result = false;
    } else if (api.settings.get('auto_join_on_invite')) {
        result = true;
    } else {
        // Invite request might come from someone not your roster list
        const contact = shared_converse.state.roster.get(from)?.getDisplayName() ?? from;

        /**
         * *Hook* which is used to gather confirmation whether a direct MUC
         * invitation should be accepted or not.
         *
         * It's meant for consumers of `@converse/headless` to subscribe to
         * this hook and then ask the user to confirm.
         *
         * @event _converse#confirmDirectMUCInvitation
         */
        result = await api.hook('confirmDirectMUCInvitation', { contact, reason, jid: room_jid }, false);
    }

    if (result) {
        const chatroom = await openChatRoom(room_jid, { password: x_el.getAttribute('password') });
        if (chatroom.session.get('connection_status') === api_public.ROOMSTATUS.DISCONNECTED) {
            shared_converse.state.chatboxes.get(room_jid).rejoin();
        }
    }
}

function getDefaultMUCNickname() {
    // XXX: if anything changes here, update the docs for the
    // locked_muc_nickname setting.
    const { profile } = shared_converse.state;
    if (!profile) {
        src_log.error('Called getDefaultMUCNickname before statusInitialized has been fired.');
        return '';
    }
    const nick = profile.getNickname();
    if (nick) {
        return nick;
    } else if (shared_api.settings.get('muc_nickname_from_jid')) {
        const bare_jid = shared_converse.session.get('bare_jid');
        return muc_utils_Strophe.unescapeNode(muc_utils_Strophe.getNodeFromJid(bare_jid));
    }
}

/**
 * Determines info message visibility based on
 * muc_show_info_messages configuration setting
 * @param {import('./types').MUCStatusCode} code
 * @memberOf _converse
 */
function isInfoVisible(code) {
    const info_messages = shared_api.settings.get('muc_show_info_messages');
    if (info_messages.includes(code)) {
        return true;
    }
    return false;
}

/**
 * Automatically join groupchats, based on the
 * "auto_join_rooms" configuration setting, which is an array
 * of strings (groupchat JIDs) or objects (with groupchat JID and other settings).
 */
async function autoJoinRooms() {
    await Promise.all(
        shared_api.settings.get('auto_join_rooms').map((muc) => {
            if (typeof muc === 'string') {
                if (shared_converse.state.chatboxes.where({ 'jid': muc }).length) {
                    return Promise.resolve();
                }
                return shared_api.rooms.open(muc);
            } else if (muc instanceof Object) {
                return shared_api.rooms.open(muc.jid, { ...muc });
            } else {
                src_log.error('Invalid muc criteria specified for "auto_join_rooms"');
                return Promise.resolve();
            }
        }),
    );
    /**
     * Triggered once any rooms that have been configured to be automatically joined,
     * specified via the _`auto_join_rooms` setting, have been entered.
     * @event _converse#roomsAutoJoined
     * @example _converse.api.listen.on('roomsAutoJoined', () => { ... });
     * @example _converse.api.waitUntil('roomsAutoJoined').then(() => { ... });
     */
    shared_api.trigger('roomsAutoJoined');
}

function onAddClientFeatures() {
    shared_api.disco.own.features.add(muc_utils_Strophe.NS.MUC);

    if (shared_api.settings.get('allow_muc_invitations')) {
        shared_api.disco.own.features.add('jabber:x:conference'); // Invites
    }
}

function onBeforeTearDown() {
    shared_converse.state.chatboxes.where({ 'type': CHATROOMS_TYPE })
        .forEach((muc) => safeSave(muc.session, { 'connection_status': api_public.ROOMSTATUS.DISCONNECTED }));
}

/**
 * @param {Element} stanza
 * @param {import('../roster/types').PresenceAttributes} attrs
 * @returns {import('../roster/types').PresenceAttributes}
 */
function onParsePresence(stanza, attrs) {
    return {
        ...attrs,
        is_muc: !!muc_utils_sizzle(`x[xmlns="${muc_utils_Strophe.NS.MUC}"]`, stanza).length,
    };
}

function onStatusInitialized() {
    addUnloadListener(() => {
        const using_websocket = shared_api.connection.isType('websocket');
        if (using_websocket && !shared_api.connection.get()?.sm?.state.id) {
            // For non-SMACKS websocket connections, or non-resumeable
            // connections, we disconnect all chatrooms when the page unloads.
            // See issue #1111
            disconnectChatRooms();
        }
    });
}

function onBeforeResourceBinding() {
    shared_api.connection.get().addHandler(
        /** @param {Element} stanza */
        (stanza) => {
            const muc_jid = muc_utils_Strophe.getBareJidFromJid(stanza.getAttribute('from'));
            if (!shared_converse.state.chatboxes.get(muc_jid)) {
                shared_api.waitUntil('chatBoxesFetched').then(async () => {
                    const muc = shared_converse.state.chatboxes.get(muc_jid);
                    if (muc) {
                        await muc.initialized;
                        muc.message_handler.run(stanza);
                    }
                });
            }
            return true;
        },
        null,
        'message',
        'groupchat',
    );
}

;// CONCATENATED MODULE: ./src/headless/plugins/muc/session.js



class MUCSession extends skeletor_esm_Model {
    defaults() {
        return {
            'connection_status': ROOMSTATUS.DISCONNECTED,
            // Whether the initial MAM history fetch that follows entering the
            // room has completed. Stays false until then so views can avoid
            // concluding (and rendering) that a room is empty while its history
            // is still being queried. Reset to false on each (re)join.
            'mam_initialized': false,
        };
    }
}

/* export default */ const muc_session = (MUCSession);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/muc.js
/**
 * @module:headless-plugins-muc-muc
 */





























const { u: muc_u, stx: muc_stx } = api_public.env;

const DISCO_INFO_TIMEOUT_ON_JOIN = 30000;

/**
 * Represents a groupchat conversation.
 */
class MUC extends model_with_vcard_ModelWithVCard(model_with_messages_ModelWithMessages(color_ColorAwareModel(ChatBoxBase))) {
    /**
     * @typedef {import('../../shared/message.js').default} BaseMessage
     * @typedef {import('./message.js').default} MUCMessage
     * @typedef {import('./occupant.js').default} MUCOccupant
     * @typedef {import('./types').NonOutcastAffiliation} NonOutcastAffiliation
     * @typedef {import('./types').MemberListItem} MemberListItem
     * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
     * @typedef {import('../../shared/types').InfoMessageAttributes} InfoMessageAttributes
     * @typedef {import('../../shared/types').ErrorMessageAttributes} ErrorMessageAttributes
     * @typedef {import('./types').MUCMessageAttributes} MUCMessageAttributes
     * @typedef {import('./types').MUCPresenceAttributes} MUCPresenceAttributes
     * @typedef {module:shared.converse.UserMessage} UserMessage
     * @typedef {import('strophe.js').Builder} Builder
     * @typedef {import('../../shared/errors').StanzaParseError} StanzaParseError
     */
    defaults() {
        /** @type {import('./types').DefaultMUCAttributes} */
        return {
            bookmarked: false,
            chat_state: undefined,
            closed: false,
            has_activity: false, // XEP-437
            hidden: isUniView() && !shared_api.settings.get('singleton'),
            hidden_occupants: !!shared_api.settings.get('hide_muc_participants'),
            message_type: 'groupchat',
            name: '',
            // For group chats, we distinguish between generally unread
            // messages and those ones that specifically mention the
            // user.
            //
            // To keep things simple, we reuse `num_unread` from
            // ChatBox to indicate unread messages which
            // mention the user and `num_unread_general` to indicate
            // generally unread messages (which *includes* mentions!).
            num_unread_general: 0,
            num_unread: 0,
            roomconfig: {},
            time_opened: this.get('time_opened') || new Date().getTime(),
            time_sent: new Date(0).toISOString(),
            type: CHATROOMS_TYPE,
        };
    }

    initialize() {
        super.initialize();
        this.initialized = this.setup();
    }

    async setup() {
        this.on('change:closed', () => {
            if (!this.get('closed')) {
                this.initialize();
            }
        });
        if (this.get('closed')) return;

        this.debouncedRejoin = lodash_es_debounce(this.rejoin, 250);

        this.initOccupants();
        this.initDiscoModels(); // sendChatState depends on this.features
        this.registerHandlers();

        this.on('change:chat_state', this.sendChatState, this);
        this.on('change:hidden', this.onHiddenChange, this);
        this.on('destroy', this.removeHandlers, this);

        await this.restoreSession();
        this.session.on('change:connection_status', this.onConnectionStatusChanged, this);

        this.listenTo(this.occupants, 'add', this.onOccupantAdded);
        this.listenTo(this.occupants, 'remove', this.onOccupantRemoved);
        this.listenTo(this.occupants, 'change:presence', this.onOccupantPresenceChanged);
        this.listenTo(this.occupants, 'change:affiliation', this.createAffiliationChangeMessage);
        this.listenTo(this.occupants, 'change:role', this.createRoleChangeMessage);

        const restored = await this.restoreFromCache();
        if (!restored) {
            await this.join();
        }

        /**
         * Triggered once a {@link MUC} has been created and initialized.
         * @event _converse#chatRoomInitialized
         * @type { MUC }
         * @example _converse.api.listen.on('chatRoomInitialized', model => { ... });
         */
        await shared_api.trigger('chatRoomInitialized', this, { synchronous: true });
    }

    isEntered() {
        return this.session?.get('connection_status') === ROOMSTATUS.ENTERED;
    }

    /**
     * Checks whether this MUC qualifies for subscribing to XEP-0437 Room Activity Indicators (RAI)
     * @returns {Boolean}
     */
    isRAICandidate() {
        return this.get('hidden') && shared_api.settings.get('muc_subscribe_to_rai') && this.getOwnAffiliation() !== 'none';
    }

    /**
     * Checks whether we're still joined and if so, restores the MUC state from cache.
     * @returns {Promise<boolean>} Returns `true` if we're still joined, otherwise returns `false`.
     */
    async restoreFromCache() {
        if (this.isEntered()) {
            await this.fetchOccupants().catch(/** @param {Error} e */ (e) => src_log.error(e));

            if (this.isRAICandidate()) {
                this.session.save('connection_status', ROOMSTATUS.DISCONNECTED);
                this.enableRAI();
                return true;
            } else if (await this.isJoined()) {
                await new Promise((r) => this.config.fetch({ 'success': r, 'error': r }));
                await new Promise((r) => this.features.fetch({ 'success': r, 'error': r }));
                await this.fetchMessages().catch(/** @param {Error} e */ (e) => src_log.error(e));
                return true;
            }
        }
        this.session.save('connection_status', ROOMSTATUS.DISCONNECTED);
        this.clearOccupantsCache();
        return false;
    }

    /**
     * Join the MUC
     * @param {String} [nick] - The user's nickname
     * @param {String} [password] - Optional password, if required by the groupchat.
     *  Will fall back to the `password` value stored in the room
     *  model (if available).
     *  @returns {Promise<void>}
     */
    async join(nick, password) {
        if (this.isEntered()) {
            // We have restored a groupchat from session storage,
            // so we don't send out a presence stanza again.
            src_log.info(`MUC ${this.get('jid')} join() early return: isEntered=true`);
            return;
        }
        src_log.info(`MUC ${this.get('jid')} join() called, setting status to CONNECTING`);
        // Set this early, so we don't rejoin in onHiddenChange.
        // Reset `mam_initialized` too: we're entering afresh, so the post-entry
        // history fetch hasn't happened yet (see MUCSession defaults).
        this.session.save({ connection_status: ROOMSTATUS.CONNECTING, mam_initialized: false });

        const result = await this.refreshDiscoInfo({ timeout: DISCO_INFO_TIMEOUT_ON_JOIN });
        const is_new = result instanceof ItemNotFoundError;
        src_log.info(`MUC ${this.get('jid')} refreshDiscoInfo complete, is_new: ${is_new}`);

        nick = await this.getAndPersistNickname(nick);
        if (!nick) {
            safeSave(this.session, { 'connection_status': ROOMSTATUS.NICKNAME_REQUIRED });
            if (!is_new && shared_api.settings.get('muc_show_logs_before_join')) {
                await this.fetchMessages();
            }
            return;
        }
        src_log.info(`MUC ${this.get('jid')} sending join presence`);
        shared_api.send(await this.constructJoinPresence(password, is_new));
        if (is_new) await this.refreshDiscoInfo();
    }

    /**
     * Clear stale cache and re-join a MUC we've been in before.
     */
    rejoin() {
        src_log.info(`MUC ${this.get('jid')} rejoin() called, current status: ${this.session.get('connection_status')}`);
        this.session.save('connection_status', ROOMSTATUS.DISCONNECTED);
        this.registerHandlers();
        this.clearOccupantsCache();
        return this.join();
    }

    /**
     * @param {string} password
     * @param {boolean} is_new
     */
    async constructJoinPresence(password, is_new) {
        const exclude_maxstanzas = is_new || this.features.get('mam_enabled');
        const maxstanzas = exclude_maxstanzas ? 0 : shared_api.settings.get('muc_history_max_stanzas');
        password = password || this.get('password');

        const { profile } = shared_converse.state;
        const show = profile.get('show');
        const status_message = profile.get('status_message');
        const stanza = muc_stx`
            <presence xmlns="jabber:client"
                      id="${getUniqueId()}"
                      from="${shared_api.connection.get().jid}"
                      to="${this.getRoomJIDAndNick()}">
                <x xmlns="${Strophe.NS.MUC}">
                    <history maxstanzas="${maxstanzas || 0}"/>
                    ${password ? muc_stx`<password>${password}</password>` : ''}
                </x>
                ${PRES_SHOW_VALUES.includes(show) ? muc_stx`<show>${show}</show>` : ''}
                ${status_message ? muc_stx`<status>${status_message}</status>` : ''}
            </presence>`;
        /**
         * *Hook* which allows plugins to update an outgoing MUC join presence stanza
         * @event _converse#constructedMUCPresence
         * @type {Element} The stanza which will be sent out
         */
        return await shared_api.hook('constructedMUCPresence', this, stanza);
    }

    clearOccupantsCache() {
        if (this.occupants.length) {
            // Remove non-members when reconnecting
            this.occupants.filter((o) => !o.isMember()).forEach((o) => o.destroy());
        } else {
            // Looks like we haven't restored occupants from cache, so we clear it.
            this.occupants.clearStore();
        }
    }

    /**
     * Given the passed in MUC message, send a XEP-0333 chat marker.
     * @async
     * @param {BaseMessage} msg
     * @param {('received'|'displayed'|'acknowledged')} [type='displayed']
     * @param {boolean} [force=false] - Whether a marker should be sent for the
     *  message, even if it didn't include a `markable` element.
     */
    sendMarkerForMessage(msg, type = 'displayed', force = false) {
        if (!msg || !shared_api.settings.get('send_chat_markers').includes(type) || msg?.get('type') !== 'groupchat') {
            return;
        }
        if (msg?.get('is_markable') || force) {
            const key = `stanza_id ${this.get('jid')}`;
            const id = msg.get(key);
            if (!id) {
                src_log.error(`Can't send marker for message without stanza ID: ${key}`);
                return Promise.resolve();
            }
            const from_jid = Strophe.getBareJidFromJid(msg.get('from'));
            sendMarker(from_jid, id, type, msg.get('type'));
        }
        return Promise.resolve();
    }

    /**
     * Finds the last eligible message and then sends a XEP-0333 chat marker for it.
     * @param { ('received'|'displayed'|'acknowledged') } [type='displayed']
     * @param {Boolean} force - Whether a marker should be sent for the
     *  message, even if it didn't include a `markable` element.
     */
    sendMarkerForLastMessage(type = 'displayed', force = false) {
        const msgs = Array.from(this.messages.models);
        msgs.reverse();
        const msg = msgs.find((m) => m.get('sender') === 'them' && (force || m.get('is_markable')));
        msg && this.sendMarkerForMessage(msg, type, force);
    }

    /**
     * Ensures that the user is subscribed to XEP-0437 Room Activity Indicators
     * if `muc_subscribe_to_rai` is set to `true`.
     * Only affiliated users can subscribe to RAI, but this method doesn't
     * check whether the current user is affiliated because it's intended to be
     * called after the MUC has been left and we don't have that information anymore.
     */
    enableRAI() {
        if (shared_api.settings.get('muc_subscribe_to_rai')) {
            const muc_domain = Strophe.getDomainFromJid(this.get('jid'));
            shared_api.user.presence.send({ to: muc_domain }, muc_stx`<rai xmlns="${Strophe.NS.RAI}"></rai>`);
        }
    }

    /**
     * Handler that gets called when the 'hidden' flag is toggled.
     */
    async onHiddenChange() {
        const roomstatus = ROOMSTATUS;
        const conn_status = this.session.get('connection_status');
        if (this.get('hidden')) {
            if (conn_status === roomstatus.ENTERED) {
                this.setChatState(INACTIVE);

                if (this.isRAICandidate()) {
                    this.sendMarkerForLastMessage('received', true);
                    await this.leave();
                    this.enableRAI();
                }
            }
        } else {
            await this.initialized;
            if (conn_status === roomstatus.DISCONNECTED) this.rejoin();
            this.clearUnreadMsgCounter();
        }
    }

    /**
     * @param {MUCOccupant} occupant
     */
    onOccupantAdded(occupant) {
        if (
            isInfoVisible(api_public.MUC_TRAFFIC_STATES.ENTERED) &&
            this.session.get('connection_status') === ROOMSTATUS.ENTERED &&
            occupant.get('presence') === 'online'
        ) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_TRAFFIC_STATES.ENTERED);
        }
    }

    /**
     * @param {MUCOccupant} occupant
     */
    onOccupantRemoved(occupant) {
        if (
            isInfoVisible(api_public.MUC_TRAFFIC_STATES.EXITED) &&
            this.isEntered() &&
            occupant.get('presence') === 'online'
        ) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_TRAFFIC_STATES.EXITED);
        }
    }

    /**
     * @param {MUCOccupant} occupant
     */
    onOccupantPresenceChanged(occupant) {
        if (occupant.get('states').includes('303')) {
            return;
        }
        if (occupant.get('presence') === 'offline' && isInfoVisible(api_public.MUC_TRAFFIC_STATES.EXITED)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_TRAFFIC_STATES.EXITED);
        } else if (occupant.get('presence') === 'online' && isInfoVisible(api_public.MUC_TRAFFIC_STATES.ENTERED)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_TRAFFIC_STATES.ENTERED);
        }
    }

    async onRoomEntered() {
        await this.occupants.fetchMembers();
        if (shared_api.settings.get('clear_messages_on_reconnection')) {
            await this.clearMessages();
        } else {
            await this.fetchMessages();
        }
        /**
         * Triggered when the user has entered a new MUC
         * @event _converse#enteredNewRoom
         * @type {MUC}
         * @example _converse.api.listen.on('enteredNewRoom', model => { ... });
         */
        shared_api.trigger('enteredNewRoom', this);
        if (
            shared_api.settings.get('auto_register_muc_nickname') &&
            (await shared_api.disco.supports(Strophe.NS.MUC_REGISTER, this.get('jid')))
        ) {
            this.registerNickname();
        }
    }

    async onConnectionStatusChanged() {
        if (this.isEntered()) {
            if (this.isRAICandidate()) {
                try {
                    await this.leave();
                } catch (e) {
                    src_log.error(e);
                }
                this.enableRAI();
            } else {
                await this.onRoomEntered();
            }
        }
    }

    async onReconnection() {
        src_log.info(`MUC ${this.get('jid')} onReconnection called, status: ${this.session.get('connection_status')}`);
        await this.rejoin();
        this.announceReconnection();
    }

    getMessagesCollection() {
        return new shared_converse.exports.MUCMessages();
    }

    restoreSession() {
        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `muc.session-${bare_jid}-${this.get('jid')}`;
        this.session = new muc_session({ id });
        initStorage(this.session, id, 'session');
        return new Promise((r) => this.session.fetch({ 'success': r, 'error': r }));
    }

    initDiscoModels() {
        const bare_jid = shared_converse.session.get('bare_jid');
        let id = `converse.muc-features-${bare_jid}-${this.get('jid')}`;
        this.features = new skeletor_esm_Model(
            Object.assign(
                { id },
                api_public.ROOM_FEATURES.reduce((acc, feature) => {
                    acc[feature] = false;
                    return acc;
                }, {}),
            ),
        );
        this.features.storage = createStore(id, 'session');
        this.features.listenTo(shared_converse, 'beforeLogout', () => this.features.storage.flush());

        id = `converse.muc-config-${bare_jid}-${this.get('jid')}`;
        this.config = new skeletor_esm_Model(/** @type {import('./types').MUCConfigAttributes} */ ({ id }));
        this.config.storage = createStore(id, 'session');
        this.config.listenTo(shared_converse, 'beforeLogout', () => this.config.storage.flush());
    }

    initOccupants() {
        this.occupants = new shared_converse.exports.MUCOccupants();
        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `converse.occupants-${bare_jid}${this.get('jid')}`;
        this.occupants.storage = createStore(id, 'session');
        this.occupants.chatroom = this;
        this.occupants.listenTo(shared_converse, 'beforeLogout', () => this.occupants.storage.flush());
    }

    fetchOccupants() {
        this.occupants.fetched = new Promise((resolve) => {
            this.occupants.fetch({
                'add': true,
                'silent': true,
                'success': resolve,
                'error': resolve,
            });
        });
        return this.occupants.fetched;
    }

    /**
     * If a user's affiliation has been changed, a <presence> stanza is sent
     * out, but if the user is not in a room, a <message> stanza MAY be sent
     * out. This handler handles such message stanzas. See "Example 176" in
     * XEP-0045.
     * @param {Element} stanza
     * @returns {void}
     */
    handleAffiliationChangedMessage(stanza) {
        if (stanza.querySelector('body')) {
            // If there's a body, we don't treat it as an affiliation change message.
            return;
        }

        const item = sizzle(`x[xmlns="${Strophe.NS.MUC_USER}"] item`, stanza).pop();
        if (item) {
            const from = stanza.getAttribute('from');
            const jid = item.getAttribute('jid');
            const data = {
                from,
                states: [],
                jid: Strophe.getBareJidFromJid(jid),
                resource: Strophe.getResourceFromJid(jid),
            };

            const affiliation = item.getAttribute('affiliation');
            if (affiliation) {
                data.affiliation = affiliation;
            }

            const role = item.getAttribute('role');
            if (role) {
                data.role = role;
            }

            const occupant = this.occupants.findOccupant({ jid: data.jid });
            if (occupant) {
                occupant.save(data);
            } else {
                this.occupants.create(data);
            }
        }
    }

    /**
     * @param {Element} stanza
     */
    async handleErrorMessageStanza(stanza) {
        const { __ } = shared_converse;

        const attrs_or_error = await parseMUCMessage(stanza, this);
        if (muc_u.isErrorObject(attrs_or_error)) {
            const { stanza, message } = /** @type {StanzaParseError} */ (attrs_or_error);
            if (stanza) src_log.error(stanza);
            return src_log.error(message);
        }

        const attrs = /** @type {MessageAttributes} */ (attrs_or_error);

        if (!(await this.shouldShowErrorMessage(attrs))) {
            return;
        }

        const nick = Strophe.getResourceFromJid(attrs.from);
        const occupant = nick ? this.getOccupant(nick) : null;

        const model = occupant ? occupant : this;

        const message = model.getMessageReferencedByError(attrs);
        if (message) {
            const new_attrs = {
                error: attrs.error,
                error_condition: attrs.error_condition,
                error_text: attrs.error_text,
                error_type: attrs.error_type,
                editable: false,
            };
            if (attrs.msgid === message.get('retraction_id')) {
                // The error message refers to a retraction
                new_attrs.retracted = undefined;
                new_attrs.retraction_id = undefined;
                new_attrs.retracted_id = undefined;

                if (!attrs.error) {
                    if (attrs.error_condition === 'forbidden') {
                        new_attrs.error = __("You're not allowed to retract your message.");
                    } else if (attrs.error_condition === 'not-acceptable') {
                        new_attrs.error = __(
                            "Your retraction was not delivered because you're not present in the groupchat.",
                        );
                    } else {
                        new_attrs.error = __('Sorry, an error occurred while trying to retract your message.');
                    }
                }
            } else if (!attrs.error) {
                if (attrs.error_condition === 'forbidden') {
                    new_attrs.error = __("Your message was not delivered because you weren't allowed to send it.");
                } else if (attrs.error_condition === 'not-acceptable') {
                    new_attrs.error = __("Your message was not delivered because you're not present in the groupchat.");
                } else {
                    new_attrs.error = __('Sorry, an error occurred while trying to send your message.');
                }
            }
            message.save(new_attrs);
        } else {
            model.createMessage(attrs);
        }
    }

    /**
     * Handles incoming message stanzas from the service that hosts this MUC
     * @param {Element} stanza
     */
    handleMessageFromMUCHost(stanza) {
        if (this.isEntered()) {
            // We're not interested in activity indicators when already joined to the room
            return;
        }
        const rai = sizzle(`rai[xmlns="${Strophe.NS.RAI}"]`, stanza).pop();
        const active_mucs = Array.from(rai?.querySelectorAll('activity') || []).map((m) => m.textContent);
        if (active_mucs.includes(this.get('jid'))) {
            this.save({
                'has_activity': true,
                'num_unread_general': 0, // Either/or between activity and unreads
            });
        }
    }

    /**
     * Handles XEP-0452 MUC Mention Notification messages
     * @param {Element} stanza
     */
    handleForwardedMentions(stanza) {
        if (this.isEntered()) {
            // Avoid counting mentions twice
            return;
        }
        const msgs = sizzle(
            `mentions[xmlns="${Strophe.NS.MENTIONS}"] forwarded[xmlns="${Strophe.NS.FORWARD}"] message[type="groupchat"]`,
            stanza,
        );
        const muc_jid = this.get('jid');
        const mentions = msgs.filter((m) => Strophe.getBareJidFromJid(m.getAttribute('from')) === muc_jid);
        if (mentions.length) {
            this.save({
                'has_activity': true,
                'num_unread': this.get('num_unread') + mentions.length,
            });
            mentions.forEach(
                /** @param {Element} stanza */ async (stanza) => {
                    const attrs = await parseMUCMessage(stanza, this);
                    const data = { stanza, attrs, 'chatbox': this };
                    shared_api.trigger('message', data);
                },
            );
        }
    }

    /**
     * Parses an incoming message stanza and queues it for processing.
     * @param {Builder|Element} stanza
     */
    async handleMessageStanza(stanza) {
        stanza = /** @type {Builder} */ (stanza).tree?.() ?? /** @type {Element} */ (stanza);

        const type = stanza.getAttribute('type');
        if (type === 'error') {
            return this.handleErrorMessageStanza(stanza);
        }
        if (type === 'groupchat') {
            if (isArchived(stanza)) {
                // MAM messages are handled in converse-mam.
                // We shouldn't get MAM messages here because
                // they shouldn't have a `type` attribute.
                return src_log.warn(`Received a MAM message with type "groupchat"`);
            }
        } else if (!type) {
            return this.handleForwardedMentions(stanza);
        }

        let attrs_or_error;
        try {
            attrs_or_error = await parseMUCMessage(stanza, this);
        } catch (e) {
            return src_log.error(e);
        }

        if (muc_u.isErrorObject(attrs_or_error)) {
            const { stanza, message } = /** @type {StanzaParseError} */ (attrs_or_error);
            if (stanza) src_log.error(stanza);
            return src_log.error(message);
        }

        const attrs = /** @type {MUCMessageAttributes} */ (attrs_or_error);
        if (attrs.type === 'groupchat') {
            attrs.codes.forEach((code) => this.createInfoMessage(code));
            this.fetchFeaturesIfConfigurationChanged(attrs);
        }

        const data = /** @type {import('./types').MUCMessageEventData} */ ({
            stanza,
            attrs,
            chatbox: this,
        });
        /**
         * Triggered when a groupchat message stanza has been received and parsed.
         * @event _converse#message
         * @type {object}
         * @property {import('./types').MUCMessageEventData} data
         */
        shared_api.trigger('message', data);
        return attrs && this.queueMessage(attrs);
    }

    /**
     * Register presence and message handlers relevant to this groupchat
     */
    registerHandlers() {
        const muc_jid = this.get('jid');
        const muc_domain = Strophe.getDomainFromJid(muc_jid);
        this.removeHandlers();
        const connection = shared_api.connection.get();
        this.presence_handler = connection.addHandler(
            /** @param {Element} stanza */ (stanza) => {
                this.onPresence(stanza);
                return true;
            },
            null,
            'presence',
            null,
            null,
            muc_jid,
            { 'ignoreNamespaceFragment': true, 'matchBareFromJid': true },
        );

        this.domain_presence_handler = connection.addHandler(
            /** @param {Element} stanza */ (stanza) => {
                this.onPresenceFromMUCHost(stanza);
                return true;
            },
            null,
            'presence',
            null,
            null,
            muc_domain,
        );

        this.message_handler = connection.addHandler(
            /** @param {Element} stanza */ (stanza) => {
                this.handleMessageStanza(stanza);
                return true;
            },
            null,
            'message',
            null,
            null,
            muc_jid,
            { 'matchBareFromJid': true },
        );

        this.domain_message_handler = connection.addHandler(
            /** @param {Element} stanza */ (stanza) => {
                this.handleMessageFromMUCHost(stanza);
                return true;
            },
            null,
            'message',
            null,
            null,
            muc_domain,
        );

        this.affiliation_message_handler = connection.addHandler(
            /** @param {Element} stanza */
            (stanza) => {
                this.handleAffiliationChangedMessage(stanza);
                return true;
            },
            Strophe.NS.MUC_USER,
            'message',
            null,
            null,
            muc_jid,
        );
    }

    removeHandlers() {
        const connection = shared_api.connection.get();
        // Remove the presence and message handlers that were
        // registered for this groupchat.
        if (this.message_handler) {
            connection?.deleteHandler(this.message_handler);
            delete this.message_handler;
        }
        if (this.domain_message_handler) {
            connection?.deleteHandler(this.domain_message_handler);
            delete this.domain_message_handler;
        }
        if (this.presence_handler) {
            connection?.deleteHandler(this.presence_handler);
            delete this.presence_handler;
        }
        if (this.domain_presence_handler) {
            connection?.deleteHandler(this.domain_presence_handler);
            delete this.domain_presence_handler;
        }
        if (this.affiliation_message_handler) {
            connection?.deleteHandler(this.affiliation_message_handler);
            delete this.affiliation_message_handler;
        }
        return this;
    }

    invitesAllowed() {
        return (
            shared_api.settings.get('allow_muc_invitations') &&
            (this.features.get('open') || this.getOwnAffiliation() === 'owner')
        );
    }

    getDisplayName() {
        const name = this.get('name');
        if (name) {
            return name.trim();
        } else if (shared_api.settings.get('locked_muc_domain') === 'hidden') {
            return Strophe.getNodeFromJid(this.get('jid'));
        } else {
            return this.get('jid');
        }
    }

    /**
     * Sends a message stanza to the XMPP server and expects a reflection
     * or error message within a specific timeout period.
     * @param {Builder|Element } message
     * @returns { Promise<Element>|Promise<TimeoutError> } Returns a promise
     *  which resolves with the reflected message stanza or with an error stanza or
     *  {@link TimeoutError}.
     */
    sendTimedMessage(message) {
        const el = message instanceof Element ? message : message.tree();
        let id = el.getAttribute('id');
        if (!id) {
            // inject id if not found
            id = getUniqueId('sendIQ');
            el.setAttribute('id', id);
        }
        const promise = openpromise_getOpenPromise();
        const timeout = shared_api.settings.get('stanza_timeout');
        const connection = shared_api.connection.get();
        const timeoutHandler = connection.addTimedHandler(timeout, () => {
            connection.deleteHandler(handler);
            const err = new TimeoutError('Timeout Error: No response from server');
            promise.resolve(err);
            return false;
        });
        const handler = connection.addHandler(
            /** @param {Element} stanza */
            (stanza) => {
                timeoutHandler && connection.deleteTimedHandler(timeoutHandler);
                promise.resolve(stanza);
            },
            null,
            'message',
            ['error', 'groupchat'],
            id,
        );
        shared_api.send(el);
        return promise;
    }

    /**
     * Retract one of your messages in this groupchat
     * @param {BaseMessage} message - The message which we're retracting.
     */
    async retractOwnMessage(message) {
        const __ = shared_converse.__;
        const editable = message.get('editable');
        const retraction_id = getUniqueId();
        const id = message.get('id');

        const stanza = muc_stx`
            <message id="${retraction_id}"
                     to="${this.get('jid')}"
                     type="groupchat"
                     xmlns="jabber:client">
                <retract id="${id}" xmlns="${Strophe.NS.RETRACT}"/>
                <body>/me retracted a message</body>
                <store xmlns="${Strophe.NS.HINTS}"/>
                <fallback xmlns="${Strophe.NS.FALLBACK}" for="${Strophe.NS.RETRACT}" />
            </message>`;

        // Optimistic save
        message.set({
            retracted: new Date().toISOString(),
            retracted_id: id,
            retraction_id: retraction_id,
            editable: false,
        });
        const result = await this.sendTimedMessage(stanza);

        if (muc_u.isErrorStanza(result)) {
            src_log.error(result);
        } else if (result instanceof TimeoutError) {
            src_log.error(result);
            message.save({
                editable,
                error_type: 'timeout',
                error: __('A timeout happened while trying to retract your message.'),
                retracted: undefined,
                retracted_id: undefined,
                retraction_id: undefined,
            });
        }
    }

    /**
     * Retract someone else's message in this groupchat.
     * @param {MUCMessage} message - The message which we're retracting.
     * @param {string} [reason] - The reason for retracting the message.
     * @example
     *  const room = await api.rooms.get(jid);
     *  const message = room.messages.findWhere({'body': 'Get rich quick!'});
     *  room.retractOtherMessage(message, 'spam');
     */
    async retractOtherMessage(message, reason) {
        const editable = message.get('editable');
        const bare_jid = shared_converse.session.get('bare_jid');
        // Optimistic save
        message.save({
            moderated: 'retracted',
            moderated_by: bare_jid,
            moderated_id: message.get('msgid'),
            moderation_reason: reason,
            editable: false,
        });
        const result = await this.sendRetractionIQ(message, reason);
        if (result === null || muc_u.isErrorStanza(result)) {
            // Undo the save if something went wrong
            message.save({
                editable,
                moderated: undefined,
                moderated_by: undefined,
                moderated_id: undefined,
                moderation_reason: undefined,
            });
        }
        return result;
    }

    /**
     * Sends an IQ stanza to the XMPP server to retract a message in this groupchat.
     * @param {MUCMessage} message - The message which we're retracting.
     * @param {string} [reason] - The reason for retracting the message.
     */
    sendRetractionIQ(message, reason) {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <moderate id="${message.get(`stanza_id ${this.get('jid')}`)}" xmlns="${Strophe.NS.MODERATE}">
                    <retract xmlns="${Strophe.NS.RETRACT}"/>
                    ${reason ? muc_stx`<reason>${reason}</reason>` : ''}
                </moderate>
            </iq>`;
        return shared_api.sendIQ(iq, null, false);
    }

    /**
     * Sends an IQ stanza to the XMPP server to destroy this groupchat. Not
     * to be confused with the {@link MUC#destroy}
     * method, which simply removes the room from the local browser storage cache.
     * @param {string} [reason] - The reason for destroying the groupchat.
     * @param {string} [new_jid] - The JID of the new groupchat which replaces this one.
     */
    sendDestroyIQ(reason, new_jid) {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_OWNER}">
                    <destroy ${new_jid ? Stanza.unsafeXML(`jid="${Strophe.xmlescape(new_jid)}"`) : ''}>
                        ${reason ? muc_stx`<reason>${reason}</reason>` : ''}
                    </destroy>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq);
    }

    /**
     * Leave the groupchat by sending an unavailable presence stanza, and then
     * tear down the features and disco collections so that they'll be
     * recreated if/when we rejoin.
     * @param {string} [exit_msg] - Message to indicate your reason for leaving
     */
    async leave(exit_msg) {
        shared_api.user.presence.send({
            type: 'unavailable',
            to: this.getRoomJIDAndNick(),
            status: exit_msg,
        });

        safeSave(this.session, { connection_status: ROOMSTATUS.DISCONNECTED });

        // Delete the features model
        if (this.features) {
            await new Promise((resolve) =>
                this.features.destroy({
                    success: resolve,
                    error: (_, e) => {
                        src_log.error(e);
                        resolve();
                    },
                }),
            );
        }
        // Delete disco entity
        const disco_entity = shared_converse.state.disco_entities?.get(this.get('jid'));
        if (disco_entity) {
            await new Promise((resolve) =>
                disco_entity.destroy({
                    success: resolve,
                    error: (_, e) => {
                        src_log.error(e);
                        resolve();
                    },
                }),
            );
        }
    }

    /**
     * @typedef {Object} CloseEvent
     * @property {string} name
     * @param {CloseEvent} [ev]
     */
    async close(ev) {
        const { ENTERED, CLOSING } = ROOMSTATUS;
        const was_entered = this.session.get('connection_status') === ENTERED;

        safeSave(this.session, { connection_status: CLOSING });
        was_entered && this.sendMarkerForLastMessage('received', true);
        await this.leave();

        this.occupants.clearStore();

        const is_closed_by_user = ev?.name !== 'closeAllChatBoxes';
        if (is_closed_by_user) {
            await this.unregisterNickname();
            if (shared_api.settings.get('muc_clear_messages_on_leave')) {
                this.clearMessages();
            }
            /**
             * Triggered when the user leaves a MUC
             * @event _converse#leaveRoom
             * @type {MUC}
             * @example _converse.api.listen.on('leaveRoom', model => { ... });
             */
            shared_api.trigger('leaveRoom', this);
        }

        // Delete the session model
        await new Promise((success) =>
            this.session.destroy({
                success,
                error: (_, e) => {
                    src_log.error(e);
                    success();
                },
            }),
        );
        return super.close();
    }

    canModerateMessages() {
        const self = this.getOwnOccupant();
        return self && self.isModerator() && shared_api.disco.supports(Strophe.NS.MODERATE, this.get('jid'));
    }

    canPostMessages() {
        return this.isEntered() && !(this.features.get('moderated') && this.getOwnRole() === 'visitor');
    }

    /**
     * @param {import('../../shared/message').default} message
     */
    isChatMessage(message) {
        return message.get('type') === this.get('message_type');
    }

    /**
     * Return an array of unique nicknames based on all occupants and messages in this MUC.
     * @returns {String[]}
     */
    getAllKnownNicknames() {
        return [
            ...new Set([...this.occupants.map((o) => o.get('nick')), ...this.messages.map((m) => m.get('nick'))]),
        ].filter((n) => n);
    }

    getAllKnownNicknamesRegex() {
        const longNickString = this.getAllKnownNicknames()
            .map((n) => parse_helpers.escapeRegexString(n))
            .join('|');
        return RegExp(`(?:\\p{P}|\\p{Z}|^)@(${longNickString})(?![\\w@-])`, 'uig');
    }

    /**
     * @param {string} jid
     */
    getOccupantByJID(jid) {
        return this.occupants.findOccupant({ jid });
    }

    /**
     * @param {string} nick
     */
    getOccupantByNickname(nick) {
        return this.occupants.findOccupant({ nick });
    }

    /**
     * @param {string} nick
     */
    getReferenceURIFromNickname(nick) {
        const muc_jid = this.get('jid');
        const occupant = this.getOccupant(nick);
        const uri = (this.features.get('nonanonymous') && occupant?.get('jid')) || `${muc_jid}/${nick}`;
        return encodeURI(`xmpp:${uri}`);
    }

    /**
     * Given a text message, look for `@` mentions and turn them into
     * XEP-0372 references
     * @param { String } text
     */
    parseTextForReferences(text) {
        const mentions_regex = /(\p{P}|\p{Z}|^)([@][\w_-]+(?:\.\w+)*)/giu;
        if (!text || !mentions_regex.test(text)) {
            return [text, []];
        }

        const getMatchingNickname = parse_helpers.findFirstMatchInArray(this.getAllKnownNicknames());

        const matchToReference = (match) => {
            let at_sign_index = match[0].indexOf('@');
            if (match[0][at_sign_index + 1] === '@') {
                // edge-case
                at_sign_index += 1;
            }
            const begin = match.index + at_sign_index;
            const end = begin + match[0].length - at_sign_index;
            const value = getMatchingNickname(match[1]);
            const type = 'mention';
            const uri = this.getReferenceURIFromNickname(value);
            return { begin, end, value, type, uri };
        };

        const regex = this.getAllKnownNicknamesRegex();
        const mentions = [...text.matchAll(regex)].filter((m) => !m[0].startsWith('/'));
        const references = mentions.map(matchToReference);

        const [updated_message, updated_references] = parse_helpers.reduceTextFromReferences(text, references);
        return [updated_message, updated_references];
    }

    /**
     * @param {MessageAttributes} [attrs] - A map of attributes to be saved on the message
     */
    async getOutgoingMessageAttributes(attrs) {
        const is_spoiler = this.get('composing_spoiler');
        let text = '',
            references;
        if (attrs?.body) {
            [text, references] = this.parseTextForReferences(attrs.body);
        }
        const origin_id = getUniqueId();
        const body = text ? muc_u.emojis.shortnamesToUnicode(text) : undefined;

        // Get reply attributes from chatbox model if replying to a message
        const reply_to_id = this.get('reply_to_id');
        const reply_to = this.get('reply_to');

        attrs = Object.assign(
            {},
            attrs,
            {
                body,
                is_spoiler,
                origin_id,
                references,
                reply_to_id,
                reply_to,
                id: origin_id,
                msgid: origin_id,
                from: `${this.get('jid')}/${this.get('nick')}`,
                fullname: this.get('nick'),
                message: body,
                nick: this.get('nick'),
                sender: 'me',
                type: 'groupchat',
                original_text: text,
            },
            await muc_u.getMediaURLsMetadata(text),
        );

        // Add XEP-0461 reply fallback before the hook
        attrs = this.addReplyFallback(attrs);

        // Clear reply state after capturing it
        if (reply_to_id) {
            this.save({ reply_to_id: undefined, reply_to: undefined });
        }

        /**
         * *Hook* which allows plugins to update the attributes of an outgoing
         * message.
         * @event _converse#getOutgoingMessageAttributes
         */
        attrs = await shared_api.hook('getOutgoingMessageAttributes', this, attrs);
        return attrs;
    }

    /**
     * Utility method to construct the JID for the current user as occupant of the groupchat.
     * @returns {string} - The groupchat JID with the user's nickname added at the end.
     * @example groupchat@conference.example.org/nickname
     */
    getRoomJIDAndNick() {
        const nick = this.get('nick');
        const jid = Strophe.getBareJidFromJid(this.get('jid'));
        return jid + (nick !== null ? `/${nick}` : '');
    }

    /**
     * Sends a message with the current XEP-0085 chat state of the user
     * as taken from the `chat_state` attribute of the {@link MUC}.
     */
    sendChatState() {
        if (
            this.get('omemo_active') ||
            !shared_api.settings.get('send_chat_state_notifications') ||
            !this.get('chat_state') ||
            !this.isEntered() ||
            (this.features.get('moderated') && this.getOwnRole() === 'visitor')
        ) {
            return;
        }

        const allowed = shared_api.settings.get('send_chat_state_notifications');
        if (Array.isArray(allowed) && !allowed.includes(this.get('chat_state'))) {
            return;
        }

        const chat_state = this.get('chat_state');
        if (chat_state === GONE) return; // <gone/> is not applicable within MUC context

        shared_api.send(muc_stx`
            <message to="${this.get('jid')}" type="groupchat" xmlns="jabber:client">
                ${chat_state === INACTIVE ? muc_stx`<inactive xmlns="${Strophe.NS.CHATSTATES}"/>` : ''}
                ${chat_state === ACTIVE ? muc_stx`<active xmlns="${Strophe.NS.CHATSTATES}"/>` : ''}
                ${chat_state === COMPOSING ? muc_stx`<composing xmlns="${Strophe.NS.CHATSTATES}"/>` : ''}
                ${chat_state === PAUSED ? muc_stx`<paused xmlns="${Strophe.NS.CHATSTATES}"/>` : ''}
                <no-store xmlns="${Strophe.NS.HINTS}"/>
                <no-permanent-store xmlns="${Strophe.NS.HINTS}"/>
            </message>`);
    }

    /**
     * Send a direct invitation as per XEP-0249
     * @param {String} recipient - JID of the person being invited
     * @param {String} [reason] - Reason for the invitation
     */
    directInvite(recipient, reason) {
        if (this.features.get('membersonly')) {
            // When inviting to a members-only groupchat, we first add
            // the person to the member list by giving them an
            // affiliation of 'member' otherwise they won't be able to join.
            this.updateMemberLists([{ jid: recipient, affiliation: 'member', reason }]);
        }
        const invitation = muc_stx`
            <message xmlns="jabber:client" to="${recipient}" id="${getUniqueId()}">
                <x xmlns="jabber:x:conference"
                    jid="${this.get('jid')}"
                    ${this.get('password') ? Stanza.unsafeXML(`password="${Strophe.xmlescape(this.get('password'))}"`) : ''}
                    ${reason ? Stanza.unsafeXML(`reason="${Strophe.xmlescape(reason)}"`) : ''} />
            </message>`;
        shared_api.send(invitation);
        /**
         * After the user has sent out a direct invitation (as per XEP-0249),
         * to a roster contact, asking them to join a room.
         * @event _converse#chatBoxMaximized
         * @type {object}
         * @property {MUC} room
         * @property {string} recipient - The JID of the person being invited
         * @property {string} reason - The original reason for the invitation
         * @example _converse.api.listen.on('chatBoxMaximized', view => { ... });
         */
        shared_api.trigger('roomInviteSent', {
            room: this,
            recipient,
            reason,
        });
    }

    /**
     * Refresh the disco identity, features and fields for this {@link MUC}.
     * *features* are stored on the features {@link Model} attribute on this {@link MUC}.
     * *fields* are stored on the config {@link Model} attribute on this {@link MUC}.
     * @param {import('../disco/types').DiscoInfoOptions} [options]
     * @returns {Promise}
     */
    async refreshDiscoInfo(options) {
        const result = await shared_api.disco.refresh(this.get('jid'), options);
        if (result instanceof StanzaError) {
            return result;
        }
        return this.getDiscoInfo().catch((e) => src_log.error(e));
    }

    /**
     * Fetch the *extended* MUC info from the server and cache it locally
     * https://xmpp.org/extensions/xep-0045.html#disco-roominfo
     * @returns {Promise}
     */
    async getDiscoInfo() {
        const jid = this.get('jid');
        const identity = await shared_api.disco.getIdentity('conference', 'text', jid);
        if (identity?.get('name')) {
            this.save({ name: identity.get('name') });
        } else {
            this.save({ name: Strophe.getNodeFromJid(jid) });
        }
        await this.getDiscoInfoFields();
        await this.getDiscoInfoFeatures();
    }

    /**
     * Fetch the *extended* MUC info fields from the server and store them locally
     * in the `config` {@link Model} attribute.
     * See: https://xmpp.org/extensions/xep-0045.html#disco-roominfo
     * @returns {Promise}
     */
    async getDiscoInfoFields() {
        const fields = await shared_api.disco.getFields(this.get('jid'));

        const config = fields.reduce((config, f) => {
            const name = f.get('var');
            if (name === 'muc#roomconfig_roomname') {
                config['roomname'] = f.get('value');
            }
            if (name?.startsWith('muc#roominfo_')) {
                config[name.replace('muc#roominfo_', '')] = f.get('value');
            }
            return config;
        }, {});

        this.config.save(config);
        if (config['roomname']) this.save({ name: config['roomname'] });
    }

    /**
     * Use converse-disco to populate the features {@link Model} which
     * is stored as an attribute on this {@link MUC}.
     * The results may be cached. If you want to force fetching the features from the
     * server, call {@link MUC#refreshDiscoInfo} instead.
     * @returns {Promise}
     */
    async getDiscoInfoFeatures() {
        const features = await shared_api.disco.getFeatures(this.get('jid'));

        const attrs = api_public.ROOM_FEATURES.reduce(
            (acc, feature) => {
                acc[feature] = false;
                return acc;
            },
            { 'fetched': new Date().toISOString() },
        );

        features.each((feature) => {
            const fieldname = feature.get('var');
            if (!fieldname.startsWith('muc_')) {
                if (fieldname === Strophe.NS.MAM) {
                    attrs.mam_enabled = true;
                } else {
                    attrs[fieldname] = true;
                }
                return;
            }
            attrs[fieldname.replace('muc_', '')] = true;
        });
        this.features.save(attrs);
    }

    /**
     * Given a <field> element, return a copy with a <value> child if
     * we can find a value for it in this rooms config.
     * @param {Element} field
     * @returns {Element}
     */
    addFieldValue(field) {
        const type = field.getAttribute('type');
        if (type === 'fixed') {
            return field;
        }
        const fieldname = field.getAttribute('var').replace('muc#roomconfig_', '');
        const config = this.get('roomconfig');
        if (fieldname in config) {
            let values;
            switch (type) {
                case 'boolean':
                    values = [config[fieldname] ? 1 : 0];
                    break;
                case 'list-multi':
                    values = config[fieldname];
                    break;
                default:
                    values = [config[fieldname]];
            }
            field.innerHTML = values.map((v) => $build('value').t(v)).join('');
        }
        return field;
    }

    /**
     * Automatically configure the groupchat based on this model's
     * 'roomconfig' data.
     * @returns {Promise<Element>}
     * Returns a promise which resolves once a response IQ has
     * been received.
     */
    async autoConfigureChatRoom() {
        const stanza = await this.fetchRoomConfiguration();
        const fields = sizzle('field', stanza);
        const configArray = fields.map((f) => this.addFieldValue(f));
        if (configArray.length) {
            return this.sendConfiguration(configArray);
        }
    }

    /**
     * Send an IQ stanza to fetch the groupchat configuration data.
     * Returns a promise which resolves once the response IQ
     * has been received.
     * @returns {Promise<Element>}
     */
    fetchRoomConfiguration() {
        return shared_api.sendIQ(muc_stx`
            <iq to="${this.get('jid')}" type="get" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_OWNER}"/>
            </iq>`);
    }

    /**
     * Sends an IQ stanza with the groupchat configuration.
     * @param {Element[]} config - The groupchat configuration
     * @returns {Promise<Element>} - A promise which resolves with
     *  the `result` stanza received from the XMPP server.
     */
    sendConfiguration(config = []) {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_OWNER}">
                    <x xmlns="${Strophe.NS.XFORM}" type="submit">
                        ${config.map((el) => Strophe.Builder.fromString(el.outerHTML))}
                    </x>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq);
    }

    onCommandError(err) {
        const { __ } = shared_converse;
        src_log.fatal(err);
        const message =
            __('Sorry, an error happened while running the command.') +
            ' ' +
            __("Check your browser's developer console for details.");
        this.createMessage({ message, 'type': 'error' });
    }

    getNickOrJIDFromCommandArgs(args) {
        const { __ } = shared_converse;
        if (muc_u.isValidJID(args.trim())) {
            return args.trim();
        }
        if (!args.startsWith('@')) {
            args = '@' + args;
        }
        const result = this.parseTextForReferences(args);
        const references = result[1];
        if (!references.length) {
            const message = __("Error: couldn't find a groupchat participant based on your arguments");
            this.createMessage({ message, 'type': 'error' });
            return;
        }
        if (references.length > 1) {
            const message = __('Error: found multiple groupchat participant based on your arguments');
            this.createMessage({ message, 'type': 'error' });
            return;
        }
        const nick_or_jid = references.pop().value;
        const reason = args.split(nick_or_jid, 2)[1];
        if (reason && !reason.startsWith(' ')) {
            const message = __("Error: couldn't find a groupchat participant based on your arguments");
            this.createMessage({ message, 'type': 'error' });
            return;
        }
        return nick_or_jid;
    }

    validateRoleOrAffiliationChangeArgs(command, args) {
        const { __ } = shared_converse;
        if (!args) {
            const message = __(
                'Error: the "%1$s" command takes two arguments, the user\'s nickname and optionally a reason.',
                command,
            );
            this.createMessage({ message, 'type': 'error' });
            return false;
        }
        return true;
    }

    getAllowedCommands() {
        let allowed_commands = ['clear', 'help', 'me', 'nick', 'register'];
        if (this.config.get('changesubject') || ['owner', 'admin'].includes(this.getOwnAffiliation())) {
            allowed_commands = [...allowed_commands, ...['subject', 'topic']];
        }
        const bare_jid = shared_converse.session.get('bare_jid');
        const occupant = this.occupants.findWhere({ 'jid': bare_jid });
        if (this.verifyAffiliations(['owner'], occupant, false)) {
            allowed_commands = allowed_commands.concat(OWNER_COMMANDS).concat(ADMIN_COMMANDS);
        } else if (this.verifyAffiliations(['admin'], occupant, false)) {
            allowed_commands = allowed_commands.concat(ADMIN_COMMANDS);
        }
        if (this.verifyRoles(['moderator'], occupant, false)) {
            allowed_commands = allowed_commands.concat(MODERATOR_COMMANDS).concat(VISITOR_COMMANDS);
        } else if (!this.verifyRoles(['visitor', 'participant', 'moderator'], occupant, false)) {
            allowed_commands = allowed_commands.concat(VISITOR_COMMANDS);
        }
        allowed_commands.sort();

        if (Array.isArray(shared_api.settings.get('muc_disable_slash_commands'))) {
            return allowed_commands.filter((c) => !shared_api.settings.get('muc_disable_slash_commands').includes(c));
        } else {
            return allowed_commands;
        }
    }

    verifyAffiliations(affiliations, occupant, show_error = true) {
        const { __ } = shared_converse;
        if (!Array.isArray(affiliations)) {
            throw new TypeError('affiliations must be an Array');
        }
        if (!affiliations.length) {
            return true;
        }
        const bare_jid = shared_converse.session.get('bare_jid');
        occupant = occupant || this.occupants.findWhere({ 'jid': bare_jid });
        if (occupant) {
            const a = occupant.get('affiliation');
            if (affiliations.includes(a)) {
                return true;
            }
        }
        if (show_error) {
            const message = __('Forbidden: you do not have the necessary affiliation in order to do that.');
            this.createMessage({ message, type: 'error' });
        }
        return false;
    }

    verifyRoles(roles, occupant, show_error = true) {
        const { __ } = shared_converse;
        if (!Array.isArray(roles)) {
            throw new TypeError('roles must be an Array');
        }
        if (!roles.length) {
            return true;
        }
        const bare_jid = shared_converse.session.get('bare_jid');
        occupant = occupant || this.occupants.findWhere({ 'jid': bare_jid });
        if (occupant) {
            const role = occupant.get('role');
            if (roles.includes(role)) {
                return true;
            }
        }
        if (show_error) {
            const message = __('Forbidden: you do not have the necessary role in order to do that.');
            this.createMessage({ message, 'type': 'error', 'is_ephemeral': 20000 });
        }
        return false;
    }

    /**
     * Returns the `role` which the current user has in this MUC
     * @returns {('none'|'visitor'|'participant'|'moderator')}
     */
    getOwnRole() {
        return this.getOwnOccupant()?.get('role');
    }

    /**
     * Returns the `affiliation` which the current user has in this MUC
     * @returns {('none'|'outcast'|'member'|'admin'|'owner')}
     */
    getOwnAffiliation() {
        return this.getOwnOccupant()?.get('affiliation') || 'none';
    }

    /**
     * Get the {@link MUCOccupant} instance which
     * represents the current user.
     * @returns {MUCOccupant}
     */
    getOwnOccupant() {
        return this.occupants.getOwnOccupant();
    }

    /**
     * Send a presence stanza to update the user's nickname in this MUC.
     * @param {String} nick
     */
    async setNickname(nick) {
        const jid = Strophe.getBareJidFromJid(this.get('jid'));
        shared_api.send(
            muc_stx`<presence xmlns="jabber:client"
                    id="${getUniqueId()}"
                    from="${shared_api.connection.get().jid}"
                    to="${jid}/${nick}"></presence>`,
        );
    }

    /**
     * Send an IQ stanza to modify an occupant's role
     * @param {MUCOccupant} occupant
     * @param {string} role
     * @param {string} reason
     * @param {function} onSuccess - callback for a successful response
     * @param {function} onError - callback for an error response
     */
    setRole(occupant, role, reason, onSuccess, onError) {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_ADMIN}">
                    <item nick="${occupant.get('nick')}" role="${role}">
                        ${reason !== null ? muc_stx`<reason>${reason}</reason>` : ''}
                    </item>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq).then(onSuccess).catch(onError);
    }

    /**
     * @param {string} nickname_or_jid - The nickname or JID of the occupant to be returned
     * @returns {MUCOccupant}
     */
    getOccupant(nickname_or_jid) {
        return muc_u.isValidJID(nickname_or_jid)
            ? this.getOccupantByJID(nickname_or_jid)
            : this.getOccupantByNickname(nickname_or_jid);
    }

    /**
     * Return an array of occupant models that have the required role
     * @param {string} role
     * @returns {{jid: string, nick: string, role: string}[]}
     */
    getOccupantsWithRole(role) {
        return this.getOccupantsSortedBy('nick')
            .filter((o) => o.get('role') === role)
            .map((item) => {
                return {
                    jid: /** @type {string} */ item.get('jid'),
                    nick: /** @type {string} */ item.get('nick'),
                    role: /** @type {string} */ item.get('role'),
                };
            });
    }

    /**
     * Return an array of occupant models that have the required affiliation
     * @param {string} affiliation
     * @returns {{jid: string, nick: string, affiliation: string}[]}
     */
    getOccupantsWithAffiliation(affiliation) {
        return this.getOccupantsSortedBy('nick')
            .filter((o) => o.get('affiliation') === affiliation)
            .map((item) => {
                return {
                    jid: /** @type {string} */ item.get('jid'),
                    nick: /** @type {string} */ item.get('nick'),
                    affiliation: /** @type {string} */ item.get('affiliation'),
                };
            });
    }

    /**
     * Return an array of occupant models, sorted according to the passed-in attribute.
     * @param {string} attr - The attribute to sort the returned array by
     * @returns {MUCOccupant[]}
     */
    getOccupantsSortedBy(attr) {
        return Array.from(this.occupants.models).sort((a, b) =>
            a.get(attr) < b.get(attr) ? -1 : a.get(attr) > b.get(attr) ? 1 : 0,
        );
    }

    /**
     * Fetch the lists of users with the given affiliations.
     * Then compute the delta between those users and
     * the passed in members, and if it exists, send the delta
     * to the XMPP server to update the member list.
     * @param {object} members - Map of member jids and affiliations.
     * @returns {Promise}
     *  A promise which is resolved once the list has been
     *  updated or once it's been established there's no need
     *  to update the list.
     */
    async updateMemberLists(members) {
        const muc_jid = this.get('jid');
        /** @type {Array<NonOutcastAffiliation>} */
        const all_affiliations = ['member', 'admin', 'owner'];
        const aff_lists = await Promise.all(all_affiliations.map((a) => getAffiliationList(a, muc_jid)));

        const old_members = aff_lists.reduce(
            /**
             * @param {MemberListItem[]} acc
             * @param {MemberListItem[]|Error} val
             * @returns {MemberListItem[]}
             */
            (acc, val) => {
                if (val instanceof Error) {
                    src_log.error(val);
                    return acc;
                }
                return [...val, ...acc];
            },
            [],
        );

        await setAffiliations(
            muc_jid,
            computeAffiliationsDelta(true, false, members, /** @type {MemberListItem[]} */ (old_members)),
        );
        await this.occupants.fetchMembers();
    }

    /**
     * Triggers a hook which gives 3rd party plugins an opportunity to determine
     * the nickname to use.
     * @return {Promise<string>} A promise which resolves with the nickname
     */
    async getNicknameFromHook() {
        /**
         * *Hook* which allows plugins to determine which nickname to use for
         * the given MUC
         * @event _converse#getNicknameForMUC
         * @type {string} The nickname to use
         */
        return await shared_api.hook('getNicknameForMUC', this, null);
    }

    /**
     * Given a nick name, save it to the model state, otherwise, look
     * for a server-side reserved nickname or default configured
     * nickname and if found, persist that to the model state.
     * @param {string} nick
     * @returns {Promise<string>} A promise which resolves with the nickname
     */
    async getAndPersistNickname(nick) {
        nick =
            nick ||
            this.get('nick') ||
            (await this.getReservedNick()) ||
            (await this.getNicknameFromHook()) ||
            shared_converse.exports.getDefaultMUCNickname();

        if (nick) safeSave(this, { nick }, { silent: true });
        return nick;
    }

    /**
     * Use service-discovery to ask the XMPP server whether
     * this user has a reserved nickname for this groupchat.
     * If so, we'll use that, otherwise we render the nickname form.
     * @returns {Promise<string>} A promise which resolves with the reserved nick or null
     */
    async getReservedNick() {
        const stanza = muc_stx`
            <iq to="${this.get('jid')}" type="get" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.DISCO_INFO}" node="x-roomuser-item"/>
            </iq>`;

        const result = await shared_api.sendIQ(stanza, DISCO_INFO_TIMEOUT_ON_JOIN, false);
        if (muc_u.isErrorObject(result)) {
            throw result;
        }
        // Result might be undefined due to a timeout
        const identity_el = result?.querySelector('query[node="x-roomuser-item"] identity');
        return identity_el ? identity_el.getAttribute('name') : null;
    }

    /**
     * Send an IQ stanza to the MUC to register this user's nickname.
     * This sets the user's affiliation to 'member' (if they weren't affiliated
     * before) and reserves the nickname for this user, thereby preventing other
     * users from using it in this MUC.
     * See https://xmpp.org/extensions/xep-0045.html#register
     */
    async registerNickname() {
        const { __ } = shared_converse;
        const nick = this.get('nick');
        const jid = this.get('jid');
        let iq, err_msg;
        try {
            iq = await shared_api.sendIQ(
                muc_stx`<iq to="${jid}" type="get" xmlns="jabber:client">
                    <query xmlns="${Strophe.NS.MUC_REGISTER}"/>
                </iq>`,
            );
        } catch (e) {
            if (sizzle(`not-allowed[xmlns="${Strophe.NS.STANZAS}"]`, e).length) {
                err_msg = __("You're not allowed to register yourself in this groupchat.");
            } else if (sizzle(`registration-required[xmlns="${Strophe.NS.STANZAS}"]`, e).length) {
                err_msg = __("You're not allowed to register in this groupchat because it's members-only.");
            }
            src_log.error(e);
            return err_msg;
        }
        const required_fields = sizzle('field required', iq).map((f) => f.parentElement);
        if (required_fields.length > 1 && required_fields[0].getAttribute('var') !== 'muc#register_roomnick') {
            return src_log.error(`Can't register the user register in the groupchat ${jid} due to the required fields`);
        }
        try {
            await shared_api.sendIQ(
                muc_stx`<iq to="${jid}" type="set" xmlns="jabber:client">
                    <query xmlns="${Strophe.NS.MUC_REGISTER}">
                        <x xmlns="${Strophe.NS.XFORM}" type="submit">
                            <field var="FORM_TYPE">
                                <value>http://jabber.org/protocol/muc#register</value>
                            </field>
                            <field var="muc#register_roomnick">
                                <value>${nick}</value>
                            </field>
                        </x>
                    </query>
                </iq>`,
            );
        } catch (e) {
            const err = await parseErrorStanza(e);
            if (err?.name === 'service-unavailable') {
                src_log.error("Can't register your nickname in this groupchat, it doesn't support registration.");
            } else if (err?.name === 'bad-request') {
                src_log.error("Can't register your nickname in this groupchat, invalid data form supplied.");
            } else {
                src_log.error(e);
            }
            throw err;
        }
    }

    /**
     * Check whether we should unregister the user from this MUC, and if so,
     * call {@link MUC#sendUnregistrationIQ}
     */
    async unregisterNickname() {
        if (shared_api.settings.get('auto_register_muc_nickname') === 'unregister') {
            try {
                if (await shared_api.disco.supports(Strophe.NS.MUC_REGISTER, this.get('jid'))) {
                    await this.sendUnregistrationIQ();
                }
            } catch (e) {
                src_log.error(e);
            }
        }
    }

    /**
     * Send an IQ stanza to the MUC to unregister this user's nickname.
     * If the user had a 'member' affiliation, it'll be removed and their
     * nickname will no longer be reserved and can instead be used (and
     * registered) by other users.
     */
    sendUnregistrationIQ() {
        const iq = muc_stx`
            <iq to="${this.get('jid')}" type="set" xmlns="jabber:client">
                <query xmlns="${Strophe.NS.MUC_REGISTER}">
                    <remove/>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq).catch((e) => src_log.error(e));
    }

    /**
     * Given a presence stanza, update the occupant model based on its contents.
     * @param {MUCPresenceAttributes} attrs - The presence stanza
     */
    updateOccupantsOnPresence(attrs) {
        if (attrs.type === 'error' || (!attrs.jid && !attrs.nick && !attrs.occupant_id)) {
            return true;
        }

        const occupant = this.occupants.findOccupant(attrs);
        // Destroy an unavailable occupant if this isn't a nick change operation and if they're not affiliated
        if (
            attrs.type === 'unavailable' &&
            occupant &&
            !attrs.codes.includes(api_public.MUC_NICK_CHANGED_CODE) &&
            !['admin', 'owner', 'member'].includes(attrs['affiliation'])
        ) {
            // Before destroying we set the new attrs, so that we can show the disconnection message
            occupant.set({
                ...attrs,
                presence: 'offline',
            });
            occupant.destroy();
            return;
        }

        const presence = attrs.type !== 'unavailable' ? 'online' : 'offline';
        const jid = attrs.jid || '';
        const occupant_attrs = {
            ...attrs,
            presence,
            jid: Strophe.getBareJidFromJid(jid) || occupant?.attributes?.jid,
            resource: Strophe.getResourceFromJid(jid) || occupant?.attributes?.resource,
        };

        if (attrs.is_self) {
            let modified = false;
            if (attrs.codes.includes(api_public.MUC_NICK_CHANGED_CODE)) {
                modified = true;
                this.set('nick', attrs.nick);
            }
            if (this.features.get(Strophe.NS.OCCUPANTID) && this.get('occupant-id') !== attrs.occupant_id) {
                modified = true;
                this.set('occupant_id', attrs.occupant_id);
            }
            modified && this.save();
        }

        if (occupant) {
            occupant.save(occupant_attrs);
        } else {
            this.occupants.create(occupant_attrs);
        }
    }

    /**
     * @param {MUCMessageAttributes} attrs
     */
    fetchFeaturesIfConfigurationChanged(attrs) {
        // 104: configuration change
        // 170: logging enabled
        // 171: logging disabled
        // 172: room no longer anonymous
        // 173: room now semi-anonymous
        // 174: room now fully anonymous
        const codes = ['104', '170', '171', '172', '173', '174'];
        if (attrs.codes.filter((code) => codes.includes(code)).length) {
            this.refreshDiscoInfo();
        }
    }

    /**
     * Given two JIDs, which can be either user JIDs or MUC occupant JIDs,
     * determine whether they belong to the same user.
     * @param {String} jid1
     * @param {String} jid2
     * @returns {Boolean}
     */
    isSameUser(jid1, jid2) {
        const bare_jid1 = Strophe.getBareJidFromJid(jid1);
        const bare_jid2 = Strophe.getBareJidFromJid(jid2);
        const resource1 = Strophe.getResourceFromJid(jid1);
        const resource2 = Strophe.getResourceFromJid(jid2);
        if (muc_u.isSameBareJID(jid1, jid2)) {
            if (bare_jid1 === this.get('jid')) {
                // MUC JIDs
                return resource1 === resource2;
            } else {
                return true;
            }
        } else {
            const occupant1 =
                bare_jid1 === this.get('jid')
                    ? this.occupants.findOccupant({ 'nick': resource1 })
                    : this.occupants.findOccupant({ 'jid': bare_jid1 });

            const occupant2 =
                bare_jid2 === this.get('jid')
                    ? this.occupants.findOccupant({ 'nick': resource2 })
                    : this.occupants.findOccupant({ 'jid': bare_jid2 });
            return occupant1 === occupant2;
        }
    }

    async isSubjectHidden() {
        const jids = await shared_api.user.settings.get('mucs_with_hidden_subject', []);
        return jids.includes(this.get('jid'));
    }

    async toggleSubjectHiddenState() {
        const muc_jid = this.get('jid');
        const jids = await shared_api.user.settings.get('mucs_with_hidden_subject', []);
        if (jids.includes(this.get('jid'))) {
            shared_api.user.settings.set(
                'mucs_with_hidden_subject',
                jids.filter((jid) => jid !== muc_jid),
            );
        } else {
            shared_api.user.settings.set('mucs_with_hidden_subject', [...jids, muc_jid]);
        }
    }

    /**
     * Handle a possible subject change and return `true` if so.
     * @param {object} attrs - Attributes representing a received
     *  message, as returned by {@link parseMUCMessage}
     */
    async handleSubjectChange(attrs) {
        const __ = shared_converse.__;
        if (typeof attrs.subject === 'string' && !attrs.thread && !attrs.message) {
            // https://xmpp.org/extensions/xep-0045.html#subject-mod
            // -----------------------------------------------------
            // The subject is changed by sending a message of type "groupchat" to the <room@service>,
            // where the <message/> MUST contain a <subject/> element that specifies the new subject but
            // MUST NOT contain a <body/> element (or a <thread/> element).
            const subject = attrs.subject;
            const author = attrs.nick;
            safeSave(this, { 'subject': { author, 'text': attrs.subject || '' } });
            if (!attrs.is_delayed && author) {
                const message = subject ? __('Topic set by %1$s', author) : __('Topic cleared by %1$s', author);
                const prev_msg = this.messages.last();
                if (prev_msg?.get('type') !== 'info' || prev_msg?.get('message') !== message) {
                    this.createMessage({ message, type: 'info', is_ephemeral: true });
                }
                if (await this.isSubjectHidden()) {
                    this.toggleSubjectHiddenState();
                }
            }
            return true;
        }
        return false;
    }

    /**
     * Set the subject for this {@link MUC}
     * @param {String} value
     */
    setSubject(value = '') {
        shared_api.send(muc_stx`
            <message to="${this.get('jid')}" type="groupchat" xmlns="jabber:client">
                <subject>${value}</subject>
            </message>`);
    }

    /**
     * Is this a chat state notification that can be ignored,
     * because it's old or because it's from us.
     * @param {Object} attrs - The message attributes
     */
    ignorableCSN(attrs) {
        return attrs.chat_state && !attrs.body && (attrs.is_delayed || this.isOwnMessage(attrs));
    }

    /**
     * Determines whether the message is from ourselves by checking
     * the `from` attribute. Doesn't check the `type` attribute.
     * @param {Object|Element|MUCMessage} msg
     * @returns {boolean}
     */
    isOwnMessage(msg) {
        let from;
        if (msg instanceof Element) {
            from = msg.getAttribute('from');
        } else if (msg instanceof shared_converse.exports.MUCMessage) {
            from = msg.get('from');
        } else {
            from = msg.from;
        }
        return Strophe.getResourceFromJid(from) == this.get('nick');
    }

    /**
     * Determines whether the incoming message stanza is a MUC reflection
     * of a message we previously sent. A MUC reflection is the server
     * echoing back our own message with the same `msgid`.
     * @param {MUCMessage} message - The existing cached message model
     * @param {MUCMessageAttributes} attrs - Attributes of the incoming stanza
     * @returns {boolean}
     */
    isMUCReflectedMessage(message, attrs) {
        return this.isOwnMessage(attrs) && attrs.msgid === message.get('msgid');
    }

    /**
     * @param {MUCMessage} message
     * @param {MUCMessageAttributes} attrs
     * @return {Promise<object>}
     */
    async getUpdatedMessageAttributes(message, attrs) {
        const new_attrs = {
            ...(await super.getUpdatedMessageAttributes(message, attrs)),
            from_muc: attrs.from_muc,
        };

        if (this.isMUCReflectedMessage(message, attrs)) {
            const stanza_id_keys = Object.keys(attrs).filter((k) => k.startsWith('stanza_id'));
            return {
                ...new_attrs,
                ...lodash_es_pick(attrs, [...stanza_id_keys, 'occupant_id']),
                ...(message.get('received') ? {} : { received: new Date().toISOString() }),
                ...(attrs.body !== undefined ? { body: attrs.body } : {}),
            };
        }
        return new_attrs;
    }

    /**
     * Send a MUC-0410 MUC Self-Ping stanza to room to determine
     * whether we're still joined.
     * @returns {Promise<boolean>}
     */
    async isJoined() {
        if (!this.isEntered()) {
            src_log.info(`isJoined: not pinging MUC ${this.get('jid')} since we're not entered`);
            return false;
        }
        if (!shared_api.connection.connected()) {
            await new Promise((resolve) => shared_api.listen.once('reconnected', resolve));
        }
        return shared_api.ping(`${this.get('jid')}/${this.get('nick')}`);
    }

    /**
     * Sends a status update presence (i.e. based on the `<show>` element)
     * @param {import("../status/types").PresenceAttrs} attrs
     * @param {Element[]|Builder[]|Element|Builder} [child_nodes]
     *  Nodes(s) to be added as child nodes of the `presence` XML element.
     */
    async sendStatusPresence(attrs, child_nodes) {
        if (this.session.get('connection_status') === ROOMSTATUS.ENTERED) {
            const presence = await shared_converse.state.profile.constructPresence(
                {
                    ...attrs,
                    to: `${this.get('jid')}/${this.get('nick')}`,
                },
                /** @type {Element[]|Builder[]} */ (child_nodes)?.map((c) => c?.tree() ?? c),
            );
            shared_api.send(presence);
        }
    }

    /**
     * Check whether we're still joined and re-join if not
     */
    async rejoinIfNecessary() {
        if (this.isRAICandidate()) {
            src_log.debug(`rejoinIfNecessary: not rejoining hidden MUC "${this.get('jid')}" since we're using RAI`);
            return true;
        }

        if (!(await this.isJoined())) {
            this.rejoin();
            return true;
        }
    }

    /**
     * @param {object} attrs
     * @returns {Promise<boolean>}
     */
    async shouldShowErrorMessage(attrs) {
        if (attrs.error_type === 'Decryption') {
            if (attrs.error_message === 'Message key not found. The counter was repeated or the key was not filled.') {
                // OMEMO message which we already decrypted before
                return false;
            } else if (attrs.error_condition === 'not-encrypted-for-this-device') {
                return false;
            }
        } else if (attrs.error_condition === 'not-acceptable' && (await this.rejoinIfNecessary())) {
            return false;
        }
        return super.shouldShowErrorMessage(attrs);
    }

    /**
     * Looks whether we already have a moderation message for this
     * incoming message. If so, it's considered "dangling" because
     * it probably hasn't been applied to anything yet, given that
     * the relevant message is only coming in now.
     * @param {object} attrs - Attributes representing a received
     *  message, as returned by {@link parseMUCMessage}
     * @returns {MUCMessage}
     */
    findDanglingModeration(attrs) {
        if (!this.messages.length) {
            return null;
        }
        // Only look for dangling moderation if there are newer
        // messages than this one, since moderation come after.
        if (this.messages.last().get('time') > attrs.time) {
            // Search from latest backwards
            const messages = Array.from(this.messages.models);
            const stanza_id = attrs[`stanza_id ${this.get('jid')}`];
            if (!stanza_id) {
                return null;
            }
            messages.reverse();
            return messages.find(
                ({ attributes }) =>
                    attributes.moderated === 'retracted' &&
                    attributes.moderated_id === stanza_id &&
                    attributes.moderated_by,
            );
        }
    }

    /**
     * Handles message moderation based on the passed in attributes.
     * @param {object} attrs - Attributes representing a received
     *  message, as returned by {@link parseMUCMessage}
     * @returns {Promise<boolean>} Returns `true` or `false` depending on
     *  whether a message was moderated or not.
     */
    async handleModeration(attrs) {
        const MODERATION_ATTRIBUTES = [
            'editable',
            'moderated',
            'moderated_by',
            'moderated_by_id',
            'moderated_id',
            'moderation_reason',
        ];
        if (attrs.moderated === 'retracted') {
            const query = {};
            const key = `stanza_id ${this.get('jid')}`;
            query[key] = attrs.moderated_id;
            const message = this.messages.findWhere(query);
            if (!message) {
                attrs['dangling_moderation'] = true;
                await this.createMessage(attrs);
                return true;
            }
            message.save(lodash_es_pick(attrs, MODERATION_ATTRIBUTES));
            return true;
        } else {
            // Check if we have dangling moderation message
            const message = this.findDanglingModeration(attrs);
            if (message) {
                const moderation_attrs = lodash_es_pick(message.attributes, MODERATION_ATTRIBUTES);
                const new_attrs = Object.assign({ dangling_moderation: false }, attrs, moderation_attrs);
                delete new_attrs['id']; // Delete id, otherwise a new cache entry gets created
                message.save(new_attrs);
                return true;
            }
        }
        return false;
    }

    getNotificationsText() {
        const { __ } = shared_converse;
        const actors_per_state = this.notifications.toJSON();

        const role_changes = shared_api.settings.get('muc_show_info_messages')
            .filter((role_change) => api_public.MUC_ROLE_CHANGES_LIST.includes(role_change));

        const join_leave_events = shared_api.settings.get('muc_show_info_messages')
            .filter((join_leave_event) => api_public.MUC_TRAFFIC_STATES_LIST.includes(join_leave_event));

        const states = [...api_public.CHAT_STATES, ...join_leave_events, ...role_changes];

        return states.reduce((result, state) => {
            const existing_actors = actors_per_state[state];
            if (!existing_actors?.length) {
                return result;
            }
            const actors = existing_actors.map((a) => this.getOccupant(a)?.getDisplayName() || a);
            if (actors.length === 1) {
                if (state === 'composing') {
                    return `${result}${__('%1$s is typing', actors[0])}\n`;
                } else if (state === 'paused') {
                    return `${result}${__('%1$s has stopped typing', actors[0])}\n`;
                } else if (state === GONE) {
                    return `${result}${__('%1$s has gone away', actors[0])}\n`;
                } else if (state === 'entered') {
                    return `${result}${__('%1$s has entered the groupchat', actors[0])}\n`;
                } else if (state === 'exited') {
                    return `${result}${__('%1$s has left the groupchat', actors[0])}\n`;
                } else if (state === 'op') {
                    return `${result}${__('%1$s is now a moderator', actors[0])}\n`;
                } else if (state === 'deop') {
                    return `${result}${__('%1$s is no longer a moderator', actors[0])}\n`;
                } else if (state === 'voice') {
                    return `${result}${__('%1$s has been given a voice', actors[0])}\n`;
                } else if (state === 'mute') {
                    return `${result}${__('%1$s has been muted', actors[0])}\n`;
                }
            } else if (actors.length > 1) {
                let actors_str;
                if (actors.length > 3) {
                    actors_str = `${Array.from(actors).slice(0, 2).join(', ')} and others`;
                } else {
                    const last_actor = actors.pop();
                    actors_str = __('%1$s and %2$s', actors.join(', '), last_actor);
                }

                if (state === 'composing') {
                    return `${result}${__('%1$s are typing', actors_str)}\n`;
                } else if (state === 'paused') {
                    return `${result}${__('%1$s have stopped typing', actors_str)}\n`;
                } else if (state === GONE) {
                    return `${result}${__('%1$s have gone away', actors_str)}\n`;
                } else if (state === 'entered') {
                    return `${result}${__('%1$s have entered the groupchat', actors_str)}\n`;
                } else if (state === 'exited') {
                    return `${result}${__('%1$s have left the groupchat', actors_str)}\n`;
                } else if (state === 'op') {
                    return `${result}${__('%1$s are now moderators', actors[0])}\n`;
                } else if (state === 'deop') {
                    return `${result}${__('%1$s are no longer moderators', actors[0])}\n`;
                } else if (state === 'voice') {
                    return `${result}${__('%1$s have been given voices', actors[0])}\n`;
                } else if (state === 'mute') {
                    return `${result}${__('%1$s have been muted', actors[0])}\n`;
                }
            }
            return result;
        }, '');
    }

    /**
     * @param { String } actor - The nickname of the actor that caused the notification
     * @param {String|Array<String>} states - The state or states representing the type of notificcation
     */
    removeNotification(actor, states) {
        const actors_per_state = this.notifications.toJSON();
        states = Array.isArray(states) ? states : [states];
        states.forEach((state) => {
            const existing_actors = Array.from(actors_per_state[state] || []);
            if (existing_actors.includes(actor)) {
                const idx = existing_actors.indexOf(actor);
                existing_actors.splice(idx, 1);
                this.notifications.set(state, Array.from(existing_actors));
            }
        });
    }

    /**
     * Update the notifications model by adding the passed in nickname
     * to the array of nicknames that all match a particular state.
     *
     * Removes the nickname from any other states it might be associated with.
     *
     * The state can be a XEP-0085 Chat State or a XEP-0045 join/leave state.
     * @param {String} actor - The nickname of the actor that causes the notification
     * @param {String} state - The state representing the type of notificcation
     */
    updateNotifications(actor, state) {
        const actors_per_state = this.notifications.toJSON();
        const existing_actors = actors_per_state[state] || [];
        if (existing_actors.includes(actor)) {
            return;
        }
        const reducer = (out, s) => {
            if (s === state) {
                out[s] = [...existing_actors, actor];
            } else {
                out[s] = (actors_per_state[s] || []).filter((a) => a !== actor);
            }
            return out;
        };
        const actors_per_chat_state = api_public.CHAT_STATES.reduce(reducer, {});
        const actors_per_traffic_state = api_public.MUC_TRAFFIC_STATES_LIST.reduce(reducer, {});
        const actors_per_role_change = api_public.MUC_ROLE_CHANGES_LIST.reduce(reducer, {});
        this.notifications.set(Object.assign(actors_per_chat_state, actors_per_traffic_state, actors_per_role_change));
        setTimeout(() => this.removeNotification(actor, state), 10000);
    }

    /**
     * @param {MessageAttributes} attrs
     * @returns {boolean}
     */
    handleMUCPrivateMessage(attrs) {
        if (attrs.type === 'chat' || attrs.type === null) {
            const occupant = this.occupants.findOccupant(attrs);
            if (occupant) {
                return occupant.queueMessage(attrs);
            }
            // TODO create occupant?
        }
        return false;
    }

    /**
     * @param {MessageAttributes} attrs
     * @returns {boolean}
     */
    handleMetadataFastening(attrs) {
        if (attrs.ogp_for_id) {
            if (attrs.from !== this.get('jid')) {
                // For now we only allow metadata from the MUC itself and not
                // from individual users who are deemed less trustworthy.
                return false;
            }
            const message = this.messages.findWhere({ 'origin_id': attrs.ogp_for_id });
            if (message) {
                const old_list = message.get('ogp_metadata') || [];
                if (old_list.filter((m) => m['og:url'] === attrs['og:url']).length) {
                    // Don't add metadata for the same URL again
                    return false;
                }
                const list = [...old_list, lodash_es_pick(attrs, METADATA_ATTRIBUTES)];
                message.save('ogp_metadata', list);
                return true;
            }
        }
        return false;
    }

    /**
     * Given {@link MessageAttributes} look for XEP-0316 Room Notifications and create info
     * messages for them.
     * @param {MUCMessageAttributes} attrs
     * @returns {boolean}
     */
    handleMEPNotification(attrs) {
        if (attrs.from !== this.get('jid') || !attrs.activities) {
            return false;
        }
        attrs.activities?.forEach((activity_attrs) => {
            const data = Object.assign(attrs, activity_attrs);
            this.createMessage(data);
            // Trigger so that notifications are shown
            shared_api.trigger('message', { 'attrs': data, 'chatbox': this });
        });
        return !!attrs.activities.length;
    }

    /**
     * Handler for all MUC messages sent to this groupchat. This method
     * shouldn't be called directly, instead {@link MUC#queueMessage}
     * should be called.
     * @param {MUCMessageAttributes|StanzaParseError} attrs_or_error - A promise which resolves to the message attributes.
     */
    async onMessage(attrs_or_error) {
        if (muc_u.isErrorObject(attrs_or_error)) {
            return src_log.error(/** @type {Error} */ (attrs_or_error).message);
        }

        const attrs = /** @type {MUCMessageAttributes} */ (attrs_or_error);
        if (attrs.type === 'error' && !(await this.shouldShowErrorMessage(attrs))) {
            return;
        }

        const message = await this.getDuplicateMessage(attrs);
        if (message) {
            message.get('type') === 'groupchat' && (await this.updateMessage(message, attrs));
            return;
        } else if (attrs.receipt_id || attrs.is_marker || this.ignorableCSN(attrs)) {
            return;
        }

        if (
            this.handleMUCPrivateMessage(attrs) ||
            this.handleMetadataFastening(attrs) ||
            this.handleMEPNotification(attrs) ||
            (await this.handleModeration(attrs)) ||
            (await this.handleRetraction(attrs)) ||
            (await this.handleSubjectChange(attrs))
        ) {
            attrs.nick && this.removeNotification(attrs.nick, ['composing', 'paused']);
            return;
        }

        this.setEditable(attrs, attrs.time);

        if (attrs['chat_state']) {
            this.updateNotifications(attrs.nick, attrs.chat_state);
        }
        /**
         * *Hook* which allows plugins to intercept an incoming MUC message stanza
         * before it is stored as a new message. Plugins can consume the stanza
         * entirely (e.g. to store it as a specialised placeholder) by returning
         * `{ handled: true }`, which prevents normal message creation.
         * @event _converse#beforeMessageCreated
         * @param {MUC} context - The MUC chatroom for which the message was received.
         * @param {MUCMessageAttributes} attrs - Parsed message attributes.
         * @param {{ handled: boolean }} data - Pass `{ handled: true }` to signal
         *   that the stanza has been fully handled and should not be processed further.
         */
        const { handled } = await shared_api.hook('beforeMessageCreated', this, attrs, { handled: false });
        if (handled) return;

        if (shouldCreateGroupchatMessage(attrs)) {
            const msg = (await this.handleCorrection(attrs)) || (await this.createMessage(attrs));
            /**
             * *Hook* which is fired after a new MUC message model has been created
             * and persisted. Plugins can use this to reconcile any state that was
             * stored in anticipation of this message (e.g. dangling reactions or
             * retractions that arrived before the original message).
             * @event _converse#afterMessageCreated
             * @param {MUC} context - The MUC chatroom the message belongs to.
             * @param {MUCMessage} data - The newly created message model.
             */
            if (msg) await shared_api.hook('afterMessageCreated', this, msg);
            this.removeNotification(attrs.nick, ['composing', 'paused']);
            this.handleUnreadMessage(msg);
        }
    }

    /**
     * @param {Element} pres
     */
    handleModifyError(pres) {
        const text = pres.querySelector('error text')?.textContent;
        if (text) {
            if (this.session.get('connection_status') === ROOMSTATUS.CONNECTING) {
                this.setDisconnectionState(text);
            } else {
                const attrs = /** @type {ErrorMessageAttributes} */ ({
                    type: 'error',
                    message: text,
                    is_ephemeral: true,
                });
                this.createMessage(attrs);
            }
        }
    }

    /**
     * Handle a presence stanza that disconnects the user from the MUC
     * @param {MUCPresenceAttributes} attrs - The stanza
     */
    handleDisconnection(attrs) {
        const { is_self, reason, actor } = attrs;
        const codes = attrs.codes.filter((c) => DISCONNECT_CODES.includes(c));
        const disconnected = is_self && codes.length > 0;
        if (!disconnected) {
            return;
        }
        const { STATUS_CODE_MESSAGES } = /** @type {UserMessage} */ (shared_converse.labels.muc);
        const message = STATUS_CODE_MESSAGES[codes[0]];
        const status = codes.includes('301') ? ROOMSTATUS.BANNED : ROOMSTATUS.DISCONNECTED;
        this.setDisconnectionState(message, reason, actor?.nick, status);
    }

    /**
     * @param {import('./types').MUCStatusCode} code
     * @param {MUCPresenceAttributes} attrs
     */
    getActionInfoMessage(code, attrs) {
        const { nick, actor } = attrs;
        const __ = shared_converse.__;
        if (code === '301') {
            return actor?.nick
                ? __('%1$s has been banned by %2$s', nick, actor.nick)
                : __('%1$s has been banned', nick);
        } else if (code === '303') {
            return __("%1$s's nickname has changed", nick);
        } else if (code === '307') {
            return actor?.nick
                ? __('%1$s has been kicked out by %2$s', nick, actor.nick)
                : __('%1$s has been kicked out', nick);
        } else if (code === '321') {
            return __('%1$s has been removed because of an affiliation change', nick);
        } else if (code === '322') {
            return __('%1$s has been removed for not being a member', nick);
        }
    }

    /**
     * @param {MUCOccupant} occupant
     */
    createAffiliationChangeMessage(occupant) {
        const __ = shared_converse.__;
        const previous_affiliation = occupant._previousAttributes.affiliation;

        if (!previous_affiliation) {
            // If no previous affiliation was set, then we don't
            // interpret this as an affiliation change.
            // For example, if muc_send_probes is true, then occupants
            // are created based on incoming messages, in which case
            // we don't yet know the affiliation
            return;
        }

        const current_affiliation = occupant.get('affiliation');
        if (previous_affiliation === 'admin' && isInfoVisible(api_public.AFFILIATION_CHANGES.EXADMIN)) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is no longer an admin of this groupchat', occupant.get('nick')),
            });
        } else if (previous_affiliation === 'owner' && isInfoVisible(api_public.AFFILIATION_CHANGES.EXOWNER)) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is no longer an owner of this groupchat', occupant.get('nick')),
            });
        } else if (previous_affiliation === 'outcast' && isInfoVisible(api_public.AFFILIATION_CHANGES.EXOUTCAST)) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is no longer banned from this groupchat', occupant.get('nick')),
            });
        }

        if (
            current_affiliation === 'none' &&
            previous_affiliation === 'member' &&
            isInfoVisible(api_public.AFFILIATION_CHANGES.EXMEMBER)
        ) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is no longer a member of this groupchat', occupant.get('nick')),
            });
        }

        if (current_affiliation === 'member' && isInfoVisible(api_public.AFFILIATION_CHANGES.MEMBER)) {
            this.createMessage({
                type: 'info',
                message: __('%1$s is now a member of this groupchat', occupant.get('nick')),
            });
        } else if (
            (current_affiliation === 'admin' && isInfoVisible(api_public.AFFILIATION_CHANGES.ADMIN)) ||
            (current_affiliation == 'owner' && isInfoVisible(api_public.AFFILIATION_CHANGES.OWNER))
        ) {
            // For example: AppleJack is now an (admin|owner) of this groupchat
            this.createMessage({
                type: 'info',
                message: __('%1$s is now an %2$s of this groupchat', occupant.get('nick'), current_affiliation),
            });
        }
    }

    createRoleChangeMessage(occupant, changed) {
        if (changed === 'none' || occupant.changed.affiliation) {
            // We don't inform of role changes if they accompany affiliation changes.
            return;
        }
        const previous_role = occupant._previousAttributes.role;
        if (previous_role === 'moderator' && isInfoVisible(api_public.MUC_ROLE_CHANGES.DEOP)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_ROLE_CHANGES.DEOP);
        } else if (previous_role === 'visitor' && isInfoVisible(api_public.MUC_ROLE_CHANGES.VOICE)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_ROLE_CHANGES.VOICE);
        }
        if (occupant.get('role') === 'visitor' && isInfoVisible(api_public.MUC_ROLE_CHANGES.MUTE)) {
            this.updateNotifications(occupant.get('nick'), api_public.MUC_ROLE_CHANGES.MUTE);
        } else if (occupant.get('role') === 'moderator') {
            if (
                !['owner', 'admin'].includes(occupant.get('affiliation')) &&
                isInfoVisible(api_public.MUC_ROLE_CHANGES.OP)
            ) {
                // Only show this message if the user isn't already
                // an admin or owner, otherwise this isn't new information.
                this.updateNotifications(occupant.get('nick'), api_public.MUC_ROLE_CHANGES.OP);
            }
        }
    }

    /**
     * Create an info message based on a received MUC status code in a
     * <presence> stanza.
     * @param {import('./types').MUCStatusCode} code
     * @param {MUCPresenceAttributes} attrs - The original stanza
     */
    createInfoMessageFromPresence(code, attrs) {
        const __ = shared_converse.__;
        const is_self = /** @type {MUCPresenceAttributes} */ (attrs).is_self ?? false;

        if (!isInfoVisible || code === '110' || (code === '100' && !is_self)) {
            return;
        }

        const { STATUS_CODE_MESSAGES } = /** @type {UserMessage} */ (shared_converse.labels.muc);
        const message = STATUS_CODE_MESSAGES[code];
        const data = /** @type {InfoMessageAttributes} */ ({
            type: 'info',
            is_ephemeral: true,
            message,
            code,
        });

        if (!is_self && ACTION_INFO_CODES.includes(code)) {
            data.message = this.getActionInfoMessage(code, attrs);
            data.reason = attrs.reason;
        } else if (is_self && NEW_NICK_CODES.includes(code)) {
            data.message = attrs.nick ? __(message, attrs.nick) : undefined;
        }

        if (data.message) {
            if (code === '201' && this.messages.findWhere(data)) {
                return;
            }
            this.createMessage(data);
        }
    }

    /**
     * Create an info message based on a received MUC status code in a <message> stanza.
     * @param {import('./types').MUCStatusCode} code
     */
    createInfoMessage(code) {
        if (!isInfoVisible(code) || code === '110') {
            return;
        }

        const { STATUS_CODE_MESSAGES } = /** @type {UserMessage} */ (shared_converse.labels.muc);
        const message = STATUS_CODE_MESSAGES[code];

        if (message) {
            this.createMessage({
                type: 'info',
                is_ephemeral: true,
                message,
                code,
            });
        }
    }

    /**
     * Set parameters regarding disconnection from this room. This helps to
     * communicate to the user why they were disconnected.
     * @param {string} message - The disconnection message, as received from (or
     *  implied by) the server.
     * @param {string} [reason] - The reason provided for the disconnection
     * @param {string} [actor] - The person (if any) responsible for this disconnection
     * @param {number} [status] - The status code (see `ROOMSTATUS`)
     */
    setDisconnectionState(message, reason, actor, status = ROOMSTATUS.DISCONNECTED) {
        this.session.save({
            'connection_status': status,
            'disconnection_actor': actor,
            'disconnection_message': message,
            'disconnection_reason': reason,
        });
    }

    /**
     * @param {Element} presence
     */
    onNicknameClash(presence) {
        const __ = shared_converse.__;
        if (shared_api.settings.get('muc_nickname_from_jid')) {
            const nick = presence.getAttribute('from').split('/')[1];
            if (nick === shared_converse.exports.getDefaultMUCNickname()) {
                this.join(nick + '-2');
            } else {
                const del = nick.lastIndexOf('-');
                const num = nick.substring(del + 1, nick.length);
                this.join(nick.substring(0, del + 1) + String(Number(num) + 1));
            }
        } else {
            this.save({
                'nickname_validation_message': __(
                    'The nickname you chose is reserved or ' + 'currently in use, please choose a different one.',
                ),
            });
            this.session.save({ 'connection_status': ROOMSTATUS.NICKNAME_REQUIRED });
        }
    }

    /**
     * Parses a <presence> stanza with type "error" and sets the proper
     * `connection_status` value for this {@link MUC} as
     * well as any additional output that can be shown to the user.
     * @param {Element} stanza - The presence stanza
     */
    onErrorPresence(stanza) {
        const __ = shared_converse.__;
        const error = stanza.querySelector('error');
        const error_type = error.getAttribute('type');
        const reason = sizzle(`text[xmlns="${Strophe.NS.STANZAS}"]`, error).pop()?.textContent;

        if (error_type === 'modify') {
            this.handleModifyError(stanza);
        } else if (error_type === 'auth') {
            if (sizzle(`not-authorized[xmlns="${Strophe.NS.STANZAS}"]`, error).length) {
                this.save({ 'password_validation_message': reason || __('Password incorrect') });
                this.session.save({ 'connection_status': ROOMSTATUS.PASSWORD_REQUIRED });
            }
            if (error.querySelector('registration-required')) {
                const message = __('You are not on the member list of this groupchat.');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('forbidden')) {
                const { STATUS_CODE_MESSAGES } = /** @type {UserMessage} */ (shared_converse.labels.muc);
                this.setDisconnectionState(STATUS_CODE_MESSAGES[301], reason, null, ROOMSTATUS.BANNED);
            }
        } else if (error_type === 'cancel') {
            if (error.querySelector('not-allowed')) {
                const message = __('You are not allowed to create new groupchats.');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('not-acceptable')) {
                const message = __("Your nickname doesn't conform to this groupchat's policies.");
                this.setDisconnectionState(message, reason);
            } else if (sizzle(`gone[xmlns="${Strophe.NS.STANZAS}"]`, error).length) {
                const moved_jid = sizzle(`gone[xmlns="${Strophe.NS.STANZAS}"]`, error)
                    .pop()
                    ?.textContent.replace(/^xmpp:/, '')
                    .replace(/\?join$/, '');
                this.save({ moved_jid, 'destroyed_reason': reason });
                this.session.save({ 'connection_status': ROOMSTATUS.DESTROYED });
            } else if (error.querySelector('conflict')) {
                this.onNicknameClash(stanza);
            } else if (error.querySelector('item-not-found')) {
                const message = __('This groupchat does not (yet) exist.');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('service-unavailable')) {
                const message = __('This groupchat has reached its maximum number of participants.');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('remote-server-not-found')) {
                const message = __('Remote server not found');
                this.setDisconnectionState(message, reason);
            } else if (error.querySelector('forbidden')) {
                const message = __("You're not allowed to enter this groupchat");
                this.setDisconnectionState(message, reason);
            } else {
                const message = __('An error happened while trying to enter this groupchat');
                this.setDisconnectionState(message, reason);
            }
        }
    }

    /**
     * Listens for incoming presence stanzas from the service that hosts this MUC
     * @param {Element} stanza - The presence stanza
     */
    onPresenceFromMUCHost(stanza) {
        if (stanza.getAttribute('type') === 'error') {
            const error = stanza.querySelector('error');
            if (error?.getAttribute('type') === 'wait' && error?.querySelector('resource-constraint')) {
                // If we get a <resource-constraint> error, we assume it's in context of XEP-0437 RAI.
                // We remove this MUC's host from the list of enabled domains and rejoin the MUC.
                if (this.session.get('connection_status') === ROOMSTATUS.DISCONNECTED) {
                    this.rejoin();
                }
            }
        }
    }

    /**
     * Handles incoming presence stanzas coming from the MUC
     * @param {Element} stanza
     */
    async onPresence(stanza) {
        if (stanza.getAttribute('type') === 'error') {
            return this.onErrorPresence(stanza);
        }

        const attrs = await parseMUCPresence(stanza, this);
        src_log.debug(
            `MUC ${this.get('jid')} onPresence received, is_self: ${attrs.is_self}, nick: ${attrs.nick}, status: ${this.session.get('connection_status')}`,
        );
        attrs.codes.forEach(async (code) => {
            this.createInfoMessageFromPresence(code, attrs);

            if (attrs.is_self && NEW_NICK_CODES.includes(code)) {
                this.save('nick', attrs.nick);

                if (
                    code === '303' &&
                    shared_api.settings.get('auto_register_muc_nickname') &&
                    (await shared_api.disco.supports(Strophe.NS.MUC_REGISTER, this.get('jid')))
                ) {
                    try {
                        await this.registerNickname();
                    } catch (e) {
                        src_log.error(e);
                        src_log.error('Error: could not register new nickname');
                    }
                }
            }
        });

        if (attrs.is_self) {
            this.onOwnPresence(attrs);
            if (this.getOwnRole() !== 'none' && this.session.get('connection_status') === ROOMSTATUS.CONNECTING) {
                this.session.save('connection_status', ROOMSTATUS.CONNECTED);
            }
        } else {
            this.updateOccupantsOnPresence(attrs);
        }
    }

    /**
     * Handles a received presence relating to the current user.
     *
     * For locked groupchats (which are by definition "new"), the
     * groupchat will either be auto-configured or created instantly
     * (with default config) or a configuration groupchat will be
     * rendered.
     *
     * If the groupchat is not locked, then the groupchat will be
     * auto-configured only if applicable and if the current
     * user is the groupchat's owner.
     * @param {MUCPresenceAttributes} attrs
     */
    async onOwnPresence(attrs) {
        src_log.info(
            `MUC ${this.get('jid')} onOwnPresence, old_status: ${this.session.get('connection_status')}, codes: ${attrs.codes.join(',')}`,
        );
        await this.occupants.fetched;

        if (attrs['type'] === 'unavailable') {
            this.handleDisconnection(attrs);
            return;
        }

        const old_status = this.session.get('connection_status');
        if (old_status !== ROOMSTATUS.ENTERED && old_status !== ROOMSTATUS.CLOSING) {
            src_log.info(`MUC ${this.get('jid')} onOwnPresence setting status to ENTERED`);
            // Set connection_status before creating the occupant, but
            // only trigger afterwards, so that plugins can access the
            // occupant in their event handlers.
            this.session.save('connection_status', ROOMSTATUS.ENTERED, { 'silent': true });
            this.updateOccupantsOnPresence(attrs);
            this.session.trigger('change:connection_status', this.session, old_status);
        } else {
            this.updateOccupantsOnPresence(attrs);
        }

        const locked_room = attrs.codes.includes('201');
        if (locked_room) {
            if (this.get('auto_configure')) {
                await this.autoConfigureChatRoom().then(() => this.refreshDiscoInfo());
            } else if (shared_api.settings.get('muc_instant_rooms')) {
                // Accept default configuration
                await this.sendConfiguration().then(() => this.refreshDiscoInfo());
            } else {
                shared_api.modal.show('converse-muc-config-modal', { model: this });
            }
        }
    }

    /**
     * Returns a boolean to indicate whether the current user
     * was mentioned in a message.
     * @param {BaseMessage} message - The text message
     */
    isUserMentioned(message) {
        const nick = this.get('nick');
        if (message.get('references').length) {
            const mentions = message
                .get('references')
                .filter((ref) => ref.type === 'mention')
                .map((ref) => ref.value);
            return mentions.includes(nick);
        } else {
            return new RegExp(`\\b${nick}\\b`).test(message.get('body'));
        }
    }

    /**
     * @param {BaseMessage} message - The text message
     */
    incrementUnreadMsgsCounter(message) {
        const settings = {
            'num_unread_general': this.get('num_unread_general') + 1,
        };
        if (this.get('num_unread_general') === 0) {
            settings['first_unread_id'] = message.get('id');
        }
        if (this.isUserMentioned(message)) {
            settings.num_unread = this.get('num_unread') + 1;
        }
        this.save(settings);
    }

    async clearUnreadMsgCounter() {
        if (this.get('num_unread_general') > 0 || this.get('num_unread') > 0 || this.get('has_activity')) {
            await this.sendMarkerForMessage(this.messages.last());
        }
        safeSave(this, {
            'has_activity': false,
            'num_unread': 0,
            'num_unread_general': 0,
        });
    }
}

/* export default */ const muc_muc = (MUC);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/occupant.js














const { Strophe: occupant_Strophe, stx: occupant_stx } = api_public.env;

/**
 * Represents a participant in a MUC
 */
class MUCOccupant extends model_with_vcard_ModelWithVCard(model_with_messages_ModelWithMessages(color_ColorAwareModel(skeletor_esm_Model))) {
    /**
     * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
     * @typedef {import('../../shared/errors').StanzaParseError} StanzaParseError
     * @typedef {import('./message.js').default} MUCMessage
     */

    async initialize() {
        this.lazy_load_vcard = true;
        super.initialize();

        await this.fetchMessages();
        this.on('change:nick', () => this.setColor());
        this.on('change:jid', () => this.setColor());
        this.on('change:chat_state', () => sendChatState(this.get('jid'), this.get('chat_state')));
    }

    defaults() {
        return {
            hats: [],
            presence: 'offline',
            show: undefined,
            states: [],
            hidden: true,
            num_unread: 0,
            message_type: 'chat',
        };
    }

    save(key, val, options) {
        let attrs;
        if (key == null) {
            // eslint-disable-line no-eq-null
            return super.save(key, val, options);
        } else if (typeof key === 'object') {
            attrs = key;
            options = val;
        } else {
            (attrs = {})[key] = val;
        }

        if (attrs.occupant_id) {
            attrs.id = attrs.occupant_id;
        }
        return super.save(attrs, options);
    }

    getMessagesCacheKey() {
        const id = this.get('occupant_id') || this.get('jid') || this.get('nick');
        return `converse.muc-private-msgs-${id}-${shared_converse.session.get('bare_jid')}`;
    }

    getMessagesCollection() {
        return new muc_messages();
    }

    /**
     * Handler for all MUC private messages sent to this occupant.
     * This method houldn't be called directly, instead {@link MUC#queueMessage} should be called.
     * @param {MessageAttributes|StanzaParseError} attrs_or_error
     */
    async onMessage(attrs_or_error) {
        if (headless_utils.isErrorObject(attrs_or_error)) {
            const { stanza, message } = /** @type {StanzaParseError} */ (attrs_or_error);
            if (stanza) src_log.error(stanza);
            return src_log.error(message);
        }

        const attrs = /** @type {MessageAttributes} */ (attrs_or_error);
        if (attrs.type === 'error' && !(await this.shouldShowErrorMessage(attrs))) {
            return;
        }

        const message = await this.getDuplicateMessage(attrs);
        if (message) {
            await this.updateMessage(message, attrs);
            return;
        } else if (await this.handleRetraction(attrs)) {
            return;
        }

        this.setEditable(attrs, attrs.time);

        /**
         * *Hook* which allows plugins to intercept an incoming MUC private message
         * stanza before it is stored as a new message. Plugins can consume the stanza
         * entirely (e.g. to store it as a specialised placeholder) by returning
         * `{ handled: true }`, which prevents normal message creation.
         * @event _converse#beforeMessageCreated
         * @param {MUCOccupant} context - The occupant for which the message was received.
         * @param {MessageAttributes} attrs - Parsed message attributes.
         * @param {{ handled: boolean }} data - Pass `{ handled: true }` to signal
         *   that the stanza has been fully handled and should not be processed further.
         */
        const { handled } = await shared_api.hook('beforeMessageCreated', this, attrs, { handled: false });
        if (handled) return;

        if (shouldCreateGroupchatMessage(attrs)) {
            const msg = (await this.handleCorrection(attrs)) || (await this.createMessage(attrs));
            /**
             * *Hook* which is fired after a new MUC occupant message model has been
             * created and persisted. Plugins can use this to reconcile any state that
             * was stored in anticipation of this message (e.g. dangling reactions or
             * retractions that arrived before the original message).
             * @event _converse#afterMessageCreated
             * @param {MUCOccupant} context - The occupant the message belongs to.
             * @param {MUCMessage} data - The newly created message model.
             */
            if (msg) await shared_api.hook('afterMessageCreated', this, msg);
            this.handleUnreadMessage(msg);
        }
    }

    /**
     * @returns {string}
     */
    getDisplayName() {
        return this.get('nick') || this.get('jid') || '';
    }

    /**
     * Return roles which may be assigned to this occupant
     * @returns {typeof ROLES} - An array of assignable roles
     */
    getAssignableRoles() {
        let disabled = shared_api.settings.get('modtools_disable_assign');
        if (!Array.isArray(disabled)) {
            disabled = disabled ? ROLES : [];
        }
        if (this.get('role') === 'moderator') {
            return ROLES.filter((r) => !disabled.includes(r));
        } else {
            return [];
        }
    }

    /**
     * Return affiliations which may be assigned by this occupant
     * @returns {typeof AFFILIATIONS} An array of assignable affiliations
     */
    getAssignableAffiliations() {
        let disabled = shared_api.settings.get('modtools_disable_assign');
        if (!Array.isArray(disabled)) {
            disabled = disabled ? AFFILIATIONS : [];
        }
        if (this.get('affiliation') === 'owner') {
            return AFFILIATIONS.filter((a) => !disabled.includes(a));
        } else if (this.get('affiliation') === 'admin') {
            return AFFILIATIONS.filter((a) => !['owner', 'admin', ...disabled].includes(a));
        } else {
            return [];
        }
    }

    isMember() {
        return ['admin', 'owner', 'member'].includes(this.get('affiliation'));
    }

    isModerator() {
        return ['admin', 'owner'].includes(this.get('affiliation')) || this.get('role') === 'moderator';
    }

    isSelf() {
        return this.get('states').includes('110');
    }

    /**
     * @param {MessageAttributes} [attrs]
     * @return {Promise<MessageAttributes>}
     */
    async getOutgoingMessageAttributes(attrs) {
        const origin_id = headless_utils.getUniqueId();
        const text = attrs?.body;
        const body = text ? headless_utils.emojis.shortnamesToUnicode(text) : undefined;
        const muc = this.collection.chatroom;
        const own_occupant = muc.getOwnOccupant();
        attrs = Object.assign(
            {},
            attrs,
            {
                body,
                from: own_occupant.get('from'),
                fullname: shared_converse.state.profile.get('fullname'),
                id: origin_id,
                jid: this.get('jid'),
                message: body,
                msgid: origin_id,
                nick: own_occupant.get('nickname'),
                origin_id,
                sender: 'me',
                time: new Date().toISOString(),
                to: this.get('from') ?? `${muc.get('jid')}/${this.get('nick')}`,
                type: 'chat',
            },
            await headless_utils.getMediaURLsMetadata(text),
        );

        /**
         * *Hook* which allows plugins to update the attributes of an outgoing message.
         * These attributes get set on the {@link Message} and persisted.
         * @event _converse#getOutgoingMessageAttributes
         * @param {MUCOccupant} chat
         *      The chat from which this message will be sent.
         * @param {MessageAttributes} attrs
         *      The message attributes, from which the stanza will be created.
         */
        attrs = await shared_api.hook('getOutgoingMessageAttributes', this, attrs);
        return attrs;
    }

    /**
     * @param {import('../chat/message').default} message - The message object
     */
    async createMessageStanza(message) {
        const stanza = await super.createMessageStanza(message);
        stanza.cnode(occupant_stx`<x xmlns="${occupant_Strophe.NS.MUC}#user"/>`).root();
        return stanza;
    }

    /**
     * @param {import('../../shared/message').default} message
     */
    isChatMessage(message) {
        return message.get('type') === this.get('message_type');
    }
}

/* export default */ const muc_occupant = (MUCOccupant);

;// CONCATENATED MODULE: ./src/headless/plugins/muc/occupants.js
/**
 * @typedef {module:plugin-muc-parsers.MemberListItem} MemberListItem
 * @typedef {import('@converse/skeletor').ModelAttributes} ModelAttributes
 * @typedef {import('@converse/skeletor').CollectionOptions} CollectionOptions
 * @typedef {import('@converse/skeletor').Options} Options
 */










const { u: occupants_u } = api_public.env;


/**
 * A list of {@link MUCOccupant} instances, representing participants in a MUC.
 * @memberOf _converse
 * @extends {Collection<MUCOccupant>}
 */
class MUCOccupants extends Collection {

    constructor (attrs, options) {
        super(
            attrs,
            Object.assign({ comparator: occupantsComparator }, options)
        );
        this.chatroom = null;
    }

    get model() {
        return muc_occupant;
    }

    initialize() {
        this.on('change:nick', () => this.sort());
        this.on('change:role', () => this.sort());
    }

    static getAutoFetchedAffiliationLists () {
        const affs = shared_api.settings.get('muc_fetch_members');
        return Array.isArray(affs) ? affs : affs ? ['member', 'admin', 'owner'] : [];
    }

    /**
     * @param {Model|ModelAttributes} attrs
     * @param {Options} [options]
     */
    create (attrs, options) {
        if (attrs.id || attrs instanceof skeletor_esm_Model) {
            return super.create(attrs, options);
        }
        attrs.id = attrs.occupant_id || getUniqueId();
        return super.create(attrs, options);
    }

    async fetchMembers () {
        if (!['member', 'admin', 'owner'].includes(this.getOwnOccupant()?.get('affiliation'))) {
            // https://xmpp.org/extensions/xep-0045.html#affil-priv
            return;
        }
        const affiliations = MUCOccupants.getAutoFetchedAffiliationLists();
        if (affiliations.length === 0) {
            return;
        }
        const muc_jid = this.chatroom.get('jid');
        const aff_lists = await Promise.all(affiliations.map(a => getAffiliationList(a, muc_jid)));

        const new_members = aff_lists.reduce(
            /**
             * @param {MemberListItem[]} acc
             * @param {MemberListItem[]|Error} val
             * @returns {MemberListItem[]}
             */
            (acc, val) => {
                if (val instanceof Error) {
                    return acc;
                }
                return [...val, ...acc];
            }, []
        );

        const known_affiliations = affiliations.filter(
            a => !occupants_u.isErrorObject(aff_lists[affiliations.indexOf(a)])
        );
        const new_jids = /** @type {MemberListItem[]} */(new_members).map(m => m.jid).filter(m => m !== undefined);

        const new_nicks = /** @type {MemberListItem[]} */(new_members).map(
            (m) => (!m.jid && m.nick) || undefined).filter(m => m !== undefined);

        const removed_members = this.filter(m => {
            return (
                known_affiliations.includes(m.get('affiliation')) &&
                !new_nicks.includes(m.get('nick')) &&
                !new_jids.includes(m.get('jid'))
            );
        });

        const bare_jid = shared_converse.session.get('bare_jid');
        removed_members.forEach(occupant => {
            if (occupant.get('jid') === bare_jid) {
                return;
            } else if (occupant.get('show') === 'offline') {
                occupant.destroy();
            } else {
                occupant.save('affiliation', null);
            }
        });
        /** @type {MemberListItem[]} */(new_members).forEach(attrs => {
            const occupant = this.findOccupant(attrs);
            occupant ? occupant.save(attrs) : this.create(attrs);
        });
        /**
         * Triggered once the member lists for this MUC have been fetched and processed.
         * @event _converse#membersFetched
         * @example _converse.api.listen.on('membersFetched', () => { ... });
         */
        shared_api.trigger('membersFetched');
    }

    /**
     * Try to find an existing occupant based on the provided {@link OccupantData} object.
     * Fetching the user by `occupant_id` is the quickest, O(1),
     * since it's a dictionary lookup.
     * Fetching by jid or nick is O(n), since it requires traversing an array.
     * Lookup by occupant_id is done first, then jid, and then nick.
     *
     * @param {import('./types').OccupantData} data
     * @returns {MUCOccupant}
     */
    findOccupant (data) {
        if (data.occupant_id) {
            return this.get(data.occupant_id);
        }

        const jid = data.jid && Strophe.getBareJidFromJid(data.jid);
        const occupant = jid && this.findWhere({ jid }) ||
            data.nick && this.findWhere({ 'nick': data.nick });

        return occupant;
    }

    /**
     * Get the {@link MUCOccupant} instance which
     * represents the current user.
     * @method _converse.MUCOccupants#getOwnOccupant
     * @returns {MUCOccupant}
     */
    getOwnOccupant () {
        return this.findOccupant({
            jid: shared_converse.session.get('bare_jid'),
            occupant_id: this.chatroom.get('occupant_id')
        });
    }
}


// @ts-ignore
/* export default */ const muc_occupants = (MUCOccupants);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/model.js













const { Strophe: chat_model_Strophe, u: model_u } = api_public.env;

/**
 * Represents a one-on-one chat conversation.
 */
class model_ChatBox extends model_with_vcard_ModelWithVCard(model_with_messages_ModelWithMessages(model_with_contact_ModelWithContact(color_ColorAwareModel(ChatBoxBase)))) {
    /**
     * @typedef {import('./message.js').default} Message
     * @typedef {import('../muc/muc.js').default} MUC
     * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
     * @typedef {import('../../shared/errors').StanzaParseError} StanzaParseError
     */

    defaults() {
        return {
            bookmarked: false,
            hidden: isUniView() && !shared_api.settings.get('singleton'),
            message_type: 'chat',
            num_unread: 0,
            time_opened: this.get('time_opened') || new Date().getTime(),
            time_sent: new Date(0).toISOString(),
            type: PRIVATE_CHAT_TYPE,
        };
    }

    /**
     * @param {import('@converse/skeletor').ModelAttributes} attrs
     * @param {import('@converse/skeletor').ModelOptions} options
     */
    constructor(attrs, options) {
        super(attrs, options);
        this.disable_mam = false;
    }

    initialize() {
        super.initialize();
        this.initialized = this.setup();
    }

    async setup() {
        const jid = this.get('jid');
        this.setPresence(jid);
        await this.setModelContact(jid);

        this.on('change:chat_state', () => sendChatState(this.get('jid'), this.get('chat_state')));
        this.on('change:hidden', () => this.get('hidden') && this.setChatState(INACTIVE));

        await this.fetchMessages();
        /**
         * Triggered once a {@link ChatBox} has been created and initialized.
         * @event _converse#chatBoxInitialized
         * @type { ChatBox}
         * @example _converse.api.listen.on('chatBoxInitialized', model => { ... });
         */
        await shared_api.trigger('chatBoxInitialized', this, { synchronous: true });
    }

    /**
     * @param {string} jid
     */
    async setPresence(jid) {
        await shared_api.waitUntil('presencesInitialized');
        const { presences } = shared_converse.state;
        this.presence = presences.get(jid) || presences.create({ jid });
        this.presence.on(
            'change:show',
            /** @param {import('../roster/presence').default} item */
            (item) => this.onPresenceChanged(item),
        );
    }

    /**
     * @param {MessageAttributes|StanzaParseError} attrs_or_error
     */
    async onMessage(attrs_or_error) {
        if (model_u.isErrorObject(attrs_or_error)) {
            const { stanza, message } = /** @type {StanzaParseError} */ (attrs_or_error);
            if (stanza) src_log.error(stanza);
            return src_log.error(message);
        }

        const attrs = /** @type {MessageAttributes} */ (attrs_or_error);
        const message = await this.getDuplicateMessage(attrs);
        if (message) {
            await this.updateMessage(message, attrs);
        } else if (
            !this.handleReceipt(attrs) &&
            !this.handleChatMarker(attrs) &&
            !(await this.handleRetraction(attrs))
        ) {
            this.setEditable(attrs, attrs.time);

            if (attrs['chat_state'] && attrs.sender === 'them') {
                this.notifications.set('chat_state', attrs.chat_state);
            }
            /**
             * *Hook* which allows plugins to intercept an incoming message stanza
             * before it is stored as a new message. Plugins can consume the stanza
             * entirely (e.g. to store it as a specialised placeholder) by returning
             * `{ handled: true }`, which prevents normal message creation.
             * @event _converse#beforeMessageCreated
             * @param {ChatBox} context - The chatbox for which the message was received.
             * @param {MessageAttributes} attrs - Parsed message attributes.
             * @param {{ handled: boolean }} data - Pass `{ handled: true }` to signal
             *   that the stanza has been fully handled and should not be processed further.
             * @example
             *   api.listen.on('beforeMessageCreated', (chatbox, attrs, data) => {
             *       if (attrs.my_custom_field) {
             *           // Handle it ourselves and stop normal processing
             *           return { ...data, handled: true };
             *       }
             *       return data;
             *   });
             */
            const { handled } = await shared_api.hook('beforeMessageCreated', this, attrs, { handled: false });
            if (handled) return;

            if (model_u.shouldCreateMessage(attrs)) {
                const msg = (await this.handleCorrection(attrs)) || (await this.createMessage(attrs));
                /**
                 * *Hook* which is fired after a new message model has been created
                 * and persisted. Plugins can use this to reconcile any state that
                 * was stored in anticipation of this message (e.g. dangling reactions
                 * or retractions that arrived before the original message).
                 * @event _converse#afterMessageCreated
                 * @param {ChatBox} context - The chatbox the message belongs to.
                 * @param {Message} data - The newly created message model.
                 * @example
                 *   api.listen.on('afterMessageCreated', (chatbox, message) => {
                 *       // e.g. apply any stored dangling reactions to this message
                 *   });
                 */
                if (msg) await shared_api.hook('afterMessageCreated', this, msg);
                this.notifications.set({ 'chat_state': null });
                this.handleUnreadMessage(msg);
            }
        }
    }

    /**
     * @param {import('../roster/presence').default} item
     */
    onPresenceChanged(item) {
        const { __ } = shared_converse;
        const show = item.get('show');
        const fullname = this.getDisplayName();
        let message;
        if (show === 'offline') {
            message = __('%1$s has gone offline', fullname);
        } else if (show === 'away') {
            message = __('%1$s has gone away', fullname);
        } else if (show === 'dnd') {
            message = __('%1$s is busy', fullname);
        } else if (show === 'online') {
            message = __('%1$s is online', fullname);
        }
        if (message) this.createMessage({ message, type: 'info', is_ephemeral: true });
    }

    async close() {
        if (shared_api.connection.connected()) {
            // Immediately sending the chat state, because the
            // model is going to be destroyed afterwards.
            this.setChatState(INACTIVE);
            sendChatState(this.get('jid'), this.get('chat_state'));
        }
        await super.close();
    }

    /**
     * @returns {string|null}
     */
    getDisplayName() {
        if (this.contact) {
            const display_name = this.contact.getDisplayName({ no_jid: true });
            if (display_name) return display_name;
        }

        if (this.vcard) {
            return this.vcard.getDisplayName();
        } else {
            return this.get('jid');
        }
    }

    /**
     * @param {string} jid1
     * @param {string} jid2
     */
    isSameUser(jid1, jid2) {
        return model_u.isSameBareJID(jid1, jid2);
    }

    /**
     * @param {MessageAttributes} attrs
     */
    handleChatMarker(attrs) {
        const to_bare_jid = chat_model_Strophe.getBareJidFromJid(attrs.to);
        if (to_bare_jid !== shared_converse.session.get('bare_jid')) {
            return false;
        }

        if (attrs.is_markable) {
            if (
                this.contact &&
                !['none', 'to', undefined].includes(this.contact.get('subscription')) &&
                !attrs.is_archived &&
                !attrs.is_carbon
            ) {
                sendMarker(attrs.from, attrs.msgid, 'received');
            }
            return false;
        } else if (attrs.marker_id) {
            const message = this.messages.findWhere({ 'msgid': attrs.marker_id });
            const field_name = `marker_${attrs.marker}`;
            if (message && !message.get(field_name)) {
                message.save({ field_name: new Date().toISOString() });
            }
            return true;
        }
    }

    /**
     * @param {MessageAttributes} [attrs]
     * @return {Promise<MessageAttributes>}
     */
    async getOutgoingMessageAttributes(attrs) {
        const is_spoiler = !!this.get('composing_spoiler');
        const origin_id = model_u.getUniqueId();
        const text = attrs?.body;
        const body = text ? model_u.emojis.shortnamesToUnicode(text) : undefined;

        // Get reply attributes from chatbox model if replying to a message
        const reply_to_id = this.get('reply_to_id');
        const reply_to = this.get('reply_to');

        attrs = Object.assign(
            {},
            attrs,
            {
                body,
                from: shared_converse.session.get('jid'),
                fullname: shared_converse.state.profile.get('fullname'),
                id: origin_id,
                is_spoiler,
                jid: this.get('jid'),
                message: body,
                msgid: origin_id,
                nick: this.get('nickname'),
                origin_id,
                reply_to_id,
                reply_to,
                sender: 'me',
                time: new Date().toISOString(),
                type: this.get('message_type'),
            },
            await model_u.getMediaURLsMetadata(text),
        );

        // Add the XEP-0461 reply fallback before the hook
        attrs = this.addReplyFallback(attrs);

        // Clear reply state after capturing it
        if (reply_to_id) {
            this.save({ reply_to_id: undefined, reply_to: undefined });
        }

        /**
         * *Hook* which allows plugins to update the attributes of an outgoing message.
         * These attributes get set on the {@link Message} or
         * {@link MUCMessage} and persisted to storage.
         * @event _converse#getOutgoingMessageAttributes
         * @param {ChatBox|MUC} chat
         *      The chat from which this message will be sent.
         * @param {MessageAttributes} attrs
         *      The message attributes, from which the stanza will be created.
         */
        attrs = await shared_api.hook('getOutgoingMessageAttributes', this, attrs);
        return attrs;
    }

    canPostMessages() {
        return true;
    }

    /**
     * @param {import('../../shared/message').default} message
     */
    isChatMessage(message) {
        const type = message.get('type');
        return type === this.get('message_type') || type === 'normal';
    }
}

/* export default */ const chat_model = (model_ChatBox);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/message.js




/**
 * Represents a (non-MUC) message.
 * These can be either `chat`, `normal` or `headline` messages.
 * @namespace _converse.Message
 * @memberOf _converse
 * @example const msg = new Message({'message': 'hello world!'});
 */
class Message extends shared_message {
    initialize() {
        super.initialize();
        this.initialized = this.setup();
    }

    async setup() {
        // If `type` changes from `error` to `chat`, we want to set the contact. See #2733
        this.on('change:type', () => this.setContact());

        await this.setContact();
        /**
         * Triggered once a {@link Message} has been created and initialized.
         * @event _converse#messageInitialized
         * @type {Message}
         * @example _converse.api.listen.on('messageInitialized', model => { ... });
         */
        await shared_api.trigger('messageInitialized', this, { synchronous: true });
    }

    setContact() {
        if (['chat', 'normal'].includes(this.get('type'))) {
            return this.setModelContact(Strophe.getBareJidFromJid(this.get('from')));
        }
    }

    getDisplayName() {
        if (this.contact) {
            return this.contact.getDisplayName();
        } else if (this.vcard) {
            return this.vcard.getDisplayName();
        } else {
            return this.get('from');
        }
    }
}

/* export default */ const chat_message = (Message);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/messages.js



/**
 * @extends {Collection<Message>}
 */
class Messages extends Collection {

    constructor () {
        super();
        this.comparator = 'time';
        this.model = chat_message;
        this.fetched = null;
        this.chatbox = null;
    }
}

/* export default */ const chat_messages = (Messages);

;// CONCATENATED MODULE: ./src/headless/plugins/chat/api.js
/**
 * @typedef {import('./model.js').default} ChatBox
 */






/* export default */ const chat_api = ({
    /**
     * The "chats" namespace (used for one-on-one chats)
     *
     * @namespace api.chats
     * @memberOf api
     */
    chats: {
        /**
         * @method api.chats.create
         * @param {string|string[]} jids An jid or array of jids
         * @param {object} [attrs] An object containing configuration attributes.
         * @returns {Promise<ChatBox|ChatBox[]>}
         */
        async create (jids, attrs) {
            if (typeof jids === 'string') {
                if (attrs && !attrs?.fullname) {
                    const contact = await shared_api.contacts.get(jids);
                    attrs.fullname = contact?.attributes?.fullname;
                }
                const chatbox = shared_api.chats.get(jids, attrs, true);
                if (!chatbox) {
                    src_log.error("Could not open chatbox for JID: "+jids);
                    return;
                }
                return chatbox;
            }
            if (Array.isArray(jids)) {
                return Promise.all(jids.map(async jid => {
                    const contact = await shared_api.contacts.get(jids);
                    attrs.fullname = contact?.attributes?.fullname;
                    return shared_api.chats.get(jid, attrs, true).maybeShow();
                }));
            }
            src_log.error("chats.create: You need to provide at least one JID");
            return null;
        },

        /**
         * Opens a new one-on-one chat.
         *
         * @method api.chats.open
         * @param {String|string[]} jids - e.g. 'buddy@example.com' or ['buddy1@example.com', 'buddy2@example.com']
         * @param {Object} [attrs] - Attributes to be set on the _converse.ChatBox model.
         * @param {Boolean} [attrs.minimized] - Should the chat be created in minimized state.
         * @param {Boolean} [force=false] - By default, a minimized
         *   chat won't be maximized (in `overlayed` view mode) and in
         *   `fullscreen` view mode a newly opened chat won't replace
         *   another chat already in the foreground.
         *   Set `force` to `true` if you want to force the chat to be
         *   maximized or shown.
         * @returns {Promise} Promise which resolves with the
         *   _converse.ChatBox representing the chat.
         *
         * @example
         * // To open a single chat, provide the JID of the contact you're chatting with in that chat:
         * converse.plugins.add('myplugin', {
         *     initialize: function() {
         *         const _converse = this._converse;
         *         // Note, buddy@example.org must be in your contacts roster!
         *         api.chats.open('buddy@example.com').then(chat => {
         *             // Now you can do something with the chat model
         *         });
         *     }
         * });
         *
         * @example
         * // To open an array of chats, provide an array of JIDs:
         * converse.plugins.add('myplugin', {
         *     initialize: function () {
         *         const _converse = this._converse;
         *         // Note, these users must first be in your contacts roster!
         *         api.chats.open(['buddy1@example.com', 'buddy2@example.com']).then(chats => {
         *             // Now you can do something with the chat models
         *         });
         *     }
         * });
         */
        async open (jids, attrs, force) {
            if (typeof jids === 'string') {
                const chat = await shared_api.chats.get(jids, attrs, true);
                if (chat) {
                    return chat.maybeShow(force);
                }
                return chat;
            } else if (Array.isArray(jids)) {
                return Promise.all(
                    jids.map(j => shared_api.chats.get(j, attrs, true).then(c => c && c.maybeShow(force)))
                        .filter(c => c)
                );
            }
            const err_msg = "chats.open: You need to provide at least one JID";
            src_log.error(err_msg);
            throw new Error(err_msg);
        },

        /**
         * Retrieves a chat or all chats.
         *
         * @method api.chats.get
         * @param {String|string[]} jids - e.g. 'buddy@example.com' or ['buddy1@example.com', 'buddy2@example.com']
         * @param {Object} [attrs] - Attributes to be set on the _converse.ChatBox model.
         * @param {Boolean} [create=false] - Whether the chat should be created if it's not found.
         * @returns {Promise<ChatBox[]>}
         *
         * @example
         * // To return a single chat, provide the JID of the contact you're chatting with in that chat:
         * const model = await api.chats.get('buddy@example.com');
         *
         * @example
         * // To return an array of chats, provide an array of JIDs:
         * const models = await api.chats.get(['buddy1@example.com', 'buddy2@example.com']);
         *
         * @example
         * // To return all open chats, call the method without any parameters::
         * const models = await api.chats.get();
         *
         */
        async get (jids, attrs={}, create=false) {
            await shared_api.waitUntil('chatBoxesFetched');

            /** @param {string} jid */
            async function _get (jid) {
                let model = await shared_api.chatboxes.get(jid);
                if (!model && create) {
                    model = await shared_api.chatboxes.create(jid, attrs, shared_converse.exports.ChatBox);
                } else {
                    model = (model && model.get('type') === PRIVATE_CHAT_TYPE) ? model : null;
                    if (model && Object.keys(attrs).length) {
                        model.save(attrs);
                    }
                }
                return model;
            }
            if (jids === undefined) {
                const chats = await shared_api.chatboxes.get();
                return chats?.filter(c => (c.get('type') === PRIVATE_CHAT_TYPE)) ?? [];
            } else if (typeof jids === 'string') {
                return _get(jids);
            }
            return Promise.all(jids.map(jid => _get(jid)));
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/chat/plugin.js












const { Strophe: chat_plugin_Strophe } = api_public.env;


api_public.plugins.add('converse-chat', {
    dependencies: ['converse-chatboxes', 'converse-disco'],

    initialize () {
        // Configuration values for this plugin
        // ====================================
        // Refer to docs/source/configuration.rst for explanations of these
        // configuration settings.
        shared_api.settings.extend({
            'allow_message_corrections': 'all',
            'allow_message_retraction': 'all',
            'allow_message_styling': true,
            'auto_join_private_chats': [],
            'clear_messages_on_reconnection': false,
            'filter_by_resource': false,
            'prune_messages_above': undefined,
            'pruning_behavior': 'unscrolled',
            'send_chat_markers': ['received', 'displayed', 'acknowledged'],
            'send_chat_state_notifications': true,
        });

        const exports = { ChatBox: chat_model, Message: chat_message, Messages: chat_messages, handleMessageStanza: handleMessageStanza };
        Object.assign(shared_converse, exports); // TODO: DEPRECATED
        Object.assign(shared_converse.exports, exports);

        Object.assign(shared_api, chat_api);

        chatboxes_api.registry.add(PRIVATE_CHAT_TYPE, chat_model);

        routeToChat();
        addRouteListener(routeToChat);

        shared_api.listen.on('chatBoxesFetched', autoJoinChats);
        shared_api.listen.on('presencesInitialized', registerMessageHandlers);

        shared_api.listen.on('connected', () => enableCarbons());
        shared_api.listen.on('reconnected', () => enableCarbons());

        // Advertise XEP-0461 Message Replies support
        shared_api.listen.on('addClientFeatures', () => {
            shared_api.disco.own.features.add(chat_plugin_Strophe.NS.REPLY);
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/chat/index.js







;// CONCATENATED MODULE: ./src/headless/plugins/disco/entity.js










const { Strophe: entity_Strophe, u: entity_u } = api_public.env;

/**
 * @class
 * @namespace _converse.DiscoEntity
 * @memberOf _converse
 *
 * A Disco Entity is a JID addressable entity that can be queried for features.
 *
 * See XEP-0030: https://xmpp.org/extensions/xep-0030.html
 */
class DiscoEntity extends skeletor_esm_Model {
    get idAttribute() {
        return 'jid';
    }

    initialize(_, options) {
        super.initialize();
        this.waitUntilFeaturesDiscovered = openpromise_getOpenPromise();
        this.waitUntilItemsFetched = openpromise_getOpenPromise();

        this.dataforms = new Collection();
        let id = `converse.dataforms-${this.get('jid')}`;
        this.dataforms.storage = createStore(id, 'session');

        this.features = new Collection();
        id = `converse.features-${this.get('jid')}`;
        this.features.storage = createStore(id, 'session');
        this.listenTo(this.features, 'add', this.onFeatureAdded);

        this.fields = new Collection();
        id = `converse.fields-${this.get('jid')}`;
        this.fields.storage = createStore(id, 'session');
        this.listenTo(this.fields, 'add', this.onFieldAdded);

        this.items = new Collection();
        id = `converse.items-${this.get('jid')}`;
        this.items.storage = createStore(id, 'session');

        this.identities = new Collection();
        id = `converse.identities-${this.get('jid')}`;
        this.identities.storage = createStore(id, 'session');

        this.fetchFeatures(options);
    }

    /**
     * Returns a Promise which resolves with a map indicating
     * whether a given identity is provided by this entity.
     * @method _converse.DiscoEntity#getIdentity
     * @param {String} category - The identity category
     * @param {String} type - The identity type
     */
    async getIdentity(category, type) {
        await this.waitUntilItemsFetched;
        return this.identities.findWhere({ category, type });
    }

    /**
     * Returns a Promise which resolves with a map indicating
     * whether a given feature is supported.
     * @method _converse.DiscoEntity#getFeature
     * @param {String} feature - The feature that might be supported.
     */
    async getFeature(feature) {
        await this.waitUntilFeaturesDiscovered;
        if (this.features.findWhere({ var: feature })) {
            return this;
        }
    }

    onFeatureAdded(feature) {
        feature.entity = this;
        /**
         * Triggered when Converse has learned of a service provided by the XMPP server.
         * See XEP-0030.
         * @event _converse#serviceDiscovered
         * @type { Model }
         * @example _converse.api.listen.on('featuresDiscovered', feature => { ... });
         */
        shared_api.trigger('serviceDiscovered', feature);
    }

    onFieldAdded(field) {
        field.entity = this;
        /**
         * Triggered when Converse has learned of a disco extension field.
         * See XEP-0030.
         * @event _converse#discoExtensionFieldDiscovered
         * @example _converse.api.listen.on('discoExtensionFieldDiscovered', () => { ... });
         */
        shared_api.trigger('discoExtensionFieldDiscovered', field);
    }

    /**
     * @param {import('./types').FetchEntityFeaturesOptions} options
     */
    async fetchFeatures(options) {
        if (options.ignore_cache) {
            await this.queryInfo(options);
            return;
        }

        // If a listener has cached disco#info for this entity (e.g. the caps
        // plugin, via a verified XEP-0115 capability hash), populate from that
        // instead of querying disco#info. The `discoEntityInfoRequested` hook
        // returns null when no listener is registered or none has cached info.
        const cached = await shared_api.hook('discoEntityInfoRequested', this, null);
        if (cached?.info) {
            this.populateFromCache(cached.info);
            return;
        }

        const store_id = this.features.storage.name;

        // Checking only whether features have been cached, even though
        // there are other things that should be cached as well. We assume
        // that if features have been cached, everything else has been also.
        const result = await this.features.storage.store.getItem(store_id);
        if ((result && result.length === 0) || result === null) {
            // A listener may ask us to scope the query to a particular node
            // (e.g. the caps plugin's "node#ver", XEP-0115 § 6.2).
            await this.queryInfo(cached?.node ? { ...options, node: cached.node } : undefined);
        } else {
            await new Promise((resolve) => this.fetch({ success: resolve, error: resolve }));

            await new Promise((resolve) =>
                this.features.fetch({
                    add: true,
                    success: () => {
                        this.waitUntilFeaturesDiscovered.resolve(this);
                        this.trigger('featuresDiscovered');
                        resolve();
                    },
                    error: resolve,
                }),
            );

            await new Promise((resolve) => this.identities.fetch({ add: true, success: resolve, error: resolve }));

            const items = this.get('items');
            if (Array.isArray(items)) {
                await Promise.all(
                    items.map(/** @param {string} jid */ async (jid) => await shared_api.disco.entities.get(jid, true)),
                );
            } else {
                await this.queryForItems();
            }
            this.waitUntilItemsFetched.resolve();
        }
    }

    /**
     * Populates this entity's identities, features and fields from cached
     * disco#info data (supplied by a `discoEntityInfoRequested` listener),
     * instead of querying disco#info over the network.
     * @param {import('./types').DiscoInfoData} info
     */
    populateFromCache(info) {
        (info.identities ?? []).forEach((identity) =>
            this.identities.create({
                category: identity.category,
                type: identity.type,
                name: identity.name,
            }),
        );
        (info.features ?? []).forEach((feature) => this.features.create({ 'var': feature, 'from': this.get('jid') }));
        // Restore the flattened XEP-0128 `fields` collection (first value per
        // field, as onInfo does). The per-form `dataforms` collection is
        // deliberately NOT reconstructed: a field's `type` is not part of the
        // XEP-0115 verification string (§ 5.1), so it isn't covered by the
        // content-addressing `ver`. Two entities can share a `ver` yet report
        // different field types, so replaying a cached `type` would assert one
        // we never verified for this entity. Typed consumers (e.g. XEP-0363's
        // `{ FORM_TYPE: { value, type: 'hidden' } }` lookup) must therefore
        // query such entities directly — and they do: service components are
        // reached via disco#items, not the presence-caps path.
        (info.dataforms ?? []).forEach((fields) =>
            Object.entries(fields).forEach(([name, values]) =>
                this.fields.create({ 'var': name, 'value': values[0], 'from': this.get('jid') }),
            ),
        );
        // Cached disco#info covers identities/features/fields only (no
        // disco#items), so there are no items to wait for.
        this.waitUntilItemsFetched.resolve();
        this.waitUntilFeaturesDiscovered.resolve(this);
        this.trigger('featuresDiscovered');
    }

    /**
     * @param {import('./types').DiscoInfoOptions} [options]
     */
    async queryInfo(options) {
        let stanza;
        try {
            stanza = await shared_api.disco.info(this.get('jid'), options?.node ?? null, options);
        } catch (iq) {
            if (entity_u.isElement(iq)) {
                const e = await parseErrorStanza(iq);
                if (e.message !== 'item-not-found') {
                    src_log.error(`Error querying disco#info for ${this.get('jid')}: ${e.message}`);
                }
                this.save({ error: e.message });
                this.waitUntilFeaturesDiscovered.resolve(e);
                this.waitUntilItemsFetched.resolve(e);
            } else {
                if (iq === null) {
                    src_log.error(`Timeout for disco#info query for ${this.get('jid')}`);
                } else {
                    src_log.error(`Error querying disco#info for ${this.get('jid')}: ${iq}`);
                }
                this.waitUntilFeaturesDiscovered.resolve(iq);
                this.waitUntilItemsFetched.resolve(iq);
            }
            return;
        }
        this.onInfo(stanza);
    }

    /**
     * @param {Element} stanza
     */
    onDiscoItems(stanza) {
        const item_els = sizzle(`query[xmlns="${entity_Strophe.NS.DISCO_ITEMS}"] item`, stanza);
        const item_jids = [];
        item_els.forEach((item) => {
            if (item.getAttribute('node')) {
                // XXX: Ignore nodes for now.
                // See: https://xmpp.org/extensions/xep-0030.html#items-nodes
                return;
            }
            const jid = item.getAttribute('jid');
            let entity = shared_converse.state.disco_entities.get(jid);
            if (entity) {
                const parent_jids = entity.get('parent_jids') || [];
                entity.set({ parent_jids: [...parent_jids, this.get('jid')] });
            } else {
                entity = shared_api.disco.entities.create({
                    jid,
                    parent_jids: [this.get('jid')],
                    name: item.getAttribute('name'),
                });
            }
            item_jids.push(entity.get('jid'));
        });
        this.save({ items: item_jids });
    }

    async queryForItems() {
        if (this.identities.where({ category: 'server' }).length === 0) {
            // Don't fetch features and items if this is not a
            // server or a conference component.
            return;
        }
        const stanza = await shared_api.disco.items(this.get('jid'));
        this.onDiscoItems(stanza);
    }

    /**
     * @param {Element} stanza
     */
    async onInfo(stanza) {
        Array.from(stanza.querySelectorAll('identity')).forEach((identity) => {
            this.identities.create({
                category: identity.getAttribute('category'),
                type: identity.getAttribute('type'),
                name: identity.getAttribute('name'),
            });
        });

        sizzle(`x[type="result"][xmlns="${entity_Strophe.NS.XFORM}"]`, stanza).forEach((form) => {
            const data = {};
            sizzle('field', form).forEach((field) => {
                data[field.getAttribute('var')] = {
                    'value': field.querySelector('value')?.textContent,
                    'type': field.getAttribute('type'),
                };
            });
            this.dataforms.create(data);
        });

        if (stanza.querySelector(`feature[var="${entity_Strophe.NS.DISCO_ITEMS}"]`)) {
            await this.queryForItems();
        }
        this.waitUntilItemsFetched.resolve();

        Array.from(stanza.querySelectorAll('feature')).forEach((feature) => {
            this.features.create({
                'var': feature.getAttribute('var'),
                'from': stanza.getAttribute('from'),
            });
        });

        // XEP-0128 Service Discovery Extensions
        sizzle('x[type="result"][xmlns="jabber:x:data"] field', stanza).forEach((field) => {
            this.fields.create({
                'var': field.getAttribute('var'),
                'value': field.querySelector('value')?.textContent,
                'from': stanza.getAttribute('from'),
            });
        });

        this.waitUntilFeaturesDiscovered.resolve(this);
        this.trigger('featuresDiscovered');

        // Let listeners observe the parsed disco#info response (e.g. the caps
        // plugin verifies it against the JID's advertised XEP-0115 `ver` and
        // caches it). Fired last so it never blocks consumers of
        // `featuresDiscovered`. No-op when no listener is registered.
        await shared_api.hook('discoEntityInfoReceived', this, stanza);
    }
}

/* export default */ const plugins_disco_entity = (DiscoEntity);

;// CONCATENATED MODULE: ./src/headless/plugins/disco/entities.js




/**
 * @extends {Collection<DiscoEntity>}
 */
class DiscoEntities extends Collection {

    constructor () {
        super();
        this.model = plugins_disco_entity;
    }

    fetchEntities () {
        return new Promise((resolve, reject) => {
            this.fetch({
                add: true,
                success: resolve,
                error (_m, e) {
                    src_log.error(e);
                    reject (new Error("Could not fetch disco entities"));
                }
            });
        });
    }
}

/* export default */ const entities = (DiscoEntities);

;// CONCATENATED MODULE: ./src/headless/shared/rsm.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description XEP-0059 Result Set Management
 *   Some code taken from the Strophe RSM plugin, licensed under the MIT License
 *   Copyright 2006-2017 Strophe (https://github.com/strophe/strophejs)
 */



const { Strophe: rsm_Strophe, $build: rsm_$build } = api_public.env;

rsm_Strophe.addNamespace("RSM", "http://jabber.org/protocol/rsm");

const RSM_QUERY_PARAMETERS = ["after", "before", "index", "max"];

const rsm_toNumber = (v) => Number(v);
const rsm_toString = (v) => v.toString();

const RSM_TYPES = {
    after: rsm_toString,
    before: rsm_toString,
    count: rsm_toNumber,
    first: rsm_toString,
    index: rsm_toNumber,
    last: rsm_toString,
    max: rsm_toNumber,
};

// This array contains both query attributes and response attributes
const RSM_ATTRIBUTES = Object.keys(RSM_TYPES);

/**
 * Instances of this class are used to page through query results according to XEP-0059 Result Set Management
 * @class RSM
 */
class RSM {
    static getQueryParameters(options = {}) {
        return RSM_QUERY_PARAMETERS.reduce((result, key) => {
            if (options[key] !== undefined) {
                result[key] = options[key];
            }
            return result;
        }, {});
    }

    static parseXMLResult(set) {
        const result = {};
        for (var i = 0; i < RSM_ATTRIBUTES.length; i++) {
            const attr = RSM_ATTRIBUTES[i];
            const elem = set.getElementsByTagName(attr)[0];
            if (!isUndefined(elem) && elem !== null) {
                result[attr] = RSM_TYPES[attr](rsm_Strophe.getText(elem));
                if (attr == "first") {
                    result.index = RSM_TYPES["index"](elem.getAttribute("index"));
                }
            }
        }
        return result;
    }

    /**
     * Creates a new RSM instance
     * @param { Object } options - Configuration options
     */
    constructor(options = {}) {
        this.query = RSM.getQueryParameters(options);
        this.result = options.xml ? RSM.parseXMLResult(options.xml) : {};
    }

    /**
     * Returns a `<set>` XML element that confirms to XEP-0059 Result Set Management.
     * The element is constructed based on the RSMQueryOptions
     * that are set on this RSM instance.
     * @returns {Element}
     */
    toXML() {
        const xml = rsm_$build("set", { xmlns: rsm_Strophe.NS.RSM });
        const reducer = (xml, a) =>
            !isUndefined(this.query[a])
                ? xml
                      .c(a)
                      .t((this.query[a] || "").toString())
                      .up()
                : xml;
        return RSM_QUERY_PARAMETERS.reduce(reducer, xml).tree();
    }

    /**
     * Returns a string representation of the result-set XML
     * @returns {string}
     */
    toString() {
        return rsm_Strophe.serialize(this.toXML());
    }

    /**
     * @param {string} max
     * @param {string} before
     */
    next(max, before) {
        const options = Object.assign({}, this.query, { after: this.result.last, before, max });
        return new RSM(options);
    }

    /**
     * @param {string} max
     * @param {string} after
     */
    previous(max, after) {
        const options = Object.assign({}, this.query, { after, before: this.result.first, max });
        return new RSM(options);
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/disco/api.js







const { Stanza: api_Stanza, Strophe: api_Strophe, stx: api_stx } = api_public.env;

/* export default */ const disco_api = ({
    /**
     * @typedef {import('./entities').default} DiscoEntities
     * @typedef {import('./entity').default} DiscoEntity
     * @typedef {import('./index').DiscoState} DiscoState
     * @typedef {import('@converse/skeletor').Collection} Collection
     */

    /**
     * The XEP-0030 service discovery API
     *
     * This API lets you discover information about entities on the
     * XMPP network.
     *
     * @namespace api.disco
     * @memberOf api
     */
    disco: {
        /**
         * @namespace api.disco.stream
         * @memberOf api.disco
         */
        stream: {
            /**
             * @method api.disco.stream.getFeature
             * @param {String} name The feature name
             * @param {String} xmlns The XML namespace
             * @example _converse.api.disco.stream.getFeature('ver', 'urn:xmpp:features:rosterver')
             */
            async getFeature(name, xmlns) {
                await shared_api.waitUntil('streamFeaturesAdded');

                const stream_features = /** @type {Collection} */ (shared_converse.state.stream_features);
                if (!name || !xmlns) {
                    throw new Error('name and xmlns need to be provided when calling disco.stream.getFeature');
                }
                if (stream_features === undefined && !shared_api.connection.connected()) {
                    // Happens during tests when disco lookups happen asynchronously after teardown.
                    const msg = `Tried to get feature ${name} ${xmlns} but stream_features has been torn down`;
                    src_log.warn(msg);
                    return;
                }
                return stream_features.findWhere({ name, xmlns });
            },
        },

        /**
         * @namespace api.disco.own
         * @memberOf api.disco
         */
        own: {
            /**
             * @namespace api.disco.own.identities
             * @memberOf api.disco.own
             */
            identities: {
                /**
                 * Lets you add new identities for this client (i.e. instance of Converse)
                 * @method api.disco.own.identities.add
                 *
                 * @param {String} category - server, client, gateway, directory, etc.
                 * @param {String} type - phone, pc, web, etc.
                 * @param {String} name - "Converse"
                 * @param {String} lang - en, el, de, etc.
                 *
                 * @example _converse.api.disco.own.identities.clear();
                 */
                add(category, type, name, lang) {
                    const disco = /** @type {DiscoState} */ (shared_converse.state.disco);
                    for (var i = 0; i < disco._identities.length; i++) {
                        if (
                            disco._identities[i].category == category &&
                            disco._identities[i].type == type &&
                            disco._identities[i].name == name &&
                            disco._identities[i].lang == lang
                        ) {
                            return false;
                        }
                    }
                    disco._identities.push({ category: category, type: type, name: name, lang: lang });
                },
                /**
                 * Clears all previously registered identities.
                 * @method api.disco.own.identities.clear
                 * @example _converse.api.disco.own.identities.clear();
                 */
                clear() {
                    /** @type {DiscoState} */ shared_converse.state.disco._identities = [];
                },
                /**
                 * Returns all of the identities registered for this client
                 * (i.e. instance of Converse).
                 * @method api.disco.identities.get
                 * @example const identities = api.disco.own.identities.get();
                 */
                get() {
                    return /** @type {DiscoState} */ shared_converse.state.disco._identities;
                },
            },

            /**
             * @namespace api.disco.own.features
             * @memberOf api.disco.own
             */
            features: {
                /**
                 * Lets you register new disco features for this client (i.e. instance of Converse)
                 * @method api.disco.own.features.add
                 * @param {String} name - e.g. http://jabber.org/protocol/caps
                 * @example _converse.api.disco.own.features.add("http://jabber.org/protocol/caps");
                 */
                add(name) {
                    const disco = /** @type {DiscoState} */ (shared_converse.state.disco);
                    for (let i = 0; i < disco._features.length; i++) {
                        if (disco._features[i] == name) {
                            return false;
                        }
                    }
                    disco._features.push(name);
                },
                /**
                 * Clears all previously registered features.
                 * @method api.disco.own.features.clear
                 * @example _converse.api.disco.own.features.clear();
                 */
                clear() {
                    const disco = /** @type {DiscoState} */ (shared_converse.state.disco);
                    disco._features = [];
                },
                /**
                 * Returns all of the features registered for this client (i.e. instance of Converse).
                 * @method api.disco.own.features.get
                 * @example const features = api.disco.own.features.get();
                 */
                get() {
                    return /** @type {DiscoState} */ shared_converse.state.disco._features;
                },
            },
        },

        /**
         * Query for information about an XMPP entity
         *
         * @method api.disco.info
         * @param {string} jid The Jabber ID of the entity to query
         * @param {string} [node] A specific node identifier associated with the JID
         * @param {import('./types').DiscoInfoOptions} [options]
         * @returns {promise} Promise which resolves once we have a result from the server.
         */
        info(jid, node, options) {
            const info = api_stx`
                <iq from="${shared_api.connection.get().jid}"
                    to="${jid}"
                    type="get"
                    xmlns="jabber:client">
                    <query xmlns="${api_Strophe.NS.DISCO_INFO}"
                           ${node ? api_Stanza.unsafeXML(`node="${node}"`) : ''}>
                    </query>
                </iq>`;
            return shared_api.sendIQ(info, options?.timeout);
        },

        /**
         * Query for items associated with an XMPP entity
         *
         * @method api.disco.items
         * @param {string} jid The Jabber ID of the entity to query for items
         * @param {string} [node] A specific node identifier associated with the JID
         * @param {object} [options]
         * @param {import('../../shared/rsm').RSM|object} [options.rsm] XEP-0059 Result
         *      Set Management query options (e.g. `{ max: 100, after: '<cursor>' }`),
         *      so a caller can page through a large item set. The response's `<set>`
         *      is returned verbatim in the result stanza for the caller to read the
         *      cursor (`<last>`) and request the next page.
         * @param {number} [options.timeout]
         * @returns {promise} Promise which resolves once we have a result from the server.
         */
        items(jid, node, options) {
            const rsm = options?.rsm ? (options.rsm instanceof RSM ? options.rsm : new RSM(options.rsm)) : null;
            return shared_api.sendIQ(
                api_stx`
                    <iq from="${shared_api.connection.get().jid}"
                        to="${jid}"
                        type="get"
                        xmlns="jabber:client">
                        <query xmlns="${api_Strophe.NS.DISCO_ITEMS}"
                               ${node ? api_Stanza.unsafeXML(`node="${node}"`) : ''}>
                            ${rsm ? api_Stanza.fromString(rsm.toString()) : ''}
                        </query>
                    </iq>`,
                options?.timeout
            );
        },

        /**
         * Namespace for methods associated with disco entities
         *
         * @namespace api.disco.entities
         * @memberOf api.disco
         */
        entities: {
            /**
             * Finds the first entity advertising a given feature.
             *
             * @method api.disco.entities.find
             * @param {string} feature The feature var to search for.
             * @param {string} [jid] The entity JID whose subtree to search. If omitted, own bare JID and domain are queried.
             * @returns {Promise<DiscoEntity[]>} An array of matching DiscoEntity instances.
             */
            async find(feature, jid) {
                await shared_api.waitUntil('discoInitialized');
                const disco_entities = /** @type {DiscoEntities} */ (shared_converse.state.disco_entities);
                if (!disco_entities) return [];

                const candidates = [];
                if (jid) {
                    const entity = await shared_api.disco.entities.get(jid, true);
                    if (entity) {
                        const items = await shared_api.disco.entities.items(jid);
                        candidates.push(entity, ...items);
                    }
                } else {
                    const bare_jid = shared_converse.session.get('bare_jid');
                    const bare_entity = await shared_api.disco.entities.get(bare_jid, true);
                    if (bare_entity) candidates.push(bare_entity);

                    const domain = api_Strophe.getDomainFromJid(bare_jid);
                    const domain_entity = await shared_api.disco.entities.get(domain, true);
                    if (domain_entity) {
                        const items = await shared_api.disco.entities.items(domain);
                        candidates.push(domain_entity, ...items);
                    }
                }

                const unique = Array.from(new Map(candidates.map((e) => [e.get('jid'), e])).values());
                const checks = unique.map(async (entity) => {
                    const has = await entity.getFeature(feature);
                    return has ? entity : null;
                });
                const results = await Promise.all(checks);
                return results.filter((e) => e);
            },

            /**
             * Get the corresponding `DiscoEntity` instance.
             *
             * @method api.disco.entities.get
             * @param {string} jid The Jabber ID of the entity
             * @param {boolean} [create] Whether the entity should be created if it doesn't exist.
             * @return {Promise<DiscoEntity|DiscoEntities|undefined>}
             * @example _converse.api.disco.entities.get(jid);
             */
            async get(jid, create = false) {
                await shared_api.waitUntil('discoInitialized');
                const disco_entities = /** @type {DiscoEntities} */ (shared_converse.state.disco_entities);
                if (!jid) {
                    return disco_entities;
                }
                if (disco_entities === undefined) {
                    // Happens during tests when disco lookups happen asynchronously after teardown.
                    src_log.warn(`Tried to look up entity ${jid} but disco_entities has been torn down`);
                    return;
                }
                const entity = disco_entities.get(jid);
                if (entity || !create) {
                    return /** @type {DiscoEntity} */(entity);
                }
                return shared_api.disco.entities.create({ jid });
            },

            /**
             * Return the disco items advertised on this entity
             *
             * @method api.disco.entities.items
             * @param {string} jid - The Jabber ID of the entity for which we want to fetch items
             * @returns {Promise<DiscoEntity[]>}
             * @example api.disco.entities.items(jid);
             */
            async items(jid) {
                const entity = await shared_api.disco.entities.get(jid);
                if (entity) {
                    await entity.waitUntilItemsFetched;

                    const item_jids = entity.get('items') || [];
                    return Promise.all(item_jids.map(/** @param {string} jid */ (jid) => shared_api.disco.entities.get(jid)));
                }
                return [];
            },

            /**
             * Create a new  disco entity. It's identity and features
             * will automatically be fetched from cache or from the
             * XMPP server.
             *
             * Fetching from cache can be disabled by passing in
             * `ignore_cache: true` in the options parameter.
             *
             * @method api.disco.entities.create
             * @param {object} data
             * @param {string} data.jid - The Jabber ID of the entity
             * @param {string} data.parent_jid - The Jabber ID of the parent entity
             * @param {string} data.name
             * @param {object} [options] - Additional options
             * @param {boolean} [options.ignore_cache]
             *     If true, fetch all features from the XMPP server instead of restoring them from cache
             * @example _converse.api.disco.entities.create({ jid }, {'ignore_cache': true});
             */
            create(data, options) {
                const disco_entities = /** @type {DiscoEntities} */ (shared_converse.state.disco_entities);
                return disco_entities.create(data, options);
            },
        },

        /**
         * @namespace api.disco.features
         * @memberOf api.disco
         */
        features: {
            /**
             * Return a given feature of a disco entity
             *
             * @method api.disco.features.get
             * @param {string} feature The feature that might be
             *     supported. In the XML stanza, this is the `var`
             *     attribute of the `<feature>` element. For
             *     example: `http://jabber.org/protocol/muc`
             * @param {string} jid The JID of the entity
             *     (and its associated items) which should be queried
             * @returns {Promise<import('@converse/skeletor').Model|import('@converse/skeletor').Model[]>}
             *     A promise which resolves with a list containing
             *     _converse.Entity instances representing the entity
             *     itself or those items associated with the entity if
             *     they support the given feature.
             * @example
             * api.disco.features.get(Strophe.NS.MAM, _converse.bare_jid);
             */
            async get(feature, jid) {
                if (!jid) throw new TypeError('api.disco.features.get: You need to provide an entity JID');

                const entity = await shared_api.disco.entities.get(jid, true);

                if (shared_converse.state.disco_entities === undefined && !shared_api.connection.connected()) {
                    // Happens during tests when disco lookups happen asynchronously after teardown.
                    src_log.warn(
                        `Tried to get feature ${feature} for ${jid} but ` +
                            `_converse.disco_entities has been torn down`
                    );
                    return [];
                }

                const items = await shared_api.disco.entities.items(jid);
                const promises = [entity.getFeature(feature), ...items.map((i) => i.getFeature(feature))];
                const result = await Promise.all(promises);
                return result.filter((f) => f instanceof Object);
            },

            /**
             * Returns true if an entity with the given JID, or if one of its
             * associated items, supports a given feature.
             *
             * @method api.disco.features.has
             * @param {string} feature The feature that might be
             *     supported. In the XML stanza, this is the `var`
             *     attribute of the `<feature>` element. For
             *     example: `http://jabber.org/protocol/muc`
             * @param {string} jid The JID of the entity
             *     (and its associated items) which should be queried
             * @returns {Promise<boolean>} A promise which resolves with a boolean
             * @example
             *      api.disco.features.has(Strophe.NS.MAM, _converse.bare_jid);
             */
            async has(feature, jid) {
                if (!jid) throw new TypeError('api.disco.feature.has: You need to provide an entity JID');

                const entity = await shared_api.disco.entities.get(jid, true);
                if (!entity) {
                    src_log.warn(`api.disco.has: could not get entity for ${jid}`);
                    return false;
                }

                if (shared_converse.state.disco_entities === undefined && !shared_api.connection.connected()) {
                    // Happens during tests when disco lookups happen asynchronously after teardown.
                    src_log.warn(`Tried to check if ${jid} supports feature ${feature}`);
                    return false;
                }

                if (await entity.getFeature(feature)) {
                    return true;
                }

                const items = await shared_api.disco.entities.items(jid);
                const result = await Promise.all(items.map((i) => i.getFeature(feature)));
                return result.map((f) => f instanceof Object).includes(true);
            },
        },

        /**
         * Used to determine whether an entity supports a given feature.
         *
         * @method api.disco.supports
         * @param {string} feature The feature that might be
         *     supported. In the XML stanza, this is the `var`
         *     attribute of the `<feature>` element. For
         *     example: `http://jabber.org/protocol/muc`
         * @param {string} jid The JID of the entity
         *     (and its associated items) which should be queried
         * @returns {Promise<boolean>|boolean} A promise which resolves with `true` or `false`.
         * @example
         * if (await api.disco.supports(Strophe.NS.MAM, _converse.bare_jid)) {
         *     // The feature is supported
         * } else {
         *     // The feature is not supported
         * }
         */
        supports(feature, jid) {
            try {
                return shared_api.disco.features.has(feature, jid);
            } catch (e) {
                src_log.error(e);
                return false;
            }
        },

        /**
         * Refresh the features, fields and identities associated with a
         * disco entity by refetching them from the server
         * @method api.disco.refresh
         * @param {string} jid The JID of the entity whose features are refreshed.
         * @param {import('./types').DiscoInfoOptions} [options]
         * @returns {Promise} A promise which resolves once the features have been refreshed
         * @example
         * await api.disco.refresh('room@conference.example.org');
         */
        async refresh(jid, options) {
            if (!jid) throw new TypeError('api.disco.refresh: You need to provide an entity JID');

            await shared_api.waitUntil('discoInitialized');
            let entity = await shared_api.disco.entities.get(jid);
            if (entity) {
                entity.features.reset();
                entity.fields.reset();
                entity.identities.reset();
                if (!entity.waitUntilFeaturesDiscovered.isPending) {
                    entity.waitUntilFeaturesDiscovered = openpromise_getOpenPromise();
                }
                if (!entity.waitUntilItemsFetched.isPending) {
                    entity.waitUntilItemsFetched = openpromise_getOpenPromise();
                }
                entity.queryInfo(options);
            } else {
                // Create it if it doesn't exist
                entity = await shared_api.disco.entities.create({ jid }, { ignore_cache: true, timeout: options.timeout });
            }
            return entity.waitUntilItemsFetched;
        },

        /**
         * Return all the features associated with a disco entity
         *
         * @method api.disco.getFeatures
         * @param { string } jid The JID of the entity whose features are returned.
         * @returns {promise} A promise which resolves with the returned features
         * @example
         * const features = await api.disco.getFeatures('room@conference.example.org');
         */
        async getFeatures(jid) {
            if (!jid) throw new TypeError('api.disco.getFeatures: You need to provide an entity JID');

            await shared_api.waitUntil('discoInitialized');
            let entity = await shared_api.disco.entities.get(jid, true);
            entity = await entity.waitUntilFeaturesDiscovered;
            return entity.features;
        },

        /**
         * Return all the service discovery extensions fields
         * associated with an entity.
         *
         * See [XEP-0129: Service Discovery Extensions](https://xmpp.org/extensions/xep-0128.html)
         *
         * @method api.disco.getFields
         * @param { string } jid The JID of the entity whose fields are returned.
         * @example
         * const fields = await api.disco.getFields('room@conference.example.org');
         */
        async getFields(jid) {
            if (!jid) throw new TypeError('api.disco.getFields: You need to provide an entity JID');

            await shared_api.waitUntil('discoInitialized');
            let entity = await shared_api.disco.entities.get(jid, true);
            entity = await entity.waitUntilFeaturesDiscovered;
            return entity.fields;
        },

        /**
         * Get the identity (with the given category and type) for a given disco entity.
         *
         * For example, when determining support for PEP (personal eventing protocol), you
         * want to know whether the user's own JID has an identity with
         * `category='pubsub'` and `type='pep'` as explained in this section of
         * XEP-0163: https://xmpp.org/extensions/xep-0163.html#support
         *
         * @method api.disco.getIdentity
         * @param {string} category -The identity category.
         *     In the XML stanza, this is the `category`
         *     attribute of the `<identity>` element.
         *     For example: 'pubsub'
         * @param {string} type - The identity type.
         *     In the XML stanza, this is the `type`
         *     attribute of the `<identity>` element.
         *     For example: 'pep'
         * @param {string} jid - The JID of the entity which might have the identity
         * @returns {promise} A promise which resolves with a map indicating
         *     whether an identity with a given type is provided by the entity.
         * @example
         * api.disco.getIdentity('pubsub', 'pep', _converse.bare_jid).then(
         *     function (identity) {
         *         if (identity) {
         *             // The entity DOES have this identity
         *         } else {
         *             // The entity DOES NOT have this identity
         *         }
         *     }
         * ).catch(e => log.error(e));
         */
        async getIdentity(category, type, jid) {
            const e = await shared_api.disco.entities.get(jid, true);
            if (e === undefined && !shared_api.connection.connected()) {
                // Happens during tests when disco lookups happen asynchronously after teardown.
                const msg =
                    `Tried to look up category ${category} for ${jid} ` +
                    `but _converse.disco_entities has been torn down`;
                src_log.warn(msg);
                return;
            }
            return e.getIdentity(category, type);
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/disco/utils.js






const { Strophe: disco_utils_Strophe, Stanza: disco_utils_Stanza, stx: disco_utils_stx } = api_public.env;

/**
 * @param {Element} stanza
 */
function onDiscoInfoRequest(stanza) {
    const node = stanza.getElementsByTagName('query')[0].getAttribute('node');
    const from = stanza.getAttribute('from');
    const id = stanza.getAttribute('id');

    const result = disco_utils_stx`
        <iq type="result"
            id="${id}"
            ${from ? disco_utils_Stanza.unsafeXML(`to="${from}"`) : ''}
            xmlns="jabber:client">
            <query xmlns="${disco_utils_Strophe.NS.DISCO_INFO}"
                   ${node ? disco_utils_Stanza.unsafeXML(`node="${node}"`) : ''}>
                ${shared_converse.state.disco._identities.map((identity) => {
                    return disco_utils_stx`
                        <identity category="${identity.category}"
                            type="${identity.type}"
                            ${identity.name ? disco_utils_Stanza.unsafeXML(`name="${identity.name}"`) : ''}
                            ${identity.lang ? disco_utils_Stanza.unsafeXML(`xml:lang="${identity.lang}"`) : ''}>
                        </identity>`;
                })}
                ${shared_converse.state.disco._features.map((f) => disco_utils_stx`<feature var="${f}"></feature>`)}
            </query>
        </iq>`;
    shared_api.send(result);
    return true;
}

function addClientFeatures() {
    // See https://xmpp.org/registrar/disco-categories.html
    shared_api.disco.own.identities.add('client', 'web', 'Converse');

    shared_api.disco.own.features.add(disco_utils_Strophe.NS.CHATSTATES);
    shared_api.disco.own.features.add(disco_utils_Strophe.NS.DISCO_INFO);
    shared_api.disco.own.features.add(disco_utils_Strophe.NS.ROSTERX); // Limited support
    shared_api.disco.own.features.add(disco_utils_Strophe.NS.CARBONS);
    /**
     * Triggered in converse-disco once the core disco features of
     * Converse have been added.
     * @event _converse#addClientFeatures
     * @example _converse.api.listen.on('addClientFeatures', () => { ... });
     */
    shared_api.trigger('addClientFeatures');
    return this;
}

async function initializeDisco() {
    addClientFeatures();
    shared_api.connection.get()
        .addHandler((stanza) => onDiscoInfoRequest(stanza), disco_utils_Strophe.NS.DISCO_INFO, 'iq', 'get', null, null);

    const disco_entities = new shared_converse.exports.DiscoEntities();

    Object.assign(shared_converse, { disco_entities }); // XXX: DEPRECATED
    Object.assign(shared_converse.state, { disco_entities });

    const bare_jid = shared_converse.session.get('bare_jid');
    const id = `converse.disco-entities-${bare_jid}`;

    disco_entities.storage = createStore(id, 'session');
    const collection = await disco_entities.fetchEntities();

    const domain = shared_converse.session.get('domain');

    if (collection.length === 0 || !collection.get(domain)) {
        // If we don't have an entity for our own XMPP server, create one.
        shared_api.disco.entities.create({ 'jid': domain }, { 'ignore_cache': true });
    }
    /**
     * Triggered once the `converse-disco` plugin has been initialized and the
     * `_converse.disco_entities` collection will be available and populated with at
     * least the service discovery features of the user's own server.
     * @event _converse#discoInitialized
     * @example _converse.api.listen.on('discoInitialized', () => { ... });
     */
    shared_api.trigger('discoInitialized');
}

function initStreamFeatures() {
    // Initialize the stream_features collection, and if we're
    // re-attaching to a pre-existing BOSH session, we restore the
    // features from cache.
    // Otherwise the features will be created once we've received them
    // from the server (see populateStreamFeatures).
    if (!shared_converse.state.stream_features) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `converse.stream-features-${bare_jid}`;
        shared_api.promises.add('streamFeaturesAdded');

        const stream_features = new Collection();
        stream_features.storage = createStore(id, 'session');
        Object.assign(shared_converse, { stream_features }); // XXX: DEPRECATED
        Object.assign(shared_converse.state, { stream_features });
    }
}

function notifyStreamFeaturesAdded() {
    /**
     * Triggered as soon as the stream features are known.
     * If you want to check whether a stream feature is supported before proceeding,
     * then you'll first want to wait for this event.
     * @event _converse#streamFeaturesAdded
     * @example _converse.api.listen.on('streamFeaturesAdded', () => { ... });
     */
    shared_api.trigger('streamFeaturesAdded');
}

function populateStreamFeatures() {
    // Strophe.js sets the <stream:features> element on the
    // Strophe.Connection instance.
    //
    // Once this is we populate the stream_features collection
    // and trigger streamFeaturesAdded.
    initStreamFeatures();
    Array.from(shared_api.connection.get().features.childNodes).forEach((feature) => {
        shared_converse.state.stream_features.create({
            'name': feature.nodeName,
            'xmlns': feature.getAttribute('xmlns'),
        });
    });
    notifyStreamFeaturesAdded();
}

function utils_clearSession() {
    const { disco_entities } = shared_converse.state;
    disco_entities?.forEach((e) => e.features.clearStore());
    disco_entities?.forEach((e) => e.identities.clearStore());
    disco_entities?.forEach((e) => e.dataforms.clearStore());
    disco_entities?.forEach((e) => e.fields.clearStore());
    disco_entities?.clearStore();
    delete shared_converse.state.disco_entities;
    Object.assign(shared_converse, { disco_entities: undefined });
}

;// CONCATENATED MODULE: ./src/headless/plugins/disco/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Converse plugin which add support for XEP-0030: Service Discovery
 */








const { Strophe: disco_Strophe } = api_public.env;

/**
 * @typedef {Object} DiscoState
 * @property {Array} _identities
 * @property {Array} _features
 */

api_public.plugins.add('converse-disco', {
    initialize() {
        Object.assign(shared_api, disco_api);

        shared_api.promises.add('discoInitialized');
        shared_api.promises.add('streamFeaturesAdded');

        const exports = { DiscoEntity: plugins_disco_entity, DiscoEntities: entities };

        Object.assign(shared_converse, exports); // XXX: DEPRECATED
        Object.assign(shared_converse.exports, exports);

        const disco = {
            _identities: [],
            _features: [],
        };
        Object.assign(shared_converse, { disco }); // XXX: DEPRECATED
        Object.assign(shared_converse.state, { disco });

        shared_api.listen.on('userSessionInitialized', async () => {
            initStreamFeatures();
            if (shared_converse.state.connfeedback.get('connection_status') === disco_Strophe.Status.ATTACHED) {
                // When re-attaching to a BOSH session, we fetch the stream features from the cache.
                await new Promise((success, error) => shared_converse.state.stream_features.fetch({ success, error }));
                notifyStreamFeaturesAdded();
            }
        });
        shared_api.listen.on('beforeResourceBinding', populateStreamFeatures);
        // A resumed XEP-0198 stream skips resource binding
        shared_api.listen.on('streamResumed', populateStreamFeatures);

        shared_api.listen.on('reconnected', initializeDisco);
        shared_api.listen.on('connected', initializeDisco);

        shared_api.listen.on('beforeTearDown', async () => {
            shared_api.promises.add('streamFeaturesAdded');
            shared_api.promises.add('discoInitialized');

            const { stream_features } = shared_converse.state;
            if (stream_features) {
                await stream_features.clearStore();
                delete shared_converse.state.stream_features;
                Object.assign(shared_converse, { stream_features: undefined }); // XXX: DEPRECATED
            }
        });

        // All disco entities stored in the cache and are refetched
        // upon login or reconnection and then stored with new ids, so to
        // avoid the cache from filling up, we remove them.
        shared_api.listen.on('will-reconnect', utils_clearSession);
        shared_api.listen.on('clearSession', utils_clearSession);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/muc/affiliations/api.js
/**
 * @module:plugin-muc-affiliations-api
 * @typedef {module:plugin-muc-parsers.MemberListItem} MemberListItem
 */


/* export default */ const affiliations_api = ({
    /**
     * The "affiliations" namespace groups methods relevant to setting and
     * getting MUC affiliations.
     *
     * @namespace api.rooms.affiliations
     * @memberOf api.rooms
     */
    affiliations: {
        /**
         * Set the given affiliation for the given JIDs in the specified MUCs
         * @typedef {Object} User
         * @property {string} User.jid - The JID of the user whose affiliation will change
         * @property {Array} User.affiliation - The new affiliation for this user
         * @property {string} [User.reason] - An optional reason for the affiliation change
         *
         * @param {String|Array<String>} muc_jids - The JIDs of the MUCs in
         *  which the affiliation should be set.
         * @param {User[]} users - An array of objects representing users
         *  for whom the affiliation is to be set.
         * @returns {Promise}
         *
         * @example
         *  api.rooms.affiliations.set(
         *      [
         *          'muc1@muc.example.org',
         *          'muc2@muc.example.org'
         *      ], [
         *          {
         *              'jid': 'user@example.org',
         *              'affiliation': 'member',
         *              'reason': "You're one of us now!"
         *          }
         *      ]
         *  )
         */
        set (muc_jids, users) {
            users = !Array.isArray(users) ? [users] : users;
            muc_jids = !Array.isArray(muc_jids) ? [muc_jids] : muc_jids;
            return setAffiliations(muc_jids, users);
        },

        /**
         * Returns an array of {@link MemberListItem} objects, representing occupants
         * that have the given affiliation.
         * @typedef {("admin"|"owner"|"member")} NonOutcastAffiliation
         * @param {NonOutcastAffiliation} affiliation
         * @param {string} jid - The JID of the MUC for which the affiliation list should be fetched
         * @returns {Promise<MemberListItem[]|Error>}
         */
        get (affiliation, jid) {
            return getAffiliationList(affiliation, jid);
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/muc/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Implements the core logic for XEP-0045 Multi-User Chat
 */



















api_public.AFFILIATION_CHANGES = AFFILIATION_CHANGES;
api_public.AFFILIATION_CHANGES_LIST = AFFILIATION_CHANGES_LIST;
api_public.MUC_TRAFFIC_STATES = MUC_TRAFFIC_STATES;
api_public.MUC_TRAFFIC_STATES_LIST = MUC_TRAFFIC_STATES_LIST;
api_public.MUC_ROLE_CHANGES = MUC_ROLE_CHANGES;
api_public.MUC_ROLE_CHANGES_LIST = MUC_ROLE_CHANGES_LIST;

api_public.MUC = { INFO_CODES: INFO_CODES };

api_public.MUC_NICK_CHANGED_CODE = MUC_NICK_CHANGED_CODE;
api_public.ROOM_FEATURES = ROOM_FEATURES;
api_public.ROOMSTATUS = ROOMSTATUS;

const { Strophe: muc_plugin_Strophe } = api_public.env;

// Add Strophe Namespaces
muc_plugin_Strophe.addNamespace('MUC_ADMIN', muc_plugin_Strophe.NS.MUC + '#admin');
muc_plugin_Strophe.addNamespace('MUC_OWNER', muc_plugin_Strophe.NS.MUC + '#owner');
muc_plugin_Strophe.addNamespace('MUC_REGISTER', 'jabber:iq:register');
muc_plugin_Strophe.addNamespace('MUC_ROOMCONF', muc_plugin_Strophe.NS.MUC + '#roomconfig');
muc_plugin_Strophe.addNamespace('MUC_USER', muc_plugin_Strophe.NS.MUC + '#user');
muc_plugin_Strophe.addNamespace('MUC_HATS', 'urn:xmpp:hats:0');
muc_plugin_Strophe.addNamespace('CONFINFO', 'urn:ietf:params:xml:ns:conference-info');

api_public.plugins.add('converse-muc', {
    dependencies: ['converse-chatboxes', 'converse-chat', 'converse-disco'],

    initialize() {
        /* The initialize function gets called as soon as the plugin is
         * loaded by converse.js's plugin machinery.
         */
        const { __, ___ } = shared_converse;

        // Configuration values for this plugin
        // ====================================
        // Refer to docs/source/configuration.rst for explanations of these
        // configuration settings.
        shared_api.settings.extend({
            allow_muc_invitations: true,
            auto_join_on_invite: false,
            auto_join_rooms: [],
            auto_register_muc_nickname: true,
            colorize_username: false,
            hide_muc_participants: false,
            locked_muc_domain: false,
            modtools_disable_assign: false,
            muc_clear_messages_on_leave: true,
            muc_domain: undefined,
            muc_fetch_members: true,
            muc_history_max_stanzas: undefined,
            muc_instant_rooms: true,
            muc_nickname_from_jid: false,
            muc_send_probes: false,
            muc_show_info_messages: [
                ...api_public.MUC.INFO_CODES.visibility_changes,
                ...api_public.MUC.INFO_CODES.self,
                ...api_public.MUC.INFO_CODES.non_privacy_changes,
                ...api_public.MUC.INFO_CODES.muc_logging_changes,
                ...api_public.MUC.INFO_CODES.nickname_changes,
                ...api_public.MUC.INFO_CODES.disconnected,
                ...api_public.MUC.INFO_CODES.affiliation_changes,
                ...api_public.MUC.INFO_CODES.join_leave_events,
                ...api_public.MUC.INFO_CODES.role_changes,
            ],
            muc_show_logs_before_join: false,
            muc_subscribe_to_rai: false,
        });
        shared_api.promises.add(['roomsAutoJoined']);

        if (shared_api.settings.get('locked_muc_domain') && typeof shared_api.settings.get('muc_domain') !== 'string') {
            throw new Error(
                'Config Error: it makes no sense to set locked_muc_domain ' + 'to true when muc_domain is not set',
            );
        }

        // This is for tests (at least until we can import modules inside tests)
        api_public.env.muc_utils = { computeAffiliationsDelta: computeAffiliationsDelta };
        Object.assign(shared_api, muc_api);
        Object.assign(shared_api.rooms, affiliations_api);

        /**
         * https://xmpp.org/extensions/xep-0045.html
         * -----------------------------------------
         */
        const STATUS_CODE_MESSAGES = {
            '100': __('This groupchat is not anonymous'),
            '102': __('This groupchat now shows unavailable members'),
            '103': __('This groupchat does not show unavailable members'),
            '104': __('The groupchat configuration has changed'),
            '170': __('Groupchat logging is now enabled'),
            '171': __('Groupchat logging is now disabled'),
            '172': __('This groupchat is now no longer anonymous'),
            '173': __('This groupchat is now semi-anonymous'),
            '174': __('This groupchat is now fully-anonymous'),
            '201': __('A new groupchat has been created'),
            // XXX: Note the triple underscore function and not double underscore.
            '210': ___('Your nickname has been automatically set to %1$s'),
            '301': __('You have been banned from this groupchat'),
            // XXX: Note the triple underscore function and not double underscore.
            '303': ___('Your nickname has been changed to %1$s'),
            '307': __('You have been kicked from this groupchat'),
            '321': __('You have been removed from this groupchat because of an affiliation change'),
            '322': __(
                "You have been removed from this groupchat because it has changed to members-only and you're not a member",
            ),
            '332': __('You have been removed from this groupchat because the service hosting it is being shut down'),
            '333': __('You have exited this groupchat due to a technical problem'),
        };
        const labels = { muc: { STATUS_CODE_MESSAGES } };
        Object.assign(shared_converse.labels, labels);
        Object.assign(shared_converse, labels); // XXX DEPRECATED

        routeToRoom();
        addRouteListener(routeToRoom);

        // TODO: DEPRECATED
        const legacy_exports = {
            ChatRoom: muc_muc,
            ChatRoomMessage: muc_message,
            ChatRoomMessages: muc_messages,
            ChatRoomOccupant: muc_occupant,
            ChatRoomOccupants: muc_occupants,
        };
        Object.assign(shared_converse, legacy_exports);

        const exports = {
            MUC: muc_muc,
            MUCMessage: muc_message,
            MUCMessages: muc_messages,
            MUCOccupant: muc_occupant,
            MUCOccupants: muc_occupants,
            getDefaultMUCNickname: getDefaultMUCNickname,
            isInfoVisible: isInfoVisible,
            onDirectMUCInvitation: onDirectMUCInvitation,
        };
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_converse, exports); // XXX DEPRECATED

        /** @type {module:shared-api.APIEndpoint} */ shared_api.chatboxes.registry.add(CHATROOMS_TYPE, muc_muc);

        if (shared_api.settings.get('allow_muc_invitations')) {
            shared_api.listen.on('connected', registerDirectInvitationHandler);
            shared_api.listen.on('reconnected', registerDirectInvitationHandler);
        }

        shared_api.listen.on('getDuplicateMessageQueries', getMUCDuplicateMessageQueries);

        shared_api.listen.on('addClientFeatures', () => shared_api.disco.own.features.add(`${muc_plugin_Strophe.NS.CONFINFO}+notify`));
        shared_api.listen.on('addClientFeatures', onAddClientFeatures);
        shared_api.listen.on('beforeTearDown', onBeforeTearDown);
        shared_api.listen.on('chatBoxesFetched', autoJoinRooms);
        shared_api.listen.on('disconnected', disconnectChatRooms);
        shared_api.listen.on('statusInitialized', onStatusInitialized);
        shared_api.listen.on('parsePresence', onParsePresence);

        // A resumed XEP-0198 stream skips resource binding
        shared_api.listen.on('streamResumed', onBeforeResourceBinding);
        shared_api.listen.on('beforeResourceBinding', onBeforeResourceBinding);

        addVisibilityListener(onWindowStateChanged);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/muc/index.js










Object.assign(headless_utils, { muc: { isChatRoom: isChatRoom, setAffiliation: setAffiliation, getDefaultMUCService: getDefaultMUCService }});



;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/utils.js





const { u: bookmarks_utils_u } = api_public.env;

/**
 * @returns {import('shared/types').StorageKeys}
 */
function getStorageKeys() {
    const { session } = shared_converse;
    const storage_key = `converse.room-bookmarks.${session.get('bare_jid')}`;
    const fetched_flag_key = `${storage_key}-fetched`;
    return { storage_key, fetched_flag_key };
}

/**
 * @param {string} jid - The JID of the bookmark.
 * @returns {string|null} The nickname if found, otherwise null.
 */
function getNicknameFromBookmark(jid) {
    if (!shared_api.settings.get('allow_bookmarks')) {
        return null;
    }
    return shared_converse.state.bookmarks?.get(jid)?.get('nick');
}

/**
 * @param {import('../chat/message')} message
 * @returns {true}
 */
function handleBookmarksPush(message) {
    shared_api.waitUntil('bookmarksInitialized')
        .then(() => shared_converse.state.bookmarks.setBookmarksFromStanza(message))
        .catch(/** @param {Error} e */ (e) => src_log.fatal(e));
    return true;
}


Object.assign(bookmarks_utils_u, {
    bookmarks: {
        getStorageKeys,
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/collection.js
/**
 * @typedef {import('../muc/muc.js').default} MUC
 */















const { Strophe: collection_Strophe, stx: collection_stx } = api_public.env;

/**
 * @extends {Collection<Bookmark>}
 */
class Bookmarks extends Collection {
    get idAttribute() {
        return 'jid';
    }

    constructor() {
        super([], { comparator: (/** @type {Bookmark} */ b) => b.getDisplayName().toLowerCase() });
        this.model = bookmarks_model;
    }

    async initialize() {
        this.on('add', (bm) =>
            this.openBookmarkedRoom(bm)
                .then((bm) => this.markRoomAsBookmarked(bm))
                .catch((e) => src_log.fatal(e)),
        );
        this.on('change:autojoin', this.onAutoJoinChanged, this);
        this.on(
            'remove',
            /** @param { Bookmark } bookmark }*/ (bookmark) => {
                this.sendRemoveBookmarkStanza(bookmark);
                this.leaveRoom(bookmark);
            },
        );

        const { storage_key, fetched_flag_key } = getStorageKeys();
        this.fetched_flag = fetched_flag_key;
        initStorage(this, storage_key);

        await this.fetchBookmarks();

        /**
         * Triggered once the {@link Bookmarks} collection
         * has been created and cached bookmarks have been fetched.
         * @event _converse#bookmarksInitialized
         * @type {Bookmarks}
         * @example _converse.api.listen.on('bookmarksInitialized', (bookmarks) => { ... });
         */
        shared_api.trigger('bookmarksInitialized', this);
    }

    static async checkBookmarksSupport() {
        const bare_jid = shared_converse.session.get('bare_jid');
        if (!bare_jid) return false;

        const identity = await shared_api.disco.getIdentity('pubsub', 'pep', bare_jid);
        if (shared_api.settings.get('allow_public_bookmarks')) {
            return !!identity;
        } else {
            return shared_api.disco.supports(collection_Strophe.NS.PUBSUB + '#publish-options', bare_jid);
        }
    }

    /**
     * @param {Bookmark} bookmark
     */
    async openBookmarkedRoom(bookmark) {
        if (shared_api.settings.get('muc_respect_autojoin') && bookmark.get('autojoin')) {
            const groupchat = await shared_api.rooms.create(bookmark.get('jid'), {
                nick: bookmark.get('nick'),
                password: bookmark.get('password'),
            });
            groupchat.maybeShow();
        }
        return bookmark;
    }

    fetchBookmarks() {
        const deferred = openpromise_getOpenPromise();
        if (shared_converse.state.session.get(this.fetched_flag)) {
            this.fetch({
                success: () => deferred.resolve(),
                error: () => deferred.resolve(),
            });
        } else {
            this.fetchBookmarksFromServer(deferred);
        }
        return deferred;
    }

    /**
     * @param {import('./types').BookmarkAttrs} attrs
     * @param {boolean} [create=true]
     * @param {import('@converse/skeletor').FetchOrCreateOptions} [options]
     */
    async setBookmark(attrs, create = true, options = {}) {
        if (!attrs.jid) return src_log.warn('No JID provided for setBookmark');

        let send_stanza = false;

        let bookmark = this.get(attrs.jid);
        if (bookmark) {
            // Check if any attrs changed
            const has_changed = Object.keys(attrs).reduce((result, k) => {
                return result || (attrs[k] ?? '') !== (bookmark.attributes[k] ?? '');
            }, false);
            if (has_changed) {
                bookmark.save(attrs, options);
                send_stanza = true;
            }
        } else if (create) {
            bookmark = await this.create(attrs, options);
            send_stanza = true;
        }

        if (bookmark && send_stanza) {
            this.sendBookmarkStanza(bookmark).catch((iq) => this.onBookmarkError(iq));
        }
    }

    /**
     * @param {Bookmark} bookmark
     * @returns {Promise<void|Element>}
     */
    async sendRemoveBookmarkStanza(bookmark) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const node = (await shared_api.disco.supports(`${collection_Strophe.NS.BOOKMARKS2}#compat`, bare_jid))
            ? collection_Strophe.NS.BOOKMARKS2
            : collection_Strophe.NS.BOOKMARKS;

        if (node === collection_Strophe.NS.BOOKMARKS2) {
            return shared_api.pubsub.retract(bare_jid, node, bookmark.get('jid'), { notify: true });
        } else {
            return this.sendBookmarkStanza().catch((iq) => this.onBookmarkError(iq));
        }
    }

    /**
     * @param {'urn:xmpp:bookmarks:1'|'storage:bookmarks'} node
     * @param {Bookmark} [bookmark]
     * @returns {Stanza|Stanza[]}
     */
    getPublishedItems(node, bookmark) {
        if (node === collection_Strophe.NS.BOOKMARKS2) {
            if (!bookmark) throw new Error('getPublishedItems: missing bookmark');

            const extensions = bookmark.get('extensions') ?? [];
            return collection_stx`<item id="${bookmark.get('jid')}">
                        <conference xmlns="${collection_Strophe.NS.BOOKMARKS2}"
                                name="${bookmark.get('name') || A}"
                                autojoin="${bookmark.get('autojoin')}">
                            ${bookmark.get('nick') ? collection_stx`<nick>${bookmark.get('nick')}</nick>` : ''}
                            ${bookmark.get('password') ? collection_stx`<password>${bookmark.get('password')}</password>` : ''}
                        ${
                            extensions.length
                                ? collection_stx`<extensions>${extensions.map((e) => Stanza.fromString(e))}</extensions>`
                                : ''
                        }
                        </conference>
                    </item>`;
        } else {
            return collection_stx`<item id="current">
                <storage xmlns="${collection_Strophe.NS.BOOKMARKS}">
                ${this.map(
                    /** @param {MUC} model */ (model) =>
                        collection_stx`<conference name="${model.get('name')}" autojoin="${model.get('autojoin')}"
                        jid="${model.get('jid')}">
                        ${model.get('nick') ? collection_stx`<nick>${model.get('nick')}</nick>` : ''}
                        ${model.get('password') ? collection_stx`<password>${model.get('password')}</password>` : ''}
                    </conference>`,
                )}
                </storage>
            </item>`;
        }
    }

    /**
     * @param {Bookmark} [bookmark]
     * @returns {Promise<void|Element>}
     */
    async sendBookmarkStanza(bookmark) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const node = (await shared_api.disco.supports(`${collection_Strophe.NS.BOOKMARKS2}#compat`, bare_jid))
            ? collection_Strophe.NS.BOOKMARKS2
            : collection_Strophe.NS.BOOKMARKS;
        const supports_max = await shared_api.disco.supports(`${collection_Strophe.NS.PUBSUB}#config-node-max`, bare_jid);
        return shared_api.pubsub.publish(null, node, this.getPublishedItems(node, bookmark), {
            persist_items: true,
            max_items: supports_max ? 'max' : 9999,
            send_last_published_item: 'never',
            access_model: 'whitelist',
        });
    }

    /**
     * @param {Element} iq
     */
    onBookmarkError(iq) {
        src_log.error('Error while trying to update bookmarks');
        src_log.error(iq);
    }

    /**
     * @param {Promise} deferred
     */
    async fetchBookmarksFromServer(deferred) {
        const bare_jid = shared_converse.session.get('bare_jid');
        const ns = (await shared_api.disco.supports(`${collection_Strophe.NS.BOOKMARKS2}#compat`, bare_jid))
            ? collection_Strophe.NS.BOOKMARKS2
            : collection_Strophe.NS.BOOKMARKS;

        const stanza = collection_stx`
            <iq type="get" from="${shared_api.connection.get().jid}" xmlns="jabber:client">
                <pubsub xmlns="${collection_Strophe.NS.PUBSUB}">
                    <items node="${ns}"/>
                </pubsub>
            </iq>`;
        shared_api.sendIQ(stanza)
            .then(/** @param {Element} iq */ (iq) => this.onBookmarksReceived(deferred, iq))
            .catch(/** @param {Element} iq */ (iq) => this.onBookmarksReceivedError(deferred, iq));
    }

    /**
     * @param {Bookmark} bookmark
     */
    markRoomAsBookmarked(bookmark) {
        const { chatboxes } = shared_converse.state;
        const groupchat = chatboxes.get(bookmark.get('jid'));
        groupchat?.save('bookmarked', true);
    }

    /**
     * @param {Bookmark} bookmark
     */
    onAutoJoinChanged(bookmark) {
        if (bookmark.get('autojoin')) {
            this.openBookmarkedRoom(bookmark);
        } else {
            this.leaveRoom(bookmark);
        }
    }

    /**
     * @param {Bookmark} bookmark
     */
    async leaveRoom(bookmark) {
        const groupchat = await shared_api.rooms.get(bookmark.get('jid'));
        groupchat?.close();
    }

    /**
     * @param {Element} stanza
     */
    async setBookmarksFromStanza(stanza) {
        const bookmarks = await parseStanzaForBookmarks(stanza);
        bookmarks.forEach(
            /** @param {import('./types.js').BookmarkAttrs} attrs */
            (attrs) => {
                const bookmark = this.get(attrs.jid);
                bookmark ? bookmark.save(attrs) : this.create(attrs);
            },
        );
    }

    /**
     * @param {Object} deferred
     * @param {Element} iq
     */
    async onBookmarksReceived(deferred, iq) {
        await this.setBookmarksFromStanza(iq);
        shared_converse.state.session.set(this.fetched_flag, true);
        if (deferred !== undefined) {
            return deferred.resolve();
        }
    }

    /**
     * @param {Object} deferred
     * @param {Element} iq
     */
    async onBookmarksReceivedError(deferred, iq) {
        if (iq === null) {
            const { __ } = shared_converse;
            src_log.error('Error: timeout while fetching bookmarks');
            shared_api.alert('error', __('Timeout Error'), [
                __(
                    'The server did not return your bookmarks within the allowed time. ' +
                        'You can reload the page to request them again.',
                ),
            ]);
            deferred?.reject(new Error('Could not fetch bookmarks'));
        } else {
            const { errors } = api_public.env;
            const e = await parseErrorStanza(iq);
            if (e instanceof errors.ItemNotFoundError) {
                // Not an exception, the user simply doesn't have any bookmarks.
                shared_converse.state.session.set(this.fetched_flag, true);
                deferred?.resolve();
            } else {
                src_log.error('Error while fetching bookmarks');
                if (iq) src_log.error(iq);
                deferred?.reject(new Error('Could not fetch bookmarks'));
            }
        }
    }

    async getUnopenedBookmarks() {
        await shared_api.waitUntil('bookmarksInitialized');
        await shared_api.waitUntil('chatBoxesFetched');
        const { chatboxes } = shared_converse.state;
        return this.filter((b) => !chatboxes.get(b.get('jid')));
    }
}

/* export default */ const bookmarks_collection = (Bookmarks);

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/api.js



const { waitUntil: bookmarks_api_waitUntil } = api_promise;

/**
 * Groups methods relevant to XEP-0402 (and XEP-0048) MUC bookmarks.
 * @namespace api.bookmarks
 * @memberOf api
 */
const api_bookmarks = {
    /**
     * Calling this function will result in an IQ stanza being sent out to set
     * the bookmark on the server.
     *
     * @method api.bookmarks.set
     * @param {import('./types').BookmarkAttrs} attrs - The room attributes
     * @param {boolean} [create=true] - Whether the bookmark should be created if it doesn't exist
     * @param {object} [options] - Skeletor set/add options
     * @returns {Promise<import('./model').default>}
     */
    async set(attrs, create = true, options = {}) {
        const bookmarks = await bookmarks_api_waitUntil('bookmarksInitialized');
        return bookmarks.setBookmark(attrs, create, options);
    },

    /**
     * @method api.bookmarks.get
     * @param {string} jid - The JID of the bookmark to return.
     * @returns {Promise<import('./model').default|undefined>}
     */
    async get(jid) {
        const bookmarks = await bookmarks_api_waitUntil('bookmarksInitialized');
        return bookmarks.get(jid);
    },
};

const bookmarks_api = { bookmarks: api_bookmarks };

/* export default */ const plugins_bookmarks_api = (bookmarks_api);

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/plugin.js
/**
 * @copyright 2025, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */










const { Strophe: bookmarks_plugin_Strophe } = api_public.env;

bookmarks_plugin_Strophe.addNamespace('BOOKMARKS', 'storage:bookmarks');
bookmarks_plugin_Strophe.addNamespace('BOOKMARKS2', 'urn:xmpp:bookmarks:1');

api_public.plugins.add('converse-bookmarks', {
    dependencies: ['converse-chatboxes', 'converse-muc', 'converse-pubsub'],

    initialize() {
        // Configuration values for this plugin
        // ====================================
        // Refer to docs/source/configuration.rst for explanations of these
        // configuration settings.
        shared_api.settings.extend({
            allow_bookmarks: true,
            allow_public_bookmarks: false,
            muc_respect_autojoin: true,
        });

        shared_api.promises.add('bookmarksInitialized');

        Object.assign(shared_api, plugins_bookmarks_api);

        const exports = { Bookmark: bookmarks_model, Bookmarks: bookmarks_collection };
        Object.assign(shared_converse, exports); // TODO: DEPRECATED
        Object.assign(shared_converse.exports, exports);

        shared_api.listen.on(
            'getNicknameForMUC',
            /**
             * @param {import('../muc/muc').default} muc
             * @param {string|null} nick
             * @returns {string}
             */
            (muc, nick) => {
                return nick || getNicknameFromBookmark(muc.get('jid'));
            },
        );

        shared_api.listen.on(
            'parseMUCPresence',
            /**
             * @param {Element} _stanza
             * @param {import('../muc/types').MUCPresenceAttributes} attrs
             */
            (_stanza, attrs) => {
                if (attrs.is_self && attrs.codes.includes('303')) {
                    shared_api.bookmarks.get(attrs.muc_jid).then(
                        /** @param {Bookmark} bookmark */ (bookmark) => {
                            if (!bookmark) src_log.warn('parseMUCPresence: no bookmark returned');

                            const { nick, muc_jid: jid } = attrs;
                            shared_api.bookmarks.set({
                                jid,
                                nick,
                                autojoin: bookmark?.get('autojoin') ?? true,
                                password: bookmark?.get('password') ?? '',
                                name: bookmark?.get('name') ?? '',
                                extensions: bookmark?.get('extensions') ?? [],
                            });
                        },
                    );
                }
                return attrs;
            },
        );

        shared_api.listen.on(
            'enteredNewRoom',
            /** @param {import('../muc/muc').default} muc */
            async ({ attributes }) => {
                const { jid, nick, password, name } = /** @type {import("../muc/types").MUCAttributes} */ (attributes);
                await shared_api.bookmarks.set({
                    jid,
                    autojoin: true,
                    nick,
                    ...(password ? { password } : {}),
                    ...(name ? { name } : {}),
                });
            },
        );

        shared_api.listen.on(
            'leaveRoom',
            /** @param {import('../muc/muc').default} muc */
            async ({ attributes }) => {
                const { jid } = /** @type {import("../muc/types").MUCAttributes} */ (attributes);
                await shared_api.bookmarks.set(
                    {
                        jid,
                        autojoin: false,
                    },
                    false,
                    // Don't trigger a Skeletor `change` event.
                    // This MUC is being left explicitly by the user,
                    // so we don't want to trigger the `onAutoJoinChanged`
                    // listener in ./collection.js to again call `close()`
                    // on the MUC.
                    {
                        silent: true,
                    },
                );
            },
        );

        shared_api.listen.on('addClientFeatures', () => {
            if (shared_api.settings.get('allow_bookmarks')) {
                shared_api.disco.own.features.add(bookmarks_plugin_Strophe.NS.BOOKMARKS + '+notify');
            }
        });

        shared_api.listen.on('clearSession', () => {
            const { state } = shared_converse;
            if (state.bookmarks) {
                state.bookmarks.clearStore({ silent: true });
                const { fetched_flag_key } = getStorageKeys();
                shared_converse.state.session.set(fetched_flag_key, undefined);
                delete state.bookmarks;
            }
        });

        shared_api.listen.on('connected', async () => {
            if (!shared_api.settings.get('allow_bookmarks')) return;

            // Add a handler for bookmarks pushed from other connected clients
            const bare_jid = shared_converse.session.get('bare_jid');
            const connection = shared_api.connection.get();
            connection.addHandler(handleBookmarksPush, bookmarks_plugin_Strophe.NS.BOOKMARKS, 'message', 'headline', null, bare_jid);
            connection.addHandler(handleBookmarksPush, bookmarks_plugin_Strophe.NS.BOOKMARKS2, 'message', 'headline', null, bare_jid);
            await Promise.all([shared_api.waitUntil('chatBoxesFetched')]);

            if (await bookmarks_collection.checkBookmarksSupport()) {
                shared_converse.state.bookmarks = new shared_converse.exports.Bookmarks();
                Object.assign(shared_converse, { bookmarks: shared_converse.state.bookmarks }); // TODO: DEPRECATED
            }
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/bookmarks/index.js






;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/model.js



const { Strophe: blocklist_model_Strophe } = api_public.env;

class BlockedEntity extends skeletor_esm_Model {
    get idAttribute () {
        return 'jid';
    }

    getDisplayName () {
        return blocklist_model_Strophe.xmlunescape(this.get('name'));
    }
}

/* export default */ const blocklist_model = (BlockedEntity);

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/collection.js









const { stx: blocklist_collection_stx, u: collection_u } = api_public.env;

/**
 * @extends {Collection<BlockedEntity>}
 */
class Blocklist extends Collection {
    get idAttribute() {
        return 'jid';
    }

    constructor() {
        super();
        this.model = blocklist_model;
    }

    async initialize() {
        const { session } = shared_converse;
        const cache_key = `converse.blocklist-${session.get('bare_jid')}`;
        this.fetched_flag = `${cache_key}-fetched`;
        initStorage(this, cache_key);

        this.on('add', this.rejectContactRequest);

        await this.fetchBlocklist();

        /**
         * Triggered once the {@link Blocklist} collection
         * has been created and cached blocklist have been fetched.
         * @event _converse#blocklistInitialized
         * @type {Blocklist}
         * @example _converse.api.listen.on('blocklistInitialized', (blocklist) => { ... });
         */
        shared_api.trigger('blocklistInitialized', this);
    }

    /**
     * @param {BlockedEntity} item
     */
    async rejectContactRequest(item) {
        const roster = await shared_api.waitUntil('rosterContactsFetched');
        const contact = roster.get(item.get('jid'));
        if (contact?.get('requesting')) {
            const chat = await shared_api.chats.get(contact.get('jid'));
            chat?.close();
            contact.unauthorize().destroy();
        }
    }

    fetchBlocklist() {
        const deferred = openpromise_getOpenPromise();
        if (shared_converse.state.session.get(this.fetched_flag)) {
            this.fetch({
                success: () => deferred.resolve(),
                error: () => deferred.resolve(),
            });
        } else {
            this.fetchBlocklistFromServer(deferred);
        }
        return deferred;
    }

    /**
     * @param {Object} deferred
     */
    async fetchBlocklistFromServer(deferred) {
        const stanza = blocklist_collection_stx`<iq xmlns="jabber:client"
            type="get"
            id="${collection_u.getUniqueId()}"><blocklist xmlns="urn:xmpp:blocking"/></iq>`;

        try {
            this.onBlocklistReceived(deferred, await shared_api.sendIQ(stanza));
        } catch (e) {
            src_log.error(e);
            deferred.resolve();
            return;
        }
    }

    /**
     * @param {Object} deferred
     * @param {Element} iq
     */
    async onBlocklistReceived(deferred, iq) {
        Array.from(iq.querySelectorAll('blocklist item')).forEach((item) => {
            const jid = item.getAttribute('jid');
            const blocked = this.get(jid);
            blocked ? blocked.save({ jid }) : this.create({ jid });
        });

        shared_converse.state.session.set(this.fetched_flag, true);
        if (deferred !== undefined) {
            return deferred.resolve();
        }
    }
}

/* export default */ const blocklist_collection = (Blocklist);

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/utils.js



const { Strophe: blocklist_utils_Strophe, stx: blocklist_utils_stx, u: blocklist_utils_u } = api_public.env;

/**
 * Sends an IQ stanza to remove one or more JIDs from the blocklist
 * @param {string|string[]} jid
 */
async function sendUnblockStanza(jid) {
    const jids = Array.isArray(jid) ? jid : [jid];
    const stanza = blocklist_utils_stx`
        <iq xmlns="jabber:client" type="set" id="${blocklist_utils_u.getUniqueId()}">
            <unblock xmlns="${blocklist_utils_Strophe.NS.BLOCKING}">
                ${jids.map((id) => blocklist_utils_stx`<item jid="${id}"/>`)}
            </unblock>
        </iq>`;
    await send.sendIQ(stanza);
}

/**
 * Sends an IQ stanza to add one or more JIDs from the blocklist
 * @param {string|string[]} jid
 */
async function sendBlockStanza(jid) {
    const jids = Array.isArray(jid) ? jid : [jid];
    const stanza = blocklist_utils_stx`
        <iq xmlns="jabber:client" type="set" id="${blocklist_utils_u.getUniqueId()}">
            <block xmlns="${blocklist_utils_Strophe.NS.BLOCKING}">
                ${jids.map((id) => blocklist_utils_stx`<item jid="${id}"/>`)}
            </block>
        </iq>`;
    await send.sendIQ(stanza);
}

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/api.js



const { waitUntil: blocklist_api_waitUntil } = api_promise;

/**
 * Groups methods relevant to XEP-0191 Blocking Command
 * @namespace api.blocklist
 * @memberOf api
 */
const api_blocklist = {
    /**
     * Retrieves the current user's blocklist
     * @returns {Promise<import('./collection').default>}
     */
    async get() {
        return await blocklist_api_waitUntil('blocklistInitialized');
    },

    /**
     * Adds a new entity to the blocklist
     * @param {string|string[]} jid
     * @param {boolean} [send_stanza=true]
     * @returns {Promise<import('./collection').default>}
     */
    async add(jid, send_stanza = true) {
        const blocklist = await blocklist_api_waitUntil('blocklistInitialized');
        const jids = Array.isArray(jid) ? jid : [jid];
        if (send_stanza) await sendBlockStanza(jids);
        jids.forEach((jid) => blocklist.create({ jid }));
        return blocklist;
    },

    /**
     * Removes an entity from the blocklist
     * @param {string|string[]} jid
     * @param {boolean} [send_stanza=true]
     * @returns {Promise<import('./collection').default>}
     */
    async remove(jid, send_stanza = true) {
        const blocklist = await blocklist_api_waitUntil('blocklistInitialized');
        const jids = Array.isArray(jid) ? jid : [jid];
        if (send_stanza) await sendUnblockStanza(jids);
        jids.forEach((jid) => blocklist.get(jid)?.destroy());
        blocklist.remove(jids);
        return blocklist;
    },
};

const blocklist_api = { blocklist: api_blocklist };

/* export default */ const plugins_blocklist_api = (blocklist_api);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/filter.js


class RosterFilter extends skeletor_esm_Model {
    initialize () {
        super.initialize();
        this.set({
            text: '',
            type: 'items',
            state: 'online'
        });
    }
}



;// CONCATENATED MODULE: ./src/headless/plugins/roster/parsers.js



const { Strophe: roster_parsers_Strophe, sizzle: roster_parsers_sizzle, dayjs: roster_parsers_dayjs } = api_public.env;

/**
 * @param {Element} stanza
 * @returns {Promise<import('./types').PresenceAttributes>}
 */
async function parsePresence(stanza) {
    const from = stanza.getAttribute('from');
    const delay = roster_parsers_sizzle(`delay[xmlns="${roster_parsers_Strophe.NS.DELAY}"]`, stanza).pop();
    const priority_value = stanza.querySelector('priority')?.textContent ?? '0';
    const priority = parseInt(priority_value, 10) || 0;

    const timestamp = delay ? roster_parsers_dayjs(delay.getAttribute('stamp')).toISOString() : new Date().toISOString();
    const attrs = {
        bare_jid: roster_parsers_Strophe.getBareJidFromJid(from),
        from,
        status: stanza.querySelector('status')?.textContent,
        resource: roster_parsers_Strophe.getResourceFromJid(from),
        show: /** @type {import('./types').PresenceShowValues|undefined} */ (stanza.querySelector('show')?.textContent),
        timestamp,
        type: /** @type {import('./types').PresenceTypes} */ (stanza.getAttribute('type')),
        priority,
        nickname: roster_parsers_sizzle(`nick[xmlns="${roster_parsers_Strophe.NS.NICK}"]`, stanza).pop()?.textContent,
    };

    /**
     * *Hook* which allows plugins to add additional parsing
     * @event _converse#parsePresence
     */
    return await shared_api.hook('parsePresence', stanza, attrs);
}

;// CONCATENATED MODULE: ./src/headless/plugins/roster/utils.js
/**
 * @typedef {import('./contacts').default} RosterContacts
 */










const { stx: roster_utils_stx } = api_public.env;

function initRoster() {
    // Initialize the collections that represent the roster contacts and groups
    const roster = new shared_converse.exports.RosterContacts();
    Object.assign(shared_converse, { roster }); // XXX Deprecated
    Object.assign(shared_converse.state, { roster });

    const bare_jid = shared_converse.session.get('bare_jid');
    let id = `converse.contacts-${bare_jid}`;
    initStorage(roster, id);

    const roster_filter = new RosterFilter();
    Object.assign(shared_converse, { roster_filter }); // XXX Deprecated
    Object.assign(shared_converse.state, { roster_filter });

    roster_filter.id = `_converse.rosterfilter-${bare_jid}`;
    initStorage(roster_filter, roster_filter.id);
    roster_filter.fetch();

    id = `converse-roster-model-${bare_jid}`;
    roster.data = new skeletor_esm_Model();
    roster.data.id = id;
    initStorage(roster.data, id);
    roster.data.fetch();
    /**
     * Triggered once the `RosterContacts`
     * been created, but not yet populated with data.
     * This event is useful when you want to create views for these collections.
     * @event _converse#chatBoxMaximized
     * @example _converse.api.listen.on('rosterInitialized', () => { ... });
     * @example _converse.api.waitUntil('rosterInitialized').then(() => { ... });
     */
    shared_api.trigger('rosterInitialized', roster);
}

/**
 * Fetch all the roster groups, and then the roster contacts.
 * Emit an event after fetching is done in each case.
 * @param {boolean} ignore_cache - If set to to true, the local cache
 *      will be ignored it's guaranteed that the XMPP server
 *      will be queried for the roster.
 */
async function populateRoster(ignore_cache = false) {
    const connection = shared_api.connection.get();
    if (ignore_cache) {
        connection.send_initial_presence = true;
    }
    const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
    try {
        await roster.fetchRosterContacts();
        shared_api.trigger('rosterContactsFetched', roster);
    } catch (reason) {
        src_log.error(reason);
    } finally {
        if (connection.send_initial_presence) {
            shared_api.user.presence.send();
            // The profile may already be gone if the session was cleared while
            // the roster fetch was still in flight (e.g. during reconnection).
            shared_converse.state.profile?.save({ presence: 'online' });
        }
    }
}

let utils_presence_ref;

function utils_registerPresenceHandler() {
    utils_unregisterPresenceHandler();
    const connection = shared_api.connection.get();
    utils_presence_ref = connection.addHandler(
        /** @param {Element} presence */
        async (presence) => {
            const attrs = await parsePresence(presence);

            const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
            roster.presenceHandler(attrs);
            return true;
        },
        null,
        'presence',
        null,
    );
}

function utils_unregisterPresenceHandler() {
    if (utils_presence_ref) {
        const connection = shared_api.connection.get();
        connection.deleteHandler(utils_presence_ref);
        utils_presence_ref = null;
    }
}

async function clearPresences() {
    await shared_converse.state.presences?.clearStore();
}

/**
 * Roster specific event handler for the clearSession event
 */
async function utils_onClearSession() {
    await clearPresences();
    if (shouldClearCache(shared_converse)) {
        const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
        if (roster) {
            roster.data?.destroy();
            await roster.clearStore();
            delete shared_converse.state.roster;
            Object.assign(shared_converse, { roster: undefined }); // XXX DEPRECATED
        }
    }
}

/**
 * Roster specific event handler for the presencesInitialized event
 * @param {Boolean} reconnecting
 */
function onPresencesInitialized(reconnecting) {
    if (reconnecting) {
        /**
         * Similar to `rosterInitialized`, but instead pertaining to reconnection.
         * This event indicates that the roster and its groups are now again
         * available after Converse.js has reconnected.
         * @event _converse#rosterReadyAfterReconnection
         * @example _converse.api.listen.on('rosterReadyAfterReconnection', () => { ... });
         */
        shared_api.trigger('rosterReadyAfterReconnection');
    } else {
        initRoster();
    }
    const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
    roster.onConnected();
    utils_registerPresenceHandler();
    populateRoster(!shared_api.connection.get().restored);
}

/**
 * Roster specific event handler for the statusInitialized event
 * @param { Boolean } reconnecting
 */
async function utils_onStatusInitialized(reconnecting) {
    if (reconnecting) {
        // When reconnecting and not resuming a previous session,
        // we clear all cached presence data, since it might be stale
        // and we'll receive new presence updates
        if (!shared_api.connection.get().hasResumed()) await clearPresences();
    } else {
        Object.assign(shared_converse.state, { presences: new shared_converse.exports.Presences() });
    }
    /**
     * Triggered once the _converse.Presences collection has been
     * initialized and its cached data fetched.
     * Returns a boolean indicating whether this event has fired due to
     * Converse having reconnected.
     * @event _converse#presencesInitialized
     * @type {boolean}
     * @example _converse.api.listen.on('presencesInitialized', (reconnecting) => { ... });
     */
    shared_api.trigger('presencesInitialized', reconnecting);
}

/**
 * Roster specific handler for the rosterContactsFetched promise
 */
function onRosterContactsFetched() {
    const roster = /** @type {RosterContacts} */ (shared_converse.state.roster);
    roster.on('add', (contact) => {
        // When a new contact is added, check if we already have a
        // chatbox open for it, and if so attach it to the chatbox.
        const chatbox = shared_converse.state.chatboxes.findWhere({ jid: contact.get('jid') });
        chatbox?.setModelContact(contact.get('jid'));
    });
}

/**
 * Reject or cancel another user's subscription to our presence updates.
 * @function rejectPresenceSubscription
 * @param {String} jid - The Jabber ID of the user whose subscription is being canceled
 * @param {String} [message] - An optional message to the user
 */
function rejectPresenceSubscription(jid, message) {
    const pres = roster_utils_stx`
        <presence to="${jid}" type="unsubscribed" xmlns="jabber:client">
            ${message ? roster_utils_stx`<status>${message}</status>` : ''}
        </presence>`;
    shared_api.send(pres);
}

/**
 * @param {import('./contact.js').default} contact
 * @return {boolean}
 */
function isUnsavedContact(contact) {
    const is_self = shared_converse.session.get('bare_jid') === contact.get('jid');
    return !is_self && !contact.get('subscription');
}

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Adds support for XEP-0191 Blocking Command
 */









const { Strophe: blocklist_plugin_Strophe, sizzle: plugin_sizzle } = api_public.env;

blocklist_plugin_Strophe.addNamespace("BLOCKING", "urn:xmpp:blocking");

api_public.plugins.add("converse-blocklist", {
    /**
     * @typedef {import('../roster/contact').default} RosterContact
     * @typedef {import('../roster/contacts').default} RosterContacts
     */

    dependencies: ["converse-disco"],

    initialize() {
        const exports = { Blocklist: blocklist_collection, BlockedEntity: blocklist_model };
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_api, plugins_blocklist_api);

        shared_api.promises.add(["blocklistInitialized"]);

        shared_api.listen.on(
            "cachedRoster",
            /** @param {RosterContacts} roster */
            async (roster) => {
                const domain = shared_converse.session.get("domain");
                const blocking_supported = await shared_api.disco.supports(blocklist_plugin_Strophe.NS.BLOCKING, domain);
                if (blocking_supported) {
                    const blocklist = await shared_api.blocklist.get();
                    const requesting_contacts = roster.filter(
                        /** @param {RosterContact} m */ (m) => m.get("requesting")
                    );
                    requesting_contacts.forEach(
                        /** @param {RosterContact} m */ async (m) => {
                            if (blocklist.get(m.get("jid"))) {
                                rejectPresenceSubscription(m.get("jid"));
                                m.destroy();
                            }
                        }
                    );
                }
            }
        );

        shared_api.listen.on(
            "getErrorAttributesForMessage",
            /**
             * @param {import('../chat/model.js').default} _message
             * @param {import('../../shared/types').MessageErrorAttributes} new_attrs
             * @param {import('../../shared/types').MessageAttributes} attrs
             */
            (_message, new_attrs, attrs) => {
                if (attrs.errors.find((e) => e.name === "blocked" && e.xmlns === `${blocklist_plugin_Strophe.NS.BLOCKING}:errors`)) {
                    const { __ } = shared_converse;
                    new_attrs.error = __("You are blocked from sending messages.");
                }
                return new_attrs;
            }
        );

        shared_api.listen.on("connected", () => {
            const connection = shared_api.connection.get();
            connection.addHandler(
                /** @param {Element} stanza */ (stanza) => {
                    const bare_jid = shared_converse.session.get("bare_jid");
                    const from = stanza.getAttribute("from");
                    if (blocklist_plugin_Strophe.getBareJidFromJid(from ?? bare_jid) != bare_jid) {
                        src_log.warn(`Received a blocklist push stanza from a suspicious JID ${from}`);
                        return true;
                    }

                    const add_jids = plugin_sizzle(`block[xmlns="${blocklist_plugin_Strophe.NS.BLOCKING}"] item`, stanza).map(
                        /** @param {Element} item */ (item) => item.getAttribute("jid")
                    );
                    if (add_jids.length) shared_api.blocklist.add(add_jids, false);

                    const remove_jids = plugin_sizzle(`unblock[xmlns="${blocklist_plugin_Strophe.NS.BLOCKING}"] item`, stanza).map(
                        /** @param {Element} item */ (item) => item.getAttribute("jid")
                    );
                    if (remove_jids.length) shared_api.blocklist.remove(remove_jids, false);

                    return true;
                },
                blocklist_plugin_Strophe.NS.BLOCKING,
                "iq",
                "set"
            );
        });

        shared_api.listen.on("clearSession", () => {
            const { state } = shared_converse;
            if (state.blocklist) {
                state.blocklist.clearStore({ "silent": true });
                state.session.set(state.blocklist.fetched_flag, undefined);
                delete state.blocklist;
            }
        });

        shared_api.listen.on("discoInitialized", async () => {
            const domain = shared_converse.session.get("domain");
            if (await shared_api.disco.supports(blocklist_plugin_Strophe.NS.BLOCKING, domain)) {
                shared_converse.state.blocklist = new shared_converse.exports.Blocklist();
            }
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/blocklist/index.js


;// CONCATENATED MODULE: ./src/headless/plugins/bosh/api.js


/* export default */ const bosh_api = ({
    /**
     * This API namespace lets you access the BOSH tokens
     * @namespace api.tokens
     * @memberOf api
     */
    tokens: {
        /**
         * @method api.tokens.get
         * @param {string} [id] The type of token to return ('rid' or 'sid').
         * @returns {string} A token, either the RID or SID token depending on what's asked for.
         * @example _converse.api.tokens.get('rid');
         */
        get (id) {
            const connection = shared_api.connection.get();
            if (!connection) return null;

            if (id.toLowerCase() === 'rid') {
                return connection.rid || connection._proto.rid;
            } else if (id.toLowerCase() === 'sid') {
                return connection.sid || connection._proto.sid;
            }
        }
    }

});

;// CONCATENATED MODULE: ./src/headless/plugins/bosh/utils.js
/**
 * @typedef {module:shared.api.user} LoginHookPayload
 */










const BOSH_SESSION_ID = 'converse.bosh-session';

let bosh_session;

async function initBOSHSession() {
    const id = BOSH_SESSION_ID;
    if (!bosh_session) {
        bosh_session = new skeletor_esm_Model({ id });
        bosh_session.storage = createStore(id, 'session');
        await new Promise((resolve) => bosh_session.fetch({ 'success': resolve, 'error': resolve }));
    }

    let jid = shared_converse.session.get('jid');
    if (jid) {
        if (bosh_session.get('jid') !== jid) {
            jid = await setUserJID(jid);
            bosh_session.clear({ 'silent': true });
            bosh_session.save({ jid });
        }
    } else {
        // Keepalive
        const jid = bosh_session.get('jid');
        if (jid) await setUserJID(jid);
    }
    return bosh_session;
}

function startNewPreboundBOSHSession() {
    if (!shared_api.settings.get('prebind_url')) {
        throw new Error('startNewPreboundBOSHSession: If you use prebind then you MUST supply a prebind_url');
    }
    const connection = shared_api.connection.get();
    const xhr = new XMLHttpRequest();
    xhr.open('GET', shared_api.settings.get('prebind_url'), true);
    xhr.setRequestHeader('Accept', 'application/json, text/javascript');
    xhr.onload = async function (event) {
        if (xhr.status >= 200 && xhr.status < 400) {
            const data = JSON.parse(xhr.responseText);
            const jid = await setUserJID(data.jid);
            connection.attach(jid, data.sid, data.rid, connection.onConnectStatusChanged, BOSH_WAIT);
        } else {
            xhr.onerror(event);
        }
    };
    xhr.onerror = function () {
        shared_api.connection.destroy();
        /**
         * Triggered when fetching prebind tokens failed
         * @event _converse#noResumeableBOSHSession
         * @type { _converse }
         * @example _converse.api.listen.on('noResumeableBOSHSession', _converse => { ... });
         */
        shared_api.trigger('noResumeableBOSHSession', shared_converse);
    };
    xhr.send();
}

/**
 * @param {unknown} _
 * @param {LoginHookPayload} payload
 */
async function attemptPrebind(_, payload) {
    if (payload.success) return payload;

    const { automatic } = payload;
    // See whether there is a BOSH session to re-attach to
    if (await restoreBOSHSession()) {
        return { ...payload, success: true };
    } else if (shared_api.settings.get('authentication') === PREBIND && (!automatic || shared_api.settings.get('auto_login'))) {
        startNewPreboundBOSHSession();
        return { ...payload, success: true };
    }
    return payload;
}

function saveJIDToSession() {
    if (bosh_session !== undefined) {
        bosh_session.save({ 'jid': shared_converse.session.get('jid') });
    }
}

function bosh_utils_clearSession() {
    if (bosh_session === undefined) {
        // Remove manually, even if we don't have the corresponding
        // model, to avoid trying to reconnect to a stale BOSH session
        const id = BOSH_SESSION_ID;
        sessionStorage.removeItem(id);
        sessionStorage.removeItem(`${id}-${id}`);
    } else {
        bosh_session.destroy();
        bosh_session = undefined;
    }
}

async function restoreBOSHSession() {
    const jid = (await initBOSHSession()).get('jid');
    const connection = shared_api.connection.get();
    if (jid && connection._proto instanceof Strophe.Bosh) {
        try {
            connection.restore(jid, connection.onConnectStatusChanged);
            return true;
        } catch (e) {
            if (!isTestEnv()) {
                src_log.warn('Could not restore session for jid: ' + jid + ' Error message: ' + e.message);
            }
            return false;
        }
    }
    return false;
}

;// CONCATENATED MODULE: ./src/headless/plugins/bosh/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Converse.js plugin which add support for XEP-0206: XMPP Over BOSH
 */








api_public.plugins.add('converse-bosh', {
    enabled() {
        // BOSH is an XMLHttpRequest transport, so it cannot work off a browser.
        // Reporting it disabled under Node also keeps the keepalive auto-login
        // path in shared/api/public.js from selecting it.
        return IS_BROWSER && !shared_converse.api.settings.get('blacklisted_plugins').includes('converse-bosh');
    },

    initialize() {
        shared_api.settings.extend({
            bosh_service_url: undefined,
            prebind_url: null,
        });

        Object.assign(shared_api, bosh_api);

        shared_api.listen.on('clearSession', bosh_utils_clearSession);
        shared_api.listen.on('setUserJID', saveJIDToSession);
        shared_api.listen.on('login', attemptPrebind);
        shared_api.listen.on('addClientFeatures', () => shared_api.disco.own.features.add(Strophe.NS.BOSH));
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/caps/model.js


/**
 * Represents a cached, verified XEP-0115 entity capabilities result: the
 * disco#info (identities, features and XEP-0128 data forms) that corresponds to
 * a particular verification hash.
 *
 * The model is content-addressed: its `id` is `${hash}/${ver}`, so a single
 * entry is shared by every JID that advertises the same caps.
 */
class CapsInfo extends skeletor_esm_Model {
    defaults() {
        return {
            identities: [],
            features: [],
            dataforms: [],
        };
    }
}

/* export default */ const caps_model = (CapsInfo);

;// CONCATENATED MODULE: ./src/headless/plugins/caps/utils.js
/**
 * @typedef {import('strophe.js').Builder} Strophe.Builder
 */





const { Strophe: caps_utils_Strophe, sizzle: caps_utils_sizzle, stx: caps_utils_stx } = api_public.env;

const text_encoder = new TextEncoder();

/**
 * Compares two strings using "i;octet" collation, i.e. a byte-wise comparison of
 * their UTF-8 encodings, as required by XEP-0115 § 5.1 for all sorting.
 * @param {string} a
 * @param {string} b
 * @returns {number}
 */
function octetCompare(a, b) {
    const ba = text_encoder.encode(a ?? '');
    const bb = text_encoder.encode(b ?? '');
    const len = Math.min(ba.length, bb.length);
    for (let i = 0; i < len; i++) {
        if (ba[i] !== bb[i]) return ba[i] - bb[i];
    }
    return ba.length - bb.length;
}

/**
 * Generates an XEP-0115 verification string for the given disco#info data,
 * following the generation method in XEP-0115 § 5.1.
 * @param {import('./types').CapsInfoData} data
 * @returns {Promise<string>} The base64-encoded SHA-1 hash
 */
async function generateVerificationString({ identities = [], features = [], dataforms = [] }) {
    // Identities, sorted by category/type/xml:lang and formatted as
    // "category/type/lang/name".
    let S = identities
        .map((id) => `${id.category}/${id.type}/${id.lang ?? ''}/${id.name ?? ''}`)
        .sort(octetCompare)
        .map((s) => `${s}<`)
        .join('');

    // Features, sorted.
    S += [...features]
        .sort(octetCompare)
        .map((feature) => `${feature}<`)
        .join('');

    // XEP-0128 data forms, sorted by FORM_TYPE. Forms without a FORM_TYPE are
    // ignored (XEP-0115 § 5.4).
    const forms = dataforms
        .map((fields) => ({ fields, form_type: (fields['FORM_TYPE'] ?? [])[0] }))
        .filter(({ form_type }) => form_type !== undefined)
        .sort((a, b) => octetCompare(a.form_type, b.form_type));

    for (const { fields, form_type } of forms) {
        S += `${form_type}<`;
        const vars = Object.keys(fields)
            .filter((v) => v !== 'FORM_TYPE')
            .sort(octetCompare);
        for (const v of vars) {
            S += `${v}<`;
            S += [...fields[v]]
                .sort(octetCompare)
                .map((value) => `${value}<`)
                .join('');
        }
    }

    const ab = await crypto.subtle.digest('SHA-1', stringToArrayBuffer(S));
    return arrayBufferToBase64(ab);
}

/**
 * Computes the verification string for this client (Converse itself), from its
 * own registered disco identities and features.
 * @returns {Promise<string>}
 */
function getOwnVerificationString() {
    return generateVerificationString({
        identities: shared_converse.api.disco.own.identities.get(),
        features: shared_converse.api.disco.own.features.get(),
        dataforms: [],
    });
}

/**
 * Checks that disco#info data is well-formed for caps purposes: no duplicate
 * identities, features or FORM_TYPE values (XEP-0115 § 5.4).
 * @param {import('./types').CapsInfoData} data
 * @returns {boolean}
 */
function isWellFormed({ identities = [], features = [], dataforms = [] }) {
    const identity_keys = identities.map((id) => `${id.category}/${id.type}/${id.lang ?? ''}/${id.name ?? ''}`);
    if (new Set(identity_keys).size !== identity_keys.length) return false;
    if (new Set(features).size !== features.length) return false;
    const form_types = dataforms.map((f) => (f['FORM_TYPE'] ?? [])[0]).filter((t) => t !== undefined);
    if (new Set(form_types).size !== form_types.length) return false;
    return true;
}

/**
 * Verifies that the given disco#info data hashes to the advertised verification
 * string (XEP-0115 § 5.4). Only the mandatory-to-implement SHA-1 algorithm is
 * supported; any other hash is treated as unverifiable.
 * @param {import('./types').CapsInfoData} info
 * @param {string} hash - The advertised hashing algorithm
 * @param {string} ver - The advertised verification string
 * @returns {Promise<boolean>}
 */
async function verifyCaps(info, hash, ver) {
    if (hash !== 'sha-1') return false;
    if (!isWellFormed(info)) return false;
    return (await generateVerificationString(info)) === ver;
}

/**
 * The storage key for the XEP-0115 capabilities cache. It isn't suffixed with
 * the user's JID like most stores: the persistent storage backend is already
 * scoped to the logged-in account, and a verification hash is a content
 * address, so a single cache per account suffices.
 * @returns {string}
 */
function getCapsCacheStorageKey() {
    return 'converse.caps';
}

/**
 * Parses the XEP-0115 entity capabilities (`<c/>`) element from a presence
 * stanza, if present.
 * @param {Element} stanza
 * @returns {import('./types').CapsAttributes|null}
 */
function getCapsAttrs(stanza) {
    const c = caps_utils_sizzle(`c[xmlns="${caps_utils_Strophe.NS.CAPS}"]`, stanza).pop();
    if (!c) return null;
    return {
        hash: c.getAttribute('hash'),
        node: c.getAttribute('node'),
        ver: c.getAttribute('ver'),
    };
}

/**
 * Returns the caps (hash, node, ver) the given full JID advertised in its
 * presence, or `undefined` if none is known.
 *
 * XEP-0115 caps ride on presence, and we only receive presence from contacts
 * we're subscribed to (i.e. in our roster). The caps a resource advertised are
 * therefore stored on that contact's roster Resource (see roster `addResource`),
 * which both survives a reload and is the single source of truth.
 * @param {string} jid - The full JID of the entity
 * @returns {import('./types').CapsAttributes|undefined}
 */
function getEntityCaps(jid) {
    const resource = caps_utils_Strophe.getResourceFromJid(jid);
    if (!resource) return undefined;
    const presence = shared_converse.state.presences?.get(caps_utils_Strophe.getBareJidFromJid(jid));
    return /** @type {import('./types').CapsAttributes|undefined} */ (presence?.resources?.get(resource)?.get('caps'));
}

/**
 * Handler for the `parsePresence` hook which enriches the parsed presence
 * attributes with the sender's advertised XEP-0115 entity capabilities, so the
 * roster handler can persist them on the sender's Resource (see roster
 * `addResource`), where disco later looks them up. An unavailable presence
 * carries no caps and drops the resource (and its caps) on the roster side.
 * @param {Element} stanza
 * @param {import('../roster/types').PresenceAttributes} attrs
 * @returns {import('../roster/types').PresenceAttributes}
 */
function utils_onParsePresence(stanza, attrs) {
    const caps = getCapsAttrs(stanza);
    return caps ? { ...attrs, caps } : attrs;
}

/**
 * Parses a disco#info response stanza into the canonical structure used for caps
 * verification and caching. Unlike the disco entity's own parsing, this
 * preserves identity `xml:lang` values and all values of multi-valued data form
 * fields, both of which are needed to recompute the verification hash.
 * @param {Element} stanza
 * @returns {import('./types').CapsInfoData}
 */
function parseDiscoInfoForCaps(stanza) {
    const identities = caps_utils_sizzle('identity', stanza).map((el) => ({
        category: el.getAttribute('category'),
        type: el.getAttribute('type'),
        name: el.getAttribute('name') ?? '',
        lang: el.getAttribute('xml:lang') ?? '',
    }));
    const features = caps_utils_sizzle('feature', stanza).map((el) => el.getAttribute('var'));
    const dataforms = caps_utils_sizzle(`x[xmlns="${caps_utils_Strophe.NS.XFORM}"]`, stanza).map((form) => {
        /** @type {Record<string, string[]>} */
        const fields = {};
        caps_utils_sizzle('field', form).forEach((field) => {
            const v = field.getAttribute('var');
            if (v) fields[v] = caps_utils_sizzle('value', field).map((val) => val.textContent ?? '');
        });
        return fields;
    });
    return { identities, features, dataforms };
}

/**
 * Handler for disco's generic `discoEntityInfoRequested` hook. Given a disco
 * entity, returns the cached disco#info for the XEP-0115 caps it advertised in
 * presence (if we've already verified that `ver`) plus the caps query node, so
 * that disco can skip or scope its network query. Returns `null` if the entity
 * advertised no caps.
 * @param {import('../disco/entity').default} entity
 * @returns {import('../disco/types').DiscoInfoLookup|null}
 */
function onDiscoEntityInfoRequested(entity) {
    const caps = getEntityCaps(entity.get('jid'));
    if (!caps) return null;

    const cached = shared_converse.state.caps_cache?.getCachedInfo(caps.hash, caps.ver);
    return {
        // The caps query node (XEP-0115 § 6.2); disco treats it as opaque.
        node: `${caps.node}#${caps.ver}`,
        info: cached
            ? {
                  identities: cached.get('identities'),
                  features: cached.get('features'),
                  dataforms: cached.get('dataforms'),
              }
            : null,
    };
}

/**
 * Handler for the `discoEntityInfoReceived` hook. After a disco#info response is
 * received and parsed, verify it against the entity's advertised `ver`
 * (XEP-0115 § 5.4) and, if valid, cache it so that future entities advertising
 * the same `ver` can skip the disco#info query.
 * @param {import('../disco/entity').default} entity
 * @param {Element} stanza
 * @returns {Promise<Element>}
 */
async function onDiscoEntityInfoReceived(entity, stanza) {
    const caps = getEntityCaps(entity.get('jid'));
    if (caps) {
        const info = parseDiscoInfoForCaps(stanza);
        if (await verifyCaps(info, caps.hash, caps.ver)) {
            shared_converse.state.caps_cache?.store(caps, info);
        } else {
            src_log.debug(`caps: not caching unverified capabilities for ${entity.get('jid')} (${caps.hash}/${caps.ver})`);
        }
    }
    return stanza;
}

/**
 * Detects, once per connection, whether our own server supports XEP-0115 Caps
 * Optimization (§ 8.4) and records the result so that broadcast presence can omit
 * redundant `<c/>` elements.
 * @returns {Promise<void>}
 */
async function detectCapsOptimizationSupport() {
    const domain = shared_converse.session?.get('domain');
    try {
        shared_converse.state.caps_optimize = !!(
            domain && (await shared_converse.api.disco.supports(caps_utils_Strophe.NS.CAPS_OPTIMIZE, domain))
        );
    } catch (e) {
        src_log.error(e);
        shared_converse.state.caps_optimize = false;
    }
}

/**
 * Adds a XEP-0115 capabilities (`<c/>`) element to the given presence stanza.
 *
 * Optimization (XEP-0115 § 8.4) only applies to broadcast presence (presence
 * with no `to`). When `optimize` is true, our server supports Caps Optimization
 * and this is a broadcast presence, the `<c/>` is omitted on presences whose
 * verification string we've already advertised this session: the server re-adds
 * the annotation for new subscribers and forwards any `ver` change, so
 * re-sending an unchanged `<c/>` on every presence is wasteful. The first
 * presence (and any subsequent `ver` change) is always annotated. Directed
 * presence (e.g. a MUC join or a presence probe) is never optimized, as
 * server-side broadcast stripping doesn't apply to it.
 * @param {Strophe.Builder} stanza
 * @param {boolean} [optimize=false]
 * @returns {Promise<Strophe.Builder>}
 */
async function addCapsNode(stanza, optimize = false) {
    const ver = await getOwnVerificationString();
    // Only broadcast presence (no `to`) is subject to § 8.4 optimization;
    // directed presence is always annotated and never updates the send-side
    // state, since the server only caches and re-adds caps for broadcasts.
    const may_optimize = optimize && !stanza.tree().getAttribute('to');
    if (may_optimize && shared_converse.state.caps_optimize && shared_converse.state.caps_last_sent_ver === ver) {
        return stanza;
    }
    const node = caps_utils_stx`<c
        xmlns="${caps_utils_Strophe.NS.CAPS}"
        hash="sha-1"
        node="https://conversejs.org"
        ver="${ver}"></c>`;
    stanza.root().cnode(node).up();
    if (may_optimize) shared_converse.state.caps_last_sent_ver = ver;
    return stanza;
}

;// CONCATENATED MODULE: ./src/headless/plugins/caps/collection.js








/**
 * A persistent cache of verified XEP-0115 entity capabilities, keyed by the
 * verification hash (`${hash}/${ver}`).
 *
 * Because a verification hash is a cryptographic content address of an entity's
 * disco#info, a single cached entry is shared by every JID (and resource) that
 * advertises the same capabilities.
 *
 * @extends {Collection<CapsInfo>}
 */
class CapsInfoCache extends Collection {
    constructor() {
        // Pass the model via options so it's set before the (async) initialize()
        // that skeletor invokes from the constructor runs and fetches from storage.
        super([], { model: caps_model });
    }

    async initialize() {
        initStorage(this, getCapsCacheStorageKey());
        await this.fetchCache();

        /**
         * Triggered once the {@link CapsInfoCache} has been created and any
         * cached capabilities have been fetched from storage.
         * @event _converse#capsInitialized
         * @example _converse.api.listen.on('capsInitialized', () => { ... });
         */
        shared_api.trigger('capsInitialized');
    }

    fetchCache() {
        const deferred = openpromise_getOpenPromise();
        this.fetch({
            success: () => deferred.resolve(),
            error: (_, e) => {
                src_log.error(e);
                deferred.resolve();
            },
        });
        return deferred;
    }

    /**
     * Returns the cached disco#info for a given verification hash, or
     * `undefined` if it hasn't been verified and cached yet. On a hit, the
     * entry's `last_used` timestamp is refreshed so that LRU eviction keeps
     * frequently-consulted capabilities.
     * @param {string} hash - The hashing algorithm (e.g. "sha-1")
     * @param {string} ver - The verification string
     * @returns {CapsInfo|undefined}
     */
    getCachedInfo(hash, ver) {
        const model = this.get(`${hash}/${ver}`);
        model?.save({ last_used: Date.now() });
        return model;
    }

    /**
     * Stores a verified disco#info result against its verification hash.
     *
     * The caller is responsible for having verified that the data hashes to
     * `ver` (see XEP-0115 Section 5.4) before calling this method.
     * @param {import('./types').CapsAttributes} caps - The advertised caps ({ hash, node, ver })
     * @param {import('./types').CapsInfoData} info - The verified disco#info data
     * @returns {CapsInfo}
     */
    store({ hash, node, ver }, { identities, features, dataforms }) {
        const id = `${hash}/${ver}`;
        const attrs = { id, hash, node, ver, identities, features, dataforms, last_used: Date.now() };
        const existing = this.get(id);
        if (existing) {
            existing.save(attrs);
            return existing;
        }
        const model = /** @type {CapsInfo} */ (this.create(attrs));
        this.evictLeastRecentlyUsed();
        return model;
    }

    /**
     * Evicts the least-recently-used entries until the cache is back within the
     * `caps_cache_size` limit. Verified caps are content-addressed and cheap to
     * re-fetch, so dropping the coldest entries is safe.
     */
    evictLeastRecentlyUsed() {
        const max = shared_api.settings.get('caps_cache_size');
        if (!(max > 0) || this.length <= max) return;

        const by_last_used = [...this.models].sort((a, b) => (a.get('last_used') ?? 0) - (b.get('last_used') ?? 0));
        let overflow = this.length - max;
        while (overflow-- > 0) by_last_used.shift()?.destroy();
    }
}

/* export default */ const caps_collection = (CapsInfoCache);

;// CONCATENATED MODULE: ./src/headless/plugins/caps/index.js
/**
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */






const { Strophe: caps_Strophe } = api_public.env;

caps_Strophe.addNamespace('CAPS', 'http://jabber.org/protocol/caps');
caps_Strophe.addNamespace('CAPS_OPTIMIZE', 'http://jabber.org/protocol/caps#optimize');

api_public.plugins.add('converse-caps', {
    dependencies: ['converse-disco', 'converse-status'],

    initialize() {
        shared_api.settings.extend({
            // Maximum number of verified capability entries kept in the
            // persistent cache. Past this, the least-recently-used entries are
            // evicted (they're cheap to re-fetch). Set to 0 to disable pruning
            // (unbounded cache).
            caps_cache_size: 3000,
        });

        shared_api.promises.add('capsInitialized');

        // Advertise XEP-0115 support in our own disco#info (XEP-0115 § 7).
        shared_api.listen.on('addClientFeatures', () => shared_api.disco.own.features.add(caps_Strophe.NS.CAPS));

        // Opt in to XEP-0115 § 8.4 optimization for general presence, but
        // addCapsNode only actually optimizes broadcast presence (no `to`);
        // directed presence (probes, RAI, subscriptions) and MUC presence are
        // always annotated.
        shared_api.listen.on('constructedPresence', (_, p) => addCapsNode(p, true));
        shared_api.listen.on('constructedMUCPresence', (_, p) => addCapsNode(p));

        // Enrich incoming presence with the sender's advertised XEP-0115 caps,
        // so the roster handler stores them on the sender's Resource.
        shared_api.listen.on('parsePresence', utils_onParsePresence);

        // On session end, reset the send-side optimization state, so the first
        // presence of the next session re-advertises our `<c/>` (XEP-0115 § 8.4).
        const onSessionEnd = () => {
            Object.assign(shared_converse.state, { caps_last_sent_ver: null, caps_optimize: false });
        };
        shared_api.listen.on('will-reconnect', onSessionEnd);
        shared_api.listen.on('clearSession', onSessionEnd);

        // Persistent cache of verified capabilities (ver -> disco#info). Unlike
        // the map above, the cached data survives reconnects, the session ending
        // and page reloads (its store is content-addressed by verification hash).
        // A fresh collection is created on each login so it binds to the current
        // session's storage backend; the persisted entries are then re-read.
        shared_api.listen.on('connected', () => {
            Object.assign(shared_converse.state, { caps_cache: new caps_collection(), caps_last_sent_ver: null });
            // Detect Caps Optimization support once per connection (§ 8.4).
            detectCapsOptimizationSupport();
        });

        // Disco integration (XEP-0115 §§ 5-6). disco fires these generic hooks;
        // we answer with cached caps to avoid a query, and verify+cache real
        // responses.
        shared_api.listen.on('discoEntityInfoRequested', onDiscoEntityInfoRequested);
        shared_api.listen.on('discoEntityInfoReceived', onDiscoEntityInfoReceived);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/chatboxes/chatboxes.js
/**
 * @typedef {import('../../shared/chatbox').default} ChatBoxBase
 */





/**
 * @extends {Collection<ChatBoxBase>}
 */
class ChatBoxes extends Collection {
    /**
     * @param {ChatBoxBase[]} models
     * @param {import('@converse/skeletor').CollectionOptions<ChatBoxBase>} options
     */
    constructor(models, options) {
        super(models, Object.assign({ comparator: 'time_opened' }, options));
    }

    /**
     * @param {Collection} collection
     */
    onChatBoxesFetched(collection) {
        collection.filter((c) => !c.isValid()).forEach((c) => c.destroy());
        /**
         * Triggered once all chat boxes have been recreated from the browser cache
         * @event _converse#chatBoxesFetched
         * @example _converse.api.listen.on('chatBoxesFetched', () => { ... });
         */
        shared_api.trigger('chatBoxesFetched');
    }

    /**
     * @param {boolean} reconnecting
     */
    onConnected(reconnecting) {
        if (reconnecting) return;

        const bare_jid = shared_converse.session.get('bare_jid');
        initStorage(this, `converse.chatboxes-${bare_jid}`);
        this.fetch({
            add: true,
            success: (c) => this.onChatBoxesFetched(c),
        });
    }

    /**
     * @param {import('./types').CreateModelAttributes} attrs
     * @param {import('@converse/skeletor').ModelOptions} options
     */
    createModel(attrs, options) {
        if (!attrs.type) {
            throw new Error('You need to specify a type of chatbox to be created');
        }
        const ChatBox = shared_api.chatboxes.registry.get(attrs.type);
        return new ChatBox(attrs, options);
    }
}

/* export default */ const chatboxes_chatboxes = (ChatBoxes);

;// CONCATENATED MODULE: ./src/headless/plugins/chatboxes/index.js
/**
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */









const { Strophe: chatboxes_Strophe } = api_public.env;


api_public.plugins.add('converse-chatboxes', {

    dependencies: ["converse-emoji", "converse-roster", "converse-vcard"],

    initialize () {

        shared_api.promises.add([
            'chatBoxesFetched',
            'chatBoxesInitialized',
            'privateChatsAutoJoined'
        ]);

        Object.assign(shared_api, { chatboxes: chatboxes_api});

        Object.assign(shared_converse, { ChatBoxes: chatboxes_chatboxes }); // TODO: DEPRECATED
        Object.assign(shared_converse.exports, { ChatBoxes: chatboxes_chatboxes });

        shared_api.listen.on('addClientFeatures', () => {
            shared_api.disco.own.features.add(chatboxes_Strophe.NS.MESSAGE_CORRECT);
            shared_api.disco.own.features.add(chatboxes_Strophe.NS.HTTPUPLOAD);
            shared_api.disco.own.features.add(chatboxes_Strophe.NS.OUTOFBAND);
        });

        let chatboxes;

        shared_api.listen.on('pluginsInitialized', () => {
            chatboxes = new shared_converse.exports.ChatBoxes();
            Object.assign(shared_converse, { chatboxes }); // TODO: DEPRECATED
            Object.assign(shared_converse.state, { chatboxes });

            /**
             * Triggered once the _converse.ChatBoxes collection has been initialized.
             * @event _converse#chatBoxesInitialized
             * @example _converse.api.listen.on('chatBoxesInitialized', () => { ... });
             * @example _converse.api.waitUntil('chatBoxesInitialized').then(() => { ... });
             */
            shared_api.trigger('chatBoxesInitialized');
        });

        shared_api.listen.on('presencesInitialized', (reconnecting) => chatboxes.onConnected(reconnecting));
        shared_api.listen.on('reconnected', () => chatboxes.forEach(m => m.onReconnection()));
        shared_api.listen.on('clearSession', onClearSession);

        // XXX: Would be nice to keep track of the last open chat and to show that again.
        shared_api.listen.on('chatBoxClosed', () => {
            if (isUniView()) {
                shared_converse.state.chatboxes.find((c) => c.get('jid'))?.maybeShow();
            }
        });

    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/adhoc/utils.js




const { Strophe: adhoc_utils_Strophe, u: adhoc_utils_u } = api_public.env;

/**
 * Given a "result" IQ stanza that contains a list of ad-hoc commands, parse it
 * and return the list of commands as JSON objects.
 * @param {Element} stanza
 * @returns {import('./types').AdHocCommand[]}
 */
function parseForCommands(stanza) {
    const items = sizzle(`query[xmlns="${adhoc_utils_Strophe.NS.DISCO_ITEMS}"][node="${adhoc_utils_Strophe.NS.ADHOC}"] item`, stanza);
    return items.map(adhoc_utils_u.getAttributes);
}

/**
 * Given a "result" IQ stanza containing the outcome of an Ad-hoc command that
 * was executed, parse it and return the values as a JSON object.
 * @param {Element} iq
 * @returns {import('./types').AdHocCommandResult}
 */
function parseCommandResult(iq) {
    const cmd_el = sizzle(`command[xmlns="${adhoc_utils_Strophe.NS.ADHOC}"]`, iq).pop();
    const note = cmd_el.querySelector('note');

    return {
        ...parseXForm(iq),
        sessionid: cmd_el.getAttribute('sessionid'),
        note: note
            ? {
                  text: note.textContent,
                  type: /** @type {'info'|'warn'|'error'} */ (note.getAttribute('type')),
              }
            : null,
        actions: Array.from(cmd_el.querySelector('actions')?.children ?? []).map((a) => a.nodeName.toLowerCase()),
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/adhoc/api.js






const { Strophe: adhoc_api_Strophe, u: api_u, stx: adhoc_api_stx } = api_public.env;


/* export default */ const adhoc_api = ({
    /**
     * @typedef {import('./types').AdHocCommandResult} AdHocCommandResult
     */

    /**
     * The XEP-0050 Ad-Hoc Commands API
     *
     * This API lets you discover ad-hoc commands available for an entity in the XMPP network.
     *
     * @namespace api.adhoc
     * @memberOf api
     */
    adhoc: {
        /**
         * @method api.adhoc.getCommands
         * @param {string} to_jid
         */
        async getCommands (to_jid) {
            try {
                return parseForCommands(await shared_api.disco.items(to_jid, adhoc_api_Strophe.NS.ADHOC));
            } catch (e) {
                if (e === null) {
                    src_log.error(`Error: timeout while fetching ad-hoc commands for ${to_jid}`);
                } else {
                    src_log.error(`Error while fetching ad-hoc commands for ${to_jid}`);
                    src_log.error(e);
                }
                return [];
            }
        },

        /**
         * @method api.adhoc.fetchCommandForm
         * @param {string} jid
         * @param {string} node
         * @returns {Promise<AdHocCommandResult>}
         */
        async fetchCommandForm (jid, node) {
            const stanza = adhoc_api_stx`
                <iq type="set" to="${jid}" xmlns="jabber:client">
                    <command xmlns="${adhoc_api_Strophe.NS.ADHOC}" action="execute" node="${node}"></command>
                </iq>`;
            return parseCommandResult(await shared_api.sendIQ(stanza));
        },

        /**
         * @method api.adhoc.runCommand
         * @param {String} jid
         * @param {String} sessionid
         * @param {import('./types').AdHocCommandAction} action
         * @param {String} node
         * @param {Array<{ [k:string]: string }>} inputs
         */
        async runCommand (jid, sessionid, node, action, inputs) {
            const iq =
                adhoc_api_stx`<iq type="set" to="${jid}" xmlns="jabber:client">
                    <command sessionid="${sessionid}" node="${node}" action="${action}" xmlns="${adhoc_api_Strophe.NS.ADHOC}">
                        ${ !['cancel', 'prev'].includes(action) ? adhoc_api_stx`
                            <x xmlns="${adhoc_api_Strophe.NS.XFORM}" type="submit">
                                ${ inputs.map(({ name, value }) => adhoc_api_stx`<field var="${name}">
                                    ${ Array.isArray(value)
                                        ? value.map(v => adhoc_api_stx`<value>${v}</value>`) : adhoc_api_stx`<value>${value}</value>` }
                                </field>`) }
                            </x>` : '' }
                    </command>
                </iq>`;

            const result = await shared_api.sendIQ(iq, null, false);
            if (result === null) {
                src_log.warn(`A timeout occurred while trying to run an ad-hoc command`);
                const { __ } = shared_converse;
                return {
                    status: 'error',
                    note: __('A timeout occurred'),
                }
            } else if (api_u.isErrorStanza(result)) {
                src_log.error('Error while trying to execute an ad-hoc command');
                src_log.error(result);
            }

            const command = result.querySelector('command');
            const status = command?.getAttribute('status');
            const resultData = command?.querySelector('x[type=result]');
            return {
                status,
                ...(status === 'executing' || (status === 'completed' && resultData) ? parseCommandResult(result) : {}),
                note: result.querySelector('note')?.textContent
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/adhoc/index.js



const { Strophe: adhoc_Strophe } = api_public.env;

adhoc_Strophe.addNamespace('ADHOC', 'http://jabber.org/protocol/commands');


api_public.plugins.add('converse-adhoc', {

    dependencies: ["converse-disco"],

    initialize () {
        Object.assign(this._converse.api, adhoc_api);
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/headlines/feed.js





/**
 * Shows headline messages
 */
class feed_HeadlinesFeed extends ChatBoxBase {
    defaults() {
        return {
            'bookmarked': false,
            'hidden': isUniView() && !shared_api.settings.get('singleton'),
            'message_type': 'headline',
            'num_unread': 0,
            'time_opened': this.get('time_opened') || new Date().getTime(),
            'time_sent': undefined,
            'type': HEADLINES_TYPE,
        };
    }

    /**
     * @param {import('@converse/skeletor').ModelAttributes} attrs
     * @param {import('@converse/skeletor').ModelOptions} options
     */
    constructor(attrs, options) {
        super(attrs, options);
        this.disable_mam = true; // Don't do MAM queries for this box
    }

    async initialize() {
        await super.initialize();
        await this.fetchMessages();
        /**
         * Triggered once a { @link _converse.HeadlinesFeed } has been created and initialized.
         * @event _converse#headlinesFeedInitialized
         * @type {HeadlinesFeed}
         * @example _converse.api.listen.on('headlinesFeedInitialized', model => { ... });
         */
        shared_api.trigger('headlinesFeedInitialized', this);
    }

    canPostMessages() {
        return false;
    }

    /**
     * @param {import('../../shared/message').default} message
     */
    isChatMessage(message) {
        const type = message.get('type');
        return type === this.get('message_type') || type === 'normal';
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/headlines/api.js
/**
 * @typedef {import('./feed.js').default} HeadlinesFeed
 */




/* export default */ const headlines_api = ({
    /**
     * The "headlines" namespace, which is used for headline-channels
     * which are read-only channels containing messages of type
     * "headline".
     *
     * @namespace api.headlines
     * @memberOf api
     */
    headlines: {
        /**
         * Retrieves a headline-channel or all headline-channels.
         *
         * @method api.headlines.get
         * @param {String|String[]} jids - e.g. 'buddy@example.com' or ['buddy1@example.com', 'buddy2@example.com']
         * @param { Object } [attrs] - Attributes to be set on the _converse.ChatBox model.
         * @param { Boolean } [create=false] - Whether the chat should be created if it's not found.
         * @returns { Promise<HeadlinesFeed[]|HeadlinesFeed> }
         */
        async get (jids, attrs={}, create=false) {
            /**
             * @param {string} jid
             * @returns {Promise<HeadlinesFeed>}
             */
            async function _get (jid) {
                let model = await shared_api.chatboxes.get(jid);
                if (!model && create) {
                    const { HeadlinesFeed } = shared_converse.exports;
                    model = await shared_api.chatboxes.create(jid, attrs, HeadlinesFeed);
                } else {
                    model = (model && model.get('type') === HEADLINES_TYPE) ? model : null;
                    if (model && Object.keys(attrs).length) {
                        model.save(attrs);
                    }
                }
                return model;
            }

            if (jids === undefined) {
                const chats = await shared_api.chatboxes.get();
                return chats?.filter(c => (c.get('type') === HEADLINES_TYPE)) ?? [];
            } else if (typeof jids === 'string') {
                return _get(jids);
            }
            return Promise.all(jids.map(jid => _get(jid)));
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/headlines/utils.js







/**
 * Handler method for all incoming messages of type "headline".
 * @param { Element } stanza
 */
async function onHeadlineMessage(stanza) {
    if (isHeadline(stanza) || isServerMessage(stanza)) {
        const from_jid = stanza.getAttribute('from');

        await shared_api.waitUntil('rosterInitialized');
        if (
            from_jid.includes('@') &&
            !shared_converse.state.roster.get(from_jid) &&
            !shared_api.settings.get('allow_non_roster_messaging')
        ) {
            return;
        }
        if (stanza.querySelector('body') === null) {
            // Avoid creating a chat box if we have nothing to show inside it.
            return;
        }

        const chatbox = await shared_api.chatboxes.create(
            from_jid,
            {
                'id': from_jid,
                'jid': from_jid,
                'type': HEADLINES_TYPE,
                'from': from_jid,
            },
            feed_HeadlinesFeed,
        );

        const attrs = await parseMessage(stanza);
        await chatbox.createMessage(attrs);
        shared_api.trigger('message', { chatbox, stanza, attrs });
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/headlines/index.js
/**
 * @module converse-headlines
 * @copyright 2022, the Converse.js contributors
 */








api_public.plugins.add('converse-headlines', {
    dependencies: ["converse-chat"],

    initialize () {
        const exports = { HeadlinesFeed: feed_HeadlinesFeed };
        Object.assign(shared_converse, exports); // XXX: DEPRECATED
        Object.assign(shared_converse.exports, exports);

        function registerHeadlineHandler () {
            shared_api.connection.get()?.addHandler(m => {
                onHeadlineMessage(m);
                return true; // keep the handler
            }, null, 'message');
        }
        shared_api.listen.on('connected', registerHeadlineHandler);
        shared_api.listen.on('reconnected', registerHeadlineHandler);

        Object.assign(shared_api, headlines_api);

        shared_api.chatboxes.registry.add(HEADLINES_TYPE, feed_HeadlinesFeed);
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/constants.js
/** @type {0} */ const UNDECIDED = 0;
/** @type {1} */ const TRUSTED = 1;
/** @type {-1} */ const UNTRUSTED = -1;

const TAG_LENGTH = 128;

const KEY_ALGO = {
    name: 'AES-GCM',
    length: 128,
};

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/crypto.js


let _promise;

/** @type {(() => Promise<typeof import('libomemo.js')>)|null} */
let _loader = null;

/**
 * Overrides how libomemo.js is loaded. Registered by `shims/node-omemo.js`,
 * because under Node the library comes from the package rather than from a file
 * served next to the bundle.
 * @param {() => Promise<typeof import('libomemo.js')>} loader
 */
function setCryptoLoader(loader) {
    _loader = loader;
}

/**
 * Loads libomemo.js from the file served alongside converse-headless.js.
 * @returns {Promise<typeof import('libomemo.js')>}
 */
function loadFromAssetDirectory() {
    // @ts-expect-error - resolved at runtime from dist/, not source
    return import(/* webpackIgnore: true */ './libomemo.esm.min.js');
}

/**
 * Dynamically imports libomemo.js (GPL-3.0 licensed).
 * The dynamic import ensures the GPL code is only loaded
 * when OMEMO encryption is actually used.
 *
 * The `webpackIgnore` magic comment prevents rspack from bundling
 * or code-splitting libomemo.esm.js. It is served as a companion
 * file alongside converse-headless.js and loaded at runtime.
 *
 * In test environments, window.libomemo is mocked and used directly.
 *
 * @returns {Promise<typeof import('libomemo.js')>}
 */
function getCrypto() {
    if (_promise) {
        return _promise;
    }

    // In tests, window.libomemo is set by the mock (src/shared/tests/mock.js)
    if (typeof window !== 'undefined' && window.libomemo) {
        _promise = Promise.resolve(/** @type {typeof import('libomemo.js')} */ (window.libomemo));
        return _promise;
    }

    const promise = (_loader ?? loadFromAssetDirectory)().catch((e) => {
        src_log.error('Failed to load libomemo.js crypto library');
        src_log.error(e);
        _promise = null;
        throw e;
    });

    // Callers that await this still see the rejection; this only stops one that
    // doesn't from surfacing as an unhandled rejection, which terminates a
    // Node process by default. OMEMO failing to load must degrade to "no OMEMO"
    // (see `initOMEMO`), never take the client down with it.
    promise.catch(() => {});

    _promise = promise;
    return _promise;
}

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/profiles.js



const { u: profiles_u, Strophe: profiles_Strophe } = api_public.env;

/**
 * Base model for the OMEMO models (Device, DeviceList) that carry an OMEMO
 * protocol version in their `version` attribute, defaulting to the legacy
 * (0.3.0) version when unset.
 * @template {import('../../shared/types').ModelAttributes} [T=import('../../shared/types').ModelAttributes]
 * @extends {Model<T>}
 */
class OMEMOVersionAwareModel extends skeletor_esm_Model {
    /** @returns {import('./types').OMEMOVersion} */
    getVersion() {
        return this.get('version') || profiles_Strophe.NS.OMEMO;
    }

    isV2() {
        return this.getVersion() === profiles_Strophe.NS.OMEMO2;
    }
}

/**
 * Strip the leading 0x05 encoding byte from a 33-byte Curve25519 key produced
 * by libomemo.js, returning the raw 32-byte value as base64. Used when
 * publishing v2 bundle elements.
 * @param {string} b64 - base64-encoded 33-byte key
 * @returns {string}
 */
function stripKeyByte(b64) {
    const buf = profiles_u.base64ToArrayBuffer(b64);
    return profiles_u.arrayBufferToBase64(buf.slice(1));
}

/**
 * Returns the protocol profile for a given OMEMO version.
 * @param {import('./types').OMEMOVersion} version
 * @returns {import('./types').OMEMOProfile}
 */
function getProfile(version) {
    if (version === profiles_Strophe.NS.OMEMO2) {
        return {
            version: profiles_Strophe.NS.OMEMO2,
            get devicelist_node() {
                return converse.env.Strophe.NS.OMEMO2_DEVICELIST;
            },
            get bundle_node_prefix() {
                return converse.env.Strophe.NS.OMEMO2_BUNDLES;
            },
            usesSCE: true,
            encodePubKey: stripKeyByte,
        };
    }
    return {
        version: profiles_Strophe.NS.OMEMO,
        get devicelist_node() {
            return converse.env.Strophe.NS.OMEMO_DEVICELIST;
        },
        get bundle_node_prefix() {
            return converse.env.Strophe.NS.OMEMO_BUNDLES;
        },
        usesSCE: false,
        encodePubKey: (/** @type {string} */ b64) => b64,
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/devicelist.js









const { Strophe: devicelist_Strophe, stx: devicelist_stx, sizzle: devicelist_sizzle, u: devicelist_u } = api_public.env;

/**
 * @extends {OMEMOVersionAwareModel<import('../../shared/types').JIDModelAttributes>}
 */
class DeviceList extends OMEMOVersionAwareModel {
    /**
     * Whether the most recent server fetch for this device list failed
     * (timeout/error) rather than authoritatively returning no devices.
     * @type {boolean}
     */
    #last_fetch_failed = false;

    get idAttribute() {
        return 'jid';
    }

    initialize() {
        super.initialize();
        this.initialized = this.initDevices();
    }

    initDevices() {
        this.devices = new shared_converse.exports.Devices(null, { version: this.getVersion() });
        const bare_jid = shared_converse.session.get('bare_jid');
        const version_suffix = this.isV2() ? '-omemo2' : '';
        const id = `converse.devicelist-${bare_jid}-${this.get('jid')}${version_suffix}`;
        devicelist_u.initStorage(this.devices, id);
        return this.fetchDevices();
    }

    /**
     * @param {import('./devices').default} collection
     */
    /**
     * Whether the most recent server fetch for this device list failed
     * (timeout or error stanza), as opposed to authoritatively returning no
     * devices (an empty list or item-not-found). Callers use this to decide
     * whether an empty device list is worth re-fetching: a genuine "no devices"
     * answer is not (a PEP push will inform us if that changes, since we
     * advertise `+notify`), but a transient failure is.
     * @returns {boolean}
     */
    get lastFetchFailed() {
        return this.#last_fetch_failed;
    }

    async onDevicesFound(collection) {
        if (collection.length === 0) {
            let ids = [];
            try {
                ids = await this.fetchDevicesFromServer();
                this.#last_fetch_failed = false;
            } catch (e) {
                // We deliberately leave this (empty) device list in place
                // instead of destroying it. `onDevicesFound` runs from within
                // `initialize`, so destroying here would orphan the model
                // mid-initialization (removing it from the collection and
                // storage while `this.initialized` is still pending, and
                // running `publishCurrentDevice` on a destroyed model).
                // Transient failures recover instead via `fetchDevices(true)`
                // in `getDevicesForContact`, and via a fresh server fetch on
                // the next reload.
                if (e === null) {
                    this.#last_fetch_failed = true;
                    src_log.error(`Timeout error while fetching OMEMO devices for ${this.get('jid')}`);
                } else if (devicelist_u.isElement(e) && (await parseErrorStanza(e)) instanceof ItemNotFoundError) {
                    // An authoritative "no such node" — the contact simply has
                    // no device list for this OMEMO version. Not a failure, so
                    // we don't keep retrying on every send.
                    this.#last_fetch_failed = false;
                    src_log.debug(`No OMEMO devices found for ${this.get('jid')}`);
                } else {
                    this.#last_fetch_failed = true;
                    src_log.error(`Could not fetch OMEMO devices for ${this.get('jid')}`);
                    src_log.error(e);
                }
            }
            const bare_jid = shared_converse.session.get('bare_jid');
            if (this.get('jid') === bare_jid) {
                this.publishCurrentDevice(ids);
            }
        } else {
            this.#last_fetch_failed = false;
        }
    }

    /**
     * @param {boolean} [refresh=false] - Discard any previously memoized
     *      result and fetch the devices anew. Used to recover from a state
     *      where an earlier fetch failed or the contact had not yet published
     *      their device list.
     */
    fetchDevices(refresh = false) {
        if (refresh) {
            this._devices_promise = undefined;
        }
        if (this._devices_promise === undefined) {
            this._devices_promise = new Promise((resolve) => {
                this.devices.fetch({
                    success: (c) => resolve(this.onDevicesFound(c)),
                    error: (_, e) => {
                        src_log.error(e);
                        resolve();
                    },
                });
            });
        }
        return this._devices_promise;
    }

    /**
     * @returns {Promise<string>}
     */
    async getOwnDeviceId() {
        const { omemo_store } = shared_converse.state;
        let device_id = omemo_store.get('device_id');
        if (!device_id) {
            // No bundle at all. Generate one (creates device in legacy list)
            await omemo_store.generateBundle();
            device_id = omemo_store.get('device_id');
        }
        if (!this.devices.get(device_id)) {
            // generateBundle always creates the device in the legacy collection.
            // For the v2 list we create a bare entry so publishDevices() includes us.
            const jid = this.get('jid');
            await this.devices.create({ id: device_id, jid }, { promise: true });
        }
        return device_id;
    }

    /**
     * @param {string[]} device_ids
     */
    async publishCurrentDevice(device_ids) {
        const bare_jid = shared_converse.session.get('bare_jid');
        if (this.get('jid') !== bare_jid) {
            return; // We only publish for ourselves.
        }
        await shared_api.omemo.session.restore();

        if (!shared_converse.state.omemo_store) {
            // Happens during tests. The connection gets torn down
            // before publishCurrentDevice has time to finish.
            src_log.debug('publishCurrentDevice: omemo_store is not defined, likely a timing issue');
            return;
        }
        if (!device_ids.includes(await this.getOwnDeviceId())) {
            return this.publishDevices();
        }
    }

    /**
     * @returns {Promise<import('./device').default[]>}
     */
    async fetchDevicesFromServer() {
        const bare_jid = shared_converse.session.get('bare_jid');
        const node = this.isV2() ? devicelist_Strophe.NS.OMEMO2_DEVICELIST : devicelist_Strophe.NS.OMEMO_DEVICELIST;
        const stanza = devicelist_stx`
            <iq type='get' from='${bare_jid}' to='${this.get('jid')}' xmlns="jabber:client">
                <pubsub xmlns='${devicelist_Strophe.NS.PUBSUB}'>
                    <items node='${node}'/>
                </pubsub>
            </iq>`;

        const iq = await shared_api.sendIQ(stanza);

        let device_ids;
        if (this.isV2()) {
            const selector = `devices[xmlns="${devicelist_Strophe.NS.OMEMO2}"] device`;
            device_ids = devicelist_sizzle(selector, iq).map((d) => d.getAttribute('id'));
        } else {
            const selector = `list[xmlns="${devicelist_Strophe.NS.OMEMO}"] device`;
            device_ids = devicelist_sizzle(selector, iq).map((d) => d.getAttribute('id'));
        }

        const jid = this.get('jid');
        return Promise.all(device_ids.map((id) => this.devices.create({ id, jid }, { promise: true })));
    }

    /**
     * Sends an IQ stanza to the current user's "devices" PEP node to
     * ensure that all devices are published for potential chat partners to see.
     * See: https://xmpp.org/extensions/attic/xep-0384-0.3.0.html#usecases-announcing
     */
    publishDevices() {
        const active_devices = this.devices.filter((d) => d.get('active'));
        let item;
        if (this.isV2()) {
            item = devicelist_stx`
                <item id='current'>
                    <devices xmlns='${devicelist_Strophe.NS.OMEMO2}'>
                        ${active_devices.map((d) => devicelist_stx`<device id='${d.get('id')}'/>`)}
                    </devices>
                </item>`;
        } else {
            item = devicelist_stx`
                <item id='current'>
                    <list xmlns='${devicelist_Strophe.NS.OMEMO}'>
                        ${active_devices.map((d) => devicelist_stx`<device id='${d.get('id')}'/>`)}
                    </list>
                </item>`;
        }
        const node = this.isV2() ? devicelist_Strophe.NS.OMEMO2_DEVICELIST : devicelist_Strophe.NS.OMEMO_DEVICELIST;
        const options = { access_model: 'open' };
        return shared_api.pubsub.publish(null, node, item, options, false);
    }

    /**
     * @param {string[]} device_ids
     */
    async removeOwnDevices(device_ids) {
        const bare_jid = shared_converse.session.get('bare_jid');
        if (this.get('jid') !== bare_jid) {
            throw new Error("Cannot remove devices from someone else's device list");
        }
        await Promise.all(
            device_ids
                .map((id) => this.devices.get(id))
                .map(
                    (d) =>
                        new Promise((resolve) =>
                            d.destroy({
                                success: resolve,
                                error: (_, e) => {
                                    src_log.error(e);
                                    resolve();
                                },
                            }),
                        ),
                ),
        );
        return this.publishDevices();
    }
}

/* export default */ const omemo_devicelist = (DeviceList);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/devicelists.js



/**
 * @extends {Collection<DeviceList>}
 */
class DeviceLists extends Collection {
    constructor() {
        super();
        this.model = omemo_devicelist;
    }
}

/* export default */ const devicelists = (DeviceLists);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/versioned-store.js


const { u: versioned_store_u, Strophe: versioned_store_Strophe } = api_public.env;

/**
 * The session/identity-key storage prefix for a given OMEMO version. Legacy is
 * unprefixed (`''`) so sessions persisted by older Converse versions keep
 * working without migration; v2 carries a `v2:` prefix.
 * @param {import('./types').OMEMOVersion} version
 */
function prefixForVersion(version) {
    return version === versioned_store_Strophe.NS.OMEMO2 ? 'v2:' : '';
}

/**
 * A thin proxy around OMEMOStore that namespaces session and identity-key
 * storage by OMEMO version.  Legacy sessions use unprefixed keys (no
 * migration needed); v2 sessions use a `v2:` prefix so the two protocol
 * versions never collide inside the same underlying model.
 *
 * Prekeys and the identity keypair are shared across both versions — only
 * the signed prekey and the session/trust data are version-specific.
 */
class VersionedOMEMOStore {
    /** @type {import('./store.js').default} */
    #base;
    /** @type {import('./types').OMEMOVersion} */
    #version;
    /** @type {string} */
    #prefix;

    /**
     * @param {import('./store.js').default} base_store
     * @param {import('./types').OMEMOVersion} version
     */
    constructor(base_store, version) {
        this.#base = base_store;
        this.#version = version;
        this.#prefix = prefixForVersion(version);
    }

    getIdentityKeyPair() {
        return this.#base.getIdentityKeyPair();
    }
    getLocalRegistrationId() {
        return this.#base.getLocalRegistrationId();
    }

    /** @param {string} address @param {ArrayBuffer} identity_key @param {unknown} direction */
    isTrustedIdentity(address, identity_key, direction) {
        return this.#base.isTrustedIdentity(this.#prefix + address, identity_key, direction);
    }

    /** @param {string} address @param {ArrayBuffer} identity_key */
    saveIdentity(address, identity_key) {
        return this.#base.saveIdentity(this.#prefix + address, identity_key);
    }

    /** @param {string|number} key_id */
    loadPreKey(key_id) {
        return this.#base.loadPreKey(key_id);
    }

    getPreKeys() {
        return this.#base.getPreKeys();
    }

    /** @param {number} key_id @param {import('libomemo.js').KeyPair} key_pair */
    storePreKey(key_id, key_pair) {
        return this.#base.storePreKey(key_id, key_pair);
    }

    /** @param {string|number} key_id */
    removePreKey(key_id) {
        return this.#base.removePreKey(key_id);
    }

    /** @param {string|number} _key_id */
    loadSignedPreKey(_key_id) {
        const attr = this.#version === versioned_store_Strophe.NS.OMEMO2 ? 'signed_prekey_omemo2' : 'signed_prekey';
        const res = this.#base.get(attr);
        if (res) {
            return {
                keyPair: {
                    privKey: versioned_store_u.base64ToArrayBuffer(res.privKey),
                    pubKey: versioned_store_u.base64ToArrayBuffer(res.pubKey),
                },
            };
        }
    }

    /** @param {number} key_id */
    removeSignedPreKey(key_id) {
        return this.#base.removeSignedPreKey(key_id);
    }

    /** @param {string} address */
    loadSession(address) {
        return this.#base.loadSession(this.#prefix + address);
    }

    /** @param {string} address @param {string} record */
    storeSession(address, record) {
        return this.#base.storeSession(this.#prefix + address, record);
    }

    /** @param {string} address */
    removeSession(address) {
        return this.#base.removeSession(this.#prefix + address);
    }

    /** @param {string} address @returns {string|undefined} */
    loadHeartbeatKey(address) {
        return this.#base.loadHeartbeatKey(this.#prefix + address);
    }

    /** @param {string} address @param {string} key_b64 @returns {Promise<void>} */
    storeHeartbeatKey(address, key_b64) {
        return this.#base.storeHeartbeatKey(this.#prefix + address, key_b64);
    }

    /** @param {string} [address=''] */
    removeAllSessions(address = '') {
        // We can't delegate to the base store's removeAllSessions: legacy keys
        // are unprefixed (for backward compat), which makes the legacy prefix
        // ('') a string-prefix of every versioned key (e.g. `sessionv2:…`), so a
        // legacy wipe there would also clear v2 sessions. Instead we scope the
        // wipe to this version's keys here, where we know our prefix, and
        // exclude the other versions' prefixes that ours would falsely match.
        const match = 'session' + this.#prefix + address;

        // Only non-empty version prefixes can be falsely matched by ours; the
        // legacy prefix ('') is shorter than every key, so it never needs
        // excluding. So a legacy wipe excludes 'v2:', and a 'v2:' wipe excludes
        // nothing (no other prefix starts with it).
        const exclude = [prefixForVersion(versioned_store_Strophe.NS.OMEMO2)]
            .filter((p) => p !== this.#prefix && p.startsWith(this.#prefix))
            .map((p) => 'session' + p);
        Object.keys(this.#base.attributes)
            .filter((key) => key.startsWith(match) && !exclude.some((e) => key.startsWith(e)))
            .forEach((key) => this.#base.removeSession(key.replace(/^session/, '')));
        return Promise.resolve();
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/sce.js
/**
 * SCE (Stanza Content Encryption, XEP-0420) payload encryption for OMEMO 2.
 *
 * Implements the crypto layer required by XEP-0384 when using urn:xmpp:omemo:2:
 *   - AES-256-CBC + HMAC-SHA-256 authenticated encryption
 *   - HKDF-SHA-256 key derivation (80 bytes → encKey || authKey || IV)
 *   - The 48-byte tuple (key ‖ truncated-HMAC) is what each per-device
 *     SessionCipher.encrypt() receives
 *   - The SCE envelope wraps the plaintext XML in <envelope xmlns='urn:xmpp:sce:1'>
 */


const { Strophe: sce_Strophe, u: sce_u, stx: sce_stx, sizzle: sce_sizzle } = api_public.env;

const HKDF_INFO = 'OMEMO Payload';

/**
 * Constant-time comparison of two byte arrays. Unlike a short-circuiting
 * compare (e.g. `Array.every`), the running time does not depend on where the
 * first differing byte is, so it leaks no information about the expected value
 * to a timing attacker. Used to verify the SCE HMAC tag.
 *
 * We hand-roll this rather than use `crypto.subtle.verify('HMAC', …)` (which
 * compares internally) because SCE truncates the HMAC to 16 bytes, and
 * `subtle.verify` only checks the full 32-byte SHA-256 output — there's no
 * supported way to verify a truncation. Node's `crypto.timingSafeEqual` isn't
 * an option either: it's absent in the browser, our production target.
 * @param {Uint8Array} a
 * @param {Uint8Array} b
 * @returns {boolean}
 */
function constantTimeEqual(a, b) {
    // Fold the length difference into the accumulator so unequal-length inputs
    // can never compare equal, without an early return.
    let diff = a.length ^ b.length;
    const len = Math.max(a.length, b.length);
    for (let i = 0; i < len; i++) {
        diff |= (a[i] ?? 0) ^ (b[i] ?? 0);
    }
    return diff === 0;
}

/**
 * Derive encKey, authKey, IV from a random 32-byte content key using HKDF-SHA-256.
 * @param {ArrayBuffer} content_key - 32 random bytes
 * @returns {Promise<{encKey: ArrayBuffer, authKey: ArrayBuffer, iv: ArrayBuffer}>}
 */
async function deriveKeys(content_key) {
    const salt = new ArrayBuffer(32); // 32 zero bytes
    const ikm = await crypto.subtle.importKey('raw', content_key, 'HKDF', false, ['deriveBits']);
    const derived = await crypto.subtle.deriveBits(
        {
            name: 'HKDF',
            hash: 'SHA-256',
            salt,
            info: new TextEncoder().encode(HKDF_INFO),
        },
        ikm,
        640, // 80 bytes = 640 bits
    );
    return {
        encKey: derived.slice(0, 32),
        authKey: derived.slice(32, 64),
        iv: derived.slice(64, 80),
    };
}

/**
 * Build the SCE <envelope> XML string for a given message body.
 *
 * Affixes per XEP-0384 SCE profile:
 *   - <rpad> MUST
 *   - <from> SHOULD (included)
 *   - <to> MUST for MUC (included when muc_jid is provided)
 *   - <time> MAY (omitted for now)
 *
 * The `extensions` are extra element builders (XEP-0372 references, XEP-0461
 * reply, OOB url, spoiler) spliced into `<content>` right after `<body>`, so
 * body-coupled metadata is encrypted alongside the body instead of leaking in
 * cleartext. They live inside the authenticated `<content>` and are therefore
 * covered by the SCE HMAC.
 *
 * `body` may be empty/null for a metadata-only message (e.g. an encrypted
 * chat state, marker or reaction), in which case no `<body>` element is
 * emitted and `<content>` carries only the `extensions`.
 *
 * @param {string|null} body - plaintext message body (omitted when falsy)
 * @param {{from_jid: string, to_jid: string|null}} affixes
 * @param {import('strophe.js').Builder[]} [extensions] - extra <content> children
 * @returns {import('strophe.js').Builder}
 */
function buildSCEEnvelope(body, { from_jid, to_jid }, extensions = []) {
    const rpad_len = 1 + Math.floor(Math.random() * 100);
    const rpad = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(rpad_len))));

    return sce_stx`
        <envelope xmlns="${sce_Strophe.NS.SCE}">
            <content>${body ? sce_stx`<body xmlns="jabber:client">${body}</body>` : ''}${extensions}</content>
            <rpad>${rpad}</rpad>
            <from xmlns="${sce_Strophe.NS.SCE}" jid="${from_jid}"/>
            ${to_jid ? sce_stx`<to xmlns="${sce_Strophe.NS.SCE}" jid="${to_jid}"/>` : ''}
        </envelope>`;
}

/**
 * Encrypt a message body using the SCE/OMEMO 2 scheme.
 *
 * Returns the 48-byte key_and_tag (content_key ‖ truncated-HMAC) as an
 * ArrayBuffer — this is what gets encrypted with SessionCipher per device —
 * and the base64-encoded AES-256-CBC ciphertext as the <payload> value.
 *
 * @param {string|null} plaintext - the message body to encrypt (omitted when falsy)
 * @param {{from_jid: string, to_jid: string|null}} affixes
 * @param {import('strophe.js').Builder[]} [extensions] - body-coupled metadata elements
 * @returns {Promise<{key_and_tag: ArrayBuffer, payload: string}>}
 */
async function encryptSCE(plaintext, affixes, extensions = []) {
    // Random 32-byte content key
    const content_key = crypto.getRandomValues(new Uint8Array(32)).buffer;
    const { encKey, authKey, iv } = await deriveKeys(content_key);

    const envelope = buildSCEEnvelope(plaintext, affixes, extensions);
    const plaintext_bytes = new TextEncoder().encode(envelope.toString());

    // AES-256-CBC encryption
    const aes_key = await crypto.subtle.importKey('raw', encKey, 'AES-CBC', false, ['encrypt']);
    const ciphertext = await crypto.subtle.encrypt({ name: 'AES-CBC', iv }, aes_key, plaintext_bytes);

    // HMAC-SHA-256 over ciphertext, truncated to 16 bytes
    const hmac_key = await crypto.subtle.importKey('raw', authKey, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
    const hmac_full = await crypto.subtle.sign('HMAC', hmac_key, ciphertext);
    const hmac_16 = hmac_full.slice(0, 16);

    // 48-byte tuple: content_key(32) ‖ HMAC(16)
    const key_and_tag = new Uint8Array(48);
    key_and_tag.set(new Uint8Array(content_key), 0);
    key_and_tag.set(new Uint8Array(hmac_16), 32);

    return {
        key_and_tag: key_and_tag.buffer,
        payload: sce_u.arrayBufferToBase64(ciphertext),
    };
}

/**
 * Decrypt an SCE/OMEMO 2 payload.
 *
 * Returns both the plaintext body string and the decrypted `<content>` element,
 * so callers can re-run the normal stanza parsers (references/reply/oob/spoiler,
 * but also chat states / markers / reactions) against the authenticated content.
 * `content` is `null` only when the envelope carries no `<content>` element;
 * `body` is `null` when there's no `<body>` — i.e. a metadata-only message.
 *
 * @param {ArrayBuffer} key_and_tag - 48-byte tuple: content_key(32) ‖ HMAC(16)
 * @param {string} payload_b64 - base64-encoded AES-256-CBC ciphertext
 * @param {{sender_jid: string, to_jid?: string|null}} expected_affixes - for validation
 * @returns {Promise<{body: string|null, content: Element|null}>}
 */
async function decryptSCE(key_and_tag, payload_b64, expected_affixes) {
    if (key_and_tag.byteLength !== 48) {
        throw new Error(`SCE key_and_tag must be 48 bytes, got ${key_and_tag.byteLength}`);
    }

    const content_key = key_and_tag.slice(0, 32);
    const expected_hmac = key_and_tag.slice(32, 48);
    const { encKey, authKey, iv } = await deriveKeys(content_key);

    const ciphertext = sce_u.base64ToArrayBuffer(payload_b64);

    // Verify HMAC before decrypting
    const hmac_key = await crypto.subtle.importKey('raw', authKey, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
    const hmac_full = await crypto.subtle.sign('HMAC', hmac_key, ciphertext);
    const hmac_16 = new Uint8Array(hmac_full.slice(0, 16));
    const expected = new Uint8Array(expected_hmac);
    if (!constantTimeEqual(hmac_16, expected)) {
        throw new Error('SCE HMAC verification failed');
    }

    // AES-256-CBC decrypt
    const aes_key = await crypto.subtle.importKey('raw', encKey, 'AES-CBC', false, ['decrypt']);
    const plaintext_bytes = await crypto.subtle.decrypt({ name: 'AES-CBC', iv }, aes_key, ciphertext);
    const envelope_xml = new TextDecoder().decode(plaintext_bytes);

    const content = parseSCEEnvelope(envelope_xml, expected_affixes);
    const body = content ? (sce_sizzle('> body', content).pop()?.textContent ?? null) : null;
    return { body, content };
}

/**
 * Parse an SCE <envelope>, validate its affixes and return the decrypted
 * `<content>` element (or `null` for a heartbeat with no `<content>`/`<body>`).
 * @param {string} envelope_xml
 * @param {{sender_jid: string, to_jid?: string|null}} expected_affixes
 * @returns {Element|null}
 */
function parseSCEEnvelope(envelope_xml, { sender_jid, to_jid }) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(envelope_xml, 'text/xml');

    const envelope = doc.documentElement;
    if (!envelope || envelope.localName !== 'envelope' || envelope.namespaceURI !== sce_Strophe.NS.SCE) {
        throw new Error('SCE: no <envelope> found in decrypted payload');
    }

    // Validate <from> affix (SHOULD be present, MUST match sender if present)
    const from_el = sce_sizzle(`> from[xmlns="${sce_Strophe.NS.SCE}"]`, envelope).pop();
    if (from_el) {
        const from_jid = from_el.getAttribute('jid');
        if (sender_jid && !sce_u.isSameBareJID(from_jid, sender_jid)) {
            throw new Error(`SCE affix mismatch: <from> is ${from_jid}, expected ${sender_jid}`);
        }
    }

    // Validate <to> affix (MUST be present and correct for MUC)
    if (to_jid) {
        const to_el = sce_sizzle(`> to[xmlns="${sce_Strophe.NS.SCE}"]`, envelope).pop();
        if (!to_el) {
            throw new Error('SCE: missing required <to> affix for MUC message');
        }
        if (!sce_u.isSameBareJID(to_el.getAttribute('jid'), to_jid)) {
            throw new Error(`SCE affix mismatch: <to> is ${to_el.getAttribute('jid')}, expected ${to_jid}`);
        }
    }

    // Return the <content> whenever it's present, even without a <body>. A
    // payload-bearing SCE envelope with no body is a metadata-only message
    // (chat state / marker / reaction), NOT a heartbeat — true OMEMO:2
    // heartbeats carry no <payload> at all and never reach this code. The
    // caller decides what to do with a bodyless content.
    return sce_sizzle('> content', envelope).pop() ?? null;
}

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/utils.js















const { u: omemo_utils_u, Strophe: omemo_utils_Strophe, stx: omemo_utils_stx, Stanza: omemo_utils_Stanza } = api_public.env;
const { arrayBufferToHex: utils_arrayBufferToHex, base64ToArrayBuffer: utils_base64ToArrayBuffer } = omemo_utils_u;

// Affiliations whose members are valid recipients of OMEMO-encrypted MUC
// messages (XEP-0384 §MUC). Excludes `outcast` (banned) and `none`.
const OMEMO_MUC_AFFILIATIONS = ['member', 'admin', 'owner'];

/**
 * Returns a VersionedOMEMOStore proxy for the given OMEMO version.
 *
 * The proxy implements the subset of libomemo's `OMEMOStore` interface that
 * `SessionCipher` and `SessionBuilder` actually exercise at runtime (the
 * crypto/session methods); the interface's raw key-value members
 * (`store`/`put`/`get`/`remove`) are part of the reference `InMemoryStore` and
 * are never called on a consumer store, so we present the proxy as an
 * `OMEMOStore` here.
 * @param {import('./types').OMEMOVersion} version
 * @returns {import('libomemo.js').OMEMOStore}
 */
function getVersionedStore(version) {
    return /** @type {import('libomemo.js').OMEMOStore} */ (
        /** @type {unknown} */ (new VersionedOMEMOStore(shared_converse.state.omemo_store, version))
    );
}

/**
 * @param {Element} stanza
 */
async function updateDevicesFromStanza(stanza) {
    // Detect which version's devicelist was pushed
    let items_el = sizzle(`items[node="${omemo_utils_Strophe.NS.OMEMO_DEVICELIST}"]`, stanza).pop();
    let version = omemo_utils_Strophe.NS.OMEMO;

    if (!items_el) {
        items_el = sizzle(`items[node="${omemo_utils_Strophe.NS.OMEMO2_DEVICELIST}"]`, stanza).pop();
        if (!items_el) return;
        version = omemo_utils_Strophe.NS.OMEMO2;
    }

    let device_ids;
    if (version === omemo_utils_Strophe.NS.OMEMO2) {
        const sel = `item devices[xmlns="${omemo_utils_Strophe.NS.OMEMO2}"] device`;
        device_ids = sizzle(sel, items_el).map((d) => d.getAttribute('id'));
    } else {
        const sel = `item list[xmlns="${omemo_utils_Strophe.NS.OMEMO}"] device`;
        device_ids = sizzle(sel, items_el).map((d) => d.getAttribute('id'));
    }

    const jid = stanza.getAttribute('from');
    const devicelist = await shared_api.omemo.devicelists.get(jid, true, version);
    const devices = devicelist.devices;
    const removed_ids = devices.pluck('id').filter(/** @param {string} id */ (id) => !device_ids.includes(id));

    const bare_jid = shared_converse.session.get('bare_jid');

    removed_ids.forEach(
        /** @param {string} id */ (id) => {
            if (jid === bare_jid && id === shared_converse.state.omemo_store.get('device_id')) {
                return; // We don't set the current device as inactive
            }
            devices.get(id).save('active', false);
        },
    );
    device_ids.forEach(
        /** @param {string} device_id */ (device_id) => {
            const device = devices.get(device_id);
            if (device) {
                device.save('active', true);
            } else {
                devices.create({ id: device_id, jid });
            }
        },
    );
    if (omemo_utils_u.isSameBareJID(bare_jid, jid)) {
        // Make sure our own device is on the list
        // (i.e. if it was removed, add it again).
        devicelist.publishCurrentDevice(device_ids);
    }
}

/**
 * @param {Element} stanza
 */
async function updateBundleFromStanza(stanza) {
    const items_el = sizzle(`items`, stanza).pop();
    if (!items_el) return;

    const node = items_el.getAttribute('node');
    const item_el = sizzle(`item`, items_el).pop();
    let version, device_id;

    if (node === omemo_utils_Strophe.NS.OMEMO2_BUNDLES) {
        // omemo:2: a single bundles node; the device id is the item id.
        version = omemo_utils_Strophe.NS.OMEMO2;
        device_id = item_el?.getAttribute('id');
    } else if (node.startsWith(omemo_utils_Strophe.NS.OMEMO_BUNDLES + ':')) {
        // legacy 0.3.0: a per-device node, device id is the node suffix.
        version = omemo_utils_Strophe.NS.OMEMO;
        device_id = node.slice(omemo_utils_Strophe.NS.OMEMO_BUNDLES.length + 1);
    } else {
        return;
    }
    if (!device_id) return;

    const jid = stanza.getAttribute('from');
    const bundle_el = sizzle(`bundle`, item_el).pop();
    const devicelist = await shared_api.omemo.devicelists.get(jid, true, version);
    const device = devicelist.devices.get(device_id) || devicelist.devices.create({ 'id': device_id, jid });

    const bundle = version === omemo_utils_Strophe.NS.OMEMO2 ? omemo_utils_u.omemo.parseBundleV2(bundle_el) : omemo_utils_u.omemo.parseBundle(bundle_el);
    // A push without a parseable <bundle> (malformed or emptied item) yields
    // null; don't overwrite a previously cached good bundle with it.
    if (bundle) device.save({ bundle });
}

/**
 * @param {Element} message
 */
async function handlePEPPush(message) {
    try {
        if (sizzle(`event[xmlns="${omemo_utils_Strophe.NS.PUBSUB}#event"]`, message).length) {
            await shared_api.waitUntil('OMEMOInitialized');
            await updateDevicesFromStanza(message);
            await updateBundleFromStanza(message);
        }
    } catch (e) {
        src_log.error(e);
    }
}

/**
 * Register a pubsub handler for devices pushed from other connected clients
 */
function utils_registerPEPPushHandler() {
    shared_api.connection.get().addHandler(
        /** @param {Element} message */
        (message) => {
            handlePEPPush(message);
            return true;
        },
        null,
        'message',
    );
}

async function fetchDeviceLists() {
    const bare_jid = shared_converse.session.get('bare_jid');

    shared_converse.state.devicelists = new devicelists();
    const id = `converse.devicelists-${bare_jid}`;
    initStorage(shared_converse.state.devicelists, id);
    await new Promise((resolve) => {
        shared_converse.state.devicelists.fetch({
            success: resolve,
            error: (_m, e) => {
                src_log.error(e);
                resolve();
            },
        });
    });

    shared_converse.state.devicelists_v2 = new devicelists();
    const id_v2 = `converse.devicelists-v2-${bare_jid}`;
    initStorage(shared_converse.state.devicelists_v2, id_v2);
    await new Promise((resolve) => {
        shared_converse.state.devicelists_v2.fetch({
            success: resolve,
            error: (_m, e) => {
                src_log.error(e);
                resolve();
            },
        });
    });

    // Ensure our own legacy device list exists (creates + publishes if needed).
    // This is awaited (unlike the v2 fetch below) because OMEMO initialization
    // depends on it: by the time `session.restore` runs and `OMEMOInitialized`
    // fires, our own device must already be present in (and published to) the
    // legacy device list, otherwise consumers race against `publishCurrentDevice`.
    await shared_api.omemo.devicelists.get(bare_jid, true);
    // Start v2 device list initialization without blocking legacy OMEMO setup.
    // The v2 PEP fetch can take time and failing it (e.g. on servers that don't
    // support omemo:2) must not prevent the legacy path from working.
    shared_api.omemo.devicelists.get(bare_jid, true, omemo_utils_Strophe.NS.OMEMO2).catch((e) => src_log.error(e));
}

/**
 * Loads (and caches on `_converse.state`) the persistent store that remembers
 * whether OMEMO encryption was last enabled or disabled for a given chat.
 *
 * Unlike the chatbox itself (which is removed from storage when the chat is
 * closed), this store persists across chat-close and re-login.
 * @returns {Promise<Model<{id: string}>>}
 */
async function fetchOMEMOActiveStates() {
    if (shared_converse.state.omemo_active_states) {
        return shared_converse.state.omemo_active_states;
    }
    const bare_jid = shared_converse.session.get('bare_jid');
    const id = `converse.omemo-active-states-${bare_jid}`;
    const model = new skeletor_esm_Model({ id });
    initStorage(model, id);
    await new Promise((resolve) => model.fetch({ success: resolve, error: resolve }));
    shared_converse.state.omemo_active_states = model;
    return model;
}

/**
 * Returns the remembered OMEMO active state for a chat, or `undefined` if the
 * user has never made an explicit choice for it.
 * @param {string} jid
 * @returns {boolean|undefined}
 */
function getOMEMOActiveState(jid) {
    return /** @type {boolean|undefined} */ (shared_converse.state.omemo_active_states?.get(jid));
}

/**
 * Persists the user's explicit choice to enable/disable OMEMO for a chat, so
 * that it's remembered the next time the chat is opened.
 * @param {string} jid
 * @param {boolean} active
 */
function setOMEMOActiveState(jid, active) {
    shared_converse.state.omemo_active_states?.save({ [jid]: active });
}

/**
 * @param {boolean} reconnecting
 */
async function initOMEMO(reconnecting) {
    if (reconnecting) {
        return;
    }
    if (!shared_converse.state.config.get('trusted') || shared_api.settings.get('clear_cache_on_logout')) {
        src_log.warn('Not initializing OMEMO, since this browser is not trusted or clear_cache_on_logout is set to true');
        return;
    }
    try {
        await fetchDeviceLists();
        await fetchOMEMOActiveStates();
        const bundle_changed = await shared_api.omemo.session.restore();

        // The bundle is persistent PubSub data, so we only (re)publish it when it
        // changed or when we haven't confirmed the current one reached the server.
        // `bundle_published` is persisted and set only after a successful publish.
        // Unlike a resumed-session check, it also handles a session established
        // out-of-band (e.g. a BOSH prebind) whose bundle was never published, and
        // it recovers from a failed publish. Prekey consumption republishes on its
        // own, see `decryptPrekeyWhisperMessage`.
        const { omemo_store } = shared_converse.state;
        if (bundle_changed || !omemo_store.get('bundle_published')) {
            await omemo_store.publishBundle();
        }
    } catch (e) {
        src_log.error('Could not initialize OMEMO support');
        src_log.error(e);
        return;
    }
    /**
     * Triggered once OMEMO support has been initialized
     * @event _converse#OMEMOInitialized
     * @example _converse.api.listen.on('OMEMOInitialized', () => { ... });
     */
    shared_api.trigger('OMEMOInitialized');
}

/**
 * @param {String} jid - The Jabber ID for which the device list will be returned.
 * @param {boolean} [create=false] - Set to `true` if the device list should be
 *      created if it cannot be found.
 * @param {import('./types').OMEMOVersion} [version] - Defaults to legacy version.
 */
async function getDeviceList(jid, create = false, version = omemo_utils_Strophe.NS.OMEMO) {
    const collection = version === omemo_utils_Strophe.NS.OMEMO2 ? shared_converse.state.devicelists_v2 : shared_converse.state.devicelists;

    const list = collection.get(jid) || (create ? collection.create({ jid, version }) : null);
    await list?.initialized;
    return list;
}

/**
 * @param {import('./device.js').default} device
 */
async function generateFingerprint(device) {
    if (device.get('bundle')?.fingerprint) {
        return;
    }
    const bundle = await device.getBundle();
    const raw = utils_base64ToArrayBuffer(bundle['identity_key']);
    // For legacy (33-byte Curve25519), strip the leading 0x05 encoding byte
    // so the display fingerprint is always the 64-char (32-byte) key hex.
    // For v2 (32-byte Ed25519), the key has no leading byte.
    const fp_buf = device.isV2 && device.isV2() ? raw : raw.slice(1);
    bundle['fingerprint'] = utils_arrayBufferToHex(fp_buf);
    device.save('bundle', bundle);
    device.trigger('change:bundle'); // Doesn't get triggered automatically due to pass-by-reference
}

/**
 * Surface a user-facing alert for a failed encrypted send and re-throw, so the
 * send pipeline (the `createMessageStanza` handler) aborts. Always throws.
 * @param {Error|errors.IQError|errors.UserFacingError} e
 * @param {import('../../shared/chatbox.js').default} chat
 * @returns {never}
 */
function handleMessageSendError(e, chat) {
    const { __ } = shared_converse;
    if (e instanceof IQError) {
        chat.save('omemo_supported', false);

        const err_msgs = [];
        if (sizzle(`presence-subscription-required[xmlns="${omemo_utils_Strophe.NS.PUBSUB_ERROR}"]`, e.iq).length) {
            err_msgs.push(
                __(
                    "Sorry, we're unable to send an encrypted message because %1$s " +
                        'requires you to be subscribed to their presence in order to see their OMEMO information',
                    e.iq.getAttribute('from'),
                ),
            );
        } else if (sizzle(`remote-server-not-found[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]`, e.iq).length) {
            err_msgs.push(
                __(
                    "Sorry, we're unable to send an encrypted message because the remote server for %1$s could not be found",
                    e.iq.getAttribute('from'),
                ),
            );
        } else {
            err_msgs.push(__('Unable to send an encrypted message due to an unexpected error.'));
            err_msgs.push(e.iq.outerHTML);
        }
        shared_api.alert('error', __('Error'), err_msgs);
    } else if (e instanceof UserFacingError) {
        shared_api.alert('error', __('Error'), [e.message]);
    }
    throw e;
}

/**
 * Returns the device collection for a contact and OMEMO version.
 * Doesn't throw on any failure, instead logs and returns an empty collection.
 * @param {string} jid
 * @param {import('./types').OMEMOVersion} [version]
 * @returns {Promise<import('./devices.js').default>}
 */
async function getDevicesForContact(jid, version = omemo_utils_Strophe.NS.OMEMO) {
    await shared_api.waitUntil('OMEMOInitialized');
    try {
        const devicelist = await shared_api.omemo.devicelists.get(jid, true, version);
        await devicelist.fetchDevices();
        // Only force a re-fetch when the previous attempt actually failed (timeout or error).
        if (devicelist.devices.length === 0 && devicelist.lastFetchFailed) {
            await devicelist.fetchDevices(true);
        }
        return devicelist.devices;
    } catch (e) {
        src_log.error(e);
        return new shared_converse.exports.Devices(null, { version });
    }
}

/**
 * @param {string} jid
 * @param {number} id
 * @param {import('./types').OMEMOVersion} [version]
 * @returns {Promise<import('libomemo.js').SessionCipher>}
 */
async function getSessionCipher(jid, id, version = omemo_utils_Strophe.NS.OMEMO) {
    const { OMEMOAddress, SessionCipher } = await getCrypto();
    const address = new OMEMOAddress(jid, id);
    const store = getVersionedStore(version);
    return new SessionCipher(store, address, version);
}

/**
 * @param {ArrayBuffer} key_and_tag
 * @param {import('./device').default} device
 * @param {import('./types').OMEMOVersion} [version]
 */
async function encryptKey(key_and_tag, device, version = omemo_utils_Strophe.NS.OMEMO) {
    const session_cipher = await getSessionCipher(device.get('jid'), Number(device.get('id')), version);
    const payload = await session_cipher.encrypt(key_and_tag);
    return { payload, device };
}

/**
 * @param {import('./device').default} device
 * @param {import('./types').OMEMOVersion} [version]
 */
async function buildSession(device, version = omemo_utils_Strophe.NS.OMEMO) {
    const { OMEMOAddress, SessionBuilder } = await getCrypto();
    const address = new OMEMOAddress(device.get('jid'), device.get('id'));
    const store = getVersionedStore(version);
    const sessionBuilder = new SessionBuilder(store, address, version);
    const prekey = device.getRandomPreKey();
    const bundle = await device.getBundle();
    const device_id = device.get('id');

    return sessionBuilder.processPreKey({
        registrationId: typeof device_id === 'string' ? parseInt(device_id, 10) : device_id,
        identityKey: utils_base64ToArrayBuffer(bundle.identity_key),
        signedPreKey: {
            keyId: bundle.signed_prekey.id, // <Number>
            publicKey: utils_base64ToArrayBuffer(bundle.signed_prekey.public_key),
            signature: utils_base64ToArrayBuffer(bundle.signed_prekey.signature),
        },
        preKey: {
            keyId: prekey.id, // <Number>
            publicKey: utils_base64ToArrayBuffer(prekey.key),
        },
    });
}

/**
 * @param {import('./device').default} device
 * @param {import('./types').OMEMOVersion} [version]
 */
async function getSession(device, version = omemo_utils_Strophe.NS.OMEMO) {
    if (!device.get('bundle')) {
        src_log.error(`Could not build an OMEMO session for device ${device.get('id')} because we don't have its bundle`);
        return null;
    }
    const { OMEMOAddress } = await getCrypto();
    const address = new OMEMOAddress(device.get('jid'), device.get('id'));
    const store = getVersionedStore(version);
    const session = await store.loadSession(address.toString());
    if (session) {
        return session;
    } else {
        try {
            return await buildSession(device, version);
        } catch (e) {
            src_log.error(`Could not build an OMEMO session for device ${device.get('id')}`);
            src_log.error(e);
            return null;
        }
    }
}

/**
 * OMEMO in a MUC requires that real JIDs are visible (non-anonymous) and that
 * the membership is restricted (members-only). This is the single source of
 * truth for that rule.
 * @param {MUC} chatroom
 */
function isOMEMOMUCEligible(chatroom) {
    return !!(chatroom.features.get('nonanonymous') && chatroom.features.get('membersonly'));
}

/**
 * A bundle-fetch error is "actionable" when it tells the user something they
 * can fix and applies to the whole contact/server rather than a single stale
 * device: presence-subscription-required or remote-server-not-found. These must
 * abort the send and be surfaced; any other (benign) per-device failure is
 * dropped silently so it only loses that one device.
 * @param {unknown} e
 * @returns {boolean}
 */
function isActionableBundleError(e) {
    return (
        e instanceof IQError &&
        sizzle(
            `presence-subscription-required[xmlns="${omemo_utils_Strophe.NS.PUBSUB_ERROR}"], ` +
                `remote-server-not-found[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]`,
            e.iq,
        ).length > 0
    );
}

/**
 * Collects the set of recipient devices for a given chatbox, split by OMEMO
 * version.  Deduplicates across versions (by device id) so each physical
 * device is addressed exactly once. V2 is preferred when both versions are present.
 * @param {import('../../shared/chatbox.js').default} chatbox
 * @returns {Promise<{legacy: import('./device.js').default[], v2: import('./device.js').default[]}>}
 */
async function getBundlesAndBuildSessions(chatbox) {
    const { __ } = shared_converse;
    const no_devices_err = __('Sorry, no devices found to which we can send an OMEMO encrypted message.');

    let legacy_devices = [];
    let v2_devices = [];

    if (chatbox instanceof muc_muc) {
        // Defense-in-depth: OMEMO activation is already gated on this upstream
        // (checkOMEMOSupported), but a room can flip to anonymous mid-session.
        if (!isOMEMOMUCEligible(chatbox)) {
            throw new UserFacingError(
                __('Cannot use OMEMO in this groupchat — it must be non-anonymous and members-only.'),
            );
        }
        // Restrict recipients to the member/admin/owner affiliation lists, per
        // XEP-0384 §MUC: the real JIDs of those three lists are the union of
        // OMEMO recipients. This excludes `outcast` (banned) and `none`
        // occupants, so encrypted key material is never addressed to a user who
        // has been removed from the room.
        //
        // Our own devices are included here via the self-occupant (it carries
        // our real JID and an eligible affiliation in a non-anonymous,
        // members-only room); the our_id filter below then drops the sending
        // device, exactly as the 1:1 branch does.
        const occupants = chatbox.occupants.filter(
            /** @param {import('../../plugins/muc/occupant').default} o */
            (o) => o.get('jid') && OMEMO_MUC_AFFILIATIONS.includes(o.get('affiliation')),
        );
        const [legacy_cols, v2_cols] = await Promise.all([
            Promise.all(occupants.map((o) => getDevicesForContact(o.get('jid'), omemo_utils_Strophe.NS.OMEMO))),
            Promise.all(occupants.map((o) => getDevicesForContact(o.get('jid'), omemo_utils_Strophe.NS.OMEMO2))),
        ]);
        legacy_devices = legacy_cols.flatMap((c) => c.models);
        v2_devices = v2_cols.flatMap((c) => c.models);
    } else if (chatbox.get('type') === PRIVATE_CHAT_TYPE) {
        const contact_jid = chatbox.get('jid');
        const bare_jid = shared_converse.session.get('bare_jid');

        // Fetch the contact's devices for both versions in parallel (same
        // server, different PEP node), so v2 activates deterministically rather
        // than only when the contact's v2 devicelist happens to already be
        // cached (e.g. from a PEP push). An empty v2 list just means the contact
        // doesn't support omemo:2, in which case we fall back to legacy.
        const [their_legacy, their_v2] = await Promise.all([
            getDevicesForContact(contact_jid, omemo_utils_Strophe.NS.OMEMO),
            getDevicesForContact(contact_jid, omemo_utils_Strophe.NS.OMEMO2),
        ]);

        // Our own device lists are populated at init, so a cached lookup suffices.
        const [own_legacy_list, own_v2_list] = await Promise.all([
            shared_api.omemo.devicelists.get(bare_jid, false, omemo_utils_Strophe.NS.OMEMO),
            shared_api.omemo.devicelists.get(bare_jid, false, omemo_utils_Strophe.NS.OMEMO2),
        ]);

        if (their_legacy.length === 0 && their_v2.length === 0) {
            throw new UserFacingError(no_devices_err);
        }

        legacy_devices = [...(own_legacy_list?.devices.models ?? []), ...their_legacy.models];
        v2_devices = [...(own_v2_list?.devices.models ?? []), ...their_v2.models];
    }

    // A device's identity for routing is the (bare JID, id) pair: device ids are
    // unique only per user, so the JID is needed to disambiguate.
    /** @param {string} jid @param {string} id */
    const deviceKey = (jid, id) => `${omemo_utils_Strophe.getBareJidFromJid(jid).toLowerCase()}/${id}`;

    // Exclude our own sending device (we encrypt to our other devices, never the
    // one composing the message).
    const our_id = shared_converse.state.omemo_store.get('device_id');
    const our_key = deviceKey(shared_converse.session.get('bare_jid'), our_id);
    legacy_devices = legacy_devices.filter((d) => deviceKey(d.get('jid'), d.get('id')) !== our_key);
    v2_devices = v2_devices.filter((d) => deviceKey(d.get('jid'), d.get('id')) !== our_key);

    // Deduplicate across versions: a device that supports both is addressed via
    // omemo:2 only (preferred), so we drop it from the legacy list here and never
    // fetch its legacy bundle.
    const v2_keys = new Set(v2_devices.map((d) => deviceKey(d.get('jid'), d.get('id'))));
    legacy_devices = legacy_devices.filter((d) => !v2_keys.has(deviceKey(d.get('jid'), d.get('id'))));

    // Fetch bundles for the remaining devices. A benign single-device failure
    // (e.g. a stale/orphaned device with no published bundle) must only drop
    // that one device, not abort the whole send — so fetchBundle swallows it and
    // returns null. A genuinely actionable, contact-wide error
    // (presence-subscription-required, remote-server-not-found) is rethrown
    // instead: it aborts the send and propagates to the user, even when our own
    // other devices are still reachable (encrypting only to ourselves would
    // silently leave the intended recipient unable to read the message).
    const fetchBundle = async (d) => {
        try {
            await d.getBundle();
            return d;
        } catch (e) {
            if (isActionableBundleError(e)) throw e;
            src_log.error(`Skipping device ${d.get('id')} of ${d.get('jid')}: could not fetch its OMEMO bundle`);
            src_log.error(e);
            return null;
        }
    };
    const [legacy_fetched, v2_fetched] = await Promise.all([
        Promise.all(legacy_devices.map(fetchBundle)),
        Promise.all(v2_devices.map(fetchBundle)),
    ]);
    legacy_devices = legacy_devices.filter((_d, i) => legacy_fetched[i] !== null);
    v2_devices = v2_devices.filter((_d, i) => v2_fetched[i] !== null);

    // Build sessions, dropping devices where session establishment fails.
    const [legacy_sessions, v2_sessions] = await Promise.all([
        Promise.all(legacy_devices.map((d) => getSession(d, omemo_utils_Strophe.NS.OMEMO))),
        Promise.all(v2_devices.map((d) => getSession(d, omemo_utils_Strophe.NS.OMEMO2))),
    ]);
    legacy_devices = legacy_devices.filter((_d, i) => legacy_sessions[i] !== null);
    v2_devices = v2_devices.filter((_d, i) => v2_sessions[i] !== null);

    if (legacy_devices.length === 0 && v2_devices.length === 0) {
        // Nothing reachable and no actionable server error to explain why.
        throw new UserFacingError(no_devices_err);
    }
    return { legacy: legacy_devices, v2: v2_devices };
}

/**
 * @param {string} plaintext
 * @returns {Promise<import('./types').EncryptedMessage>}
 */
async function encryptMessage(plaintext) {
    // The client MUST use fresh, randomly generated key/IV pairs
    // with AES-128 in Galois/Counter Mode (GCM).

    // For GCM a 12 byte IV is strongly suggested as other IV lengths
    // will require additional calculations. In principle any IV size
    // can be used as long as the IV doesn't ever repeat. NIST however
    // suggests that only an IV size of 12 bytes needs to be supported
    // by implementations.
    //
    // https://crypto.stackexchange.com/questions/26783/ciphertext-and-tag-size-and-iv-transmission-with-aes-in-gcm-mode
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const key = await crypto.subtle.generateKey(KEY_ALGO, true, ['encrypt', 'decrypt']);
    const algo = /** @type {AesGcmParams} */ {
        iv,
        name: 'AES-GCM',
        tagLength: TAG_LENGTH,
    };
    const encrypted = await crypto.subtle.encrypt(algo, key, omemo_utils_u.stringToArrayBuffer(plaintext));
    const length = encrypted.byteLength - ((128 + 7) >> 3);
    const ciphertext = encrypted.slice(0, length);
    const tag = encrypted.slice(length);
    const exported_key = await crypto.subtle.exportKey('raw', key);
    return {
        tag,
        key: exported_key,
        key_and_tag: omemo_utils_u.appendArrayBuffer(exported_key, tag),
        payload: omemo_utils_u.arrayBufferToBase64(ciphertext),
        iv: omemo_utils_u.arrayBufferToBase64(iv),
    };
}

/**
 * @param {import('./types').EncryptedMessage} obj
 * @returns {Promise<string>}
 */
async function decryptMessage(obj) {
    const key_obj = await crypto.subtle.importKey('raw', obj.key, KEY_ALGO, true, ['encrypt', 'decrypt']);
    const cipher = omemo_utils_u.appendArrayBuffer(omemo_utils_u.base64ToArrayBuffer(obj.payload), obj.tag);
    const algo = /** @type {AesGcmParams} */ {
        name: 'AES-GCM',
        iv: omemo_utils_u.base64ToArrayBuffer(obj.iv),
        tagLength: TAG_LENGTH,
    };
    return omemo_utils_u.arrayBufferToString(await crypto.subtle.decrypt(algo, key_obj, cipher));
}

/**
 * Groups an array of {payload, device} dicts by the device's bare JID.
 * Used to produce <keys jid="..."> groupings in the v2 <encrypted> element.
 * @param {Array<{payload: import('libomemo.js').EncryptResult, device: import('./device.js').default}>} dicts
 * @returns {Map<string, Array<{payload: import('libomemo.js').EncryptResult, device: import('./device.js').default}>>}
 */
function groupByJID(dicts) {
    const map = new Map();
    for (const entry of dicts) {
        const jid = entry.device.get('jid');
        if (!map.has(jid)) map.set(jid, []);
        map.get(jid).push(entry);
    }
    return map;
}

/**
 * Encrypt the given key material with the long-standing OMEMO session of each
 * eligible (trusted + active) recipient device.
 * @param {ArrayBuffer} key_and_tag
 * @param {import('./device').default[]} devices
 * @param {import('./types').OMEMOVersion} version
 */
function encryptKeyForDevices(key_and_tag, devices, version) {
    return Promise.all(
        devices
            .filter((d) => d.get('trusted') != UNTRUSTED && d.get('active'))
            .map((d) => encryptKey(key_and_tag, d, version)),
    );
}

/**
 * Build a legacy (eu.siacs.conversations.axolotl) `<encrypted>` element from
 * the per-device encrypted keys. When `payload` is null the result is a
 * KeyTransportElement (the `<payload>` is omitted), as used for heartbeats.
 * @param {Array<{payload: import('libomemo.js').EncryptResult, device: import('./device.js').default}>} legacy_dicts
 * @param {string} iv
 * @param {string|null} payload
 */
function buildLegacyEncryptedElement(legacy_dicts, iv, payload) {
    const sid = shared_converse.state.omemo_store.get('device_id');

    // An encrypted header is added to the message for each device that is
    // supposed to receive it. These headers simply contain the key that the
    // payload message is encrypted with, and they are separately encrypted
    // using the session corresponding to the counterpart device.
    return omemo_utils_stx`<encrypted xmlns="${omemo_utils_Strophe.NS.OMEMO}">
            <header sid="${sid}">
                ${legacy_dicts.map(({ payload: p, device }) => {
                    const prekey = 3 == p.type;
                    if (prekey) {
                        return omemo_utils_stx`<key rid="${device.get('id')}" prekey="true">${btoa(p.body)}</key>`;
                    }
                    return omemo_utils_stx`<key rid="${device.get('id')}">${btoa(p.body)}</key>`;
                })}
                <iv>${iv}</iv>
            </header>
            ${payload ? omemo_utils_stx`<payload>${payload}</payload>` : ''}
        </encrypted>`;
}

/**
 * Build an OMEMO:2 (urn:xmpp:omemo:2) `<encrypted>` element from the per-device
 * encrypted keys. When `payload` is null the `<payload>` is omitted, yielding
 * an empty OMEMO message (used for heartbeats).
 * @param {Array<{payload: import('libomemo.js').EncryptResult, device: import('./device.js').default}>} v2_dicts
 * @param {string|null} payload
 */
function buildOMEMO2EncryptedElement(v2_dicts, payload) {
    // Group keys by recipient JID for the v2 <keys jid='...'> structure
    const by_jid = groupByJID(v2_dicts);
    const keys_elements = [];
    for (const [jid, entries] of by_jid) {
        const key_els = entries.map(({ payload: p, device }) => {
            if (p.kex) {
                return omemo_utils_stx`<key rid="${device.get('id')}" kex="true">${btoa(p.body)}</key>`;
            }
            return omemo_utils_stx`<key rid="${device.get('id')}">${btoa(p.body)}</key>`;
        });
        keys_elements.push(omemo_utils_stx`<keys jid="${jid}">${key_els}</keys>`);
    }

    const sid = shared_converse.state.omemo_store.get('device_id');

    return omemo_utils_stx`<encrypted xmlns="${omemo_utils_Strophe.NS.OMEMO2}">
            <header sid="${sid}">${keys_elements}</header>
            ${payload ? omemo_utils_stx`<payload>${payload}</payload>` : ''}
        </encrypted>`;
}

/**
 * @param {string} plaintext - the message body to encrypt (the legacy payload)
 * @param {import('./device').default[]} devices
 */
async function getLegacyEncryptedElement(plaintext, devices) {
    const { key_and_tag, iv, payload } = await encryptMessage(plaintext);

    // The 16 bytes key and the GCM authentication tag (The tag
    // SHOULD have at least 128 bit) are concatenated and for each
    // intended recipient device, i.e. both own devices as well as
    // devices associated with the contact, the result of this
    // concatenation is encrypted using the corresponding
    // long-standing OMEMO session.
    const legacy_dicts = await encryptKeyForDevices(key_and_tag, devices, omemo_utils_Strophe.NS.OMEMO);
    return buildLegacyEncryptedElement(legacy_dicts, iv, payload);
}

/**
 * Build the metadata elements that go inside the OMEMO 2 SCE `<content>` envelope.
 *
 * These mirror the cleartext builders in `createMessageStanza`
 * ({@link module:headless-shared-model-with-messages}), but for encrypted
 * messages they live encrypted inside `<content>` instead of in cleartext.
 * Legacy OMEMO 1 recipients don't get them (its payload is a string, not an element)
 * and degrade gracefully.
 * @param {import('../../shared/message').default} message
 * @returns {import('strophe.js').Builder[]}
 */
function getSCEExtensions(message) {
    const { oob_url, is_spoiler, spoiler_hint, references, reply_to_id, reply_to } = message.attributes;
    // The `<active/>` chat state that `createMessageStanza` would otherwise add
    // in cleartext is carried here instead (it's gated out of the cleartext
    // stanza for encrypted messages), so it still clears the recipient's typing
    // indicator without leaking activity metadata to the server.
    const extensions = [omemo_utils_stx`<active xmlns="${omemo_utils_Strophe.NS.CHATSTATES}"/>`];
    if (oob_url) {
        extensions.push(omemo_utils_stx`<x xmlns="${omemo_utils_Strophe.NS.OUTOFBAND}"><url>${oob_url}</url></x>`);
    }
    if (is_spoiler) {
        extensions.push(omemo_utils_stx`<spoiler xmlns="${omemo_utils_Strophe.NS.SPOILER}">${spoiler_hint ?? ''}</spoiler>`);
    }
    references?.forEach((ref) => {
        extensions.push(omemo_utils_stx`<reference xmlns="${omemo_utils_Strophe.NS.REFERENCE}"
                begin="${ref.begin}"
                end="${ref.end}"
                type="${ref.type}"
                uri="${ref.uri}"></reference>`);
    });
    if (reply_to_id) {
        extensions.push(omemo_utils_stx`<reply xmlns="${omemo_utils_Strophe.NS.REPLY}" id="${reply_to_id}" to="${reply_to || ''}"></reply>`);
        const reply_fallback = message.get('fallback')?.[omemo_utils_Strophe.NS.REPLY];
        if (reply_fallback) {
            extensions.push(
                omemo_utils_stx`<fallback xmlns="${omemo_utils_Strophe.NS.FALLBACK}" for="${omemo_utils_Strophe.NS.REPLY}">
                    <body start="${reply_fallback.start}" end="${reply_fallback.end}"/>
                </fallback>`,
            );
        }
    }
    return extensions;
}

/**
 * @param {import('../../shared/chatbox').default} chat
 * @param {string|null} plaintext - the SCE `<body>` (omitted when falsy, e.g. a metadata-only message)
 * @param {import('strophe.js').Builder[]} extensions - extra elements for the SCE `<content>`
 * @param {import('./device').default[]} devices
 */
async function getOMEMO2EncryptedElement(chat, plaintext, extensions, devices) {
    const is_muc = chat instanceof muc_muc;
    const muc_jid = is_muc ? chat.get('jid') : null;
    const bare_jid = shared_converse.session.get('bare_jid');

    // Build SCE envelope and encrypt it. Body-coupled metadata
    // (references/reply/oob/spoiler/reactions) is encrypted inside <content>.
    const { key_and_tag, payload } = await encryptSCE(plaintext, { from_jid: bare_jid, to_jid: muc_jid }, extensions);

    const v2_dicts = await encryptKeyForDevices(key_and_tag, devices, omemo_utils_Strophe.NS.OMEMO2);
    return buildOMEMO2EncryptedElement(v2_dicts, payload);
}

/**
 * Build a legacy heartbeat (KeyTransportElement): a fresh key/IV pair with no
 * `<payload>` (XEP-0384 0.3.0 §Sending a key). Encrypting an empty plaintext
 * with AES-GCM yields a valid 16-byte authentication tag and empty ciphertext,
 * so we reuse {@link encryptMessage} and simply drop the payload.
 * @param {import('./device').default[]} devices
 */
async function getLegacyHeartbeatElement(devices) {
    const { key_and_tag, iv } = await encryptMessage('');
    const legacy_dicts = await encryptKeyForDevices(key_and_tag, devices, omemo_utils_Strophe.NS.OMEMO);
    return buildLegacyEncryptedElement(legacy_dicts, iv, null);
}

/**
 * Build an OMEMO:2 heartbeat (empty OMEMO message): per XEP-0384, 32 zero-bytes
 * are encrypted directly with the Double Ratchet session for each device and the
 * `<payload>` is omitted altogether.
 * @param {import('./device').default[]} devices
 */
async function getOMEMO2HeartbeatElement(devices) {
    const zero_bytes = new ArrayBuffer(32);
    const v2_dicts = await encryptKeyForDevices(zero_bytes, devices, omemo_utils_Strophe.NS.OMEMO2);
    return buildOMEMO2EncryptedElement(v2_dicts, null);
}

/**
 * Send an OMEMO heartbeat (an empty/payload-less OMEMO message) to `chat` for
 * the given protocol version. Heartbeats forward the Double Ratchet so a peer's
 * message counter restarts at 0; see the XEP-0384 "counter of 53 or higher"
 * rule. The message carries no `<body>`, so it produces no visible/stored chat
 * message. We reuse the normal send-path session setup so every (trusted,
 * active) device gets the heartbeat and any missing sessions are (re)built.
 * @param {import('../../shared/chatbox.js').default} chat
 * @param {import('./types').OMEMOVersion} version
 */
async function sendOMEMOHeartbeat(chat, version) {
    const is_v2 = version === omemo_utils_Strophe.NS.OMEMO2;
    const { legacy, v2 } = await getBundlesAndBuildSessions(chat);
    const devices = is_v2 ? v2 : legacy;
    if (!devices.length) return;

    const encrypted_el = is_v2 ? await getOMEMO2HeartbeatElement(devices) : await getLegacyHeartbeatElement(devices);

    const is_muc = chat instanceof muc_muc;

    const stanza = omemo_utils_stx`<message xmlns="jabber:client"
            from="${shared_converse.session.get('jid')}"
            to="${chat.get('jid')}"
            type="${is_muc ? 'groupchat' : 'chat'}"
            id="${omemo_utils_u.getUniqueId()}">
        ${encrypted_el}
        <encryption xmlns="${omemo_utils_Strophe.NS.EME}" namespace="${is_v2 ? omemo_utils_Strophe.NS.OMEMO2 : omemo_utils_Strophe.NS.OMEMO}"/>
        <store xmlns="${omemo_utils_Strophe.NS.HINTS}"/>
    </message>`;
    shared_api.send(stanza);
}

/**
 * Send a XEP-0085 chat state notification for an OMEMO-active chat.
 *
 * Called from the `change:chat_state` listener added by {@link onChatInitialized}.
 * The cleartext path in `sendChatState` / `MUC#sendChatState` is suppressed
 * when `omemo_active`, so this function is solely responsible for the outgoing
 * notification in encrypted sessions.
 *
 * - OMEMO:2 devices present → encrypted SCE stanza with `<no-store>` hints.
 * - Legacy-only session (no v2 devices) → cleartext stanza, matching what
 *   other clients do for legacy OMEMO.
 * - Mixed session (both v2 and legacy devices) → encrypted only; legacy
 *   devices in a mixed session do not receive a CSN.
 *
 * @param {import('../../shared/chatbox.js').default} chatbox
 */
async function sendOMEMO2ChatState(chatbox) {
    if (!chatbox.get('omemo_active')) return;

    const chat_state = chatbox.get('chat_state');
    if (!chat_state) return;

    const allowed = shared_api.settings.get('send_chat_state_notifications');
    if (!allowed || (Array.isArray(allowed) && !allowed.includes(chat_state))) {
        return;
    }

    const is_muc = chatbox instanceof muc_muc;
    if (is_muc) {
        // Mirror the guards in MUC#sendChatState
        if (!(/** @type {MUC} */ (chatbox).isEntered())) return;
        if (
            /** @type {MUC} */ (chatbox).features?.get('moderated') &&
            /** @type {MUC} */ (chatbox).getOwnRole() === 'visitor'
        )
            return;
        if (chat_state === 'gone') return; // <gone/> not applicable in MUC
    }

    const jid = chatbox.get('jid');
    const type = is_muc ? 'groupchat' : 'chat';
    const { v2, legacy } = await getBundlesAndBuildSessions(chatbox);

    if (v2.length) {
        const el = await getOMEMO2EncryptedElement(
            chatbox,
            null,
            [omemo_utils_stx`<${omemo_utils_Stanza.unsafeXML(chat_state)} xmlns="${omemo_utils_Strophe.NS.CHATSTATES}"/>`],
            v2,
        );
        shared_api.send(
            omemo_utils_stx`<message xmlns="jabber:client"
                    from="${shared_converse.session.get('jid')}"
                    to="${jid}"
                    type="${type}"
                    id="${omemo_utils_u.getUniqueId()}">
                ${el}
                <encryption xmlns="${omemo_utils_Strophe.NS.EME}" namespace="${omemo_utils_Strophe.NS.OMEMO2}"/>
                <no-store xmlns="${omemo_utils_Strophe.NS.HINTS}"/>
                <no-permanent-store xmlns="${omemo_utils_Strophe.NS.HINTS}"/>
            </message>`,
        );
    } else if (legacy.length) {
        // Legacy-only session: send cleartext, same as non-OMEMO clients do.
        shared_api.send(
            omemo_utils_stx`<message to="${jid}" type="${type}" xmlns="jabber:client">
                <${omemo_utils_Stanza.unsafeXML(chat_state)} xmlns="${omemo_utils_Strophe.NS.CHATSTATES}"/>
                <no-store xmlns="${omemo_utils_Strophe.NS.HINTS}"/>
                <no-permanent-store xmlns="${omemo_utils_Strophe.NS.HINTS}"/>
            </message>`,
        );
    }
}

/**
 * Send a XEP-0333 chat marker for an OMEMO-active chat.
 *
 * Called from {@link sendMarker} in `shared/actions.js` when `omemo_active` is
 * set. The cleartext path is suppressed in that case, so this function is solely
 * responsible for the outgoing marker in encrypted sessions.
 *
 * - OMEMO:2 devices present → encrypted SCE stanza.
 * - Legacy-only session (no v2 devices) → cleartext marker, matching what
 *   other clients do for legacy OMEMO.
 * - Mixed session (both v2 and legacy devices) → encrypted only; legacy
 *   devices in a mixed session do not receive the marker.
 *
 * @param {import('../../shared/chatbox.js').default} chatbox
 * @param {string} to_jid
 * @param {string} msg_id - the `id` of the message being marked
 * @param {string} type - marker type ('displayed', 'received', 'acknowledged')
 * @param {string} [msg_type] - 'chat' or 'groupchat'; defaults to 'chat'
 */
async function sendOMEMO2Marker(chatbox, to_jid, msg_id, type, msg_type) {
    const stanza_type = msg_type || 'chat';
    const { v2, legacy } = await getBundlesAndBuildSessions(chatbox);

    if (v2.length) {
        const el = await getOMEMO2EncryptedElement(
            chatbox,
            null,
            [omemo_utils_stx`<${omemo_utils_Stanza.unsafeXML(type)} xmlns="${omemo_utils_Strophe.NS.MARKERS}" id="${msg_id}"/>`],
            v2,
        );
        shared_api.send(
            omemo_utils_stx`<message xmlns="jabber:client"
                    from="${shared_converse.session.get('jid')}"
                    to="${to_jid}"
                    type="${stanza_type}"
                    id="${omemo_utils_u.getUniqueId()}">
                ${el}
                <encryption xmlns="${omemo_utils_Strophe.NS.EME}" namespace="${omemo_utils_Strophe.NS.OMEMO2}"/>
            </message>`,
        );
    } else if (legacy.length) {
        // Legacy-only session: send cleartext marker, same as non-OMEMO clients do.
        shared_api.send(
            omemo_utils_stx`<message from="${shared_converse.session.get('jid')}"
                    id="${omemo_utils_u.getUniqueId()}"
                    to="${to_jid}"
                    type="${stanza_type}"
                    xmlns="jabber:client">
                <${omemo_utils_Stanza.unsafeXML(type)} xmlns="${omemo_utils_Strophe.NS.MARKERS}" id="${msg_id}"/>
            </message>`,
        );
    }
}

/**
 * Encrypt `plaintext` (and, for omemo:2, `extensions` inside the SCE
 * `<content>`) for every reachable recipient device of `chat`, returning the
 * OMEMO `<encrypted>` element(s) to attach to a message stanza plus the EME
 * (XEP-0380) namespace to advertise.
 *
 * @param {import('../../shared/chatbox').default} chat
 * @param {string|null} plaintext - the body (legacy payload / omemo:2 SCE `<body>`)
 * @param {import('strophe.js').Builder[]} [extensions] - encrypted SCE `<content>` children
 * @returns {Promise<{elements: import('strophe.js').Builder[], eme_ns: string}>}
 */
async function getEncryptedElements(chat, plaintext, extensions = []) {
    const { legacy, v2 } = await getBundlesAndBuildSessions(chat);

    const elements = [];
    if (legacy.length > 0) {
        elements.push(await getLegacyEncryptedElement(plaintext, legacy));
    }
    if (v2.length > 0) {
        elements.push(await getOMEMO2EncryptedElement(chat, plaintext, extensions, v2));
    }
    // Advertise the newest method present (v2 if any device uses it). If both
    // device sets are empty getBundlesAndBuildSessions has already thrown.
    const eme_ns = v2.length > 0 ? omemo_utils_Strophe.NS.OMEMO2 : omemo_utils_Strophe.NS.OMEMO;
    return { elements, eme_ns };
}

/**
 * Handler for the `createMessageStanza` hook: for an encrypted outgoing chat
 * message, attach the OMEMO `<encrypted>` element(s) (plus store + EME hints) to
 * the stanza that was built from the Message model. Non-encrypted messages pass
 * through untouched. A send failure is surfaced to the user via
 * {@link handleMessageSendError} (which re-throws to abort the send).
 *
 * @param {import('../../shared/chatbox').default} chat
 * @param {import('../../shared/types').MessageAndStanza} data
 * @return {Promise<import('../../shared/types').MessageAndStanza>}
 */
async function createMessageStanzaHandler(chat, data) {
    const { stanza, message } = data;

    if (!message.get('is_encrypted')) return data;

    try {
        if (!message.get('body')) throw new Error('No message body to encrypt!');

        const { elements, eme_ns } = await getEncryptedElements(
            chat,
            message.get('plaintext'),
            getSCEExtensions(message),
        );
        for (const el of elements) {
            stanza.cnode(el).root();
        }
        stanza.cnode(omemo_utils_stx`<store xmlns="${omemo_utils_Strophe.NS.HINTS}"/>`).root();
        stanza.cnode(omemo_utils_stx`<encryption xmlns="${omemo_utils_Strophe.NS.EME}" namespace="${eme_ns}"/>`).root();
        return { message, stanza };
    } catch (e) {
        handleMessageSendError(e, chat); // surfaces a user-facing alert and re-throws
    }
}

/**
 * @param {import('../../shared/chatbox.js').default} chat
 * @param {import('../../shared/types').MessageAttributes} attrs
 * @return {import('../../shared/types').MessageAttributes}
 */
function getOutgoingMessageAttributes(chat, attrs) {
    const { __ } = shared_converse;
    if (chat.get('omemo_active') && attrs.body) {
        return {
            ...attrs,
            is_encrypted: true,
            plaintext: attrs.body,
            body: __(
                'This is an OMEMO encrypted message which your client doesn’t seem to support. ' +
                    'Find more information on https://conversations.im/omemo',
            ),
        };
    }
    return attrs;
}

/**
 * Checks whether the contact advertises any OMEMO-compatible devices.
 * Legacy is checked first and short-circuits.
 * @param {string} jid
 */
async function contactHasOMEMOSupport(jid) {
    const legacy = await omemo_utils_u.omemo.getDevicesForContact(jid, omemo_utils_Strophe.NS.OMEMO);
    if (legacy.length > 0) {
        return true;
    }
    const v2 = await omemo_utils_u.omemo.getDevicesForContact(jid, omemo_utils_Strophe.NS.OMEMO2);
    return v2.length > 0;
}

/**
 * @param {import('../../shared/chatbox.js').default} chatbox
 * @param {boolean} [restore=false] Whether to restore remembered OMEMO active state.
 */
async function checkOMEMOSupported(chatbox, restore = false) {
    // OMEMO is never initialized on an untrusted device (see `initOMEMO`), so
    // `OMEMOInitialized` never resolves and we'd wait forever below. Mark it
    // unsupported up front so the UI doesn't offer encryption. See #2336.
    if (!shared_converse.state.config.get('trusted')) {
        chatbox.set('omemo_supported', false);
        return;
    }

    let supported;
    if (chatbox.get('type') === CHATROOMS_TYPE) {
        await shared_api.waitUntil('OMEMOInitialized');
        supported = isOMEMOMUCEligible(/** @type {MUC} */ (chatbox));
    } else if (chatbox.get('type') === PRIVATE_CHAT_TYPE) {
        supported = await contactHasOMEMOSupport(chatbox.get('jid'));
    }
    chatbox.set('omemo_supported', !!supported);
    if (supported && restore) {
        // Restore the user's last explicit choice for this chat, falling back
        // to `omemo_default` when no choice has been remembered yet
        const remembered = getOMEMOActiveState(chatbox.get('jid'));
        if (remembered !== undefined) {
            chatbox.set('omemo_active', remembered);
        } else if (shared_api.settings.get('omemo_default')) {
            chatbox.set('omemo_active', true);
        }
    }
}

/**
 * @param {MUC} chatroom
 * @param {import('../../plugins/muc/occupant').default} occupant
 */
async function onOccupantAdded(chatroom, occupant) {
    if (occupant.isSelf() || !isOMEMOMUCEligible(chatroom)) {
        return;
    }
    const { __ } = shared_converse;
    if (chatroom.get('omemo_active')) {
        const supported = await contactHasOMEMOSupport(occupant.get('jid'));
        if (!supported) {
            chatroom.createMessage({
                'message': __(
                    "%1$s doesn't appear to have a client that supports OMEMO. " +
                        'Encrypted chat will no longer be possible in this grouchat.',
                    occupant.get('nick'),
                ),
                'type': 'error',
            });
            chatroom.save({ 'omemo_active': false, 'omemo_supported': false });
        }
    }
}

/**
 * @param {import('../../shared/chatbox.js').default} chatbox
 */
function onChatInitialized(chatbox) {
    checkOMEMOSupported(chatbox, true);

    chatbox.on('change:chat_state', () => sendOMEMO2ChatState(chatbox));

    if (chatbox.get('type') === CHATROOMS_TYPE) {
        /** @type {MUC} */ (chatbox).occupants.on(
            'add',
            /** @param {import('../../plugins/muc/occupant').default} o */ (o) =>
                onOccupantAdded(/** @type {MUC} */ (chatbox), o),
        );
        /** @type {MUC} */ (chatbox).features.on('change', () => checkOMEMOSupported(chatbox));
    }
}

/**
 * @param {import('../../shared/message').default} message
 * @param {import('../../shared/types').FileUploadMessageAttributes} attrs
 */
function setEncryptedFileURL(message, attrs) {
    if (message.file.xep454_ivkey) {
        const url = attrs.oob_url.replace(/^https?:/, 'aesgcm:') + '#' + message.file.xep454_ivkey;
        return {
            ...attrs,
            ...{
                oob_url: null, // Since only the body gets encrypted, we don't set the oob_url
                message: url,
                body: url,
            },
        };
    }
    return attrs;
}

/**
 * @param {File} file
 * @returns {Promise<File>}
 */
async function encryptFile(file) {
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const key = await crypto.subtle.generateKey({ name: 'AES-GCM', length: 256 }, true, ['encrypt', 'decrypt']);
    const encrypted = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, await file.arrayBuffer());
    const exported_key = await crypto.subtle.exportKey('raw', key);
    const encrypted_file = new File([encrypted], file.name, { type: file.type, lastModified: file.lastModified });

    Object.assign(encrypted_file, { xep454_ivkey: utils_arrayBufferToHex(iv) + utils_arrayBufferToHex(exported_key) });
    return encrypted_file;
}

Object.assign(omemo_utils_u, {
    omemo: {
        ...omemo_utils_u.omemo,
        decryptMessage,
        decryptSCE: decryptSCE,
        encryptMessage,
        encryptSCE: encryptSCE,
        generateFingerprint,
        getDevicesForContact,
        getOMEMOActiveState,
        getVersionedStore,
        setOMEMOActiveState,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/parsers.js
/**
 * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
 * @typedef {import('../../plugins/muc/types').MUCMessageAttributes} MUCMessageAttributes
 * @typedef {import('./types').MUCMessageAttrsWithEncryption} MUCMessageAttrsWithEncryption
 * @typedef {import('./types').MessageAttrsWithEncryption} MessageAttrsWithEncryption
 */












const { Strophe: omemo_parsers_Strophe } = api_public.env;

// XEP-0384: "When a client receives the first message for a given ratchet key
// with a counter of 53 or higher, it MUST send a heartbeat message."
const HEARTBEAT_COUNTER_THRESHOLD = 53;

// Synchronous guard to prevent concurrent heartbeat sends for the same session.
// Two decryptions arriving in the same tick could both pass the store.loadHeartbeatKey
// check before either storeHeartbeatKey() completes. This Set is checked and mutated
// synchronously (no await), so it closes that window. The store check still handles
// page reloads (the Set is cleared on reload).
const heartbeat_in_flight = new Set();

const DECRYPTION_ERROR_ATTRS = {
    error_type: 'Decryption',
    is_ephemeral: true,
    // Don't start the ephemeral auto-destruct countdown until the message has
    // actually been seen by the user (handled in the view).
    defer_ephemeral_timer: true,
    is_error: true,
    type: 'error',
};

/**
 * @returns {object}
 */
function getNoKeyErrorAttrs() {
    const { __ } = shared_converse;
    return {
        ...DECRYPTION_ERROR_ATTRS,
        error_condition: 'not-encrypted-for-this-device',
        error_text: __(
            'Received an OMEMO encrypted message which could not be decrypted, ' +
                'because it was not encrypted for this device.',
        ),
    };
}

/**
 * @param {Error} e
 */
function getDecryptionErrorAttributes(e) {
    const { __ } = shared_converse;
    return {
        ...DECRYPTION_ERROR_ATTRS,
        error_text:
            __('Sorry, could not decrypt a received OMEMO message due to an error.') + ` ${e.name} ${e.message}`,
        error_condition: e.name,
        error_message: e.message,
    };
}

/**
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @param {Error} e
 */
function handleDecryptionError(attrs, e) {
    if (e?.name === 'MessageCounterError') {
        // XEP-0384: a message we already decrypted. Ignore it silently.
        src_log.debug(`Ignoring a duplicate OMEMO message: ${e.message}`);
        return attrs;
    }
    src_log.error(`OMEMO decryption failed: ${e.name} ${e.message}`);
    return Object.assign(attrs, getDecryptionErrorAttributes(e));
}

/**
 * We use the bare, real (i.e. non-MUC) JID as encrypted session identifier.
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 */
function getJIDForDecryption(attrs) {
    const { __ } = shared_converse;
    let from_jid;
    if (attrs.sender === 'me') {
        from_jid = shared_converse.session.get('bare_jid');
    } else if (attrs.contact_jid) {
        from_jid = attrs.contact_jid;
    } else if (attrs.type === 'groupchat') {
        // MUC message: from_real_jid is the occupant's real JID, set by the MUC parser.
        from_jid = /** @type {MUCMessageAttributes} */ (attrs).from_real_jid;
    } else {
        from_jid = attrs.from;
    }

    if (!from_jid) {
        Object.assign(attrs, {
            error_text: __(
                'Sorry, could not decrypt a received OMEMO ' +
                    "message because we don't have the XMPP address for that user.",
            ),
            error_type: 'Decryption',
            is_ephemeral: true,
            is_error: true,
            type: 'error',
        });
        throw new Error('Could not find JID to decrypt OMEMO message for');
    }
    return from_jid;
}

/**
 * Implements the XEP-0384 heartbeat rule: when we've just decrypted the first
 * message for a given ratchet key whose counter is >= 53, send a heartbeat (an
 * empty OMEMO message) to forward the ratchet. We send at most one heartbeat per
 * ratchet key; the dedup is persisted in the (versioned) OMEMO store so it
 * survives page reloads (the peer only restarts its counter at 0 a round-trip
 * after processing our heartbeat). Best-effort and fire-and-forget — failures
 * are logged, never surfaced to the user.
 *
 * The legacy heartbeat is a `KeyTransportElement` (XEP-0384 0.3.0), which the
 * older protocol defines and conforming clients already handle.
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @param {string} from_jid - the (real) bare JID identifying the OMEMO session
 * @param {string|number} device_id - the sender's device id
 * @param {{counter: number, key: ArrayBuffer}|undefined} ratchet - from the decrypt result
 * @param {import('./types').OMEMOVersion} version
 */
async function maybeSendOMEMOHeartbeat(attrs, from_jid, device_id, ratchet, version) {
    if (!ratchet || ratchet.counter < HEARTBEAT_COUNTER_THRESHOLD) return;

    const { OMEMOAddress } = await getCrypto();
    const address = new OMEMOAddress(from_jid, parseInt(`${device_id}`, 10)).toString();
    const ratchet_key_b64 = headless_utils.arrayBufferToBase64(ratchet.key);

    if (heartbeat_in_flight.has(address)) return;
    heartbeat_in_flight.add(address);
    try {
        const store = new VersionedOMEMOStore(shared_converse.state.omemo_store, version);
        if (store.loadHeartbeatKey(address) === ratchet_key_b64) return;

        // Send to the MUC room (groupchat) or the contact (1:1). The session is
        // keyed by the sender's real JID, but the heartbeat is addressed to the chat.
        // For MUC messages, attrs.from is the room JID and attrs.type is 'groupchat'.
        // For 1:1, from_jid is the contact's bare JID (the chatbox key).
        const chat_jid = attrs.type === 'groupchat' ? omemo_parsers_Strophe.getBareJidFromJid(attrs.from) : from_jid;
        const chat = shared_converse.state.chatboxes?.get(chat_jid);
        if (!chat) return;

        await sendOMEMOHeartbeat(chat, version);
        await store.storeHeartbeatKey(address, ratchet_key_b64);
    } finally {
        heartbeat_in_flight.delete(address);
    }
}

/**
 * Fire-and-forget wrapper around {@link maybeSendOMEMOHeartbeat}. Logs errors
 * instead of letting them propagate to the caller.
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @param {string} from_jid - the (real) bare JID identifying the OMEMO session
 * @param {string|number} device_id - the sender's device id
 * @param {{counter: number, key: ArrayBuffer}|undefined} ratchet - from the decrypt result
 * @param {import('./types').OMEMOVersion} version
 */
function fireHeartbeat(attrs, from_jid, device_id, ratchet, version) {
    maybeSendOMEMOHeartbeat(attrs, from_jid, device_id, ratchet, version).catch((e) =>
        src_log.error(`Could not send OMEMO heartbeat: ${e}`),
    );
}

/**
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @param {ArrayBuffer} key_and_tag
 */
async function handleDecryptedWhisperMessage(attrs, key_and_tag) {
    const from_jid = getJIDForDecryption(attrs);
    const devicelist = await shared_api.omemo.devicelists.get(from_jid, true);
    const encrypted = attrs.encrypted;
    let device = devicelist.devices.get(encrypted.device_id);
    if (!device) {
        device = await devicelist.devices.create({ 'id': encrypted.device_id, 'jid': from_jid }, { 'promise': true });
    }
    if (encrypted.payload) {
        const key = key_and_tag.slice(0, 16);
        const tag = key_and_tag.slice(16);
        const result = await decryptMessage({
            ...encrypted,
            payload: encrypted.payload,
            ...{ key, tag },
        });
        device.save('active', true);
        return result;
    }
}

/**
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 */
async function decryptWhisperMessage(attrs) {
    const from_jid = getJIDForDecryption(attrs);
    const session_cipher = await getSessionCipher(from_jid, parseInt(attrs.encrypted.device_id, 10));
    const key = headless_utils.base64ToArrayBuffer(attrs.encrypted.key);
    try {
        const { plaintext: key_and_tag, ratchet } = await session_cipher.decryptWhisperMessage(key, 'binary');
        const plaintext = await handleDecryptedWhisperMessage(attrs, key_and_tag);
        fireHeartbeat(attrs, from_jid, attrs.encrypted.device_id, ratchet, omemo_parsers_Strophe.NS.OMEMO);
        if (plaintext) {
            return Object.assign(attrs, { plaintext });
        } else {
            // Empty/heartbeat message (KeyTransportElement with no <payload>).
            return Object.assign(attrs, { 'is_only_key': true });
        }
    } catch (e) {
        return handleDecryptionError(attrs, e);
    }
}

/**
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 */
async function decryptPrekeyWhisperMessage(attrs) {
    const from_jid = getJIDForDecryption(attrs);
    const session_cipher = await getSessionCipher(from_jid, parseInt(attrs.encrypted.device_id, 10));
    const key = headless_utils.base64ToArrayBuffer(attrs.encrypted.key);
    let key_and_tag, ratchet;
    try {
        ({ plaintext: key_and_tag, ratchet } = await session_cipher.decryptPreKeyWhisperMessage(key, 'binary'));
    } catch (e) {
        return handleDecryptionError(attrs, e);
    }
    fireHeartbeat(attrs, from_jid, attrs.encrypted.device_id, ratchet, omemo_parsers_Strophe.NS.OMEMO);
    try {
        const plaintext = await handleDecryptedWhisperMessage(attrs, key_and_tag);
        const { omemo_store } = shared_converse.state;
        await omemo_store.generateMissingPreKeys();
        await omemo_store.publishBundle();
        if (plaintext) {
            return Object.assign(attrs, { 'plaintext': plaintext });
        } else {
            return Object.assign(attrs, { 'is_only_key': true });
        }
    } catch (e) {
        src_log.error(`${e.name} ${e.message}`);
        return Object.assign(attrs, getDecryptionErrorAttributes(e));
    }
}

/**
 * Decrypt a legacy OMEMO (eu.siacs.conversations.axolotl) message.
 * @param {Element} stanza
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @returns {Promise<MUCMessageAttributes|MessageAttributes|MUCMessageAttrsWithEncryption|MessageAttrsWithEncryption>}
 */
async function decryptLegacyOMEMOMessage(stanza, attrs) {
    const encrypted_el = sizzle(`encrypted[xmlns="${omemo_parsers_Strophe.NS.OMEMO}"]`, stanza).pop();
    const header = encrypted_el.querySelector('header');
    attrs.encrypted = { 'device_id': header.getAttribute('sid') };

    const device_id = await shared_api.omemo?.getDeviceID();
    const key = device_id && sizzle(`key[rid="${device_id}"]`, encrypted_el).pop();
    if (key) {
        Object.assign(attrs.encrypted, {
            iv: header.querySelector('iv').textContent,
            key: key.textContent,
            payload: encrypted_el.querySelector('payload')?.textContent || null,
            prekey: ['true', '1'].includes(key.getAttribute('prekey')),
        });
    } else {
        return Object.assign(attrs, getNoKeyErrorAttrs());
    }
    // https://xmpp.org/extensions/xep-0384.html#usecases-receiving
    if (attrs.encrypted.prekey === true) {
        return decryptPrekeyWhisperMessage(attrs);
    } else {
        return decryptWhisperMessage(attrs);
    }
}

/**
 * Decrypt an OMEMO 2 message.
 * @param {Element} stanza
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @param {import('../muc/muc.js').default} [chatbox] - The MUC model (for re-parsing reactions)
 * @returns {Promise<MUCMessageAttributes|MessageAttributes|MUCMessageAttrsWithEncryption|MessageAttrsWithEncryption>}
 */
async function decryptOMEMO2Message(stanza, attrs, chatbox) {
    const encrypted_el = sizzle(`encrypted[xmlns="${omemo_parsers_Strophe.NS.OMEMO2}"]`, stanza).pop();
    if (!encrypted_el) return attrs;

    const header = encrypted_el.querySelector('header');
    const sender_device_id = header.getAttribute('sid');

    const device_id = await shared_api.omemo?.getDeviceID();
    if (!device_id) return attrs;

    // Find our <key rid='...'> under any <keys jid='our_bare_jid'>
    const bare_jid = shared_converse.session.get('bare_jid');
    const keys_el = sizzle(`keys[jid="${bare_jid}"]`, encrypted_el).pop();
    if (!keys_el) {
        return Object.assign(attrs, getNoKeyErrorAttrs());
    }

    const key_el = keys_el.querySelector(`key[rid="${device_id}"]`);
    if (!key_el) {
        return Object.assign(attrs, getNoKeyErrorAttrs());
    }

    const from_jid = getJIDForDecryption(attrs);
    const key_b64 = key_el.textContent.trim();
    const key_bytes = headless_utils.base64ToArrayBuffer(key_b64);

    // Whether the <key> holds a key exchange (OMEMOKeyExchange) or a regular
    // message (OMEMOAuthenticatedMessage). We detect this from the payload
    // rather than trusting the `kex` attribute: libsignal-based senders (e.g.
    // QXmpp/Kaidan) keep emitting key-exchange messages until they receive a
    // reply, but only set kex="true" on the first one, leaving the repeats
    // mislabelled. The two protobufs are unambiguous by their first tag byte —
    // OMEMOKeyExchange begins with field 1 `pk_id` (varint → 0x08), whereas
    // OMEMOAuthenticatedMessage begins with field 1 `mac` (bytes → 0x0A).
    const is_kex = new Uint8Array(key_bytes)[0] === 0x08 || key_el.getAttribute('kex') === 'true';

    attrs.encrypted = {
        device_id: sender_device_id,
        key: key_b64,
        payload: encrypted_el.querySelector('payload')?.textContent?.trim() || null,
        prekey: is_kex,
    };

    const session_cipher = await getSessionCipher(from_jid, parseInt(sender_device_id, 10), omemo_parsers_Strophe.NS.OMEMO2);

    let key_and_tag, ratchet;
    try {
        if (is_kex) {
            ({ plaintext: key_and_tag, ratchet } = await session_cipher.decryptPreKeyWhisperMessage(
                key_bytes,
                'binary',
            ));
            // After handling a key exchange, regenerate and publish prekeys
            const { omemo_store } = shared_converse.state;
            await omemo_store.generateMissingPreKeys();
            await omemo_store.publishBundle();
        } else {
            ({ plaintext: key_and_tag, ratchet } = await session_cipher.decryptWhisperMessage(key_bytes, 'binary'));
        }
    } catch (e) {
        return handleDecryptionError(attrs, e);
    }

    fireHeartbeat(attrs, from_jid, sender_device_id, ratchet, omemo_parsers_Strophe.NS.OMEMO2);

    if (!attrs.encrypted.payload) {
        // Empty/heartbeat message
        return Object.assign(attrs, { 'is_only_key': true });
    }

    try {
        const is_muc = attrs.type === 'groupchat';
        const muc_jid = is_muc ? attrs.from : null;
        const { body, content } = await decryptSCE(key_and_tag, attrs.encrypted.payload, {
            sender_jid: from_jid,
            to_jid: muc_jid,
        });

        // Update device active state
        const devicelist = await shared_api.omemo.devicelists.get(from_jid, true, omemo_parsers_Strophe.NS.OMEMO2);
        let device = devicelist.devices.get(sender_device_id);
        if (!device) {
            device = await devicelist.devices.create({ 'id': sender_device_id, 'jid': from_jid }, { 'promise': true });
        }
        device.save('active', true);

        if (!content) {
            // Payload present but no <content> at all — nothing to surface.
            return Object.assign(attrs, { 'is_only_key': true });
        }

        // A payload-bearing SCE envelope is never a heartbeat (those carry no
        // <payload> and are handled above). Its <content> may hold a <body>
        // with body-coupled metadata (references/reply/oob/spoiler), or it may
        // be a metadata-only message (chat state / marker / reaction) with no
        // <body>. Either way we re-run the normal parsers against the decrypted,
        // authenticated <content> — not the wire stanza, which carries none of
        // this for an encrypted message.
        Object.assign(
            attrs,
            { references: getReferences(content) },
            getReplyAttributes(content),
            getFallbackAttributes(content),
            getOutOfBandAttributes(content),
            getSpoilerAttributes(content),
        );
        if (body) attrs.plaintext = body;

        // The chat state now travels encrypted inside <content> (it's gated out
        // of the cleartext stanza for encrypted messages), so we read it from
        // there. Chat state and markers are only applied when actually present,
        // so a metadata-only message (e.g. a reaction) gets no spurious chat
        // state and any cleartext one from a non-SCE sender isn't clobbered.
        const chat_state = getChatState(content);
        if (chat_state) attrs.chat_state = chat_state;
        const marker = getChatMarker(content);
        if (marker) {
            attrs.is_marker = true;
            attrs.marker_id = marker.getAttribute('id');
        }
        if (sizzle(`markable[xmlns="${omemo_parsers_Strophe.NS.MARKERS}"]`, content).length) {
            attrs.is_markable = true;
        }

        /**
         * *Hook* which lets plugins parse metadata from the decrypted SCE
         * `<content>` of an OMEMO:2 message, the same way they parse a wire
         * stanza via `parseMessage`/`parseMUCMessage`. This keeps plugin-specific
         * parsing (e.g. XEP-0444 reactions) in the plugin instead of coupling it
         * to OMEMO. The `chatbox` is forwarded so MUC-aware parsers can resolve
         * room context.
         * @event _converse#parseEncryptedContent
         * @param {Element} content - The decrypted SCE `<content>` element
         * @param {object} attrs - The message attributes parsed so far
         * @param {import('../muc/muc.js').default} [chatbox] - The MUC model, if any
         * @example api.listen.on('parseEncryptedContent', parseReactionsMessage);
         */
        attrs = await shared_api.hook('parseEncryptedContent', content, attrs, chatbox);

        // A content that surfaced nothing the user acts on (no body and no
        // chat state / marker / reaction) is treated as a key-transport message
        // so it isn't shown as a blank message. `reaction_to_id` is added by the
        // reactions plugin via the hook above, so it's not on the base type.
        const has_reaction = !!(/** @type {{reaction_to_id?: string}} */ (attrs)).reaction_to_id;
        if (has_reaction) {
            // The emoji body is only a legacy-OMEMO fallback (marked by a
            // XEP-0428 <fallback for="urn:xmpp:reactions:0">); the structured
            // <reactions> is what we act on. Drop it so the emoji isn't surfaced
            // as a standalone message alongside the reaction.
            delete (/** @type {{plaintext?: string}} */ (attrs)).plaintext;
        }
        if (!body && !attrs.chat_state && !attrs.is_marker && !attrs.is_markable && !has_reaction) {
            return Object.assign(attrs, { 'is_only_key': true });
        }
        return attrs;
    } catch (e) {
        src_log.error(`SCE decryption failed: ${e.name} ${e.message}`);
        return Object.assign(attrs, getDecryptionErrorAttributes(e));
    }
}

/**
 * Hook handler for {@link parseMessage} and {@link parseMUCMessage}, which
 * parses the passed in `message` stanza for OMEMO attributes and then sets
 * them on the attrs object.
 *
 * A single stanza may carry both an `urn:xmpp:omemo:2` and a legacy
 * `eu.siacs.conversations.axolotl` `<encrypted>` element: a sender that
 * supports both addresses each recipient device in whichever version that
 * device understands. The EME (XEP-0380) hint names only one method and exists
 * for clients that can decrypt *neither* — it must not be used to pick a
 * decryption path. So we route on which `<encrypted>` block actually contains a
 * `<key>` for our own device, preferring omemo:2.
 *
 * @param {Element} stanza - The message stanza
 * @param {MUCMessageAttributes|MessageAttributes} attrs
 * @param {import('../muc/muc.js').default} [chatbox] - The MUC model (only for
 *   `parseMUCMessage`); used to re-parse encrypted reactions from the SCE content.
 * @returns {Promise<MUCMessageAttributes| MessageAttributes|MUCMessageAttrsWithEncryption|MessageAttrsWithEncryption>}
 */
async function parseEncryptedMessage(stanza, attrs, chatbox) {
    if (shared_api.settings.get('clear_cache_on_logout') || !attrs.is_encrypted) {
        return attrs;
    }

    const device_id = await shared_api.omemo?.getDeviceID();
    const bare_jid = shared_converse.session.get('bare_jid');

    const v2_el = sizzle(`encrypted[xmlns="${omemo_parsers_Strophe.NS.OMEMO2}"]`, stanza).pop();
    const legacy_el = sizzle(`encrypted[xmlns="${omemo_parsers_Strophe.NS.OMEMO}"]`, stanza).pop();

    const has_v2_key =
        !!(v2_el && device_id) && sizzle(`keys[jid="${bare_jid}"] key[rid="${device_id}"]`, v2_el).length > 0;
    const has_legacy_key = !!(legacy_el && device_id) && sizzle(`key[rid="${device_id}"]`, legacy_el).length > 0;

    if (has_v2_key) {
        return await decryptOMEMO2Message(stanza, attrs, chatbox);
    }
    if (has_legacy_key) {
        return await decryptLegacyOMEMOMessage(stanza, attrs);
    }

    // The message is OMEMO-encrypted but no <key> is addressed to this device.
    // Only surface the "not encrypted for this device" error once we actually
    // know our own device id, otherwise OMEMO isn't ready yet and we'd raise a
    // spurious error during an init race.
    if (device_id && (v2_el || legacy_el)) {
        return Object.assign(attrs, getNoKeyErrorAttrs());
    }

    // Not an OMEMO message we can handle; leave attrs untouched so any EME
    // fallback body is shown.
    return attrs;
}

/**
 * Given an XML element representing a legacy OMEMO bundle, parse it
 * and return a map.
 * @param {Element} [bundle_el]
 * @returns {?import('./types').Bundle} `null` if no bundle element was given.
 */
function parseBundle(bundle_el) {
    if (!bundle_el) return null;
    const signed_prekey_public_el = bundle_el.querySelector('signedPreKeyPublic');
    const signed_prekey_signature_el = bundle_el.querySelector('signedPreKeySignature');
    const prekeys = sizzle(`prekeys > preKeyPublic`, bundle_el).map(
        /** @param {Element} el */ (el) => ({
            id: parseInt(el.getAttribute('preKeyId'), 10),
            key: el.textContent,
        }),
    );
    return {
        identity_key: bundle_el.querySelector('identityKey').textContent.trim(),
        signed_prekey: {
            id: parseInt(signed_prekey_public_el.getAttribute('signedPreKeyId'), 10),
            public_key: signed_prekey_public_el.textContent,
            signature: signed_prekey_signature_el.textContent,
        },
        prekeys,
    };
}

/**
 * Given an XML element representing an OMEMO 2 bundle, parse it
 * and return a map using the same internal format as the legacy bundle.
 *
 * All key values are base64-encoded 32-byte raw Curve25519/Ed25519 bytes
 * (the leading 0x05 byte is absent for v2).
 *
 * @param {Element} [bundle_el]
 * @returns {?import('./types').Bundle} `null` if no bundle element was given.
 */
function parseBundleV2(bundle_el) {
    if (!bundle_el) return null;
    const spk_el = bundle_el.querySelector('spk');
    const prekeys = sizzle('prekeys > pk', bundle_el).map(
        /** @param {Element} el */ (el) => ({
            id: parseInt(el.getAttribute('id'), 10),
            key: el.textContent.trim(),
        }),
    );
    return {
        identity_key: bundle_el.querySelector('ik').textContent.trim(),
        signed_prekey: {
            id: parseInt(spk_el.getAttribute('id'), 10),
            public_key: spk_el.textContent.trim(),
            signature: bundle_el.querySelector('spks').textContent.trim(),
        },
        prekeys,
    };
}

Object.assign(headless_utils, {
    omemo: {
        ...headless_utils.omemo,
        parseBundle,
        parseBundleV2,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/device.js









const { Strophe: device_Strophe, sizzle: device_sizzle, stx: device_stx, u: device_u } = api_public.env;

/**
 * @extends {OMEMOVersionAwareModel<import('./types').DeviceAttributes>}
 */
class Device extends OMEMOVersionAwareModel {
    defaults() {
        return {
            trusted: UNDECIDED,
            active: true,
        };
    }

    /**
     * @returns {import('./types').CounterpartyPreKey}
     */
    getRandomPreKey() {
        // XXX: assumes that the bundle has already been fetched
        const bundle = this.get('bundle');
        return bundle.prekeys[device_u.getRandomInt(bundle.prekeys.length)];
    }

    /**
     * Fetch the device's OMEMO bundle from the server.
     * A bundle is a collection of publicly accessible data that can
     * be used to build a session with a device, namely its public IdentityKey,
     * a signed PreKey with corresponding signature, and a list of (single use) PreKeys.
     * @returns {Promise<import('./types').Bundle>}
     */
    async fetchBundleFromServer() {
        const bare_jid = shared_converse.session.get('bare_jid');
        const device_id = this.get('id');
        const is_v2 = this.isV2();
        const bundle_xmlns = is_v2 ? device_Strophe.NS.OMEMO2 : device_Strophe.NS.OMEMO;

        // omemo:2 keeps all bundles in the single `urn:xmpp:omemo:2:bundles` node,
        // addressed by item id = device id; legacy 0.3.0 uses a per-device node.
        const bundle_node = is_v2 ? device_Strophe.NS.OMEMO2_BUNDLES : `${device_Strophe.NS.OMEMO_BUNDLES}:${device_id}`;
        const items_el = is_v2
            ? device_stx`<items node="${bundle_node}"><item id="${device_id}"/></items>`
            : device_stx`<items node="${bundle_node}"/>`;

        const stanza = device_stx`
            <iq type="get" from="${bare_jid}" to="${this.get('jid')}" xmlns="jabber:client">
                <pubsub xmlns="${device_Strophe.NS.PUBSUB}">${items_el}</pubsub>
            </iq>`;

        let iq;
        try {
            iq = await shared_api.sendIQ(stanza);
        } catch (iq) {
            src_log.error(`Could not fetch bundle for device ${device_id} from ${this.get('jid')}`);
            src_log.error(iq);
            if (iq && iq.querySelector('error')) {
                throw new IQError('Could not fetch bundle', iq);
            }
            return null;
        }
        if (iq.querySelector('error')) {
            throw new IQError('Could not fetch bundle', iq);
        }

        const publish_el = device_sizzle(`items[node="${bundle_node}"]`, iq).pop();
        const bundle_el = device_sizzle(`bundle[xmlns="${bundle_xmlns}"]`, publish_el).pop();
        if (!bundle_el) {
            // The IQ resolved as type="result" but carries no <bundle>.
            // A stale/orphaned device with no published bundle can produce this.
            // Throw a benign, non-actionable IQError so the caller skips this device.
            src_log.warn(`No OMEMO bundle published for device ${device_id} of ${this.get('jid')}`);
            throw new IQError('Could not fetch bundle', iq);
        }
        const bundle = is_v2 ? parseBundleV2(bundle_el) : parseBundle(bundle_el);
        this.save('bundle', bundle);
        return bundle;
    }

    /**
     * Fetch and save the bundle information associated with
     * this device, if the information is not cached already.
     * @returns {Promise<import('./types').Bundle>}
     */
    getBundle() {
        if (this.get('bundle')) {
            return Promise.resolve(this.get('bundle'));
        } else {
            return this.fetchBundleFromServer();
        }
    }
}

/* export default */ const omemo_device = (Device);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/devices.js



/**
 * @extends {Collection<Device>}
 */
class Devices extends Collection {
    /**
     * @param {Device[]|object[]} [models]
     * @param {object} [options]
     * @param {import('./types').OMEMOVersion} [options.version]
     */
    constructor(models, options = {}) {
        super(models, options);
        this.model = omemo_device;
        // The OMEMO version this collection belongs to. Stamped onto every
        // device so that Device.isV2() (and thus bundle node selection and
        // parsing) is correct for the contact's devices, not just our own.
        this.version = options.version;
    }

    /**
     * Stamp the collection's OMEMO version onto every device created through it,
     * unless one was explicitly provided.
     * @param {object|Device} attrs
     * @param {object} [options]
     */
    _prepareModel(attrs, options) {
        if (this.version && attrs && !(attrs instanceof omemo_device) && !attrs.version) {
            attrs.version = this.version;
        }
        return super._prepareModel(attrs, options);
    }
}

/* export default */ const omemo_devices = (Devices);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/store.js









const { Strophe: store_Strophe, stx: store_stx, u: store_u } = api_public.env;

/**
 * @extends {Model<import('./types').OMEMOStoreAttributes>}
 */
class OMEMOStore extends skeletor_esm_Model {
    /** @type {Promise<boolean>} */
    #setup_promise;

    get Direction() {
        return {
            SENDING: 1,
            RECEIVING: 2,
        };
    }

    /**
     * @returns {import('libomemo.js').KeyPair}
     */
    getIdentityKeyPair() {
        const keypair = this.get('identity_keypair');
        return {
            privKey: store_u.base64ToArrayBuffer(keypair.privKey),
            pubKey: store_u.base64ToArrayBuffer(keypair.pubKey),
        };
    }

    /**
     * @returns {number}
     */
    getLocalRegistrationId() {
        return parseInt(this.get('device_id'), 10);
    }

    /**
     * @param {string} address
     * @param {ArrayBuffer} identity_key
     * @param {unknown} _direction
     * @returns {boolean}
     */
    isTrustedIdentity(address, identity_key, _direction) {
        if (address === null || address === undefined) {
            throw new Error("Can't check identity key for invalid key");
        }
        if (!(identity_key instanceof ArrayBuffer)) {
            throw new Error('Expected identity_key to be an ArrayBuffer');
        }
        const trusted = this.get('identity_key' + address);
        if (trusted === undefined) {
            return true;
        }
        return store_u.arrayBufferToBase64(identity_key) === trusted;
    }

    /**
     * @param {string} address
     * @returns {ArrayBuffer}
     */
    loadIdentityKey(address) {
        if (address === null || address === undefined) {
            throw new Error("Can't load identity_key for invalid address");
        }
        return store_u.base64ToArrayBuffer(this.get('identity_key' + address));
    }

    /**
     * @param {string} address
     * @param {ArrayBuffer} identity_key
     * @returns {boolean}
     */
    saveIdentity(address, identity_key) {
        if (address === null || address === undefined) {
            throw new Error("Can't save identity_key for invalid address");
        }
        const existing = this.get('identity_key' + address);
        const b64_idkey = store_u.arrayBufferToBase64(identity_key);
        this.save('identity_key' + address, b64_idkey);

        if (existing && b64_idkey !== existing) {
            return true;
        } else {
            return false;
        }
    }

    getPreKeys() {
        return this.get('prekeys') || {};
    }

    /**
     * @param {string|number} key_id
     * @returns {Promise<{ keyPair: import('libomemo.js').KeyPair }|void>}
     */
    loadPreKey(key_id) {
        const res = this.getPreKeys()[key_id];
        if (res) {
            return Promise.resolve({
                keyPair: {
                    privKey: store_u.base64ToArrayBuffer(res.privKey),
                    pubKey: store_u.base64ToArrayBuffer(res.pubKey),
                },
            });
        }
        return Promise.resolve();
    }

    /**
     * @param {number} key_id
     * @param {import('libomemo.js').KeyPair} key_pair
     */
    storePreKey(key_id, key_pair) {
        const prekey = {
            [key_id]: {
                privKey: store_u.arrayBufferToBase64(key_pair.privKey),
                pubKey: store_u.arrayBufferToBase64(key_pair.pubKey),
            },
        };
        this.save('prekeys', Object.assign(this.getPreKeys(), prekey));
    }

    /**
     * @param {string|number} key_id
     */
    removePreKey(key_id) {
        const prekeys = { ...this.getPreKeys() };
        delete prekeys[key_id];
        this.save('prekeys', prekeys);
        return Promise.resolve();
    }

    /**
     * @param {string} _key_id
     * @returns {{ keyPair: import('libomemo.js').KeyPair }|void}
     */
    loadSignedPreKey(_key_id) {
        const res = this.get('signed_prekey');
        if (res) {
            return {
                keyPair: {
                    privKey: store_u.base64ToArrayBuffer(res.privKey),
                    pubKey: store_u.base64ToArrayBuffer(res.pubKey),
                },
            };
        }
    }

    /**
     * @param {import('libomemo.js').SignedPreKey} spk
     */
    storeSignedPreKey(spk) {
        if (typeof spk !== 'object') {
            throw new Error('storeSignedPreKey: expected an object');
        }
        this.save('signed_prekey', {
            id: spk.keyId,
            privKey: store_u.arrayBufferToBase64(spk.keyPair.privKey),
            pubKey: store_u.arrayBufferToBase64(spk.keyPair.pubKey),
            signature: store_u.arrayBufferToBase64(spk.signature),
        });
    }

    /**
     * Store the v2 (urn:xmpp:omemo:2) signed prekey. Kept separate from the
     * legacy SPK because the signature covers different bytes (32-byte curve vs
     * 33-byte curve form).
     * @param {import('libomemo.js').SignedPreKey} spk
     */
    storeSignedPreKeyV2(spk) {
        if (typeof spk !== 'object') {
            throw new Error('storeSignedPreKeyV2: expected an object');
        }
        this.save('signed_prekey_omemo2', {
            id: spk.keyId,
            privKey: store_u.arrayBufferToBase64(spk.keyPair.privKey),
            pubKey: store_u.arrayBufferToBase64(spk.keyPair.pubKey),
            signature: store_u.arrayBufferToBase64(spk.signature),
        });
    }

    /**
     * @param {number} key_id
     */
    removeSignedPreKey(key_id) {
        if (this.get('signed_prekey')['id'] === key_id) {
            this.unset('signed_prekey');
            this.save();
        }
    }

    /**
     * @param {string} address
     */
    loadSession(address) {
        return Promise.resolve(this.get('session' + address));
    }

    /**
     * @param {string} address
     * @param {object} record
     */
    storeSession(address, record) {
        return Promise.resolve(this.save('session' + address, record));
    }

    /**
     * @param {string} address
     */
    removeSession(address) {
        // Drop the heartbeat marker (see {@link loadHeartbeatKey}) together with
        // the session, so a rebuilt session starts with a clean slate.
        this.unset('heartbeat:' + address);
        return Promise.resolve(this.unset('session' + address));
    }

    /**
     * The ratchet key (base64) for which we last sent an OMEMO heartbeat to this
     * session, or `undefined`. Used to enforce the XEP-0384 rule of sending at
     * most one heartbeat per ratchet key, in a way that survives page reloads.
     * @param {string} address
     * @returns {string|undefined}
     */
    loadHeartbeatKey(address) {
        return this.get('heartbeat:' + address);
    }

    /**
     * Records and persists the ratchet key we just heartbeated for.
     * @param {string} address
     * @param {string} key_b64 - base64 of the ratchet key we just heartbeated for
     * @returns {Promise<void>}
     */
    storeHeartbeatKey(address, key_b64) {
        return this.save('heartbeat:' + address, key_b64, { promise: true });
    }

    /**
     * @param {string} [address='']
     */
    removeAllSessions(address = '') {
        const keys = Object.keys(this.attributes).filter((key) => (key.startsWith('session' + address) ? key : false));
        const attrs = {};
        keys.forEach((key) => {
            attrs[key] = undefined;
        });
        this.save(attrs);
        return Promise.resolve();
    }

    async publishBundle() {
        // The v2 bundle publish runs in the background: failing it (e.g. on a
        // server that doesn't support omemo:2) must not block legacy OMEMO setup.
        this.#publishV2Bundle().catch((e) => src_log.error(e));
        await this.#publishLegacyBundle();
        // Record that our bundle reached the server, so we don't needlessly
        // republish it on the next connection (see initOMEMO). Any change to the
        // stored bundle clears this flag again. If the publish above rejected we
        // never get here, so the flag stays false and we retry next time.
        this.save({ bundle_published: true });
    }

    #publishLegacyBundle() {
        const signed_prekey = this.get('signed_prekey');
        const node = `${store_Strophe.NS.OMEMO_BUNDLES}:${this.get('device_id')}`;
        const item = store_stx`
            <item>
                <bundle xmlns="${store_Strophe.NS.OMEMO}">
                    <signedPreKeyPublic signedPreKeyId="${signed_prekey.id}"
                        >${signed_prekey.pubKey}</signedPreKeyPublic>
                    <signedPreKeySignature>${signed_prekey.signature}</signedPreKeySignature>
                    <identityKey>${this.get('identity_keypair').pubKey}</identityKey>
                    <prekeys>${Object.values(this.get('prekeys')).map(
                        (prekey, id) => store_stx`<preKeyPublic preKeyId="${id}">${prekey.pubKey}</preKeyPublic>`,
                    )}
                    </prekeys>
                </bundle>
            </item>`;
        const options = { access_model: 'open' };
        return shared_api.pubsub.publish(null, node, item, options, false);
    }

    async #publishV2Bundle() {
        const spk = this.get('signed_prekey_omemo2');
        if (!spk) {
            src_log.warn('No v2 signed prekey found, skipping v2 bundle publication');
            return;
        }
        const { curvePubKeyToEd25519PubKey } = await getCrypto();
        const identity_keypair = this.get('identity_keypair');
        const device_id = this.get('device_id');
        // Unlike legacy 0.3.0 (which uses a per-device node), omemo:2 stores every
        // device's bundle as a separate item — keyed by item id = device id — in
        // the single `urn:xmpp:omemo:2:bundles` node. See XEP-0384 §4.3.2.
        const node = store_Strophe.NS.OMEMO2_BUNDLES;

        // Ed25519 IK from curve pubkey
        const curve_ik = store_u.base64ToArrayBuffer(identity_keypair.pubKey);
        const ed25519_ik = await curvePubKeyToEd25519PubKey(curve_ik);
        const ed25519_ik_b64 = store_u.arrayBufferToBase64(ed25519_ik);

        // Strip leading byte from SPK pubkey (33 → 32 bytes) for v2 wire format
        const spk_pub_raw = store_u.base64ToArrayBuffer(spk.pubKey);
        const spk_pub_b64 = store_u.arrayBufferToBase64(spk_pub_raw.slice(1));

        // Prekeys with stripped leading byte
        const prekeys_obj = this.get('prekeys');
        const prekey_items = Object.entries(prekeys_obj).map(([key_id, pk]) => {
            const raw = store_u.base64ToArrayBuffer(/** @type {{pubKey:string}} */ (pk).pubKey);
            const stripped = store_u.arrayBufferToBase64(raw.slice(1));
            return store_stx`<pk id="${key_id}">${stripped}</pk>`;
        });

        const item = store_stx`
            <item id="${device_id}">
                <bundle xmlns="${store_Strophe.NS.OMEMO2}">
                    <spk id="${spk.id}">${spk_pub_b64}</spk>
                    <spks>${spk.signature}</spks>
                    <ik>${ed25519_ik_b64}</ik>
                    <prekeys>${prekey_items}</prekeys>
                </bundle>
            </item>`;
        // `max_items=max` is REQUIRED by XEP-0384: the shared bundles node must
        // retain one item per device rather than only the latest.
        const options = { access_model: 'open', max_items: 'max' };
        return shared_api.pubsub.publish(null, node, item, options, false);
    }

    async generateMissingPreKeys() {
        const { KeyHelper } = await getCrypto();

        const prekeyIds = Object.keys(this.getPreKeys());
        const missing_keys = Array.from({ length: shared_converse.NUM_PREKEYS }, (_, id) => id.toString()).filter(
            (id) => !prekeyIds.includes(id),
        );

        if (missing_keys.length < 1) {
            src_log.debug('No missing prekeys to generate for our own device');
            return Promise.resolve();
        }

        const keys = await Promise.all(missing_keys.map((id) => KeyHelper.generatePreKey(parseInt(id, 10))));
        keys.forEach((k) => this.storePreKey(k.keyId, k.keyPair));
        // These replacement prekeys aren't on the server yet. The caller
        // republishes right after, but clearing the flag means a failed publish
        // is retried on the next connection rather than silently skipped.
        this.save({ bundle_published: false });

        const prekeys = this.getPreKeys();
        const marshalled_keys = Object.keys(prekeys).map((id) => ({
            id,
            key: prekeys[id].pubKey,
        }));

        const bare_jid = shared_converse.session.get('bare_jid');
        const devicelist = await getDeviceList(bare_jid);
        const device = devicelist.devices.get(this.get('device_id'));
        const bundle = await device.getBundle();
        device.save('bundle', Object.assign(bundle, { 'prekeys': marshalled_keys }));
    }

    /**
     * Generates, stores and then returns pre-keys.
     *
     * Pre-keys are one half of a X3DH key exchange and are published as part
     * of the device bundle.
     *
     * For a new contact or device to establish an encrypted session, it needs
     * to use a pre-key, which it chooses randomly from the list of available
     * ones.
     */
    async generatePreKeys() {
        const amount = shared_converse.NUM_PREKEYS;
        const { KeyHelper } = await getCrypto();
        const keys = await Promise.all([...Array(amount).keys()].map((id) => KeyHelper.generatePreKey(id)));

        keys.forEach((k) => this.storePreKey(k.keyId, k.keyPair));

        return keys.map((k) => ({
            id: k.keyId,
            key: store_u.arrayBufferToBase64(k.keyPair.pubKey),
        }));
    }

    /**
     * Generate the cryptographic data used by the X3DH key agreement protocol
     * in order to build a session with other devices.
     *
     * By generating a bundle, and publishing it via PubSub, we allow other
     * clients to download it and start asynchronous encrypted sessions with us,
     * even if we're offline at that time.
     *
     * Generates both legacy (0.3.0) and v2 (omemo:2) bundle material and
     * publishes both PEP nodes.
     */
    async generateBundle() {
        const { KeyHelper } = await getCrypto();

        // The first thing that needs to happen if a client wants to
        // start using OMEMO is they need to generate an IdentityKey
        // and a Device ID.

        // The IdentityKey is a Curve25519 public/private Key pair.
        const identity_keypair = await KeyHelper.generateIdentityKeyPair();
        const identity_key = store_u.arrayBufferToBase64(identity_keypair.pubKey);

        // The Device ID is a randomly generated integer between 1 and 2^31 - 1.
        const device_id = await generateDeviceID();

        this.save({
            device_id,
            identity_key,
            identity_keypair: {
                privKey: store_u.arrayBufferToBase64(identity_keypair.privKey),
                pubKey: identity_key,
            },
            // A freshly generated bundle hasn't reached the server yet.
            bundle_published: false,
        });

        // Generate both legacy and v2 signed prekeys (signatures differ in key encoding).
        const [signed_prekey, signed_prekey_v2] = await Promise.all([
            KeyHelper.generateSignedPreKey(identity_keypair, 0, store_Strophe.NS.OMEMO),
            KeyHelper.generateSignedPreKey(identity_keypair, 0, store_Strophe.NS.OMEMO2),
        ]);
        this.storeSignedPreKey(signed_prekey);
        this.storeSignedPreKeyV2(signed_prekey_v2);

        const prekeys = await this.generatePreKeys();

        const bundle = { identity_key, device_id, prekeys };
        bundle['signed_prekey'] = {
            id: signed_prekey.keyId,
            public_key: store_u.arrayBufferToBase64(signed_prekey.keyPair.pubKey),
            signature: store_u.arrayBufferToBase64(signed_prekey.signature),
        };

        const bare_jid = shared_converse.session.get('bare_jid');
        const devicelist = await shared_api.omemo.devicelists.get(bare_jid);
        const device = await devicelist.devices.create({ id: bundle.device_id, 'jid': bare_jid }, { promise: true });
        device.save('bundle', bundle);
    }

    /**
     * Backfills omemo:2 key material for an already provisioned device.
     *
     * Stores created before omemo:2 support have a device_id, identity key and
     * legacy signed prekey, but no `signed_prekey_omemo2`.
     *
     * This generates the missing v2 signed prekey, reusing the existing
     * identity key so our fingerprint and device_id are unchanged. When we
     * generate one, initOMEMO publishes the (now changed) bundle right after
     * the session is restored.
     *
     * @returns {Promise<boolean>} Whether a new v2 signed prekey was generated.
     */
    async ensureV2SignedPreKey() {
        if (this.get('signed_prekey_omemo2') || !this.get('identity_keypair')) {
            return false;
        }
        src_log.info('Migrating OMEMO store: generating the missing omemo:2 signed prekey');
        const { KeyHelper } = await getCrypto();
        const signed_prekey_v2 = await KeyHelper.generateSignedPreKey(this.getIdentityKeyPair(), 0, store_Strophe.NS.OMEMO2);
        this.storeSignedPreKeyV2(signed_prekey_v2);
        return true;
    }

    /**
     * Self-heal a partially-provisioned store before its bundle is published.
     *
     * A {@link OMEMOStore#generateBundle} interrupted after persisting the
     * device_id and identity key (e.g. the tab is closed while the 100 prekeys
     * are still being generated) leaves a store with a device_id but missing
     * its signed prekeys and/or one-time prekeys.
     *
     * This backfills whatever key material is missing, reusing the existing
     * identity key and device_id so the fingerprint stays unchanged.
     * It also subsumes the omemo:2 migration for stores created before omemo:2
     * support.
     *
     * @returns {Promise<boolean>} Whether any key material was (re)generated, in
     *      which case the bundle changed and must be republished.
     */
    async ensureProvisioned() {
        let changed = await this.ensureV2SignedPreKey();
        const { KeyHelper } = await getCrypto();
        if (!this.get('signed_prekey')) {
            src_log.warn('OMEMO store is missing its legacy signed prekey; regenerating it');
            const spk = await KeyHelper.generateSignedPreKey(this.getIdentityKeyPair(), 0, store_Strophe.NS.OMEMO);
            this.storeSignedPreKey(spk);
            changed = true;
        }
        if (Object.keys(this.getPreKeys()).length === 0) {
            src_log.warn('OMEMO store has no prekeys (interrupted provisioning?); regenerating them');
            await this.generatePreKeys();
            changed = true;
        }
        if (changed) {
            // The regenerated material is no longer what we last published.
            this.save({ bundle_published: false });
        }
        return changed;
    }

    /**
     * Restores the persisted OMEMO store, provisioning or repairing it as needed.
     *
     * @returns {Promise<boolean>} Whether key material was (re)generated, so that
     *      the caller knows the bundle changed and must be (re)published.
     */
    fetchSession() {
        if (this.#setup_promise === undefined) {
            this.#setup_promise = new Promise(/** @param {(v: boolean) => void} resolve */ (resolve, reject) => {
                this.fetch({
                    success: () => {
                        if (!this.get('device_id') || !this.get('identity_keypair')) {
                            // No store yet, or a generateBundle() interrupted before
                            // the identity key was persisted. (Re)generate a complete
                            // bundle; any half-published device_id is left as an orphan.
                            // A brand-new bundle always needs publishing.
                            this.generateBundle()
                                .then(() => resolve(true))
                                .catch(reject);
                        } else {
                            // Existing store: backfill any missing key material and
                            // report whether that changed the bundle.
                            this.ensureProvisioned()
                                .then(resolve)
                                .catch((e) => {
                                    src_log.error('Could not repair/migrate the OMEMO store');
                                    src_log.error(e);
                                    resolve(false);
                                });
                        }
                    },
                    /**
                     * @param {unknown} _model
                     * @param {unknown} resp
                     */
                    error: (_model, resp) => {
                        src_log.warn(`Could not restore OMEMO session, we'll generate a new one: ${resp}`);
                        this.generateBundle()
                            .then(() => resolve(true))
                            .catch(reject);
                    },
                });
            });
        }
        return this.#setup_promise;
    }
}

async function generateDeviceID() {
    const { KeyHelper } = await getCrypto();

    /* Generates a device ID, making sure that it's unique */
    const bare_jid = shared_converse.session.get('bare_jid');
    const devicelist = await getDeviceList(bare_jid, true);
    const existing_ids = devicelist.devices.pluck('id');
    let device_id = KeyHelper.generateRegistrationId();

    // Before publishing a freshly generated device id for the first time,
    // a device MUST check whether that device id already exists, and if so, generate a new one.
    let i = 0;
    while (existing_ids.includes(device_id)) {
        device_id = KeyHelper.generateRegistrationId();
        i++;
        if (i === 10) {
            throw new Error('Unable to generate a unique device ID');
        }
    }
    return device_id.toString();
}

/* export default */ const plugins_omemo_store = (OMEMOStore);

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/api.js








const { Strophe: omemo_api_Strophe, stx: omemo_api_stx, u: omemo_api_u } = api_public.env;

/* export default */ const omemo_api = ({
    /**
     * The "omemo" namespace groups methods relevant to OMEMO
     * encryption.
     *
     * @namespace _converse.api.omemo
     * @memberOf _converse.api
     */
    omemo: {
        /**
         * Returns the device ID of the current device.
         */
        async getDeviceID() {
            await shared_api.waitUntil('OMEMOInitialized');
            return shared_converse.state.omemo_store.get('device_id');
        },

        /**
         * Encrypt and send a message to `chat` for every OMEMO version its
         * recipients support, without persisting a Message model. This is the
         * encrypted counterpart of a raw `api.send`.
         *
         * On failure (e.g. no reachable devices, or a presence/server error) a
         * user-facing alert is shown and the error is re-thrown — the same way an
         * encrypted chat-message send fails — so callers can roll back any
         * optimistic state. Awaits the encryption; resolves once the stanza is
         * handed to `api.send`.
         *
         * @method _converse.api.omemo.send
         * @param {import('../../shared/chatbox.js').default} chat
         * @param {string} plaintext - the message body (may be empty)
         * @param {import('strophe.js').Builder[]} [extensions] - encrypted SCE `<content>` children
         */
        async send(chat, plaintext, extensions = []) {
            try {
                const { elements, eme_ns } = await getEncryptedElements(chat, plaintext || null, extensions);

                // `from` is our own full JID (the server stamps/overwrites it
                // regardless); the authenticated identity is the SCE `<from>`
                // affix set during encryption.
                const stanza = omemo_api_stx`<message xmlns="jabber:client"
                        from="${shared_converse.session.get('jid')}"
                        to="${chat.get('jid')}"
                        type="${chat instanceof muc_muc ? 'groupchat' : 'chat'}"
                        id="${omemo_api_u.getUniqueId()}">
                    ${elements}
                    <encryption xmlns="${omemo_api_Strophe.NS.EME}" namespace="${eme_ns}"/>
                    <store xmlns="${omemo_api_Strophe.NS.HINTS}"/>
                </message>`;
                shared_api.send(stanza);
            } catch (e) {
                handleMessageSendError(e, chat); // surfaces a user-facing alert and re-throws
            }
        },

        session: {
            /**
             * @returns {Promise<boolean>} Whether key material was (re)generated
             *      while restoring, i.e. whether the bundle needs (re)publishing.
             */
            async restore() {
                const { state } = shared_converse;
                if (state.omemo_store === undefined) {
                    const { state } = shared_converse;
                    const bare_jid = shared_converse.session.get('bare_jid');
                    const id = `converse.omemosession-${bare_jid}`;
                    state.omemo_store = new plugins_omemo_store({ id });
                    initStorage(state.omemo_store, id);
                }
                return await state.omemo_store.fetchSession();
            },
        },

        /**
         * The "devicelists" namespace groups methods related to OMEMO device lists
         *
         * @namespace _converse.api.omemo.devicelists
         * @memberOf _converse.api.omemo
         */
        devicelists: {
            /**
             * Returns the {@link DeviceList} for a particular JID.
             * The device list will be created if it doesn't exist already.
             * @method _converse.api.omemo.devicelists.get
             * @param {String} jid - The Jabber ID for which the device list will be returned.
             * @param {boolean} [create=false] - Set to `true` if the device list
             *      should be created if it cannot be found.
             * @param {import('./types').OMEMOVersion} [version] - The OMEMO version.
             *      Defaults to the legacy version.
             */
            async get(jid, create = false, version = omemo_api_Strophe.NS.OMEMO) {
                return await getDeviceList(jid, create, version);
            },
        },

        /**
         * The "bundle" namespace groups methods relevant to the user's OMEMO bundle.
         * @namespace _converse.api.omemo.bundle
         * @memberOf _converse.api.omemo
         */
        bundle: {
            /**
             * Lets you generate a new OMEMO device bundle
             *
             * @method _converse.api.omemo.bundle.generate
             * @returns {promise} Promise which resolves once we have a result from the server.
             */
            async generate() {
                await shared_api.waitUntil('OMEMOInitialized');
                // Remove current device
                const bare_jid = shared_converse.session.get('bare_jid');
                const devicelist = await shared_api.omemo.devicelists.get(bare_jid);

                const { omemo_store } = shared_converse.state;
                const device_id = omemo_store.get('device_id');
                if (device_id) {
                    const device = devicelist.devices.get(device_id);
                    omemo_store.unset(device_id);
                    if (device) {
                        await new Promise((done) => device.destroy({ 'success': done, 'error': done }));
                    }
                    devicelist.devices.trigger('remove');
                }

                // Generate new device bundle and publish
                // We'll need to create new sessions (i.e. send out new PreKeyWhisperMessage) when sending messages
                // See: https://xmpp.org/extensions/attic/xep-0384-0.3.0.html#usecases-announcing
                await omemo_store.generateBundle();
                await omemo_store.removeAllSessions();
                await omemo_store.publishBundle();
                await devicelist.publishDevices();

                const device = devicelist.devices.get(omemo_store.get('device_id'));
                return generateFingerprint(device);
            },
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/plugin.js












const { u: plugin_u, Strophe: omemo_plugin_Strophe } = api_public.env;

api_public.plugins.add('converse-omemo', {
    dependencies: ['converse-pubsub'],

    /**
     * @param {import('../../shared/_converse.js').ConversePrivateGlobal} _converse
     */
    enabled(_converse) {
        return (
            _converse.state.config.get('trusted') &&
            !_converse.api.settings.get('clear_cache_on_logout') &&
            !_converse.api.settings.get('blacklisted_plugins').includes('converse-omemo')
        );
    },

    initialize() {
        shared_api.settings.extend({ omemo_default: false });
        shared_api.promises.add(['OMEMOInitialized']);

        const exports = {
            Device: omemo_device,
            Devices: omemo_devices,
            DeviceList: omemo_devicelist,
            DeviceLists: devicelists,
            OMEMOStore: plugins_omemo_store,
        };

        Object.assign(shared_converse.api, omemo_api);
        Object.assign(shared_converse, exports); // DEPRECATED
        Object.assign(shared_converse.exports, exports);

        shared_api.listen.on('connected', utils_registerPEPPushHandler);
        shared_api.listen.on('createMessageStanza', createMessageStanzaHandler);

        shared_api.listen.on('chatRoomInitialized', onChatInitialized);
        shared_api.listen.on('chatBoxInitialized', onChatInitialized);
        shared_api.listen.on('getOutgoingMessageAttributes', getOutgoingMessageAttributes);

        shared_api.listen.on('statusInitialized', initOMEMO);
        shared_api.listen.on('addClientFeatures', () => {
            shared_api.disco.own.features.add(`${omemo_plugin_Strophe.NS.OMEMO_DEVICELIST}+notify`);
            shared_api.disco.own.features.add(`${omemo_plugin_Strophe.NS.OMEMO2_DEVICELIST}+notify`);
        });

        shared_api.listen.on('parseMessage', parseEncryptedMessage);
        shared_api.listen.on('parseMUCMessage', parseEncryptedMessage);

        shared_api.listen.on('sendMarker', async (chatbox, data) => {
            if (!chatbox?.get('omemo_active')) return data;
            await sendOMEMO2Marker(chatbox, data.to_jid, data.id, data.type, data.msg_type).catch(() => {});
            return { ...data, handled: true };
        });

        shared_api.listen.on('afterFileUploaded', setEncryptedFileURL);
        shared_api.listen.on(
            'beforeFileUpload',
            /**
             * @param {import('../../shared/chatbox.js').default} chat
             * @param {File} file
             */
            (chat, file) => (chat.get('omemo_active') ? encryptFile(file) : file),
        );

        shared_api.listen.on('clearSession', () => {
            delete shared_converse.state.omemo_store;
            if (plugin_u.shouldClearCache(shared_converse)) {
                if (shared_converse.state.devicelists) {
                    shared_converse.state.devicelists.clearStore();
                    delete shared_converse.state.devicelists;
                }
                if (shared_converse.state.devicelists_v2) {
                    shared_converse.state.devicelists_v2.clearStore();
                    delete shared_converse.state.devicelists_v2;
                }
                if (shared_converse.state.omemo_active_states) {
                    shared_converse.state.omemo_active_states.storage?.clear();
                }
            }
            // Drop the in-memory reference so it's re-fetched from storage on
            // the next login (keeping the remembered states across re-login,
            // unless the cache was cleared above). See #1472.
            delete shared_converse.state.omemo_active_states;
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/omemo/index.js







const { Strophe: omemo_Strophe } = api_public.env;

omemo_Strophe.addNamespace('OMEMO_DEVICELIST', omemo_Strophe.NS.OMEMO + '.devicelist');
omemo_Strophe.addNamespace('OMEMO_VERIFICATION', omemo_Strophe.NS.OMEMO + '.verification');
omemo_Strophe.addNamespace('OMEMO_WHITELISTED', omemo_Strophe.NS.OMEMO + '.whitelisted');
omemo_Strophe.addNamespace('OMEMO_BUNDLES', omemo_Strophe.NS.OMEMO + '.bundles');

// OMEMO 2 (urn:xmpp:omemo:2) namespaces
omemo_Strophe.addNamespace('OMEMO2', 'urn:xmpp:omemo:2');
omemo_Strophe.addNamespace('OMEMO2_DEVICELIST', 'urn:xmpp:omemo:2:devices');
omemo_Strophe.addNamespace('OMEMO2_BUNDLES', 'urn:xmpp:omemo:2:bundles');

omemo_Strophe.addNamespace('SCE', 'urn:xmpp:sce:1');



;// CONCATENATED MODULE: ./src/headless/plugins/mam/placeholder.js



class MAMPlaceholderMessage extends skeletor_esm_Model {
    defaults() {
        return {
            msgid: getUniqueId(),
            is_ephemeral: false,
        };
    }

    async fetchMissingMessages() {
        this.set('fetching', true);
        const options = {
            rsm: {
                before: this.get('before') ?? '', // We always query backwards (newest first)
            },
            mam: {
                start: this.get('start'),
            },
        };
        await headless_utils.mam.fetchArchivedMessages(this.collection.chatbox, options);
        this.destroy();
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/mam/utils.js
/**
 * @typedef {import('../muc/muc').default} MUC
 * @typedef {import('../chat/model').default} ChatBox
 * @typedef {import('@converse/skeletor').Model} Model
 */













const { NS: utils_NS } = Strophe;
const mam_utils_u = api_public.env.utils;
const { stx: mam_utils_stx } = api_public.env;

/**
 * @param {Element|Error} e
 * @param {Element} iq
 */
async function onMAMError(e, iq) {
    if (mam_utils_u.isElement(e)) {
        const err = await parseErrorStanza(e);
        if (err?.name === 'feature-not-implemented') {
            src_log.warn(`Message Archive Management (XEP-0313) not supported by ${iq.getAttribute('to')}`);
            return;
        }
    }
    src_log.error(`Error while trying to set archiving preferences for ${iq.getAttribute('to')}.`);
    src_log.error(iq);
}

/**
 * Handle returned IQ stanza containing Message Archive
 * Management (XEP-0313) preferences.
 *
 * XXX: For now we only handle the global default preference.
 * The XEP also provides for per-JID preferences, which is
 * currently not supported in converse.js.
 *
 * Per JID preferences will be set in chat boxes, so it'll
 * probably be handled elsewhere in any case.
 *
 * @param {Element} iq
 * @param {Model} feature
 */
function onMAMPreferences(iq, feature) {
    const preference = sizzle(`prefs[xmlns="${utils_NS.MAM}"]`, iq).pop();
    const default_pref = preference.getAttribute('default');
    if (default_pref !== shared_api.settings.get('message_archiving')) {
        const stanza = $iq({ 'type': 'set' }).c('prefs', {
            'xmlns': utils_NS.MAM,
            'default': shared_api.settings.get('message_archiving'),
        });
        Array.from(preference.children).forEach((child) => stanza.cnode(child).up());

        // XXX: Strictly speaking, the server should respond with the updated prefs
        // (see example 18: https://xmpp.org/extensions/xep-0313.html#config)
        // but Prosody doesn't do this, so we don't rely on it.
        shared_api.sendIQ(stanza)
            .then(() => feature.save({ 'preferences': { 'default': shared_api.settings.get('message_archiving') } }))
            .catch(/** @param {Error|Element} e */ (e) => shared_converse.exports.onMAMError(e, stanza.tree()));
    } else {
        feature.save({ 'preferences': { 'default': shared_api.settings.get('message_archiving') } });
    }
}

/**
 * @param {Model} feature
 */
function getMAMPrefsFromFeature(feature) {
    const prefs = feature.get('preferences') || {};
    if (feature.get('var') !== utils_NS.MAM || shared_api.settings.get('message_archiving') === undefined) {
        return;
    }
    if (prefs['default'] !== shared_api.settings.get('message_archiving')) {
        const stanza = mam_utils_stx`
            <iq type="get" xmlns="jabber:client">
                <prefs xmlns="${utils_NS.MAM}"></prefs>
            </iq>`;
        shared_api.sendIQ(stanza)
            .then(/** @param {Element} iq */ (iq) => shared_converse.exports.onMAMPreferences(iq, feature))
            .catch(/** @param {Error|Element} e */ (e) => shared_converse.exports.onMAMError(e, stanza.tree()));
    }
}

/**
 * @param {MUC} muc
 */
function preMUCJoinMAMFetch(muc) {
    if (
        !shared_api.settings.get('muc_show_logs_before_join') ||
        !muc.features.get('mam_enabled') ||
        muc.get('prejoin_mam_fetched')
    ) {
        return;
    }
    fetchNewestMessages(muc);
    muc.save({ prejoin_mam_fetched: true });
}

/**
 * @param {ChatBox|MUC} model
 * @param {Error|string} error
 */
async function createMessageFromError(model, error) {
    if (error instanceof TimeoutError) {
        const msg = await model.createMessage({
            type: 'error',
            message: error.message,
            retry_event_id: error.retry_event_id,
            is_ephemeral: 20000,
        });
        msg.error = error;
    }
}

/**
 * @param {ChatBox|MUC} model
 * @param {Object} result
 * @param {Object} query
 * @param {Object} options
 * @param {('forwards'|'backwards'|false)} [should_page=false]
 */
async function handleMAMResult(model, result, query, options, should_page = false) {
    const is_muc = model.get('type') === CHATROOMS_TYPE;
    const doParseMessage = /** @param {Element} s*/ (s) =>
        is_muc ? parseMUCMessage(s, /** @type {MUC} */ (model)) : parseMessage(s);

    const messages = await Promise.all(result.messages.map(doParseMessage));
    result.messages = messages;

    /**
     * Synchronous event which allows listeners to first do some
     * work based on the MAM result before calling the handlers here.
     * @event _converse#MAMResult
     */
    const data = { query, 'chatbox': model, messages };
    await shared_api.trigger('MAMResult', data, { 'synchronous': true });

    messages.forEach((m) => model.queueMessage(m));
    if (result.error) {
        const event_id = (result.error.retry_event_id = mam_utils_u.getUniqueId());
        shared_api.listen.once(event_id, () => fetchArchivedMessages(model, options, should_page));
        createMessageFromError(model, result.error);
    }
}

/**
 * Fetch XEP-0313 archived messages based on the passed in criteria.
 * @param {ChatBox|MUC} model
 * @param {import('./types').FetchArchivedMessagesOptions} [options]
 * @param {('forwards'|'backwards'|false)} [should_page=false] - Determines whether
 *  this function should recursively page through the entire result set if a limited
 *  number of results were returned.
 */
async function fetchArchivedMessages(model, options = {}, should_page = false) {
    if (model.disable_mam) return;

    const is_muc = model.get('type') === CHATROOMS_TYPE;
    const bare_jid = shared_converse.session.get('bare_jid');
    const mam_jid = is_muc ? model.get('jid') : bare_jid;

    const supported = await shared_api.disco.supports(utils_NS.MAM, mam_jid);
    if (!supported) return;

    // The session may have been torn down while we were awaiting above. If so,
    // there's no point querying the archive (and `api.archive.query` would throw).
    if (!shared_api.connection.connected()) return;

    const max = shared_api.settings.get('archived_messages_page_size');
    const query = /** @type {import('./types').ArchiveQueryOptions} */ {
        is_groupchat: is_muc,
        rsm: {
            max,
            ...options.rsm,
        },
        mam: {
            with: model.get('jid'),
            ...options.mam,
        },
    };

    const result = await shared_api.archive.query(query);
    await handleMAMResult(model, result, query, options, should_page);

    if (result.rsm && !result.complete) {
        if (should_page) {
            if (should_page === 'forwards') {
                options = result.rsm.next(max, options.rsm.before).query;
            } else if (should_page === 'backwards') {
                options = result.rsm.previous(max, options.rsm.after).query;
            }
            return fetchArchivedMessages(model, options, should_page);
        } else {
            createGapPlaceholder(model, options, result);
        }
    }
}

/**
 * Creates a placeholder to fill gaps in the history.
 * @param {ChatBox|MUC} model
 * @param {import('./types').ArchiveQueryOptions} [options]
 * @param {import('./types').MAMQueryResult} [result]
 */
async function createGapPlaceholder(model, options, result) {
    const msgs = await Promise.all(result.messages);

    const is_muc = model.get('type') === CHATROOMS_TYPE;
    const mam_jid = is_muc ? model.get('jid') : shared_converse.session.get('bare_jid');

    const { rsm } = result;
    const key = `stanza_id ${mam_jid}`;
    const adjacent_message = msgs.find((m) => m[key] === rsm.result.first);
    const adjacent_message_date = new Date(adjacent_message['time']);

    const msg_data = {
        before: rsm.result.first,
        start: options.mam?.start,
        template_hook: 'getMessageTemplate',
        time: new Date(adjacent_message_date.getTime() - 1).toISOString(),
    };

    if (model.messages.findWhere(msg_data)) {
        src_log.debug('Gap placeholder already exists, not recreating.');
        return;
    }

    model.messages.add(new MAMPlaceholderMessage(msg_data));
}

/**
 * Creates a placeholder to fetch messages at the top of the chat history.
 * @param {ChatBox|MUC} model
 */
function createScrollupPlaceholder(model) {
    if (model.messages.length) {
        const is_muc = model.get('type') === CHATROOMS_TYPE;
        const mam_jid = is_muc ? model.get('jid') : shared_converse.session.get('bare_jid');
        const key = `stanza_id ${mam_jid}`;
        const oldest_message = model.getOldestMessage();
        if (!oldest_message) return;

        const msg_data = {
            before: oldest_message.get(key),
            template_hook: 'getMessageTemplate',
            time: new Date(new Date(oldest_message.get('time')).getTime() - 1).toISOString(),
        };

        if (model.messages.findWhere(msg_data)) {
            src_log.debug('Gap placeholder already exists, not recreating.');
            return;
        }
        model.messages.add(new MAMPlaceholderMessage(msg_data));
    }
}

/**
 * Fetches messages that might have been archived *after*
 * the last archived message in our local cache.
 * @param {ChatBox|MUC} model
 */
function fetchNewestMessages(model) {
    if (model.disable_mam) return;

    // XXX: It's important to first get the most recent message, before making any
    // async calls, like `api.disco.supports`, so that we can avoid a race
    // condition with possible new incoming messages.
    // We want the most recent cached message, otherwise we would query with
    // the wrong `start` value. This function used to call
    // `api.disco.supports`, but it's also called in `fetchArchivedMessages`,
    // so it's not necessary here.
    const most_recent_msg = model.getMostRecentMessage();
    const should_page = shared_api.settings.get('mam_request_all_pages') ? 'backwards' : false;

    if (most_recent_msg) {
        return fetchArchivedMessages(
            model,
            { mam: { start: most_recent_msg.get('time') }, rsm: { before: '' } },
            should_page,
        );
    } else {
        return fetchArchivedMessages(model, { rsm: { before: '' } }, should_page);
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/mam/api.js









const { NS: api_NS } = Strophe;
const { dayjs: api_dayjs, stx: mam_api_stx, u: mam_api_u } = api_public.env;


/* export default */ const mam_api = ({
    /**
     * The [XEP-0313](https://xmpp.org/extensions/xep-0313.html) Message Archive Management API
     *
     * Enables you to query an XMPP server for archived messages.
     *
     * See also the [message-archiving](https://conversejs.org/docs/configuration/#message-archiving)
     * option in the configuration settings section, which you'll
     * usually want to use in conjunction with this API.
     *
     * @namespace _converse.api.archive
     * @memberOf _converse.api
     */
    archive: {
         /**
          * Query for archived messages.
          *
          * The options parameter can also be an instance of
          * RSM to enable easy querying between results pages.
          *
          * @method _converse.api.archive.query
          * @param {import('./types').ArchiveQueryOptions} [options={}] - Optional query parameters
          * @throws {Error} An error is thrown if the XMPP server responds with an error.
          * @returns {Promise<import('./types').MAMQueryResult>}
          *
          * @example
          * // Requesting all archived messages
          * // ================================
          * //
          * // The simplest query that can be made is to simply not pass in any parameters.
          * // Such a query will return all archived messages for the current user.
          *
          * let result;
          * try {
          *     result = await api.archive.query();
          * } catch (e) {
          *     // The query was not successful, perhaps inform the user?
          *     // The IQ stanza returned by the XMPP server is passed in, so that you
          *     // may inspect it and determine what the problem was.
          * }
          * // Do something with the messages, like showing them in your webpage.
          * result.messages.forEach(m => this.showMessage(m));
          *
          * @example
          * // Requesting all archived messages for a particular contact or room
          * // =================================================================
          * //
          * // To query for messages sent between the current user and another user or room,
          * // the query options need to contain the the JID (Jabber ID) of the user or
          * // room under the  `with` key.
          *
          * // For a particular user
          * let result;
          * try {
          *    result = await api.archive.query({ mam: { with: 'john@doe.net' }});
          * } catch (e) {
          *     // The query was not successful
          * }
          *
          * // For a particular room
          * let result;
          * try {
          *    result = await api.archive.query({ mam: { with: 'discuss@conference.doglovers.net' }}, is_groupchat: true });
          * } catch (e) {
          *     // The query was not successful
          * }
          *
          * @example
          * // Requesting all archived messages before or after a certain date
          * // ===============================================================
          * //
          * // The MAM `start` and `end` parameters are used to query for messages
          * // within a certain timeframe. The passed in date values may either be ISO8601
          * // formatted date strings, or JavaScript Date objects.
          *
          *  const options = {
          *      mam: {
          *          'with': 'john@doe.net',
          *          'start': '2010-06-07T00:00:00Z',
          *          'end': '2010-07-07T13:23:54Z'
          *      },
          *  };
          * let result;
          * try {
          *    result = await api.archive.query(options);
          * } catch (e) {
          *     // The query was not successful
          * }
          *
          * @example
          * // Limiting the amount of messages returned
          * // ========================================
          * //
          * // The amount of returned messages may be limited with the `max` parameter.
          * // By default, the messages are returned from oldest to newest.
          *
          * // Return maximum 10 archived messages
          * let result;
          * try {
          *     result = await api.archive.query({ mam: { with: 'john@doe.net', max:10 }});
          * } catch (e) {
          *     // The query was not successful
          * }
          *
          * @example
          * // Paging forwards through a set of archived messages
          * // ==================================================
          * //
          * // When limiting the amount of messages returned per query, you might want to
          * // repeatedly make a further query to fetch the next batch of messages.
          * //
          * // To simplify this usecase for you, the callback method receives not only an array
          * // with the returned archived messages, but also a special RSM (*Result Set Management*)
          * // object which contains the query parameters you passed in, as well
          * // as two utility methods `next`, and `previous`.
          * //
          * // When you call one of these utility methods on the returned RSM object, and then
          * // pass the result into a new query, you'll receive the next or previous batch of
          * // archived messages. Please note, when calling these methods, pass in an integer
          * // to limit your results.
          *
          * const options = { mam: { with: 'john@doe.net' }, rsm: { max:10 }};
          * let result;
          * try {
          *     result = await api.archive.query(options);
          * } catch (e) {
          *     // The query was not successful
          * }
          * // Do something with the messages, like showing them in your webpage.
          * result.messages.forEach(m => this.showMessage(m));
          *
          * while (!result.complete) {
          *     try {
          *         result = await api.archive.query({
          *             mam: { ...options.mam },
          *             rsm: {
          *                 ...options.rsm,
          *                 ...rsm.next(10).query
          *                 }
          *             });
          *     } catch (e) {
          *         // The query was not successful
          *     }
          *     // Do something with the messages, like showing them in your webpage.
          *     result.messages.forEach(m => this.showMessage(m));
          * }
          *
          * @example
          * // Paging backwards through a set of archived messages
          * // ===================================================
          * //
          * // To page backwards through the archive, you need to know the UID of the message
          * // which you'd like to page backwards from and then pass that as value for the
          * // `before` parameter. If you simply want to page backwards from the most recent
          * // message, pass in the `before` parameter with an empty string value `''`.
          *
          * let result;
          * const options = { rsm: { before: '', max:5 }};
          * try {
          *     result = await api.archive.query(options);
          * } catch (e) {
          *     // The query was not successful
          * }
          * // Do something with the messages, like showing them in your webpage.
          * result.messages.forEach(m => this.showMessage(m));
          *
          * // Now we query again, to get the previous batch.
          * try {
          *     try {
          *         result = await api.archive.query({
          *             mam: { ...options.mam },
          *             rsm: {
          *                 ...options.rsm,
          *                 ...rsm.previous(5).query
          *                 }
          *             });
          * } catch (e) {
          *     // The query was not successful
          * }
          * // Do something with the messages, like showing them in your webpage.
          * result.messages.forEach(m => this.showMessage(m));
          *
          */
        async query (options={}) {
            if (!shared_api.connection.connected()) {
                throw new Error('Can\'t call `api.archive.query` before having established an XMPP session');
            }

            let toJID;
            if (options && options.is_groupchat) {
                if (!options.mam?.with) {
                    throw new Error(
                        'You need to specify a "with" value containing '+
                        'the groupchat JID, when querying groupchat messages.');
                }
                toJID = options.mam.with;
            }

            const withJID = !options.is_groupchat && options.mam?.with || null;

            const bare_jid = shared_converse.session.get('bare_jid');
            const jid = toJID || bare_jid;
            const supported = await shared_api.disco.supports(api_NS.MAM, jid);
            if (!supported) {
                src_log.warn(`Did not fetch MAM archive for ${jid} because it doesn't support ${api_NS.MAM}`);
                return { messages: [] };
            }

            // Validate start and end dates and add them to attrs (in the right format)
            const { start: startDate, end: endDate } = ['start', 'end'].reduce((acc, t) => {
                if (options.mam?.[t]) {
                    const date = api_dayjs(options.mam[t]);
                    if (date.isValid()) {
                        acc[t] = date.toISOString();
                    } else {
                        throw new TypeError(`archive.query: invalid date provided for: ${t}`);
                    }
                }
                return acc;
            }, { start: null, end: null });

            const connection = shared_api.connection.get();
            const rsm = options.rsm ? new RSM(options.rsm) : {};
            const queryid = mam_api_u.getUniqueId();

            const stanza = mam_api_stx`
                <iq id="${mam_api_u.getUniqueId()}"
                        ${toJID ? Stanza.unsafeXML(`to="${Strophe.xmlescape(toJID)}"`) : ""}
                        type="set"
                        xmlns="jabber:client">
                    <query queryid="${queryid}" xmlns="${api_NS.MAM}">
                        ${
                            withJID || startDate || endDate
                                ? mam_api_stx`
                            <x type="submit" xmlns="${api_NS.XFORM}">
                                <field type="hidden" var="FORM_TYPE"><value>${api_NS.MAM}</value></field>
                                ${withJID ? mam_api_stx`<field var="with"><value>${withJID}</value></field>` : ""}
                                ${startDate ? mam_api_stx`<field var="start"><value>${startDate}</value></field>` : ""}
                                ${endDate ? mam_api_stx`<field var="end"><value>${endDate}</value></field>` : ""}
                            </x>`
                                : ""
                        }
                        ${Object.keys(rsm.query ?? {}).length ? Stanza.fromString(rsm.toString()) : ""}
                    </query>
                </iq>`;

            const messages = [];
            const message_handler = connection.addHandler(/** @param {Element} stanza */(stanza) => {
                const result = sizzle(`message > result[xmlns="${api_NS.MAM}"]`, stanza).pop();
                if (result === undefined || result.getAttribute('queryid') !== queryid) {
                    return true;
                }
                const from = stanza.getAttribute('from') || bare_jid;
                if (options.is_groupchat) {
                    if (from !== options.mam?.with) {
                        src_log.warn(`Ignoring alleged groupchat MAM message from ${stanza.getAttribute('from')}`);
                        return true;
                    }
                } else if (from !== bare_jid) {
                    src_log.warn(`Ignoring alleged MAM message from ${stanza.getAttribute('from')}`);
                    return true;
                }
                messages.push(stanza);
                return true;
            }, api_NS.MAM);

            let error;
            const timeout = shared_api.settings.get('message_archiving_timeout');
            const iq_result = await shared_api.sendIQ(stanza, timeout, false);
            if (iq_result === null) {
                const { __ } = shared_converse;
                const err_msg = __("Timeout while trying to fetch archived messages.");
                src_log.error(err_msg);
                error = new TimeoutError(err_msg);
                return { messages, error };

            } else if (mam_api_u.isErrorStanza(iq_result)) {
                const { __ } = shared_converse;
                const err_msg = __('An error occurred while querying for archived messages.');
                src_log.error(err_msg);
                src_log.error(iq_result);
                error = new Error(err_msg);
                return { messages, error };
            }
            connection.deleteHandler(message_handler);

            let rsm_result;
            const fin = iq_result && sizzle(`fin[xmlns="${api_NS.MAM}"]`, iq_result).pop();
            const complete = fin?.getAttribute('complete') === 'true';
            const set = sizzle(`set[xmlns="${api_NS.RSM}"]`, fin).pop();
            if (set) {
                rsm_result = new RSM({...options.rsm, xml: set});
            }
            return { messages, rsm: rsm_result, complete };
        }
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/mam/plugin.js
/**
 * @description XEP-0313 Message Archive Management
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */










const { NS: plugin_NS } = Strophe;

api_public.plugins.add("converse-mam", {
    dependencies: ["converse-disco", "converse-muc"],

    initialize() {
        shared_api.settings.extend({
            archived_messages_page_size: "50",
            mam_request_all_pages: false,
            message_archiving: undefined, // Supported values are 'always', 'never', 'roster'
            // https://xmpp.org/extensions/xep-0313.html#prefs
            message_archiving_timeout: 60000, // Time (in milliseconds) to wait before aborting MAM request
        });

        Object.assign(shared_api, mam_api);
        // This is mainly done to aid with tests
        const exports = { onMAMError: onMAMError, onMAMPreferences: onMAMPreferences, handleMAMResult: handleMAMResult, MAMPlaceholderMessage: MAMPlaceholderMessage };
        Object.assign(shared_converse, exports); // XXX DEPRECATED
        Object.assign(shared_converse.exports, exports);

        /************************ Event Handlers ************************/
        shared_api.listen.on("addClientFeatures", () => shared_api.disco.own.features.add(plugin_NS.MAM));
        shared_api.listen.on("serviceDiscovered", getMAMPrefsFromFeature);
        shared_api.listen.on("chatRoomViewInitialized", ({ model }) => {
            if (shared_api.settings.get("muc_show_logs_before_join")) {
                preMUCJoinMAMFetch(model);
                // If we want to show MAM logs before entering the MUC, we need
                // to be informed once it's clear that this MUC supports MAM.
                model.features.on("change:mam_enabled", () => preMUCJoinMAMFetch(model));
            }
        });
        shared_api.listen.on(
            "enteredNewRoom",
            /** @param {import('../muc/muc').default} muc */ async (muc) => {
                try {
                    if (muc.features.get("mam_enabled")) {
                        await fetchNewestMessages(muc);
                        // `fetchNewestMessages` only *queues* the fetched messages
                        // for processing (via `queueMessage`), so wait for that
                        // queue to drain before declaring the history settled —
                        // otherwise a room with history could momentarily look empty.
                        await muc.msg_chain;
                    }
                } finally {
                    // History has settled (fetched, errored, or MAM unavailable).
                    // Always flip the flag so views can treat a message-less room
                    // as genuinely empty rather than waiting forever.
                    muc.session.save({ mam_initialized: true });
                }
            }
        );

        shared_api.listen.on("chatReconnected", (chat) => {
            if (![CHATROOMS_TYPE, PRIVATE_CHAT_TYPE].includes(chat.get("type"))) {
                return;
            }
            fetchNewestMessages(chat);
        });

        shared_api.listen.on("afterMessagesFetched", (chat) => {
            if (chat.get("type") === PRIVATE_CHAT_TYPE) {
                fetchNewestMessages(chat);
            }
            createScrollupPlaceholder(chat);
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/mam/index.js





Object.assign(headless_utils, { mam: { fetchArchivedMessages: fetchArchivedMessages }});



;// CONCATENATED MODULE: ./src/headless/plugins/ping/utils.js





const { Strophe: ping_utils_Strophe, stx: ping_utils_stx } = api_public.env;

let lastStanzaDate;

function utils_onWindowStateChanged () {
    if (!isAppHidden()) shared_api.ping(null, 5000);
}

function setLastStanzaDate (date) {
    lastStanzaDate = date;
}

function pong (ping) {
    lastStanzaDate = new Date();
    const from = ping.getAttribute('from');
    const id = ping.getAttribute('id');
    const iq = ping_utils_stx`<iq type="result" to="${from}" id="${id}" xmlns="jabber:client"></iq>`;
    shared_api.sendIQ(iq);
    return true;
}

function registerPongHandler () {
    const connection = shared_api.connection.get();
    if (connection.disco) {
        shared_api.disco.own.features.add(ping_utils_Strophe.NS.PING);
    }
    return connection.addHandler(pong, ping_utils_Strophe.NS.PING, "iq", "get");
}

function registerPingHandler () {
    shared_api.connection.get()?.addHandler(() => {
        if (shared_api.settings.get('ping_interval') > 0) {
            // Handler on each stanza, saves the received date
            // in order to ping only when needed.
            lastStanzaDate = new Date();
            return true;
        }
    });
}

let intervalId;

function registerHandlers () {
    // Wrapper so that we can spy on registerPingHandler in tests
    registerPongHandler();
    registerPingHandler();
    clearInterval(intervalId);
    intervalId = setInterval(onEverySecond, 1000);
}

function unregisterIntervalHandler () {
    clearInterval(intervalId);
}

function onEverySecond () {
    if (isTestEnv() || !shared_api.connection.authenticated()) {
        return;
    }
    const ping_interval = shared_api.settings.get('ping_interval');
    if (ping_interval > 0) {
        const now = new Date();
        lastStanzaDate = lastStanzaDate ?? now;
        if ((now.valueOf() - lastStanzaDate.valueOf())/1000 > ping_interval) {
            shared_api.ping();
        }
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/ping/api.js






const { Strophe: ping_api_Strophe, u: ping_api_u, stx: ping_api_stx } = api_public.env;

/* export default */ const ping_api = ({
    /**
     * Pings the entity represented by the passed in JID by sending an IQ stanza to it.
     * @method api.ping
     * @param {string} [jid] - The JID of the service to ping
     *  If the ping is sent out to the user's bare JID and no response is received it will attempt to reconnect.
     * @param {number} [timeout] - The amount of time in
     *  milliseconds to wait for a response. The default is 10000;
     * @returns {Promise<boolean|null>}
     *  Whether the pinged entity responded with a non-error IQ stanza.
     *  If we already know we're not connected, no ping is sent out and `null` is returned.
     */
    async ping(jid, timeout) {
        if (!shared_api.connection.authenticated()) {
            src_log.debug("Not pinging when we know we're not authenticated");
            return null;
        }

        // XXX: We could first check here if the server advertised that it supports PING.
        // However, some servers don't advertise while still responding to pings
        // const feature = _converse.disco_entities[_converse.domain].features.findWhere({'var': Strophe.NS.PING});
        setLastStanzaDate(new Date());
        const bare_jid = shared_converse.session.get('bare_jid');
        jid = jid || ping_api_Strophe.getDomainFromJid(bare_jid);
        const iq = ping_api_stx`
            <iq type="get"
                to="${jid}"
                id="${ping_api_u.getUniqueId('ping')}"
                xmlns="jabber:client">
                <ping xmlns="${ping_api_Strophe.NS.PING}"></ping>
            </iq>`;

        const result = await shared_api.sendIQ(iq, timeout || 10000, false);
        if (result === null) {
            src_log.warn(`Timeout while pinging ${jid}`);
            if (jid === ping_api_Strophe.getDomainFromJid(bare_jid)) {
                shared_api.connection.reconnect();
            }
            return false;
        } else if (ping_api_u.isErrorStanza(result)) {
            src_log.error(`Error while pinging ${jid}`);
            src_log.error(result);
            return false;
        }
        return true;
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/ping/index.js
/**
 * @description
 * Converse.js plugin which add support for application-level pings
 * as specified in XEP-0199 XMPP Ping.
 * @copyright 2022, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */






const { Strophe: ping_Strophe } = api_public.env;


ping_Strophe.addNamespace('PING', "urn:xmpp:ping");


api_public.plugins.add('converse-ping', {

    initialize () {
        shared_api.settings.extend({
            ping_interval: 60 //in seconds
        });

        Object.assign(shared_api, ping_api);

        shared_api.listen.on('connected', registerHandlers);
        shared_api.listen.on('reconnected', registerHandlers);
        shared_api.listen.on('disconnected', unregisterIntervalHandler);

        addVisibilityListener(utils_onWindowStateChanged);
    }
});

;// CONCATENATED MODULE: ./src/headless/plugins/pubsub/parsers.js


/**
 * @param {Element} iq - An IQ result stanza
 * @returns {import('./types').PubSubConfigOptions}
 */
function parseStanzaForPubSubConfig(iq) {
    return parseXForm(iq).fields.reduce((acc, f) => {
        if (f.var.startsWith('pubsub#')) {
            const key = f.var.replace(/^pubsub#/, '');
            if (f.type === 'boolean') {
                acc[key] = f.checked;
            } else if (f.type === 'list-multi' || f.type === 'text-multi' || f.type === 'jid-multi') {
                acc[key] = f.values?.length ? f.values : null;
            } else {
                acc[key] = f.value ?? null;
            }
        }
        return acc;
    }, {});
}

;// CONCATENATED MODULE: ./src/headless/plugins/pubsub/api.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */








const { Strophe: pubsub_api_Strophe, stx: pubsub_api_stx, Stanza: pubsub_api_Stanza } = api_public.env;

/* export default */ const pubsub_api = ({
    /**
     * @typedef {import('strophe.js').Builder} Builder
     * @typedef {import('strophe.js').Stanza} Stanza
     * @typedef {import('./types').PubSubConfigOptions} PubSubConfigOptions
     *
     * The "pubsub" namespace groups methods relevant to PubSub
     * @namespace _converse.api.pubsub
     * @memberOf _converse.api
     */
    pubsub: {
        config: {
            /**
             * Fetches the configuration for a PubSub node
             * @method _converse.api.pubsub.config.get
             * @param {string} jid - The JID of the pubsub service where the node resides
             * @param {string} node - The node to configure
             * @returns {Promise<import('./types').PubSubConfigOptions>}
             */
            async get(jid, node) {
                if (!node) throw new Error('api.pubsub.config.get: Node value required');

                const bare_jid = shared_converse.session.get('bare_jid');
                const full_jid = shared_converse.session.get('jid');
                const entity_jid = jid || bare_jid;

                const stanza = pubsub_api_stx`
                    <iq xmlns="jabber:client"
                        from="${full_jid}"
                        type="get"
                        to="${entity_jid}">
                    <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}#owner"><configure node="${node}"/></pubsub>
                    </iq>`;

                let response;
                try {
                    response = await shared_api.sendIQ(stanza);
                } catch (error) {
                    throw await parseErrorStanza(error);
                }
                return parseStanzaForPubSubConfig(response);
            },

            /**
             * Configures a PubSub node
             * @method _converse.api.pubsub.config.set
             * @param {string} jid The JID of the pubsub service where the node resides
             * @param {string} node The node to configure
             * @param {PubSubConfigOptions} config The configuration options
             * @returns {Promise<import('./types').PubSubConfigOptions>}
             */
            async set(jid, node, config) {
                if (!node) throw new Error('api.pubsub.config.set: Node value required');

                const bare_jid = shared_converse.session.get('bare_jid');
                const entity_jid = jid || bare_jid;
                const new_config = {
                    ...(await shared_api.pubsub.config.get(entity_jid, node)),
                    ...config,
                };

                // Fields without a value are omitted so that they're left as-is by the server.
                // Multi-value fields are submitted as one <value> per entry.
                const stanza = pubsub_api_stx`
                    <iq xmlns="jabber:client"
                        from="${bare_jid}"
                        type="set"
                        to="${entity_jid}">
                    <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}#owner">
                        <configure node="${node}">
                            <x xmlns="${pubsub_api_Strophe.NS.XFORM}" type="submit">
                                <field var="FORM_TYPE" type="hidden">
                                    <value>${pubsub_api_Strophe.NS.PUBSUB}#node_config</value>
                                </field>
                                ${Object.entries(new_config)
                                    .filter(([, v]) => v != null)
                                    .map(
                                        ([k, v]) =>
                                            pubsub_api_stx`<field var="pubsub#${k}">${(Array.isArray(v) ? v : [v]).map(
                                                (v) => pubsub_api_stx`<value>${v}</value>`,
                                            )}</field>`,
                                    )}
                            </x>
                        </configure>
                    </pubsub>
                    </iq>`;

                try {
                    await shared_api.sendIQ(stanza);
                } catch (error) {
                    throw await parseErrorStanza(error);
                }
                return new_config;
            },
        },

        /**
         * Publishes an item to a PubSub node
         * @method _converse.api.pubsub.publish
         * @param {string} jid The JID of the pubsub service where the node resides.
         * @param {string} node The node being published to
         * @param {Builder|Stanza|(Builder|Stanza)[]} item The XML element(s) being published
         * @param {PubSubConfigOptions} options The publisher options
         *      (see https://xmpp.org/extensions/xep-0060.html#publisher-publish-options)
         * @param {boolean} strict_options Indicates whether the publisher
         *      options are a strict requirement or not. If they're NOT
         *      strict, then Converse will publish to the node even if
         *      the publish options precondition cannot be met.
         * @returns {Promise<void|Element>}
         */
        async publish(jid, node, item, options, strict_options = true) {
            if (!node) throw new Error('api.pubsub.publish: node value required');
            if (!item) throw new Error('api.pubsub.publish: item value required');

            const bare_jid = shared_converse.session.get('bare_jid');
            const entity_jid = jid || bare_jid;

            const stanza = pubsub_api_stx`
                <iq xmlns="jabber:client"
                    from="${bare_jid}"
                    type="set"
                    to="${entity_jid}">
                <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}">
                    <publish node="${node}">${item}</publish>
                    ${
                        options
                            ? pubsub_api_stx`<publish-options>
                    <x xmlns="${pubsub_api_Strophe.NS.XFORM}" type="submit">
                        <field var="FORM_TYPE" type="hidden">
                            <value>${pubsub_api_Strophe.NS.PUBSUB}#publish-options</value>
                        </field>
                        ${Object.entries(options).map(
                            ([k, v]) => pubsub_api_stx`<field var="pubsub#${k}"><value>${v}</value></field>`,
                        )}
                    </x></publish-options>`
                            : ''
                    }
                </pubsub>
                </iq>`;

            if (entity_jid === bare_jid) {
                // This is PEP, check for support
                const supports_pep =
                    (await shared_api.disco.getIdentity('pubsub', 'pep', bare_jid)) ||
                    (await shared_api.disco.getIdentity('pubsub', 'pep', pubsub_api_Strophe.getDomainFromJid(bare_jid)));

                if (!supports_pep) {
                    src_log.warn(`api.pubsub.publish: Not publishing via PEP because it's not supported!`);
                    src_log.warn(stanza);
                    return;
                }
            }

            // Check for #publish-options support.
            const supports_publish_options =
                (await shared_api.disco.supports(pubsub_api_Strophe.NS.PUBSUB + '#publish-options', entity_jid)) ||
                (entity_jid === bare_jid &&
                    // XEP-0223 says we need to check the server for support
                    // (although Prosody returns it on the bare jid)
                    (await shared_api.disco.supports(
                        pubsub_api_Strophe.NS.PUBSUB + '#publish-options',
                        pubsub_api_Strophe.getDomainFromJid(entity_jid),
                    )));

            if (!supports_publish_options && strict_options) {
                src_log.warn(`api.pubsub.publish: #publish-options not supported, refusing to publish item.`);
                src_log.warn(stanza);
                return;
            }

            try {
                await shared_api.sendIQ(stanza);
            } catch (iq) {
                const e = await parseErrorStanza(iq);
                if (
                    e.name === 'conflict' &&
                    /** @type {import('shared/errors').StanzaError} */ (e).extra[pubsub_api_Strophe.NS.PUBSUB_ERROR] ===
                        'precondition-not-met'
                ) {
                    try {
                        // Manually configure the node if we can't set it via publish-options
                        await shared_api.pubsub.config.set(entity_jid, node, options);
                        await shared_api.sendIQ(stanza);
                    } catch (e) {
                        // The reconfigure path can fail at any step: fetching the
                        // config (e.g. `forbidden` on a node we don't own), setting
                        // it, or the retried publish itself.
                        src_log.error(e);
                        if (!strict_options) {
                            // The publish-options precondition couldn't be met.
                            // We re-publish but without publish-options.
                            const el = stanza.tree();
                            const options_el = el.querySelector('publish-options');
                            options_el.parentNode.removeChild(options_el);
                            src_log.warn(`api.pubsub.publish: #publish-options precondition-not-met, publishing anyway.`);
                            await shared_api.sendIQ(el);
                        } else {
                            throw e;
                        }
                    }
                } else {
                    throw iq;
                }
            }
        },

        /**
         * Retracts (deletes) an item from a PubSub node (XEP-0060 § 7.2).
         * @method _converse.api.pubsub.retract
         * @param {string} jid - The JID of the pubsub service where the node
         *      resides. Pass a falsy value to retract from your own PEP service.
         * @param {string} node - The node to retract the item from
         * @param {string} id - The id of the item to retract
         * @param {object} [options]
         * @param {boolean} [options.notify=true] - Whether to ask the server to
         *      notify subscribers of the retraction.
         * @returns {Promise<void>}
         */
        async retract(jid, node, id, options = {}) {
            if (!node) throw new Error('api.pubsub.retract: node value required');
            if (!id) throw new Error('api.pubsub.retract: id value required');

            const { notify = true } = options;
            const bare_jid = shared_converse.session.get('bare_jid');
            const entity_jid = jid || bare_jid;

            const stanza = pubsub_api_stx`
                <iq xmlns="jabber:client" from="${bare_jid}" type="set" to="${entity_jid}">
                    <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}">
                        <retract node="${node}" notify="${notify ? 'true' : 'false'}">
                            <item id="${id}"/>
                        </retract>
                    </pubsub>
                </iq>`;

            try {
                await shared_api.sendIQ(stanza);
            } catch (error) {
                throw await parseErrorStanza(error);
            }
        },

        /**
         * Creates a PubSub node at a given service
         * @param {string} jid - The PubSub service JID
         * @param {string} node - The node to create
         * @param {PubSubConfigOptions} config The configuration options
         * @returns {Promise<void>}
         */
        async create(jid, node, config) {
            if (!node) throw new Error('api.pubsub.create: node value required');

            const own_jid = shared_converse.state.session.get('jid');
            const iq = pubsub_api_stx`
                <iq xmlns="jabber:client"
                    type="set"
                    from="${own_jid}"
                    to="${jid}">
                    <pubsub xmlns="http://jabber.org/protocol/pubsub">
                        <create node="${node}"/>
                        <configure>
                            <x xmlns="${pubsub_api_Strophe.NS.XFORM}" type="submit">
                                <field var="FORM_TYPE" type="hidden">
                                    <value>${pubsub_api_Strophe.NS.PUBSUB}#node_config</value>
                                </field>
                                ${Object.entries(config).map(
                                    ([k, v]) => pubsub_api_stx`<field var="pubsub#${k}"><value>${v}</value></field>`,
                                )}
                            </x>
                        </configure>
                    </pubsub>
                </iq>`;

            try {
                await shared_api.sendIQ(iq);
            } catch (error) {
                throw await parseErrorStanza(error);
            }
        },

        /**
         * Subscribes the local user to a PubSub node.
         *
         * Subscribes with the *bare* JID, so the subscription is durable and
         * resource-independent: notifications are delivered to whichever
         * resource is online, and the subscription survives reconnects (a
         * full-JID subscription is bound to a resource that changes on every
         * reconnect, silently stranding delivery on the old resource).
         * @method _converse.api.pubsub.subscribe
         * @param {string} jid - PubSub service JID.
         * @param {string} node - The node to subscribe to
         * @returns {Promise<void>}
         */
        async subscribe(jid, node) {
            if (!node) throw new Error('api.pubsub.subscribe: node value required');

            const service = jid || (await shared_api.disco.entities.find('http://jabber.org/protocol/pubsub'));
            const from = shared_converse.session.get('jid');
            const bare_jid = shared_converse.session.get('bare_jid');
            const iq = pubsub_api_stx`
                <iq type="set" from="${from}" to="${service}" xmlns="jabber:client">
                  <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}">
                    <subscribe node="${node}" jid="${bare_jid}"/>
                  </pubsub>
                </iq>`;

            try {
                await shared_api.sendIQ(iq);
            } catch (error) {
                throw await parseErrorStanza(error);
            }
        },

        /**
         * Unsubscribes the local user from a PubSub node. Unsubscribes the bare
         * JID, matching the durable subscription created by {@link subscribe}.
         * @method _converse.api.pubsub.unsubscribe
         * @param {string} jid - The PubSub service JID
         * @param {string} node - The node to unsubscribe from
         * @returns {Promise<void>}
         */
        async unsubscribe(jid, node) {
            if (!node) throw new Error('api.pubsub.unsubscribe: node value required');

            const from = shared_converse.session.get('jid');
            const bare_jid = shared_converse.session.get('bare_jid');
            const iq = pubsub_api_stx`
                <iq type="set" from="${from}" to="${jid}" xmlns="jabber:client">
                  <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}">
                    <unsubscribe node="${node}" jid="${bare_jid}"/>
                  </pubsub>
                </iq>`;

            try {
                await shared_api.sendIQ(iq);
            } catch (error) {
                throw await parseErrorStanza(error);
            }
        },

        /**
         * Retrieves the subscriptions for the local user.
         * @method _converse.api.pubsub.subscriptions
         * @param {string} [jid] - The PubSub service JID.
         * @param {string} [node] - The node to retrieve subscriptions from.
         * @returns {Promise<import('./types').PubSubSubscription[]>}
         */
        async subscriptions(jid, node) {
            const service = jid || (await shared_api.disco.entities.find(pubsub_api_Strophe.NS.PUBSUB));
            const own_jid = shared_converse.session.get('jid');
            const iq = pubsub_api_stx`
                <iq xmlns="jabber:client"
                    type="get"
                    from="${own_jid}"
                    to="${service}">
                  <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}">
                    <subscriptions${node ? ` node="${node}"` : ''}/>
                  </pubsub>
                </iq>`;
            const response = await shared_api.sendIQ(iq);
            const subs_el = response.querySelector('pubsub subscriptions');
            if (!subs_el) return [];

            const subs = Array.from(subs_el.querySelectorAll('subscription')).map((el) => ({
                node: el.getAttribute('node'),
                jid: el.getAttribute('jid'),
                subscription: el.getAttribute('subscription'),
                subid: el.hasAttribute('subid') ? el.getAttribute('subid') : undefined,
            }));
            return subs;
        },

        items: {
            /**
             * Retrieves items from a PubSub node (XEP-0060 § 6.5 "Retrieve Items").
             *
             * Supports requesting the most recent N items (`max_items`), specific
             * item ids (`item_ids`), and paging through large result sets with
             * XEP-0059 Result Set Management (`rsm`).
             *
             * @method _converse.api.pubsub.items.get
             * @param {string|null} jid - The JID of the pubsub service where the node
             *      resides. Pass a falsy value to query your own PEP service (bare JID).
             * @param {string} node - The node to retrieve items from
             * @param {import('./types').PubSubItemsOptions} [options]
             * @returns {Promise<import('./types').PubSubItemsResult>}
             */
            async get(jid, node, options = {}) {
                if (!node) throw new Error('api.pubsub.items.get: node value required');

                const bare_jid = shared_converse.session.get('bare_jid');
                const full_jid = shared_converse.session.get('jid');
                const entity_jid = jid || bare_jid;

                const { max_items, item_ids, rsm: rsm_options, timeout } = options;
                const rsm = rsm_options ? new RSM(rsm_options) : null;

                const stanza = pubsub_api_stx`
                    <iq xmlns="jabber:client"
                        type="get"
                        from="${full_jid}"
                        to="${entity_jid}">
                    <pubsub xmlns="${pubsub_api_Strophe.NS.PUBSUB}">
                        <items node="${node}"${max_items ? pubsub_api_Stanza.unsafeXML(` max_items="${max_items}"`) : ''}>
                            ${item_ids?.map((id) => pubsub_api_stx`<item id="${id}"/>`) ?? ''}
                        </items>
                        ${rsm ? pubsub_api_Stanza.fromString(rsm.toString()) : ''}
                    </pubsub>
                    </iq>`;

                let response;
                try {
                    response = await shared_api.sendIQ(stanza, timeout);
                } catch (error) {
                    throw await parseErrorStanza(error);
                }

                const items = Array.from(response.querySelectorAll('pubsub > items > item'));
                const set = response.querySelector('pubsub > set');
                return {
                    items,
                    rsm: set ? new RSM({ ...(rsm_options ?? {}), xml: set }) : undefined,
                };
            },

            /**
             * Resolve the payloads of a batch of PubSub event items, retrieving any
             * that arrived as a bare `<item id/>` header.
             *
             * A node whose `pubsub#deliver_payloads` is `false` is
             * "notification-only". It notifies subscribers with headers and expects
             * them to retrieve the content themselves (XEP-0060 § 4.3 Event Types).
             *
             * Best-effort: an id the service doesn't return is logged and left out,
             * rather than silently thinning the batch. The order of the rest is
             * preserved.
             *
             * @method _converse.api.pubsub.items.resolve
             * @param {string|null} jid - The JID of the pubsub service where the node
             *      resides. Pass a falsy value for your own PEP service (bare JID).
             * @param {string} node - The node the items were published to
             * @param {Element[]} items - The `<item>` elements from the event
             * @returns {Promise<Element[]>}
             */
            async resolve(jid, node, items) {
                const item_ids = items
                    .filter((el) => !el.firstElementChild)
                    .map((el) => el.getAttribute('id'))
                    .filter(Boolean);

                if (!item_ids.length) return items;

                const by_id = new Map();
                try {
                    const { items: fetched } = await shared_api.pubsub.items.get(jid, node, { item_ids });

                    // Keyed by id rather than taken in order, so a server that
                    // ignores the requested ids and returns the whole node still
                    // yields the right items.
                    fetched.forEach(/** @param {Element} el */ (el) => by_id.set(el.getAttribute('id'), el));

                    const missing = item_ids.filter((id) => !by_id.has(id));
                    if (missing.length) {
                        src_log.warn(`pubsub.items.resolve: no items ${missing} in ${node} at ${jid}`);
                    }
                } catch (e) {
                    src_log.warn(`pubsub.items.resolve: could not fetch items ${item_ids} from ${node} at ${jid}: ${e}`);
                }
                return items
                    .map((el) => (el.firstElementChild ? el : by_id.get(el.getAttribute('id'))))
                    .filter(Boolean);
            },
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/pubsub/index.js
/**
 * @module converse-pubsub
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */





const { Strophe: pubsub_Strophe, sizzle: pubsub_sizzle } = api_public.env;

pubsub_Strophe.addNamespace('PUBSUB_ERROR', pubsub_Strophe.NS.PUBSUB + '#errors');

api_public.plugins.add('converse-pubsub', {
    dependencies: ['converse-disco'],

    initialize() {
        const { api } = shared_converse;
        Object.assign(shared_converse.api, pubsub_api);

        api.listen.on(
            'parseErrorStanza',
            /**
             * @param {Element} stanza
             * @param {import('shared/types.js').ErrorExtra} extra
             */
            (stanza, extra) => {
                const pubsub_err = pubsub_sizzle(`error [xmlns="${pubsub_Strophe.NS.PUBSUB_ERROR}"]`, stanza).pop();
                if (pubsub_err) {
                    return {
                        ...extra,
                        [pubsub_Strophe.NS.PUBSUB_ERROR]: pubsub_err.nodeName,
                    };
                }
                return extra;
            }
        );
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/time/utils.js







const { Stanza: time_utils_Stanza, Strophe: time_utils_Strophe, stx: time_utils_stx } = api_public.env;

/**
 * Whether we're willing to disclose our local time to the entity that asked.
 *
 * XEP-0202 § 5 notes that an offset leaks something about where you are, but
 * gives no guidance on who may ask. The `send_entity_time` setting decides:
 * 'public' answers anyone, anything else truthy answers only entities
 * subscribed to our presence (the rule XEP-0012 § 7 imposes on the comparable
 * Last Activity data), and anything falsy answers nobody.
 *
 * Treating unrecognised truthy values as 'presence' means a stale or mistyped
 * setting errs towards disclosing less.
 * @param {string|null} from - The 'from' attribute of the incoming IQ
 * @returns {Promise<boolean>}
 */
async function mayShareTimeWith(from) {
    const setting = shared_api.settings.get('send_entity_time');
    if (!setting) return false;
    if (setting === 'public') return true;

    // An IQ without a 'from' was sent by our own server on our behalf.
    if (!from) return true;

    // Roster contacts are stored under a lowercased bare JID, and not every
    // server hands us a normalised localpart.
    const bare_jid = time_utils_Strophe.getBareJidFromJid(from).toLowerCase();
    // Our own other resources are us, and always get an answer.
    if (bare_jid === shared_converse.session?.get('bare_jid')) return true;

    // A contact's client can ask as soon as it sees our presence, which is
    // before we've fetched the roster. Reading an empty roster then would deny
    // someone who is in fact subscribed, and their client is entitled to take
    // that error for a lack of support (it's how we read it ourselves, see
    // api.time.get) and stop asking for the rest of the session.
    await shared_api.waitUntil('rosterContactsFetched');

    // 'from' and 'both' are the two states in which they receive our presence.
    const contact = shared_converse.state.roster?.get(bare_jid);
    return ['from', 'both'].includes(contact?.get('subscription'));
}

/**
 * Responds to an incoming XEP-0202 time request.
 *
 * `send_entity_time` is read per request rather than at registration time, so
 * that turning it off stops us disclosing our timezone straight away instead of
 * on the next reconnection. Note that our disco#info features are settled when
 * the session starts, so a mid-session change is only reflected there after
 * reconnecting.
 * @param {Element} iq - The incoming IQ stanza
 */
async function respondToTimeRequest(iq) {
    const from = iq.getAttribute('from');
    const id = iq.getAttribute('id');

    // A request that arrived without a 'from' came from our own server, and
    // the answer goes back the same way. An empty 'to' is not a valid JID
    // (RFC 6120 § 8.1.1.1), so leave the attribute off entirely rather than
    // send one.
    const to = from ? time_utils_Stanza.unsafeXML(`to="${time_utils_Strophe.xmlescape(from)}"`) : '';

    const may_share = await mayShareTimeWith(from);
    // Deciding can mean waiting for the roster, by which time the session may
    // be gone.
    if (!shared_api.connection.connected()) return;

    if (!may_share) {
        shared_api.sendIQ(time_utils_stx`
            <iq type="error" ${to} id="${id}" xmlns="jabber:client">
                <error type="cancel">
                    <service-unavailable xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"/>
                </error>
            </iq>`);
        return;
    }

    // Both values must describe the same instant, so they come from one Date.
    const now = new Date();
    shared_api.sendIQ(time_utils_stx`
        <iq type="result" ${to} id="${id}" xmlns="jabber:client">
            <time xmlns="${time_utils_Strophe.NS.TIME}">
                <tzo>${formatTZO(-now.getTimezoneOffset())}</tzo>
                <utc>${now.toISOString().replace(/\.\d{3}Z$/, 'Z')}</utc>
            </time>
        </iq>`);
}

/**
 * Strophe wants to know synchronously whether the handler stays registered,
 * while deciding whether we may answer can mean waiting for the roster, so the
 * answering happens on its own.
 * @param {Element} iq - The incoming IQ stanza
 * @returns {boolean}
 */
function handleTimeRequest(iq) {
    respondToTimeRequest(iq);
    return true;
}

/**
 * Advertises XEP-0202 support in our own disco#info, which XEP-0202 § 3
 * requires of any entity that answers time queries.
 *
 * Both sharing modes advertise: under 'presence' we do support the protocol,
 * and who gets an answer is a matter of authorization rather than support.
 * Nothing is advertised when sharing is off, since we then answer nobody.
 */
function utils_addClientFeatures() {
    if (shared_api.settings.get('send_entity_time')) {
        shared_api.disco.own.features.add(time_utils_Strophe.NS.TIME);
    }
}

/**
 * Registers the XEP-0202 time handler. Strophe drops its handlers when the
 * connection is re-established, so this runs again on every reconnection.
 */
function registerTimeHandler() {
    return shared_api.connection.get().addHandler(handleTimeRequest, time_utils_Strophe.NS.TIME, 'iq', 'get');
}

/**
 * Formats an offset in minutes as the ±HH:MM string XEP-0202 uses.
 * The inverse of {@link parseTZO}.
 * @param {number} minutes - Offset in minutes (positive = ahead of UTC)
 * @returns {string} Timezone offset string like "+05:30"
 */
function formatTZO(minutes) {
    const sign = minutes < 0 ? '-' : '+';
    const abs = Math.abs(minutes);
    const hours = String(Math.floor(abs / 60)).padStart(2, '0');
    const mins = String(abs % 60).padStart(2, '0');
    return `${sign}${hours}:${mins}`;
}

/**
 * Canonicalises an offset that came off the wire, or rejects it.
 *
 * XEP-0202 § 4 defers to XEP-0082, whose TZD is either "Z" or ±HH:MM, so a peer
 * in UTC may legitimately answer "Z". Anything else we can't read, and taking
 * it anyway would be worse than having no offset at all: {@link parseTZO}
 * answers 0 for what it can't parse, which would put the contact in our own
 * timezone and warn (or fail to warn) on hours that aren't theirs.
 * @param {string} tzo - An offset as received, e.g. "+05:30" or "Z"
 * @returns {string|null} The offset as ±HH:MM, or null if it isn't one
 */
function normalizeTZO(tzo) {
    if (tzo === 'Z') return '+00:00';

    const match = tzo?.match(/^[+-](\d{2}):(\d{2})$/);
    if (!match) return null;

    const hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    // The real range is -12:00 to +14:00, so anything past that is a bug at the
    // other end rather than a timezone.
    return minutes < 60 && hours * 60 + minutes <= 14 * 60 ? tzo : null;
}

/**
 * Parses timezone offset string (±HH:MM) to minutes
 * @param {string} tzo - Timezone offset string like "+05:30" or "-08:00"
 * @returns {number} Offset in minutes
 */
function parseTZO(tzo) {
    const match = tzo.match(/^([+-])(\d{2}):(\d{2})$/);
    if (!match) return 0;
    const sign = match[1] === '+' ? 1 : -1;
    const hours = parseInt(match[2], 10);
    const mins = parseInt(match[3], 10);
    return sign * (hours * 60 + mins);
}

/**
 * Checks if the given hour falls within "off-hours" (e.g., nighttime)
 * @param {number} hour - Hour in 24h format (0-23)
 * @param {number} warning_start - Start hour of warning period (default 22)
 * @param {number} warning_end - End hour of warning period (default 7)
 * @returns {boolean}
 */
function isOffHours(hour, warning_start = 22, warning_end = 7) {
    if (warning_start > warning_end) {
        // Range spans midnight (e.g., 22:00 - 07:00)
        return hour >= warning_start || hour < warning_end;
    } else {
        // Range within same day
        return hour >= warning_start && hour < warning_end;
    }
}

/**
 * Gets the current hour in the remote entity's timezone
 * @param {Date} now - The current time (e.g., new Date())
 * @param {string} tzo - Timezone offset string like "+05:30"
 * @returns {number} Hour in remote timezone (0-23)
 */
function getRemoteHour(now, tzo) {
    const offset_mins = parseTZO(tzo);
    const remote_time = new Date(now.getTime() + offset_mins * 60 * 1000);
    return remote_time.getUTCHours();
}

/**
 * The locale to write times in.
 *
 * `getLocale` is only on the i18n namespace once the full build has installed
 * it, so @converse/headless on its own (in Node, say) falls back to the
 * runtime's idea of the locale. Converse spells its locales with an underscore
 * ("pt_BR"), Intl wants the BCP 47 hyphen.
 * @returns {string|undefined}
 */
function getDisplayLocale() {
    const locale = /** @type {{ getLocale?: () => string }} */ (i18n).getLocale?.();
    return locale ? locale.replace('_', '-') : undefined;
}

/** @type {{ locale: string|undefined, formatter: Intl.DateTimeFormat }|null} */
let time_formatter = null;

/**
 * A formatter for the wall-clock time in some other timezone.
 *
 * Constructing one is expensive relative to using it, and every chat showing a
 * time reformats it once a minute, so the last one is kept.
 * @param {string} [locale]
 * @returns {Intl.DateTimeFormat}
 */
function getTimeFormatter(locale) {
    if (!time_formatter || time_formatter.locale !== locale) {
        // timeStyle rather than hour and minute separately, so that each locale
        // pads the way it pads: "04:00" on a 24-hour clock, "4:00 AM" on a
        // 12-hour one.
        const options = /** @type {Intl.DateTimeFormatOptions} */ ({ timeStyle: 'short', timeZone: 'UTC' });
        let formatter;
        try {
            formatter = new Intl.DateTimeFormat(locale, options);
        } catch (e) {
            // An unusable locale tag isn't worth failing a render over.
            src_log.warn(`Could not format times for locale ${locale}: ${e}`);
            formatter = new Intl.DateTimeFormat(undefined, options);
        }
        time_formatter = { locale, formatter };
    }
    return time_formatter.formatter;
}

/**
 * Formats the current time in a remote timezone the way the user's locale
 * writes times, so that a 12-hour locale gets "11:14 PM" rather than "23:14".
 * @param {Date} now - The current time (e.g., new Date())
 * @param {string} tzo - Timezone offset string like "+05:30"
 * @param {string} [locale] - A BCP 47 tag. Defaults to the UI locale.
 * @returns {string} The remote time, formatted for display
 */
function formatRemoteTime(now, tzo, locale = getDisplayLocale()) {
    const offset_mins = parseTZO(tzo);
    const remote_time = new Date(now.getTime() + offset_mins * 60 * 1000);
    // The shift has already put their wall-clock time into the Date, which is
    // why the formatter is pinned to UTC. Left to itself it would apply our own
    // timezone on top and move the time a second time.
    return getTimeFormatter(locale).format(remote_time);
}

/**
 * Gets the local (browser) timezone offset in minutes
 * @returns {number} Offset in minutes (positive = ahead of UTC)
 */
function getLocalTZOMinutes() {
    // getTimezoneOffset returns minutes behind UTC (negative for ahead)
    // Invert it to match the convention used here (positive = ahead of UTC)
    return -new Date().getTimezoneOffset();
}

/**
 * Calculates the absolute difference between a remote timezone and ours.
 *
 * Minutes rather than hours, because plenty of timezones are offset by a
 * fraction of an hour (+05:30 in India, +05:45 in Nepal, -03:30 in
 * Newfoundland) and rounding those to whole hours loses real differences.
 * @param {string} remote_tzo - Remote timezone offset string like "+05:30"
 * @returns {number} Absolute difference in minutes
 */
function getTimezoneDiffMinutes(remote_tzo) {
    return Math.abs(parseTZO(remote_tzo) - getLocalTZOMinutes());
}

// Export utility functions for use by other plugins
Object.assign(headless_utils, {
    time: {
        formatTZO,
        normalizeTZO,
        parseTZO,
        isOffHours,
        getRemoteHour,
        formatRemoteTime,
        getLocalTZOMinutes,
        getTimezoneDiffMinutes,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/time/entity-time.js
/**
 * Per-chat tracking of a contact's XEP-0202 entity time.
 *
 * This is the half of the feature that has nothing to do with drawing: which
 * full JID to ask, when to ask it, and what the answer means. It holds no DOM
 * and starts no repaint timers, so a TUI or any other non-browser consumer gets
 * the same behaviour a browser does by calling `api.time.contact.get`.
 *
 * @copyright 2026, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */






// Presence can flap, and each change is a reason to re-ask. Collapse a burst
// of them into one query.
const FETCH_DEBOUNCE = 300;

// How long an answer is trusted before reading it asks for it again. Every
// other trigger is an event (the chat opening, their presence changing, a
// message arriving), and a chat can sit open through all of them and through
// the contact's DST transition, warning at hours that stopped being theirs.
const TZO_TTL = 60 * 60 * 1000;

// What we last heard, per contact. Deliberately not an attribute on any model:
// every model we could hang it on is persisted, and `save()` writes every
// attribute a model holds, so it would reach storage the next time anything
// else saved (the composer saves a draft as you type) and be rehydrated on a
// later page load. That matters less for its age than for what we could not
// then do about it: a contact who is offline can't be re-asked, so a stored
// answer from a previous session would be shown with no way to correct it.
// Nothing is shown instead, and we ask again when we can. The chat is kept
// alongside the offset because it, not the contact, is what a re-query is sent
// on behalf of.
/** @type {WeakMap<any, {tzo: string, chatbox: any}>} */
const tzo_by_contact = new WeakMap();

// Per-chat bookkeeping for the querying itself, which is tied to the chat being
// open rather than to the contact.
/**
 * @type {WeakMap<any, {
 *   timeout: ReturnType<typeof setTimeout>|null,
 *   loading: boolean,
 *   pending: boolean,
 *   last_attempt: number,
 * }>}
 */
const fetch_state = new WeakMap();

/**
 * @param {any} chatbox
 */
function getFetchState(chatbox) {
    let state = fetch_state.get(chatbox);
    if (!state) {
        state = { timeout: null, loading: false, pending: false, last_attempt: 0 };
        fetch_state.set(chatbox, state);
    }
    return state;
}

/**
 * Resolves the full JID to query for a given chat.
 *
 * Their highest-priority resource is the best answer. Failing that (they're
 * offline, or we have no presence subscription), the most recent message they
 * sent us carries a full JID, which is stale but better than asking their
 * server a question only their client can answer.
 * @param {any} chatbox
 * @returns {string|null}
 */
function getFullJIDForChat(chatbox) {
    const full_jid = getFullJID(chatbox.get('jid'));
    if (full_jid) return full_jid;

    const messages = chatbox.messages;
    if (messages?.length) {
        for (let i = messages.length - 1; i >= 0; i--) {
            const msg = messages.at(i);
            const from = msg.get('from');
            if (from?.includes('/') && msg.get('sender') === 'them') {
                return from;
            }
        }
    }
    return null;
}

/**
 * Queries the contact and records their offset against the contact.
 * @param {any} chatbox
 */
async function doFetch(chatbox) {
    // Not only the paths that go through `change:closed`: a message arriving in
    // a chat the user has shut, or that contact's presence flapping, is no
    // reason to tell them we're here.
    if (chatbox.get('closed') || !shared_api.settings.get('show_entity_time')) return;

    const state = getFetchState(chatbox);
    if (state.loading) {
        // Whatever prompted this happened after the answer in flight was asked
        // for, so it's a reason to ask again rather than to drop the question.
        state.pending = true;
        return;
    }

    // Before the early return below, so that a contact we can't currently
    // address doesn't have every read of their (stale) offset schedule another
    // attempt.
    state.last_attempt = Date.now();

    const full_jid = getFullJIDForChat(chatbox);
    if (!full_jid) return;

    state.loading = true;
    try {
        const result = await shared_api.time.get(full_jid);
        const contact = chatbox.contact;
        if (result && contact) {
            tzo_by_contact.set(contact, { tzo: result.tzo, chatbox });
            // No attribute to fire a `change:` event, so say so ourselves.
            contact.trigger('entity_time:change');
        }
    } catch (e) {
        src_log.error(`Error fetching entity time for ${full_jid}: ${e}`);
    } finally {
        state.loading = false;
        if (state.pending) {
            state.pending = false;
            fetchEntityTime(chatbox);
        }
    }
}

/**
 * Schedules a (debounced) entity time query for this chat.
 * @param {any} chatbox
 */
function fetchEntityTime(chatbox) {
    const state = getFetchState(chatbox);
    if (state.timeout) clearTimeout(state.timeout);
    state.timeout = setTimeout(() => {
        state.timeout = null;
        doFetch(chatbox);
    }, FETCH_DEBOUNCE);
}

/**
 * Asks again for an offset we've been holding for a while.
 *
 * Reading it is the moment to check: an offset nobody is looking at doesn't
 * need to be right, and this way only the contacts on screen are asked again.
 * @param {any} chatbox
 */
function maybeRefresh(chatbox) {
    if (!chatbox) return;

    const state = getFetchState(chatbox);
    if (state.loading || state.timeout) return;
    if (Date.now() - state.last_attempt < TZO_TTL) return;

    fetchEntityTime(chatbox);
}

/**
 * @param {any} chatbox
 */
function listenToPresence(chatbox) {
    const presence = chatbox.contact?.presence;
    if (!presence) return;

    // They may have switched device, and so timezone.
    chatbox.listenTo(presence, 'change', () => fetchEntityTime(chatbox));
    if (presence.resources) {
        chatbox.listenTo(presence.resources, 'add change', () => fetchEntityTime(chatbox));
    }
}

/**
 * Starts tracking entity time for a private chat.
 *
 * Queries are deliberately tied to the chat being open. Asking on behalf of
 * every chat restored from storage at login would put a burst of queries on the
 * wire and tell a pile of contacts we're back, for chats the user isn't looking
 * at.
 * @param {any} chatbox
 */
function onChatBoxInitialized(chatbox) {
    // A chat with ourselves resolves to one of our own resources, so this would
    // be us asking us what time it is.
    if (chatbox.get('jid') === shared_converse.session?.get('bare_jid')) return;

    // Every time the chat is opened, not only the first: an offset we already
    // have is the one thing that stops us noticing that they have travelled or
    // crossed a DST boundary. The debounce and the in-flight guard in doFetch
    // keep that to one query.
    chatbox.listenTo(chatbox, 'change:closed', () => fetchEntityTime(chatbox));

    // A message from them is the other way we learn a full JID.
    if (chatbox.messages) {
        chatbox.listenTo(chatbox.messages, 'add', (/** @type {any} */ msg) => {
            if (!tzo_by_contact.has(chatbox.contact) && msg.get('sender') === 'them') fetchEntityTime(chatbox);
        });
    }

    chatbox.rosterContactAdded?.then(() => {
        listenToPresence(chatbox);
        fetchEntityTime(chatbox);
    });

    fetchEntityTime(chatbox);
}

/**
 * What we know about the contact's local time, right now.
 * @param {any} contact - A roster contact
 * @returns {import('./types').ContactTime|null}
 */
function getContactTime(contact) {
    if (!shared_api.settings.get('show_entity_time')) return null;

    const known = contact ? tzo_by_contact.get(contact) : null;
    if (!known) return null;

    // Reading an offset is also when it gets checked for age.
    maybeRefresh(known.chatbox);
    const { tzo } = known;

    // Our own clock is the authority on the current instant; the contact only
    // told us how far from UTC they are. XEP-0202 § 5 warns that a peer's idea
    // of UTC is exactly what you shouldn't trust.
    const now = new Date();
    const hour = getRemoteHour(now, tzo);
    const differs_by_minutes = getTimezoneDiffMinutes(tzo);
    const off_hours = isOffHours(
        hour,
        shared_api.settings.get('entity_time_warning_start'),
        shared_api.settings.get('entity_time_warning_end'),
    );

    // A contact in our own timezone tells us nothing our own clock doesn't, so
    // that never warrants a warning. Above that, the user's threshold decides.
    const min_diff_minutes = shared_api.settings.get('entity_time_min_diff_hours') * 60;
    const differs_enough = differs_by_minutes !== 0 && differs_by_minutes >= min_diff_minutes;

    return {
        tzo,
        time: formatRemoteTime(now, tzo),
        hour,
        differs_by_minutes,
        differs_enough,
        is_off_hours: off_hours,
        should_warn: differs_enough && off_hours,
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/time/api.js






const { Strophe: time_api_Strophe, stx: time_api_stx, u: time_api_u } = api_public.env;

/* export default */ const time_api = ({
    /**
     * The "time" namespace groups methods for XEP-0202 Entity Time
     * @namespace api.time
     * @memberOf api
     */
    time: {
        /**
         * Gets the entity time from a JID per XEP-0202
         * @method api.time.get
         * @param {string} jid - The JID to query for time
         * @param {number} [timeout=10000] - Timeout in milliseconds
         * @returns {Promise<import('./types').EntityTime|null>} The entity's
         *  time info, or `null` if the entity didn't respond or doesn't
         *  support XEP-0202.
         */
        async get(jid, timeout = 10000) {
            if (!shared_api.connection.authenticated()) {
                src_log.debug('Not querying time when not authenticated');
                return null;
            }

            const iq = time_api_stx`
                <iq type="get" to="${jid}" id="${time_api_u.getUniqueId('time')}" xmlns="jabber:client">
                    <time xmlns="${time_api_Strophe.NS.TIME}"/>
                </iq>`;

            const result = await shared_api.sendIQ(iq, timeout, false);

            if (result === null) {
                src_log.warn(`Timeout while getting time from ${jid}`);
                return null;
            } else if (time_api_u.isErrorStanza(result)) {
                src_log.debug(`Error getting time from ${jid} (entity may not support XEP-0202)`);
                return null;
            }

            const time_el = result.querySelector(':scope > time');
            const utc_str = time_el?.querySelector(':scope > utc')?.textContent;
            const tzo_str = time_el?.querySelector(':scope > tzo')?.textContent;

            if (!utc_str || !tzo_str) {
                src_log.error(`Invalid time response from ${jid} - missing utc or tzo`);
                return null;
            }

            const utc = new Date(utc_str);
            if (isNaN(utc.getTime())) {
                src_log.error(`Invalid time response from ${jid} - unparseable utc: ${utc_str}`);
                return null;
            }

            const tzo = normalizeTZO(tzo_str);
            if (!tzo) {
                src_log.error(`Invalid time response from ${jid} - unparseable tzo: ${tzo_str}`);
                return null;
            }

            return { utc, tzo };
        },

        /**
         * @namespace api.time.contact
         * @memberOf api.time
         */
        contact: {
            /**
             * What we currently know about a contact's local time. Everything a
             * UI needs in order to decide whether, and what, to show. Returns
             * `null` while their offset is still unknown.
             *
             * Reads what the last query recorded, rather than waiting for one,
             * so unlike {@link api.time.get} it answers immediately. An answer
             * old enough to have gone stale (they may have travelled, or
             * crossed a DST boundary) does start a query in the background, to
             * be reported by the contact's `entity_time:change` event. The
             * result describes this instant, so call it again whenever you
             * redraw rather than holding on to it.
             * @method api.time.contact.get
             * @param {any} contact - A roster contact
             * @returns {import('./types').ContactTime|null}
             * @example
             * const t = api.time.contact.get(chat.contact);
             * if (t?.should_warn) console.log(`It's ${t.time} for them`);
             */
            get: getContactTime,
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/time/index.js
/**
 * @description
 * Converse.js plugin which adds support for XEP-0202 Entity Time.
 * @see https://xmpp.org/extensions/xep-0202.html
 * @copyright 2026, the Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */






api_public.plugins.add('converse-time', {
    dependencies: ['converse-disco'],

    initialize() {
        shared_api.settings.extend({
            // Who we answer time requests from: 'public' for anyone,
            // 'presence' for entities subscribed to our presence, and anything
            // falsy for nobody.
            'send_entity_time': 'presence',
            'show_entity_time': true,
            'entity_time_warning_start': 22,
            'entity_time_warning_end': 7,
            'entity_time_min_diff_hours': 0, // Minimum timezone difference to show warning (0 = any different timezone)
        });

        Object.assign(shared_api, time_api);

        shared_api.listen.on('addClientFeatures', utils_addClientFeatures);
        shared_api.listen.on('connected', registerTimeHandler);
        shared_api.listen.on('reconnected', registerTimeHandler);
        shared_api.listen.on('chatBoxInitialized', onChatBoxInitialized);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/constants.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */

/**
 * The PEP node on which a user's own microblog (XEP-0277) entries are published.
 */
const MICROBLOG_NODE = 'urn:xmpp:microblog:0';

/**
 * Prefix of the per-post comments node. The full node name is
 * `urn:xmpp:microblog:0:comments/<post-id>` (XEP-0277 § Comments).
 */
const COMMENTS_NODE_PREFIX = 'urn:xmpp:microblog:0:comments/';

/**
 * Node configuration for a post's comments node (XEP-0277 § Comments node
 * configuration), sent as XEP-0060 publish-options / node config. `access_model`
 * and `publish_model` are `open` so *anyone* can read and add a comment.
 * The author pre-creates the node when publishing the post, since a foreign
 * commenter can't create nodes on the author's PEP service.
 */
const COMMENTS_PUBLISH_OPTIONS = {
    access_model: 'open',
    publish_model: 'open',
    persist_items: 'true',
    max_items: 'max',
    send_last_published_item: 'never',
    notify_retract: 'true',
    deliver_payloads: 'true',
    // This node is `publish_model` open, so *anyone*
    // can add an item to it, and without the server-stamped `publisher` the only
    // authorship on a comment is the `<author>` the commenter wrote themselves.
    // See {@link MICROBLOG_PUBLISH_OPTIONS}.
    itemreply: 'publisher',
};

/**
 * Disco feature advertised by clients that understand the modern PubSub Social
 * Feed (XEP-0472).
 */
const SOCIAL_FEED_FEATURE = 'urn:xmpp:pubsub-social-feed:1';

/**
 * The `pubsub#type` (and disco feature) of the XEP-0472 **gallery** profile: a
 * social-feed node whose every item carries at least one image `enclosure`. We
 * consume such nodes (rendering them as an image grid), but don't host them.
 */
const GALLERY_TYPE = 'urn:xmpp:pubsub-social-feed:gallery:1';

/**
 * A profile banner is not part of XEP-0277/0472. Movim publishes one to this PEP
 * node using the XEP-0084 User Avatar *metadata* format, but *by reference*:
 * an `<info url="…"/>` element (namespace {@link NS_AVATAR_METADATA}) pointing
 * at an HTTP-hosted image.
 */
const MOVIM_BANNER_NODE = 'urn:xmpp:movim-banner:0';
const NS_AVATAR_METADATA = 'urn:xmpp:avatar:metadata';

/**
 * Per-request IQ timeout (ms) for the best-effort banner fetch. Short (vs. the
 * 60s default) so a slow or unresponsive PEP service never leaves a banner IQ
 * hanging; the header just renders without a banner meanwhile.
 */
const BANNER_FETCH_TIMEOUT = 10000;

/**
 * How many posts to fetch per page when backfilling a feed's history
 * (XEP-0060 § 6.5 Retrieve Items, `max_items` / RSM `max`).
 */
const POSTS_PAGE_SIZE = 20;

/**
 * Ceiling for feeds on servers *without* RSM support. Without RSM we can't page
 * efficiently — native `max_items` only ever returns the newest N, so paging
 * backwards would re-fetch the whole set each time — so we load up to this many of
 * the newest posts in one query and don't offer "load older". A deliberate cap to
 * avoid an unbounded fetch on a busy feed.
 */
const POSTS_MAX_WITHOUT_RSM = 200;

/**
 * How many contacts the manual "find people to follow" sweep probes at once. The
 * sweep is network-bound (waiting on IQ replies), so a modest pool keeps it quick
 * without flooding the connection.
 */
const FOLLOWABLE_SCAN_CONCURRENCY = 10;

/**
 * Per-probe IQ timeout (ms) for the sweep. Much shorter than the default 60s
 * `stanza_timeout`, so a contact whose server never replies fails fast and frees
 * a worker instead of stalling the whole sweep.
 */
const FOLLOWABLE_PROBE_TIMEOUT = 10000;

/**
 * How many nodes to request per RSM page when listing a service's nodes
 * (`api.microblog.browseFeeds`).
 */
const BROWSE_PAGE_SIZE = 100;

/**
 * Node configuration for our own social feed node, sent as XEP-0060
 * publish-options. This is the XEP-0472 "Base profile" config, plus an open
 * access model.
 */
const MICROBLOG_PUBLISH_OPTIONS = {
    access_model: 'open',
    persist_items: 'true',
    max_items: 'max',
    send_last_published_item: 'never',
    notify_retract: 'true',
    // `deliver_payloads` is a deliberate deviation: XEP-0472 § Base profile says it
    // SHOULD be `false` (subscribers get bare `<item id/>` headers and fetch the
    // content on demand). That requirement seems tailored towards a caching
    // server-side client like Movim.
    deliver_payloads: 'true',

    // `itemreply` is `publisher` to keep the server's `publisher` attribute on our
    // items. The field is named for who receives replies, but XEP-0060 § 13.17
    // ("Associating Events and Payloads with the Generating Entity") notes that "the
    // primary use of the 'pubsub#itemreply' option is to allow node owners to
    // determine whether the server will include a 'publisher' attribute in items or
    // not", and Prosody implements exactly that. Without it the attribute is stripped
    // from retrieval responses, leaving `is_mine` to trust the entry's self-asserted
    // `<author>`.
    itemreply: 'publisher',
};

/**
 * XEP-0330 (Pubsub Subscription): the PEP node holding the user's portable
 * follow-list (the durable source of truth for who they follow), and the
 * namespace of each list item's `<subscription>` payload.
 */
const FOLLOWING_NODE = 'urn:xmpp:pubsub:subscription';
const NS_SUBSCRIPTION = 'urn:xmpp:pubsub:subscription:0';

/**
 * Node configuration for the follow-list, sent as XEP-0060 publish-options.
 * Matches Movim's `generateConfig` so the same node interoperates: persistent,
 * presence-readable (contacts can discover who you follow), unbounded, and
 * notifying on retraction.
 */
const FOLLOWING_PUBLISH_OPTIONS = {
    persist_items: 'true',
    access_model: 'presence',
    send_last_published_item: 'never',
    max_items: 'max',
    notify_retract: 'true',
};

// Atom (RFC 4287) and the syndication threading extension (RFC 4685) namespaces.
// Declared as plain constants (rather than read off `Strophe.NS`) so the parser
// is independent of plugin-initialization order.
const NS_ATOM = 'http://www.w3.org/2005/Atom';
const NS_THREAD = 'http://purl.org/syndication/thread/1.0';
const NS_XHTML = 'http://www.w3.org/1999/xhtml';

/**
 * The Skeletor model `type` used by microblog posts, distinguishing them from
 * chat/groupchat/headline messages.
 */
const MICROBLOG_TYPE = 'microblog';

/**
 * The text marker of a "like": a comment whose entry text is exactly this heart
 * (U+2665). Likes ride the per-post comments node as ♥-comments (XEP-0277
 * convention), so a single fetch of the node yields both comments and likes.
 */
const LIKE_MARKER = '♥';

/**
 * How many per-post comment-summary fetches run concurrently (the greedy
 * on-visible fetch). Bounded so scrolling a long timeline doesn't flood the
 * connection; smaller than the followable sweep since these fire continuously as
 * posts scroll into view rather than as a one-shot burst.
 */
const COMMENT_SUMMARY_CONCURRENCY = 4;

/**
 * Max rounds {@link CommentFeed.resolveOrphans} walks up the ancestor chain,
 * fetching missing parents by id on a non-RSM node. Each round resolves one more
 * generation, so this bounds how deep an out-of-window reply chain is reconnected
 * (and backstops a pathological pointer cycle). Deeper ancestors than this stay
 * orphaned until a later fetch reaches them.
 */
const ORPHAN_RESOLVE_ROUNDS = 5;

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/message.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */






/**
 * Represents a single microblog post (a parsed Atom entry).
 * Extends {@link BaseMessage} to inherit vCard/contact/colour awareness.
 * @extends {BaseMessage}
 */
class PubSubMessage extends shared_message {
    defaults() {
        return Object.assign(super.defaults(), {
            type: MICROBLOG_TYPE,
        });
    }

    initialize() {
        super.initialize();
        this.setContact();
        this.setReposter();
        this.setAuthorName();
    }

    /**
     * Resolve the post's author to an *existing* roster contact (or our own
     * profile for own posts) and expose it as `this.contact`. Unlike chat
     * messages we pass `create: false` since a social feed may have many authors
     * who aren't contacts, and we don't want to inject them into the roster.
     * The author avatar is rendered from the vCard cache regardless
     * (see {@link getVCardJID}).
     * @returns {Promise<void>}
     */
    async setContact() {
        const jid = this.getAuthorJID();
        if (jid) await this.setModelContact(Strophe.getBareJidFromJid(jid), { create: false });
    }

    /**
     * The bare JID whose vCard represents this post's author. Consulted by
     * {@link getVCardForModel} so a post resolves its avatar from the vCard cache
     * (never the roster) — authors who aren't contacts still show an avatar.
     * @returns {string|undefined}
     */
    getVCardJID() {
        const jid = this.getAuthorJID();
        return jid ? Strophe.getBareJidFromJid(jid) : undefined;
    }

    /**
     * The bare JID of the account that *reposted* this post into the feed (the
     * server-stamped publisher). This is distinct from {@link getAuthorJID},
     * which — for a repost — names the *original* author. Returns undefined when
     * the post isn't a repost.
     * @returns {string|undefined}
     */
    getReposterJID() {
        if (!this.get('is_repost')) return undefined;

        const jid = this.get('publisher') || this.get('from');
        return jid ? Strophe.getBareJidFromJid(jid) : undefined;
    }

    /**
     * The reposter's cached vCard (or null), resolved lazily by
     * {@link setReposter}. Used only to put a name on the "… reposted" line.
     * @returns {import('../vcard/vcard').default|null}
     */
    get reposterVCard() {
        return this._reposter_vcard ?? null;
    }

    /**
     * Resolve the reposter's vCard from the cache
     * No-op for non-reposts and for our own reposts (which are labeled "you").
     * @returns {Promise<void>}
     */
    async setReposter() {
        if (this.get('is_mine')) return;

        const jid = this.getReposterJID();
        if (!jid) return;

        await shared_api.waitUntil('VCardsInitialized');
        const { vcards } = shared_converse.state;
        const vcard = vcards.get(jid) || vcards.create({ jid }, { lazy_load: true });
        this._reposter_vcard = vcard;
        vcard?.on('change', () => this.trigger('vcard:change'));
        this.trigger('vcard:change');
    }

    /**
     * The reposter's display name from their vCard, falling back to their bare
     * JID. Only meaningful for a repost that isn't our own.
     * @returns {string|undefined}
     */
    getReposterName() {
        const jid = this.getReposterJID();
        if (!jid) return undefined;

        return this._reposter_vcard?.getDisplayName() || jid;
    }

    /**
     * Give the author a human name even when the post carries no Atom `<author><name>`.
     * @returns {Promise<void>}
     */
    async setAuthorName() {
        const vcard = await this.getVCard();
        if (!vcard) return;

        const sync = () => {
            const name = this.contact?.get('nickname') || vcard.get('nickname') || vcard.get('fullname');
            if (name) this.set('nickname', name);
        };
        sync();
        this.listenTo(vcard, 'change', sync);
        this.on('contact:add', sync);
        this.on('contact:change', sync);
    }

    /**
     * Persist each post to the collection's store as an offline cache. The
     * PubSub node stays the source of truth; this just avoids an empty feed on
     * reload before the server responds.
     */
    get autoSync() {
        return true;
    }

    /**
     * Derived display values, recomputed automatically when their deps change.
     * @returns {import('@converse/skeletor').ComputedProperties<this>}
     */
    get computed() {
        return {
            displayName: {
                deps: ['author_name', 'nickname', 'author_jid', 'publisher', 'from'],
                // Prefer the post's self-declared author name, then the resolved
                // contact/vCard nickname, and only fall back to the bare JID when
                // no human name is known.
                fn: (m) => {
                    const name = m.get('author_name') || m.get('nickname');
                    if (name) return name;

                    const jid = m.get('author_jid') || m.get('publisher') || m.get('from');
                    return jid ? Strophe.getBareJidFromJid(jid) : '';
                },
            },
            // Whether the logged-in user published this post (replaces the legacy
            // `sender: 'me'|'them'` flag). Authorship is the publisher's, not the
            // atom:author's, which for a repost is the *original* author.
            is_mine: {
                deps: ['publisher', 'from', 'author_jid', 'is_repost'],
                fn: (m) => {
                    // Authorship is the server-stamped `publisher` when present.
                    // Otherwise: for a repost it's the reposter (the node owner,
                    // `from`); for anything else (incl. comments, which always
                    // carry an <author>) it's the claimed author, falling back
                    // to the node owner for own posts with no <author>.
                    const jid =
                        m.get('publisher') ||
                        (m.get('is_repost') ? m.get('from') : m.get('author_jid') || m.get('from'));
                    const bare_jid = shared_converse.session?.get('bare_jid');
                    return !!jid && !!bare_jid && Strophe.getBareJidFromJid(jid) === bare_jid;
                },
            },
        };
    }

    /**
     * @returns {string}
     */
    getDisplayName() {
        return this.get('displayName');
    }

    /**
     * The author whose feed/JID this post is attributed to (the original author
     * for a repost, otherwise the publisher). The entry's own `<author>` wins
     * over the via link: the via href is a *location* — for a post reposted off
     * a community node that's the node's service JID, not a person.
     * @returns {string|undefined}
     */
    getAuthorJID() {
        return this.get('author_jid') || this.get('via_jid') || this.get('publisher') || this.get('from');
    }

    /**
     * The community/topic feed this post arrived through, when that feed is a
     * thing distinct from its author. Null for an ordinary personal-microblog
     * post and for comment items.
     *
     * `title` is the human label we follow the feed by (from the XEP-0330 list),
     * falling back to the raw node id for a feed we're only browsing.
     * @returns {{ jid: string, node: string, title: string }|null}
     */
    getSourceFeed() {
        const jid = this.get('from');
        const node = this.get('node');

        if (!jid || !node) return null;
        if (node === MICROBLOG_NODE || node.startsWith(COMMENTS_NODE_PREFIX)) return null;

        const bare = Strophe.getBareJidFromJid(jid);
        const title = shared_converse.state.following?.get(`${bare}/${node}`)?.get('title') || node;
        return { jid: bare, node, title };
    }

    /**
     * Colour the post by its *displayed* author, so every post from the same
     * author shares a colour and the name colour matches the avatar. Overrides
     * {@link ColorAwareModel}'s default, which would key on `from` — the
     * *reposter* for a repost, not the original author shown in the header.
     * @returns {string}
     */
    getIdentifier() {
        return this.getAuthorJID() || super.getIdentifier();
    }

    /**
     * The PubSub node holding this post's comments. Uses the node advertised
     * by the post's `rel="replies"` link, else derives the conventional per-post
     * node `urn:xmpp:microblog:0:comments/<post-id>`.
     * @returns {string}
     */
    getCommentsNode() {
        return this.get('comments_node') || COMMENTS_NODE_PREFIX + this.get('id');
    }

    /**
     * The JID of the PubSub service hosting this post's comments node. The
     * comments link MAY point at a dedicated pubsub component; absent that, the
     * node lives on the post author's PEP service (their bare JID).
     * @returns {string|undefined}
     */
    getCommentsService() {
        if (this.get('comments_jid')) return this.get('comments_jid');
        const jid = this.getAuthorJID();
        return jid ? Strophe.getBareJidFromJid(jid) : undefined;
    }

    /**
     * XEP-0277 § Comment Author security check: the (spoofable) `<author><uri>`
     * should match the server-stamped `publisher`. Returns true only when both
     * are known *and* disagree — a genuine impersonation signal for the UI.
     *
     * The XEP suggests also flagging when `publisher` is absent, but many
     * servers (e.g. Prosody) simply omit it from retrieve-items responses, so
     * flagging every backfilled comment would cry wolf. We treat "can't verify"
     * as unflagged rather than suspicious.
     * @returns {boolean}
     */
    getAuthorMismatch() {
        const publisher = this.get('publisher');
        const author_jid = this.get('author_jid');
        if (!author_jid || !publisher) return false; // Nothing to verify against.
        return Strophe.getBareJidFromJid(author_jid) !== Strophe.getBareJidFromJid(publisher);
    }
}

/* export default */ const microblog_message = (PubSubMessage);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/messages.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */




/**
 * A collection of {@link PubSubMessage} posts belonging to one feed (or, when
 * nested under a post, that post's comments).
 *
 * `autoSync` is hydrate-only at the collection level: the collection loads its
 * cached members from storage on construction, while each {@link PubSubMessage}
 * persists itself. Storage is supplied via the `id` construction option so it is
 * available before the constructor's hydration step runs.
 *
 * @extends {Collection<PubSubMessage>}
 */
class PubSubMessages extends Collection {
    get model() {
        return microblog_message;
    }

    get autoSync() {
        return true;
    }

    /**
     * @param {PubSubMessage[]} [_models]
     * @param {object} [options]
     * @param {string} [options.id] - Cache key for the backing store.
     */
    initialize(_models, options = {}) {
        // Show the newest posts first.
        this.comparator =
            /**
             * @param {PubSubMessage} a
             * @param {PubSubMessage} b
             */
            (a, b) => (b.get('time') || '').localeCompare(a.get('time') || '');

        if (options.id) {
            this.storage = createStore(options.id);
        }
    }
}

/* export default */ const microblog_messages = (PubSubMessages);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/parsers.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 *
 * Parse XEP-0277 (Microblogging over XMPP) Atom payloads. Stanza *construction*
 * lives on the feed model ({@link PubSubFeed.createPostStanza} /
 * `createRepostStanza`), following the codebase convention of building stanzas
 * on the model that owns the resulting objects.
 */







/**
 * Resolve the `<atom:entry>` for a PubSub item (or accept a bare entry).
 * @param {Element} item
 * @returns {Element|undefined}
 */
function getEntry(item) {
    if (item.localName === 'entry' && item.namespaceURI === NS_ATOM) return item;
    return sizzle(`> entry[xmlns="${NS_ATOM}"]`, item).pop();
}

/**
 * Classify an Atom text construct's `type` into how we render it. RFC 4287 §3.1
 * defines the shorthands `text`/`html`/`xhtml` for text constructs, but
 * `atom:content` (§4.1.3) may instead carry a MIME type: bridges like
 * atomtopubsub (WordPress → XMPP, seen here via Movim) stamp `type="text/html"`
 * for entity-escaped HTML, so treat that as `html`. An absent or unrecognised
 * type is plain text.
 * @param {Element} el
 * @returns {'text'|'html'|'xhtml'}
 */
function textConstructKind(el) {
    const type = (el.getAttribute('type') || '').toLowerCase();
    if (type === 'xhtml') return 'xhtml';
    if (type === 'html' || type === 'text/html') return 'html';
    return 'text';
}

/**
 * Parse an Atom "Text construct" (`<title>`, `<summary>` or `<content>`): plain
 * text, a wrapping XHTML `<div>` (`xhtml`), or an entity-escaped HTML fragment
 * (`html` / `text/html`, common in blog/Atom feeds). For the two markup forms we
 * return the HTML in `xhtml` (the caller renders it sanitized) plus a plain-text
 * form in `text` for previews.
 * @param {Element|undefined} el
 * @returns {{ text?: string, xhtml?: string }}
 */
function parseTextConstruct(el) {
    if (!el) return {};
    const kind = textConstructKind(el);
    if (kind === 'xhtml') {
        const div = sizzle('> div', el).pop();
        return {
            text: el.textContent?.trim() || undefined,
            xhtml: (div ? div.innerHTML : el.innerHTML) || undefined,
        };
    }
    if (kind === 'html') {
        // The XML parser has already unescaped the fragment, so textContent is the
        // HTML markup itself. Keep it for rich rendering; derive plain text for
        // previews (decodeHTMLEntities strips the tags).
        const markup = el.textContent?.trim() || undefined;
        return { text: markup ? decodeHTMLEntities(markup) : undefined, xhtml: markup };
    }
    return { text: el.textContent?.trim() || undefined };
}

/**
 * Select the best rendition of an Atom text construct from every sibling of the
 * same name.
 *
 * Movim publishes the same construct twice: a rich `<content type="xhtml">`
 * alongside a `<content type="text">` Markdown source.
 * @param {Element[]} els
 * @returns {{ text?: string, xhtml?: string }}
 */
function pickTextConstruct(els) {
    if (!els.length) return {};

    const isRich = (el) => textConstructKind(el) !== 'text';
    const rich = parseTextConstruct(els.find(isRich));
    const plain = parseTextConstruct(els.find((el) => !isRich(el)));
    return { xhtml: rich.xhtml, text: plain.text ?? rich.text };
}

const NS_GEOLOC = 'http://jabber.org/protocol/geoloc';

/**
 * Parse an XEP-0080 `<geoloc>` child of an Atom entry (XEP-0277 § Geotagging)
 * into a compact `{ lat, lon, label }` for rendering a location line, or
 * `undefined` when there's no geoloc or nothing worth showing. `label` prefers
 * the free-form `<text>`, else a "locality, region, country" join. Coordinates
 * are only returned when both parse as finite numbers (a map link needs both).
 * @param {Element} entry
 * @returns {{geoloc: { lat?: number, lon?: number, label?: string }} | undefined}
 */
function parseGeoloc(entry) {
    const geo = sizzle('> geoloc', entry).find((g) => g.namespaceURI === NS_GEOLOC);
    if (!geo) return undefined;

    const field = /** @param {string} name */ (name) =>
        sizzle(`> ${name}`, geo).pop()?.textContent?.trim() || undefined;
    const lat = Number(field('lat'));
    const lon = Number(field('lon'));
    const has_coords =
        field('lat') !== undefined && field('lon') !== undefined && Number.isFinite(lat) && Number.isFinite(lon);
    const label =
        field('text') || [field('locality'), field('region'), field('country')].filter(Boolean).join(', ') || undefined;

    if (!has_coords && !label) return undefined;

    return { geoloc: { ...(has_coords ? { lat, lon } : {}), ...(label ? { label } : {}) } };
}

/**
 * RFC 4685 threading (XEP-0277 § Replying to a Post). A comment/reply carries
 * one or more `<thr:in-reply-to>` pointing at the item it replies to. An entry
 * MAY carry several (e.g. an http and an xmpp form of the same target), so take
 * the first whose xmpp href yields an item id, keeping any `ref` (the parent's
 * atom:id) as a fallback resolver.
 * @param {Element} entry
 */
function parseThreading(entry) {
    let in_reply_to;
    let in_reply_to_ref;
    let in_reply_to_jid;
    let in_reply_to_node;

    const in_reply_tos = sizzle('> *', entry).filter(
        (el) => el.localName === 'in-reply-to' && el.namespaceURI === NS_THREAD,
    );

    for (const el of in_reply_tos) {
        const href = el.getAttribute('href') || undefined;
        const ref = el.getAttribute('ref') || undefined;
        // Keep the first `ref` seen as a fallback (resolves by atom:id when no href item id available)
        if (ref && !in_reply_to_ref) in_reply_to_ref = ref;

        const item = href?.startsWith('xmpp:') ? getItemFromURI(href) : undefined;
        if (item) {
            in_reply_to = item;
            in_reply_to_jid = getJIDFromURI(href);
            in_reply_to_node = getNodeFromURI(href);
            if (ref) in_reply_to_ref = ref;
            break;
        }
    }
    return {
        in_reply_to,
        in_reply_to_ref,
        in_reply_to_jid,
        in_reply_to_node,
    };
}

/**
 * Links carry repost provenance (`rel="via"`), the comments node
 * (`rel="replies"`), media attachments (`rel="enclosure"`), and the entry's
 * canonical web URL (`rel="alternate"`) are all unprefixed Atom elements. The
 * via href/ref are kept verbatim so reposting a repost can propagate them (the
 * via link must keep pointing at the *original* post, per XEP-0277).
 * @param {Element} entry
 * @param {string} author_jid
 * @param {string} publisher
 */
function parseLinks(entry, author_jid, publisher) {
    let via_jid;
    let via_href;
    let via_ref;
    let comments_jid;
    let comments_node;
    let alternate_url;
    const enclosures = [];

    for (const link of sizzle('> link', entry)) {
        const rel = link.getAttribute('rel');
        if (rel === 'via') {
            via_href = link.getAttribute('href') || undefined;
            via_ref = link.getAttribute('ref') || undefined;
            via_jid = via_href ? getJIDFromURI(via_href) : undefined;
        } else if (rel === 'replies' && link.getAttribute('title') === 'comments') {
            // The comments node may live on the author's PEP service or on a
            // dedicated pubsub component, so keep the href's service JID too.
            const href = link.getAttribute('href');
            comments_jid = href ? getJIDFromURI(href) : undefined;
            comments_node = getNodeFromURI(href);
        } else if (rel === 'enclosure') {
            // RFC 4287 media attachment
            const href = link.getAttribute('href');
            if (href) {
                enclosures.push({
                    href,
                    type: link.getAttribute('type') || undefined,
                    title: link.getAttribute('title') || undefined,
                });
            }
        } else if (!rel || rel === 'alternate') {
            // The entry's canonical URL (RFC 4287 §4.2.7.2: a missing rel means
            // "alternate"). Blog/news bridges (WordPress via atomtopubsub) put the
            // article permalink here while the body is only a teaser, so keep the
            // first one to render as a "read more" link. Ignore non-web schemes
            // (e.g. an xmpp: self-reference).
            const href = link.getAttribute('href');
            if (href && !alternate_url && href.startsWith('http')) alternate_url = href;
        }
    }

    return {
        via_jid,
        via_href,
        via_ref,
        comments_jid,
        comments_node,
        alternate_url,
        ...(enclosures.length ? { enclosures } : {}),
        // An author JID that differs from the publisher marks a repeated post
        // (XEP-0277 § Repeating a Post). A `rel="via"` link is the explicit signal.
        is_repost:
            !!via_jid ||
            !!(
                author_jid &&
                publisher &&
                Strophe.getBareJidFromJid(author_jid) !== Strophe.getBareJidFromJid(publisher)
            ),
    };
}

/**
 * Parse a single PubSub `<item>` (or a bare `<entry>`) from a microblog node
 * into a flat attributes object suitable for a {@link PubSubMessage}.
 *
 * @param {Element} item - An `<item>` element (as returned by retrieve-items or a
 *      PEP event), or an `<entry>` element directly.
 * @param {object} [context]
 * @param {string} [context.from] - JID of the feed this item belongs to.
 * @param {string} [context.node] - The PubSub node the item was published to.
 * @returns {import('./types').PubSubMessageAttrs}
 */
function parseAtomEntry(item, { from, node } = {}) {
    const is_entry = item.localName === 'entry' && item.namespaceURI === NS_ATOM;
    const entry = getEntry(item);
    if (!entry) {
        throw new Error('parseAtomEntry: no <entry> found in item');
    }

    const id = is_entry ? getUniqueId() : item.getAttribute('id');
    // The PubSub server stamps the publisher on event/retrieve items; trust it
    // over the (spoofable) atom:author for authorship (XEP-0277 § Security).
    const publisher = is_entry ? undefined : item.getAttribute('publisher') || undefined;

    const author = sizzle('> author', entry).pop();
    const author_name = author ? sizzle('> name', author).pop()?.textContent?.trim() : undefined;
    const author_uri = author ? sizzle('> uri', author).pop()?.textContent?.trim() : undefined;
    const author_jid = author_uri ? getJIDFromURI(author_uri) : undefined;

    // An Atom entry can carry up to three text constructs:
    // - <title> XEP-0277 short posts put the whole post here
    // - <summary> Excerpt
    // - <content> Full body Atom-native feeds use this, often with an empty <title>
    const title = pickTextConstruct(sizzle('> title', entry));
    const summary = pickTextConstruct(sizzle('> summary', entry));
    const content = pickTextConstruct(sizzle('> content', entry));

    const published = sizzle('> published', entry).pop()?.textContent?.trim();
    const updated = sizzle('> updated', entry).pop()?.textContent?.trim();
    const time = published ?? updated;

    return {
        type: MICROBLOG_TYPE,
        msgid: id,
        id,
        node,
        from,
        title: title.text,
        content: content.text,
        summary: summary.text,
        title_xhtml: title.xhtml,
        summary_xhtml: summary.xhtml,
        content_xhtml: content.xhtml,
        atom_id: sizzle('> id', entry).pop()?.textContent?.trim(),
        author_name,
        author_jid,
        publisher,
        categories: sizzle('> category', entry)
            .map((el) => el.getAttribute('term'))
            .filter(Boolean),
        published,
        updated,
        ...(time ? { time } : {}),

        ...parseThreading(entry),
        ...parseGeoloc(entry),
        ...parseLinks(entry, author_jid, publisher),
    };
}

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/placeholder.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */



/**
 * A non-post placeholder that marks a point in a feed's history where more posts
 * can be loaded. Two roles, distinguished only by `stop_at_time`:
 *
 * - **older-frontier** (no `stop_at_time`): sits at a feed's oldest-loaded post and
 *   pages older until the node is exhausted — the per-feed "load older" control.
 * - **gap** (`stop_at_time` set): sits in a newer-than-cache gap and pages the
 *   missing range until it reaches the cached posts.
 *
 * It is positioned in the timeline by `time` (set by whoever creates it) and, when
 * scrolled into view, calls the feed's shared {@link module:feed~PubSubFeed#fetchOlder}
 * primitive. It is never persisted (recreated on load).
 *
 * @extends {Model}
 */
class PubsubPlaceholderMessage extends skeletor_esm_Model {
    defaults() {
        const id = getUniqueId();
        return {
            id,
            msgid: id,
            is_ephemeral: false,
            // `time`, `before_cursor` and (for gaps) `stop_at_time` are supplied by
            // the creator so the placeholder sorts into the right position.
        };
    }

    /**
     * Load one page of older posts into the feed, then remove this placeholder.
     * `fetchOlder` re-seeds a follow-on placeholder if more history remains, which
     * also re-arms the IntersectionObserver (a fresh element).
     * @returns {Promise<void>}
     */
    async fetchMissingMessages() {
        this.set('fetching', true);
        await this.collection.feed.fetchOlder(this);
        this.destroy();
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/utils/thread.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 *
 * Pure helpers that assemble a flat comment collection into a reply tree
 * (XEP-0277 § Comments + RFC 4685 threading). Unit-testable in isolation and
 * cheap to recompute on every render.
 *
 * The wire is flat with every reply, at any depth, living in one comments node and
 * pointing at its parent with `<thr:in-reply-to>`. These helpers turn that flat
 * list into a parent/child structure.
 */


/**
 * The parent pointer of a comment if it nests within this thread.
 *
 * A comment carries a raw `in_reply_to` that may point at a sibling in the same
 * node (i.e. a nesting reply) or at a post in another node (a Movim-style post-reply).
 * Since a `buildCommentTree` call only ever sees one node's items,
 * "same thread" means the pointer's node/jid match the comment's own.
 * A pointer with no node/jid is treated as same-thread.
 * @param {import('../post-comment').default} comment
 * @returns {{ id: string, ref: (string|undefined) }|null}
 */
function nestingParent(comment) {
    const id = comment.get('in_reply_to');
    const ref = comment.get('in_reply_to_ref');
    if (!id && !ref) return null;

    const ptr_node = comment.get('in_reply_to_node');
    const ptr_jid = comment.get('in_reply_to_jid');
    const same_node = !ptr_node || ptr_node === comment.get('node');
    const same_jid =
        !ptr_jid || Strophe.getBareJidFromJid(ptr_jid) === Strophe.getBareJidFromJid(comment.get('from') || '');
    if (!same_node || !same_jid) return null; // cross-node: a post-reply, not a nesting one

    // `id` (the parent item id) is the primary key; `ref` (its atom:id) resolves an
    // entry whose href carried no item id (see parseAtomEntry).
    return { id: id || undefined, ref: ref || undefined };
}

/**
 * Oldest-first comparator for two tree nodes, tie-broken by id for stability
 * (the backing collection is newest-first, so we sort an explicit snapshot).
 * @param {import('./types').CommentTreeNode} a
 * @param {import('./types').CommentTreeNode} b
 * @returns {number}
 */
function byTimeAsc(a, b) {
    const ta = a.comment.get('published') || a.comment.get('time') || '';
    const tb = b.comment.get('published') || b.comment.get('time') || '';
    return ta.localeCompare(tb) || String(a.comment.get('id')).localeCompare(String(b.comment.get('id')));
}

/**
 * Assemble a flat list of a single thread's comments into a reply tree.
 *
 * Pass the thread's real comments (the caller must filter out ♥ likes).
 *
 * Classification per comment:
 *  - **root**: no nesting pointer (a direct comment on the post). Surfaced.
 *  - **child**: nesting pointer resolves to a loaded comment. Hung off it.
 *  - **orphan**: nesting pointer set but the parent isn't loaded.
 *  - a reference cycle is broken by demoting the closing node to a root.
 *
 * @param {import('../post-comment').default[]} comments
 * @returns {{ roots: import('./types.ts').CommentTreeNode[], by_id: import('./types').CommentTreeMap }}
 */
function buildCommentTree(comments) {
    /** @type {import('./types.ts').CommentTreeMap} */
    const by_id = new Map();

    for (const comment of comments) {
        /** @type {import('./types.ts').CommentTreeNode} */
        const node = { comment, replies: [], parent: null };
        by_id.set(comment.get('id'), node);
    }

    // Resolve each comment's parent (tentatively; cycles broken below), reusing the
    // one nesting/resolution pass so structure and counts can never disagree.
    const parents = resolveThreadParents(comments);
    for (const node of by_id.values()) {
        const info = parents.get(node.comment.get('id'));
        if (info.parent && by_id.has(info.parent)) node.parent = by_id.get(info.parent);
        else if (info.orphan) node.orphan = true;
    }

    // Break any reference cycle by cutting the edge that closes it, which makes
    // that node a root (parent restored to null, not orphaned).
    for (const start of by_id.values()) {
        const seen = new Set();
        let cur = start;
        while (cur?.parent) {
            if (seen.has(cur)) {
                cur.parent = null;
                break;
            }
            seen.add(cur);
            cur = cur.parent;
        }
    }

    // Materialise the child lists and collect the roots. A root is any node with
    // no parent that isn't an orphan (real roots + cycle-demoted nodes).
    /** @type {import('./types.ts').CommentTreeNode[]} */
    const roots = [];
    for (const node of by_id.values()) {
        if (node.parent) node.parent.replies.push(node);
        else if (!node.orphan) roots.push(node);
    }

    roots.sort(byTimeAsc);
    for (const node of by_id.values()) node.replies.sort(byTimeAsc);

    return { roots, by_id };
}

/**
 * Resolve, for every passed item (comments *and* ♥ likes), how it attaches to the
 * thread: the loaded item it nests under, or that it is a post-level item (no
 * nesting pointer), or that it is an orphan (a nesting pointer whose parent isn't
 * loaded). Shared by {@link buildCommentTree} and {@link computeThreadCounts} so a
 * rendered reply and its counted total can never disagree.
 * @param {import('../post-comment').default[]} items
 * @returns {Map<string, { parent: string|null, orphan: boolean }>}
 */
function resolveThreadParents(items) {
    const present = new Set();
    /** @type {Map<string, string>} atom:id → item id */
    const by_atom = new Map();
    for (const it of items) {
        present.add(it.get('id'));
        const atom_id = it.get('atom_id');
        if (atom_id && !by_atom.has(atom_id)) by_atom.set(atom_id, it.get('id'));
    }

    /** @type {Map<string, { parent: string|null, orphan: boolean }>} */
    const out = new Map();
    for (const it of items) {
        const pk = nestingParent(it);
        let parent = null;
        let orphan = false;
        if (pk) {
            const resolved = pk.id && present.has(pk.id) ? pk.id : pk.ref ? by_atom.get(pk.ref) : undefined;
            if (resolved && resolved !== it.get('id')) parent = resolved;
            else if (!resolved) orphan = true; // pointer set, parent not loaded
            // a self-reference (resolved === own id) falls through as a post-level root
        }
        out.set(it.get('id'), { parent, orphan });
    }
    return out;
}

/**
 * The distinct-liker key for a ♥ item: its author's bare JID, or a per-item
 * fallback when the author is unknown (so unattributable likes count once each
 * rather than collapsing together).
 * @param {import('../post-comment').default} like
 * @returns {string}
 */
function likerKey(like) {
    const jid = like.getAuthorJID?.();
    return jid ? Strophe.getBareJidFromJid(jid) : `id:${like.get('id')}`;
}

/**
 * Partition a thread's items into denormalised counts in a single pass: the
 * post-level summary plus per-comment counts, keyed by comment id.
 *
 * Likes are attributed to their target (the post when they carry no nesting
 * pointer, else the comment they reply to) and counted by distinct liker, so a ♥
 * aimed at a comment never inflates the post's like count. `comment_count` is the
 * whole thread's reply total (every real comment, orphans included); a comment's
 * `reply_count` is its *direct* replies only.
 * @param {import('../post-comment').default[]} items - A thread's items (likes included).
 * @returns {{
 *   post: { comment_count: number, like_count: number, liked_by_me: boolean, my_like_id: (string|undefined) },
 *   byComment: Map<string, { reply_count: number, like_count: number, liked_by_me: boolean, my_like_id: (string|undefined) }>
 * }}
 */
function computeThreadCounts(items) {
    const reals = items.filter((it) => typeof it.isLike === 'function');
    const parents = resolveThreadParents(reals);

    let comment_count = 0;
    const post_likers = new Set();
    let post_liked_by_me = false;
    let post_my_like_id;

    /** @type {Map<string, { reply_count: number, likers: Set<string>, liked_by_me: boolean, my_like_id: (string|undefined) }>} */
    const agg = new Map();
    const ensure = (/** @type {string} */ id) => {
        let a = agg.get(id);
        if (!a) {
            a = { reply_count: 0, likers: new Set(), liked_by_me: false, my_like_id: undefined };
            agg.set(id, a);
        }
        return a;
    };
    // Seed every real comment so a childless, unliked comment still reports zeros.
    for (const it of reals) if (!it.isLike()) ensure(it.get('id'));

    for (const it of reals) {
        const info = parents.get(it.get('id'));
        if (it.isLike()) {
            // A like belongs to exactly one target; an orphan like (whose target
            // isn't loaded) is counted nowhere.
            if (info.orphan) continue;
            if (info.parent === null) {
                post_likers.add(likerKey(it));
                if (it.get('is_mine')) {
                    post_liked_by_me = true;
                    post_my_like_id = it.get('id');
                }
            } else if (agg.has(info.parent)) {
                const a = agg.get(info.parent);
                a.likers.add(likerKey(it));
                if (it.get('is_mine')) {
                    a.liked_by_me = true;
                    a.my_like_id = it.get('id');
                }
            }
        } else {
            // Every real comment counts toward the thread total, orphans included;
            // only a resolved, non-orphan parent gets a reply credited to it.
            comment_count++;
            if (!info.orphan && info.parent !== null && agg.has(info.parent)) {
                agg.get(info.parent).reply_count++;
            }
        }
    }

    const byComment = new Map();
    for (const [id, a] of agg) {
        byComment.set(id, {
            reply_count: a.reply_count,
            like_count: a.likers.size,
            liked_by_me: a.liked_by_me,
            my_like_id: a.my_like_id,
        });
    }
    return {
        post: {
            comment_count,
            like_count: post_likers.size,
            liked_by_me: post_liked_by_me,
            my_like_id: post_my_like_id,
        },
        byComment,
    };
}

/**
 * The ancestor chain of a comment, root-first (excluding the comment itself), for
 * rendering the context above a focused item in the drill-down view. Returns an
 * empty array for a root or an id not present in the tree.
 * @param { import('./types.ts').CommentTreeMap} by_id - The `by_id` from {@link buildCommentTree}.
 * @param {string} id - The focused comment's item id.
 * @returns {import('./types.ts').CommentTreeNode[]}
 */
function getAncestors(by_id, id) {
    const start = by_id.get(id);
    if (!start) return [];

    /** @type {import('./types').CommentTreeNode[]} */
    const chain = [];
    let node = start.parent;
    while (node) {
        chain.push(node);
        node = node.parent;
    }
    return chain.reverse();
}

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/comment-summary.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */






/**
 * A bounded, deduped work queue. Runs at most `concurrency` tasks at once, and
 * each distinct `key` at most once *successfully* (until {@link DedupeQueue#reset}),
 * so the same post's comments aren't re-fetched every time it scrolls back into
 * view. A task that fails isn't marked done, so a later {@link DedupeQueue#add}
 * for that key retries it.
 *
 * Like the `scanFollowable` worker pool, but a long-lived streaming queue rather
 * than a one-shot sweep: the greedy on-visible fetch enqueues continuously as
 * posts enter the viewport.
 */
class DedupeQueue {
    /**
     * @param {number} [concurrency]
     */
    constructor(concurrency = (/* inlined export .COMMENT_SUMMARY_CONCURRENCY */4)) {
        this.concurrency = concurrency;
        /** @type {Array<{ key: string, task: () => Promise<void>, resolve: () => void }>} */
        this._queue = [];
        /** @type {Map<string, Promise<void>>} keys queued or in flight */
        this._pending = new Map();
        /** @type {Set<string>} keys that ran successfully this session */
        this._done = new Set();
        this._active = 0;
    }

    /**
     * Enqueue `task` under `key`. Returns a promise that settles once the task
     * has run. A key already queued/in-flight returns that same promise; a key
     * that already ran successfully resolves immediately without re-running (a
     * key whose task failed is re-enqueueable).
     * @param {string} key
     * @param {() => Promise<void>} task
     * @returns {Promise<void>}
     */
    add(key, task) {
        if (!key || this._done.has(key)) return Promise.resolve();
        const existing = this._pending.get(key);
        if (existing) return existing;

        let resolve;
        const promise = new Promise((r) => (resolve = r));
        this._pending.set(key, promise);
        this._queue.push({ key, task, resolve });
        this._drain();
        return promise;
    }

    _drain() {
        while (this._active < this.concurrency && this._queue.length) {
            const { key, task, resolve } = this._queue.shift();
            this._active++;
            Promise.resolve()
                .then(task)
                .then(
                    // Only mark done on success; a failed task (e.g. a transient
                    // fetch error) stays re-enqueueable so a later visibility can
                    // retry rather than caching "never fetched" for the session.
                    () => this._done.add(key),
                    (e) => src_log.error(e),
                )
                .finally(() => {
                    this._active--;
                    this._pending.delete(key);
                    resolve();
                    this._drain();
                });
        }
    }

    /**
     * Drop all queue state (on session clear) so a fresh login re-fetches.
     */
    reset() {
        this._queue = [];
        this._pending.clear();
        this._done.clear();
        this._active = 0;
    }
}

/**
 * The singleton queue funnelling per-post comment-summary fetches.
 */
const comment_summary_queue = new DedupeQueue();

/**
 * Recompute a post's denormalised comment/like counts from its comment thread
 * and persist them onto the post (the timeline's display source of truth). The
 * thread stays the source; these attrs are a synced cache that survives reload
 * and thread eviction. A no-op when the thread isn't materialised.
 *
 * Called explicitly at each mutation point (after a summary fetch, after our own
 * comment; later slices add live-event and like calls) rather than via a
 * `feed.messages` listener, which would fire once per item during a bulk fetch.
 * @param {import('./message').default} post
 * @param {import('./comment-feed').default} [feed] - The post's thread, if already resolved.
 */
function syncCommentSummary(post, feed) {
    feed = feed || shared_converse.state.commentfeeds?.getFeed(post.getCommentsService(), post.getCommentsNode(), false);
    if (!feed) return;
    const summary = feed.summarize();
    const changed = Object.keys(summary).some((k) => post.get(k) !== summary[k]);
    // Detached browse-feed posts (a non-followed author's) are in-memory with no
    // store, so persist only when the post is store-backed; else set reactively.
    if (changed) safeSave(post, summary);
}

/**
 * Recompute and persist each comment's own denormalised counts (`reply_count`,
 * `like_count`, `liked_by_me`, `my_like_id`) from the thread, so the drill-down
 * view can show a reply/like tally on every row without re-walking the node.
 * @param {import('./comment-feed').default} [feed]
 */
function syncCommentCounts(feed) {
    if (!feed) return;

    const { byComment } = computeThreadCounts(feed.comments);
    for (const comment of feed.getComments()) {
        const counts = byComment.get(comment.get('id'));
        if (!counts) continue;

        const changed = Object.keys(counts).some((k) => comment.get(k) !== counts[k]);
        if (changed) safeSave(comment, counts);
    }
}

/**
 * Find the loaded post a comments node belongs to, by scanning the timeline
 * feeds for a post whose comments node + service match. Returns undefined when
 * the post isn't loaded (its counts then simply aren't synced live).
 * @param {string} service - The comments service JID.
 * @param {string} node - The comments node.
 * @returns {import('./message').default|undefined}
 */
function findPostForThread(service, node) {
    const feeds = shared_converse.state.pubsubfeeds;
    if (!feeds || !node?.startsWith(COMMENTS_NODE_PREFIX)) return undefined;
    const post_id = node.slice(COMMENTS_NODE_PREFIX.length);
    for (const feed of feeds.models) {
        const post = feed.messages?.get(post_id);
        // Item ids are only unique within a node, so confirm the post actually
        // points at this comments node/service before syncing it.
        if (post && post.getCommentsNode() === node && post.getCommentsService() === service) {
            return post;
        }
    }
    return undefined;
}

/**
 * The loaded comment that owns a **Libervia child node** (a comment which
 * advertised its own replies node, see {@link PostComment.getRepliesRef}), by
 * scanning the materialised comment threads. Returns undefined when no such
 * comment is loaded. Bounded by `social_max_comment_threads`; only run on live
 * events / a child-node fetch.
 * @param {string} service - The child comments node's service JID.
 * @param {string} node - The child comments node.
 * @returns {import('./post-comment').default|undefined}
 */
function findOwningComment(service, node) {
    const feeds = shared_converse.state.commentfeeds;
    if (!feeds) return undefined;
    for (const feed of feeds.models) {
        for (const m of feed.messages?.models ?? []) {
            const ref = typeof (/** @type {any} */ (m).getRepliesRef) === 'function' ? m.getRepliesRef() : null;
            if (ref && ref.node === node && ref.jid === service) return m;
        }
    }
    return undefined;
}

/**
 * The loaded entity a comments node hangs off: a post (the common per-post node),
 * or, for a Libervia child node, the comment that advertised it. Distinguished by
 * whether the returned model carries `getRepliesRef` (only a {@link PostComment} does).
 * @param {string} service - The comments service JID.
 * @param {string} node - The comments node.
 * @returns {import('./message').default|import('./post-comment').default|undefined}
 */
function findParentForThread(service, node) {
    return findPostForThread(service, node) || findOwningComment(service, node);
}

/**
 * Write a Libervia owning comment's denormalised counts from its child node,
 * whose top-level items are that comment's direct replies (and post-level ♥ its
 * likes). This is how a comment whose replies live in a *separate* node gets a
 * `reply_count` / `like_count`, which the flat model computes locally instead.
 * @param {import('./post-comment').default} comment
 * @param {import('./comment-feed').default} [child] - The comment's replies node.
 */
function syncOwningComment(comment, child) {
    if (!comment || !child) return;
    const { post } = computeThreadCounts(child.comments);
    const attrs = {
        reply_count: post.comment_count,
        like_count: post.like_count,
        liked_by_me: post.liked_by_me,
        my_like_id: post.my_like_id,
    };
    const changed = Object.keys(attrs).some((k) => comment.get(k) !== attrs[k]);
    if (changed) safeSave(comment, attrs);
}

/**
 * Sync a comment thread's counts onto its owning entity after a live event routed
 * into the thread (see `handleMicroblogEvent`), or after a child node is fetched.
 * Syncs the thread's own per-comment counts, then the owning post's summary, or —
 * for a Libervia child node — the owning comment's count. A no-op when the owner
 * isn't loaded.
 * @param {string} service - The comments service JID.
 * @param {string} node - The comments node.
 * @param {import('./comment-feed').default} [feed] - The thread, if already resolved.
 */
function syncCommentThread(service, node, feed) {
    feed = feed || shared_converse.state.commentfeeds?.getFeed(service, node, false);
    // Per-comment counts drive the thread view and don't depend on the owner
    // being loaded, so sync them whenever the thread is materialised.
    if (feed) syncCommentCounts(feed);

    const parent = findParentForThread(service, node);
    if (!parent) return;
    if (typeof (/** @type {any} */ (parent).getRepliesRef) === 'function') {
        syncOwningComment(/** @type {import('./post-comment').default} */ (parent), feed);
    } else {
        syncCommentSummary(/** @type {import('./message').default} */ (parent), feed);
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/utils.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */








/**
 * Build the `tag:` URI used as the Atom `<id>` of a new entry (RFC 4151).
 * @param {string} jid
 * @param {string} id
 * @returns {string}
 */
function buildTagId(jid, id) {
    const domain = Strophe.getDomainFromJid(jid) || jid;
    const date = new Date().toISOString().split('T')[0];
    return `tag:${domain},${date}:posts-${id}`;
}

// A hashtag in post text: `#` at a word boundary, then a letter and word chars.
// Kept in sync with the renderer's pattern in `app-social/texture.js`, so the
// `<category>` terms we publish match the hashtags shown in a post's body.
const HASHTAG_REGEX = /(?<![\p{L}\p{N}_])#(\p{L}[\p{L}\p{N}_]*)/gu;

/**
 * The distinct hashtag terms in `text` (without `#`, lower-cased), for emitting
 * as Atom `<category>` terms (XEP-0277 § Post Categories) when publishing, so a
 * post's tags are machine-readable to aggregators and bridges rather than only
 * inline text.
 * @param {string} text
 * @returns {string[]}
 */
function extractHashtags(text) {
    const tags = new Set();
    for (const m of (text ?? '').matchAll(HASHTAG_REGEX)) tags.add(m[1].toLowerCase());
    return Array.from(tags);
}

/**
 * Parse a feed address into a `{ jid, node }` pair, or null if it isn't a usable
 * address. Accepts either a bare JID (a user like `news@example.org` or a service
 * like `pubsub.example.org`), which defaults to the PEP microblog node, or an XMPP
 * pubsub URI carrying an explicit node (`xmpp:pubsub.example.org?;node=news`, per
 * RFC 5122 / XEP-0060).
 * @param {string} address
 * @returns {{ jid: string, node: string }|null}
 */
function parseFeedAddress(address) {
    const raw = address?.trim();
    if (!raw) return null;

    let jid = raw;
    let node = MICROBLOG_NODE;

    if ((/^xmpp:/i).test(raw)) {
        const [jid_part, query = ''] = raw.slice('xmpp:'.length).split('?');
        jid = decodeURIComponent(jid_part);
        // The query is `[action];key=value;key=value` (the leading action may be
        // empty), so pick out the `node=` pair wherever it sits.
        const node_pair = query.split(';').find((p) => p.startsWith('node='));
        if (node_pair) node = decodeURIComponent(node_pair.slice('node='.length));
    }

    // Strip any resource and require a dotted domain, so a stray word isn't taken
    // for a JID. A service JID (`pubsub.example.org`) has no local part.
    jid = Strophe.getBareJidFromJid(jid) || jid;
    const domain = Strophe.getDomainFromJid(jid);
    if (!jid || !node || !domain?.includes('.')) return null;

    return { jid, node };
}

// Coalesce follow-list re-syncs. A burst of `+notify` pushes (e.g. a bulk-follow
// on another device) must not fire N concurrent list re-reads: while one pass
// runs, further triggers just mark it to run once more when it finishes.
let resyncing_following = false;
let resync_following_pending = false;

/**
 * Re-sync the local follow state from the durable XEP-0330 list (coalesced,
 * fire-and-forget). Triggered by a `+notify` push on our own follow-list node.
 */
function resyncFollowing() {
    if (resyncing_following) {
        resync_following_pending = true;
        return;
    }
    resyncing_following = true;
    (async () => {
        do {
            resync_following_pending = false;
            await shared_api.microblog.syncFollowing();
        } while (resync_following_pending);
    })()
        .catch((e) => src_log.error(e))
        .finally(() => {
            resyncing_following = false;
        });
}

/**
 * Retrieve the payloads of any items that arrived as a bare `<item id/>` header.
 *
 * The retrieval itself is by `api.pubsub.items.resolve`. A header for an item we
 * already hold isn't fetched at all. It keeps a redelivered comment from raising
 * a second notification, and drops the id from a batch we'd otherwise ask the
 * service to re-send content we have. The cost is that an *edit* republished under
 * the same id goes unseen on such a node, because a bare header carries nothing
 * that tells an edit from a redelivery.
 *
 * @param {import('./feed').default} feed - The feed the items belong to.
 * @param {Element[]} items
 * @returns {Promise<Element[]>}
 */
async function resolveItemPayloads(feed, items) {
    const { jid, node } = feed.attrs;
    // The collection can only answer "do we have this already" once hydrated,
    // which is what addItems waits on too.
    await feed.messages.hydrated;
    const wanted = items.filter((el) => el.firstElementChild || !feed.messages.get(el.getAttribute('id')));
    return shared_api.pubsub.items.resolve(jid, node, wanted);
}

/**
 * Handle an incoming PEP/PubSub event, routing items to the relevant feed. A feed
 * is auto-created only for the user's own microblog node; events from any other
 * node are applied only to a feed the user already follows (a contact's microblog
 * or an arbitrary community node on a pubsub service).
 *
 * @param {Element} message
 * @returns {boolean} Always `true`, to keep the Strophe handler registered.
 */
function handleMicroblogEvent(message) {
    try {
        const event = sizzle(`event[xmlns="${Strophe.NS.PUBSUB}#event"]`, message).pop();
        if (!event) return true;

        const feeds = shared_converse.state.pubsubfeeds;
        if (!feeds) return true;

        const bare_jid = shared_converse.session.get('bare_jid');
        const from = Strophe.getBareJidFromJid(message.getAttribute('from')) || bare_jid;

        for (const items_el of sizzle('> items', event)) {
            const node = items_el.getAttribute('node');
            if (!node) continue;

            // A change to our *own* XEP-0330 follow list (a follow/unfollow made
            // on another device or client) arrives here via `+notify`. It isn't a
            // timeline node, so re-sync the mirror + feeds from the server rather
            // than routing items. A contact's list (from someone else) must never
            // mutate our own follows, so it's ignored.
            if (node === FOLLOWING_NODE) {
                if (from === bare_jid) resyncFollowing();
                continue;
            }

            // Route by feed *existence*, not by node name, so any followed node
            // works (a contact's `urn:xmpp:microblog:0`, or an arbitrary community
            // node on a pubsub service), while our own non-feed PEP nodes (avatar,
            // bookmarks, OMEMO...) are ignored:
            //  - a comments node routes to its own collection, and only into an
            //    already-open thread (create=false), so it never surfaces in the timeline;
            //  - our own microblog node is auto-created;
            //  - a followed community/contact node routes into its already-materialised
            //    feed (persisted, so present even before the Social app opens);
            //  - anything else has no feed and is dropped.
            // Route by feed *existence* first: a materialised comment thread takes
            // its live items whatever its node is named, so a Libervia child node
            // (which need not use the `urn:xmpp:microblog:0:comments/` prefix) still
            // routes. Then fall back to the node-name test, so a conventional
            // comments node with no open thread is still recognised as comments (and
            // dropped, create=false) rather than mistaken for a timeline node.
            const comment_feed = shared_converse.state.commentfeeds?.getFeed(from, node, false);
            const is_comments = !!comment_feed || node.startsWith(COMMENTS_NODE_PREFIX);
            const feed = is_comments
                ? comment_feed
                : feeds.getFeed(from, node, from === bare_jid && node === MICROBLOG_NODE);
            if (!feed) continue;

            const items = sizzle('> item', items_el);
            const retracts = sizzle('> retract', items_el)
                .map((el) => el.getAttribute('id'))
                .filter(Boolean);
            if (!items.length && !retracts.length) continue;

            if (items.length) {
                // Snapshot the thread's existing comment ids so a re-delivered
                // item (already present) can't raise a second notification.
                const known = is_comments ? new Set(feed.messages.models.map((m) => m.get('id'))) : null;
                // A live comment/like landing on a materialised (pinned/open)
                // thread updates the owning post's denormalised counts, so the
                // timeline reflects it without reopening the thread, and a comment
                // or like on one of *our* posts raises a desktop notification.
                // Resolution and addItems are both async, so the one catch at the
                // end of the chain keeps a rejection from escaping.
                resolveItemPayloads(feed, items)
                    .then((resolved) => feed.addItems(resolved))
                    .then((added) => {
                        if (!is_comments) return;
                        syncCommentThread(from, node, feed);
                        notifyOfThreadActivity(from, node, added, known);
                    })
                    .catch((e) => src_log.error(e));
            }
            if (retracts.length) {
                feed.removeItems(retracts);
                if (is_comments) syncCommentThread(from, node, feed);
            }
        }
    } catch (e) {
        src_log.error(e);
    }
    return true;
}

/**
 * Raise a `microblogNotification` for each newly-arrived comment or ♥ like on one
 * of *our* own posts, so the notifications plugin can show a desktop alert (parity
 * with chat messages). Deliberately narrow:
 *  - runs only from the live PEP path (never the `fetchComments` backfill), so
 *    opening or pinning a thread never back-notifies its existing activity;
 *  - `known` filters out a re-delivered item already in the thread;
 *  - our own comments/likes are skipped;
 *  - a ♥ like notifies as `type: 'like'`, a text comment as `type: 'comment'`,
 *    so the notifications plugin can word each one;
 *  - the thread's owning post must be ours (`is_mine`), which also requires it to
 *    be loaded in a timeline feed (otherwise there's nothing to open/attribute).
 *
 * @param {string} service - The comments service JID.
 * @param {string} node - The comments node.
 * @param {import('./post-comment').default[]} comments - The models `addItems` returned.
 * @param {Set<string>} known - Comment ids present before this batch.
 */
function notifyOfThreadActivity(service, node, comments, known) {
    const feed = shared_converse.state.commentfeeds?.getFeed(service, node, false);
    const post = findPostForThread(service, node);
    const post_is_mine = !!post?.get('is_mine');

    // A ref the notification click opens the thread from: the loaded post, else —
    // for a conventional per-post comments node — the post id encoded in the node.
    const ref = post
        ? { feedJid: post.get('from'), node: post.get('node'), itemId: post.get('id') }
        : node.startsWith(COMMENTS_NODE_PREFIX)
          ? { feedJid: service, node: MICROBLOG_NODE, itemId: node.slice(COMMENTS_NODE_PREFIX.length) }
          : null;
    if (!ref) return;

    for (const comment of comments) {
        if (known.has(comment.get('id')) || comment.get('is_mine')) continue;
        // Notifiable when it lands on our own post, or replies to / likes one of
        // our own comments in the loaded thread.
        const parent_id = comment.get('in_reply_to');
        const parent = parent_id ? feed?.messages.get(parent_id) : null;
        if (!post_is_mine && !parent?.get('is_mine')) continue;

        const type = comment.isLike?.() ? 'like' : 'comment';
        /**
         * Triggered for a notifiable microblog event: a comment or ♥ like on one of
         * the user's own posts, or a reply to / like of one of their own comments.
         * The notifications plugin listens for this to raise an HTML5 desktop
         * notification.
         * @event _converse#microblogNotification
         * @type {{ type: 'comment'|'like', post: import('./message').default, comment: import('./post-comment').default, ref: { feedJid: string, node: string, itemId: string } }}
         */
        shared_api.trigger('microblogNotification', { type, post, comment, ref });
    }
}

/**
 * Register a handler for microblog items pushed via PEP from our own or
 * followed nodes.
 */
function registerMicroblogHandler() {
    shared_api.connection.get().addHandler(handleMicroblogEvent, null, 'message');
}

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/feed.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */














const { stx: feed_stx, Stanza: feed_Stanza } = api_public.env;

// One detached browse feed per JID + node, reused across profile-view opens (the
// same pattern MicroblogProfile uses): re-visiting an unfollowed author gets the
// already-fetched feed instead of a blank refetch, and the set of browsed-but-not-
// followed feeds becomes enumerable (see {@link PubSubFeed.browseFeeds}). Session-
// scoped: cleared on logout via {@link PubSubFeed.clearBrowseFeeds}.
const browse_feeds = new Map();

/**
 * One PubSub feed: a single node at a single JID (your own
 * `urn:xmpp:microblog:0`, a contact's microblog, or a community node).
 * @extends {Model}
 */
class PubSubFeed extends skeletor_esm_Model {
    get idAttribute() {
        return 'id';
    }

    defaults() {
        return {
            node: MICROBLOG_NODE,
        };
    }

    /**
     * The collection class backing {@link messages}. {@link CommentFeed} overrides
     * this so a thread's items are {@link PostComment}s (which carry comment-only
     * behaviour like `isLike`), while a timeline feed's items are plain
     * {@link PubSubMessage}s.
     * @returns {typeof PubSubMessages}
     */
    get messagesCollectionClass() {
        return microblog_messages;
    }

    initialize() {
        super.initialize();
        const MessagesCollection = this.messagesCollectionClass;

        // Unfollowed feeds are stored in-memory and not persisted
        const id = this.get('in_memory') ? undefined : this.getMessagesCacheKey();
        /** @type {PubSubMessages} */
        this.messages = new MessagesCollection(null, { id });
        this.messages.feed = this;
    }

    /**
     * @returns {string}
     */
    getMessagesCacheKey() {
        const bare_jid = shared_converse.session.get('bare_jid');
        return `converse.pubsub-messages-${this.get('jid')}-${this.get('node')}-${bare_jid}`;
    }

    /**
     * Get (creating + caching if necessary) the detached, in-memory browse feed
     * for a JID + node the user does *not* follow. Deliberately kept out of
     * `_converse.state.pubsubfeeds` (that collection is persisted and aggregated
     * wholesale into the timeline), but cached here so re-opening a profile is
     * warm and browsed feeds are enumerable for e.g. mention completion.
     * @param {string} jid
     * @param {string} node
     * @returns {PubSubFeed}
     */
    static getBrowseFeed(jid, node) {
        const id = `${jid}/${node}`;
        let feed = browse_feeds.get(id);
        if (!feed) {
            feed = new PubSubFeed({ jid, node, in_memory: true });
            browse_feeds.set(id, feed);
        }
        return feed;
    }

    /**
     * Drop a cached browse feed, e.g. when a follow supersedes it with the
     * shared feed from `_converse.state.pubsubfeeds`.
     * @param {string} jid
     * @param {string} node
     */
    static dropBrowseFeed(jid, node) {
        browse_feeds.delete(`${jid}/${node}`);
    }

    /**
     * The feeds browsed this session without following them.
     * @returns {PubSubFeed[]}
     */
    static browseFeeds() {
        return [...browse_feeds.values()];
    }

    /**
     * Drop every cached browse feed and its listeners (on logout / session clear).
     */
    static clearBrowseFeeds() {
        browse_feeds.forEach((feed) => {
            feed.messages?.stopListening();
            feed.stopListening();
        });
        browse_feeds.clear();
    }

    /**
     * Whether this feed is the logged-in user's own microblog (a PEP node).
     * @returns {boolean}
     */
    isOwnFeed() {
        return Strophe.getBareJidFromJid(this.get('jid')) === shared_converse.session.get('bare_jid');
    }

    /**
     * Whether this feed is an XEP-0472 **gallery** node (its items are images),
     * as opposed to a text microblog/social feed. Drives the image-grid rendering
     * in the profile view; depends on {@link discoverType} having run.
     * @returns {boolean}
     */
    isGallery() {
        return this.get('type') === GALLERY_TYPE;
    }

    /**
     * Learn this node's XEP-0472 profile from its `pubsub#type` (XEP-0060 § 5.4
     * node metadata) and cache it on the model, so the UI can tell a gallery node
     * from a text feed. Best-effort and skipped once known.
     * @returns {Promise<string|undefined>}
     */
    async discoverType() {
        const known = this.get('type');
        if (known) return known;

        try {
            const stanza = await shared_api.disco.info(this.get('jid'), this.get('node'));
            const type =
                sizzle('x[type="result"] field[var="pubsub#type"] value', stanza)[0]?.textContent?.trim() || undefined;
            if (type) this.set({ type });

            return type;
        } catch (e) {
            src_log.debug(`discoverType: could not read pubsub#type for ${this.get('jid')} (${this.get('node')}): ${e}`);
            return undefined;
        }
    }

    /**
     * Parse incoming PubSub `<item>` elements into posts, add/merge them into the
     * feed, and persist them to the offline cache. Used both for retrieve-items
     * backfill and live PEP events.
     * @param {Element[]} items
     * @returns {Promise<import('./message').default[]>}
     */
    async addItems(items) {
        await this.messages.hydrated;

        const from = this.get('jid');
        const node = this.get('node');

        const saves = [];
        const added = items
            .map((item) => {
                try {
                    const attrs = parseAtomEntry(item, { from, node });
                    const existing = this.messages.get(attrs.id);
                    const message = /** @type {import('./message').default} */ (
                        this.messages.add(attrs, { merge: true })
                    );
                    if (this.messages.storage && message && (!existing || message.hasChanged())) {
                        saves.push(message.save(null, { promise: true }));
                    }
                    return message;
                } catch (e) {
                    src_log.error(e);
                    return null;
                }
            })
            .filter(Boolean);
        await Promise.all(saves);
        return added;
    }

    /**
     * The feed's cached posts (excluding placeholders), newest-first.
     * @returns {import('./message').default[]}
     */
    getPosts() {
        return this.messages.models.filter((m) => !(m instanceof PubsubPlaceholderMessage));
    }

    /**
     * The newest cached post (or undefined if the feed is empty). The collection is
     * sorted newest-first, so scan from the front for the first non-placeholder.
     * @returns {import('./message').default|undefined}
     */
    getNewestPost() {
        return this.messages.models.find((m) => !(m instanceof PubsubPlaceholderMessage));
    }

    /**
     * The oldest cached post (or undefined if the feed is empty). Scan from the back
     * of the newest-first collection for the first non-placeholder.
     * @returns {import('./message').default|undefined}
     */
    getOldestPost() {
        const models = this.messages.models;
        for (let i = models.length - 1; i >= 0; i--) {
            if (!(models[i] instanceof PubsubPlaceholderMessage)) return models[i];
        }
        return undefined;
    }

    /**
     * Whether an older-frontier ("load older") placeholder is already present.
     * @returns {boolean}
     */
    hasScrolldownPlaceholder() {
        return this.messages.models.some((m) => m instanceof PubsubPlaceholderMessage && !m.get('stop_at_time'));
    }

    /**
     * Persist the opaque RSM cursor of a fetched page's oldest item onto that post,
     * so we can page *older* than it later. No-op without RSM.
     * @param {import('./message').default[]} added
     * @param {import('../pubsub/types.ts').PubSubItemsResult} result
     * @returns {import('./message').default|undefined} The oldest post of the page.
     */
    storePageCursor(added, result) {
        if (!added.length) return undefined;
        // Determine on which end is the oldest message
        const first = added[0];
        const last = added[added.length - 1];
        const ascending = (first.get('time') ?? '') <= (last.get('time') ?? '');
        const oldest = ascending ? first : last;
        const cursor = ascending ? result.rsm?.result?.first : result.rsm?.result?.last;
        if (cursor && oldest.get('rsm_cursor') !== cursor) {
            oldest.save({ rsm_cursor: cursor });
        }
        return oldest;
    }

    /**
     * Fetch the newest page of the feed's history and merge it in (XEP-0060 § 6.5).
     * Uses native `max_items` since not all servers support RSM pubsub (e.g. Prosody).
     * @returns {Promise<void>}
     */
    async fetchPosts() {
        const { jid, node } = this.attrs;
        // Kick off the network fetch immediately so it runs in parallel with
        // hydration (and so callers can observe the request without awaiting).
        const promise = shared_api.pubsub.items.get(jid, node, { max_items: (/* inlined export .POSTS_PAGE_SIZE */20) });

        await this.messages.hydrated;
        // Newest post we already have, to detect a gap the newest page won't reach.
        const cached_newest_time = this.getNewestPost()?.get('time');

        let result;
        try {
            result = await promise;
        } catch (e) {
            // Record why the fetch failed so the UI can tell an empty feed apart
            // from one we're not allowed to read.
            this.set('fetch_error', /** @type {any} */ (e)?.name || 'error');
            src_log.error(e);
            return;
        }
        this.set({
            supports_rsm: !!result.rsm,
            fetch_error: null,
        });
        const added = await this.addItems(result.items);
        const page_oldest = this.storePageCursor(added, result);

        if (!this.get('supports_rsm')) {
            // Without RSM we can't page efficiently (native `max_items` only ever
            // returns the newest N, so paging backwards re-fetches everything). When
            // the newest page is full there may be more history, so load a single
            // larger window up front, then disable paging.
            if (result.items.length >= (/* inlined export .POSTS_PAGE_SIZE */20)) {
                try {
                    const full = await shared_api.pubsub.items.get(jid, node, { max_items: (/* inlined export .POSTS_MAX_WITHOUT_RSM */200) });
                    await this.addItems(full.items);
                } catch (e) {
                    src_log.error(e);
                }
            }
            this.set('history_complete', true);
            return;
        }

        const complete = result.items.length < (/* inlined export .POSTS_PAGE_SIZE */20);
        this.set('history_complete', complete);
        if (complete) return;

        // A gap exists when the newest page's oldest post is still newer than the
        // posts we already had cached (i.e. it didn't reach them).
        if (
            cached_newest_time &&
            page_oldest &&
            new Date(page_oldest.get('time')).getTime() > new Date(cached_newest_time).getTime()
        ) {
            this.createGapPlaceholder(page_oldest, cached_newest_time);
        }
        this.createScrolldownPlaceholder();
    }

    /**
     * Load one page of posts *older* than `placeholder`'s cursor and merge them in.
     * Shared by the older-frontier and gap placeholders.
     *
     * Pages via the opaque RSM `before` cursor. Placeholders only exist on
     * RSM-capable servers (see {@link fetchPosts}), so no `max_items` fallback is
     * needed here. Re-seeds a follow-on placeholder of the same kind when more
     * history remains.
     * @param {PubsubPlaceholderMessage} placeholder
     * @returns {Promise<void>}
     */
    async fetchOlder(placeholder) {
        await this.messages.hydrated;
        const { jid, node } = this.attrs;
        const before_cursor = placeholder.get('before_cursor');
        const stop_at_time = placeholder.get('stop_at_time');
        // No cursor ⇒ nothing to page against (shouldn't happen: placeholders are
        // only created when RSM is supported and a cursor was captured).
        if (!before_cursor) return;

        let result;
        try {
            result = await shared_api.pubsub.items.get(jid, node, { rsm: { before: before_cursor, max: (/* inlined export .POSTS_PAGE_SIZE */20) } });
        } catch (e) {
            src_log.error(e);
            return;
        }

        const added = await this.addItems(result.items);
        const page_oldest = this.storePageCursor(added, result);

        const more = result.items.length >= (/* inlined export .POSTS_PAGE_SIZE */20);
        const reached_cache = !!(
            stop_at_time &&
            page_oldest &&
            new Date(page_oldest.get('time')).getTime() <= new Date(stop_at_time).getTime()
        );

        if (more && !reached_cache && page_oldest) {
            // Re-seed a follow-on placeholder of the same kind at the new oldest post.
            // `storePageCursor` has already stored this page's older-frontier cursor
            // onto `page_oldest`, so read it back rather than re-deriving it.
            this.messages.add(
                new PubsubPlaceholderMessage({
                    before_cursor: page_oldest.get('rsm_cursor'),
                    ...(stop_at_time ? { stop_at_time } : {}),
                    time: new Date(new Date(page_oldest.get('time')).getTime() - 1).toISOString(),
                }),
            );
        } else if (!stop_at_time) {
            // The older frontier is exhausted (start of the node reached).
            this.set('history_complete', true);
        }
    }

    /**
     * Seed the per-feed "load older" placeholder at the feed's oldest-loaded post.
     * Positioned in the aggregate timeline by the oldest post's time, so it sits at
     * the point where *this* feed's loaded history ends and interleaves correctly.
     */
    createScrolldownPlaceholder() {
        if (this.get('history_complete') || this.hasScrolldownPlaceholder()) return;
        const oldest = this.getOldestPost();
        if (!oldest) return;
        this.messages.add(
            new PubsubPlaceholderMessage({
                before_cursor: oldest.get('rsm_cursor'),
                time: new Date(new Date(oldest.get('time')).getTime() - 1).toISOString(),
            }),
        );
    }

    /**
     * Mark a newer-than-cache gap: a placeholder positioned just below the newest
     * page that pages the missing range until it reaches the cached posts.
     * @param {import('./message').default} page_oldest - Oldest post of the newest page.
     * @param {string} stop_at_time - Time of the newest cached post (the gap's floor).
     */
    createGapPlaceholder(page_oldest, stop_at_time) {
        // `storePageCursor` already stored the page's older-frontier cursor onto
        // `page_oldest`; the gap pages older from there until it reaches the cache.
        const before_cursor = page_oldest.get('rsm_cursor');
        const time = new Date(new Date(page_oldest.get('time')).getTime() - 1).toISOString();
        const exists = this.messages.models.some(
            (m) =>
                m instanceof PubsubPlaceholderMessage &&
                m.get('time') === time &&
                m.get('stop_at_time') === stop_at_time,
        );
        if (exists) return;
        this.messages.add(new PubsubPlaceholderMessage({ before_cursor, stop_at_time, time }));
    }

    /**
     * Remove posts from the feed by id, e.g. in response to a retraction event.
     * @param {string[]} ids
     */
    removeItems(ids) {
        ids.forEach((id) => this.messages.get(id)?.destroy());
    }

    /**
     * Retract (delete) one of our own posts: remove it from the node and drop
     * the locally-cached copy.
     * @param {string} id - The PubSub item id of the post
     * @returns {Promise<void>}
     */
    async retractPost(id) {
        await shared_api.pubsub.retract(this.get('jid'), this.get('node'), id);
        this.messages.get(id)?.destroy();
    }

    /**
     * Tear the feed down (when unfollowing): clear its cached posts and remove
     * the feed itself from the feeds collection / offline cache.
     * @returns {Promise<void>}
     */
    async close() {
        this.messages.clearStore?.({ silent: true });
        await this.destroy();
    }

    /**
     * Publish a new post to this feed's node.
     *
     * With no `xhtml` the post is a plain-text `<title>` (the historical short-post
     * form). With `xhtml` (a well-formed `<div xmlns="…xhtml">…</div>` fragment,
     * produced by the rich composer) the post carries Movim-compatible **dual
     * content**: `<content type="text">` (the markdown source in `body`) plus
     * `<content type="xhtml">` (the rendered fragment). See {@link parseAtomEntry}'s
     * `pickTextConstruct`, which reads exactly that pair back.
     * @param {string} body - Plain text, or the markdown source when `xhtml` is set.
     * @param {object} [opts]
     * @param {string} [opts.xhtml] - A well-formed XHTML `<div>` fragment for a rich post.
     * @param {import('./types').PubSubEnclosure[]} [opts.enclosures] - Media attachments
     *      (e.g. XEP-0363-uploaded files), emitted as `<link rel="enclosure">`.
     * @returns {Promise<void>}
     */
    async publishPost(body, { xhtml, enclosures } = {}) {
        const text = body?.trim();
        // A post needs either text or at least one media attachment.
        if (!text && !enclosures?.length) return;

        const id = getUniqueId();
        // Provision the post's open comments node so *others* can reply.
        this.ensureCommentsNode(id);

        const item = this.createPostStanza({ body: text, xhtml, enclosures, id });
        // Publish with the XEP-0472 Base-profile node config so our node stays a
        // well-formed social feed that contacts can subscribe to. Non-strict:
        // if the server can't honour the publish-options precondition we still
        // publish the post.
        await shared_api.pubsub.publish(this.get('jid'), this.get('node'), item, MICROBLOG_PUBLISH_OPTIONS, false);

        // Optimistically render our own post; the PEP echo (if any) will merge
        // by id rather than duplicate.
        const [added] = await this.addItems([item.tree()]);

        // Pin + subscribe to our own post's comments thread
        if (added && this.isOwnFeed()) shared_api.microblog.comments.pin(added).catch((e) => src_log.error(e));
    }

    /**
     * Edit one of our own posts. Republish to the same PubSub item id,
     * preserving the entry's `atom:id` and original `published` time while
     * stamping a fresh `updated`. Per XEP-0060 a publish to an existing item id
     * replaces it, and {@link addItems} merges the new payload into the cached
     * post by id, so the timeline updates in place without reordering. The
     * post's comments node (keyed by the same id) is untouched.
     * @param {string} id - The PubSub item id of the post to edit.
     * @param {string} body - Plain text, or the markdown source when `xhtml` is set.
     * @param {object} [opts]
     * @param {string} [opts.xhtml] - A well-formed XHTML `<div>` fragment for a rich post.
     * @param {import('./types').PubSubEnclosure[]} [opts.enclosures] - Media attachments.
     * @returns {Promise<void>}
     */
    async editPost(id, body, { xhtml, enclosures } = {}) {
        const text = body?.trim();
        // An edited post, like a new one, needs either text or a media attachment.
        if (!text && !enclosures?.length) return;

        const existing = this.messages.get(id);
        const item = this.createPostStanza({
            body: text,
            xhtml,
            enclosures,
            id,
            // Keep the entry's stable identity and creation time; only `updated` moves.
            atom_id: existing?.get('atom_id'),
            published: existing?.get('published') || existing?.get('time'),
            updated: new Date().toISOString(),
        });
        await shared_api.pubsub.publish(this.get('jid'), this.get('node'), item, MICROBLOG_PUBLISH_OPTIONS, false);
        await this.addItems([item.tree()]);
    }

    /**
     * Create this post's open comments node so others can add comments.
     * Best-effort and swallows errors (the node may already exist,
     * or the server may refuse). Returns the in-flight promise for callers that
     * want to await it (e.g. tests), but {@link publishPost} deliberately does not.
     * @param {string} id - The post's PubSub item id.
     * @returns {Promise<void>}
     */
    ensureCommentsNode(id) {
        return shared_api.pubsub.create(this.get('jid'), COMMENTS_NODE_PREFIX + id, COMMENTS_PUBLISH_OPTIONS)
            .catch((e) => src_log.debug(`ensureCommentsNode: could not create the comments node for ${id}: ${e}`));
    }

    /**
     * Construct the PubSub `<item>` for a new plain-text post on this feed's
     * node. `author` is intentionally omitted for own-feed posts (the node owner
     * is implied per XEP-0277). Carries a `rel="replies"` link advertising the
     * post's comments node, so readers know where to add comments.
     * @param {import('./types').PubSubPublishAttrs} attrs
     * @returns {import('strophe.js').Stanza}
     */
    createPostStanza(attrs) {
        const id = attrs.id || getUniqueId();
        const now = new Date().toISOString();
        const published = attrs.published || now;
        const updated = attrs.updated || now;
        const tag_id = attrs.atom_id || buildTagId(this.get('jid'), id);
        const comments_node = COMMENTS_NODE_PREFIX + id;
        const comments_href = `xmpp:${this.get('jid')}?;node=${encodeURIComponent(comments_node)}`;

        // A rich post carries dual content (Movim-compatible): the markdown source
        // as `<content type="text">` plus the rendered `<content type="xhtml">`.
        // The xhtml fragment is injected raw (it's already well-formed XML built by
        // the composer); the plain-text path keeps the historical `<title>` form.
        const body = attrs.xhtml
            ? feed_stx`<content type="text">${attrs.body}</content>${feed_Stanza.unsafeXML(
                  `<content type="xhtml">${attrs.xhtml}</content>`,
              )}`
            : feed_stx`<title type="text">${attrs.body}</title>`;

        // Media attachments (RFC 4287 / XEP-0277) as `<link rel="enclosure">`; the
        // reader renders images/audio/video inline (see the social message template).
        const enclosures = (attrs.enclosures || []).map(
            (e) => feed_stx`<link rel="enclosure" href="${e.href}" type="${e.type || ''}" title="${e.title || ''}"/>`,
        );

        // The body's inline #hashtags, also emitted as machine-readable Atom
        // `<category>` terms (XEP-0277 § Post Categories) so aggregators/bridges
        // can read a post's tags without scraping its text.
        const categories = extractHashtags(attrs.body).map((term) => feed_stx`<category term="${term}"/>`);

        return feed_stx`
            <item id="${id}">
                <entry xmlns="${NS_ATOM}">
                    ${body}
                    ${enclosures}
                    ${categories}
                    <link rel="replies" title="comments" href="${comments_href}"/>
                    <id>${tag_id}</id>
                    <published>${published}</published>
                    <updated>${updated}</updated>
                </entry>
            </item>`;
    }

    /**
     * Repeat (repost) an existing post into this feed's node (XEP-0277 §
     * Repeating a Post). Publishes a new item attributed to the original author
     * with a `rel="via"` link, then optimistically renders it.
     * @param {import('./message').default} post - The post to repost.
     * @returns {Promise<void>}
     */
    async repostPost(post) {
        const item = this.createRepostStanza(post);
        await shared_api.pubsub.publish(this.get('jid'), this.get('node'), item, MICROBLOG_PUBLISH_OPTIONS, false);
        await this.addItems([item.tree()]);
    }

    /**
     * Construct the PubSub `<item>` that repeats (reposts) an existing post onto
     * this feed's node (XEP-0277 § Repeating a Post): a new item carrying the
     * **original** author (`<author>`) and a `rel="via"` link back to the
     * original post, with its text constructs copied. The server stamps the reposter
     * as `publisher`, so it renders attributed to the original author with a
     * "reposted by …" eyebrow
     * (see {@link parseAtomEntry} and PubSubMessage.getReposterJID).
     * @param {import('./message').default} post - The post being reposted.
     * @returns {import('strophe.js').Stanza}
     */
    createRepostStanza(post) {
        const id = getUniqueId();
        const now = new Date().toISOString();

        const author_jid = post.getAuthorJID();
        const author_name = post.getDisplayName() || author_jid;
        const node = post.get('node') || MICROBLOG_NODE;
        const item_id = post.get('id') ?? '';

        // The via link must point at the *original* post (per XEP-0277).
        // When the post is itself a repost, propagate its via href/ref
        // verbatim so the whole chain resolves to the same original.
        const via_href =
            post.get('via_href') ||
            `xmpp:${post.get('from')}?;node=${encodeURIComponent(node)};item=${encodeURIComponent(item_id)}`;
        const via_ref = post.get('via_href') ? post.get('via_ref') : post.get('atom_id');

        const title = post.get('title');
        const summary = post.get('summary');
        const content = post.get('content');

        return feed_stx`
            <item id="${id}">
                <entry xmlns="${NS_ATOM}">
                    ${author_jid ? feed_stx`<author><name>${author_name}</name><uri>xmpp:${author_jid}</uri></author>` : ''}
                    <title type="text">${title ?? ''}</title>
                    ${summary !== undefined ? feed_stx`<summary type="text">${summary}</summary>` : ''}
                    ${content !== undefined ? feed_stx`<content type="text">${content}</content>` : ''}
                    ${
                        via_ref
                            ? feed_stx`<link rel="via" href="${via_href}" ref="${via_ref}"/>`
                            : feed_stx`<link rel="via" href="${via_href}"/>`
                    }
                    <id>${buildTagId(this.get('jid'), id)}</id>
                    <published>${now}</published>
                    <updated>${now}</updated>
                </entry>
            </item>`;
    }
}

/* export default */ const microblog_feed = (PubSubFeed);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/feeds.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */






/**
 * The set of PubSub feeds the user is reading — their own microblog plus any
 * contacts'/communities' nodes. Registered as `_converse.state.pubsubfeeds`.
 *
 * @extends {Collection<PubSubFeed>}
 */
class PubSubFeeds extends Collection {
    get model() {
        return microblog_feed;
    }

    get autoSync() {
        return true;
    }

    initialize() {
        const bare_jid = shared_converse.session.get('bare_jid');
        this.storage = createStore(`converse.pubsub-feeds-${bare_jid}`);
    }

    /**
     * Build the canonical feed id for a JID + node pair.
     * @param {string} jid
     * @param {string} node
     * @returns {string}
     */
    static getFeedId(jid, node) {
        return `${jid}/${node}`;
    }

    /**
     * Get an existing feed, or create and add it.
     * @param {string} jid - The feed's JID (bare JID for the user's own PEP feed).
     * @param {string} [node=MICROBLOG_NODE]
     * @param {boolean} [create=true]
     * @returns {PubSubFeed|undefined|Promise<PubSubFeed|void>}
     */
    getFeed(jid, node = MICROBLOG_NODE, create = true) {
        const id = PubSubFeeds.getFeedId(jid, node);
        const existing = this.get(id);
        if (existing || !create) return existing;

        return this.create({ id, jid, node });
    }
}

/* export default */ const microblog_feeds = (PubSubFeeds);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/profile.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */










// One profile model per author, reused across profile-view opens: the model
// registers a long-lived listener on the (cached) vCard, so re-creating it on
// every open would leak. Cleared on logout via {@link clearProfiles}.
const profiles = new Map();

/**
 * A microblog author's profile: the person behind a feed (their avatar, display
 * name and colour), independent of whether they've posted or are a roster
 * contact. Backs the Social app's profile-view header.
 *
 * It's the same vCard/contact/colour-aware composition a {@link PubSubMessage}
 * uses, minus the post scaffolding, so the header resolves an author's avatar
 * from the vCard cache exactly like a timeline post does — non-contacts
 * included (see {@link getVCardJID}). It is *not* persisted: the feed and the
 * vCard cache are the sources of truth; this is a transient view model.
 *
 * @extends {Model}
 */
class MicroblogProfile extends model_with_vcard_ModelWithVCard(model_with_contact_ModelWithContact(color_ColorAwareModel(skeletor_esm_Model))) {
    get idAttribute() {
        return 'jid';
    }

    initialize() {
        super.initialize();
        // Resolve to an *existing* roster contact (or our own profile) so its
        // nickname wins for the display name, but never inject the author into
        // the roster — a feed's authors aren't necessarily contacts.
        this.setModelContact(this.get('jid'), { create: false });
    }

    /**
     * Get (creating + caching if necessary) the {@link MicroblogProfile} for an
     * author's bare JID.
     * @param {string} jid
     * @returns {MicroblogProfile}
     */
    static getProfile(jid) {
        const bare_jid = Strophe.getBareJidFromJid(jid);
        let profile = profiles.get(bare_jid);
        if (!profile) {
            profile = new MicroblogProfile({ jid: bare_jid });
            profiles.set(bare_jid, profile);
        }
        return profile;
    }

    /**
     * Drop every cached profile and its listeners (on logout / session clear).
     */
    static clearProfiles() {
        profiles.forEach((profile) => profile.stopListening());
        profiles.clear();
    }

    /**
     * Extract a banner image URL from a `urn:xmpp:movim-banner:0` item. Movim stores
     * the banner in the XEP-0084 avatar-metadata format *by reference*:
     * `<metadata xmlns="urn:xmpp:avatar:metadata"><info url="…"/></metadata>`.
     *
     * The URL is author-controlled and ends up as an `<img src>`, so only an
     * absolute `http(s)` URL is accepted.
     * @param {Element} [item]
     * @returns {string|null}
     */
    static parseBannerUrl(item) {
        if (!item) return null;

        const info = sizzle(`> metadata[xmlns="${Strophe.NS.AVATAR_METADATA}"] > info`, item).pop();
        const url = info?.getAttribute('url')?.trim();
        if (!url) return null;

        try {
            const { protocol } = new URL(url);
            if (protocol === 'https:' || protocol === 'http:') return url;
        } catch {
            // Not a valid absolute URL.
        }
        return null;
    }

    /**
     * The bare JID whose vCard represents this author, so the avatar resolves
     * from the vCard cache like a post's does (see {@link getVCardForModel}).
     * @returns {string|undefined}
     */
    getVCardJID() {
        return this.get('jid');
    }

    /**
     * The author's display name: the roster nickname wins (set by
     * {@link setModelContact}), then the vCard's name, and only then the bare
     * JID as a last resort.
     * @returns {string}
     */
    getDisplayName() {
        return this.get('nickname') || this.vcard?.getDisplayName?.() || this.get('jid');
    }

    /**
     * The author's full name (the vCard's `FN`), if they publish one. Kept apart
     * from {@link getNickname} so a profile can show both.
     * @returns {string|undefined}
     */
    getFullname() {
        return this.vcard?.get('fullname') || undefined;
    }

    /**
     * The author's nickname: the roster's, which the user chose for them, else
     * the one the author publishes themselves (XEP-0172, or the vCard's
     * `NICKNAME`).
     * @returns {string|undefined}
     */
    getNickname() {
        return this.get('nickname') || this.vcard?.getNickname?.() || undefined;
    }

    /**
     * Fetch the author's profile banner (a wide header image) from their
     * `urn:xmpp:movim-banner:0` PEP node and, if present, set `banner_url` so the
     * profile header renders it. Best-effort and reactive: absence, an
     * unreadable node (a presence-restricted banner, like the feed itself), or a
     * malformed item simply leaves the header banner-less.
     *
     * Deduplicated and cached for the model's lifetime: the profile model is
     * reused across profile-view opens, so this fetches at most once per author
     * per session.
     * @returns {Promise<void>}
     */
    fetchBanner() {
        this._banner_promise ??= this.#fetchBanner();
        return this._banner_promise;
    }

    async #fetchBanner() {
        try {
            const { items } = await shared_api.pubsub.items.get(this.get('jid'), MOVIM_BANNER_NODE, {
                max_items: 1,
                timeout: (/* inlined export .BANNER_FETCH_TIMEOUT */10000),
            });
            const url = MicroblogProfile.parseBannerUrl(items?.[0]);
            if (url) this.set('banner_url', url);
        } catch (e) {
            src_log.debug(`MicroblogProfile.fetchBanner: no banner for ${this.get('jid')}: ${e}`);
        }
    }
}

/* export default */ const microblog_profile = (MicroblogProfile);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/post-comment.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */




/**
 * @extends {PubSubMessage}
 */
class PostComment extends microblog_message {
    /**
     * Whether this comment is a "like": a ♥-comment (XEP-0277 convention) whose
     * entry text is exactly the heart marker. Likes ride the comments node, so a
     * single fetch of the node yields both comments and likes.
     * @returns {boolean}
     */
    isLike() {
        return this.get('title') === (/* inlined export .LIKE_MARKER */"♥");
    }

    /**
     * The `{ jid, node }` of a *dedicated* comments node this comment advertises
     * for its own replies, or null. This is the Libervia ActivityPub-gateway model
     * (a comments node per comment).
     * @returns {{ jid: string, node: string }|null}
     */
    getRepliesRef() {
        const node = this.get('comments_node');
        if (!node) return null;

        const author = this.getAuthorJID();
        const jid = this.get('comments_jid') || (author ? Strophe.getBareJidFromJid(author) : undefined);
        return jid ? { jid, node } : null;
    }
}

/* export default */ const post_comment = (PostComment);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/post-comments.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */



/**
 * The collection of {@link PostComment}s in one post's comment thread (a
 * {@link CommentFeed}). Identical to {@link PubSubMessages} but for its element
 * type, so a thread's items carry comment-only behaviour (`isLike`) that timeline
 * posts don't.
 *
 * @extends {PubSubMessages}
 */
class PostComments extends microblog_messages {
    get model() {
        return post_comment;
    }
}

/* export default */ const post_comments = (PostComments);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/comment-feed.js










const { stx: comment_feed_stx, Strophe: comment_feed_Strophe } = api_public.env;

/**
 * A single post's comments thread (XEP-0277 § Comments): a {@link PubSubFeed}
 * over that post's comments node. Kept in a collection separate from the
 * timeline feeds ({@link CommentFeeds}) so comments never surface in the
 * aggregated feed.
 *
 * @extends {PubSubFeed}
 */
class CommentFeed extends microblog_feed {
    /**
     * A thread's items are {@link PostComment}s (they carry `isLike`), not the
     * plain {@link PubSubMessage}s a timeline feed holds.
     * @returns {typeof import('./messages').default}
     */
    get messagesCollectionClass() {
        return post_comments;
    }

    /**
     * Fetch this thread and make it complete enough to render as a tree. Drives
     * the inherited {@link PubSubFeed.fetchPosts} paging (RSM where the comments
     * service supports it, else the newest-`POSTS_MAX_WITHOUT_RSM` window with
     * `history_complete`), then {@link resolveOrphans} to reconnect a reply whose
     * parent fell outside the window on a non-RSM node. The node may not exist yet
     * (an empty thread), which `fetchPosts` records as `fetch_error` rather than
     * throwing.
     *
     * Marks the thread as fetching for the duration so a concurrent
     * {@link CommentFeeds.pruneThreads} can't evict it mid-fetch.
     * @returns {Promise<void>}
     */
    async fetchComments() {
        this._fetching = true;
        try {
            await this.fetchPosts();
            await this.resolveOrphans();
        } finally {
            this._fetching = false;
        }
    }

    /**
     * Reconnect orphans (replies whose in-thread parent isn't loaded) by fetching
     * the missing ancestors by item id, walking up the chain until each branch
     * reaches a loaded root or a retracted (not-found) ancestor.
     *
     * **Non-RSM only.** On an RSM-capable node normal "load older" paging brings
     * parents in *in order*, so a targeted id-fetch is unnecessary and harmful: an
     * out-of-order item carries no `rsm_cursor` and lands at an arbitrary time
     * position, polluting the anchors and gap detection `fetchOlder` relies on. So
     * this early-returns when the node paged via RSM and lets paging adopt orphans.
     *
     * A parent that comes back not-found is recorded in an in-memory absent-set so
     * it isn't re-requested; its orphan stays kept-but-hidden (see buildCommentTree).
     * @returns {Promise<void>}
     */
    async resolveOrphans() {
        if (this.get('supports_rsm')) return; // paging adopts orphans in order

        const { jid, node } = this.attrs;
        this._absent_parents ||= new Set();
        for (let round = 0; round < (/* inlined export .ORPHAN_RESOLVE_ROUNDS */5); round++) {
            await this.messages.hydrated;
            const present = new Set(this.messages.models.map((m) => m.get('id')));
            const missing = new Set();
            for (const m of this.messages.models) {
                const parent = m.get('in_reply_to');
                if (!parent || present.has(parent) || this._absent_parents.has(parent)) continue;
                // Only chase a same-thread (nesting) pointer; a cross-node pointer
                // is a Movim-style post-reply, not a missing thread ancestor.
                const p_node = m.get('in_reply_to_node');
                const p_jid = m.get('in_reply_to_jid');
                if ((p_node && p_node !== node) || (p_jid && p_jid !== jid)) continue;
                missing.add(parent);
            }
            if (!missing.size) return;

            let result;
            try {
                result = await shared_api.pubsub.items.get(jid, node, { item_ids: [...missing] });
            } catch (e) {
                src_log.debug(`CommentFeed.resolveOrphans: item fetch failed for ${node} at ${jid}: ${e}`);
                return;
            }
            const fetched = new Set((result.items ?? []).map((el) => el.getAttribute('id')));
            // A requested id the server didn't return is retracted: stop asking.
            for (const id of missing) if (!fetched.has(id)) this._absent_parents.add(id);
            if (!result.items?.length) return;
            await this.addItems(result.items);
            // Loop to resolve any grandparents the just-fetched items now reference.
        }
    }

    /**
     * Whether a {@link fetchComments} is currently in flight. Consulted by
     * {@link CommentFeeds.pruneThreads} to exempt an actively-fetching thread
     * from eviction.
     * @returns {boolean}
     */
    isFetching() {
        return !!this._fetching;
    }

    /**
     * This thread's items as {@link PostComment}s (the collection's element
     * type; the base `messages` is typed as the timeline {@link PubSubMessage}).
     * @returns {import('./post-comment').default[]}
     */
    get comments() {
        return /** @type {import('./post-comment').default[]} */ (this.messages.models);
    }

    /**
     * This thread's real comments (every item except ♥ likes). Excludes any
     * "load older" placeholders the inherited paging seeds into the collection.
     * @returns {import('./post-comment').default[]}
     */
    getComments() {
        return this.comments.filter((m) => typeof m.isLike === 'function' && !m.isLike());
    }

    /**
     * The ♥ likes authored by me that target `parent_id` (a comment's item id),
     * or the *post* when `parent_id` is omitted. There should be at most one, but
     * duplicates can accrue (e.g. liking from a second device);
     * {@link _converse.api.microblog.unlike} retracts all of them. Matches on the
     * raw `in_reply_to` since our own likes always carry the target's item id.
     * @param {string} [parent_id] - A comment's item id; omit for the post.
     * @returns {import('./post-comment').default[]}
     */
    getMyLikes(parent_id) {
        return this.comments.filter(
            (m) =>
                typeof m.isLike === 'function' &&
                m.isLike() &&
                m.get('is_mine') &&
                (parent_id ? m.get('in_reply_to') === parent_id : !m.get('in_reply_to')),
        );
    }

    /**
     * Denormalised counts for one target in this thread: the **post** (omit
     * `parent_id`) or a specific **comment** (its item id). Written onto the post
     * by {@link syncCommentSummary} and onto each comment by
     * {@link syncCommentCounts}, so the timeline/thread can show counts without
     * re-walking the node.
     *
     * A ♥ is attributed to the item it targets, so a like on a comment no longer
     * inflates the post's like count; likes are counted by **distinct liker** (a
     * person liking from two devices is one like). See {@link computeThreadCounts}.
     * @param {string} [parent_id] - A comment's item id; omit for the post.
     * @returns {{ comment_count?: number, reply_count?: number, like_count: number, liked_by_me: boolean, my_like_id: (string|undefined) }}
     */
    summarize(parent_id) {
        const { post, byComment } = computeThreadCounts(this.comments);
        if (!parent_id) return post;
        return byComment.get(parent_id) ?? { reply_count: 0, like_count: 0, liked_by_me: false, my_like_id: undefined };
    }

    /**
     * Publish a comment to this thread's node and optimistically render it.
     * @param {import('./types').PubSubCommentAttrs} attrs
     * @returns {Promise<import('./message').default|undefined>}
     */
    async publishComment(attrs) {
        const id = attrs.id || getUniqueId();
        const item = this.createCommentStanza({ ...attrs, id });
        // Non-strict: on someone else's PEP comments node we can't reconfigure
        // it, but if the author created it publish_model=open our publish lands.
        await shared_api.pubsub.publish(this.get('jid'), this.get('node'), item, COMMENTS_PUBLISH_OPTIONS, false);

        const [added] = await this.addItems([item.tree()]);
        // The server stamps `publisher` on the echo; set it locally too so our
        // optimistic copy is recognised as ours (is_mine) before any echo.
        added?.set({ publisher: attrs.author_jid });
        return added;
    }

    /**
     * Construct the PubSub `<item>` for a new comment (XEP-0277 § Adding a Comment).
     * an Atom entry carrying the commenter's `<author>` and text.
     * The `<author><uri>` lets readers run the XEP-0277 § Comment Author check
     * (see {@link PubSubMessage.getAuthorMismatch}).
     * @param {import('./types').PubSubCommentAttrs} attrs
     * @returns {import('strophe.js').Stanza}
     */
    createCommentStanza(attrs) {
        const id = attrs.id || getUniqueId();
        const now = attrs.published || new Date().toISOString();
        const tag_id = buildTagId(this.get('jid'), id);

        const parent = attrs.in_reply_to;
        // The pointer's href locates the parent item in *this* comments node.
        const reply_href = parent
            ? `xmpp:${this.get('jid')}?;node=${encodeURIComponent(this.get('node'))};item=${encodeURIComponent(parent)}`
            : null;
        const reply_el = !parent
            ? ''
            : attrs.in_reply_to_ref
              ? comment_feed_stx`<thr:in-reply-to xmlns:thr="${NS_THREAD}" ref="${attrs.in_reply_to_ref}" href="${reply_href}"/>`
              : comment_feed_stx`<thr:in-reply-to xmlns:thr="${NS_THREAD}" href="${reply_href}"/>`;

        return comment_feed_stx`
            <item id="${id}">
                <entry xmlns="${comment_feed_Strophe.NS.ATOM}">
                    <author>
                        <name>${attrs.author_name || attrs.author_jid}</name>
                        <uri>xmpp:${attrs.author_jid}</uri>
                    </author>
                    <title type="text">${attrs.body}</title>
                    ${reply_el}
                    <id>${tag_id}</id>
                    <published>${now}</published>
                    <updated>${now}</updated>
                </entry>
            </item>`;
    }
}

/* export default */ const microblog_comment_feed = (CommentFeed);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/comment-feeds.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */







/**
 * @extends {PubSubFeeds}
 */
class CommentFeeds extends microblog_feeds {
    get model() {
        return microblog_comment_feed;
    }

    initialize() {
        const bare_jid = shared_converse.session.get('bare_jid');
        this.storage = createStore(`converse.pubsub-comment-feeds-${bare_jid}`);
    }

    /**
     * Get an existing comment thread (touching its recency on explicit access),
     * or create + persist one. A `create=false` lookup (e.g. PEP routing) neither
     * creates a thread nor bumps recency.
     * @param {string} jid - The comments service JID.
     * @param {string} node - The comments node.
     * @param {boolean} [create=true]
     * @returns {CommentFeed|undefined}
     */
    getFeed(jid, node, create = true) {
        const id = microblog_feeds.getFeedId(jid, node);
        const existing = /** @type {CommentFeed|undefined} */ (this.get(id));
        if (existing) {
            if (create) existing.save({ last_viewed: Date.now() });
            return existing;
        }
        if (!create) return undefined;
        const feed = /** @type {CommentFeed} */ (this.create({ id, jid, node, last_viewed: Date.now() }));
        this.pruneThreads();
        return feed;
    }

    /**
     * Evict threads once the collection exceeds `social_max_comment_threads`,
     * destroying each evicted thread and its store. Empty threads (they cache no
     * comments, so re-fetching is cheap) are evicted before non-empty ones, which
     * hold real content; within each group the least-recently-viewed goes first.
     * Pinned threads (own posts, kept live) and threads with a fetch in flight
     * are never evicted.
     */
    pruneThreads() {
        const cap = shared_api.settings.get('social_max_comment_threads');
        if (!cap || typeof cap !== 'number' || this.length <= cap) return;
        // A just-created thread pending its first fetch looks empty but is the
        // newest, so it sorts last within the empty group and survives; one whose
        // fetch has actually started is exempt outright (isFetching).
        const evictable = this.filter((f) => !f.get('pinned') && !f.isFetching()).sort((a, b) => {
            const a_empty = a.messages.length === 0;
            const b_empty = b.messages.length === 0;
            if (a_empty !== b_empty) return a_empty ? -1 : 1; // empties first
            return (a.get('last_viewed') || 0) - (b.get('last_viewed') || 0); // then oldest
        });
        evictable.slice(0, this.length - cap).forEach((f) => f.close());
    }

    /**
     * Bound the number of *pinned* threads (our own posts', subscribed for live
     * comment/like counts) to `social_max_pinned_threads`: past the cap, the
     * least-recently-pinned are unsubscribed and evicted so server-side
     * subscriptions don't accumulate without limit. A thread mid-fetch is
     * exempt; the most-recently-pinned always survive.
     * @returns {Promise<void>}
     */
    async enforcePinnedCap() {
        const cap = shared_api.settings.get('social_max_pinned_threads');
        if (!cap || typeof cap !== 'number') return;
        const pinned = this.filter((f) => f.get('pinned') && !f.isFetching());
        if (pinned.length <= cap) return;
        const excess = pinned
            .sort((a, b) => (a.get('last_viewed') || 0) - (b.get('last_viewed') || 0))
            .slice(0, pinned.length - cap);
        for (const feed of excess) {
            try {
                await shared_api.pubsub.unsubscribe(feed.get('jid'), feed.get('node'));
            } catch (e) {
                src_log.debug(`enforcePinnedCap: unsubscribe from ${feed.get('node')} failed (non-fatal): ${e}`);
            }
            await feed.close();
        }
    }
}

/* export default */ const comment_feeds = (CommentFeeds);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/followable.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */




/**
 * One cached verdict on whether a contact has a followable microblog feed,
 * learned by probing their `urn:xmpp:microblog:0` node during a manual "find
 * people to follow" sweep.
 * @extends {Model}
 */
class FollowableContact extends skeletor_esm_Model {
    get idAttribute() {
        return 'jid';
    }

    defaults() {
        return {
            /** Whether the contact has a readable microblog feed with content. */
            followable: false,
            /** Whether the user dismissed this suggestion (snooze-until-new). */
            snoozed: false,
            /** ISO time of the newest post seen, for preview/sort (optional). */
            latest: null,
        };
    }
}

/**
 * The per-account, persisted cache of microblog-followability verdicts, keyed by
 * bare JID. Registered as `_converse.state.followablecache`. It lets a manual
 * sweep avoid re-probing contacts it already checked, and backs the recurring
 * "Accounts you might like to follow" widget (including its snooze state).
 *
 * Mirrors the {@link import('./feeds.js').default} persistence pattern.
 * @extends {Collection<FollowableContact>}
 */
class FollowableCache extends Collection {
    get model() {
        return FollowableContact;
    }

    get autoSync() {
        return true;
    }

    initialize() {
        const bare_jid = shared_converse.session.get('bare_jid');
        this.storage = createStore(`converse.microblog-followable-${bare_jid}`);
    }

    /**
     * Whether this JID has been snoozed by the user.
     * @param {string} jid
     * @returns {boolean}
     */
    isSnoozed(jid) {
        return !!this.get(jid)?.get('snoozed');
    }

    /**
     * Upsert a probe verdict.
     * @param {string} jid
     * @param {{ followable: boolean, latest?: string|null }} verdict
     */
    record(jid, { followable, latest = null }) {
        const attrs = { followable, latest };
        const entry = this.get(jid);
        if (entry) entry.save(attrs);
        else this.create({ jid, ...attrs });
    }

    /**
     * The bare JIDs known followable and not snoozed.
     * @returns {string[]}
     */
    candidates() {
        return this.filter((c) => c.get('followable') && !c.get('snoozed')).map((c) => c.get('jid'));
    }

    /**
     * Snooze the given JIDs so they stop being suggested until a *new* candidate
     * is discovered. Creates a cache entry for JIDs not probed yet (e.g. an
     * online-caps hit), so the snooze sticks.
     * @param {string[]} jids
     */
    snooze(jids) {
        jids.forEach((jid) => {
            const entry = this.get(jid);
            if (entry) entry.save({ snoozed: true });
            else this.create({ jid, snoozed: true });
        });
    }
}

/* export default */ const microblog_followable = (FollowableCache);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/following.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 *
 * XEP-0330 (Pubsub Subscription): a portable, server-side list of the PubSub
 * nodes the user follows, published to their own `urn:xmpp:pubsub:subscription`
 * PEP node. Unlike `+notify` caps (an ephemeral, presence-derived delivery
 * filter), this list is queryable, countable, and syncs across a user's devices
 * and clients.
 */





/**
 * One entry in the durable XEP-0330 follow list: a PubSub node the user follows
 * (a contact's `urn:xmpp:microblog:0`, or any `server`/`node` pair).
 * @extends {Model}
 */
class FollowedFeed extends skeletor_esm_Model {
    get idAttribute() {
        return 'id';
    }

    defaults() {
        return { node: MICROBLOG_NODE };
    }
}

/**
 * A local, persisted mirror of the durable XEP-0330 follow list.
 * The source of truth for whom the user follows. Registered as `_converse.state.following`.
 *
 * Consulted by {@link _converse.api.microblog.isFollowing}, so "do we follow this
 * author" is decoupled from "do we happen to have a feed loaded for them" (a
 * browse-only profile feed exists without a follow). Kept in sync two ways:
 * {@link Following#track}/{@link Following#untrack} on this device's own
 * follow/unfollow, and {@link Following#reconcile}, which reconciles the whole
 * mirror against the server list read on `initFollowing` (catching
 * follows/unfollows made on another device or client, e.g. Movim).
 *
 * Mirrors the {@link import('./feeds.js').default} persistence pattern.
 * @extends {Collection<FollowedFeed>}
 */
class Following extends Collection {
    get model() {
        return FollowedFeed;
    }

    get autoSync() {
        return true;
    }

    initialize() {
        const bare_jid = shared_converse.session.get('bare_jid');
        this.storage = createStore(`converse.microblog-following-${bare_jid}`);
    }

    /**
     * The canonical entry id for a follow: `server/node`, matching a feed's id.
     * @param {string} server
     * @param {string} node
     * @returns {string}
     */
    static getId(server, node) {
        return `${server}/${node}`;
    }

    /**
     * Whether the given node is in the follow list.
     * @param {string} server
     * @param {string} [node=MICROBLOG_NODE]
     * @returns {boolean}
     */
    isFollowing(server, node = MICROBLOG_NODE) {
        return !!this.get(Following.getId(server, node));
    }

    /**
     * Record (add or update the title of) a follow.
     * @param {{ server: string, node?: string, title?: string }} attrs
     * @returns {FollowedFeed|Promise<FollowedFeed|void>}
     */
    track({ server, node = MICROBLOG_NODE, title }) {
        const id = Following.getId(server, node);
        const entry = this.get(id);
        if (entry) {
            if (title !== undefined && title !== entry.get('title')) entry.save({ title });
            return entry;
        }
        return this.create({ id, server, node, title });
    }

    /**
     * Drop a follow from the mirror.
     * @param {string} server
     * @param {string} [node=MICROBLOG_NODE]
     */
    untrack(server, node = MICROBLOG_NODE) {
        this.get(Following.getId(server, node))?.destroy();
    }

    /**
     * Reconcile the mirror against the authoritative XEP-0330 list read from the
     * server: upsert every entry present and drop any local entry no longer in the list.
     * @param {Array<{ server: string, node: string, title?: string }>} entries
     * @returns {Promise<void>}
     */
    async reconcile(entries) {
        await this.hydrated;
        const seen = new Set();
        for (const entry of entries) {
            this.track(entry);
            seen.add(Following.getId(entry.server, entry.node));
        }
        for (const model of [...this.models]) {
            if (!seen.has(model.id)) model.destroy();
        }
    }
}

/* export default */ const microblog_following = (Following);

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/utils/following.js







const { stx: following_stx } = api_public.env;

/**
 * Compute the XEP-0330 item id for a subscription: the lowercase-hex SHA-1 of
 * `server + '<' + node + '<' + own-bare-jid`.
 * @param {string} server - The followed entity's pubsub service.
 * @param {string} node - The followed node.
 * @param {string} jid - The follower's bare JID.
 * @returns {Promise<string>}
 */
async function computeFollowItemId(server, node, jid) {
    const ab = await crypto.subtle.digest('SHA-1', stringToArrayBuffer(`${server}<${node}<${jid}`));
    return arrayBufferToHex(ab);
}

/**
 * Build a XEP-0330 follow-list `<item>`.
 * @param {{ server: string, node: string, id: string, title?: string }} attrs
 * @returns {import('strophe.js').Stanza}
 */
function buildFollowItem({ server, node, id, title }) {
    return following_stx`
        <item id="${id}">
            <subscription xmlns="${NS_SUBSCRIPTION}" server="${server}" node="${node}"
                >${title ? following_stx`<title>${title}</title>` : ''}</subscription>
        </item>`;
}

/**
 * Parse a XEP-0330 follow-list `<item>` into a plain object.
 * @param {Element} item
 * @returns {{ server: string, node: string, title?: string }|null}
 */
function parseFollowItem(item) {
    const sub = sizzle(`> subscription[xmlns="${NS_SUBSCRIPTION}"]`, item).pop();
    if (!sub) return null;
    return {
        server: sub.getAttribute('server'),
        node: sub.getAttribute('node'),
        title: sizzle('> title', sub).pop()?.textContent?.trim() || undefined,
    };
}

/**
 * Publish (add or update) a follow to the durable XEP-0330 list on our own PEP
 * service.
 * @param {string} server - The followed entity's pubsub service (a contact's bare JID for PEP).
 * @param {string} node - The followed node (e.g. `urn:xmpp:microblog:0`).
 * @param {string} [title] - A human-readable label.
 * @returns {Promise<void>}
 */
async function publishFollow(server, node, title) {
    const bare_jid = shared_converse.session.get('bare_jid');
    const id = await computeFollowItemId(server, node, bare_jid);
    await shared_api.pubsub.publish(
        null,
        FOLLOWING_NODE,
        buildFollowItem({ server, node, id, title }),
        FOLLOWING_PUBLISH_OPTIONS,
    );
}

/**
 * Retract a follow from the XEP-0330 list.
 * @param {string} server
 * @param {string} node
 * @returns {Promise<void>}
 */
async function retractFollow(server, node) {
    const bare_jid = shared_converse.session.get('bare_jid');
    const id = await computeFollowItemId(server, node, bare_jid);
    await shared_api.pubsub.retract(null, FOLLOWING_NODE, id);
}

/**
 * Read a durable XEP-0330 follow list. Defaults to our own PEP service; pass a
 * JID to read a contact's list instead (their node is `access_model=presence`,
 * so this succeeds for contacts with presence access and is refused otherwise).
 * @param {string} [jid=null] - Whose list to read; null/own for our own.
 * @returns {Promise<Array<{ server: string, node: string, title?: string }>>}
 */
async function readFollowing(jid = null) {
    const { items } = await shared_api.pubsub.items.get(jid, FOLLOWING_NODE);
    const parsed = items.map(parseFollowItem).filter(Boolean);
    // A follow is identified by its (server, node) pair (that's what the XEP-0330
    // item id hashes). Collapse duplicate items for the same pair, which a client
    // can accumulate by re-following a feed over time, so each appears once.
    const seen = new Set();
    return parsed.filter((f) => {
        const key = `${f.server} ${f.node}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/api.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */

















/**
 * Probe a JID's PubSub node to learn whether it holds a followable feed. Resolves
 * to a verdict, used by the followable cache and by {@link followByAddress}. A
 * node that returns at least one item is followable (and yields a preview
 * timestamp); an empty node, a missing node, or an access error is not.
 * @param {string} jid - The feed's JID (a contact's bare JID, or a pubsub service).
 * @param {string} [node=MICROBLOG_NODE] - The node to probe.
 * @returns {Promise<{ followable: boolean, latest?: string|null }>}
 */
async function probeFeed(jid, node = MICROBLOG_NODE) {
    try {
        const result = await shared_api.pubsub.items.get(jid, node, {
            max_items: 1,
            timeout: (/* inlined export .FOLLOWABLE_PROBE_TIMEOUT */10000),
        });
        const item = result?.items?.[0];
        if (!item) return { followable: false };
        let latest = null;
        try {
            latest = parseAtomEntry(item, { from: jid, node })?.time ?? null;
        } catch (e) {
            // The preview timestamp is best-effort; ignore a parse failure.
            src_log.debug(`probeFeed: could not parse latest item for ${jid} (${node}): ${e}`);
        }
        return { followable: true, latest };
    } catch (e) {
        src_log.debug(`probeFeed: ${jid} has no readable feed at ${node}: ${e}`);
        return { followable: false };
    }
}

/**
 * Fetch one pubsub node's disco#info and distil the XEP-0060 § 5.4 metadata form
 * into the fields the browse UI needs. Best-effort: a node that doesn't answer,
 * or carries no metadata form, resolves to `is_feed: false`.
 * @param {string} jid - The pubsub service JID.
 * @param {string} node - The node id to inspect.
 * @returns {Promise<Partial<import('./types').BrowsableFeed>>}
 */
async function probeNodeMeta(jid, node) {
    try {
        const stanza = await shared_api.disco.info(jid, node, { timeout: (/* inlined export .FOLLOWABLE_PROBE_TIMEOUT */10000) });
        const field = /** @param {string} name */ (name) =>
            sizzle(`x[type="result"] field[var="${name}"] value`, stanza)[0]?.textContent || undefined;
        const node_type = sizzle(`identity[category="pubsub"]`, stanza)[0]?.getAttribute('type') || undefined;
        const type = field('pubsub#type');
        const subs = field('pubsub#num_subscribers');
        const num_subscribers = subs !== undefined && subs !== '' ? Number(subs) : undefined;
        return {
            title: field('pubsub#title'),
            description: field('pubsub#description'),
            type,
            node_type,
            num_subscribers,
            is_feed: type === NS_ATOM || type === SOCIAL_FEED_FEATURE || type === GALLERY_TYPE,
        };
    } catch (e) {
        src_log.debug(`browseFeeds: could not read node meta for ${jid} (${node}): ${e}`);
        return { is_feed: false };
    }
}

/**
 * Resolve what a like/unlike targets: a post or a comment.
 *
 * A like is always on the post's comments node, the difference is what it points at
 * and where the denormalised like state lives.
 *
 *  - a post → the like is a post-level item (no `in_reply_to`)
 *      Its counts live on the post, reconciled by {@link syncCommentSummary}.
 *  - a comment (a {@link PostComment} with `isLike`) → the lie carries `in_reply_to`
 *      Its counts live on the comment, reconciled by {@link syncCommentCounts}.
 * @param {import('./message').default} target - A post or a comment.
 * @returns {Promise<import('./types').LikeTarget>}
 */
async function resolveLikeTarget(target) {
    if (typeof (/** @type {import('./post-comment').default} */ (target).isLike) === 'function') {
        const feed = target.collection?.feed;
        return { feed, model: target, parent_id: target.get('id'), reconcile: () => syncCommentCounts(feed) };
    }
    const feed = await shared_api.microblog.comments.feed(target);
    return { feed, model: target, parent_id: undefined, reconcile: () => syncCommentSummary(target, feed) };
}

/* export default */ const microblog_api = ({
    /**
     * The "microblog" namespace groups methods relevant to XEP-0277
     * Microblogging.
     *
     * @namespace _converse.api.microblog
     * @memberOf _converse.api
     */
    microblog: {
        feeds: {
            /**
             * Get (creating if necessary) a microblog feed for a JID + node.
             * @method _converse.api.microblog.feeds.get
             * @param {string} [jid] - The feed's JID. Defaults to the logged-in
             *      user's bare JID (their own microblog).
             * @param {string} [node='urn:xmpp:microblog:0']
             * @param {boolean} [create=true]
             * @returns {Promise<import('./feed').default|undefined>}
             */
            async get(jid, node = MICROBLOG_NODE, create = true) {
                await shared_api.waitUntil('pubsubFeedsInitialized');
                const bare_jid = shared_converse.session.get('bare_jid');
                return shared_converse.state.pubsubfeeds.getFeed(jid || bare_jid, node, create);
            },

            /**
             * Get the logged-in user's own microblog feed.
             * @method _converse.api.microblog.feeds.own
             * @returns {Promise<import('./feed').default>}
             */
            async own() {
                return await shared_api.microblog.feeds.get();
            },

            /**
             * The detached browse feeds cached this session. Feeds the user
             * looked at (e.g. via an author's profile) without following them.
             * @method _converse.api.microblog.feeds.browsed
             * @returns {import('./feed').default[]}
             */
            browsed() {
                return microblog_feed.browseFeeds();
            },
        },

        profile: {
            /**
             * Get (creating + caching if necessary) the profile model for an
             * author's JID. The person behind a feed (avatar, display name,
             * colour), resolved from the vCard cache like a post's author is.
             * Backs the Social app's profile view and works for non-contacts too.
             * @method _converse.api.microblog.profile.get
             * @param {string} jid - The author's (bare) JID.
             * @returns {import('./profile').default}
             */
            get(jid) {
                return microblog_profile.getProfile(jid);
            },

            /**
             * Get a feed suitable for an author's profile view.
             *
             * When we follow the author (or it's our own), this is the *shared* feed
             * from {@link _converse.state.pubsubfeeds}. When we don't follow them,
             * it's a **detached**, browse-only feed that is deliberately *not* added
             * to that collection (it stays in-memory only), but cached for the
             * session (see {@link PubSubFeed.getBrowseFeed}) so re-visits are warm.
             * Either way the caller should {@link PubSubFeed.fetchPosts} to backfill it.
             * @method _converse.api.microblog.profile.feed
             * @param {string} jid - The author's (bare) JID.
             * @param {string} [node=MICROBLOG_NODE]
             * @returns {Promise<import('./feed').default>}
             */
            async getFeed(jid, node = MICROBLOG_NODE) {
                await shared_api.waitUntil('pubsubFeedsInitialized');
                const bare_jid = shared_converse.session.get('bare_jid');
                const shared = shared_converse.state.pubsubfeeds?.getFeed(jid || bare_jid, node, false);
                if (shared) {
                    // A follow may have superseded a cached browse feed; drop the stale copy.
                    microblog_feed.dropBrowseFeed(jid || bare_jid, node);
                    return shared;
                }
                return microblog_feed.getBrowseFeed(jid || bare_jid, node);
            },
        },

        /**
         * Whether a JID can be followed, i.e. it advertises a XEP-0472 social
         * feed (`urn:xmpp:pubsub-social-feed:1`).
         *
         * A social feed is advertised in a client's per-resource XEP-0115 entity
         * caps, not on the bare-JID account disco#info, so we resolve the feature
         * against the contact's resources (full JIDs).
         *
         * @method _converse.api.microblog.canFollow
         * @param {string} jid
         * @returns {Promise<boolean>}
         */
        async canFollow(jid) {
            const bare_jid = shared_converse.session.get('bare_jid');
            const contact_jid = Strophe.getBareJidFromJid(jid);
            if (contact_jid === bare_jid) return false;

            const full_jids = Strophe.getResourceFromJid(jid)
                ? [jid]
                : (shared_converse.state.presences
                      ?.get(contact_jid)
                      ?.resources?.map((r) => `${contact_jid}/${r.get('name')}`) ?? []);

            for (const full_jid of full_jids) {
                if (await shared_api.disco.supports(SOCIAL_FEED_FEATURE, full_jid)) return true;
            }
            return false;
        },

        /**
         * Discover roster contacts that can be followed but aren't yet — the
         * union of two sources, minus contacts already followed or snoozed:
         *  1. the cheap online path: contacts whose live resources advertise a
         *     XEP-0472 social feed ({@link canFollow}); and
         *  2. verdicts learned by the manual {@link scanFollowable} sweep, read
         *     from the persistent followable cache (covers offline contacts).
         *
         * No network is used here: (1) reads cached entity caps and (2) reads
         * the local cache, so it's safe to recompute on roster/presence/cache
         * changes. The explicit sweep is what issues the probes.
         * @method _converse.api.microblog.discoverFollowable
         * @returns {Promise<string[]>} The bare JIDs of followable contacts.
         */
        async discoverFollowable() {
            const roster = shared_converse.state.roster;
            if (!roster) return [];
            const cache = shared_converse.state.followablecache;

            const candidates = roster.filter((c) => !c.isUnsaved() && !c.get('requesting'));
            const online = await Promise.all(
                candidates.map(async (contact) => {
                    const jid = contact.get('jid');
                    if (shared_api.microblog.isFollowing(jid)) return null;
                    return (await shared_api.microblog.canFollow(jid)) ? jid : null;
                }),
            );

            const cached = cache?.candidates() ?? [];
            const jids = [...new Set([...online.filter(Boolean), ...cached])];
            return jids.filter((jid) => !shared_api.microblog.isFollowing(jid) && !cache?.isSnoozed(jid));
        },

        /**
         * Probe roster contacts' microblog nodes to discover followable feeds,
         * including OFFLINE contacts that {@link discoverFollowable}'s cheap path
         * can't see (it only reads online resources' caps). An explicit,
         * user-initiated sweep: it targets every saved, not-yet-followed contact
         * without a fresh cached verdict, probes each `urn:xmpp:microblog:0` node
         * with bounded concurrency, and caches each verdict so re-scans are cheap.
         * (A contact whose node isn't readable simply caches as not-followable.)
         *
         * @method _converse.api.microblog.scanFollowable
         * @param {object} [opts]
         * @param {(p: {scanned: number, total: number, found: number}) => void} [opts.onProgress]
         * @param {AbortSignal} [opts.signal] - Abort to stop launching further probes.
         * @returns {Promise<string[]>} The bare JIDs found followable in this sweep.
         */
        async scanFollowable({ onProgress, signal } = {}) {
            const roster = shared_converse.state.roster;
            const cache = shared_converse.state.followablecache;
            if (!roster) return [];

            // Re-probe every saved contact we don't already follow. The sweep is
            // an explicit user action, so it deliberately re-checks contacts seen
            // before — a previously-empty node may now have posts, and the user
            // expects the button to actually do something each time.
            const targets = roster
                .filter((c) => !c.isUnsaved() && !c.get('requesting'))
                .map((c) => c.get('jid'))
                .filter((jid) => !shared_api.microblog.isFollowing(jid));

            const found = [];
            const total = targets.length;
            let scanned = 0;
            onProgress?.({ scanned, total, found: 0 });

            // A streaming worker pool (rather than fixed batches): each worker pulls
            // the next contact as soon as its probe settles, so one slow/timing-out
            // probe never holds up the others. Probes carry a short timeout, so a
            // dead server frees its worker in seconds, not the default 60s.
            const queue = [...targets];
            const worker = async () => {
                while (queue.length && !signal?.aborted) {
                    const jid = queue.shift();
                    const verdict = await probeFeed(jid);
                    cache?.record(jid, verdict);
                    if (verdict.followable) found.push(jid);
                    scanned++;
                    onProgress?.({ scanned, total, found: found.length });
                }
            };
            const pool = Array.from({ length: Math.min((/* inlined export .FOLLOWABLE_SCAN_CONCURRENCY */10), total) }, () => worker());
            await Promise.all(pool);
            return found;
        },

        /**
         * Follow a a social feed and record it in the durable XEP-0330 list.
         * Subscribe for live delivery (XEP-0472) and create + backfill the feed.
         *
         * @method _converse.api.microblog.follow
         * @param {string} jid - The followed entity's JID (a contact's bare JID).
         * @param {object} [options]
         * @param {string} [options.title] - A human-readable label for the follow.
         * @param {string} [options.node=MICROBLOG_NODE] - The node to follow.
         * @returns {Promise<import('./feed').default|undefined>}
         */
        async follow(jid, { title, node = MICROBLOG_NODE } = {}) {
            jid = Strophe.getBareJidFromJid(jid);
            await publishFollow(jid, node, title);
            shared_converse.state.following?.track({ server: jid, node, title });
            try {
                await shared_api.pubsub.subscribe(jid, node);
            } catch (e) {
                // Explicit subscription is the live-delivery path. If a server
                // doesn't honour cross-account PEP subscriptions this is
                // non-fatal: the XEP-0330 list is the durable record of the
                // follow, and the items.get backfill below still populates the feed.
                src_log.debug(`api.microblog.follow: explicit subscribe to ${jid} failed (non-fatal): ${e}`);
            }
            const feed = await shared_api.microblog.feeds.get(jid, node, true);
            microblog_feed.dropBrowseFeed(jid, node);
            feed?.fetchPosts();
            return feed;
        },

        /**
         * Follow several feeds in sequence (see {@link follow}). Sequential
         * rather than parallel so we don't fire N publish+subscribe+backfill
         * bursts at the server at once. Never rejects: each entry's outcome is
         * reported in the returned array, so one failure doesn't abort the rest.
         *
         * @method _converse.api.microblog.followMany
         * @param {string[]} jids - The bare JIDs to follow.
         * @returns {Promise<Array<{ jid: string, ok: boolean, error?: Error }>>}
         */
        async followMany(jids) {
            const results = [];
            for (const jid of jids ?? []) {
                try {
                    await shared_api.microblog.follow(jid);
                    results.push({ jid, ok: true });
                } catch (error) {
                    src_log.error(error);
                    results.push({ jid, ok: false, error });
                }
            }
            return results;
        },

        /**
         * Parse a feed address into a `{ jid, node }` pair, or null if it isn't a
         * usable address. Accepts a bare JID (a user or a pubsub service, which
         * defaults to the PEP microblog node) or an XMPP pubsub URI carrying an
         * explicit node (`xmpp:pubsub.example.org?;node=news`). Exposed so the
         * "Follow a feed" UI can validate and preview input as it's typed.
         * @method _converse.api.microblog.parseFeedAddress
         * @param {string} address
         * @returns {{ jid: string, node: string }|null}
         */
        parseFeedAddress(address) {
            return parseFeedAddress(address);
        },

        /**
         * Follow a feed given a free-form address (a bare JID or an XMPP pubsub
         * node URI), probing it first so an unreadable or missing node fails loudly
         * rather than adding an empty feed. This is the entry point for following
         * feeds that aren't roster contacts, e.g. a community or news node on a
         * pubsub service.
         *
         * @method _converse.api.microblog.followByAddress
         * @param {string} address - A bare JID or `xmpp:` pubsub URI.
         * @param {object} [options]
         * @param {string} [options.node] - Overrides the node parsed from the address.
         * @param {string} [options.title] - A human-readable label for the follow.
         * @returns {Promise<import('./feed').default|undefined>}
         * @throws {Error} named `InvalidFeedAddress` if the address can't be parsed,
         *      or `FeedNotFound` if the node has no readable feed.
         */
        async followByAddress(address, { node, title } = {}) {
            const parsed = parseFeedAddress(address);
            if (!parsed) {
                throw Object.assign(new Error(`Not a valid feed address: ${address}`), {
                    name: 'InvalidFeedAddress',
                });
            }
            const target_node = node || parsed.node;
            const { followable } = await probeFeed(parsed.jid, target_node);
            if (!followable) {
                throw Object.assign(new Error(`No readable feed at ${parsed.jid} (${target_node})`), {
                    name: 'FeedNotFound',
                });
            }
            return shared_api.microblog.follow(parsed.jid, { node: target_node, title });
        },

        /**
         * Browse one page of the feed nodes hosted on a PubSub service. Sends
         * disco#items to list the service's nodes (XEP-0060 § 5.5 Discover Nodes),
         * then probes each node's disco#info (§ 5.4 meta-data) with bounded
         * concurrency to learn its title, description, payload type and subscriber
         * count.
         *
         * A busy service returns its nodes one page at a time via XEP-0059 RSM, so
         * this fetches a single page and returns the server's `<last>` cursor plus
         * `has_more`; the caller pages by calling again with `after: cursor`. RSM is
         * the only standard way to bound a disco#items query, so a service without
         * it just returns its nodes in one unpaged batch (no cursor, `has_more`
         * false).
         *
         * @method _converse.api.microblog.browseFeeds
         * @param {string} service_jid - A pubsub service JID (or any JID that
         *      answers disco#items with a node list).
         * @param {object} [opts]
         * @param {string} [opts.after] - RSM cursor from a previous page's `cursor`
         *      (omit for the first page).
         * @param {number} [opts.max=BROWSE_PAGE_SIZE] - Page size (RSM `max`).
         * @param {(p: {probed: number, total: number}) => void} [opts.onProgress]
         * @param {AbortSignal} [opts.signal] - Abort to stop probing further nodes.
         * @returns {Promise<import('./types.ts').BrowseFeedsResult>}
         * @throws {Error} named `InvalidFeedAddress` if `service_jid` isn't usable.
         */
        async browseFeeds(service_jid, { after, max = (/* inlined export .BROWSE_PAGE_SIZE */100), onProgress, signal } = {}) {
            const jid = Strophe.getBareJidFromJid(service_jid?.trim() || '') || service_jid?.trim();
            const domain = Strophe.getDomainFromJid(jid || '');
            if (!jid || !domain?.includes('.')) {
                throw Object.assign(new Error(`Not a valid service address: ${service_jid}`), {
                    name: 'InvalidFeedAddress',
                });
            }

            // 1. List one page of the service's nodes (XEP-0060 § 5.5) via RSM. Only
            //    items carrying a `node` attribute are pubsub nodes (a bare-JID item
            //    is a child entity, not a feed).
            const items_iq = await shared_api.disco.items(jid, undefined, {
                rsm: { max, ...(after ? { after } : {}) },
                timeout: (/* inlined export .FOLLOWABLE_PROBE_TIMEOUT */10000),
            });
            const page = sizzle(`query[xmlns="${Strophe.NS.DISCO_ITEMS}"] item`, items_iq)
                .filter((el) => el.getAttribute('node'))
                .map((el) => ({
                    jid: el.getAttribute('jid') || jid,
                    node: el.getAttribute('node'),
                    name: el.getAttribute('name') || undefined,
                }));

            // A full page plus a cursor means there are more pages.
            // A short page is the end of the set.
            const set = sizzle(`set[xmlns="${Strophe.NS.RSM}"]`, items_iq)[0];
            const cursor = (set ? RSM.parseXMLResult(set).last : undefined) ?? null;
            const full = page.length >= max;
            const has_more = full && cursor !== null && cursor !== after;

            // Drop XEP-0277 per-post comment threads
            const nodes = page.filter((n) => !n.node.startsWith(COMMENTS_NODE_PREFIX));
            const dropped = page.length - nodes.length;
            if (dropped) src_log.debug(`browseFeeds: ${jid} — hid ${dropped} comment node(s) from the page`);

            // `title` holds pubsub#title only (filled in by the info probe); the
            // display label falls back to `name` then `node` in the UI.
            /** @type {import('./types').BrowsableFeed[]} */
            const feeds = nodes.map((n) => ({ ...n, is_feed: false, probed: false }));

            const total = feeds.length;
            let probed = 0;
            onProgress?.({ probed, total });

            // 2. Probe each node's disco#info with a streaming worker pool + short
            //    timeout (same shape as scanFollowable): one slow node never holds
            //    up the rest, and an aborted browse stops launching further probes.
            const queue = Array.from({ length: total }, (_, i) => i);
            const worker = async () => {
                while (queue.length && !signal?.aborted) {
                    const idx = queue.shift();
                    const meta = await probeNodeMeta(jid, feeds[idx].node);
                    Object.assign(feeds[idx], meta, { probed: true });
                    probed++;
                    onProgress?.({ probed, total });
                }
            };
            const pool = Array.from({ length: Math.min((/* inlined export .FOLLOWABLE_SCAN_CONCURRENCY */10), total) }, () => worker());
            await Promise.all(pool);
            return { feeds, cursor, has_more };
        },

        /**
         * Unfollow a contact's social feed: retract the XEP-0330 item, unsubscribe
         * to stop live delivery and drop the local feed and its cached posts.
         * @method _converse.api.microblog.unfollow
         * @param {string} jid
         * @param {object} [options]
         * @param {string} [options.node=MICROBLOG_NODE]
         * @returns {Promise<void>}
         */
        async unfollow(jid, { node = MICROBLOG_NODE } = {}) {
            // Match the bare-JID key recorded by follow() (see there).
            jid = Strophe.getBareJidFromJid(jid);
            await retractFollow(jid, node);
            shared_converse.state.following?.untrack(jid, node);
            try {
                await shared_api.pubsub.unsubscribe(jid, node);
            } catch (e) {
                src_log.debug(`api.microblog.unfollow: explicit unsubscribe from ${jid} failed (non-fatal): ${e}`);
            }
            await shared_api.waitUntil('pubsubFeedsInitialized');
            const feed = shared_converse.state.pubsubfeeds?.getFeed(jid, node, false);
            await feed?.close();
        },

        /**
         * Repeat (repost) a post into the user's own microblog feed (XEP-0277 §
         * Repeating a Post). Published to the user's own node and attributed to
         * the original author, so it renders with a "reposted by you" eyebrow.
         * @method _converse.api.microblog.repost
         * @param {import('./message').default} post - The post to repost.
         * @returns {Promise<void>}
         */
        async repost(post) {
            const feed = await shared_api.microblog.feeds.own();
            await feed.repostPost(post);
        },

        /**
         * Like a post *or a comment*: publish a ♥ to the post's comments node,
         * pointing at the comment when the target is one (see {@link resolveLikeTarget}).
         *
         * Optimistic: the like state flips immediately so that UI can update.
         * If the publish is refused the state is rolled back and the error
         * re-thrown for the caller to surface. A no-op if we already like it.
         * @method _converse.api.microblog.like
         * @param {import('./message').default} target - A post or a comment.
         * @returns {Promise<import('./message').default|undefined>} Our ♥ item.
         */
        async like(target) {
            if (target.get('liked_by_me')) return undefined;

            const { feed, model, parent_id, reconcile } = await resolveLikeTarget(target);
            if (!feed) return undefined;

            // The cached flag can be stale (another device already liked). If the
            // thread we've loaded already holds a ♥ of ours for this target, don't
            // publish a duplicate, just reconcile the denormalised state and bail.
            if (feed.getMyLikes(parent_id).length) {
                reconcile();
                return undefined;
            }

            const author_jid = shared_converse.session.get('bare_jid');
            const author_name = shared_converse.state.profile?.getDisplayName?.() || author_jid;
            const id = getUniqueId();

            // Optimistically reflect the like, keeping a snapshot to revert to.
            const snapshot = {
                like_count: model.get('like_count'),
                liked_by_me: model.get('liked_by_me'),
                my_like_id: model.get('my_like_id'),
            };
            safeSave(model, { liked_by_me: true, my_like_id: id, like_count: (model.get('like_count') || 0) + 1 });

            try {
                const like = await feed.publishComment({
                    body: (/* inlined export .LIKE_MARKER */"♥"),
                    author_jid,
                    author_name,
                    id,
                    ...(parent_id ? { in_reply_to: parent_id } : {}),
                });
                // Reconcile against the thread now the ♥ has actually landed.
                reconcile();
                return like;
            } catch (e) {
                safeSave(model, snapshot);
                throw e;
            }
        },

        /**
         * Un-like a post *or a comment*: retract *every* ♥ of ours for that target
         * from the comments node (duplicates can accrue across devices / cache
         * resets, so one tap clears it regardless of how many accumulated).
         *
         * Optimistic: the like is removed and the count reverts immediately, then
         * the retracts are sent; if any is refused the like is restored and the
         * error re-thrown for the caller to surface. A no-op if we don't like it.
         * @method _converse.api.microblog.unlike
         * @param {import('./message').default} target - A post or a comment.
         * @returns {Promise<void>}
         */
        async unlike(target) {
            if (!target.get('liked_by_me') && !target.get('my_like_id')) return;

            const { feed, model, parent_id, reconcile } = await resolveLikeTarget(target);
            if (!feed) return;

            // Every ♥ of ours for this target in the loaded thread, plus the cached
            // id in case the thread isn't loaded (deduped into a set).
            const ids = new Set(feed.getMyLikes(parent_id).map((m) => m.get('id')));
            if (model.get('my_like_id')) ids.add(model.get('my_like_id'));
            if (!ids.size) return;

            // Optimistically remove the like, keeping a snapshot to revert to.
            const snapshot = {
                like_count: model.get('like_count'),
                liked_by_me: model.get('liked_by_me'),
                my_like_id: model.get('my_like_id'),
            };
            safeSave(model, {
                liked_by_me: false,
                my_like_id: undefined,
                like_count: Math.max(0, (model.get('like_count') || 0) - 1),
            });

            try {
                for (const id of ids) {
                    await shared_api.pubsub.retract(feed.get('jid'), feed.get('node'), id);
                }
            } catch (e) {
                safeSave(model, snapshot);
                throw e;
            }
            // Confirmed: drop our local ♥s and reconcile counts from the thread.
            ids.forEach((id) => feed.messages.get(id)?.destroy());
            reconcile();
        },

        /**
         * The "comments" namespace groups XEP-0277 § Comments methods, which
         * operate on a post's per-post comments node.
         * @namespace _converse.api.microblog.comments
         * @memberOf _converse.api.microblog
         */
        comments: {
            /**
             * Get (creating it locally if necessary) the comments thread for a post.
             * The thread is a {@link CommentFeed} over the post's comments node,
             * kept out of the timeline aggregate.
             * @method _converse.api.microblog.comments.feed
             * @param {import('./message').default} post
             * @returns {Promise<import('./comment-feed').default|undefined>}
             */
            async feed(post) {
                await shared_api.waitUntil('pubsubFeedsInitialized');
                const service = post.getCommentsService();
                const node = post.getCommentsNode();
                if (!service || !node) return undefined;
                return shared_converse.state.commentfeeds?.getFeed(service, node, true);
            },

            /**
             * Fetch a post's comments into its thread and return the thread, then
             * denormalise each comment's own counts (see {@link syncCommentCounts})
             * so the drill-down view can show a reply/like tally per row.
             * @method _converse.api.microblog.comments.fetch
             * @param {import('./message').default} post
             * @returns {Promise<import('./comment-feed').default|undefined>}
             */
            async fetch(post) {
                const feed = await shared_api.microblog.comments.feed(post);
                await feed?.fetchComments();
                if (feed) syncCommentCounts(feed);
                return feed;
            },

            /**
             * Resolve a focused item's direct replies to the feed that holds them,
             * fetching it. The drill-down view reads two shapes identically:
             *  - **null**: the flat model (ours / Movim / renostr). The item's
             *    replies are the items in its *own* thread node whose `in_reply_to`
             *    is this item, so the caller filters the thread it already has.
             *  - **a CommentFeed**: the Libervia node-per-comment model. The item
             *    advertised a dedicated replies node (see
             *    {@link PostComment.getRepliesRef}); its replies are that feed's
             *    top-level items.
             *
             * Only ever follows the *explicit* replies link, so a flat thread is
             * never probed. The child feed is an ordinary member of
             * `commentfeeds`, so LRU eviction, pinning and live routing all apply.
             * @method _converse.api.microblog.comments.replies
             * @param {import('./post-comment').default} item
             * @returns {Promise<import('./comment-feed').default|null>}
             */
            async replies(item) {
                const ref = item?.getRepliesRef?.();
                if (!ref) return null; // flat: replies live in the item's own thread

                const feed = await shared_api.microblog.comments.thread(ref.jid, ref.node);
                // Denormalise the owning comment's reply/like count from its child node.
                if (feed) syncCommentThread(ref.jid, ref.node, feed);
                return feed;
            },

            /**
             * Materialise and backfill a comments node by address, returning its
             * {@link CommentFeed}. The low-level primitive behind {@link replies}
             * and used to resolve a deep-linked Libervia child-node comment.
             * @method _converse.api.microblog.comments.thread
             * @param {string} jid - The comments service JID.
             * @param {string} node - The comments node.
             * @returns {Promise<import('./comment-feed').default|null>}
             */
            async thread(jid, node) {
                await shared_api.waitUntil('pubsubFeedsInitialized');
                const feed = shared_converse.state.commentfeeds?.getFeed(jid, node, true);
                if (!feed) return null;
                await feed.fetchComments();
                return feed;
            },

            /**
             * Fetch a post's comments and denormalise the resulting counts onto
             * the post (see {@link syncCommentSummary}). This is the source for
             * the timeline's comment/like counts.
             * @method _converse.api.microblog.comments.fetchSummary
             * @param {import('./message').default} post
             * @returns {Promise<void>}
             */
            fetchSummary(post) {
                const service = post?.getCommentsService();
                const node = post?.getCommentsNode();
                if (!service || !node) return Promise.resolve();

                // Key the dedupe on the comments-feed identity (service + node),
                const key = microblog_feeds.getFeedId(service, node);
                return comment_summary_queue.add(key, async () => {
                    const feed = await shared_api.microblog.comments.feed(post);
                    if (!feed) return;

                    await feed.fetchComments();
                    syncCommentSummary(post, feed);
                });
            },

            /**
             * Pin and subscribe to a post's comment thread so live comments/likes
             * route in and bump the post's denormalised counts. Used for our own
             * posts, so we take an explicit bare-JID subscription and
             * materialise (pin) the thread feed since `handleMicroblogEvent` routes a
             * comment event only into an already existing thread (create=false).
             * Idempotent; bounded by `social_max_pinned_threads`.
             * @method _converse.api.microblog.comments.pin
             * @param {import('./message').default} post
             * @returns {Promise<import('./comment-feed').default|undefined>}
             */
            async pin(post) {
                const service = post?.getCommentsService();
                const node = post?.getCommentsNode();
                if (!service || !node) return undefined;

                await shared_api.waitUntil('pubsubFeedsInitialized');
                const feeds = shared_converse.state.commentfeeds;
                const feed = feeds?.getFeed(service, node, true);
                if (!feed) return undefined;
                if (!feed.get('pinned')) feed.save({ pinned: true });

                try {
                    await shared_api.pubsub.subscribe(service, node);
                } catch (e) {
                    // Non-fatal: without the subscription live comments won't push,
                    // but the thread is still fetched on open / next summary refresh.
                    src_log.debug(`api.microblog.comments.pin: subscribe to ${node} failed (non-fatal): ${e}`);
                }
                await feeds.enforcePinnedCap();
                return feed;
            },

            /**
             * Pin+subscribe the comment threads of our recent own posts (bounded
             * by `social_max_pinned_threads`) so live comments/likes on them keep
             * the counts current. Called on load; safe to call repeatedly.
             * @method _converse.api.microblog.comments.pinRecentOwn
             * @returns {Promise<void>}
             */
            async pinRecentOwn() {
                await shared_api.waitUntil('pubsubFeedsInitialized');
                const bare_jid = shared_converse.session.get('bare_jid');
                const own = shared_converse.state.pubsubfeeds?.getFeed(bare_jid, MICROBLOG_NODE, false);
                if (!own) return;

                const cap = shared_api.settings.get('social_max_pinned_threads') || 0;
                // getPosts() is newest-first, so the newest `cap` posts are pinned.
                for (const post of own.getPosts().slice(0, cap)) {
                    await shared_api.microblog.comments.pin(post);
                }
            },

            /**
             * Add a comment to a post, or a threaded reply to one of its comments.
             * Publishes an Atom entry attributed to us into the post's comments
             * node; when `parent` is given, the entry carries a `<thr:in-reply-to>`
             * pointing at it (RFC 4685), so the whole thread stays in one node.
             * @method _converse.api.microblog.comments.add
             * @param {import('./message').default} post - The post that owns the thread.
             * @param {string} body - The comment text.
             * @param {object} [opts]
             * @param {import('./post-comment').default} [opts.parent] - The comment
             *      being replied to; omit for a direct comment on the post.
             * @returns {Promise<import('./message').default|undefined>}
             */
            async add(post, body, { parent } = {}) {
                const text = body?.trim();
                if (!text) return undefined;

                const author_jid = shared_converse.session.get('bare_jid');
                const author_name = shared_converse.state.profile?.getDisplayName?.() || author_jid;

                // Publish where the conversation already is. Into a parent's own
                // replies node, otherwise into the post's thread node with an
                // in_reply_to pointer at the parent (the flat model).
                const ref = parent && typeof parent.getRepliesRef === 'function' ? parent.getRepliesRef() : null;
                if (ref) {
                    const child = await shared_api.microblog.comments.thread(ref.jid, ref.node);
                    if (!child) return undefined;

                    const reply = await child.publishComment({ body: text, author_jid, author_name });
                    syncCommentThread(ref.jid, ref.node, child); // bump the owning comment's count
                    return reply;
                }

                const feed = await shared_api.microblog.comments.feed(post);
                if (!feed) return undefined;

                const reply = parent ? { in_reply_to: parent.get('id'), in_reply_to_ref: parent.get('atom_id') } : {};
                const comment = await feed.publishComment({ body: text, author_jid, author_name, ...reply });

                // Reflect our own new comment in the post's total and, when it's a
                // reply, in the parent comment's reply count.
                syncCommentSummary(post, feed);
                if (parent) syncCommentCounts(feed);

                return comment;
            },
        },

        /**
         * Read a durable XEP-0330 follow list (the server-side source of truth
         * for who an account follows), e.g. for a Following list/count. Defaults
         * to our own list; pass a JID to read a contact's (their node is
         * presence-access, so it succeeds for contacts and is refused otherwise).
         * @method _converse.api.microblog.following
         * @param {string} [jid=null] - Whose list to read; null/own for our own.
         * @returns {Promise<Array<{ server: string, node: string, title?: string }>>}
         */
        async following(jid = null) {
            return await readFollowing(jid);
        },

        /**
         * Materialise the feeds the user reads and backfill them.
         * Idempotent, so the Social UI can call it whenever it opens.
         *
         * Deliberately *not* run on connect: the headless plugin stays passive so
         * it doesn't issue PEP queries for users who never open the Social app
         * (cached feeds already survive reconnects, so live PEP routing is
         * unaffected). The UI drives this instead.
         * @method _converse.api.microblog.initFollowing
         * @returns {Promise<void>}
         */
        async initFollowing() {
            await shared_api.waitUntil('pubsubFeedsInitialized');
            const feeds = shared_converse.state.pubsubfeeds;
            if (!feeds) return;

            // Ensure the own feed is present so it's part of the aggregate timeline.
            feeds.getFeed(shared_converse.session.get('bare_jid'), MICROBLOG_NODE, true);

            let following = null;
            try {
                // Read the durable XEP-0330 follow list
                following = await readFollowing();
            } catch (e) {
                // No follow-list node yet (or it's empty/inaccessible). Leave
                // `following` null so a transient failure never wipes the mirror.
                src_log.debug(`api.microblog.initFollowing: could not read the follow list: ${e}`);
            }
            if (following) {
                // Reconcile the durable list into the local mirror (the source of
                // truth for isFollowing), catching follows/unfollows made on
                // another device, then materialise each followed feed.
                await shared_converse.state.following?.reconcile(following);
                for (const { server, node } of following) {
                    feeds.getFeed(server, node, true);
                }
            }
            feeds.forEach(/** @param {import('./feed').default} f */ (f) => f.fetchPosts());

            // Re-establish live comment/like delivery for our recent own posts so
            // their counts keep ticking across reconnects (fire-and-forget; reads
            // the already-hydrated own feed).
            shared_api.microblog.comments.pinRecentOwn().catch((e) => src_log.error(e));
        },

        /**
         * Re-read the durable XEP-0330 follow list from our own PEP service and
         * bring local state into line with it: reconcile the `following` mirror,
         * materialise and backfill any feed newly followed on another device or
         * client, and drop any feed unfollowed elsewhere. Only the delta is
         * touched (feeds we already follow are left as they are), and every step
         * is idempotent, so re-running it (e.g. on a `+notify` echo of our own
         * change) is a no-op.
         *
         * Driven by the `+notify` push on our follow-list node (see
         * `handleMicroblogEvent`), which is how a follow/unfollow made on one
         * device propagates live to the others.
         * @method _converse.api.microblog.syncFollowing
         * @returns {Promise<void>}
         */
        async syncFollowing() {
            await shared_api.waitUntil('pubsubFeedsInitialized');
            const feeds = shared_converse.state.pubsubfeeds;
            const mirror = shared_converse.state.following;
            if (!feeds || !mirror) return;

            let following;
            try {
                following = await readFollowing();
            } catch (e) {
                // A transient read failure must never wipe the mirror; leave
                // local state untouched and wait for the next notification.
                src_log.debug(`api.microblog.syncFollowing: could not read the follow list: ${e}`);
                return;
            }

            // Snapshot the follows we held *before* reconciling, so we can tell
            // which entries were added or removed on the other device. The mirror
            // id is `server/node`, matching a feed's id.
            const had = new Map(
                mirror.map(
                    /** @param {import('./following').FollowedFeed} m */ (m) => [
                        m.id,
                        { server: m.get('server'), node: m.get('node') },
                    ],
                ),
            );
            await mirror.reconcile(following);

            const desired = new Set(following.map(({ server, node }) => `${server}/${node}`));
            // Materialise + backfill feeds newly followed elsewhere.
            for (const { server, node } of following) {
                if (had.has(`${server}/${node}`)) continue;
                feeds.getFeed(server, node, true)?.fetchPosts();
            }
            // Drop feeds unfollowed elsewhere (mirrors `unfollow`). We don't
            // unsubscribe: the device that unfollowed already did, and the
            // subscription is a durable account-wide (bare-JID) one.
            for (const [id, { server, node }] of had) {
                if (desired.has(id)) continue;
                await feeds.getFeed(server, node, false)?.close();
            }
        },

        /**
         * Whether the user currently follows a JID + node, per the durable
         * XEP-0330 follow list (mirrored in `_converse.state.following`). This is
         * independent of whether a feed happens to be loaded for the JID — a
         * browse-only profile feed exists without a follow.
         * @method _converse.api.microblog.isFollowing
         * @param {string} jid
         * @param {string} [node=MICROBLOG_NODE]
         * @returns {boolean}
         */
        isFollowing(jid, node = MICROBLOG_NODE) {
            const bare_jid = shared_converse.session.get('bare_jid');
            const server = Strophe.getBareJidFromJid(jid);
            if (server === bare_jid) return false;

            return !!shared_converse.state.following?.isFollowing(server, node);
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 *
 * Headless plugin implementing XEP-0277 (Microblogging over XMPP) on top of the
 * generic PubSub plugin. Exposes feeds/posts as Skeletor models and routes
 * incoming PEP events; the "Social" UI app renders on top of this.
 */






















const { Strophe: microblog_plugin_Strophe } = api_public.env;

microblog_plugin_Strophe.addNamespace('ATOM', NS_ATOM);
microblog_plugin_Strophe.addNamespace('THREAD', NS_THREAD);
microblog_plugin_Strophe.addNamespace('AVATAR_METADATA', NS_AVATAR_METADATA);

api_public.plugins.add('converse-microblog', {
    dependencies: ['converse-pubsub', 'converse-disco'],

    initialize() {
        shared_api.promises.add('pubsubFeedsInitialized');

        shared_api.settings.extend({
            // Cap on the *number* of retained comment threads stored on posts.
            'social_max_comment_threads': 200,
            // Cap on subscriptions to pinned (e.g. our own) comment threads.
            // Past the cap the least-recently-pinned are unsubscribed + evicted
            'social_max_pinned_threads': 50,
        });

        const exports = {
            CommentFeed: microblog_comment_feed,
            CommentFeeds: comment_feeds,
            FollowableCache: microblog_followable,
            Following: microblog_following,
            MicroblogProfile: microblog_profile,
            PostComment: post_comment,
            PostComments: post_comments,
            PubSubFeed: microblog_feed,
            PubSubFeeds: microblog_feeds,
            PubSubMessage: microblog_message,
            PubSubMessages: microblog_messages,
            PubsubPlaceholderMessage: PubsubPlaceholderMessage,
        };
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_api, microblog_api);

        shared_api.listen.on('addClientFeatures', () => {
            // Advertise that we understand the PubSub Social Feed (XEP-0472)
            // and the microblog node.
            shared_api.disco.own.features.add(SOCIAL_FEED_FEATURE);
            shared_api.disco.own.features.add(MICROBLOG_NODE);
            // Ask the server to push changes to our own XEP-0330 follow list to
            // all our online resources (`+notify`), so a follow/unfollow on one
            // device syncs live to the others. Unlike the microblog node (curated
            // content, delivered by explicit subscription) the follow list is
            // presence-broadcast profile state, so `+notify` is the right fit.
            shared_api.disco.own.features.add(`${FOLLOWING_NODE}+notify`);
        });

        shared_api.listen.on('clearSession', () => {
            // Drop the in-memory summary-fetch dedupe state so a fresh login
            // re-fetches counts (the persisted post attrs still show meanwhile).
            comment_summary_queue.reset();

            // Drop cached author profiles (and their vCard listeners).
            microblog_profile.clearProfiles();

            // Drop the session's detached browse feeds (unfollowed authors' feeds).
            microblog_feed.clearBrowseFeeds();

            const { state } = shared_converse;
            if (state.pubsubfeeds) {
                state.pubsubfeeds.clearStore?.({ silent: true });
                delete state.pubsubfeeds;
            }
            if (state.commentfeeds) {
                state.commentfeeds.clearStore?.({ silent: true });
                delete state.commentfeeds;
            }
            if (state.followablecache) {
                state.followablecache.clearStore?.({ silent: true });
                delete state.followablecache;
            }
            if (state.following) {
                state.following.clearStore?.({ silent: true });
                delete state.following;
            }
        });

        shared_api.listen.on('connected', onConnected);
        shared_api.listen.on('reconnected', onConnected);
    },
});

async function onConnected() {
    try {
        registerMicroblogHandler();
        const feeds = new shared_converse.exports.PubSubFeeds();
        shared_converse.state.pubsubfeeds = feeds;

        // Comment threads live in their own persisted collection so they never
        // enter the aggregated timeline; growth is bounded by a thread LRU.
        const commentfeeds = new shared_converse.exports.CommentFeeds();
        shared_converse.state.commentfeeds = commentfeeds;

        const followablecache = new shared_converse.exports.FollowableCache();
        shared_converse.state.followablecache = followablecache;

        // A local, persisted mirror of the durable XEP-0330 follow list
        const following = new shared_converse.exports.Following();
        shared_converse.state.following = following;

        await Promise.all([feeds.hydrated, commentfeeds.hydrated, followablecache.hydrated, following.hydrated]);

        // A prior session may have hydrated more threads than the current cap.
        commentfeeds.pruneThreads();
    } catch (e) {
        src_log.error(e);
    }
    /**
     * Triggered once the microblog feeds collection has been created and
     * hydrated from the offline cache.
     * @event _converse#pubsubFeedsInitialized
     */
    shared_api.trigger('pubsubFeedsInitialized');
}

;// CONCATENATED MODULE: ./src/headless/plugins/microblog/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */










;// CONCATENATED MODULE: ./src/headless/plugins/reactions/parsers.js


const { Strophe: reactions_parsers_Strophe } = api_public.env;

/**
 * @typedef {import('../../plugins/muc/muc').default} MUC
 * @typedef {import('../../plugins/muc/types').MUCMessageAttributes} MUCMessageAttributes
 * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
 * @typedef {import('./types').MUCMessageAttrsWithReactions} MUCMessageAttrsWithReactions
 * @typedef {import('./types').MessageAttrsWithReactions} MessageAttrsWithReactions
 */

/**
 * Parse reactions from a message stanza and return updated attributes.
 *
 * Per XEP-0444, a reaction stanza references an existing message via
 * `<reactions id="...">`. This parser extracts the referenced message ID
 * and creates a reactions object keyed by the reacting party's stable
 * identity key (since each incoming reaction stanza only contains reactions
 * from a single sender).
 *
 * The key used for the `reactions` map follows this priority chain for MUC:
 *
 * 1. **occupant_id** (XEP-0421) — stable across nick changes, works in all
 *    MUC anonymity modes.
 * 2. **real bare JID** (`from_real_jid`) — used only when the MUC is
 *    non-anonymous, to avoid key inconsistency in semi-anonymous rooms where
 *    only moderators can see real JIDs.
 * 3. **full JID** (`room@domain/nick`) — last-resort fallback.
 *
 * For 1:1 chats the key is always the sender's bare JID.
 *
 * Later, when the message attributes are applied to the original message,
 * the `getUpdatedMessageAttributes` hook merges this single-reactor object
 * with existing reactions from other reactors.
 *
 * @param {Element} stanza - The XMPP message stanza
 * @param {MessageAttributes|MUCMessageAttributes} attrs - Current message attributes
 * @param {MUC} [chatbox] - The MUC model,
 *   passed for MUC messages so we can inspect room features (e.g. anonymity mode).
 *   For 1:1 chats, this parameter is `undefined`.
 * @returns {Promise<MessageAttrsWithReactions|MUCMessageAttrsWithReactions>}
 */
async function parseReactionsMessage(stanza, attrs, chatbox) {
    const reactions_element = stanza.getElementsByTagNameNS(reactions_parsers_Strophe.NS.REACTIONS, 'reactions')[0];

    if (!reactions_element) {
        return attrs;
    }

    const reaction_to_id = reactions_element.getAttribute('id');
    if (!reaction_to_id) {
        return attrs;
    }

    const reaction_elements = reactions_element.getElementsByTagName('reaction');
    const emojis = Array.from(reaction_elements)
        .map((el) => el.textContent)
        .filter((e) => e);

    let reacting_key;
    if (attrs.type === 'groupchat') {
        const muc_attrs = /** @type {MUCMessageAttributes} */ (attrs);
        const muc_chatbox = /** @type {import('../../plugins/muc/muc.js').default|undefined} */ (chatbox);
        if (muc_attrs.occupant_id) {
            // XEP-0421: stable across nick changes, preferred in all MUC types
            reacting_key = muc_attrs.occupant_id;
        } else if (muc_attrs.from_real_jid && muc_chatbox?.features?.get('nonanonymous')) {
            // Non-anonymous MUC: real bare JID is visible to all participants
            // and is stable across nick changes
            reacting_key = muc_attrs.from_real_jid;
        } else {
            // Semi-anonymous MUC without XEP-0421: fall back to full JID
            reacting_key = attrs.from;
        }
    } else {
        reacting_key = reactions_parsers_Strophe.getBareJidFromJid(attrs.from);
    }

    const reactions = { [reacting_key]: emojis };

    return Object.assign(attrs, {
        reaction_to_id,
        reactions,
    });
}

;// CONCATENATED MODULE: ./src/headless/plugins/reactions/utils.js




const { Strophe: reactions_utils_Strophe, u: reactions_utils_u } = api_public.env;

/**
 * @typedef {import('../../shared/types').MessageAttributes} MessageAttributes
 * @typedef {import('../../plugins/muc/types').MUCMessageAttributes} MUCMessageAttributes
 * @typedef {import('./types').MessageAttrsWithReactions} MessageAttrsWithReactions
 * @typedef {import('./types').MUCMessageAttrsWithReactions} MUCMessageAttrsWithReactions
 * @typedef {import('../../shared/types').ChatBoxOrMUC} ChatBoxOrMUC
 * @typedef {import('../../shared/message').default} BaseMessage
 */

/**
 * Hook handler for the `getDuplicateMessageQueries` hook.
 *
 * Adds query objects so that incoming reaction stanzas can be matched against
 * the message they target. Per XEP-0444, the `<reactions id="...">` attribute
 * contains the id of the original message. Different clients use different id
 * types for this reference:
 *
 * - The sender's client-assigned stanza id (`msgid` / `origin_id`).
 * - The MUC-assigned stanza_id (`stanza_id <muc-jid>`), as used by Conversations
 *   and other compliant clients.
 *
 * By contributing all three query objects here we ensure a single O(n) scan
 * in {@link getDuplicateMessage} covers all cases, with no reaction-specific
 * logic leaking into shared code.
 *
 * @param {ChatBoxOrMUC} chatbox
 * @param {object[]} queries
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} attrs
 * @returns {object[]}
 */
function getDuplicateMessageQueries(chatbox, queries, attrs) {
    const reaction_to_id = /** @type {string|undefined} */ (attrs.reaction_to_id);
    if (!reaction_to_id) return queries;

    /** @type {object[]} */
    const extra = [{ origin_id: reaction_to_id }, { msgid: reaction_to_id }];

    if (chatbox.get('type') === 'chatroom') {
        extra.push({ [`stanza_id ${chatbox.get('jid')}`]: reaction_to_id });
    }

    return [...queries, ...extra];
}

/**
 * This hook handler merges the incoming single-reactor reactions
 * with all existing reactions from other reactors, so that no
 * reactions are lost when the message is saved. Keys are
 * occupant_id, bare JID, or full JID depending on the context
 * (see {@link parseReactionsMessage} for the priority chain).
 *
 * @param {BaseMessage} message
 * @param {MessageAttributes|MUCMessageAttributes} new_attrs
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} original_attrs
 * @returns {MessageAttrsWithReactions|MUCMessageAttrsWithReactions}
 */
function getUpdatedMessageAttributes(message, new_attrs, original_attrs) {
    const incoming_reactions = original_attrs?.reactions;
    if (!incoming_reactions) return new_attrs;

    const reactions = { ...(message.get('reactions') || {}) };

    for (const key in incoming_reactions) {
        if (incoming_reactions[key]?.length) {
            reactions[key] = incoming_reactions[key];
        } else {
            delete reactions[key];
        }
    }
    return { ...new_attrs, reactions };
}

/**
 * Handler for the getErrorAttributesForMessage hook.
 *
 * When a reaction fails to send (e.g., due to a server error or stanza timeout),
 * this hook ensures that the user's own reaction is not preserved locally as if
 * it had been delivered successfully.
 *
 * It removes the current user's reaction from the message's reactions map,
 * so that the UI will not show a local-only reaction that failed to reach
 * the recipient.
 *
 * @param {BaseMessage} message
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} new_attrs
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} original_attrs
 * @returns {MessageAttrsWithReactions|MUCMessageAttrsWithReactions}
 */
function getErrorAttributesForMessage(message, new_attrs, original_attrs) {
    if (original_attrs.reaction_to_id) {
        const chatbox = message.collection?.chatbox;
        const my_key = chatbox ? getOwnReactionJID(chatbox) : reactions_utils_Strophe.getBareJidFromJid(shared_api.connection.get().jid);
        const reactions = { ...message.get('reactions') };
        delete reactions[my_key];
        new_attrs.reactions = reactions;
    }
    return new_attrs;
}

/**
 * Handler for the beforeMessageCreated hook.
 *
 * When a reaction stanza arrives for a message that isn't in local
 * state yet (e.g. during MAM catch-up where messages arrive out of
 * order), store it as a dangling reaction so it can be applied once
 * the original message arrives.
 *
 * @param {ChatBoxOrMUC} chatbox
 * @param {MessageAttrsWithReactions|MUCMessageAttrsWithReactions} attrs
 * @param {{handled: boolean}} data - The hook data object
 * @returns {{handled: boolean}} - Updated hook data
 */
function onBeforeMessageCreated(chatbox, attrs, data) {
    if (!attrs.reaction_to_id) return data;

    // If the target message already exists, the normal getDuplicateMessage
    // flow will have matched it and updateMessage will be called instead
    // so we only reach here if the target is missing.
    attrs.dangling_reaction = true;
    chatbox.createMessage(attrs);
    return { ...data, handled: true };
}

/**
 * Handler for the afterMessageCreated hook.
 *
 * When a new message is created, check whether any dangling reactions
 * were waiting for it. If so, merge their reactions onto the new
 * message and destroy the placeholders.
 *
 * @param {ChatBoxOrMUC} chatbox
 * @param {BaseMessage} message - The newly created message model
 */
function onAfterMessageCreated(chatbox, message) {
    const msgid = message.get('msgid');
    const origin_id = message.get('origin_id');

    // Collect all stanza_id values from the new message so we can match dangling
    // reactions that reference the message by its server-assigned stanza_id
    // (e.g. as sent by Conversations and other XEP-0444 compliant MUC clients).
    const stanza_id_values = Object.keys(message.attributes)
        .filter((k) => k.startsWith('stanza_id '))
        .map((k) => message.get(k))
        .filter(Boolean);

    if (!msgid && !origin_id && !stanza_id_values.length) return;

    const danglings = chatbox.messages.models.filter((m) => {
        if (!m.get('dangling_reaction')) return false;
        const reaction_to_id = m.get('reaction_to_id');
        return reaction_to_id === msgid || reaction_to_id === origin_id || stanza_id_values.includes(reaction_to_id);
    });
    if (!danglings.length) return;

    const reactions = { ...(message.get('reactions') || {}) };
    for (const dangling of danglings) {
        const incoming = dangling.get('reactions') || {};
        for (const jid in incoming) {
            if (incoming[jid]?.length) {
                reactions[jid] = incoming[jid];
            } else {
                delete reactions[jid];
            }
        }
        dangling.destroy();
    }
    message.save({ reactions });
}

/**
 * Returns the key under which the current user's reactions are stored
 * on a given message's `reactions` map.
 *
 * The key follows the same priority chain used when parsing incoming
 * reaction stanzas ({@link parseReactionsMessage}):
 *
 * 1. **occupant_id** (XEP-0421) — stable across nick changes, works in all
 *    MUC anonymity modes.
 * 2. **real bare JID** — used only when the MUC is non-anonymous (every
 *    participant can see real JIDs), to avoid inconsistency in semi-anonymous
 *    rooms where only moderators see real JIDs.
 * 3. **full JID** (`room@domain/nick`) — last-resort fallback.
 *
 * For 1:1 chats the key is always the own bare JID.
 *
 * @param {ChatBoxOrMUC} chatbox
 * @returns {string}
 */
function getOwnReactionJID(chatbox) {
    if (chatbox.get('type') === 'chatroom') {
        if (chatbox.get('occupant_id')) {
            return chatbox.get('occupant_id');
        }
        if (chatbox.features?.get('nonanonymous')) {
            return shared_converse.session.get('bare_jid');
        }
        return `${chatbox.get('jid')}/${chatbox.get('nick')}`;
    }
    return reactions_utils_Strophe.getBareJidFromJid(shared_api.connection.get().jid);
}

Object.assign(reactions_utils_u, {
    reactions: {
        ...reactions_utils_u.reactions,
        getOwnReactionJID,
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/reactions/plugin.js
/**
 * @module converse-reactions
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description XEP-0444: Message Reactions - Headless core logic
 */






const { Strophe: reactions_plugin_Strophe } = api_public.env;

reactions_plugin_Strophe.addNamespace('REACTIONS', 'urn:xmpp:reactions:0');

api_public.plugins.add('converse-reactions', {
    dependencies: ['converse-chat', 'converse-muc', 'converse-pubsub', 'converse-emoji'],

    initialize() {
        shared_api.listen.on('parseMessage', parseReactionsMessage);
        shared_api.listen.on('parseMUCMessage', parseReactionsMessage);
        shared_api.listen.on('parseEncryptedContent', parseReactionsMessage);

        shared_api.listen.on('getDuplicateMessageQueries', getDuplicateMessageQueries);
        shared_api.listen.on('getUpdatedMessageAttributes', getUpdatedMessageAttributes);
        shared_api.listen.on('getErrorAttributesForMessage', getErrorAttributesForMessage);

        shared_api.listen.on('beforeMessageCreated', onBeforeMessageCreated);
        shared_api.listen.on('afterMessageCreated', onAfterMessageCreated);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/reactions/index.js
/**
 * XEP-0444: Message Reactions - Headless core
 */


;// CONCATENATED MODULE: ./src/headless/plugins/version/api.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */




const { Strophe: version_api_Strophe, u: version_api_u, stx: version_api_stx } = api_public.env;

/* export default */ const version_api = ({
    /**
     * The XEP-0092 Software Version API
     *
     * This API lets you query an XMPP entity (such as your own server) for the
     * name, version and operating system of the software it's running.
     *
     * @namespace api.version
     * @memberOf api
     */
    version: {
        /**
         * Queries an XMPP entity for its software version, as specified in
         * XEP-0092: Software Version.
         *
         * @method api.version.get
         * @param {string} [jid] The JID of the entity to query. If not provided,
         *  the user's own server (the domain part of their JID) is queried.
         * @param {number} [timeout] The amount of time in milliseconds to wait
         *  for a response.
         * @returns {Promise<import('./types').SoftwareVersion|null>} A promise
         *  which resolves with the software version details, or with `null` if
         *  the entity didn't respond or doesn't support XEP-0092.
         * @example
         * const version = await api.version.get();
         * // { name: 'Prosody', version: '0.12.0', os: 'Debian GNU/Linux' }
         */
        async get(jid, timeout) {
            if (!shared_api.connection.authenticated()) {
                return null;
            }

            const bare_jid = shared_converse.session.get('bare_jid');
            jid = jid || version_api_Strophe.getDomainFromJid(bare_jid);

            const iq = version_api_stx`
                <iq type="get" to="${jid}" xmlns="jabber:client">
                    <query xmlns="${version_api_Strophe.NS.VERSION}"></query>
                </iq>`;

            const result = await shared_api.sendIQ(iq, timeout, false);
            if (result === null || version_api_u.isErrorStanza(result)) {
                return null;
            }

            const query = result.querySelector(':scope > query');
            if (!query) {
                return null;
            }

            return {
                name: query.querySelector(':scope > name')?.textContent || null,
                version: query.querySelector(':scope > version')?.textContent || null,
                os: query.querySelector(':scope > os')?.textContent || null,
            };
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/version/index.js
/**
 * @description
 * Converse.js plugin which adds support for querying the software version of
 * an XMPP entity, as specified in XEP-0092: Software Version.
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */




// Strophe already defines `Strophe.NS.VERSION` as 'jabber:iq:version'.

api_public.plugins.add('converse-version', {
    initialize() {
        Object.assign(shared_api, version_api);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/status/api.js




let api_idle_seconds = 0;
let idle = false;

/* export default */ const status_api = ({
    /**
     * Set and get the user's chat status, also called their *availability*.
     * @namespace _converse.api.user.status
     * @memberOf _converse.api.user
     */
    status: {
        /**
         * Return the current user's availability status.
         * @method _converse.api.user.status.get
         * @example _converse.api.user.status.get();
         */
        async get() {
            await shared_api.waitUntil('statusInitialized');

            const show = shared_converse.state.profile.get('show');
            if (show) {
                return show;
            }
            const status = shared_converse.state.profile.get('status');
            if (!status) {
                return 'online';
            }
            return status;
        },

        /**
         * The user's status can be set to one of the following values:
         * @method _converse.api.user.status.set
         * @param { string } value The user's chat status (e.g. 'away', 'dnd', 'offline', 'online', 'unavailable' or 'xa')
         * @param { string } [message] A custom status message
         *
         * @example _converse.api.user.status.set('dnd');
         * @example _converse.api.user.status.set('dnd', 'In a meeting');
         */
        async set(value, message) {
            if (!Object.keys(STATUS_WEIGHTS).includes(value)) {
                throw new Error(
                    'Invalid availability value. See https://xmpp.org/rfcs/rfc3921.html#rfc.section.2.2.2.1',
                );
            }

            let show = PRES_SHOW_VALUES.includes(value) ? value : undefined;
            if (value === 'away') {
                show = 'dnd';
            }

            const type = PRES_TYPE_VALUES.includes(value) ? value : undefined;
            const data = { show, type };

            if (typeof message === 'string') {
                data.status_message = message;
            }
            await shared_api.waitUntil('statusInitialized');
            shared_converse.state.profile.save(data);
        },

        /**
         * Set and retrieve the user's custom status message.
         *
         * @namespace _converse.api.user.status.message
         * @memberOf _converse.api.user.status
         */
        message: {
            /**
             * @method _converse.api.user.status.message.get
             * @returns {Promise<string>} The status message
             * @example const message = _converse.api.user.status.message.get()
             */
            async get() {
                await shared_api.waitUntil('statusInitialized');
                return shared_converse.state.profile.get('status_message');
            },
            /**
             * @method _converse.api.user.status.message.set
             * @param {string} status The status message
             * @example _converse.api.user.status.message.set('In a meeting');
             */
            async set(status) {
                await shared_api.waitUntil('statusInitialized');
                shared_converse.state.profile.save({ status_message: status });
            },
        },
    },

    /**
     * Set and get the user's idle status
     * @namespace _converse.api.user.idle
     * @memberOf _converse.api.user
     */
    idle: {
        /**
         * @method _converse.api.user.idle.get
         * @returns {import('./types').IdleStatus}
         * @example _converse.api.user.idle.get();
         */
        get() {
            return { idle, seconds: api_idle_seconds };
        },

        /**
         * @method _converse.api.user.idle.set
         * @param {import('./types').IdleStatus} status
         */
        set(status) {
            if (typeof status.idle === 'boolean') {
                idle = status.idle;
            }
            if (typeof status.seconds === 'number') {
                api_idle_seconds = status.seconds;
            }
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/roster/contact.js









const { Strophe: contact_Strophe, stx: contact_stx, u: contact_u } = api_public.env;

class contact_RosterContact extends model_with_vcard_ModelWithVCard(color_ColorAwareModel(skeletor_esm_Model)) {
    get idAttribute() {
        return 'jid';
    }

    defaults() {
        return {
            groups: [],
            num_unread: 0,
        };
    }

    initialize(attrs) {
        super.initialize();
        this.initialized = this.setup(attrs);
    }

    async setup(attrs) {
        this.lazy_load_vcard = true;

        await this.setPresence();
        const { jid } = attrs;
        this.set({
            ...attrs,
            ...{
                jid: contact_Strophe.getBareJidFromJid(jid).toLowerCase(),
                user_id: contact_Strophe.getNodeFromJid(jid),
            },
        });
        /**
         * When a contact's presence status has changed.
         * The presence status is either `online`, `offline`, `dnd`, `away` or `xa`.
         * @event _converse#contactPresenceChanged
         * @type {RosterContact}
         * @example _converse.api.listen.on('contactPresenceChanged', contact => { ... });
         */
        this.listenTo(this.presence, 'change:show', () => shared_api.trigger('contactPresenceChanged', this));
        this.listenTo(this.presence, 'change:show', () => this.trigger('presence:change'));
        this.listenTo(this.presence, 'change:presence', () => shared_api.trigger('contactPresenceChanged', this));
        this.listenTo(this.presence, 'change:presence', () => this.trigger('presence:change'));
        /**
         * Synchronous event which provides a hook for further initializing a RosterContact
         * @event _converse#rosterContactInitialized
         * @param {RosterContact} contact
         */
        await shared_api.trigger('rosterContactInitialized', this, { synchronous: true });
    }

    async setPresence() {
        const jid = this.get('jid');
        await shared_api.waitUntil('presencesInitialized');
        const { presences } = shared_converse.state;
        this.presence = presences.get(jid) || presences.create({ jid });
    }

    getStatus() {
        return this.presence?.getStatus() || 'offline';
    }

    async openChat() {
        return await shared_api.chats.open(this.get('jid'), {}, true);
    }

    /**
     * @param {import('./types').ContactDisplayNameOptions} [options]
     * @returns {string}
     */
    getDisplayName(options) {
        return this.get('nickname') || this.vcard?.getDisplayName() || (options?.no_jid ? null : this.get('jid'));
    }

    /**
     * Send a presence subscription request to this roster contact
     * @param {string} [message] - An optional message to explain the
     *      reason for the subscription request.
     */
    subscribeToPresence(message) {
        shared_api.user.presence.send({
            type: 'subscribe',
            to: this.get('jid'),
            status: message,
        });
        this.save('ask', 'subscribe'); // ask === 'subscribe' Means we have asked to subscribe to them.
        return this;
    }

    /**
     * Upon receiving the presence stanza of type "subscribed",
     * the user SHOULD acknowledge receipt of that subscription
     * state notification by sending a presence stanza of type
     * "subscribe" to the contact
     */
    ackSubscribe() {
        shared_api.user.presence.send({ type: 'subscribe', to: this.get('jid') });
    }

    /**
     * Upon receiving the presence stanza of type "unsubscribed",
     * the user SHOULD acknowledge receipt of that subscription state
     * notification by sending a presence stanza of type "unsubscribe"
     * this step lets the user's server know that it MUST no longer
     * send notification of the subscription state change to the user.
     */
    ackUnsubscribe() {
        shared_api.send(contact_stx`<presence type="unsubscribe" to="${this.get('jid')}" xmlns="jabber:client"></presence>`);
        this.sendRosterRemoveStanza();
        this.destroy();
    }

    /**
     * Unauthorize this contact's presence subscription
     * @param {string} [message] - Optional message to send to the person being unauthorized
     */
    unauthorize(message) {
        rejectPresenceSubscription(this.get('jid'), message);
        this.save({ requesting: false });
        return this;
    }

    /**
     * Authorize presence subscription
     * @param {string} [message] - Optional message to send to the person being authorized
     */
    authorize(message) {
        shared_api.send(contact_stx`
            <presence
                to="${this.get('jid')}"
                type="subscribed"
                xmlns="jabber:client">
                    ${message && message !== '' ? contact_stx`<status>${message}</status>` : ''}
            </presence>`);

        this.save({
            requesting: false,
            subscription: 'from',
        });
        return this;
    }

    /**
     * Remove this contact from the roster
     * @param {boolean} [unauthorize] - Whether to also unauthorize the
     * @returns {Promise<Error|Element>}
     */
    async remove(unauthorize) {
        const subscription = this.get('subscription');
        if (subscription === 'none' && this.get('ask') !== 'subscribe') {
            this.destroy();
            return;
        }
        if (this.get('ask') === 'subscribe' || subscription === 'to') {
            // See: https://datatracker.ietf.org/doc/html/rfc6121#section-3.3.1
            shared_api.send(contact_stx`<presence type="unsubscribe" to="${this.get('jid')}" xmlns="jabber:client"></presence>`);
        }
        if (unauthorize && ['from', 'both'].includes(subscription)) {
            // See: https://datatracker.ietf.org/doc/html/rfc6121#section-3.2.1
            this.unauthorize();
        }
        const promise = this.sendRosterRemoveStanza();
        if (this.collection) this.destroy();

        try {
            return await promise;
        } catch (e) {
            if (contact_u.isElement(e)) {
                // Return if it's only an error stanza
                return e;
            }
            throw e;
        }
    }

    /**
     * @param {import('./types').RosterContactUpdateAttrs} attrs
     * @returns {Promise}
     */
    async update(attrs) {
        this.save(attrs);
        return await shared_api.sendIQ(
            contact_stx`<iq xmlns="jabber:client" type="set">
                <query xmlns="${contact_Strophe.NS.ROSTER}">
                    <item jid="${this.get('jid')}" name="${this.get('nickname')}">
                        ${this.get('groups')?.map(/** @param {string} group */ (group) => contact_stx`<group>${group}</group>`)}
                    </item>
                </query>
            </iq>`,
        );
    }

    /**
     * Instruct the XMPP server to remove this contact from our roster
     * @returns {Promise}
     */
    async sendRosterRemoveStanza() {
        const iq = contact_stx`<iq type="set" xmlns="jabber:client">
            <query xmlns="${contact_Strophe.NS.ROSTER}">
                <item jid="${this.get('jid')}" subscription="remove"/>
            </query>
        </iq>`;
        return await shared_api.sendIQ(iq);
    }

    isUnsaved() {
        return this.get('subscription') === undefined;
    }
}

/* export default */ const roster_contact = (contact_RosterContact);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/contacts.js









const { Strophe: contacts_Strophe, sizzle: contacts_sizzle, stx: contacts_stx, u: contacts_u, Stanza: contacts_Stanza } = api_public.env;

/**
 * @extends {Collection<RosterContact>}
 */
class RosterContacts extends Collection {
    constructor() {
        super();
        this.model = roster_contact;
        this.data = null;
    }

    initialize() {
        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `roster.state-${bare_jid}-${this.get('jid')}`;
        this.state = new skeletor_esm_Model(/** @type {import('./types').ContactsStateAttrs} */ ({ id, 'collapsed_groups': [] }));
        initStorage(this.state, id);
        this.state.fetch();
        shared_api.listen.on(
            'chatBoxClosed',
            /** @param {import('../../shared/chatbox').default} model */
            (model) => this.removeUnsavedContact(model),
        );
    }

    /**
     * @param {import('../../shared/chatbox').default} model
     */
    removeUnsavedContact(model) {
        const contact = this.get(model.get('jid'));
        if (contact && contact.get('subscription') === undefined) {
            contact.destroy();
        }
    }

    onConnected() {
        // Called as soon as the connection has been established
        // (either after initial login, or after reconnection).
        // Use the opportunity to register stanza handlers.
        this.registerRosterHandler();
        this.registerRosterXHandler();
    }

    /**
     * Register a handler for roster IQ "set" stanzas, which update
     * roster contacts.
     */
    registerRosterHandler() {
        // Register a handler for roster IQ "set" stanzas, which update
        // roster contacts.
        shared_api.connection.get().addHandler(
            /** @param {Element} iq */ (iq) => {
                shared_converse.state.roster.onRosterPush(iq);
                return true;
            },
            contacts_Strophe.NS.ROSTER,
            'iq',
            'set',
        );
    }

    /**
     * Register a handler for RosterX message stanzas, which are
     * used to suggest roster contacts to a user.
     */
    registerRosterXHandler() {
        let t = 0;
        const connection = shared_api.connection.get();
        connection.addHandler(
            /** @param {Element} msg */ (msg) => {
                setTimeout(() => {
                    const { roster } = shared_converse.state;
                    shared_api.connection.get().flush();
                    roster.subscribeToSuggestedItems(msg);
                }, t);
                t += msg.querySelectorAll('item').length * 250;
                return true;
            },
            contacts_Strophe.NS.ROSTERX,
            'message',
            null,
        );
    }

    /**
     * Fetches the roster contacts, first by trying the browser cache,
     * and if that's empty, then by querying the XMPP server.
     * @returns {promise} Promise which resolves once the contacts have been fetched.
     */
    async fetchRosterContacts() {
        const result = await new Promise((resolve, reject) => {
            this.fetch({
                add: true,
                silent: true,
                success: resolve,
                error: (_, e) => reject(e),
            });
        });
        if (contacts_u.isErrorObject(result)) {
            src_log.error(result);
            // Force a full roster refresh
            shared_converse.session.save('roster_cached', false);
            this.data.save('version', undefined);
        }

        if (shared_converse.session.get('roster_cached')) {
            /**
             * The contacts roster has been retrieved from the local cache
             * @event _converse#cachedRoster
             * @type {RosterContacts}
             * @example _converse.api.listen.on('cachedRoster', (items) => { ... });
             * @example _converse.api.waitUntil('cachedRoster').then(items => { ... });
             */
            shared_api.trigger('cachedRoster', result);
        } else {
            shared_api.connection.get().send_initial_presence = true;
            return shared_converse.state.roster.fetchFromServer();
        }
    }

    /**
     * @param {Element} msg
     */
    subscribeToSuggestedItems(msg) {
        Array.from(msg.querySelectorAll('item')).forEach((item) => {
            if (item.getAttribute('action') === 'add') {
                this.addContact({
                    jid: item.getAttribute('jid'),
                    name: item.getAttribute('name'),
                    subscription: 'to',
                });
            }
        });
        return true;
    }

    /**
     * @param {string} jid
     */
    isSelf(jid) {
        return contacts_u.isSameBareJID(jid, shared_api.connection.get().jid);
    }

    /**
     * Send an IQ stanza to the XMPP server to add a new roster contact.
     * @param {import('./types').RosterContactAttributes} attributes
     */
    sendContactAddIQ(attributes) {
        const { jid, groups } = attributes;
        const name = attributes.name ? attributes.name : null;
        const iq = contacts_stx`
            <iq type="set" xmlns="jabber:client">
                <query xmlns="${contacts_Strophe.NS.ROSTER}">
                    <item jid="${jid}" ${name ? contacts_Stanza.unsafeXML(`name="${contacts_Strophe.xmlescape(name)}"`) : ''}>
                        ${groups?.map(/** @param {string} g */ (g) => contacts_stx`<group>${g}</group>`)}
                    </item>
                </query>
            </iq>`;
        return shared_api.sendIQ(iq);
    }

    /**
     * Adds a {@link RosterContact} instance to {@link RosterContacts} and
     * optionally (if subscribe=true) subscribe to the contact's presence
     * updates which also adds the contact to the roster on the XMPP server.
     * @param {import('./types').RosterContactAttributes} attributes
     * @param {boolean} [persist=true] - Whether the contact should be persisted to the user's roster.
     * @param {boolean} [subscribe=true] - Whether we should subscribe to the contacts presence updates.
     * @param {string} [message=''] - An optional message to include with the presence subscription
     * @returns {Promise<RosterContact>}
     */
    async addContact(attributes, persist = true, subscribe = true, message = '') {
        const { jid, name } = attributes ?? {};
        if (!jid || !contacts_u.isValidJID(jid)) throw new Error('Invalid JID provided to addContact');

        await shared_api.waitUntil('rosterContactsFetched');

        if (persist) {
            try {
                await this.sendContactAddIQ(attributes);
            } catch (e) {
                src_log.error(e);
                const { __ } = shared_converse;
                alert(__('Sorry, an error occurred while trying to add %1$s as a contact.', name || jid));
                throw e;
            }
        }

        const contact = await this.create(
            {
                ...{
                    ask: undefined,
                    nickname: name,
                    groups: [],
                    requesting: false,
                    subscription: persist ? 'none' : undefined,
                },
                ...attributes,
            },
            { sort: false },
        );

        if (contact && subscribe) contact.subscribeToPresence(message);

        return contact;
    }

    /**
     * @param {import('./types').PresenceAttributes} attrs
     * @param {string} [auth_msg=''] - Optional message to be included in the
     *   authorization of the contacts subscription request.
     * @param {string} [sub_msg=''] - Optional message to be included in our
     *   reciprocal subscription request.
     */
    async subscribeBack(attrs, auth_msg = '', sub_msg = '') {
        const bare_jid = attrs.bare_jid;
        const contact = this.get(bare_jid);
        const { RosterContact } = shared_converse.exports;
        if (contact instanceof RosterContact) {
            contact.authorize().subscribeToPresence();
        } else {
            // Can happen when a subscription is retried or roster was deleted
            const contact = await this.addContact({
                jid: bare_jid,
                name: attrs.nickname,
                groups: [],
                subscription: 'from',
            });
            if (contact instanceof RosterContact) {
                contact.authorize(auth_msg).subscribeToPresence(sub_msg);
            }
        }
    }

    /**
     * Handle roster updates from the XMPP server.
     * See: https://xmpp.org/rfcs/rfc6121.html#roster-syntax-actions-push
     * @param {Element} iq - The IQ stanza received from the XMPP server.
     */
    onRosterPush(iq) {
        const id = iq.getAttribute('id');
        const from = iq.getAttribute('from');
        const bare_jid = shared_converse.session.get('bare_jid');
        if (from && from !== bare_jid) {
            // https://tools.ietf.org/html/rfc6121#page-15
            //
            // A receiving client MUST ignore the stanza unless it has no 'from'
            // attribute (i.e., implicitly from the bare JID of the user's
            // account) or it has a 'from' attribute whose value matches the
            // user's bare JID <user@domainpart>.
            src_log.warn(`Ignoring roster illegitimate roster push message from ${iq.getAttribute('from')}`);
            return;
        }
        shared_api.send(contacts_stx`<iq type="result" id="${id}" from="${shared_api.connection.get().jid}" xmlns="jabber:client" />`);

        const query = contacts_sizzle(`query[xmlns="${contacts_Strophe.NS.ROSTER}"]`, iq).pop();
        this.data.save('version', query.getAttribute('ver'));

        const items = contacts_sizzle(`item`, query);
        if (items.length > 1) {
            src_log.error(iq);
            throw new Error('Roster push query may not contain more than one "item" element.');
        }
        if (items.length === 0) {
            src_log.warn(iq);
            src_log.warn('Received a roster push stanza without an "item" element.');
            return;
        }

        this.updateContact(items.pop());
        /**
         * When the roster receives a push event from server (i.e. new entry in your contacts roster).
         * @event _converse#rosterPush
         * @type {Element}
         * @example _converse.api.listen.on('rosterPush', iq => { ... });
         */
        shared_api.trigger('rosterPush', iq);
        return;
    }

    shouldUseRosterVersioning() {
        return (
            shared_api.settings.get('enable_roster_versioning') &&
            this.data.get('version') &&
            shared_api.disco.stream.getFeature('ver', 'urn:xmpp:features:rosterver')
        );
    }

    /**
     * Fetches the roster from the XMPP server and updates the local state
     * @emits _converse#roster
     * @returns {Promise}
     */
    async fetchFromServer() {
        const stanza = contacts_stx`
            <iq type="get" id="${contacts_u.getUniqueId('roster')}" xmlns="jabber:client">
                <query xmlns="${contacts_Strophe.NS.ROSTER}"
                    ${this.shouldUseRosterVersioning() ? contacts_Stanza.unsafeXML(`ver="${this.data.get('version')}"`) : ''}>
                </query>
            </iq>`;

        const iq = await shared_api.sendIQ(stanza, null, false);

        if (iq.getAttribute('type') === 'result') {
            const query = contacts_sizzle(`query[xmlns="${contacts_Strophe.NS.ROSTER}"]`, iq).pop();
            if (query) {
                const items = contacts_sizzle(`item`, query);
                if (!this.data.get('version') && this.models.length) {
                    // We're getting the full roster, so remove all cached
                    // contacts that aren't included in it.
                    const jids = items.map(/** @param {Element} item */ (item) => item.getAttribute('jid'));
                    this.forEach((m) => !m.get('requesting') && !jids.includes(m.get('jid')) && m.destroy());
                }
                items.forEach((item) => this.updateContact(item));
                this.data.save('version', query.getAttribute('ver'));
            }
        } else if (!contacts_u.isServiceUnavailableError(iq)) {
            // Some unknown error happened, so we will try to fetch again if the page reloads.
            src_log.error(iq);
            src_log.error('Error while trying to fetch roster from the server');
            return;
        }

        shared_converse.session.save('roster_cached', true);
        /**
         * When the roster has been received from the XMPP server.
         * See also the `cachedRoster` event further up, which gets called instead of
         * `roster` if its already in the cache.
         * @event _converse#roster
         * @type {Element}
         * @example _converse.api.listen.on('roster', iq => { ... });
         * @example _converse.api.waitUntil('roster').then(iq => { ... });
         */
        shared_api.trigger('roster', iq);
    }

    /**
     * Update or create RosterContact models based on the given `item` XML
     * node received in the resulting IQ stanza from the server.
     * @param {Element} item
     */
    updateContact(item) {
        const jid = item.getAttribute('jid');
        const contact = this.get(jid);
        const subscription = item.getAttribute('subscription');
        if (subscription === 'remove') {
            return contact?.destroy();
        }

        const ask = item.getAttribute('ask');
        const nickname = item.getAttribute('name');
        const groups = [
            ...new Set(
                contacts_sizzle('group', item)
                    .map((e) => e.textContent?.trim())
                    .filter((n) => n),
            ),
        ];

        if (contact) {
            // We only find out about requesting contacts via the
            // presence handler, so if we receive a contact
            // here, we know they aren't requesting anymore.
            contact.save({ subscription, ask, nickname, groups, 'requesting': null });
        } else {
            this.create({ nickname, ask, groups, jid, subscription }, { sort: false });
        }
    }

    /**
     * @param {import('./types').PresenceAttributes} attrs
     */
    createRequestingContact(attrs) {
        const user_data = {
            jid: attrs.bare_jid,
            subscription: 'none',
            ask: null,
            requesting: true,
            nickname: attrs.nickname,
        };
        /**
         * Triggered when someone has requested to subscribe to your presence (i.e. to be your contact).
         * @event _converse#contactRequest
         * @type {RosterContact}
         * @example _converse.api.listen.on('contactRequest', contact => { ... });
         */
        shared_api.trigger('contactRequest', this.create(user_data));
    }

    /**
     * @param {import('./types').PresenceAttributes} attrs
     */
    handleIncomingSubscription(attrs) {
        const from = attrs.from;
        const bare_jid = attrs.bare_jid;
        const contact = this.get(bare_jid);

        if (!shared_api.settings.get('allow_contact_requests')) {
            const { __ } = shared_converse;
            rejectPresenceSubscription(from, __('This client does not allow presence subscriptions'));
        }
        if (shared_api.settings.get('auto_subscribe')) {
            if (!contact || contact.get('subscription') !== 'to') {
                this.subscribeBack(attrs);
            } else {
                contact.authorize();
            }
        } else {
            if (contact) {
                if (contact.get('subscription') !== 'none') {
                    contact.authorize();
                } else if (contact.get('ask') === 'subscribe') {
                    contact.authorize();
                }
            } else {
                this.createRequestingContact(attrs);
            }
        }
    }

    /**
     * @param {import('./types').PresenceAttributes} attrs
     */
    handleOwnPresence(attrs) {
        const { from, resource, show, type: presence_type } = attrs;
        const { profile } = shared_converse.state;

        if (
            shared_api.connection.get().jid !== from &&
            presence_type !== 'unavailable' &&
            (shared_api.settings.get('synchronize_availability') === true ||
                shared_api.settings.get('synchronize_availability') === resource)
        ) {
            // Another resource has changed its status and
            // synchronize_availability option set to update,
            // we'll update ours as well.
            profile.save({ show, presence: 'online', status_message: attrs.status }, { silent: true });
        }
        if (shared_converse.session.get('jid') === from && presence_type === 'unavailable') {
            // XXX: We've received an "unavailable" presence from our
            // own resource. Apparently this happens due to a
            // Prosody bug, whereby we send an IQ stanza to remove
            // a roster contact, and Prosody then sends
            // "unavailable" globally, instead of directed to the
            // particular user that's removed.
            //
            // Here is the bug report: https://prosody.im/issues/1121
            //
            // I'm not sure whether this might legitimately happen
            // in other cases.
            //
            // As a workaround for now we simply send our presence again,
            // otherwise we're treated as offline.
            shared_api.user.presence.send();
        }
    }

    /**
     * @param {import('./types').PresenceAttributes} attrs
     */
    presenceHandler(attrs) {
        if (attrs.type === 'error') return true;
        if (attrs.is_muc) return true;

        const { bare_jid, type: presence_type } = attrs;

        if (this.isSelf(bare_jid)) {
            return this.handleOwnPresence(attrs);
        }

        const contact = this.get(bare_jid);
        if (contact && contact.get('status') !== attrs.status) {
            contact.save({ status: attrs.status });
        }

        if (presence_type === 'subscribed' && contact) {
            contact.ackSubscribe();
        } else if (presence_type === 'unsubscribed' && contact) {
            contact.ackUnsubscribe();
        } else if (presence_type === 'unsubscribe') {
            return;
        } else if (presence_type === 'subscribe') {
            this.handleIncomingSubscription(attrs);
        } else if (presence_type === 'unavailable' && contact) {
            contact.presence.removeResource(attrs);
        } else if (contact) {
            // presence_type is undefined, i.e. an "available" presence
            contact.presence.addResource(attrs);
        }
    }
}

/* export default */ const contacts = (RosterContacts);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/resource.js


class Resource extends skeletor_esm_Model {
    get idAttribute() {
        return 'name';
    }
}

/* export default */ const roster_resource = (Resource);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/resources.js




/**
 * @extends {Collection<Resource>}
 */
class Resources extends Collection {
    /**
     * Auto-hydrate the persisted resources from storage on construction.
     * @returns {boolean}
     */
    get autoSync() {
        return true;
    }

    /**
     * @param {Resource[]} _models
     * @param {{ jid: string }} [options]
     */
    initialize(_models, options) {
        this.model = roster_resource;
        // Storage is set here before skeletor's autoSync hydration check.
        initStorage(this, `converse.resources-${options?.jid}`, 'session');
    }
}

/* export default */ const resources = (Resources);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/presence.js



/**
 * @extends {Model<import('./types').PresenceModelAttrs>}
 */
class Presence extends skeletor_esm_Model {
    get idAttribute() {
        return 'jid';
    }

    defaults() {
        return {
            presence: /** @type {import('./types').PresenceTypes | 'offline'} */ ('offline'),
        };
    }

    initialize() {
        super.initialize();
        this.resources = new resources(null, { jid: this.get('jid') });

        this.listenTo(this.resources, 'update', this.onResourcesChanged);
        this.listenTo(this.resources, 'change', this.onResourcesChanged);
    }

    onResourcesChanged() {
        const hpr = this.getHighestPriorityResource();
        const { presence, show } = hpr?.attributes ?? {};
        this.save({ presence, show });
    }

    getStatus() {
        const presence = this.get('presence');
        if (presence === 'offline') {
            return 'offline';
        }
        return this.get('show') || presence || 'offline';
    }

    /**
     * Return the resource with the highest priority.
     * If multiple resources have the same priority, take the latest one.
     */
    getHighestPriorityResource() {
        return this.resources.sortBy((r) => `${r.get('priority')}-${r.get('timestamp')}`).reverse()[0];
    }

    /**
     * Adds a new resource and it's associated attributes as taken
     * from the passed in presence stanza.
     * Also updates the presence if the resource has higher priority (and is newer).
     * @param {import('./types').PresenceAttributes} attrs
     */
    addResource(attrs) {
        const settings = {
            ...attrs,
            name: attrs.resource,
            presence: attrs.type === 'unavailable' ? 'offline' : 'online',
        };
        const resource = this.resources.get(settings.name);
        if (resource) {
            resource.save(settings);
        } else {
            this.resources.create(settings);
        }
    }

    /**
     * Remove the passed in resource from the resources map.
     * Also redetermines the presence given that there's one less
     * resource.
     * @param {import('./types').PresenceAttributes} attrs
     */
    removeResource({ resource: name }) {
        const resource = this.resources.get(name);
        resource?.destroy();
    }
}

/* export default */ const roster_presence = (Presence);

;// CONCATENATED MODULE: ./src/headless/plugins/roster/presences.js





/**
 * @extends {Collection<Presence>}
 */
class Presences extends Collection {
    constructor() {
        super();
        this.model = roster_presence;
    }

    initialize() {
        super.initialize();

        const bare_jid = shared_converse.session.get('bare_jid');
        const id = `converse.presences-${bare_jid}`;
        initStorage(this, id, 'session');

        // We might be continuing an existing session, so we fetch cached presence data.
        this.initialized = new Promise((r) => this.fetch({ success: r, error: r }));
    }
}

/* export default */ const roster_presences = (Presences);

;// CONCATENATED MODULE: ./src/headless/plugins/status/profile.js







const { Stanza: profile_Stanza, Strophe: profile_Strophe, stx: profile_stx } = api_public.env;

class Profile extends model_with_vcard_ModelWithVCard(color_ColorAwareModel(skeletor_esm_Model)) {
    defaults() {
        return {
            presence: 'online',
            status: null,
            show: null,
            groups: [],
        };
    }

    /**
     * @return {import('./types').ConnectionStatus}
     */
    getStatus() {
        const presence = this.get('presence');
        if (presence === 'offline' || presence === 'unavailable') {
            return 'offline';
        }
        return this.get('show') || presence || 'offline';
    }

    get(attr) {
        if (attr === 'jid') {
            return shared_converse.session.get('bare_jid');
        } else if (attr === 'nickname') {
            return shared_api.settings.get('nickname');
        }
        return super.get(attr);
    }

    /**
     * @param {string|Object} key
     * @param {string|Object} [val]
     * @param {Object} [options]
     */
    set(key, val, options) {
        if (key === 'jid' || key === 'nickname') {
            throw new Error('Readonly property');
        }
        return super.set(key, val, options);
    }

    initialize() {
        super.initialize();
        this.on('change', (item) => {
            // Use `hasChanged` (membership) rather than truthiness of the new value:
            // clearing `show` (e.g. auto-away reset on user activity, or going back to
            // 'online') sets it to undefined, which a `item.changed?.show` check would
            // miss — leaving contacts seeing the stale away/xa presence.
            if (item.hasChanged('status') || item.hasChanged('status_message') || item.hasChanged('show')) {
                shared_api.user.presence.send({
                    show: this.get('show'),
                    status: this.get('status_message'),
                });
            }
        });
    }

    /**
     * @param {import('../roster/types.js').ContactDisplayNameOptions} [options]
     */
    getDisplayName(options) {
        const { __ } = shared_converse;
        const name = this.vcard?.get('fullname') || this.getNickname() || this.get('jid');
        return options?.context === 'roster' ? `${name} (${__('me')})` : name;
    }

    /**
     * @returns {string|undefined}
     */
    getNickname() {
        return this.vcard?.getNickname() || shared_api.settings.get('nickname') || undefined;
    }

    /**
     * Constructs a presence stanza
     * @param {import('./types').PresenceAttrs} [attrs={}]
     * @returns {Promise<Stanza>}
     */
    async constructPresence(attrs = {}) {
        const { type, to } = attrs;
        const { profile } = shared_converse.state;
        const status = typeof attrs.status === 'string' ? attrs.status : this.get('status_message');
        const show = attrs.show || this.get('status');
        const include_nick = type === 'subscribe';
        const nick = include_nick ? profile.getNickname() : null;
        const priority = shared_api.settings.get('priority');
        const { idle: is_idle, seconds: idle_seconds } = shared_api.user.idle.get();

        let idle_since;
        if (is_idle) {
            idle_since = new Date();
            idle_since.setSeconds(idle_since.getSeconds() - idle_seconds);
        }

        const presence = profile_stx`
            <presence ${to ? profile_Stanza.unsafeXML(`to="${profile_Strophe.xmlescape(to)}"`) : ''}
                    ${type ? profile_Stanza.unsafeXML(`type="${profile_Strophe.xmlescape(type)}"`) : ''}
                    xmlns="jabber:client">
                ${nick ? profile_stx`<nick xmlns="${profile_Strophe.NS.NICK}">${nick}</nick>` : ''}
                ${show ? profile_stx`<show>${show}</show>` : ''}
                ${status ? profile_stx`<status>${status}</status>` : ''}
                <priority>${Number.isNaN(Number(priority)) ? 0 : priority}</priority>
                ${idle_since ? profile_stx`<idle xmlns="${profile_Strophe.NS.IDLE}" since="${idle_since.toISOString()}"></idle>` : ''}
            </presence>`;

        /**
         * *Hook* which allows plugins to modify a presence stanza
         * @event _converse#constructedPresence
         */
        return await shared_api.hook('constructedPresence', null, presence);
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/status/utils.js




/**
 * @param {boolean} reconnecting
 */
function status_utils_onStatusInitialized(reconnecting) {
    /**
     * Triggered when the user's own chat status has been initialized.
     * @event _converse#statusInitialized
     * @example _converse.api.listen.on('statusInitialized', status => { ... });
     * @example _converse.api.waitUntil('statusInitialized').then(() => { ... });
     */
    shared_api.trigger('statusInitialized', reconnecting);
}

/**
 * @param {boolean} reconnecting
 */
function initStatus(reconnecting) {
    // If there's no profile obj, then we were never connected to
    // begin with, so we set reconnecting to false.
    reconnecting = shared_converse.state.profile === undefined ? false : reconnecting;
    if (reconnecting) {
        status_utils_onStatusInitialized(reconnecting);
    } else {
        const id = `converse.xmppstatus-${shared_converse.session.get('bare_jid')}`;
        shared_converse.state.profile = new shared_converse.exports.Profile({ id });
        shared_converse.state.xmppstatus = shared_converse.state.profile; // Deprecated
        Object.assign(shared_converse, { xmppstatus: shared_converse.state.profile }); // Deprecated
        initStorage(shared_converse.state.profile, id, 'session');
        shared_converse.state.profile.fetch({
            success: () => status_utils_onStatusInitialized(reconnecting),
            error: () => status_utils_onStatusInitialized(reconnecting),
            silent: true,
        });
    }
}

;// CONCATENATED MODULE: ./src/headless/plugins/status/plugin.js








api_public.plugins.add('converse-status', {
    initialize() {
        shared_api.settings.extend({ priority: 0 });
        shared_api.promises.add(['statusInitialized']);

        const exports = {
            XMPPStatus: Profile, // Deprecated
            Profile: Profile,
        };
        Object.assign(shared_converse, exports); // Deprecated
        Object.assign(shared_converse.exports, exports);
        Object.assign(shared_converse.api.user, status_api);

        shared_api.listen.on('clearSession', () => {
            if (shouldClearCache(shared_converse) && shared_converse.state.profile) {
                shared_converse.state.profile.destroy();
                delete shared_converse.state.profile;
                Object.assign(shared_converse, { profile: undefined }); // XXX DEPRECATED
                shared_api.promises.add(['statusInitialized']);
            }
        });

        shared_api.listen.on('connected', () => initStatus(false));
        shared_api.listen.on('reconnected', () => initStatus(true));
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/status/index.js





;// CONCATENATED MODULE: ./src/headless/plugins/roster/api.js





const { Strophe: roster_api_Strophe } = api_public.env;

/* export default */ const roster_api = ({
    /**
     * @namespace _converse.api.contacts
     * @memberOf _converse.api
     *
     * @typedef {import('./contact').default} RosterContact
     */
    contacts: {
        /**
         * This method is used to retrieve roster contacts.
         *
         * @method _converse.api.contacts.get
         * @param {(string[]|string)} jids The JID or JIDs of the contacts to be returned.
         * @returns {promise} Promise which resolves with the
         *  {@link RosterContact} (or an array of them) representing the contact.
         *
         * @example
         * // Fetch a single contact
         * _converse.api.listen.on('rosterContactsFetched', function () {
         *     const contact = await _converse.api.contacts.get('buddy@example.com')
         *     // ...
         * });
         *
         * @example
         * // To get multiple contacts, pass in an array of JIDs:
         * _converse.api.listen.on('rosterContactsFetched', function () {
         *     const contacts = await _converse.api.contacts.get(
         *         ['buddy1@example.com', 'buddy2@example.com']
         *     )
         *     // ...
         * });
         *
         * @example
         * // To return all contacts, simply call ``get`` without any parameters:
         * _converse.api.listen.on('rosterContactsFetched', function () {
         *     const contacts = await _converse.api.contacts.get();
         *     // ...
         * });
         */
        async get(jids) {
            await shared_api.waitUntil('rosterContactsFetched');
            const { roster } = shared_converse.state;
            const _getter = /** @param {string} jid */ (jid) => roster.get(roster_api_Strophe.getBareJidFromJid(jid));
            if (jids === undefined) {
                jids = roster.pluck('jid');
            } else if (typeof jids === 'string') {
                return _getter(jids);
            }
            return /** @type {string[]} */ (jids).map(_getter);
        },

        /**
         * Remove a contact from the roster
         * @param {string} jid
         * @param {boolean} [unsubscribe] - Whether we should unsubscribe
         * from the contact's presence updates.
         */
        async remove(jid, unsubscribe) {
            await shared_api.waitUntil('rosterContactsFetched');
            const contact = await shared_api.contacts.get(jid);
            contact.remove(unsubscribe);
        },

        /**
         * Add a contact.
         * @param {import('./types').RosterContactAttributes} attributes
         * @param {boolean} [persist=true] - Whether the contact should be persisted to the user's roster.
         * @param {boolean} [subscribe=true] - Whether we should subscribe to the contacts presence updates.
         * @param {string} [message=''] - An optional message to include with the presence subscription
         * @param {boolean} subscribe - Whether a presence subscription should
         *      be sent out to the contact being added.
         * @returns {Promise<RosterContact>}
         * @example
         *      api.contacts.add({ jid: 'buddy@example.com', groups: ['Buddies'] })
         */
        async add(attributes, persist = true, subscribe = true, message = '') {
            if (!isValidJID(attributes?.jid)) throw new Error('api.contacts.add: Valid JID required');

            const { roster } = shared_converse.state;
            return roster.addContact(attributes, persist, subscribe, message);
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/roster/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */












api_public.plugins.add('converse-roster', {
    dependencies: ['converse-status'],

    initialize() {
        shared_api.settings.extend({
            allow_contact_requests: true,
            auto_subscribe: false,
            enable_roster_versioning: true,
            show_self_in_roster: true,
            synchronize_availability: true,
        });

        shared_api.promises.add([
            'cachedRoster',
            'roster',
            'rosterContactsFetched',
            'rosterInitialized',
            'presencesInitialized',
        ]);

        // API methods only available to plugins
        Object.assign(shared_converse.api, roster_api);
        Object.assign(headless_utils, { roster: { isUnsavedContact: isUnsavedContact } });

        const { __ } = shared_converse;
        const labels = {
            HEADER_UNSAVED_CONTACTS: __('Unsaved contacts'),
            HEADER_CURRENT_CONTACTS: __('My contacts'),
            HEADER_PENDING_CONTACTS: __('Pending contacts'),
            HEADER_REQUESTING_CONTACTS: __('Contact requests'),
            HEADER_UNGROUPED: __('Ungrouped'),
            HEADER_UNREAD: __('New messages'),
        };
        Object.assign(shared_converse, labels); // XXX DEPRECATED
        Object.assign(shared_converse.labels, labels);

        const exports = { Presence: roster_presence, Presences: roster_presences, RosterContact: roster_contact, RosterContacts: contacts };
        Object.assign(shared_converse, exports); // XXX DEPRECATED
        Object.assign(shared_converse.exports, exports);

        shared_api.listen.on('beforeTearDown', () => utils_unregisterPresenceHandler());
        shared_api.listen.on('clearSession', utils_onClearSession);
        shared_api.listen.on('presencesInitialized', onPresencesInitialized);
        shared_api.listen.on('statusInitialized', utils_onStatusInitialized);
        shared_api.listen.on('streamResumptionFailed', () => shared_converse.session.set('roster_cached', false));

        shared_api.waitUntil('rosterContactsFetched').then(onRosterContactsFetched);
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/roster/index.js









;// CONCATENATED MODULE: ./src/headless/plugins/smacks/index.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 * @description Converse.js plugin which adds support for XEP-0198: Stream Management.
 *
 * Stream Management itself (counters, the unacked queue, <enable/>/<resume/>
 * negotiation and stanza re-sending) is implemented natively by Strophe and
 * activated through the `enableStreamManagement` connection option, which
 * `api.connection.init` derives from the `enable_smacks` setting. This
 * plugin only registers the settings and re-emits Strophe's failure hook as
 * a Converse event.
 */



const { Strophe: smacks_Strophe } = api_public.env;

smacks_Strophe.addNamespace('SM', 'urn:xmpp:sm:3');

api_public.plugins.add('converse-smacks', {
    initialize() {
        // Configuration values for this plugin
        // ====================================
        // Refer to docs/source/configuration.rst for explanations of these
        // configuration settings.
        shared_api.settings.extend({
            enable_smacks: true,
            smacks_max_unacked_stanzas: 5,
        });

        shared_api.listen.on('connectionInitialized', () => {
            const { sm } = shared_api.connection.get();
            if (!sm) {
                return;
            }
            sm.onResumed = () => {
                /**
                 * Triggered when the previous XEP-0198 stream was resumed.
                 * Fires while the <resumed/> nonza is being processed
                 * (before the server's replay of queued stanzas is handled)
                 * so it can be used to register handlers for those stanzas
                 * (resource binding, and therefore `beforeResourceBinding`,
                 * is skipped on resumption).
                 * @event _converse#streamResumed
                 */
                shared_api.trigger('streamResumed');
            };

            /**
             * @param {Element} _el
             * @param {boolean} resume_failed
             */
            sm.onFailed = (_el, resume_failed) => {
                if (resume_failed) {
                    /**
                     * Triggered when the XEP-0198 stream could not be resumed.
                     * @event _converse#streamResumptionFailed
                     */
                    shared_api.trigger('streamResumptionFailed');
                }
            };
        });
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/vcard.js



class VCard extends skeletor_esm_Model {
    /**
     * @param {import("../../shared/types").ModelAttributes} attrs
     * @param {import("./types").VCardModelOptions} options
     */
    constructor(attrs, options) {
        super(attrs, options);
        this._vcard = null;
    }

    /**
     * @param {import("../../shared/types.ts").ModelAttributes} [_attrs]
     * @param {import("./types.ts").VCardModelOptions} [options]
     */
    initialize(_attrs, options) {
        // A vcard rehydrated from cache (`fromStorage`) already represents a known
        // entity, so it must not eagerly refetch on every page load.
        const lazy = !!options?.lazy_load || !!options?.fromStorage;
        this.lazy_load = shared_api.settings.get('lazy_load_vcards') && lazy;

        if (this.lazy_load) {
            this.once('visibilityChanged', () => shared_api.vcard.update(this));
        } else {
            shared_api.vcard.update(this);
        }
    }

    get idAttribute() {
        return 'jid';
    }

    /**
     * Helper method that returns the user's nickname given that there's more
     * than on esource.
     *
     * `pep_nickname` (XEP-0172 User Nickname, pushed over PEP) wins over the
     * vcard-temp `NICKNAME`/`FN`.
     * @returns {string|undefined}
     */
    getNickname() {
        return this.get('pep_nickname') || this.get('nickname') || undefined;
    }

    /**
     * The best human-readable name resolvable for this JID from its identity
     * sources, or undefined if none is known.
     * @returns {string|undefined}
     */
    getName() {
        return this.getNickname() || this.get('fullname') || undefined;
    }

    getDisplayName() {
        return this.getName() || this.get('jid');
    }
}

/* export default */ const vcard_vcard = (VCard);

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/vcards.js







/**
 * @extends {Collection<VCard>}
 */
class VCards extends Collection {
    constructor() {
        super();
        this.model = vcard_vcard;
    }

    async initialize() {
        const { session } = shared_converse;
        const bare_jid = session.get('bare_jid');
        const cache_key = `${bare_jid}-converse.vcards`;
        initStorage(this, cache_key);

        await this.fetchVCards();

        /**
         * Triggered as soon as the `_converse.state.vcards` collection has
         * been initialized and populated from cache.
         * @event _converse#VCardsInitialized
         */
        shared_api.trigger('VCardsInitialized');
    }

    fetchVCards() {
        const deferred = openpromise_getOpenPromise();
        this.fetch({
            success: () => deferred.resolve(),
            error: () => deferred.resolve(),
        });
        return deferred;
    }
}

/* export default */ const vcard_vcards = (VCards);

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/api.js
/**
 * @typedef {import('@converse/skeletor').Model} Model
 */






const { Strophe: vcard_api_Strophe, dayjs: vcard_api_dayjs, u: vcard_api_u, stx: vcard_api_stx } = api_public.env;

/* export default */ const vcard_api = ({
    /**
     * The XEP-0054 VCard API
     *
     * This API lets you access and update user VCards
     *
     * @namespace _converse.api.vcard
     * @memberOf _converse.api
     */
    vcard: {
        /**
         * Enables setting new values for a VCard.
         *
         * Sends out an IQ stanza to set the user's VCard and if
         * successful, it updates the {@link _converse.VCard}
         * for the passed in JID.
         *
         * @method _converse.api.vcard.set
         * @param {string} jid The JID for which the VCard should be set
         * @param {import("./types").VCardData} data A map of VCard keys and values
         * @example
         * let jid = _converse.bare_jid;
         * _converse.api.vcard.set( jid, {
         *     'fn': 'John Doe',
         *     'nickname': 'jdoe'
         * }).then(() => {
         *     // Success
         * }).catch((e) => {
         *     // Failure, e is your error object
         * }).
         */
        async set(jid, data) {
            if (!jid) throw Error('No jid provided for the VCard data');
            shared_api.waitUntil('VCardsInitialized');

            let vcard = shared_converse.state.vcards.get(jid);
            const old_vcard_attrs = vcard?.attributes ?? null;
            if (vcard && old_vcard_attrs.image !== data.image) {
                // Optimistically update the vcard with image data. Otherwise some servers (e.g. Ejabberd)
                // could send a XEP-0153 vcard:update presence which would cause us to refetch the vcard again.
                const buffer = vcard_api_u.base64ToArrayBuffer(data.image);
                const hash_ab = await crypto.subtle.digest('SHA-1', buffer);
                vcard.save({
                    image: data.image,
                    image_type: data.image_type,
                    image_hash: vcard_api_u.arrayBufferToHex(hash_ab),
                });
            }

            let result;
            const vcard_el = vcard_api_stx`
                <vCard xmlns="vcard-temp">
                    <FN>${data.fn ?? ''}</FN>
                    <NICKNAME>${data.nickname ?? ''}</NICKNAME>
                    <URL>${data.url ?? ''}</URL>
                    <ROLE>${data.role ?? ''}</ROLE>
                    <EMAIL><INTERNET/><PREF/><USERID>${data.email ?? ''}</USERID></EMAIL>
                    <PHOTO>
                        <TYPE>${data.image_type ?? ''}</TYPE>
                        <BINVAL>${data.image ?? ''}</BINVAL>
                    </PHOTO>
                </vCard>`;
            try {
                result = await shared_api.sendIQ(createStanza('set', jid, vcard_el));
            } catch (e) {
                if (old_vcard_attrs) vcard.save(old_vcard_attrs);
                throw e;
            }

            vcard = await shared_api.vcard.update(jid, true);
            if (vcard_api_u.isOwnJID(jid)) {
                // Send out a XEP-0153 presence with the image hash
                const node = vcard_api_stx`<x xmlns="${vcard_api_Strophe.NS.VCARD_UPDATE}">
                    <photo>${vcard.get('image_hash') ?? ''}</photo>
                </x>`;
                shared_api.user.presence.send({}, node);
            }
            return result;
        },

        /**
         * @method _converse.api.vcard.get
         * @param {Model|string} model Either a `Model` instance, or a string JID.
         *     If a `Model` instance is passed in, then it must have either a `jid`
         *     attribute or a `muc_jid` attribute.
         * @param {boolean} [force] A boolean indicating whether the vcard should be
         *     fetched from the server even if it's been fetched before.
         * @returns {Promise<import("./types").VCardResult|null>} A Promise which resolves
         *     with the VCard data for a particular JID or for a `Model` instance which
         *     represents an entity with a JID (such as a roster contact, chat or chatroom occupant).
         *
         * @example
         * const { api } = _converse;
         * api.waitUntil('rosterContactsFetched').then(() => {
         *     api.vcard.get('someone@example.org').then(
         *         (vcard) => {
         *             // Do something with the vcard...
         *         }
         *     );
         * });
         */
        async get(model, force) {
            shared_api.waitUntil('VCardsInitialized');

            if (typeof model === 'string') return fetchVCard(model);

            const jid = model.get('jid');
            const vcard_updated = model.get('vcard_updated');
            const vcard_error = model.get('vcard_error');

            if (vcard_updated || vcard_error) {
                const muc = shared_converse.state.chatboxes.get(jid);
                if (!muc || !force) return null;

                // We don't get XEP-0153 presence updates for MUCs, so we need
                // to refresh from time to time.
                // We check how long ago it was fetched. If it was longer ago than
                // the last 7 days plus some jitter (to prevent an IQ fetch flood),
                // we try again.
                const { random, round } = Math;
                const subtract_flag = round(random());
                const recent_date = vcard_api_dayjs()
                    .subtract(7, 'days')
                    .subtract(round(random() * 24) * subtract_flag, 'hours')
                    .add(round(random() * 24) * (!subtract_flag ? 1 : 0), 'hours');

                const updated_recently = vcard_api_dayjs(vcard_updated).isAfter(recent_date);
                if (!force && updated_recently) return null;
            }

            if (!jid) {
                src_log.error('No JID to get vcard for');
                return null;
            }

            return await fetchVCard(jid);
        },

        /**
         * Fetches the VCard associated with a particular `Model` instance
         * (by using its `jid` or `muc_jid` attribute) and then updates the model with the
         * returned VCard data.
         *
         * @method _converse.api.vcard.update
         * @param {Model} model A `Model` instance
         * @param {boolean} [force] A boolean indicating whether the vcard should be
         *     fetched again even if it's been fetched before.
         * @returns {promise} A promise which resolves once the update has completed.
         * @example
         * const { api } = _converse;
         * api.waitUntil('rosterContactsFetched').then(async () => {
         *     const chatbox = await api.chats.get('someone@example.org');
         *     api.vcard.update(chatbox);
         * });
         */
        async update(model, force) {
            shared_api.waitUntil('VCardsInitialized');
            const data = await this.get(model, force);
            if (data === null) {
                return;
            }
            model = typeof model === 'string' ? shared_converse.state.vcards.get(model) : model;
            if (!model) {
                src_log.error(`Could not find a VCard model for ${model}`);
                return;
            }
            if (Object.keys(data).length) {
                delete data['stanza'];
                vcard_api_u.safeSave(model, data);
            }
            return model;
        },
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/plugin.js
/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */









const { Strophe: vcard_plugin_Strophe } = api_public.env;

api_public.plugins.add('converse-vcard', {
    dependencies: ['converse-status', 'converse-roster'],

    enabled() {
        return !shared_api.settings.get('blacklisted_plugins')?.includes('converse-vcard');
    },

    initialize() {
        shared_api.settings.extend({
            lazy_load_vcards: true,
        });

        shared_api.promises.add('VCardsInitialized');

        Object.assign(shared_converse.api, vcard_api);

        const exports = { VCard: vcard_vcard, VCards: vcard_vcards };
        Object.assign(shared_converse, exports); // XXX DEPRECATED
        Object.assign(shared_converse.exports, exports);

        shared_api.listen.on(
            'chatRoomInitialized',
            /** @param {import('../muc/muc').default} m */ (m) => {
                m.listenTo(m.occupants, 'change:image_hash', (o) => onOccupantAvatarChanged(o));
            },
        );

        shared_api.listen.on('addClientFeatures', () => {
            shared_api.disco.own.features.add(vcard_plugin_Strophe.NS.VCARD);
            shared_api.disco.own.features.add(vcard_plugin_Strophe.NS.VCARD_UPDATE);

            // Ask XEP-0163 PEP services to push XEP-0172 nickname changes to us.
            shared_api.disco.own.features.add(vcard_plugin_Strophe.NS.NICK + '+notify');
        });
        shared_api.listen.on('clearSession', () => {
            clearVCardsSession();
            resetNickState();
        });

        shared_api.listen.on('statusInitialized', () => {
            // XEP-0172: publish our own nickname to PEP on login and when changed.
            publishOwnNickname();
            shared_converse.state.profile?.on('vcard:change', () => publishOwnNickname());
        });

        shared_api.listen.on('visibilityChanged', ({ el }) => {
            const { model } = el;
            if (model?.vcard) model.vcard.trigger('visibilityChanged');
        });

        shared_api.listen.on('connected', () => {
            const vcards = new shared_converse.exports.VCards();
            shared_converse.state.vcards = vcards;
            Object.assign(shared_converse, { vcards }); // XXX DEPRECATED
        });

        shared_api.listen.on('presencesInitialized', () => {
            registerPresenceHandler();
            registerNickHandler();
        });
        shared_api.listen.on('beforeTearDown', () => {
            unregisterPresenceHandler();
            unregisterNickHandler();
        });
        shared_api.listen.on('constructedPresence', (_, p) => updatePresence(p));
    },
});

;// CONCATENATED MODULE: ./src/headless/plugins/vcard/index.js







;// CONCATENATED MODULE: ./src/headless/index.js














 // XEP-0363 HTTP File Upload

// START: Removable components
// ---------------------------
// The following components may be removed if they're not needed.

 // XEP-0199 XMPP Ping

 // XEP-0206 BOSH
 // XEP-0115 Entity Capabilities
 // RFC-6121 Instant messaging

 // XEP-0030 Service discovery
 // XEP-0050 Ad Hoc Commands
 // Support for headline messages
 // Support for headline messages

// XEP-0313 Message Archive Management


// XEP-0045 Multi-user chat


 // XEP-0199 XMPP Ping
 // XEP-0060 Pubsub
 // XEP-0202 Entity Time
 // XEP-0277 Microblogging
 // XEP-0444 Message Reactions
 // XEP-0092 Software Version

// RFC-6121 Contacts Roster


 // XEP-0198 Stream Management

 // XEP-0054 VCard-temp
// ---------------------------
// END: Removable components



const constants = Object.assign({}, shared_constants_namespaceObject, muc_constants_namespaceObject, omemo_constants_namespaceObject);

Object.assign(shared_converse.constants, constants);




globalThis['converse'] = api_public;

/* export default */ const headless = (api_public);

})();

var __webpack_exports__BaseMessage = __webpack_exports__.XQ;
var __webpack_exports__Bookmark = __webpack_exports__.Xh;
var __webpack_exports__Bookmarks = __webpack_exports__._r;
var __webpack_exports__Builder = __webpack_exports__.M$;
var __webpack_exports__ChatBox = __webpack_exports__.sB;
var __webpack_exports__Collection = __webpack_exports__.pM;
var __webpack_exports__Device = __webpack_exports__.pF;
var __webpack_exports__DeviceList = __webpack_exports__.fs;
var __webpack_exports__DeviceLists = __webpack_exports__.K_;
var __webpack_exports__Devices = __webpack_exports__.uk;
var __webpack_exports__EmojiPicker = __webpack_exports__.pP;
var __webpack_exports__EventEmitter = __webpack_exports__.bk;
var __webpack_exports__MAMPlaceholderMessage = __webpack_exports__.yp;
var __webpack_exports__MUC = __webpack_exports__.mu;
var __webpack_exports__MUCMessage = __webpack_exports__.pJ;
var __webpack_exports__MUCMessages = __webpack_exports__.Q1;
var __webpack_exports__MUCOccupant = __webpack_exports__.PW;
var __webpack_exports__MUCOccupants = __webpack_exports__.O0;
var __webpack_exports__Message = __webpack_exports__.QB;
var __webpack_exports__Messages = __webpack_exports__.B2;
var __webpack_exports__MicroblogProfile = __webpack_exports__.Qd;
var __webpack_exports__Model = __webpack_exports__.Kx;
var __webpack_exports__ModelWithMessages = __webpack_exports__.w;
var __webpack_exports__Presence = __webpack_exports__.Cq;
var __webpack_exports__Presences = __webpack_exports__.T7;
var __webpack_exports__Profile = __webpack_exports__.WV;
var __webpack_exports__PubSubFeed = __webpack_exports__.Qq;
var __webpack_exports__PubSubFeeds = __webpack_exports__.n0;
var __webpack_exports__PubSubMessage = __webpack_exports__.RM;
var __webpack_exports__PubSubMessages = __webpack_exports__.mp;
var __webpack_exports__RosterContact = __webpack_exports__.C7;
var __webpack_exports__RosterContacts = __webpack_exports__.yP;
var __webpack_exports__RosterFilter = __webpack_exports__.G2;
var __webpack_exports__Stanza = __webpack_exports__.xS;
var __webpack_exports__VCard = __webpack_exports__.Jn;
var __webpack_exports__VCards = __webpack_exports__.K2;
var __webpack_exports___converse = __webpack_exports__.JR;
var __webpack_exports__api = __webpack_exports__.FH;
var __webpack_exports__buildCommentTree = __webpack_exports__.Ev;
var __webpack_exports__computeThreadCounts = __webpack_exports__.wK;
var __webpack_exports__constants = __webpack_exports__.AA;
var __webpack_exports__converse = __webpack_exports__.iq;
var __webpack_exports__default = __webpack_exports__.Ay;
var __webpack_exports__errors = __webpack_exports__.sO;
var __webpack_exports__getAncestors = __webpack_exports__.DS;
var __webpack_exports__getUploadService = __webpack_exports__.nb;
var __webpack_exports__i18n = __webpack_exports__.Ru;
var __webpack_exports__log = __webpack_exports__.Rm;
var __webpack_exports__parsers = __webpack_exports__.T_;
var __webpack_exports__u = __webpack_exports__.u;
var __webpack_exports__uploadFile = __webpack_exports__.QM;
export { __webpack_exports__BaseMessage as BaseMessage, __webpack_exports__Bookmark as Bookmark, __webpack_exports__Bookmarks as Bookmarks, __webpack_exports__Builder as Builder, __webpack_exports__ChatBox as ChatBox, __webpack_exports__Collection as Collection, __webpack_exports__Device as Device, __webpack_exports__DeviceList as DeviceList, __webpack_exports__DeviceLists as DeviceLists, __webpack_exports__Devices as Devices, __webpack_exports__EmojiPicker as EmojiPicker, __webpack_exports__EventEmitter as EventEmitter, __webpack_exports__MAMPlaceholderMessage as MAMPlaceholderMessage, __webpack_exports__MUC as MUC, __webpack_exports__MUCMessage as MUCMessage, __webpack_exports__MUCMessages as MUCMessages, __webpack_exports__MUCOccupant as MUCOccupant, __webpack_exports__MUCOccupants as MUCOccupants, __webpack_exports__Message as Message, __webpack_exports__Messages as Messages, __webpack_exports__MicroblogProfile as MicroblogProfile, __webpack_exports__Model as Model, __webpack_exports__ModelWithMessages as ModelWithMessages, __webpack_exports__Presence as Presence, __webpack_exports__Presences as Presences, __webpack_exports__Profile as Profile, __webpack_exports__PubSubFeed as PubSubFeed, __webpack_exports__PubSubFeeds as PubSubFeeds, __webpack_exports__PubSubMessage as PubSubMessage, __webpack_exports__PubSubMessages as PubSubMessages, __webpack_exports__RosterContact as RosterContact, __webpack_exports__RosterContacts as RosterContacts, __webpack_exports__RosterFilter as RosterFilter, __webpack_exports__Stanza as Stanza, __webpack_exports__VCard as VCard, __webpack_exports__VCards as VCards, __webpack_exports___converse as _converse, __webpack_exports__api as api, __webpack_exports__buildCommentTree as buildCommentTree, __webpack_exports__computeThreadCounts as computeThreadCounts, __webpack_exports__constants as constants, __webpack_exports__converse as converse, __webpack_exports__default as default, __webpack_exports__errors as errors, __webpack_exports__getAncestors as getAncestors, __webpack_exports__getUploadService as getUploadService, __webpack_exports__i18n as i18n, __webpack_exports__log as log, __webpack_exports__parsers as parsers, __webpack_exports__u as u, __webpack_exports__uploadFile as uploadFile };

//# sourceMappingURL=converse-headless.js.map